
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("dtVue", function(module, exports) {

var $jubk3 = parcelRequire("jubk3");

function $c25f711fd5cdf3ef$export$72aeabfc882e7732(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    return (0, $jubk3.getMentionsConfig)(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents);
}
module.exports["createMentionsConfig"] = $c25f711fd5cdf3ef$export$72aeabfc882e7732;

});

parcelRegister("jubk3", function(module, exports) {

var $k9rxT = parcelRequire("k9rxT");


var $bje9P = parcelRequire("bje9P");


var $7lu50 = parcelRequire("7lu50");


var $f7B1p = parcelRequire("f7B1p");


var $04e9M = parcelRequire("04e9M");


var $caelp = parcelRequire("caelp");

/**
 * @generated SignedSource<<fa032903485ae14295b104237c524b04>>
 * @relayHash f1566d2dfc3b1c8e62dbd552d1d5ea7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f
const $2c3903aefb77a74c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "ids"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadMentionsUsersUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadMentionsUsersUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f1566d2dfc3b1c8e62dbd552d1d5ea7b",
            "id": "9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f",
            "metadata": {},
            "name": "preloadMentionsUsersUsersQuery",
            "operationKind": "query",
            "text": "query preloadMentionsUsersUsersQuery($ids:[ID!]!){users(accountIds:$ids){__typename,id,name}}"
        }
    };
}();
$2c3903aefb77a74c$var$node.hash = "3783fdf735e372b90adc93c9f8ad8005";
var $2c3903aefb77a74c$export$2e2bcd8739ae039 = $2c3903aefb77a74c$var$node;



var $dYU3e = parcelRequire("dYU3e");

const $ed0e2cb9f5186ade$var$ARI_PREFIX = 'ari:cloud:identity::user/';
const $ed0e2cb9f5186ade$export$7c5848ab9f90077b = 50;
const $ed0e2cb9f5186ade$var$PreloadMentionsUsersUsersQuery = (0, $2c3903aefb77a74c$export$2e2bcd8739ae039);
const $ed0e2cb9f5186ade$var$getUserData = async (ids)=>{
    const { data: data } = await (0, $dYU3e.queryAgg)({
        query: $ed0e2cb9f5186ade$var$PreloadMentionsUsersUsersQuery,
        variables: {
            ids: ids
        },
        __callerPackage__: "fabric-media-support"
    });
    return data?.users;
};
const $ed0e2cb9f5186ade$export$3adfff745266e959 = async (userIds)=>{
    const ids = userIds.map((id)=>`${$ed0e2cb9f5186ade$var$ARI_PREFIX}${id}`);
    const users = await $ed0e2cb9f5186ade$var$getUserData(ids);
    return (users || []).map((user)=>({
            id: user?.id?.replace($ed0e2cb9f5186ade$var$ARI_PREFIX, ''),
            name: user?.name
        }));
};


class $71c2faaa98a432d0$export$82da878d725997a7 {
    getLookupLimit() {
        // HOT-108964 - sending too many mentions in the request header at once returns a 400
        // The API itself apparently has a hard limit of 90 (HOT-95106), but if we're not careful we can send too many
        // mentions and make the request header too large and the endpoint falls over
        return 0, $ed0e2cb9f5186ade$export$7c5848ab9f90077b;
    }
    async lookupMentionNames(ids) {
        // Allows to rely upon the preloaded mentions data when resolving mentions in the editor
        // both on the client and server side
        return (0, $ed0e2cb9f5186ade$export$3adfff745266e959)(ids).then((users)=>users.map((user)=>({
                    ...user,
                    status: (0, $caelp.MentionNameStatus).OK
                })));
    }
}



var $80Dol = parcelRequire("80Dol");


var $g2yI6 = parcelRequire("g2yI6");

const $b08c9dc0f73ff25f$export$7758cc57d736bc3e = '/gateway/api/mentions';
const $b08c9dc0f73ff25f$export$bcbcd41d6c96b319 = '/gateway/api/teams/mentions';
const $b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL = '/gateway/api/v3/invitations/invite';
async function $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, focusedMentionId, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    const userMentionConfig = {
        url: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        productId: 'micros-group/confluence',
        containerId: spaceId || undefined,
        shouldHighlightMention: (mention)=>mention.id === accountId,
        debounceTime: 150
    };
    const shouldEnableInvite = !!onInviteItemClick;
    if (shouldEnableInvite) {
        userMentionConfig.productName = 'Confluence';
        userMentionConfig.shouldEnableInvite = shouldEnableInvite;
        userMentionConfig.onInviteItemClick = onInviteItemClick;
        userMentionConfig.userRole = userRole;
    }
    userMentionConfig.inviteXProductUser = async (userId, mentionName)=>{
        let isSuccess = false;
        let client;
        try {
            if (accountId === userId || isEligibleXProductUserInvite && !await isEligibleXProductUserInvite()) return;
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const response = await (0, $f7B1p.cfetch)($b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    users: [
                        {
                            id: userId
                        }
                    ],
                    resources: [
                        `ari:cloud:confluence::site/${cloudId}`
                    ]
                })
            });
            if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
            const data = await response.json();
            const inviteResponseObj = data[0];
            const product = Object.keys(inviteResponseObj?.results || {})[0];
            const invitationStatus = inviteResponseObj?.results?.[product];
            isSuccess = product?.includes('confluence') && invitationStatus === 'INVITED';
            await client.sendTrackEvent({
                source: 'editor',
                action: 'invited',
                actionSubject: 'xProductUser',
                attributes: {
                    invitationStatus: invitationStatus,
                    inviteeId: userId
                }
            });
        } catch (error) {
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserInvite',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack,
                    inviteeId: userId
                }
            });
            isSuccess = false;
        }
        onXProductUserInviteClick?.(mentionName, isSuccess);
    };
    const teamMentionConfig = {
        url: $b08c9dc0f73ff25f$export$bcbcd41d6c96b319,
        productId: 'micros-group/confluence',
        shouldHighlightMention: (mention)=>mention.id === accountId
    };
    const scrollToMention = ()=>{
        if (focusedMentionId) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const mentionElement = document.querySelector(`[data-local-id="${focusedMentionId}"]`);
            if (mentionElement) mentionElement.scrollIntoView({
                behavior: 'instant',
                inline: 'center',
                block: 'center'
            });
        }
    };
    userMentionConfig.mentionNameResolver = new (0, $bje9P.DefaultMentionNameResolver)(new (0, $71c2faaa98a432d0$export$82da878d725997a7)(), withAnalyticsEventProps, scrollToMention);
    return $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite, includeAgents);
}
async function $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite, includeAgents) {
    let includeExternalCollaborators = false;
    const data = await (0, $g2yI6.fetchMentionsProviderData)();
    // Entitlement check to determine if tenant is premium/enabled for Guests
    includeExternalCollaborators = data ? (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(data) === true : false;
    return new (0, $80Dol.UserTeamMentionProvider)('/gateway/api/v1/recommendations', userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite, includeAgents ?? false);
}
async function $b08c9dc0f73ff25f$export$86c3c7f166be321d(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    if (!cloudId) throw new Error('MentionResource cannot be configured without a cloud id');
    const spaceId = mentionContext?.spaceId || undefined;
    const mentionResource = await $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, undefined, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents);
    return {
        mentionResource: mentionResource,
        presenceResource: new (0, $k9rxT.default)({
            url: '/gateway/api/directory/graphql',
            cloudId: cloudId,
            productId: 'confluence'
        }),
        // Required for the TinyMCE mentions plugin, should be removed when TinyMCE is removed
        mentionServiceUrl: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        contextIdentifier: {
            containerId: spaceId || '',
            objectId: mentionContext?.contentId || '',
            childObjectId: mentionContext?.commentId || ''
        }
    };
}
module.exports["createFabricMentionResource"] = $b08c9dc0f73ff25f$export$395a616bfa7556a6;
module.exports["getMentionsConfig"] = $b08c9dc0f73ff25f$export$86c3c7f166be321d;

});

parcelRegister("8z3oB", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $a2foB = parcelRequire("a2foB");


var $gqqjz = parcelRequire("gqqjz");

const $0ffa514f9611729c$export$723a1497b2536563 = ({ showFlag: showFlag, hideFlag: hideFlag })=>{
    const createFlag = (flagOptions)=>{
        const { isAutoDismiss: isAutoDismiss, ...restOptions } = flagOptions;
        const { type: type, appearance: appearance, actions: actions } = flagOptions;
        const shouldAutoDismiss = isAutoDismiss ?? (appearance === 'info' || appearance === 'success');
        showFlag({
            ...restOptions,
            type: appearance ?? type,
            actions: actions?.map(({ text: content, onClick: onClick })=>({
                    onClick: ()=>onClick(),
                    content: content
                })),
            customComponent: shouldAutoDismiss ? (0, $a2foB.default) : undefined
        });
        return true;
    };
    const closeFlag = ({ id: id })=>{
        hideFlag(id);
        return true;
    };
    return {
        showFlag: createFlag,
        closeFlag: closeFlag
    };
};
const $0ffa514f9611729c$export$b0063bae72b769ca = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, children);
module.exports["getFlagProvider"] = $0ffa514f9611729c$export$723a1497b2536563;
module.exports["FlagProvider"] = $0ffa514f9611729c$export$b0063bae72b769ca;

});

parcelRegister("9rzZK", function(module, exports) {
"use strict";
var $6e028e870d91151c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6e028e870d91151c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6e028e870d91151c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6e028e870d91151c$var$__exportStar((parcelRequire("apeJP")), module.exports);

});

parcelRegister("apeJP", function(module, exports) {
"use strict";
var $7937abe35ad685cf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7937abe35ad685cf$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7937abe35ad685cf$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7937abe35ad685cf$var$__exportStar((parcelRequire("hDx1A")), module.exports);

});

parcelRegister("hDx1A", function(module, exports) {
"use strict";
var $cd6fb22db38e33a0$var$__assign = module.exports && module.exports.__assign || function() {
    $cd6fb22db38e33a0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cd6fb22db38e33a0$var$__assign.apply(this, arguments);
};
var $cd6fb22db38e33a0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cd6fb22db38e33a0$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $cd6fb22db38e33a0$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.postRobotOn = module.exports.postRobotSend = module.exports.createIframeBridge = void 0;

var $9B424 = parcelRequire("9B424");

Object.defineProperty(module.exports, "postRobotOn", {
    enumerable: true,
    get: function() {
        return $9B424.on;
    }
});
Object.defineProperty(module.exports, "postRobotSend", {
    enumerable: true,
    get: function() {
        return $9B424.send;
    }
});

var $efN0P = parcelRequire("efN0P");

var $cd6fb22db38e33a0$var$setupMessageListeners = function(window1, domain, listeners) {
    return Object.entries(listeners).map(function(_a) {
        var eventKey = _a[0], eventHandler = _a[1];
        return (0, $9B424.on)(eventKey, {
            window: window1,
            domain: domain
        }, function(event) {
            if (eventHandler && event.origin === domain) return eventHandler(event);
            return Promise.resolve();
        });
    });
};
var $cd6fb22db38e33a0$var$createIframeBridge = function(options) {
    if (!options.withWindow) throw new Error('Target window to setup the bridge with is not defined');
    var bridge = {
        open: function() {
            var withWindow = options.withWindow, withDomain = options.withDomain, features = options.features, theme = options.theme, surfaceColor = options.surfaceColor, sendHandshakeMetric = options.sendHandshakeMetric, metadata = options.metadata, shouldReceiveEmbeddedMacroMessages = options.shouldReceiveEmbeddedMacroMessages;
            var listeners = $cd6fb22db38e33a0$var$setupMessageListeners(withWindow, withDomain, features);
            var cancelEmbeddedMacroHandler;
            var localId = metadata === null || metadata === void 0 ? void 0 : metadata.localId;
            if (shouldReceiveEmbeddedMacroMessages && localId) try {
                var productHostname_1 = window.location.hostname;
                var handler = (0, $9B424.on)("messageFromEmbeddedFAUS_".concat(localId), {}, function(event) {
                    var originUrl = new URL(event.origin);
                    if (originUrl.hostname !== productHostname_1) return Promise.resolve();
                    var _a = event.data || {}, eventKey = _a.eventKey, payload = $cd6fb22db38e33a0$var$__rest(_a, [
                        "eventKey"
                    ]);
                    var handler = features[eventKey];
                    if (handler) return handler($cd6fb22db38e33a0$var$__assign($cd6fb22db38e33a0$var$__assign({}, event), {
                        data: payload
                    }));
                    return Promise.resolve();
                });
                cancelEmbeddedMacroHandler = handler.cancel;
            } catch (error) {
                console.error("Failed to set up messageFromEmbeddedFAUS listener for localId ".concat(localId, ":"), error);
            }
            var cancelReadyHandler = (0, $9B424.on)($efN0P.READY_EVENT, {
                window: withWindow,
                domain: withDomain
            }, function() {
                return $cd6fb22db38e33a0$var$__awaiter(void 0, void 0, void 0, function() {
                    return $cd6fb22db38e33a0$var$__generator(this, function(_a) {
                        return [
                            2,
                            true
                        ];
                    });
                });
            }).cancel;
            (0, $9B424.send)(withWindow, $efN0P.READY_EVENT, $cd6fb22db38e33a0$var$__assign({
                theme: theme,
                surfaceColor: surfaceColor
            }, options.metadata || {}), {
                timeout: $efN0P.BRIDGE_HANDSHAKE_TIMEOUT_MS
            }).then(function() {
                sendHandshakeMetric(true);
            }).catch(function(error) {
                sendHandshakeMetric(false, error);
                return (0, $efN0P.handleMissingHandlerError)(error);
            });
            return {
                enableTheming: function() {
                    (0, $9B424.send)(withWindow, $efN0P.THEME_ENABLE_EVENT).catch($efN0P.handleMissingHandlerError);
                },
                setTheme: function(theme, surfaceColor, env) {
                    (0, $9B424.send)(withWindow, $efN0P.THEME_CHANGE_EVENT, {
                        theme: theme,
                        surfaceColor: surfaceColor,
                        env: env,
                        isFedRamp: metadata === null || metadata === void 0 ? void 0 : metadata.isFedRamp
                    }).catch($efN0P.handleMissingHandlerError);
                },
                close: function() {
                    cancelReadyHandler();
                    cancelEmbeddedMacroHandler === null || cancelEmbeddedMacroHandler === void 0 || cancelEmbeddedMacroHandler();
                    listeners.forEach(function(_a) {
                        var cancel = _a.cancel;
                        return cancel();
                    });
                }
            };
        }
    };
    return bridge;
};
module.exports.createIframeBridge = $cd6fb22db38e33a0$var$createIframeBridge;

});

parcelRegister("hnAIF", function(module, exports) {

var $e9nC3 = parcelRequire("e9nC3");

var $ca7111645b19e17d$require$Buffer = $e9nC3.Buffer;
!function(root, factory) {
    module.exports = factory();
}("undefined" != typeof self ? self : module.exports, function() {
    return function(modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module1 = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            module1.l = !0;
            return module1.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                enumerable: !0,
                get: getter
            });
        };
        __webpack_require__.r = function(exports) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            Object.defineProperty(exports, "__esModule", {
                value: !0
            });
        };
        __webpack_require__.t = function(value, mode) {
            1 & mode && (value = __webpack_require__(value));
            if (8 & mode) return value;
            if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
            var ns = Object.create(null);
            __webpack_require__.r(ns);
            Object.defineProperty(ns, "default", {
                enumerable: !0,
                value: value
            });
            if (2 & mode && "string" != typeof value) for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            return ns;
        };
        __webpack_require__.n = function(module1) {
            var getter = module1 && module1.__esModule ? function() {
                return module1.default;
            } : function() {
                return module1;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function(object, property) {
            return ({}).hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = 0);
    }([
        function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Promise", function() {
                return promise_ZalgoPromise;
            });
            __webpack_require__.d(__webpack_exports__, "TYPES", function() {
                return src_types_TYPES_0;
            });
            __webpack_require__.d(__webpack_exports__, "ProxyWindow", function() {
                return window_ProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "setup", function() {
                return setup;
            });
            __webpack_require__.d(__webpack_exports__, "destroy", function() {
                return destroy;
            });
            __webpack_require__.d(__webpack_exports__, "serializeMessage", function() {
                return setup_serializeMessage;
            });
            __webpack_require__.d(__webpack_exports__, "deserializeMessage", function() {
                return setup_deserializeMessage;
            });
            __webpack_require__.d(__webpack_exports__, "createProxyWindow", function() {
                return createProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "toProxyWindow", function() {
                return setup_toProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "on", function() {
                return on_on;
            });
            __webpack_require__.d(__webpack_exports__, "once", function() {
                return on_once;
            });
            __webpack_require__.d(__webpack_exports__, "send", function() {
                return send_send;
            });
            __webpack_require__.d(__webpack_exports__, "markWindowKnown", function() {
                return markWindowKnown;
            });
            __webpack_require__.d(__webpack_exports__, "cleanUpWindow", function() {
                return cleanUpWindow;
            });
            __webpack_require__.d(__webpack_exports__, "bridge", function() {});
            function isRegex(item) {
                return "[object RegExp]" === ({}).toString.call(item);
            }
            var IE_WIN_ACCESS_ERROR = "Call was rejected by callee.\r\n";
            function isAboutProtocol(win) {
                void 0 === win && (win = window);
                return "about:" === win.location.protocol;
            }
            function getParent(win) {
                void 0 === win && (win = window);
                if (win) try {
                    if (win.parent && win.parent !== win) return win.parent;
                } catch (err) {}
            }
            function getOpener(win) {
                void 0 === win && (win = window);
                if (win && !getParent(win)) try {
                    return win.opener;
                } catch (err) {}
            }
            function canReadFromWindow(win) {
                try {
                    return !0;
                } catch (err) {}
                return !1;
            }
            function getActualDomain(win) {
                void 0 === win && (win = window);
                var location = win.location;
                if (!location) throw new Error("Can not read window location");
                var protocol = location.protocol;
                if (!protocol) throw new Error("Can not read window protocol");
                if ("file:" === protocol) return "file://";
                if ("about:" === protocol) {
                    var parent = getParent(win);
                    return parent && canReadFromWindow() ? getActualDomain(parent) : "about://";
                }
                var host = location.host;
                if (!host) throw new Error("Can not read window host");
                return protocol + "//" + host;
            }
            function getDomain(win) {
                void 0 === win && (win = window);
                var domain = getActualDomain(win);
                return domain && win.mockDomain && 0 === win.mockDomain.indexOf("mock:") ? win.mockDomain : domain;
            }
            function isSameDomain(win) {
                if (!function(win) {
                    try {
                        if (win === window) return !0;
                    } catch (err) {}
                    try {
                        var desc = Object.getOwnPropertyDescriptor(win, "location");
                        if (desc && !1 === desc.enumerable) return !1;
                    } catch (err) {}
                    try {
                        if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                    } catch (err) {}
                    try {
                        if (getActualDomain(win) === getActualDomain(window)) return !0;
                    } catch (err) {}
                    return !1;
                }(win)) return !1;
                try {
                    if (win === window) return !0;
                    if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                    if (getDomain(window) === getDomain(win)) return !0;
                } catch (err) {}
                return !1;
            }
            function assertSameDomain(win) {
                if (!isSameDomain(win)) throw new Error("Expected window to be same domain");
                return win;
            }
            function isAncestorParent(parent, child) {
                if (!parent || !child) return !1;
                var childParent = getParent(child);
                return childParent ? childParent === parent : -1 !== (function(win) {
                    var result = [];
                    try {
                        for(; win.parent !== win;){
                            result.push(win.parent);
                            win = win.parent;
                        }
                    } catch (err) {}
                    return result;
                })(child).indexOf(parent);
            }
            function getFrames(win) {
                var result = [];
                var frames;
                try {
                    frames = win.frames;
                } catch (err) {
                    frames = win;
                }
                var len;
                try {
                    len = frames.length;
                } catch (err) {}
                if (0 === len) return result;
                if (len) {
                    for(var i = 0; i < len; i++){
                        var frame = void 0;
                        try {
                            frame = frames[i];
                        } catch (err) {
                            continue;
                        }
                        result.push(frame);
                    }
                    return result;
                }
                for(var _i = 0; _i < 100; _i++){
                    var _frame = void 0;
                    try {
                        _frame = frames[_i];
                    } catch (err) {
                        return result;
                    }
                    if (!_frame) return result;
                    result.push(_frame);
                }
                return result;
            }
            var iframeWindows = [];
            var iframeFrames = [];
            function isWindowClosed(win, allowMock) {
                void 0 === allowMock && (allowMock = !0);
                try {
                    if (win === window) return !1;
                } catch (err) {
                    return !0;
                }
                try {
                    if (!win) return !0;
                } catch (err) {
                    return !0;
                }
                try {
                    if (win.closed) return !0;
                } catch (err) {
                    return !err || err.message !== IE_WIN_ACCESS_ERROR;
                }
                if (allowMock && isSameDomain(win)) try {
                    if (win.mockclosed) return !0;
                } catch (err) {}
                try {
                    if (!win.parent || !win.top) return !0;
                } catch (err) {}
                var iframeIndex = function(collection, item) {
                    for(var i = 0; i < collection.length; i++)try {
                        if (collection[i] === item) return i;
                    } catch (err) {}
                    return -1;
                }(iframeWindows, win);
                if (-1 !== iframeIndex) {
                    var frame = iframeFrames[iframeIndex];
                    if (frame && function(frame) {
                        if (!frame.contentWindow) return !0;
                        if (!frame.parentNode) return !0;
                        var doc = frame.ownerDocument;
                        if (doc && doc.documentElement && !doc.documentElement.contains(frame)) {
                            var parent = frame;
                            for(; parent.parentNode && parent.parentNode !== parent;)parent = parent.parentNode;
                            if (!parent.host || !doc.documentElement.contains(parent.host)) return !0;
                        }
                        return !1;
                    }(frame)) return !0;
                }
                return !1;
            }
            function getAncestor(win) {
                void 0 === win && (win = window);
                return getOpener(win = win || window) || getParent(win) || void 0;
            }
            function matchDomain(pattern, origin) {
                if ("string" == typeof pattern) {
                    if ("string" == typeof origin) return "*" === pattern || origin === pattern;
                    if (isRegex(origin)) return !1;
                    if (Array.isArray(origin)) return !1;
                }
                return isRegex(pattern) ? isRegex(origin) ? pattern.toString() === origin.toString() : !Array.isArray(origin) && Boolean(origin.match(pattern)) : !!Array.isArray(pattern) && (Array.isArray(origin) ? JSON.stringify(pattern) === JSON.stringify(origin) : !isRegex(origin) && pattern.some(function(subpattern) {
                    return matchDomain(subpattern, origin);
                }));
            }
            function isWindow(obj) {
                try {
                    if (obj === window) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if ("[object Window]" === ({}).toString.call(obj)) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (window.Window && obj instanceof window.Window) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.self === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.parent === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.top === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && "__unlikely_value__" === obj.__cross_domain_utils_window_check__) return !1;
                } catch (err) {
                    return !0;
                }
                try {
                    if ("postMessage" in obj && "self" in obj && "location" in obj) return !0;
                } catch (err) {}
                return !1;
            }
            function closeWindow(win) {
                try {
                    win.close();
                } catch (err) {}
            }
            function utils_isPromise(item) {
                try {
                    if (!item) return !1;
                    if ("undefined" != typeof Promise && item instanceof Promise) return !0;
                    if ("undefined" != typeof window && "function" == typeof window.Window && item instanceof window.Window) return !1;
                    if ("undefined" != typeof window && "function" == typeof window.constructor && item instanceof window.constructor) return !1;
                    var _toString = {}.toString;
                    if (_toString) {
                        var name = _toString.call(item);
                        if ("[object Window]" === name || "[object global]" === name || "[object DOMWindow]" === name) return !1;
                    }
                    if ("function" == typeof item.then) return !0;
                } catch (err) {
                    return !1;
                }
                return !1;
            }
            var dispatchedErrors = [];
            var possiblyUnhandledPromiseHandlers = [];
            var activeCount = 0;
            var flushPromise;
            function flushActive() {
                if (!activeCount && flushPromise) {
                    var promise = flushPromise;
                    flushPromise = null;
                    promise.resolve();
                }
            }
            function startActive() {
                activeCount += 1;
            }
            function endActive() {
                activeCount -= 1;
                flushActive();
            }
            var promise_ZalgoPromise = function() {
                function ZalgoPromise(handler) {
                    var _this = this;
                    this.resolved = void 0;
                    this.rejected = void 0;
                    this.errorHandled = void 0;
                    this.value = void 0;
                    this.error = void 0;
                    this.handlers = void 0;
                    this.dispatching = void 0;
                    this.stack = void 0;
                    this.resolved = !1;
                    this.rejected = !1;
                    this.errorHandled = !1;
                    this.handlers = [];
                    if (handler) {
                        var _result;
                        var _error;
                        var resolved = !1;
                        var rejected = !1;
                        var isAsync = !1;
                        startActive();
                        try {
                            handler(function(res) {
                                if (isAsync) _this.resolve(res);
                                else {
                                    resolved = !0;
                                    _result = res;
                                }
                            }, function(err) {
                                if (isAsync) _this.reject(err);
                                else {
                                    rejected = !0;
                                    _error = err;
                                }
                            });
                        } catch (err) {
                            endActive();
                            this.reject(err);
                            return;
                        }
                        endActive();
                        isAsync = !0;
                        resolved ? this.resolve(_result) : rejected && this.reject(_error);
                    }
                }
                var _proto = ZalgoPromise.prototype;
                _proto.resolve = function(result) {
                    if (this.resolved || this.rejected) return this;
                    if (utils_isPromise(result)) throw new Error("Can not resolve promise with another promise");
                    this.resolved = !0;
                    this.value = result;
                    this.dispatch();
                    return this;
                };
                _proto.reject = function(error) {
                    var _this2 = this;
                    if (this.resolved || this.rejected) return this;
                    if (utils_isPromise(error)) throw new Error("Can not reject promise with another promise");
                    if (!error) {
                        var _err = error && "function" == typeof error.toString ? error.toString() : ({}).toString.call(error);
                        error = new Error("Expected reject to be called with Error, got " + _err);
                    }
                    this.rejected = !0;
                    this.error = error;
                    this.errorHandled || setTimeout(function() {
                        _this2.errorHandled || function(err, promise) {
                            if (-1 === dispatchedErrors.indexOf(err)) {
                                dispatchedErrors.push(err);
                                setTimeout(function() {
                                    throw err;
                                }, 1);
                                for(var j = 0; j < possiblyUnhandledPromiseHandlers.length; j++)possiblyUnhandledPromiseHandlers[j](err, promise);
                            }
                        }(error, _this2);
                    }, 1);
                    this.dispatch();
                    return this;
                };
                _proto.asyncReject = function(error) {
                    this.errorHandled = !0;
                    this.reject(error);
                    return this;
                };
                _proto.dispatch = function() {
                    var resolved = this.resolved, rejected = this.rejected, handlers = this.handlers;
                    if (!this.dispatching && (resolved || rejected)) {
                        this.dispatching = !0;
                        startActive();
                        var chain = function(firstPromise, secondPromise) {
                            return firstPromise.then(function(res) {
                                secondPromise.resolve(res);
                            }, function(err) {
                                secondPromise.reject(err);
                            });
                        };
                        for(var i = 0; i < handlers.length; i++){
                            var _handlers$i = handlers[i], onSuccess = _handlers$i.onSuccess, onError = _handlers$i.onError, promise = _handlers$i.promise;
                            var _result2 = void 0;
                            if (resolved) try {
                                _result2 = onSuccess ? onSuccess(this.value) : this.value;
                            } catch (err) {
                                promise.reject(err);
                                continue;
                            }
                            else if (rejected) {
                                if (!onError) {
                                    promise.reject(this.error);
                                    continue;
                                }
                                try {
                                    _result2 = onError(this.error);
                                } catch (err) {
                                    promise.reject(err);
                                    continue;
                                }
                            }
                            if (_result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected)) {
                                _result2.resolved ? promise.resolve(_result2.value) : promise.reject(_result2.error);
                                _result2.errorHandled = !0;
                            } else utils_isPromise(_result2) ? _result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected) ? _result2.resolved ? promise.resolve(_result2.value) : promise.reject(_result2.error) : chain(_result2, promise) : promise.resolve(_result2);
                        }
                        handlers.length = 0;
                        this.dispatching = !1;
                        endActive();
                    }
                };
                _proto.then = function(onSuccess, onError) {
                    if (onSuccess && "function" != typeof onSuccess && !onSuccess.call) throw new Error("Promise.then expected a function for success handler");
                    if (onError && "function" != typeof onError && !onError.call) throw new Error("Promise.then expected a function for error handler");
                    var promise = new ZalgoPromise;
                    this.handlers.push({
                        promise: promise,
                        onSuccess: onSuccess,
                        onError: onError
                    });
                    this.errorHandled = !0;
                    this.dispatch();
                    return promise;
                };
                _proto.catch = function(onError) {
                    return this.then(void 0, onError);
                };
                _proto.finally = function(onFinally) {
                    if (onFinally && "function" != typeof onFinally && !onFinally.call) throw new Error("Promise.finally expected a function");
                    return this.then(function(result) {
                        return ZalgoPromise.try(onFinally).then(function() {
                            return result;
                        });
                    }, function(err) {
                        return ZalgoPromise.try(onFinally).then(function() {
                            throw err;
                        });
                    });
                };
                _proto.timeout = function(time, err) {
                    var _this3 = this;
                    if (this.resolved || this.rejected) return this;
                    var timeout = setTimeout(function() {
                        _this3.resolved || _this3.rejected || _this3.reject(err || new Error("Promise timed out after " + time + "ms"));
                    }, time);
                    return this.then(function(result) {
                        clearTimeout(timeout);
                        return result;
                    });
                };
                _proto.toPromise = function() {
                    if ("undefined" == typeof Promise) throw new TypeError("Could not find Promise");
                    return Promise.resolve(this);
                };
                ZalgoPromise.resolve = function(value) {
                    return value instanceof ZalgoPromise ? value : utils_isPromise(value) ? new ZalgoPromise(function(resolve, reject) {
                        return value.then(resolve, reject);
                    }) : (new ZalgoPromise).resolve(value);
                };
                ZalgoPromise.reject = function(error) {
                    return (new ZalgoPromise).reject(error);
                };
                ZalgoPromise.asyncReject = function(error) {
                    return (new ZalgoPromise).asyncReject(error);
                };
                ZalgoPromise.all = function(promises) {
                    var promise = new ZalgoPromise;
                    var count = promises.length;
                    var results = [];
                    if (!count) {
                        promise.resolve(results);
                        return promise;
                    }
                    var chain = function(i, firstPromise, secondPromise) {
                        return firstPromise.then(function(res) {
                            results[i] = res;
                            0 == (count -= 1) && promise.resolve(results);
                        }, function(err) {
                            secondPromise.reject(err);
                        });
                    };
                    for(var i = 0; i < promises.length; i++){
                        var prom = promises[i];
                        if (prom instanceof ZalgoPromise) {
                            if (prom.resolved) {
                                results[i] = prom.value;
                                count -= 1;
                                continue;
                            }
                        } else if (!utils_isPromise(prom)) {
                            results[i] = prom;
                            count -= 1;
                            continue;
                        }
                        chain(i, ZalgoPromise.resolve(prom), promise);
                    }
                    0 === count && promise.resolve(results);
                    return promise;
                };
                ZalgoPromise.hash = function(promises) {
                    var result = {};
                    var awaitPromises = [];
                    var _loop = function(key) {
                        if (promises.hasOwnProperty(key)) {
                            var value = promises[key];
                            utils_isPromise(value) ? awaitPromises.push(value.then(function(res) {
                                result[key] = res;
                            })) : result[key] = value;
                        }
                    };
                    for(var key in promises)_loop(key);
                    return ZalgoPromise.all(awaitPromises).then(function() {
                        return result;
                    });
                };
                ZalgoPromise.map = function(items, method) {
                    return ZalgoPromise.all(items.map(method));
                };
                ZalgoPromise.onPossiblyUnhandledException = function(handler) {
                    return function(handler) {
                        possiblyUnhandledPromiseHandlers.push(handler);
                        return {
                            cancel: function() {
                                possiblyUnhandledPromiseHandlers.splice(possiblyUnhandledPromiseHandlers.indexOf(handler), 1);
                            }
                        };
                    }(handler);
                };
                ZalgoPromise.try = function(method, context, args) {
                    if (method && "function" != typeof method && !method.call) throw new Error("Promise.try expected a function");
                    var result;
                    startActive();
                    try {
                        result = method.apply(context, args || []);
                    } catch (err) {
                        endActive();
                        return ZalgoPromise.reject(err);
                    }
                    endActive();
                    return ZalgoPromise.resolve(result);
                };
                ZalgoPromise.delay = function(_delay) {
                    return new ZalgoPromise(function(resolve) {
                        setTimeout(resolve, _delay);
                    });
                };
                ZalgoPromise.isPromise = function(value) {
                    return !!(value && value instanceof ZalgoPromise) || utils_isPromise(value);
                };
                ZalgoPromise.flush = function() {
                    return function(Zalgo) {
                        var promise = flushPromise = flushPromise || new Zalgo;
                        flushActive();
                        return promise;
                    }(ZalgoPromise);
                };
                return ZalgoPromise;
            }();
            function util_safeIndexOf(collection, item) {
                for(var i = 0; i < collection.length; i++)try {
                    if (collection[i] === item) return i;
                } catch (err) {}
                return -1;
            }
            var weakmap_CrossDomainSafeWeakMap = function() {
                function CrossDomainSafeWeakMap() {
                    this.name = void 0;
                    this.weakmap = void 0;
                    this.keys = void 0;
                    this.values = void 0;
                    this.name = "__weakmap_" + (1e9 * Math.random() >>> 0) + "__";
                    if (function() {
                        if ("undefined" == typeof WeakMap) return !1;
                        if (void 0 === Object.freeze) return !1;
                        try {
                            var testWeakMap = new WeakMap;
                            var testKey = {};
                            Object.freeze(testKey);
                            testWeakMap.set(testKey, "__testvalue__");
                            return "__testvalue__" === testWeakMap.get(testKey);
                        } catch (err) {
                            return !1;
                        }
                    }()) try {
                        this.weakmap = new WeakMap;
                    } catch (err) {}
                    this.keys = [];
                    this.values = [];
                }
                var _proto = CrossDomainSafeWeakMap.prototype;
                _proto._cleanupClosedWindows = function() {
                    var weakmap = this.weakmap;
                    var keys = this.keys;
                    for(var i = 0; i < keys.length; i++){
                        var value = keys[i];
                        if (isWindow(value) && isWindowClosed(value)) {
                            if (weakmap) try {
                                weakmap.delete(value);
                            } catch (err) {}
                            keys.splice(i, 1);
                            this.values.splice(i, 1);
                            i -= 1;
                        }
                    }
                };
                _proto.isSafeToReadWrite = function(key) {
                    return !isWindow(key);
                };
                _proto.set = function(key, value) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        weakmap.set(key, value);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var name = this.name;
                        var entry = key[name];
                        entry && entry[0] === key ? entry[1] = value : Object.defineProperty(key, name, {
                            value: [
                                key,
                                value
                            ],
                            writable: !0
                        });
                        return;
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var keys = this.keys;
                    var values = this.values;
                    var index = util_safeIndexOf(keys, key);
                    if (-1 === index) {
                        keys.push(key);
                        values.push(value);
                    } else values[index] = value;
                };
                _proto.get = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        if (weakmap.has(key)) return weakmap.get(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        return entry && entry[0] === key ? entry[1] : void 0;
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var index = util_safeIndexOf(this.keys, key);
                    if (-1 !== index) return this.values[index];
                };
                _proto.delete = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        weakmap.delete(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        entry && entry[0] === key && (entry[0] = entry[1] = void 0);
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var keys = this.keys;
                    var index = util_safeIndexOf(keys, key);
                    if (-1 !== index) {
                        keys.splice(index, 1);
                        this.values.splice(index, 1);
                    }
                };
                _proto.has = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        if (weakmap.has(key)) return !0;
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        return !(!entry || entry[0] !== key);
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    return -1 !== util_safeIndexOf(this.keys, key);
                };
                _proto.getOrSet = function(key, getter) {
                    if (this.has(key)) return this.get(key);
                    var value = getter();
                    this.set(key, value);
                    return value;
                };
                return CrossDomainSafeWeakMap;
            }();
            function getFunctionName(fn) {
                return fn.name || fn.__name__ || fn.displayName || "anonymous";
            }
            function setFunctionName(fn, name) {
                try {
                    delete fn.name;
                    fn.name = name;
                } catch (err) {}
                fn.__name__ = fn.displayName = name;
                return fn;
            }
            function uniqueID() {
                var chars = "0123456789abcdef";
                return "xxxxxxxxxx".replace(/./g, function() {
                    return chars.charAt(Math.floor(Math.random() * chars.length));
                }) + "_" + (function(str) {
                    if ("function" == typeof btoa) return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(m, p1) {
                        return String.fromCharCode(parseInt(p1, 16));
                    }));
                    if ("undefined" != typeof $ca7111645b19e17d$require$Buffer) return $ca7111645b19e17d$require$Buffer.from(str, "utf8").toString("base64");
                    throw new Error("Can not find window.btoa or Buffer");
                })((new Date).toISOString().slice(11, 19).replace("T", ".")).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
            }
            var objectIDs;
            function serializeArgs(args) {
                try {
                    return JSON.stringify([].slice.call(args), function(subkey, val) {
                        return "function" == typeof val ? "memoize[" + function(obj) {
                            objectIDs = objectIDs || new weakmap_CrossDomainSafeWeakMap;
                            if (null == obj || "object" != typeof obj && "function" != typeof obj) throw new Error("Invalid object");
                            var uid = objectIDs.get(obj);
                            if (!uid) {
                                uid = typeof obj + ":" + uniqueID();
                                objectIDs.set(obj, uid);
                            }
                            return uid;
                        }(val) + "]" : val;
                    });
                } catch (err) {
                    throw new Error("Arguments not serializable -- can not be used to memoize");
                }
            }
            var memoizedFunctions = [];
            function memoize(method, options) {
                var _this = this;
                void 0 === options && (options = {});
                var cacheMap = new weakmap_CrossDomainSafeWeakMap;
                var memoizedFunction = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var cache = cacheMap.getOrSet(options.thisNamespace ? this : method, function() {
                        return {};
                    });
                    var key = serializeArgs(args);
                    var cacheTime = options.time;
                    cache[key] && cacheTime && Date.now() - cache[key].time < cacheTime && delete cache[key];
                    if (cache[key]) return cache[key].value;
                    var time = Date.now();
                    var value = method.apply(this, arguments);
                    cache[key] = {
                        time: time,
                        value: value
                    };
                    return cache[key].value;
                };
                memoizedFunction.reset = function() {
                    cacheMap.delete(options.thisNamespace ? _this : method);
                };
                memoizedFunctions.push(memoizedFunction);
                return setFunctionName(memoizedFunction, (options.name || getFunctionName(method)) + "::memoized");
            }
            memoize.clear = function() {
                for(var _i2 = 0; _i2 < memoizedFunctions.length; _i2++)memoizedFunctions[_i2].reset();
            };
            function memoizePromise(method) {
                var cache = {};
                function memoizedPromiseFunction() {
                    var _arguments = arguments, _this2 = this;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    var key = serializeArgs(args);
                    if (cache.hasOwnProperty(key)) return cache[key];
                    cache[key] = promise_ZalgoPromise.try(function() {
                        return method.apply(_this2, _arguments);
                    }).finally(function() {
                        delete cache[key];
                    });
                    return cache[key];
                }
                memoizedPromiseFunction.reset = function() {
                    cache = {};
                };
                return setFunctionName(memoizedPromiseFunction, getFunctionName(method) + "::promiseMemoized");
            }
            function src_util_noop() {}
            function stringifyError(err, level) {
                void 0 === level && (level = 1);
                if (level >= 3) return "stringifyError stack overflow";
                try {
                    if (!err) return "<unknown error: " + ({}).toString.call(err) + ">";
                    if ("string" == typeof err) return err;
                    if (err instanceof Error) {
                        var stack = err && err.stack;
                        var message = err && err.message;
                        if (stack && message) return -1 !== stack.indexOf(message) ? stack : message + "\n" + stack;
                        if (stack) return stack;
                        if (message) return message;
                    }
                    return err && err.toString && "function" == typeof err.toString ? err.toString() : ({}).toString.call(err);
                } catch (newErr) {
                    return "Error while stringifying error: " + stringifyError(newErr, level + 1);
                }
            }
            function stringify(item) {
                return "string" == typeof item ? item : item && item.toString && "function" == typeof item.toString ? item.toString() : ({}).toString.call(item);
            }
            memoize(function(obj) {
                if (Object.values) return Object.values(obj);
                var result = [];
                for(var key in obj)obj.hasOwnProperty(key) && result.push(obj[key]);
                return result;
            });
            function util_isRegex(item) {
                return "[object RegExp]" === ({}).toString.call(item);
            }
            function util_getOrSet(obj, key, getter) {
                if (obj.hasOwnProperty(key)) return obj[key];
                var val = getter();
                obj[key] = val;
                return val;
            }
            Error;
            function isDocumentReady() {
                return Boolean(document.body) && "complete" === document.readyState;
            }
            function isDocumentInteractive() {
                return Boolean(document.body) && "interactive" === document.readyState;
            }
            memoize(function() {
                return new promise_ZalgoPromise(function(resolve) {
                    if (isDocumentReady() || isDocumentInteractive()) return resolve();
                    var interval = setInterval(function() {
                        if (isDocumentReady() || isDocumentInteractive()) {
                            clearInterval(interval);
                            return resolve();
                        }
                    }, 10);
                });
            });
            var currentScript = "undefined" != typeof document ? document.currentScript : null;
            var getCurrentScript = memoize(function() {
                if (currentScript) return currentScript;
                if (currentScript = function() {
                    try {
                        var stack = function() {
                            try {
                                throw new Error("_");
                            } catch (err) {
                                return err.stack || "";
                            }
                        }();
                        var stackDetails = /.*at [^(]*\((.*):(.+):(.+)\)$/gi.exec(stack);
                        var scriptLocation = stackDetails && stackDetails[1];
                        if (!scriptLocation) return;
                        for(var _i20 = 0, _Array$prototype$slic2 = [].slice.call(document.getElementsByTagName("script")).reverse(); _i20 < _Array$prototype$slic2.length; _i20++){
                            var script = _Array$prototype$slic2[_i20];
                            if (script.src && script.src === scriptLocation) return script;
                        }
                    } catch (err) {}
                }()) return currentScript;
                throw new Error("Can not determine current script");
            });
            var currentUID = uniqueID();
            memoize(function() {
                var script;
                try {
                    script = getCurrentScript();
                } catch (err) {
                    return currentUID;
                }
                var uid = script.getAttribute("data-uid");
                if (uid && "string" == typeof uid) return uid;
                uid = uniqueID();
                script.setAttribute("data-uid", uid);
                return uid;
            });
            function global_getGlobal(win) {
                void 0 === win && (win = window);
                var globalKey = "__post_robot_10_0_41__";
                return win !== window ? win[globalKey] : win[globalKey] = win[globalKey] || {};
            }
            var getObj = function() {
                return {};
            };
            function globalStore(key, defStore) {
                void 0 === key && (key = "store");
                void 0 === defStore && (defStore = getObj);
                return util_getOrSet(global_getGlobal(), key, function() {
                    var store = defStore();
                    return {
                        has: function(storeKey) {
                            return store.hasOwnProperty(storeKey);
                        },
                        get: function(storeKey, defVal) {
                            return store.hasOwnProperty(storeKey) ? store[storeKey] : defVal;
                        },
                        set: function(storeKey, val) {
                            store[storeKey] = val;
                            return val;
                        },
                        del: function(storeKey) {
                            delete store[storeKey];
                        },
                        getOrSet: function(storeKey, getter) {
                            return util_getOrSet(store, storeKey, getter);
                        },
                        reset: function() {
                            store = defStore();
                        },
                        keys: function() {
                            return Object.keys(store);
                        }
                    };
                });
            }
            var WildCard = function() {};
            function getWildcard() {
                var global = global_getGlobal();
                global.WINDOW_WILDCARD = global.WINDOW_WILDCARD || new WildCard;
                return global.WINDOW_WILDCARD;
            }
            function windowStore(key, defStore) {
                void 0 === key && (key = "store");
                void 0 === defStore && (defStore = getObj);
                return globalStore("windowStore").getOrSet(key, function() {
                    var winStore = new weakmap_CrossDomainSafeWeakMap;
                    var getStore = function(win) {
                        return winStore.getOrSet(win, defStore);
                    };
                    return {
                        has: function(win) {
                            return getStore(win).hasOwnProperty(key);
                        },
                        get: function(win, defVal) {
                            var store = getStore(win);
                            return store.hasOwnProperty(key) ? store[key] : defVal;
                        },
                        set: function(win, val) {
                            getStore(win)[key] = val;
                            return val;
                        },
                        del: function(win) {
                            delete getStore(win)[key];
                        },
                        getOrSet: function(win, getter) {
                            return util_getOrSet(getStore(win), key, getter);
                        }
                    };
                });
            }
            function getInstanceID() {
                return globalStore("instance").getOrSet("instanceID", uniqueID);
            }
            function resolveHelloPromise(win, _ref) {
                var domain = _ref.domain;
                var helloPromises = windowStore("helloPromises");
                var existingPromise = helloPromises.get(win);
                existingPromise && existingPromise.resolve({
                    domain: domain
                });
                var newPromise = promise_ZalgoPromise.resolve({
                    domain: domain
                });
                helloPromises.set(win, newPromise);
                return newPromise;
            }
            function sayHello(win, _ref4) {
                return (0, _ref4.send)(win, "postrobot_hello", {
                    instanceID: getInstanceID()
                }, {
                    domain: "*",
                    timeout: -1
                }).then(function(_ref5) {
                    var origin = _ref5.origin, instanceID = _ref5.data.instanceID;
                    resolveHelloPromise(win, {
                        domain: origin
                    });
                    return {
                        win: win,
                        domain: origin,
                        instanceID: instanceID
                    };
                });
            }
            function getWindowInstanceID(win, _ref6) {
                var send = _ref6.send;
                return windowStore("windowInstanceIDPromises").getOrSet(win, function() {
                    return sayHello(win, {
                        send: send
                    }).then(function(_ref7) {
                        return _ref7.instanceID;
                    });
                });
            }
            function markWindowKnown(win) {
                windowStore("knownWindows").set(win, !0);
            }
            function isSerializedType(item) {
                return "object" == typeof item && null !== item && "string" == typeof item.__type__;
            }
            function determineType(val) {
                return void 0 === val ? "undefined" : null === val ? "null" : Array.isArray(val) ? "array" : "function" == typeof val ? "function" : "object" == typeof val ? val instanceof Error ? "error" : "function" == typeof val.then ? "promise" : "[object RegExp]" === ({}).toString.call(val) ? "regex" : "[object Date]" === ({}).toString.call(val) ? "date" : "object" : "string" == typeof val ? "string" : "number" == typeof val ? "number" : "boolean" == typeof val ? "boolean" : void 0;
            }
            function serializeType(type, val) {
                return {
                    __type__: type,
                    __val__: val
                };
            }
            var _SERIALIZER;
            var SERIALIZER = ((_SERIALIZER = {}).function = function() {}, _SERIALIZER.error = function(_ref) {
                return serializeType("error", {
                    message: _ref.message,
                    stack: _ref.stack,
                    code: _ref.code,
                    data: _ref.data
                });
            }, _SERIALIZER.promise = function() {}, _SERIALIZER.regex = function(val) {
                return serializeType("regex", val.source);
            }, _SERIALIZER.date = function(val) {
                return serializeType("date", val.toJSON());
            }, _SERIALIZER.array = function(val) {
                return val;
            }, _SERIALIZER.object = function(val) {
                return val;
            }, _SERIALIZER.string = function(val) {
                return val;
            }, _SERIALIZER.number = function(val) {
                return val;
            }, _SERIALIZER.boolean = function(val) {
                return val;
            }, _SERIALIZER.null = function(val) {
                return val;
            }, _SERIALIZER);
            var defaultSerializers = {};
            var _DESERIALIZER;
            var DESERIALIZER = ((_DESERIALIZER = {}).function = function() {
                throw new Error("Function serialization is not implemented; nothing to deserialize");
            }, _DESERIALIZER.error = function(_ref2) {
                var stack = _ref2.stack, code = _ref2.code, data = _ref2.data;
                var error = new Error(_ref2.message);
                error.code = code;
                data && (error.data = data);
                error.stack = stack + "\n\n" + error.stack;
                return error;
            }, _DESERIALIZER.promise = function() {
                throw new Error("Promise serialization is not implemented; nothing to deserialize");
            }, _DESERIALIZER.regex = function(val) {
                return new RegExp(val);
            }, _DESERIALIZER.date = function(val) {
                return new Date(val);
            }, _DESERIALIZER.array = function(val) {
                return val;
            }, _DESERIALIZER.object = function(val) {
                return val;
            }, _DESERIALIZER.string = function(val) {
                return val;
            }, _DESERIALIZER.number = function(val) {
                return val;
            }, _DESERIALIZER.boolean = function(val) {
                return val;
            }, _DESERIALIZER.null = function(val) {
                return val;
            }, _DESERIALIZER);
            var defaultDeserializers = {};
            new promise_ZalgoPromise(function(resolve) {
                if (window.document && window.document.body) return resolve(window.document.body);
                var interval = setInterval(function() {
                    if (window.document && window.document.body) {
                        clearInterval(interval);
                        return resolve(window.document.body);
                    }
                }, 10);
            });
            function cleanupProxyWindows() {
                var idToProxyWindow = globalStore("idToProxyWindow");
                for(var _i2 = 0, _idToProxyWindow$keys2 = idToProxyWindow.keys(); _i2 < _idToProxyWindow$keys2.length; _i2++){
                    var id = _idToProxyWindow$keys2[_i2];
                    idToProxyWindow.get(id).shouldClean() && idToProxyWindow.del(id);
                }
            }
            function getSerializedWindow(winPromise, _ref) {
                var send = _ref.send, _ref$id = _ref.id, id = void 0 === _ref$id ? uniqueID() : _ref$id;
                var windowNamePromise = winPromise.then(function(win) {
                    if (isSameDomain(win)) return assertSameDomain(win).name;
                });
                var windowTypePromise = winPromise.then(function(window1) {
                    if (isWindowClosed(window1)) throw new Error("Window is closed, can not determine type");
                    return getOpener(window1) ? "popup" : "iframe";
                });
                windowNamePromise.catch(src_util_noop);
                windowTypePromise.catch(src_util_noop);
                return {
                    id: id,
                    getType: function() {
                        return windowTypePromise;
                    },
                    getInstanceID: memoizePromise(function() {
                        return winPromise.then(function(win) {
                            return getWindowInstanceID(win, {
                                send: send
                            });
                        });
                    }),
                    close: function() {
                        return winPromise.then(closeWindow);
                    },
                    getName: function() {
                        return winPromise.then(function(win) {
                            if (!isWindowClosed(win)) return isSameDomain(win) ? assertSameDomain(win).name : windowNamePromise;
                        });
                    },
                    focus: function() {
                        return winPromise.then(function(win) {
                            win.focus();
                        });
                    },
                    isClosed: function() {
                        return winPromise.then(function(win) {
                            return isWindowClosed(win);
                        });
                    },
                    setLocation: function(href) {
                        return winPromise.then(function(win) {
                            var domain = window.location.protocol + "//" + window.location.host;
                            if (0 === href.indexOf("/")) href = "" + domain + href;
                            else if (!href.match(/^https?:\/\//) && 0 !== href.indexOf(domain)) throw new Error("Expected url to be http or https url, or absolute path, got " + JSON.stringify(href));
                            if (isSameDomain(win)) try {
                                if (win.location && "function" == typeof win.location.replace) {
                                    win.location.replace(href);
                                    return;
                                }
                            } catch (err) {}
                            win.location = href;
                        });
                    },
                    setName: function(name) {
                        return winPromise.then(function(win) {
                            var sameDomain = isSameDomain(win);
                            var frame = function(win) {
                                if (isSameDomain(win)) return assertSameDomain(win).frameElement;
                                for(var _i21 = 0, _document$querySelect2 = document.querySelectorAll("iframe"); _i21 < _document$querySelect2.length; _i21++){
                                    var frame = _document$querySelect2[_i21];
                                    if (frame && frame.contentWindow && frame.contentWindow === win) return frame;
                                }
                            }(win);
                            if (!sameDomain) throw new Error("Can not set name for cross-domain window: " + name);
                            assertSameDomain(win).name = name;
                            frame && frame.setAttribute("name", name);
                            windowNamePromise = promise_ZalgoPromise.resolve(name);
                        });
                    }
                };
            }
            var window_ProxyWindow = function() {
                function ProxyWindow(_ref2) {
                    var send = _ref2.send, win = _ref2.win, serializedWindow = _ref2.serializedWindow;
                    this.id = void 0;
                    this.isProxyWindow = !0;
                    this.serializedWindow = void 0;
                    this.actualWindow = void 0;
                    this.actualWindowPromise = void 0;
                    this.send = void 0;
                    this.name = void 0;
                    this.actualWindowPromise = new promise_ZalgoPromise;
                    this.serializedWindow = serializedWindow || getSerializedWindow(this.actualWindowPromise, {
                        send: send
                    });
                    globalStore("idToProxyWindow").set(this.getID(), this);
                    win && this.setWindow(win, {
                        send: send
                    });
                }
                var _proto = ProxyWindow.prototype;
                _proto.getID = function() {
                    return this.serializedWindow.id;
                };
                _proto.getType = function() {
                    return this.serializedWindow.getType();
                };
                _proto.isPopup = function() {
                    return this.getType().then(function(type) {
                        return "popup" === type;
                    });
                };
                _proto.setLocation = function(href) {
                    var _this = this;
                    return this.serializedWindow.setLocation(href).then(function() {
                        return _this;
                    });
                };
                _proto.getName = function() {
                    return this.serializedWindow.getName();
                };
                _proto.setName = function(name) {
                    var _this2 = this;
                    return this.serializedWindow.setName(name).then(function() {
                        return _this2;
                    });
                };
                _proto.close = function() {
                    var _this3 = this;
                    return this.serializedWindow.close().then(function() {
                        return _this3;
                    });
                };
                _proto.focus = function() {
                    var _this4 = this;
                    var isPopupPromise = this.isPopup();
                    var getNamePromise = this.getName();
                    var reopenPromise = promise_ZalgoPromise.hash({
                        isPopup: isPopupPromise,
                        name: getNamePromise
                    }).then(function(_ref3) {
                        var name = _ref3.name;
                        _ref3.isPopup && name && window.open("", name);
                    });
                    var focusPromise = this.serializedWindow.focus();
                    return promise_ZalgoPromise.all([
                        reopenPromise,
                        focusPromise
                    ]).then(function() {
                        return _this4;
                    });
                };
                _proto.isClosed = function() {
                    return this.serializedWindow.isClosed();
                };
                _proto.getWindow = function() {
                    return this.actualWindow;
                };
                _proto.setWindow = function(win, _ref4) {
                    var send = _ref4.send;
                    this.actualWindow = win;
                    this.actualWindowPromise.resolve(this.actualWindow);
                    this.serializedWindow = getSerializedWindow(this.actualWindowPromise, {
                        send: send,
                        id: this.getID()
                    });
                    windowStore("winToProxyWindow").set(win, this);
                };
                _proto.awaitWindow = function() {
                    return this.actualWindowPromise;
                };
                _proto.matchWindow = function(win, _ref5) {
                    var _this5 = this;
                    var send = _ref5.send;
                    return promise_ZalgoPromise.try(function() {
                        return _this5.actualWindow ? win === _this5.actualWindow : promise_ZalgoPromise.hash({
                            proxyInstanceID: _this5.getInstanceID(),
                            knownWindowInstanceID: getWindowInstanceID(win, {
                                send: send
                            })
                        }).then(function(_ref6) {
                            var match = _ref6.proxyInstanceID === _ref6.knownWindowInstanceID;
                            match && _this5.setWindow(win, {
                                send: send
                            });
                            return match;
                        });
                    });
                };
                _proto.unwrap = function() {
                    return this.actualWindow || this;
                };
                _proto.getInstanceID = function() {
                    return this.serializedWindow.getInstanceID();
                };
                _proto.shouldClean = function() {
                    return Boolean(this.actualWindow && isWindowClosed(this.actualWindow));
                };
                _proto.serialize = function() {
                    return this.serializedWindow;
                };
                ProxyWindow.unwrap = function(win) {
                    return ProxyWindow.isProxyWindow(win) ? win.unwrap() : win;
                };
                ProxyWindow.serialize = function(win, _ref7) {
                    var send = _ref7.send;
                    cleanupProxyWindows();
                    return ProxyWindow.toProxyWindow(win, {
                        send: send
                    }).serialize();
                };
                ProxyWindow.deserialize = function(serializedWindow, _ref8) {
                    var send = _ref8.send;
                    cleanupProxyWindows();
                    return globalStore("idToProxyWindow").get(serializedWindow.id) || new ProxyWindow({
                        serializedWindow: serializedWindow,
                        send: send
                    });
                };
                ProxyWindow.isProxyWindow = function(obj) {
                    return Boolean(obj && !isWindow(obj) && obj.isProxyWindow);
                };
                ProxyWindow.toProxyWindow = function(win, _ref9) {
                    var send = _ref9.send;
                    cleanupProxyWindows();
                    if (ProxyWindow.isProxyWindow(win)) return win;
                    var actualWindow = win;
                    return windowStore("winToProxyWindow").get(actualWindow) || new ProxyWindow({
                        win: actualWindow,
                        send: send
                    });
                };
                return ProxyWindow;
            }();
            function addMethod(id, val, name, source, domain) {
                var methodStore = windowStore("methodStore");
                var proxyWindowMethods = globalStore("proxyWindowMethods");
                if (window_ProxyWindow.isProxyWindow(source)) proxyWindowMethods.set(id, {
                    val: val,
                    name: name,
                    domain: domain,
                    source: source
                });
                else {
                    proxyWindowMethods.del(id);
                    methodStore.getOrSet(source, function() {
                        return {};
                    })[id] = {
                        domain: domain,
                        name: name,
                        val: val,
                        source: source
                    };
                }
            }
            function lookupMethod(source, id) {
                var methodStore = windowStore("methodStore");
                var proxyWindowMethods = globalStore("proxyWindowMethods");
                return methodStore.getOrSet(source, function() {
                    return {};
                })[id] || proxyWindowMethods.get(id);
            }
            function function_serializeFunction(destination, domain, val, key, _ref3) {
                on = (_ref = {
                    on: _ref3.on,
                    send: _ref3.send
                }).on, send = _ref.send, globalStore("builtinListeners").getOrSet("functionCalls", function() {
                    return on("postrobot_method", {
                        domain: "*"
                    }, function(_ref2) {
                        var source = _ref2.source, origin = _ref2.origin, data = _ref2.data;
                        var id = data.id, name = data.name;
                        var meth = lookupMethod(source, id);
                        if (!meth) throw new Error("Could not find method '" + name + "' with id: " + data.id + " in " + getDomain(window));
                        var methodSource = meth.source, domain = meth.domain, val = meth.val;
                        return promise_ZalgoPromise.try(function() {
                            if (!matchDomain(domain, origin)) throw new Error("Method '" + data.name + "' domain " + JSON.stringify(util_isRegex(meth.domain) ? meth.domain.source : meth.domain) + " does not match origin " + origin + " in " + getDomain(window));
                            if (window_ProxyWindow.isProxyWindow(methodSource)) return methodSource.matchWindow(source, {
                                send: send
                            }).then(function(match) {
                                if (!match) throw new Error("Method call '" + data.name + "' failed - proxy window does not match source in " + getDomain(window));
                            });
                        }).then(function() {
                            return val.apply({
                                source: source,
                                origin: origin
                            }, data.args);
                        }, function(err) {
                            return promise_ZalgoPromise.try(function() {
                                if (val.onError) return val.onError(err);
                            }).then(function() {
                                err.stack && (err.stack = "Remote call to " + name + "(" + function(args) {
                                    void 0 === args && (args = []);
                                    var item;
                                    return (item = args, [].slice.call(item)).map(function(arg) {
                                        return "string" == typeof arg ? "'" + arg + "'" : void 0 === arg ? "undefined" : null === arg ? "null" : "boolean" == typeof arg ? arg.toString() : Array.isArray(arg) ? "[ ... ]" : "object" == typeof arg ? "{ ... }" : "function" == typeof arg ? "() => { ... }" : "<" + typeof arg + ">";
                                    }).join(", ");
                                }(data.args) + ") failed\n\n" + err.stack);
                                throw err;
                            });
                        }).then(function(result) {
                            return {
                                result: result,
                                id: id,
                                name: name
                            };
                        });
                    });
                });
                var _ref, on, send;
                var id = val.__id__ || uniqueID();
                destination = window_ProxyWindow.unwrap(destination);
                var name = val.__name__ || val.name || key;
                "string" == typeof name && "function" == typeof name.indexOf && 0 === name.indexOf("anonymous::") && (name = name.replace("anonymous::", key + "::"));
                if (window_ProxyWindow.isProxyWindow(destination)) {
                    addMethod(id, val, name, destination, domain);
                    destination.awaitWindow().then(function(win) {
                        addMethod(id, val, name, win, domain);
                    });
                } else addMethod(id, val, name, destination, domain);
                return serializeType("cross_domain_function", {
                    id: id,
                    name: name
                });
            }
            function serializeMessage(destination, domain, obj, _ref) {
                var _serialize;
                var on = _ref.on, send = _ref.send;
                return function(obj, serializers) {
                    void 0 === serializers && (serializers = defaultSerializers);
                    var result = JSON.stringify(obj, function(key) {
                        var val = this[key];
                        if (isSerializedType(this)) return val;
                        var type = determineType(val);
                        if (!type) return val;
                        var serializer = serializers[type] || SERIALIZER[type];
                        return serializer ? serializer(val, key) : val;
                    });
                    return void 0 === result ? "undefined" : result;
                }(obj, ((_serialize = {}).promise = function(val, key) {
                    return function(destination, domain, val, key, _ref) {
                        return serializeType("cross_domain_zalgo_promise", {
                            then: function_serializeFunction(destination, domain, function(resolve, reject) {
                                return val.then(resolve, reject);
                            }, key, {
                                on: _ref.on,
                                send: _ref.send
                            })
                        });
                    }(destination, domain, val, key, {
                        on: on,
                        send: send
                    });
                }, _serialize.function = function(val, key) {
                    return function_serializeFunction(destination, domain, val, key, {
                        on: on,
                        send: send
                    });
                }, _serialize.object = function(val) {
                    return isWindow(val) || window_ProxyWindow.isProxyWindow(val) ? serializeType("cross_domain_window", window_ProxyWindow.serialize(val, {
                        send: send
                    })) : val;
                }, _serialize));
            }
            function deserializeMessage(source, origin, message, _ref2) {
                var _deserialize;
                var send = _ref2.send;
                return function(str, deserializers) {
                    void 0 === deserializers && (deserializers = defaultDeserializers);
                    if ("undefined" !== str) return JSON.parse(str, function(key, val) {
                        if (isSerializedType(this)) return val;
                        var type;
                        var value;
                        if (isSerializedType(val)) {
                            type = val.__type__;
                            value = val.__val__;
                        } else {
                            type = determineType(val);
                            value = val;
                        }
                        if (!type) return value;
                        var deserializer = deserializers[type] || DESERIALIZER[type];
                        return deserializer ? deserializer(value, key) : value;
                    });
                }(message, ((_deserialize = {}).cross_domain_zalgo_promise = function(serializedPromise) {
                    return function(source, origin, _ref2) {
                        return new promise_ZalgoPromise(_ref2.then);
                    }(0, 0, serializedPromise);
                }, _deserialize.cross_domain_function = function(serializedFunction) {
                    return function(source, origin, _ref4, _ref5) {
                        var id = _ref4.id, name = _ref4.name;
                        var send = _ref5.send;
                        var getDeserializedFunction = function(opts) {
                            void 0 === opts && (opts = {});
                            function crossDomainFunctionWrapper() {
                                var _arguments = arguments;
                                return window_ProxyWindow.toProxyWindow(source, {
                                    send: send
                                }).awaitWindow().then(function(win) {
                                    var meth = lookupMethod(win, id);
                                    if (meth && meth.val !== crossDomainFunctionWrapper) return meth.val.apply({
                                        source: window,
                                        origin: getDomain()
                                    }, _arguments);
                                    var _args = [].slice.call(_arguments);
                                    return opts.fireAndForget ? send(win, "postrobot_method", {
                                        id: id,
                                        name: name,
                                        args: _args
                                    }, {
                                        domain: origin,
                                        fireAndForget: !0
                                    }) : send(win, "postrobot_method", {
                                        id: id,
                                        name: name,
                                        args: _args
                                    }, {
                                        domain: origin,
                                        fireAndForget: !1
                                    }).then(function(res) {
                                        return res.data.result;
                                    });
                                }).catch(function(err) {
                                    throw err;
                                });
                            }
                            crossDomainFunctionWrapper.__name__ = name;
                            crossDomainFunctionWrapper.__origin__ = origin;
                            crossDomainFunctionWrapper.__source__ = source;
                            crossDomainFunctionWrapper.__id__ = id;
                            crossDomainFunctionWrapper.origin = origin;
                            return crossDomainFunctionWrapper;
                        };
                        var crossDomainFunctionWrapper = getDeserializedFunction();
                        crossDomainFunctionWrapper.fireAndForget = getDeserializedFunction({
                            fireAndForget: !0
                        });
                        return crossDomainFunctionWrapper;
                    }(source, origin, serializedFunction, {
                        send: send
                    });
                }, _deserialize.cross_domain_window = function(serializedWindow) {
                    return window_ProxyWindow.deserialize(serializedWindow, {
                        send: send
                    });
                }, _deserialize));
            }
            var SEND_MESSAGE_STRATEGIES = {};
            SEND_MESSAGE_STRATEGIES.postrobot_post_message = function(win, serializedMessage, domain) {
                0 === domain.indexOf("file:") && (domain = "*");
                win.postMessage(serializedMessage, domain);
            };
            function send_sendMessage(win, domain, message, _ref2) {
                var on = _ref2.on, send = _ref2.send;
                return promise_ZalgoPromise.try(function() {
                    var domainBuffer = windowStore().getOrSet(win, function() {
                        return {};
                    });
                    domainBuffer.buffer = domainBuffer.buffer || [];
                    domainBuffer.buffer.push(message);
                    domainBuffer.flush = domainBuffer.flush || promise_ZalgoPromise.flush().then(function() {
                        if (isWindowClosed(win)) throw new Error("Window is closed");
                        var serializedMessage = serializeMessage(win, domain, ((_ref = {}).__post_robot_10_0_41__ = domainBuffer.buffer || [], _ref), {
                            on: on,
                            send: send
                        });
                        var _ref;
                        delete domainBuffer.buffer;
                        var strategies = Object.keys(SEND_MESSAGE_STRATEGIES);
                        var errors = [];
                        for(var _i2 = 0; _i2 < strategies.length; _i2++){
                            var strategyName = strategies[_i2];
                            try {
                                SEND_MESSAGE_STRATEGIES[strategyName](win, serializedMessage, domain);
                            } catch (err) {
                                errors.push(err);
                            }
                        }
                        if (errors.length === strategies.length) throw new Error("All post-robot messaging strategies failed:\n\n" + errors.map(function(err, i) {
                            return i + ". " + stringifyError(err);
                        }).join("\n\n"));
                    });
                    return domainBuffer.flush.then(function() {
                        delete domainBuffer.flush;
                    });
                }).then(src_util_noop);
            }
            function getResponseListener(hash) {
                return globalStore("responseListeners").get(hash);
            }
            function deleteResponseListener(hash) {
                globalStore("responseListeners").del(hash);
            }
            function isResponseListenerErrored(hash) {
                return globalStore("erroredResponseListeners").has(hash);
            }
            function getRequestListener(_ref) {
                var name = _ref.name, win = _ref.win, domain = _ref.domain;
                var requestListeners = windowStore("requestListeners");
                "*" === win && (win = null);
                "*" === domain && (domain = null);
                if (!name) throw new Error("Name required to get request listener");
                for(var _i4 = 0, _ref3 = [
                    win,
                    getWildcard()
                ]; _i4 < _ref3.length; _i4++){
                    var winQualifier = _ref3[_i4];
                    if (winQualifier) {
                        var nameListeners = requestListeners.get(winQualifier);
                        if (nameListeners) {
                            var domainListeners = nameListeners[name];
                            if (domainListeners) {
                                if (domain && "string" == typeof domain) {
                                    if (domainListeners[domain]) return domainListeners[domain];
                                    if (domainListeners.__domain_regex__) for(var _i6 = 0, _domainListeners$__DO2 = domainListeners.__domain_regex__; _i6 < _domainListeners$__DO2.length; _i6++){
                                        var _domainListeners$__DO3 = _domainListeners$__DO2[_i6], listener = _domainListeners$__DO3.listener;
                                        if (matchDomain(_domainListeners$__DO3.regex, domain)) return listener;
                                    }
                                }
                                if (domainListeners["*"]) return domainListeners["*"];
                            }
                        }
                    }
                }
            }
            function handleRequest(source, origin, message, _ref) {
                var on = _ref.on, send = _ref.send;
                var options = getRequestListener({
                    name: message.name,
                    win: source,
                    domain: origin
                });
                var logName = "postrobot_method" === message.name && message.data && "string" == typeof message.data.name ? message.data.name + "()" : message.name;
                function sendResponse(ack, data, error) {
                    return promise_ZalgoPromise.flush().then(function() {
                        if (!message.fireAndForget && !isWindowClosed(source)) try {
                            return send_sendMessage(source, origin, {
                                id: uniqueID(),
                                origin: getDomain(window),
                                type: "postrobot_message_response",
                                hash: message.hash,
                                name: message.name,
                                ack: ack,
                                data: data,
                                error: error
                            }, {
                                on: on,
                                send: send
                            });
                        } catch (err) {
                            throw new Error("Send response message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                        }
                    });
                }
                return promise_ZalgoPromise.all([
                    promise_ZalgoPromise.flush().then(function() {
                        if (!message.fireAndForget && !isWindowClosed(source)) try {
                            return send_sendMessage(source, origin, {
                                id: uniqueID(),
                                origin: getDomain(window),
                                type: "postrobot_message_ack",
                                hash: message.hash,
                                name: message.name
                            }, {
                                on: on,
                                send: send
                            });
                        } catch (err) {
                            throw new Error("Send ack message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                        }
                    }),
                    promise_ZalgoPromise.try(function() {
                        if (!options) throw new Error("No handler found for post message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                        if (!matchDomain(options.domain, origin)) throw new Error("Request origin " + origin + " does not match domain " + options.domain.toString());
                        return options.handler({
                            source: source,
                            origin: origin,
                            data: message.data
                        });
                    }).then(function(data) {
                        return sendResponse("success", data);
                    }, function(error) {
                        return sendResponse("error", null, error);
                    })
                ]).then(src_util_noop).catch(function(err) {
                    if (options && options.handleError) return options.handleError(err);
                    throw err;
                });
            }
            function handleAck(source, origin, message) {
                if (!isResponseListenerErrored(message.hash)) {
                    var options = getResponseListener(message.hash);
                    if (!options) throw new Error("No handler found for post message ack for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                    try {
                        if (!matchDomain(options.domain, origin)) throw new Error("Ack origin " + origin + " does not match domain " + options.domain.toString());
                        if (source !== options.win) throw new Error("Ack source does not match registered window");
                    } catch (err) {
                        options.promise.reject(err);
                    }
                    options.ack = !0;
                }
            }
            function handleResponse(source, origin, message) {
                if (!isResponseListenerErrored(message.hash)) {
                    var options = getResponseListener(message.hash);
                    if (!options) throw new Error("No handler found for post message response for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                    if (!matchDomain(options.domain, origin)) throw new Error("Response origin " + origin + " does not match domain " + (pattern = options.domain, Array.isArray(pattern) ? "(" + pattern.join(" | ") + ")" : isRegex(pattern) ? "RegExp(" + pattern.toString() : pattern.toString()));
                    var pattern;
                    if (source !== options.win) throw new Error("Response source does not match registered window");
                    deleteResponseListener(message.hash);
                    "error" === message.ack ? options.promise.reject(message.error) : "success" === message.ack && options.promise.resolve({
                        source: source,
                        origin: origin,
                        data: message.data
                    });
                }
            }
            function receive_receiveMessage(event, _ref2) {
                var on = _ref2.on, send = _ref2.send;
                var receivedMessages = globalStore("receivedMessages");
                try {
                    if (!window || window.closed || !event.source) return;
                } catch (err) {
                    return;
                }
                var source = event.source, origin = event.origin;
                var messages = function(message, source, origin, _ref) {
                    var on = _ref.on, send = _ref.send;
                    var parsedMessage;
                    try {
                        parsedMessage = deserializeMessage(source, origin, message, {
                            on: on,
                            send: send
                        });
                    } catch (err) {
                        return;
                    }
                    if (parsedMessage && "object" == typeof parsedMessage && null !== parsedMessage) {
                        var parseMessages = parsedMessage.__post_robot_10_0_41__;
                        if (Array.isArray(parseMessages)) return parseMessages;
                    }
                }(event.data, source, origin, {
                    on: on,
                    send: send
                });
                if (messages) {
                    markWindowKnown(source);
                    for(var _i2 = 0; _i2 < messages.length; _i2++){
                        var message = messages[_i2];
                        if (receivedMessages.has(message.id)) return;
                        receivedMessages.set(message.id, !0);
                        if (isWindowClosed(source) && !message.fireAndForget) return;
                        0 === message.origin.indexOf("file:") && (origin = "file://");
                        try {
                            "postrobot_message_request" === message.type ? handleRequest(source, origin, message, {
                                on: on,
                                send: send
                            }) : "postrobot_message_response" === message.type ? handleResponse(source, origin, message) : "postrobot_message_ack" === message.type && handleAck(source, origin, message);
                        } catch (err) {
                            setTimeout(function() {
                                throw err;
                            }, 0);
                        }
                    }
                }
            }
            function on_on(name, options, handler) {
                if (!name) throw new Error("Expected name");
                if ("function" == typeof (options = options || {})) {
                    handler = options;
                    options = {};
                }
                if (!handler) throw new Error("Expected handler");
                (options = options || {}).name = name;
                options.handler = handler || options.handler;
                var win = options.window;
                var domain = options.domain;
                var requestListener = function addRequestListener(_ref4, listener) {
                    var name = _ref4.name, win = _ref4.win, domain = _ref4.domain;
                    var requestListeners = windowStore("requestListeners");
                    if (!name || "string" != typeof name) throw new Error("Name required to add request listener");
                    if (Array.isArray(win)) {
                        var listenersCollection = [];
                        for(var _i8 = 0, _win2 = win; _i8 < _win2.length; _i8++)listenersCollection.push(addRequestListener({
                            name: name,
                            domain: domain,
                            win: _win2[_i8]
                        }, listener));
                        return {
                            cancel: function() {
                                for(var _i10 = 0; _i10 < listenersCollection.length; _i10++)listenersCollection[_i10].cancel();
                            }
                        };
                    }
                    if (Array.isArray(domain)) {
                        var _listenersCollection = [];
                        for(var _i12 = 0, _domain2 = domain; _i12 < _domain2.length; _i12++)_listenersCollection.push(addRequestListener({
                            name: name,
                            win: win,
                            domain: _domain2[_i12]
                        }, listener));
                        return {
                            cancel: function() {
                                for(var _i14 = 0; _i14 < _listenersCollection.length; _i14++)_listenersCollection[_i14].cancel();
                            }
                        };
                    }
                    var existingListener = getRequestListener({
                        name: name,
                        win: win,
                        domain: domain
                    });
                    win && "*" !== win || (win = getWildcard());
                    domain = domain || "*";
                    if (existingListener) throw win && domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString() + " for " + (win === getWildcard() ? "wildcard" : "specified") + " window") : win ? new Error("Request listener already exists for " + name + " for " + (win === getWildcard() ? "wildcard" : "specified") + " window") : domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString()) : new Error("Request listener already exists for " + name);
                    var nameListeners = requestListeners.getOrSet(win, function() {
                        return {};
                    });
                    var domainListeners = util_getOrSet(nameListeners, name, function() {
                        return {};
                    });
                    var strDomain = domain.toString();
                    var regexListeners;
                    var regexListener;
                    util_isRegex(domain) ? (regexListeners = util_getOrSet(domainListeners, "__domain_regex__", function() {
                        return [];
                    })).push(regexListener = {
                        regex: domain,
                        listener: listener
                    }) : domainListeners[strDomain] = listener;
                    return {
                        cancel: function() {
                            delete domainListeners[strDomain];
                            if (regexListener) {
                                regexListeners.splice(regexListeners.indexOf(regexListener, 1));
                                regexListeners.length || delete domainListeners.__domain_regex__;
                            }
                            Object.keys(domainListeners).length || delete nameListeners[name];
                            win && !Object.keys(nameListeners).length && requestListeners.del(win);
                        }
                    };
                }({
                    name: name,
                    win: win,
                    domain: domain
                }, {
                    handler: options.handler,
                    handleError: options.errorHandler || function(err) {
                        throw err;
                    },
                    window: win,
                    domain: domain || "*",
                    name: name
                });
                return {
                    cancel: function() {
                        requestListener.cancel();
                    }
                };
            }
            function on_once(name, options, handler) {
                if ("function" == typeof (options = options || {})) {
                    handler = options;
                    options = {};
                }
                var promise = new promise_ZalgoPromise;
                var listener;
                options.errorHandler = function(err) {
                    listener.cancel();
                    promise.reject(err);
                };
                listener = on_on(name, options, function(event) {
                    listener.cancel();
                    promise.resolve(event);
                    if (handler) return handler(event);
                });
                promise.cancel = listener.cancel;
                return promise;
            }
            var send_send = function send(win, name, data, options) {
                var domainMatcher = (options = options || {}).domain || "*";
                var responseTimeout = options.timeout || -1;
                var childTimeout = options.timeout || 5e3;
                var fireAndForget = options.fireAndForget || !1;
                return promise_ZalgoPromise.try(function() {
                    !function(name, win, domain) {
                        if (!name) throw new Error("Expected name");
                        if (domain && "string" != typeof domain && !Array.isArray(domain) && !util_isRegex(domain)) throw new TypeError("Can not send " + name + ". Expected domain " + JSON.stringify(domain) + " to be a string, array, or regex");
                        if (isWindowClosed(win)) throw new Error("Can not send " + name + ". Target window is closed");
                    }(name, win, domainMatcher);
                    if (function(parent, child) {
                        var actualParent = getAncestor(child);
                        if (actualParent) return actualParent === parent;
                        if (child === parent) return !1;
                        if (function(win) {
                            void 0 === win && (win = window);
                            try {
                                if (win.top) return win.top;
                            } catch (err) {}
                            if (getParent(win) === win) return win;
                            try {
                                if (isAncestorParent(window, win) && window.top) return window.top;
                            } catch (err) {}
                            try {
                                if (isAncestorParent(win, window) && window.top) return window.top;
                            } catch (err) {}
                            for(var _i7 = 0, _getAllChildFrames4 = function getAllChildFrames(win) {
                                var result = [];
                                for(var _i3 = 0, _getFrames2 = getFrames(win); _i3 < _getFrames2.length; _i3++){
                                    var frame = _getFrames2[_i3];
                                    result.push(frame);
                                    for(var _i5 = 0, _getAllChildFrames2 = getAllChildFrames(frame); _i5 < _getAllChildFrames2.length; _i5++)result.push(_getAllChildFrames2[_i5]);
                                }
                                return result;
                            }(win); _i7 < _getAllChildFrames4.length; _i7++){
                                var frame = _getAllChildFrames4[_i7];
                                try {
                                    if (frame.top) return frame.top;
                                } catch (err) {}
                                if (getParent(frame) === frame) return frame;
                            }
                        }(child) === child) return !1;
                        for(var _i15 = 0, _getFrames8 = getFrames(parent); _i15 < _getFrames8.length; _i15++)if (_getFrames8[_i15] === child) return !0;
                        return !1;
                    }(window, win)) return function(win, timeout, name) {
                        void 0 === timeout && (timeout = 5e3);
                        void 0 === name && (name = "Window");
                        var promise = function(win) {
                            return windowStore("helloPromises").getOrSet(win, function() {
                                return new promise_ZalgoPromise;
                            });
                        }(win);
                        -1 !== timeout && (promise = promise.timeout(timeout, new Error(name + " did not load after " + timeout + "ms")));
                        return promise;
                    }(win, childTimeout);
                }).then(function(_temp) {
                    return function(win, targetDomain, actualDomain, _ref) {
                        var send = _ref.send;
                        return promise_ZalgoPromise.try(function() {
                            return "string" == typeof targetDomain ? targetDomain : promise_ZalgoPromise.try(function() {
                                return actualDomain || sayHello(win, {
                                    send: send
                                }).then(function(_ref2) {
                                    return _ref2.domain;
                                });
                            }).then(function(normalizedDomain) {
                                if (!matchDomain(targetDomain, targetDomain)) throw new Error("Domain " + stringify(targetDomain) + " does not match " + stringify(targetDomain));
                                return normalizedDomain;
                            });
                        });
                    }(win, domainMatcher, (void 0 === _temp ? {} : _temp).domain, {
                        send: send
                    });
                }).then(function(targetDomain) {
                    var domain = targetDomain;
                    var logName = "postrobot_method" === name && data && "string" == typeof data.name ? data.name + "()" : name;
                    var promise = new promise_ZalgoPromise;
                    var hash = name + "_" + uniqueID();
                    if (!fireAndForget) {
                        var responseListener = {
                            name: name,
                            win: win,
                            domain: domain,
                            promise: promise
                        };
                        !function(hash, listener) {
                            globalStore("responseListeners").set(hash, listener);
                        }(hash, responseListener);
                        var reqPromises = windowStore("requestPromises").getOrSet(win, function() {
                            return [];
                        });
                        reqPromises.push(promise);
                        promise.catch(function() {
                            !function(hash) {
                                globalStore("erroredResponseListeners").set(hash, !0);
                            }(hash);
                            deleteResponseListener(hash);
                        });
                        var totalAckTimeout = function(win) {
                            return windowStore("knownWindows").get(win, !1);
                        }(win) ? 1e4 : 2e3;
                        var totalResTimeout = responseTimeout;
                        var ackTimeout = totalAckTimeout;
                        var resTimeout = totalResTimeout;
                        var interval = function(method, time) {
                            var timeout;
                            !function loop() {
                                timeout = setTimeout(function() {
                                    !function() {
                                        if (isWindowClosed(win)) return promise.reject(new Error("Window closed for " + name + " before " + (responseListener.ack ? "response" : "ack")));
                                        if (responseListener.cancelled) return promise.reject(new Error("Response listener was cancelled for " + name));
                                        ackTimeout = Math.max(ackTimeout - 500, 0);
                                        -1 !== resTimeout && (resTimeout = Math.max(resTimeout - 500, 0));
                                        responseListener.ack || 0 !== ackTimeout ? 0 === resTimeout && promise.reject(new Error("No response for postMessage " + logName + " in " + getDomain() + " in " + totalResTimeout + "ms")) : promise.reject(new Error("No ack for postMessage " + logName + " in " + getDomain() + " in " + totalAckTimeout + "ms"));
                                    }();
                                    loop();
                                }, 500);
                            }();
                            return {
                                cancel: function() {
                                    clearTimeout(timeout);
                                }
                            };
                        }();
                        promise.finally(function() {
                            interval.cancel();
                            reqPromises.splice(reqPromises.indexOf(promise, 1));
                        }).catch(src_util_noop);
                    }
                    return send_sendMessage(win, domain, {
                        id: uniqueID(),
                        origin: getDomain(window),
                        type: "postrobot_message_request",
                        hash: hash,
                        name: name,
                        data: data,
                        fireAndForget: fireAndForget
                    }, {
                        on: on_on,
                        send: send
                    }).then(function() {
                        return fireAndForget ? promise.resolve() : promise;
                    }, function(err) {
                        throw new Error("Send request message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                    });
                });
            };
            function setup_serializeMessage(destination, domain, obj) {
                return serializeMessage(destination, domain, obj, {
                    on: on_on,
                    send: send_send
                });
            }
            function setup_deserializeMessage(source, origin, message) {
                return deserializeMessage(source, origin, message, {
                    on: on_on,
                    send: send_send
                });
            }
            function createProxyWindow(win) {
                return new window_ProxyWindow({
                    send: send_send,
                    win: win
                });
            }
            function setup_toProxyWindow(win) {
                return window_ProxyWindow.toProxyWindow(win, {
                    send: send_send
                });
            }
            function setup() {
                if (!global_getGlobal().initialized) {
                    global_getGlobal().initialized = !0;
                    on = (_ref3 = {
                        on: on_on,
                        send: send_send
                    }).on, send = _ref3.send, (global = global_getGlobal()).receiveMessage = global.receiveMessage || function(message) {
                        return receive_receiveMessage(message, {
                            on: on,
                            send: send
                        });
                    };
                    !function(_ref5) {
                        var on = _ref5.on, send = _ref5.send;
                        globalStore().getOrSet("postMessageListener", function() {
                            return function(obj, event, handler) {
                                obj.addEventListener("message", handler);
                                return {
                                    cancel: function() {
                                        obj.removeEventListener("message", handler);
                                    }
                                };
                            }(window, 0, function(event) {
                                !function(event, _ref4) {
                                    var on = _ref4.on, send = _ref4.send;
                                    promise_ZalgoPromise.try(function() {
                                        var source = event.source || event.sourceElement;
                                        var origin = event.origin || event.originalEvent && event.originalEvent.origin;
                                        var data = event.data;
                                        "null" === origin && (origin = "file://");
                                        if (source) {
                                            if (!origin) throw new Error("Post message did not have origin domain");
                                            receive_receiveMessage({
                                                source: source,
                                                origin: origin,
                                                data: data
                                            }, {
                                                on: on,
                                                send: send
                                            });
                                        }
                                    });
                                }(event, {
                                    on: on,
                                    send: send
                                });
                            });
                        });
                    }({
                        on: on_on,
                        send: send_send
                    });
                    !function(_ref8) {
                        var on = _ref8.on, send = _ref8.send;
                        globalStore("builtinListeners").getOrSet("helloListener", function() {
                            var listener = on("postrobot_hello", {
                                domain: "*"
                            }, function(_ref3) {
                                resolveHelloPromise(_ref3.source, {
                                    domain: _ref3.origin
                                });
                                return {
                                    instanceID: getInstanceID()
                                };
                            });
                            var parent = getAncestor();
                            parent && sayHello(parent, {
                                send: send
                            }).catch(function(err) {});
                            return listener;
                        });
                    }({
                        on: on_on,
                        send: send_send
                    });
                }
                var _ref3, on, send, global;
            }
            function destroy() {
                !function() {
                    var responseListeners = globalStore("responseListeners");
                    for(var _i2 = 0, _responseListeners$ke2 = responseListeners.keys(); _i2 < _responseListeners$ke2.length; _i2++){
                        var hash = _responseListeners$ke2[_i2];
                        var listener = responseListeners.get(hash);
                        listener && (listener.cancelled = !0);
                        responseListeners.del(hash);
                    }
                }();
                (listener = globalStore().get("postMessageListener")) && listener.cancel();
                var listener;
                delete window.__post_robot_10_0_41__;
            }
            var src_types_TYPES_0 = !0;
            function cleanUpWindow(win) {
                for(var _i2 = 0, _requestPromises$get2 = windowStore("requestPromises").get(win, []); _i2 < _requestPromises$get2.length; _i2++)_requestPromises$get2[_i2].reject(new Error("Window " + (isWindowClosed(win) ? "closed" : "cleaned up") + " before response")).catch(src_util_noop);
            }
            setup();
        }
    ]);
});

});

parcelRegister("cVuzC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $1VhsF = parcelRequire("1VhsF");


var $ad7Ou = parcelRequire("ad7Ou");


var $cuaBm = parcelRequire("cuaBm");

const $d67a3b86cd77a20f$var$styles = {
    box: "_3vBAKHv0qQ _3hxITi6wH8 _2V7sgO2M4S"
};
const $d67a3b86cd77a20f$var$ThreeLOPrompt = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(13);
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $cuaBm.useAuth)(props);
    const { authUrl: authUrl, onInitialization: onInitialization } = props;
    let t0;
    let t1;
    if ($[0] !== onInitialization) {
        t0 = ()=>{
            if (onInitialization) onInitialization();
        };
        t1 = [
            onInitialization
        ];
        $[0] = onInitialization;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    if (!authUrl || authUrl === "") {
        let t2;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
                appearance: "error"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d67a3b86cd77a20f$var$messages.noAuthURLErrorMessage));
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let t2;
    if ($[4] !== promptMessage) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, promptMessage);
        $[4] = promptMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== buttonText || $[7] !== loading || $[8] !== startAuth) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: startAuth,
            isLoading: loading
        }, buttonText);
        $[6] = buttonText;
        $[7] = loading;
        $[8] = startAuth;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== t2 || $[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onPointerDown: $d67a3b86cd77a20f$var$_temp,
            padding: "space.250",
            xcss: $d67a3b86cd77a20f$var$styles.box
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            alignInline: "start",
            space: "space.250",
            grow: "hug",
            testId: "three-lo-prompt"
        }, t2, t3)));
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : (props)=>{
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $cuaBm.useAuth)(props);
    const { authUrl: authUrl, onInitialization: onInitialization } = props;
    (0, $cozmU.useEffect)(()=>{
        if (onInitialization) onInitialization();
    }, [
        onInitialization
    ]);
    if (!authUrl || authUrl === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d67a3b86cd77a20f$var$messages.noAuthURLErrorMessage));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onPointerDown: (e)=>e.stopPropagation(),
        padding: "space.250",
        xcss: $d67a3b86cd77a20f$var$styles.box
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "start",
        space: "space.250",
        grow: "hug",
        testId: "three-lo-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, promptMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: startAuth,
        isLoading: loading
    }, buttonText))));
};
var $d67a3b86cd77a20f$export$2e2bcd8739ae039 = $d67a3b86cd77a20f$var$ThreeLOPrompt;
const $d67a3b86cd77a20f$export$92dadb4ff2941f34 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { forgeDoc: forgeDoc, dispatch: dispatch } = t0;
    const { message: message, authUrl: authUrl, promptText: promptText } = forgeDoc.props;
    let t1;
    if ($[0] !== dispatch) {
        t1 = ()=>dispatch({
                type: "render",
                extensionData: {}
            });
        $[0] = dispatch;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== authUrl || $[3] !== message || $[4] !== promptText || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d67a3b86cd77a20f$var$ThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            onSuccess: t1
        });
        $[2] = authUrl;
        $[3] = message;
        $[4] = promptText;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ forgeDoc: forgeDoc, dispatch: dispatch })=>{
    const { message: message, authUrl: authUrl, promptText: promptText } = forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d67a3b86cd77a20f$var$ThreeLOPrompt, {
        message: message,
        authUrl: authUrl,
        promptText: promptText,
        onSuccess: ()=>dispatch({
                type: 'render',
                extensionData: {}
            })
    });
};
const $d67a3b86cd77a20f$export$388ff2bd3ce4e348 = ({ appName: appName, onSuccess: onSuccess })=>{
    return function threeLOPrompt({ forgeDoc: { props: props }, dispatch: dispatch }) {
        const { message: message, authUrl: authUrl, promptText: promptText } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d67a3b86cd77a20f$var$ThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            appName: appName,
            onSuccess: ()=>{
                if (onSuccess) onSuccess();
                return dispatch({
                    type: 'render',
                    extensionData: {}
                });
            }
        });
    };
};
const $d67a3b86cd77a20f$export$7519b5f6e74be543 = ({ appName: appName, onSuccess: onSuccess, message: message, onInitialization: onInitialization })=>{
    return function threeLOPrompt(props) {
        const { authUrl: authUrl, promptText: promptText, onSuccess: onSuccessFromIframeComponent } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d67a3b86cd77a20f$var$ThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            appName: appName,
            onSuccess: ()=>{
                if (onSuccess) onSuccess();
                return Promise.resolve(onSuccessFromIframeComponent);
            },
            onInitialization: onInitialization
        });
    };
};
const $d67a3b86cd77a20f$var$messages = (0, $kSwu1.defineMessages)({
    noAuthURLErrorMessage: {
        id: "confluence.threeLOPrompt.no.authURL.error-message",
        defaultMessage: "Consent URL not found. Please refresh the page and try again."
    }
});
function $d67a3b86cd77a20f$var$_temp(e) {
    return e.stopPropagation();
}
module.exports["default"] = $d67a3b86cd77a20f$export$2e2bcd8739ae039;
module.exports["ThreeLOPromptRenderFn"] = $d67a3b86cd77a20f$export$92dadb4ff2941f34;
module.exports["makeThreeLOPromptForCustomUI"] = $d67a3b86cd77a20f$export$7519b5f6e74be543;

});

parcelRegister("l1aSK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4aRua = parcelRequire("4aRua");


var $fTOZ6 = parcelRequire("fTOZ6");


var $jvEso = parcelRequire("jvEso");

const $108fe2be9334ff20$var$useDeprecationWarning = (0, $gtMdU.isReactCompilerActivePlatform)() ? (componentName)=>{
    const $ = (0, $bDgLe.c)(4);
    const { forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $fTOZ6.RendererContext));
    let t0;
    let t1;
    if ($[0] !== componentName || $[1] !== forgeEnvironment) {
        t0 = ()=>{
            if (forgeEnvironment !== "PRODUCTION") (0, $jvEso.default)(`[@forge/react: ${componentName}] Warning: The "${componentName}" component is deprecated and will be removed on the 28th of August 2025. Please use the "Text" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/.`);
        };
        t1 = [
            forgeEnvironment,
            componentName
        ];
        $[0] = componentName;
        $[1] = forgeEnvironment;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
} : (componentName)=>{
    const { forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $fTOZ6.RendererContext));
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (forgeEnvironment !== 'PRODUCTION') (0, $jvEso.default)(`[@forge/react: ${componentName}] Warning: The "${componentName}" component is deprecated and will be removed on the 28th of August 2025. Please use the "Text" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/.`);
    }, [
        forgeEnvironment,
        componentName
    ]);
};
// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
const $108fe2be9334ff20$var$PROTOCOL_ALLOWLIST = [
    'http:',
    'https:',
    'ftp:',
    'ftps:',
    'mailto:',
    'skype:',
    'callto:',
    'facetime:',
    'git:',
    'irc:',
    'irc6:',
    'news:',
    'nntp:',
    'feed:',
    'cvs:',
    'svn:',
    'mvn:',
    'ssh:',
    'scp:',
    'sftp:',
    'itms:',
    'notes:',
    'hipchat:',
    'sourcetree:',
    'urn:',
    'tel:',
    'xmpp:',
    'telnet:',
    'vnc:',
    'rdp:',
    'whatsapp:',
    'slack:',
    'sip:',
    'sips:',
    'magnet:',
    'tds:'
];
const $108fe2be9334ff20$export$300bd6d67c49dbfc = (urlString)=>{
    const url = new URL(urlString || '', window.location.href);
    if ($108fe2be9334ff20$var$PROTOCOL_ALLOWLIST.includes(url.protocol)) return url.toString();
    else return 'about:blank';
};
const $108fe2be9334ff20$export$e7bdca014c19fc5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Em(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    $108fe2be9334ff20$var$useDeprecationWarning("Em");
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "em"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function Em({ children: children }) {
    $108fe2be9334ff20$var$useDeprecationWarning('Em');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "em"
    }, children);
};
const $108fe2be9334ff20$export$97176b8d51d2058f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Strike(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    $108fe2be9334ff20$var$useDeprecationWarning("Strike");
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("s", null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function Strike({ children: children }) {
    $108fe2be9334ff20$var$useDeprecationWarning('Strike');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("s", null, children);
};
const $108fe2be9334ff20$export$89b8e0fa65f6a914 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function String(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { text: text } = t0;
    let t1;
    if ($[0] !== text) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, text);
        $[0] = text;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function String({ text: text }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, text);
};
const $108fe2be9334ff20$export$f301627d437cff88 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Strong(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    $108fe2be9334ff20$var$useDeprecationWarning("Strong");
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "strong"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function Strong({ children: children }) {
    $108fe2be9334ff20$var$useDeprecationWarning('Strong');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong"
    }, children);
};
function $108fe2be9334ff20$var$wrap(Component) {
    return function WrappedComponent({ Components: Components, children: children, props: propsAny, render: render, renderChildren: renderChildren, dispatch: dispatch }) {
        const props = propsAny;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props, renderChildren({
            Components: Components,
            children: children,
            render: render,
            dispatch: dispatch
        }));
    };
}
const $108fe2be9334ff20$export$fec26b2d751c6d95 = $108fe2be9334ff20$var$wrap($108fe2be9334ff20$export$e7bdca014c19fc5c);
const $108fe2be9334ff20$export$e9e7c187aef6a83a = $108fe2be9334ff20$var$wrap($108fe2be9334ff20$export$97176b8d51d2058f);
const $108fe2be9334ff20$export$11a9c970dcafffc0 = $108fe2be9334ff20$var$wrap($108fe2be9334ff20$export$89b8e0fa65f6a914);
const $108fe2be9334ff20$export$566c617eb72a5976 = $108fe2be9334ff20$var$wrap($108fe2be9334ff20$export$f301627d437cff88);
module.exports["sanitizeUrl"] = $108fe2be9334ff20$export$300bd6d67c49dbfc;
module.exports["EmFn"] = $108fe2be9334ff20$export$fec26b2d751c6d95;
module.exports["StrikeFn"] = $108fe2be9334ff20$export$e9e7c187aef6a83a;
module.exports["StringFn"] = $108fe2be9334ff20$export$11a9c970dcafffc0;
module.exports["StrongFn"] = $108fe2be9334ff20$export$566c617eb72a5976;

});

parcelRegister("fTOZ6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0904818465c76069$export$1e9ea4edb6d1bfe6 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({});
module.exports["RendererContext"] = $0904818465c76069$export$1e9ea4edb6d1bfe6;

});

parcelRegister("jvEso", function(module, exports) {
$parcel$export(module.exports, "default", () => $2dcffbb0e829713b$export$2e2bcd8739ae039);
// Displays a warning message only once per message to avoid spamming the console with the same message multiple times.
const $2dcffbb0e829713b$var$messages = new Set();
function $2dcffbb0e829713b$export$2e2bcd8739ae039(message) {
    if ($2dcffbb0e829713b$var$messages.has(message)) return;
    $2dcffbb0e829713b$var$messages.add(message);
    if (typeof window !== 'undefined') // eslint-disable-next-line no-console
    console.warn(message);
}

});

parcelRegister("jKlwt", function(module, exports) {
/* CustomUIRenderer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $fMV63 = parcelRequire("fMV63");


var $7aRdF = parcelRequire("7aRdF");


var $aRGok = parcelRequire("aRGok");


var $9ivsj = parcelRequire("9ivsj");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $bLswh = parcelRequire("bLswh");


var $f3Db5 = parcelRequire("f3Db5");





var $cJ0FD = parcelRequire("cJ0FD");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $6Ec6w = parcelRequire("6Ec6w");


var $1l0kj = parcelRequire("1l0kj");




const $c11aa90375a1251c$export$8350d65d9a3785ef = ({ isBridgeModal: isBridgeModal, isMacroExtension: isMacroExtension, modalSize: modalSize, title: title, icon: icon, extension: extension, modalExtension: modalExtension, onClose: onClose, closeModalExtension: closeModalExtension, executeViewOnCloseCallback: executeViewOnCloseCallback })=>{
    /* Title/icon source priority:
   * - Bridge modals:
   *     - Use title/icon props (passed in from bridge call)
   *     - Fallback to extension.properties.title for fullscreen modals with empty title
   *     - For non-fullscreen modals, we won't render the header if the title prop is not provided
   * - Modal extension points: Use modalExtension.title and extensionIcon, defaults to extension name if not provided
   */ const modalTitle = isBridgeModal ? modalSize === 'fullscreen' && !title ? extension.properties.title : title : modalExtension?.title || extension.properties.title;
    /**
   * Icon rendering logic:
   * - Bridge modals: show icon section only if icon prop is provided
   * - Macro extension points: always show icon section (uses extension icon or AddonIcon fallback)
   * - Other modals: no icon section
   */ const shouldShowIcon = isBridgeModal ? !!icon : isMacroExtension;
    const modalIcon = isBridgeModal ? icon : (0, $f3Db5.getExtensionIcon)(extension);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, shouldShowIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, modalIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: modalIcon,
        alt: "",
        width: "24px",
        height: "24px"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
        label: "",
        color: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, modalTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, modalTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: "Close Modal",
        onClick: isBridgeModal ? onClose : async ()=>{
            try {
                await executeViewOnCloseCallback();
            } finally{
                closeModalExtension?.();
            }
        }
    }));
};



var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $5WvJi = parcelRequire("5WvJi");


const $e74a04044e98fb21$export$7844aa44752a3a21 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { closeProps: closeProps, modalContent: modalContent, headerProps: headerProps } = t0;
    let t1;
    if ($[0] !== headerProps) {
        t1 = headerProps.isMacroExtension || headerProps.isBridgeModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c11aa90375a1251c$export$8350d65d9a3785ef), headerProps) : null;
        $[0] = headerProps;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== closeProps || $[3] !== modalContent || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5WvJi.FullScreenModalDialog), {
            ...closeProps,
            testId: "custom-ui-fullscreen-modal-dialog"
        }, t1, modalContent);
        $[2] = closeProps;
        $[3] = modalContent;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ closeProps: closeProps, modalContent: modalContent, headerProps: headerProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5WvJi.FullScreenModalDialog), {
        ...closeProps,
        testId: "custom-ui-fullscreen-modal-dialog"
    }, headerProps.isMacroExtension || headerProps.isBridgeModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c11aa90375a1251c$export$8350d65d9a3785ef), headerProps) : null, modalContent);
};



var $9oYqV = parcelRequire("9oYqV");


var $6FQr4 = parcelRequire("6FQr4");


var $1gaKI = parcelRequire("1gaKI");


var $l07HN = parcelRequire("l07HN");











var $5ELQr = parcelRequire("5ELQr");


var $kvlRh = parcelRequire("kvlRh");

const $7d47bd4d241b2224$export$95197f008126b1a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(19);
    const { accountId: accountId, bridge: bridge, components: components, coreData: coreData, extension: extension, forgeDoc: forgeDoc, loadingComponent: loadingComponent, mentionProvider: mentionProvider, modalExtension: modalExtension, onAppError: onAppError, onError: onError, onSuccess: onSuccess, product: product } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    let t0;
    if ($[0] !== accountId || $[1] !== bridge || $[2] !== cloudId || $[3] !== components || $[4] !== mentionProvider || $[5] !== product || $[6] !== workspaceId) {
        t0 = {
            accountId: accountId,
            bridge: bridge,
            cloudId: cloudId,
            workspaceId: workspaceId,
            mentionProvider: mentionProvider,
            product: product,
            components: components
        };
        $[0] = accountId;
        $[1] = bridge;
        $[2] = cloudId;
        $[3] = components;
        $[4] = mentionProvider;
        $[5] = product;
        $[6] = workspaceId;
        $[7] = t0;
    } else t0 = $[7];
    const getComponents = (0, $kvlRh.useUIKitComponents)(t0);
    let t1;
    if ($[8] !== onAppError || $[9] !== onError) {
        t1 = (err)=>{
            onError?.(err.message);
            onAppError?.(err.message);
        };
        $[8] = onAppError;
        $[9] = onError;
        $[10] = t1;
    } else t1 = $[10];
    const handleError = t1;
    if (!forgeDoc) return null;
    let t2;
    if ($[11] !== extension || $[12] !== forgeDoc || $[13] !== getComponents || $[14] !== handleError || $[15] !== loadingComponent || $[16] !== modalExtension || $[17] !== onSuccess) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ELQr.default), {
            forgeDoc: forgeDoc,
            extension: extension,
            components: getComponents,
            modalExtension: modalExtension,
            extensionType: "xen:macro",
            loading: true,
            loadingComponent: loadingComponent,
            onError: handleError,
            onSuccess: onSuccess
        });
        $[11] = extension;
        $[12] = forgeDoc;
        $[13] = getComponents;
        $[14] = handleError;
        $[15] = loadingComponent;
        $[16] = modalExtension;
        $[17] = onSuccess;
        $[18] = t2;
    } else t2 = $[18];
    return t2;
} : (props)=>{
    const { accountId: accountId, bridge: bridge, components: components, coreData: coreData, extension: extension, forgeDoc: forgeDoc, loadingComponent: loadingComponent, mentionProvider: mentionProvider, modalExtension: modalExtension, onAppError: onAppError, onError: onError, onSuccess: onSuccess, product: product } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const getComponents = (0, $kvlRh.useUIKitComponents)({
        accountId: accountId,
        bridge: bridge,
        cloudId: cloudId,
        workspaceId: workspaceId,
        mentionProvider: mentionProvider,
        product: product,
        components: components
    });
    const handleError = (0, $cozmU.useCallback)((err)=>{
        onError?.(err.message);
        onAppError?.(err.message);
    }, [
        onError,
        onAppError
    ]);
    if (!forgeDoc) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ELQr.default), {
        forgeDoc: forgeDoc,
        extension: extension,
        components: getComponents,
        modalExtension: modalExtension,
        extensionType: 'xen:macro',
        loading: true,
        loadingComponent: loadingComponent,
        onError: handleError,
        onSuccess: onSuccess
    });
};



var $lAA41 = parcelRequire("lAA41");


var $9ytZz = parcelRequire("9ytZz");


var $4AVLc = parcelRequire("4AVLc");


var $iyAN0 = parcelRequire("iyAN0");

const $43491d82f0daf39a$var$styles = {
    modalDeprecationMessage: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
};
const $43491d82f0daf39a$export$17d9f1e4832027c9 = ({ accountId: accountId, bridge: bridge, contextIds: contextIds, contextChangeListeners: contextChangeListeners, coreData: coreData, customBridgeMethods: customBridgeMethods, customBridge: customBridge, customBridgeContext: customBridgeContext, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, getThreeLOPrompt: getThreeLOPrompt, height: height, width: width, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, iframeRef: iframeRef, isInModal: isInModal, loadingComponent: loadingComponent, locale: locale, localId: localId, modalStyles: modalStyles, modalProvider: modalProvider, onIframeLoad: onIframeLoad, onModalCustomUIRendererClose: onModalCustomUIRendererClose, product: product, timezone: timezone, getModalWidth: getModalWidth, setIsLoading: setIsLoading, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId })=>{
    const [error, setError] = (0, $cozmU.useState)(null); // modalOptions is null when no modal is open is non null when opened
    // Uses InternalModalState to allow extension property from FAUS forwarding
    const [modalOptions, setModalOptions] = (0, $cozmU.useState)(null);
    const [viewOnClose, setViewOnClose] = (0, $cozmU.useState)();
    const [embeddedUIKitModalContext, setEmbeddedUIKitModalContext] = (0, $cozmU.useState)(null);
    const onCloseFromModalClass = modalOptions?.onClose;
    const embeddedMacroModalProps = modalOptions?.isEmbeddedMacroModal ? {
        extensionPayload: modalOptions?.extensionPayload,
        // Extension view data in macro module is only reserved for bodied macro content.
        // Since we don't support embedded bodied macros, extensionViewData will always be undefined.
        extensionViewData: undefined,
        coreData: {
            ...coreData,
            localId: modalOptions?.embeddedMacroLocalId || ''
        }
    } : {};
    const iframeProps = {
        accountId: accountId,
        contextIds: contextIds,
        contextChangeListeners: contextChangeListeners,
        components: getThreeLOPrompt,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        customBridge: customBridge,
        customBridgeContext: customBridgeContext,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        isHidden: isIframeHidden,
        isResizable: isIframeResizable,
        locale: locale,
        timezone: timezone,
        loadingComponent: loadingComponent,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedMacroParentType: embeddedMacroParentType,
        embeddedParentLocalId: embeddedParentLocalId,
        ...(0, $iDrrr.fg)('platform_faus_navigate_to_product') ? {} : embeddedMacroModalProps
    };
    const modalIframeProps = {
        ...iframeProps,
        ...embeddedMacroModalProps
    };
    const isBodiedMacro = extension.properties?.layout === 'bodied';
    const extensionInModal = (0, $cozmU.useMemo)(()=>{
        // Use the embedded macro's extension if provided (for modals opened from embedded macros)
        const baseExtension = modalOptions?.extension || extension; // `openModal`'s resource is optional; only override when one is explicitly provided. When it is
        // omitted the modal defaults to the current resource, so we inherit it (and its entry) untouched.
        let resourceOverride = {};
        if (modalOptions?.resource) resourceOverride = (0, $l07HN.resolveDynamicResource)(modalOptions.resource);
        return {
            ...baseExtension,
            // Pass a type that is not included in the dimensions presets so that it falls back to default
            type: `${baseExtension.type}::dynamic-modal`,
            properties: {
                ...baseExtension.properties,
                ...resourceOverride
            }
        };
    }, [
        extension,
        modalOptions?.resource,
        modalOptions?.extension
    ]);
    const onError = (error)=>{
        // Under bridge v2 the runtime overlay owns error display, so don't take over the
        // surface here — setting error would unmount the iframe and the overlay with it.
        if (error && !(0, $iDrrr.fg)('forge-ui-bridge-core-reset')) setError(error);
    };
    const extensionDataInModal = (0, $cozmU.useMemo)(()=>{
        // Use the embedded macro's extensionData if provided (for modals opened from embedded macros)
        const baseExtensionData = modalOptions?.extensionData || extensionData;
        return {
            ...baseExtensionData,
            ...modalOptions?.context ? {
                modal: modalOptions?.context
            } : {},
            // This is to handle an incompatibility issue with Compass and JSM where they are incorrectly currently spreading the context object on the top level instead of in the `modal` object.
            // Remove once Compass apps have been updated https://softwareteams.atlassian.net/browse/COMPASS-22051 and a notice to app developers have been sent out
            ...(product === 'compass' || extension.type.startsWith('jiraServiceManagement')) && modalOptions?.context ? {
                ...modalOptions?.context
            } : {}
        };
    }, [
        extension.type,
        extensionData,
        modalOptions?.context,
        modalOptions?.extensionData,
        product
    ]);
    const handleModalTearDown = (0, $cozmU.useCallback)(()=>{
        setModalOptions(null);
    }, [
        setModalOptions
    ]);
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    const handleModalClose = (0, $cozmU.useCallback)(()=>{
        onCloseFromModalClass?.(); // if reduced motion is enabled, we need to call handleModalTearDown here as it no longer calls `onCloseComplete` in `ModalCustomUIRenderer`
        if (isReducedMotion) handleModalTearDown();
    }, [
        isReducedMotion,
        onCloseFromModalClass,
        handleModalTearDown
    ]); // Confluence specific feature
    // Needed to show Forge modals in live pages. dialogs won't be passed in if the page isn't live.
    (0, $cozmU.useEffect)(()=>{
        if (product !== 'confluence') return;
        if (dialogs && modalOptions) dialogs.showDialog($43491d82f0daf39a$export$5d28a207fd7621f6, {
            extension: extensionInModal,
            extensionData: extensionDataInModal,
            localId: localId,
            onTearDown: handleModalTearDown,
            bridge: bridge,
            size: modalOptions.size,
            closeOnEscape: modalOptions.closeOnEscape,
            closeOnOverlayClick: modalOptions.closeOnOverlayClick
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        modalOptions,
        dialogs
    ]); // Only reachable without bridge-core-reset; under it `error` stays null and the runtime overlay
    // renders ForgeAppErrorMessage instead.
    // TODO: remove once forge-ui-bridge-core-reset is fully rolled out.
    if (error && (0, $iyAN0.shouldRenderForgeAppErrorMessage)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AVLc.ForgeAppErrorMessage), {
        extension: extension,
        error: error
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isBodiedMacro && embeddedUIKitModalContext?.forgeDoc && embeddedUIKitModalContext?.extension && (0, $iDrrr.fg)('platform_forge_ui_uikit_modal_in_custom_ui_parent') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d47bd4d241b2224$export$95197f008126b1a1), {
        accountId: accountId,
        bridge: bridge,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        forgeDoc: embeddedUIKitModalContext.forgeDoc,
        extension: embeddedUIKitModalContext.extension,
        getThreeLOPrompt: getThreeLOPrompt,
        loadingComponent: loadingComponent,
        product: product,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fMV63.Iframe), {
        ...iframeProps,
        entryPoint: entryPoint,
        isResizable: isIframeResizable,
        customBridge: {
            ...customBridge,
            ...isBodiedMacro && (0, $iDrrr.fg)('forge-ui-bridge-core-reset') ? {
                setEmbeddedMacroModalForgeDoc: (_ctx, payload)=>{
                    setEmbeddedUIKitModalContext(payload?.embeddedUIKitModalContext ?? null);
                }
            } : {}
        },
        bridge: {
            ...bridge,
            openModal: (opts)=>{
                setModalOptions(opts.data);
                return true;
            },
            ...onModalCustomUIRendererClose ? {
                close: (payload)=>{
                    onModalCustomUIRendererClose().then(()=>{
                        bridge?.close?.(payload);
                    }).finally(()=>{
                        return true;
                    });
                }
            } : {}
        },
        customBridgeMethods: {
            ...customBridgeMethods,
            ...isBodiedMacro && (0, $iDrrr.fg)('platform_forge_ui_uikit_modal_in_custom_ui_parent') ? {
                setEmbeddedMacroModalForgeDoc: (payload)=>{
                    setEmbeddedUIKitModalContext(payload?.embeddedUIKitModalContext);
                }
            } : {}
        },
        height: height,
        width: width,
        isInModal: isInModal,
        ref: iframeRef,
        onLoad: onIframeLoad,
        setIsLoading: setIsLoading,
        onError: onError
    }), modalOptions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($43491d82f0daf39a$export$5d28a207fd7621f6, {
        ...(0, $iDrrr.fg)('platform_faus_navigate_to_product') ? modalIframeProps : iframeProps,
        product: product,
        getThreeLOPrompt: getThreeLOPrompt,
        dialogs: dialogs,
        extension: extensionInModal,
        extensionData: extensionDataInModal,
        localId: modalOptions?.embeddedMacroLocalId || localId,
        onTearDown: handleModalTearDown,
        bridge: {
            ...bridge,
            onClose: (callback)=>{
                setViewOnClose(()=>callback.data); // stores the callback for when modal is closed
                return true;
            },
            close: (payload)=>{
                onCloseFromModalClass?.(payload.data);
                return true;
            }
        },
        modalOnClose: handleModalClose,
        size: modalOptions.size,
        title: modalOptions.title,
        icon: modalOptions.icon,
        closeOnEscape: modalOptions.closeOnEscape,
        closeOnOverlayClick: modalOptions.closeOnOverlayClick,
        modalStyles: modalStyles,
        modalProvider: modalProvider,
        getModalWidth: getModalWidth,
        isIframeResizable: isIframeResizable,
        viewOnClose: viewOnClose,
        customBridge: customBridge
    }) : null);
};
const $43491d82f0daf39a$export$5d28a207fd7621f6 = ({ accountId: accountId, bridge: bridge, coreData: coreData, closeOnEscape: closeOnEscape, closeOnOverlayClick: closeOnOverlayClick, consentMessage: consentMessage, contextChangeListeners: contextChangeListeners, contextIds: contextIds, customBridgeMethods: customBridgeMethods, customBridge: customBridge, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, getThreeLOPrompt: getThreeLOPrompt, isIframeHidden: isIframeHidden = false, isIframeResizable: isIframeResizable = false, loadingComponent: loadingComponent, locale: locale, localId: localId, mentionProvider: mentionProvider, modalExtension: modalExtension, modalStyles: modalStyles, modalProvider: ModalProvider, onConsentModalClose: onConsentModalClose, onConsentSuccess: onConsentSuccess, onError: onError, onForgeDocUpdated: onForgeDocUpdated, onIframeLoad: onIframeLoad, onTearDown: onTearDown, product: product, size: size, title: title, icon: icon, timezone: timezone, getModalWidth: getModalWidth, modalOnClose: // onClose from `Modal`
modalOnClose, viewOnClose: // onClose from `view`
viewOnClose })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(true); // This is for preventing inline dialog apps from being closed by an esc key press when a
    // modal is open until https://product-fabric.atlassian.net/browse/DSP-3552 is resolved.
    (0, $cozmU.useEffect)(()=>{
        if (product !== 'confluence' || modalExtension?.type === 'macroConfig' || product === 'confluence' && modalExtension?.type === 'bylineItem') return;
        function dismissEscape(e) {
            if (e.key === 'Escape') {
                e.stopPropagation();
                if (closeOnEscape) {
                    modalOnClose?.();
                    setIsOpen(false);
                }
            }
        }
        if (isOpen) document.addEventListener('keydown', dismissEscape, {
            capture: true
        });
        return ()=>document.removeEventListener('keydown', dismissEscape, {
                capture: true
            });
    }, [
        isOpen,
        closeOnEscape,
        product,
        modalOnClose,
        modalExtension?.type
    ]);
    const { trackExtensionLoaded: trackExtensionLoaded, trackBridgeSucceed: trackBridgeSucceed, trackBridgeFailed: trackBridgeFailed } = (0, $6FQr4.useForgeUiAnalyticsEvent)();
    const extensionType = (0, $1gaKI.getExtensionType)(extension?.properties);
    const environmentType = extension?.environmentType;
    const isMacroExtension = extension?.type === (0, $bLswh.ConfluenceExtension).MACRO; // Only tracking fullscreen modals
    (0, $cozmU.useEffect)(()=>{
        if (modalExtension?.modalWidth === 'fullscreen') trackExtensionLoaded({
            forgeEnvironment: environmentType,
            renderType: 'CustomUI',
            extensionType: extensionType,
            viewportSize: 'fullscreen'
        });
    }, [
        modalExtension?.modalWidth,
        environmentType,
        extensionType,
        trackExtensionLoaded
    ]);
    const modalWidthForMacroCustomConfig = extension.type === (0, $bLswh.ConfluenceExtension).MACRO && modalExtension?.modalWidth !== undefined && (0, $9ytZz.isNamedSize)(modalExtension.modalWidth) ? modalExtension.modalWidth : undefined;
    const sizeString = typeof size === 'object' ? undefined : size;
    const modalSize = modalWidthForMacroCustomConfig ?? sizeString ?? // safeguards old logic against custom sizes
    extension.properties.viewportSize ?? 'medium'; // If size is defined, iframe modal should not be resizable.
    // In JSM ONLY, iframe modal should ALWAYS be resizable.
    // Iframe should scale to 100% of the modal so that Select drop downs are not cut off
    // If developer is using Modal() from bridge and they pick 'resizable' size, the modal will always be resizable.
    const isJsmModule = extension.type.startsWith('jiraServiceManagement');
    const isResizableSize = modalSize === 'resizable';
    const isModalResizable = isResizableSize || isJsmModule || (size !== undefined ? false : isIframeResizable);
    const shouldShowFCFModalDeprecationMessage = (extension.type === (0, $bLswh.JiraExtension).CUSTOM_FIELD || extension.type === (0, $bLswh.JiraExtension).CUSTOM_FIELD_TYPE) && !(0, $iDrrr.fg)('forge_disable_fcf_modal_experience_on_issue_view');
    const executeViewOnCloseCallback = async ()=>{
        if (viewOnClose) try {
            await viewOnClose();
            trackBridgeSucceed({
                method: 'onClose',
                forgeEnvironment: extension.environmentType
            });
        } catch (error) {
            trackBridgeFailed({
                method: 'onClose',
                errorName: error instanceof Error ? error.name : 'UnknownError',
                forgeEnvironment: extension.environmentType
            });
        }
    };
    const renderModal = ()=>{
        const closeProps = {
            onClose: async ()=>{
                try {
                    await executeViewOnCloseCallback();
                } finally{
                    modalOnClose?.();
                    setIsOpen(false);
                }
            },
            onCloseComplete: onTearDown,
            shouldCloseOnEscapePress: closeOnEscape
        }; // Moved up from below as needed for ModalContentWrapper
        const isBridgeModal = !modalExtension;
        const supportsFullscreenModal = modalSize === 'fullscreen' && (isBridgeModal || (0, $lAA41.FULLSCREEN_SUPPORTED_EXTENSION_TYPES).has(extension.type));
        const resolvedDimensions = (0, $f3Db5.resolveModalDimensions)({
            size: modalExtension?.modalWidth ?? size ?? extension.properties.viewportSize,
            getModalWidth: getModalWidth,
            shouldFallbackFromFullscreen: modalSize === 'fullscreen' && !supportsFullscreenModal,
            isResizableSize: isResizableSize
        });
        const modalContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldShowFCFModalDeprecationMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $43491d82f0daf39a$var$styles.modalDeprecationMessage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9oYqV.ForgeModalDeprecationMessage), {
            extension: extension
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f3Db5.ModalContentWrapper), {
            size: resolvedDimensions.contentSize,
            styles: modalStyles,
            isResizable: isModalResizable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($43491d82f0daf39a$export$17d9f1e4832027c9, {
            product: product,
            coreData: coreData,
            getThreeLOPrompt: getThreeLOPrompt,
            dialogs: dialogs,
            accountId: accountId,
            contextChangeListeners: contextChangeListeners,
            contextIds: contextIds,
            extension: extension,
            extensionData: extensionData,
            extensionViewData: extensionViewData,
            bridge: bridge,
            customBridgeMethods: customBridgeMethods,
            customBridge: customBridge,
            consentMessage: consentMessage,
            entryPoint: entryPoint,
            getContextToken: getContextToken,
            height: "100%",
            isIframeHidden: isIframeHidden,
            isIframeResizable: isModalResizable,
            locale: locale,
            localId: localId,
            mentionProvider: mentionProvider,
            modalExtension: modalExtension,
            onConsentSuccess: onConsentSuccess,
            onForgeDocUpdated: onForgeDocUpdated,
            timezone: timezone,
            onConsentModalClose: onConsentModalClose,
            onError: onError,
            onIframeLoad: onIframeLoad,
            loadingComponent: loadingComponent,
            extensionPayload: extensionPayload,
            modalStyles: modalStyles,
            onModalCustomUIRendererClose: async ()=>{
                try {
                    await executeViewOnCloseCallback();
                } finally{
                    setIsOpen(false); // If is a modal extension point, call modalOnClose to reset state from product
                    // This is required to reset the state of the modal in the product when view.close is called
                    if (modalExtension) modalOnClose?.();
                }
            },
            isInModal: true
        }))); // Shared header props for the extracted ModalCustomUIRendererHeader component
        const headerProps = {
            isBridgeModal: isBridgeModal,
            isMacroExtension: isMacroExtension,
            modalSize: resolvedDimensions.contentSize,
            title: title,
            icon: icon,
            extension: extension,
            modalExtension: modalExtension,
            onClose: closeProps.onClose,
            closeModalExtension: modalExtension?.closeModalExtension,
            executeViewOnCloseCallback: executeViewOnCloseCallback
        };
        if (supportsFullscreenModal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e74a04044e98fb21$export$7844aa44752a3a21), {
            closeProps: closeProps,
            isMacroExtension: isMacroExtension,
            isBridgeModal: isBridgeModal,
            modalContent: modalContent,
            headerProps: headerProps
        });
        else {
            // Fallback to 'max' if modalSize is 'fullscreen' but fullscreen is not supported
            const shouldFallbackFromFullscreen = modalSize === 'fullscreen' && !supportsFullscreenModal;
            const resolvedWidth = resolvedDimensions.width;
            const resolvedHeight = resolvedDimensions.height;
            if (shouldFallbackFromFullscreen) // eslint-disable-next-line no-console
            console.warn('Forge fullscreen modal is only supported in the forge/bridge modal and specific extension points. Refer to https://developer.atlassian.com/platform/forge/manifest-reference/modules/ for more guidance. The modal will be rendered with max width instead.');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
                ...closeProps,
                width: resolvedWidth,
                height: resolvedHeight,
                testId: "custom-ui-modal-dialog",
                shouldCloseOnOverlayClick: closeOnOverlayClick,
                shouldCloseOnEscapePress: closeOnEscape,
                shouldScrollInViewport: isResizableSize
            }, isBridgeModal && title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c11aa90375a1251c$export$8350d65d9a3785ef), headerProps) : null, modalContent);
        }
    };
    if (ModalProvider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ModalProvider, null, renderModal()));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && renderModal());
};
module.exports["CustomUIRenderer"] = $43491d82f0daf39a$export$17d9f1e4832027c9;
module.exports["ModalCustomUIRenderer"] = $43491d82f0daf39a$export$5d28a207fd7621f6;

});

parcelRegister("6FQr4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $852mP = parcelRequire("852mP");


var $9DHhW = parcelRequire("9DHhW");


var $DIyeF = parcelRequire("DIyeF");


var $4K6lC = parcelRequire("4K6lC");


var $5xQdV = parcelRequire("5xQdV");


var $jAJ6s = parcelRequire("jAJ6s");


var $5Wwa0 = parcelRequire("5Wwa0");

const $dbbeb25eee57ac80$export$43835e9acf248a15 = (createAnalyticsEvent, { action: action, actionSubject: actionSubject, source: source, attributes: attributes }, options)=>{
    const { sampleRate: sampleRate, filter: filter } = options ?? {};
    // If a sample rate is provided, we can use it to determine whether to fire the event
    if (sampleRate) {
        const randomValue = Math.random();
        if (randomValue > sampleRate) return; // Don't fire the event
    }
    const event = createAnalyticsEvent({
        eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
        data: {
            action: action,
            actionSubject: actionSubject,
            attributes: attributes,
            source: source,
            tags: [
                'forge'
            ]
        }
    });
    // Don't fire the event if there's a filter and event does not pass it
    if (filter && !filter(event)) return;
    event.fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
};
const $dbbeb25eee57ac80$export$7eca133280843f9e = (createAnalyticsEvent, { action: action, actionSubject: actionSubject, attributes: attributes })=>{
    createAnalyticsEvent({
        eventType: (0, $852mP.UI_EVENT_TYPE),
        data: {
            action: action,
            actionSubject: actionSubject,
            attributes: attributes
        }
    }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
};
// We limit the type of bridge methods we track to only the ones we are analysing in databricks to avoid sending too many events
const $dbbeb25eee57ac80$var$allowedBridgeMethods = {
    navigate: {
        allowed: true,
        options: {
            sampleRate: 0.1
        }
    },
    openRovo: {
        allowed: true
    },
    isRovoEnabled: {
        allowed: true
    },
    // PIR-30455: The following three methods (openModal, close, onClose) are temporarily tracked as we have a high frequency of changes to the modal extension points
    // TODO cleanup: https://ecosystem-platform.atlassian.net/browse/EXT-4533
    openModal: {
        allowed: true
    },
    close: {
        allowed: true
    },
    onClose: {
        allowed: true
    }
};
const $dbbeb25eee57ac80$export$f4ca3aaa7a36404 = (createAnalyticsEvent, { source: source, method: method, additionalAttributes: additionalAttributes, forgeEnvironment: forgeEnvironment })=>{
    if ($dbbeb25eee57ac80$var$allowedBridgeMethods[method]?.allowed) $dbbeb25eee57ac80$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'succeeded',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    }, $dbbeb25eee57ac80$var$allowedBridgeMethods[method]?.options);
};
const $dbbeb25eee57ac80$var$trackForgeFeatureFlagEvent = (createAnalyticsEvent, { source: source, appType: appType, baseUrl: baseUrl, appId: appId, flagName: flagName, eventType: eventType, success: success, featureFlagEnv: featureFlagEnv, forgeEnvironment: forgeEnvironment })=>{
    $dbbeb25eee57ac80$export$43835e9acf248a15(createAnalyticsEvent, {
        action: eventType,
        actionSubject: 'forge.ui.feature_flag',
        source: source,
        attributes: {
            appType: appType,
            baseUrl: baseUrl,
            appId: appId,
            flagName: flagName,
            eventType: eventType,
            success: success,
            featureFlagEnv: featureFlagEnv,
            forgeEnvironment: forgeEnvironment
        }
    });
};
const $dbbeb25eee57ac80$var$trackObjectStoreAction = (createAnalyticsEvent, { source: source, appType: appType, appId: appId, action: action, forgeEnvironment: forgeEnvironment })=>{
    $dbbeb25eee57ac80$export$43835e9acf248a15(createAnalyticsEvent, {
        action: action,
        actionSubject: 'forge.ui.object_store',
        source: source,
        attributes: {
            appType: appType,
            appId: appId,
            forgeEnvironment: forgeEnvironment
        }
    });
};
const $dbbeb25eee57ac80$var$trackPermissionAction = (createAnalyticsEvent, { source: source, appId: appId, installationId: installationId, action: action })=>{
    $dbbeb25eee57ac80$export$43835e9acf248a15(createAnalyticsEvent, {
        action: action,
        actionSubject: 'forge.ui.permission',
        source: source,
        attributes: {
            appId: appId,
            installationId: installationId
        }
    });
};
const $dbbeb25eee57ac80$export$5c425ded9b0e7602 = (createAnalyticsEvent, { source: source, errorName: errorName, method: method, forgeEnvironment: forgeEnvironment, additionalAttributes: additionalAttributes })=>$dbbeb25eee57ac80$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'failed',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            error: errorName,
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    });
const $dbbeb25eee57ac80$export$d84d2f0ce1c82c0 = (createAnalyticsEvent, { source: source, forgeEnvironment: forgeEnvironment, components: components, forgeReactMajorVersion: forgeReactMajorVersion })=>$dbbeb25eee57ac80$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'rendered',
        actionSubject: 'forge.ui.analytics.component_usage',
        source: source,
        attributes: {
            forgeEnvironment: forgeEnvironment,
            components: components,
            forgeReactMajorVersion: forgeReactMajorVersion
        }
    });
const $dbbeb25eee57ac80$export$7e97f0f47f75f097 = (createAnalyticsEvent, { source: source, target: target })=>$dbbeb25eee57ac80$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'rendered',
        actionSubject: 'forge.ui.renderer',
        source: source,
        attributes: {
            target: target
        }
    });
const $dbbeb25eee57ac80$var$trackExtensionLoaded = (createAnalyticsEvent, { source: source, forgeEnvironment: forgeEnvironment, renderType: renderType, extensionType: extensionType, isConfiguring: isConfiguring, isInserting: isInserting, viewportSize: viewportSize })=>{
    const options = {
        filter: (0, $jAJ6s.extensionLoadedEventFilter)
    };
    $dbbeb25eee57ac80$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'loaded',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            forgeEnvironment: forgeEnvironment,
            renderType: renderType,
            extensionType: extensionType,
            isConfiguring: isConfiguring,
            isInserting: isInserting,
            viewportSize: viewportSize
        }
    }, options);
};
const $dbbeb25eee57ac80$var$trackExtensionRemounted = (createAnalyticsEvent, { source: source, mountCount: mountCount, isUseBridgeReinit: isUseBridgeReinit })=>$dbbeb25eee57ac80$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'remounted',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            mountCount: mountCount,
            isUseBridgeReinit: isUseBridgeReinit
        }
    });
const $dbbeb25eee57ac80$var$trackHandShakeMetric = (createAnalyticsEvent, { source: source, success: success, error: error })=>{
    if (error) $dbbeb25eee57ac80$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'failed',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            target: 'handshake',
            success: success,
            reason: error instanceof Error ? error.message : 'Unknown error',
            isUnrecoverable: (0, $5Wwa0.isUnrecoverableError)(error)
        }
    });
    else // Sample 10% of the events to reduce the costs
    // We only need 10% of the good events for the same SLO target
    $dbbeb25eee57ac80$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'succeeded',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            target: 'handshake',
            success: success
        }
    }, {
        sampleRate: 0.1
    });
};
const $dbbeb25eee57ac80$export$b6445106a2f749a7 = (createAnalyticsEvent, { source: source, extensionId: extensionId, reason: reason })=>$dbbeb25eee57ac80$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'rejected',
        actionSubject: 'forge.ui.embedded_macro',
        source: source,
        attributes: {
            extensionId: extensionId,
            extensionType: 'xen:macro',
            reason: reason
        }
    });
const $dbbeb25eee57ac80$export$f3c52ade35e032f7 = (createAnalyticsEvent, { source: source, extensionKey: extensionKey })=>$dbbeb25eee57ac80$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'rendered',
        actionSubject: 'forge.ui.bodied_macro_embedded_content',
        source: source,
        attributes: {
            extensionKey: extensionKey,
            extensionType: 'xen:macro'
        }
    });
const $dbbeb25eee57ac80$var$createForgeUiAnalyticsEventTrackers = ({ createAnalyticsEvent: createAnalyticsEvent, source: source })=>{
    return {
        trackHandShakeMetric: ({ source: source, success: success, error: error })=>$dbbeb25eee57ac80$var$trackHandShakeMetric(createAnalyticsEvent, {
                source: source,
                success: success,
                error: error
            }),
        trackComponentUsageRendered: ({ forgeEnvironment: forgeEnvironment, components: components, forgeReactMajorVersion: forgeReactMajorVersion })=>$dbbeb25eee57ac80$export$d84d2f0ce1c82c0(createAnalyticsEvent, {
                source: source,
                forgeEnvironment: forgeEnvironment,
                components: components,
                forgeReactMajorVersion: forgeReactMajorVersion
            }),
        trackRendererRendered: ({ target: target })=>$dbbeb25eee57ac80$export$7e97f0f47f75f097(createAnalyticsEvent, {
                source: source,
                target: target
            }),
        trackExtensionLoaded: ({ forgeEnvironment: forgeEnvironment, renderType: renderType, extensionType: extensionType, isConfiguring: isConfiguring, isInserting: isInserting, viewportSize: viewportSize })=>$dbbeb25eee57ac80$var$trackExtensionLoaded(createAnalyticsEvent, {
                source: source,
                forgeEnvironment: forgeEnvironment,
                renderType: renderType,
                extensionType: extensionType,
                isConfiguring: isConfiguring,
                isInserting: isInserting,
                viewportSize: viewportSize
            }),
        trackExtensionRemounted: ({ mountCount: mountCount })=>$dbbeb25eee57ac80$var$trackExtensionRemounted(createAnalyticsEvent, {
                source: source,
                mountCount: mountCount
            }),
        trackBridgeSucceed: ({ method: method, forgeEnvironment: forgeEnvironment, additionalAttributes: additionalAttributes })=>$dbbeb25eee57ac80$export$f4ca3aaa7a36404(createAnalyticsEvent, {
                source: source,
                method: method,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: additionalAttributes
            }),
        trackBridgeFailed: ({ method: method, errorName: errorName, forgeEnvironment: forgeEnvironment, additionalAttributes: additionalAttributes })=>$dbbeb25eee57ac80$export$5c425ded9b0e7602(createAnalyticsEvent, {
                source: source,
                errorName: errorName,
                method: method,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: additionalAttributes
            }),
        trackForgeFeatureFlagEvent: ({ appType: appType, baseUrl: baseUrl, appId: appId, flagName: flagName, eventType: eventType, success: success, featureFlagEnv: featureFlagEnv, forgeEnvironment: forgeEnvironment })=>$dbbeb25eee57ac80$var$trackForgeFeatureFlagEvent(createAnalyticsEvent, {
                source: source,
                appType: appType,
                baseUrl: baseUrl,
                appId: appId,
                flagName: flagName,
                eventType: eventType,
                success: success,
                featureFlagEnv: featureFlagEnv,
                forgeEnvironment: forgeEnvironment
            }),
        trackObjectStoreAction: ({ appType: appType, appId: appId, action: action, forgeEnvironment: forgeEnvironment })=>$dbbeb25eee57ac80$var$trackObjectStoreAction(createAnalyticsEvent, {
                source: source,
                appType: appType,
                appId: appId,
                action: action,
                forgeEnvironment: forgeEnvironment
            }),
        trackPermissionAction: ({ appId: appId, installationId: installationId, action: action })=>$dbbeb25eee57ac80$var$trackPermissionAction(createAnalyticsEvent, {
                source: source,
                appId: appId,
                installationId: installationId,
                action: action
            })
    };
};
const $dbbeb25eee57ac80$export$4b165c4db6e19dc5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: source } = (0, $DIyeF.useMetricsContext)();
    let t0;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== source) {
        t0 = ()=>$dbbeb25eee57ac80$var$createForgeUiAnalyticsEventTrackers({
                createAnalyticsEvent: createAnalyticsEvent,
                source: source
            });
        t1 = [
            createAnalyticsEvent,
            source
        ];
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    const cachedTrackers = (0, $5xQdV.useMemoOne)(t0, t1);
    return cachedTrackers;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: source } = (0, $DIyeF.useMetricsContext)();
    const cachedTrackers = (0, $5xQdV.useMemoOne)(()=>$dbbeb25eee57ac80$var$createForgeUiAnalyticsEventTrackers({
            createAnalyticsEvent: createAnalyticsEvent,
            source: source
        }), [
        createAnalyticsEvent,
        source
    ]);
    return cachedTrackers;
};
module.exports["fireEvent"] = $dbbeb25eee57ac80$export$43835e9acf248a15;
module.exports["fireUIEvent"] = $dbbeb25eee57ac80$export$7eca133280843f9e;
module.exports["trackBridgeSucceed"] = $dbbeb25eee57ac80$export$f4ca3aaa7a36404;
module.exports["trackBridgeFailed"] = $dbbeb25eee57ac80$export$5c425ded9b0e7602;
module.exports["trackComponentUsageRendered"] = $dbbeb25eee57ac80$export$d84d2f0ce1c82c0;
module.exports["trackRendererRendered"] = $dbbeb25eee57ac80$export$7e97f0f47f75f097;
module.exports["trackEmbeddedMacroRejected"] = $dbbeb25eee57ac80$export$b6445106a2f749a7;
module.exports["trackBodiedMacroEmbeddedContent"] = $dbbeb25eee57ac80$export$f3c52ade35e032f7;
module.exports["useForgeUiAnalyticsEvent"] = $dbbeb25eee57ac80$export$4b165c4db6e19dc5;

});

parcelRegister("lBErP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<aab4c21b77461656be8e7f55fdded6ff>>
 * @relayHash 88ed8af64ac7185a0999b8c6bf0f12bf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 17357ad13472c97d7073c2a1eb4b600d98011b17893ba0a316e9e5de283bfc82
const $0f0cb4edaab7195a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "InvocationResponsePayload",
        "kind": "LinkedField",
        "name": "response",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "body"
            }
        ]
    }, v4 = {
        "concreteType": "ForgeContextToken",
        "kind": "LinkedField",
        "name": "contextToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jwt"
            },
            {
                "kind": "ScalarField",
                "name": "expiresAt"
            }
        ]
    }, v5 = {
        "concreteType": "RateLimitProperties",
        "kind": "LinkedField",
        "name": "rateLimitProperties",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "rateLimitRemaining"
            },
            {
                "kind": "ScalarField",
                "name": "rateLimitReset"
            },
            {
                "kind": "ScalarField",
                "name": "rateLimitValue"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InvokeExtensionPayloadErrorExtensionFields",
                "kind": "LinkedField",
                "name": "fields",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "authInfoUrl"
                    }
                ]
            }
        ],
        "type": "InvokeExtensionPayloadErrorExtension"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useInvokeExtensionRelayMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "InvokeExtensionResponse",
                    "kind": "LinkedField",
                    "name": "invokeExtension",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useInvokeExtensionRelayMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "InvokeExtensionResponse",
                    "kind": "LinkedField",
                    "name": "invokeExtension",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "17357ad13472c97d7073c2a1eb4b600d98011b17893ba0a316e9e5de283bfc82",
            "metadata": {},
            "name": "useInvokeExtensionRelayMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0f0cb4edaab7195a$var$node.hash = "7da04c6e6467fec1087d3d61ffac8358";
var $0f0cb4edaab7195a$export$2e2bcd8739ae039 = $0f0cb4edaab7195a$var$node;



var $5xQdV = parcelRequire("5xQdV");


var $iLX84 = parcelRequire("iLX84");


var $6SsN4 = parcelRequire("6SsN4");


var $iGKcz = parcelRequire("iGKcz");

const $a43d808670168fdc$export$46af696e5313090f = (0, $iLX84.default)`mutation forge_ui_invokeExtension($input:InvokeExtensionInput!){invokeExtension(input:$input){success response{body}contextToken{jwt expiresAt}rateLimitProperties{rateLimitRemaining rateLimitReset rateLimitValue}errors{message extensions{errorType statusCode ...on InvokeExtensionPayloadErrorExtension{fields{authInfoUrl}}}}}}`;
const $a43d808670168fdc$export$19d283d2f5a7d3c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (contextIds, extensionId)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    let t1;
    if ($[0] !== contextIds) {
        t0 = (environment, config)=>(0, $6SsN4.commitMutation)(environment, {
                ...config,
                cacheConfig: {
                    metadata: {
                        headers: {
                            "atl-attribution": (0, $iGKcz.createAtlAttributionHeader)(contextIds.sort().join())
                        }
                    }
                }
            });
        t1 = [
            contextIds
        ];
        $[0] = contextIds;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    const customCommitFn = (0, $5xQdV.useCallbackOne)(t0, t1);
    const [commit] = (0, $6SsN4.useMutation)((0, $0f0cb4edaab7195a$export$2e2bcd8739ae039), customCommitFn);
    let t2;
    let t3;
    if ($[3] !== commit || $[4] !== contextIds || $[5] !== extensionId) {
        t2 = (payload, t4)=>{
            const entryPoint = t4 === undefined ? "resolver" : t4;
            return new Promise((resolve, reject)=>{
                commit({
                    variables: {
                        input: {
                            contextIds: contextIds,
                            extensionId: extensionId,
                            payload: payload,
                            entryPoint: entryPoint
                        }
                    },
                    onCompleted: (data, errors)=>{
                        if (Array.isArray(errors) && errors.length > 0) resolve({
                            data: {
                                invokeExtension: {
                                    errors: errors,
                                    success: false,
                                    response: null,
                                    contextToken: null
                                }
                            }
                        });
                        resolve({
                            data: data
                        });
                    },
                    onError: reject
                });
            });
        };
        t3 = [
            contextIds,
            extensionId,
            commit
        ];
        $[3] = commit;
        $[4] = contextIds;
        $[5] = extensionId;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    return (0, $5xQdV.useCallbackOne)(t2, t3);
} : (contextIds, extensionId)=>{
    const customCommitFn = (0, $5xQdV.useCallbackOne)((environment, config)=>(0, $6SsN4.commitMutation)(environment, {
            ...config,
            cacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(contextIds.sort().join())
                    }
                }
            }
        }), [
        contextIds
    ]);
    const [commit] = (0, $6SsN4.useMutation)((0, $0f0cb4edaab7195a$export$2e2bcd8739ae039), customCommitFn);
    return (0, $5xQdV.useCallbackOne)((payload, entryPoint = 'resolver')=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        contextIds: contextIds,
                        extensionId: extensionId,
                        payload: payload,
                        entryPoint: entryPoint
                    }
                },
                onCompleted: (data, errors)=>{
                    if (Array.isArray(errors) && errors.length > 0) // We pass the error to `resolve` here so it can goes through the error handling logic found in packages/forge/forge-ui/src/custom-ui/iframe/InnerIframe.tsx - onInvoke
                    resolve({
                        data: {
                            invokeExtension: {
                                errors: errors,
                                success: false,
                                response: null,
                                contextToken: null
                            }
                        }
                    });
                    resolve({
                        data: data
                    });
                },
                onError: reject
            });
        }), [
        contextIds,
        extensionId,
        commit
    ]);
};
module.exports["useInvokeExtension"] = $a43d808670168fdc$export$19d283d2f5a7d3c;

});

parcelRegister("8e5a1", function(module, exports) {
/*
 * File: iframeResizer.contentWindow.js
 * Desc: Include this file in any page being loaded into an iframe
 *       to force the iframe to resize to the content size.
 * Requires: iframeResizer.js on host page.
 * Doc: https://iframe-resizer.com
 * Author: David J. Bradshaw - info@iframe-resizer.com
 *
 */ // eslint-disable-next-line sonarjs/cognitive-complexity, no-shadow-restricted-names
(function(undefined) {
    if (typeof window === 'undefined') return; // don't run for server side render
    var autoResize = true, base = 10, bodyBackground = '', bodyMargin = 0, bodyMarginStr = '', bodyObserver = null, bodyPadding = '', calculateWidth = false, doubleEventList = {
        resize: 1,
        click: 1
    }, eventCancelTimer = 128, firstRun = true, height = 1, heightCalcModeDefault = 'bodyOffset', heightCalcMode = heightCalcModeDefault, initLock = true, initMsg = '', inPageLinks = {}, interval = 32, intervalTimer = null, logging = false, mouseEvents = false, msgID = '[iFrameSizer]', msgIdLen = msgID.length, myID = '', resetRequiredMethods = {
        max: 1,
        min: 1,
        bodyScroll: 1,
        documentElementScroll: 1
    }, resizeFrom = 'child', sendPermit = true, target = window.parent, targetOriginDefault = '*', tolerance = 0, triggerLocked = false, triggerLockedTimer = null, throttledTimer = 16, width = 1, widthCalcModeDefault = 'scroll', widthCalcMode = widthCalcModeDefault, win = window, onMessage = function() {
        warn('onMessage function not defined');
    }, onReady = function() {}, onPageInfo = function() {}, customCalcMethods = {
        height: function() {
            warn('Custom height calculation function not defined');
            return document.documentElement.offsetHeight;
        },
        width: function() {
            warn('Custom width calculation function not defined');
            return document.body.scrollWidth;
        }
    }, eventHandlersByName = {}, passiveSupported = false;
    function noop() {}
    try {
        var options = Object.create({}, {
            passive: {
                // eslint-disable-next-line getter-return
                get: function() {
                    passiveSupported = true;
                }
            }
        });
        window.addEventListener('test', noop, options);
        window.removeEventListener('test', noop, options);
    } catch (error) {
    /* */ }
    function addEventListener(el, evt, func, options) {
        el.addEventListener(evt, func, passiveSupported ? options || {} : false);
    }
    function removeEventListener(el, evt, func) {
        el.removeEventListener(evt, func, false);
    }
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    // Based on underscore.js
    function throttle(func) {
        var context, args, result, timeout = null, previous = 0, later = function() {
            previous = Date.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) // eslint-disable-next-line no-multi-assign
            context = args = null;
        };
        return function() {
            var now = Date.now();
            if (!previous) previous = now;
            var remaining = throttledTimer - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > throttledTimer) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) // eslint-disable-next-line no-multi-assign
                context = args = null;
            } else if (!timeout) timeout = setTimeout(later, remaining);
            return result;
        };
    }
    function formatLogMsg(msg) {
        return msgID + '[' + myID + '] ' + msg;
    }
    function log(msg) {
        if (logging && 'object' === typeof window.console) // eslint-disable-next-line no-console
        console.log(formatLogMsg(msg));
    }
    function warn(msg) {
        if ('object' === typeof window.console) // eslint-disable-next-line no-console
        console.warn(formatLogMsg(msg));
    }
    function init() {
        readDataFromParent();
        log('Initialising iFrame (' + window.location.href + ')');
        readDataFromPage();
        setMargin();
        setBodyStyle('background', bodyBackground);
        setBodyStyle('padding', bodyPadding);
        injectClearFixIntoBodyElement();
        checkHeightMode();
        checkWidthMode();
        stopInfiniteResizingOfIFrame();
        setupPublicMethods();
        setupMouseEvents();
        startEventListeners();
        inPageLinks = setupInPageLinks();
        sendSize('init', 'Init message from host page');
        onReady();
    }
    function readDataFromParent() {
        function strBool(str) {
            return 'true' === str;
        }
        var data = initMsg.slice(msgIdLen).split(':');
        myID = data[0];
        bodyMargin = undefined === data[1] ? bodyMargin : Number(data[1]); // For V1 compatibility
        calculateWidth = undefined === data[2] ? calculateWidth : strBool(data[2]);
        logging = undefined === data[3] ? logging : strBool(data[3]);
        interval = undefined === data[4] ? interval : Number(data[4]);
        autoResize = undefined === data[6] ? autoResize : strBool(data[6]);
        bodyMarginStr = data[7];
        heightCalcMode = undefined === data[8] ? heightCalcMode : data[8];
        bodyBackground = data[9];
        bodyPadding = data[10];
        tolerance = undefined === data[11] ? tolerance : Number(data[11]);
        inPageLinks.enable = undefined === data[12] ? false : strBool(data[12]);
        resizeFrom = undefined === data[13] ? resizeFrom : data[13];
        widthCalcMode = undefined === data[14] ? widthCalcMode : data[14];
        mouseEvents = undefined === data[15] ? mouseEvents : strBool(data[15]);
    }
    function depricate(key) {
        var splitName = key.split('Callback');
        if (splitName.length === 2) {
            var name = 'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1);
            this[name] = this[key];
            delete this[key];
            warn("Deprecated: '" + key + "' has been renamed '" + name + "'. The old method will be removed in the next major version.");
        }
    }
    function readDataFromPage() {
        function readData() {
            var data = window.iFrameResizer;
            log('Reading data from page: ' + JSON.stringify(data));
            Object.keys(data).forEach(depricate, data);
            onMessage = 'onMessage' in data ? data.onMessage : onMessage;
            onReady = 'onReady' in data ? data.onReady : onReady;
            targetOriginDefault = 'targetOrigin' in data ? data.targetOrigin : targetOriginDefault;
            heightCalcMode = 'heightCalculationMethod' in data ? data.heightCalculationMethod : heightCalcMode;
            widthCalcMode = 'widthCalculationMethod' in data ? data.widthCalculationMethod : widthCalcMode;
        }
        function setupCustomCalcMethods(calcMode, calcFunc) {
            if ('function' === typeof calcMode) {
                log('Setup custom ' + calcFunc + 'CalcMethod');
                customCalcMethods[calcFunc] = calcMode;
                calcMode = 'custom';
            }
            return calcMode;
        }
        if ('iFrameResizer' in window && Object === window.iFrameResizer.constructor) {
            readData();
            heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
            widthCalcMode = setupCustomCalcMethods(widthCalcMode, 'width');
        }
        log('TargetOrigin for parent set to: ' + targetOriginDefault);
    }
    function chkCSS(attr, value) {
        if (-1 !== value.indexOf('-')) {
            warn('Negative CSS value ignored for ' + attr);
            value = '';
        }
        return value;
    }
    function setBodyStyle(attr, value) {
        if (undefined !== value && '' !== value && 'null' !== value) {
            document.body.style[attr] = value;
            log('Body ' + attr + ' set to "' + value + '"');
        }
    }
    function setMargin() {
        // If called via V1 script, convert bodyMargin from int to str
        if (undefined === bodyMarginStr) bodyMarginStr = bodyMargin + 'px';
        setBodyStyle('margin', chkCSS('margin', bodyMarginStr));
    }
    function stopInfiniteResizingOfIFrame() {
        document.documentElement.style.height = '';
        document.body.style.height = '';
        log('HTML & body height set to "auto"');
    }
    function manageTriggerEvent(options) {
        var listener = {
            add: function(eventName) {
                function handleEvent() {
                    sendSize(options.eventName, options.eventType);
                }
                eventHandlersByName[eventName] = handleEvent;
                addEventListener(window, eventName, handleEvent, {
                    passive: true
                });
            },
            remove: function(eventName) {
                var handleEvent = eventHandlersByName[eventName];
                delete eventHandlersByName[eventName];
                removeEventListener(window, eventName, handleEvent);
            }
        };
        if (options.eventNames && Array.prototype.map) {
            options.eventName = options.eventNames[0];
            options.eventNames.map(listener[options.method]);
        } else listener[options.method](options.eventName);
        log(capitalizeFirstLetter(options.method) + ' event listener: ' + options.eventType);
    }
    function manageEventListeners(method) {
        manageTriggerEvent({
            method: method,
            eventType: 'Animation Start',
            eventNames: [
                'animationstart',
                'webkitAnimationStart'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Animation Iteration',
            eventNames: [
                'animationiteration',
                'webkitAnimationIteration'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Animation End',
            eventNames: [
                'animationend',
                'webkitAnimationEnd'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Input',
            eventName: 'input'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Mouse Up',
            eventName: 'mouseup'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Mouse Down',
            eventName: 'mousedown'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Orientation Change',
            eventName: 'orientationchange'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Print',
            eventNames: [
                'afterprint',
                'beforeprint'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Ready State Change',
            eventName: 'readystatechange'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch Start',
            eventName: 'touchstart'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch End',
            eventName: 'touchend'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch Cancel',
            eventName: 'touchcancel'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition Start',
            eventNames: [
                'transitionstart',
                'webkitTransitionStart',
                'MSTransitionStart',
                'oTransitionStart',
                'otransitionstart'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition Iteration',
            eventNames: [
                'transitioniteration',
                'webkitTransitionIteration',
                'MSTransitionIteration',
                'oTransitionIteration',
                'otransitioniteration'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition End',
            eventNames: [
                'transitionend',
                'webkitTransitionEnd',
                'MSTransitionEnd',
                'oTransitionEnd',
                'otransitionend'
            ]
        });
        if ('child' === resizeFrom) manageTriggerEvent({
            method: method,
            eventType: 'IFrame Resized',
            eventName: 'resize'
        });
    }
    function checkCalcMode(calcMode, calcModeDefault, modes, type) {
        if (calcModeDefault !== calcMode) {
            if (!(calcMode in modes)) {
                warn(calcMode + ' is not a valid option for ' + type + 'CalculationMethod.');
                calcMode = calcModeDefault;
            }
            log(type + ' calculation method set to "' + calcMode + '"');
        }
        return calcMode;
    }
    function checkHeightMode() {
        heightCalcMode = checkCalcMode(heightCalcMode, heightCalcModeDefault, getHeight, 'height');
    }
    function checkWidthMode() {
        widthCalcMode = checkCalcMode(widthCalcMode, widthCalcModeDefault, getWidth, 'width');
    }
    function startEventListeners() {
        if (true === autoResize) {
            manageEventListeners('add');
            setupMutationObserver();
        } else log('Auto Resize disabled');
    }
    //   function stopMsgsToParent() {
    //     log('Disable outgoing messages')
    //     sendPermit = false
    //   }
    //   function removeMsgListener() {
    //     log('Remove event listener: Message')
    //     removeEventListener(window, 'message', receiver)
    //   }
    function disconnectMutationObserver() {
        if (null !== bodyObserver) /* istanbul ignore next */ // Not testable in PhantonJS
        bodyObserver.disconnect();
    }
    function stopEventListeners() {
        manageEventListeners('remove');
        disconnectMutationObserver();
        clearInterval(intervalTimer);
    }
    //   function teardown() {
    //     stopMsgsToParent()
    //     removeMsgListener()
    //     if (true === autoResize) stopEventListeners()
    //   }
    function injectClearFixIntoBodyElement() {
        var clearFix = document.createElement('div');
        clearFix.style.clear = 'both';
        // Guard against the following having been globally redefined in CSS.
        clearFix.style.display = 'block';
        clearFix.style.height = '0';
        document.body.appendChild(clearFix);
    }
    function setupInPageLinks() {
        function getPagePosition() {
            return {
                x: window.pageXOffset === undefined ? document.documentElement.scrollLeft : window.pageXOffset,
                y: window.pageYOffset === undefined ? document.documentElement.scrollTop : window.pageYOffset
            };
        }
        function getElementPosition(el) {
            var elPosition = el.getBoundingClientRect(), pagePosition = getPagePosition();
            return {
                x: parseInt(elPosition.left, 10) + parseInt(pagePosition.x, 10),
                y: parseInt(elPosition.top, 10) + parseInt(pagePosition.y, 10)
            };
        }
        function findTarget(location) {
            function jumpToTarget(target) {
                var jumpPosition = getElementPosition(target);
                log('Moving to in page link (#' + hash + ') at x: ' + jumpPosition.x + ' y: ' + jumpPosition.y);
                sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
            }
            var hash = location.split('#')[1] || location, hashData = decodeURIComponent(hash), target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
            if (undefined === target) {
                log('In page link (#' + hash + ') not found in iFrame, so sending to parent');
                sendMsg(0, 0, 'inPageLink', '#' + hash);
            } else jumpToTarget(target);
        }
        function checkLocationHash() {
            var hash = window.location.hash;
            var href = window.location.href;
            if ('' !== hash && '#' !== hash) findTarget(href);
        }
        function bindAnchors() {
            function setupLink(el) {
                function linkClicked(e) {
                    e.preventDefault();
                    /* jshint validthis:true */ findTarget(this.getAttribute('href'));
                }
                if ('#' !== el.getAttribute('href')) addEventListener(el, 'click', linkClicked);
            }
            Array.prototype.forEach.call(document.querySelectorAll('a[href^="#"]'), setupLink);
        }
        function bindLocationHash() {
            addEventListener(window, 'hashchange', checkLocationHash);
        }
        function initCheck() {
            // Check if page loaded with location hash after init resize
            setTimeout(checkLocationHash, eventCancelTimer);
        }
        function enableInPageLinks() {
            /* istanbul ignore else */ // Not testable in phantonJS
            if (Array.prototype.forEach && document.querySelectorAll) {
                log('Setting up location.hash handlers');
                bindAnchors();
                bindLocationHash();
                initCheck();
            } else warn('In page linking not fully supported in this browser! (See README.md for IE8 workaround)');
        }
        if (inPageLinks.enable) enableInPageLinks();
        else log('In page linking not enabled');
        return {
            findTarget: findTarget
        };
    }
    function setupMouseEvents() {
        if (mouseEvents !== true) return;
        function sendMouse(e) {
            sendMsg(0, 0, e.type, e.screenY + ':' + e.screenX);
        }
        function addMouseListener(evt, name) {
            log('Add event listener: ' + name);
            addEventListener(window.document, evt, sendMouse);
        }
        addMouseListener('mouseenter', 'Mouse Enter');
        addMouseListener('mouseleave', 'Mouse Leave');
    }
    function setupPublicMethods() {
        log('Enable public methods');
        win.parentIFrame = {
            autoResize: function autoResizeF(resize) {
                if (true === resize && false === autoResize) {
                    autoResize = true;
                    startEventListeners();
                } else if (false === resize && true === autoResize) {
                    autoResize = false;
                    stopEventListeners();
                }
                sendMsg(0, 0, 'autoResize', JSON.stringify(autoResize));
                return autoResize;
            },
            close: function closeF() {
                sendMsg(0, 0, 'close');
            // teardown()
            },
            getId: function getIdF() {
                return myID;
            },
            getPageInfo: function getPageInfoF(callback) {
                if ('function' === typeof callback) {
                    onPageInfo = callback;
                    sendMsg(0, 0, 'pageInfo');
                } else {
                    onPageInfo = function() {};
                    sendMsg(0, 0, 'pageInfoStop');
                }
            },
            moveToAnchor: function moveToAnchorF(hash) {
                inPageLinks.findTarget(hash);
            },
            reset: function resetF() {
                resetIFrame('parentIFrame.reset');
            },
            scrollTo: function scrollToF(x, y) {
                sendMsg(y, x, 'scrollTo'); // X&Y reversed at sendMsg uses height/width
            },
            scrollToOffset: function scrollToF(x, y) {
                sendMsg(y, x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
            },
            sendMessage: function sendMessageF(msg, targetOrigin) {
                sendMsg(0, 0, 'message', JSON.stringify(msg), targetOrigin);
            },
            setHeightCalculationMethod: function setHeightCalculationMethodF(heightCalculationMethod) {
                heightCalcMode = heightCalculationMethod;
                checkHeightMode();
            },
            setWidthCalculationMethod: function setWidthCalculationMethodF(widthCalculationMethod) {
                widthCalcMode = widthCalculationMethod;
                checkWidthMode();
            },
            setTargetOrigin: function setTargetOriginF(targetOrigin) {
                log('Set targetOrigin: ' + targetOrigin);
                targetOriginDefault = targetOrigin;
            },
            size: function sizeF(customHeight, customWidth) {
                var valString = '' + (customHeight || '') + (customWidth ? ',' + customWidth : '');
                sendSize('size', 'parentIFrame.size(' + valString + ')', customHeight, customWidth);
            }
        };
    }
    function initInterval() {
        if (0 !== interval) {
            log('setInterval: ' + interval + 'ms');
            intervalTimer = setInterval(function() {
                sendSize('interval', 'setInterval: ' + interval);
            }, Math.abs(interval));
        }
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function setupBodyMutationObserver() {
        function addImageLoadListners(mutation) {
            function addImageLoadListener(element) {
                if (false === element.complete) {
                    log('Attach listeners to ' + element.src);
                    element.addEventListener('load', imageLoaded, false);
                    element.addEventListener('error', imageError, false);
                    elements.push(element);
                }
            }
            if (mutation.type === 'attributes' && mutation.attributeName === 'src') addImageLoadListener(mutation.target);
            else if (mutation.type === 'childList') Array.prototype.forEach.call(mutation.target.querySelectorAll('img'), addImageLoadListener);
        }
        function removeFromArray(element) {
            elements.splice(elements.indexOf(element), 1);
        }
        function removeImageLoadListener(element) {
            log('Remove listeners from ' + element.src);
            element.removeEventListener('load', imageLoaded, false);
            element.removeEventListener('error', imageError, false);
            removeFromArray(element);
        }
        function imageEventTriggered(event, type, typeDesc) {
            removeImageLoadListener(event.target);
            sendSize(type, typeDesc + ': ' + event.target.src);
        }
        function imageLoaded(event) {
            imageEventTriggered(event, 'imageLoad', 'Image loaded');
        }
        function imageError(event) {
            imageEventTriggered(event, 'imageLoadFailed', 'Image load failed');
        }
        function mutationObserved(mutations) {
            sendSize('mutationObserver', 'mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type);
            // Deal with WebKit / Blink asyncing image loading when tags are injected into the page
            mutations.forEach(addImageLoadListners);
        }
        function createMutationObserver() {
            var target = document.querySelector('body'), config = {
                attributes: true,
                attributeOldValue: false,
                characterData: true,
                characterDataOldValue: false,
                childList: true,
                subtree: true
            };
            observer = new MutationObserver(mutationObserved);
            log('Create body MutationObserver');
            observer.observe(target, config);
            return observer;
        }
        var elements = [], MutationObserver = window.MutationObserver || window.WebKitMutationObserver, observer = createMutationObserver();
        return {
            disconnect: function() {
                if ('disconnect' in observer) {
                    log('Disconnect body MutationObserver');
                    observer.disconnect();
                    elements.forEach(removeImageLoadListener);
                }
            }
        };
    }
    function setupMutationObserver() {
        var forceIntervalTimer = 0 > interval;
        // Not testable in PhantomJS
        /* istanbul ignore if */ if (window.MutationObserver || window.WebKitMutationObserver) {
            if (forceIntervalTimer) initInterval();
            else bodyObserver = setupBodyMutationObserver();
        } else {
            log('MutationObserver not supported in this browser!');
            initInterval();
        }
    }
    // document.documentElement.offsetHeight is not reliable, so
    // we have to jump through hoops to get a better value.
    function getComputedStyle(prop, el) {
        var retVal = 0;
        el = el || document.body; // Not testable in phantonJS
        retVal = document.defaultView.getComputedStyle(el, null);
        retVal = null === retVal ? 0 : retVal[prop];
        return parseInt(retVal, base);
    }
    function chkEventThottle(timer) {
        if (timer > throttledTimer / 2) {
            throttledTimer = 2 * timer;
            log('Event throttle increased to ' + throttledTimer + 'ms');
        }
    }
    // Idea from https://github.com/guardian/iframe-messenger
    function getMaxElement(side, elements) {
        var elementsLength = elements.length, elVal = 0, maxVal = 0, Side = capitalizeFirstLetter(side), timer = Date.now();
        for(var i = 0; i < elementsLength; i++){
            elVal = elements[i].getBoundingClientRect()[side] + getComputedStyle('margin' + Side, elements[i]);
            if (elVal > maxVal) maxVal = elVal;
        }
        timer = Date.now() - timer;
        log('Parsed ' + elementsLength + ' HTML elements');
        log('Element position calculated in ' + timer + 'ms');
        chkEventThottle(timer);
        return maxVal;
    }
    function getAllMeasurements(dimensions) {
        return [
            dimensions.bodyOffset(),
            dimensions.bodyScroll(),
            dimensions.documentElementOffset(),
            dimensions.documentElementScroll()
        ];
    }
    function getTaggedElements(side, tag) {
        function noTaggedElementsFound() {
            warn('No tagged elements (' + tag + ') found on page');
            return document.querySelectorAll('body *');
        }
        var elements = document.querySelectorAll('[' + tag + ']');
        if (elements.length === 0) noTaggedElementsFound();
        return getMaxElement(side, elements);
    }
    function getAllElements() {
        return document.querySelectorAll('body *');
    }
    var getHeight = {
        bodyOffset: function getBodyOffsetHeight() {
            return document.body.offsetHeight + getComputedStyle('marginTop') + getComputedStyle('marginBottom');
        },
        offset: function() {
            return getHeight.bodyOffset() // Backwards compatibility
            ;
        },
        bodyScroll: function getBodyScrollHeight() {
            return document.body.scrollHeight;
        },
        custom: function getCustomWidth() {
            return customCalcMethods.height();
        },
        documentElementOffset: function getDEOffsetHeight() {
            return document.documentElement.offsetHeight;
        },
        documentElementScroll: function getDEScrollHeight() {
            return document.documentElement.scrollHeight;
        },
        max: function getMaxHeight() {
            return Math.max.apply(null, getAllMeasurements(getHeight));
        },
        min: function getMinHeight() {
            return Math.min.apply(null, getAllMeasurements(getHeight));
        },
        grow: function growHeight() {
            return getHeight.max() // Run max without the forced downsizing
            ;
        },
        lowestElement: function getBestHeight() {
            return Math.max(getHeight.bodyOffset() || getHeight.documentElementOffset(), getMaxElement('bottom', getAllElements()));
        },
        taggedElement: function getTaggedElementsHeight() {
            return getTaggedElements('bottom', 'data-iframe-height');
        }
    }, getWidth = {
        bodyScroll: function getBodyScrollWidth() {
            return document.body.scrollWidth;
        },
        bodyOffset: function getBodyOffsetWidth() {
            return document.body.offsetWidth;
        },
        custom: function getCustomWidth() {
            return customCalcMethods.width();
        },
        documentElementScroll: function getDEScrollWidth() {
            return document.documentElement.scrollWidth;
        },
        documentElementOffset: function getDEOffsetWidth() {
            return document.documentElement.offsetWidth;
        },
        scroll: function getMaxWidth() {
            return Math.max(getWidth.bodyScroll(), getWidth.documentElementScroll());
        },
        max: function getMaxWidth() {
            return Math.max.apply(null, getAllMeasurements(getWidth));
        },
        min: function getMinWidth() {
            return Math.min.apply(null, getAllMeasurements(getWidth));
        },
        rightMostElement: function rightMostElement() {
            return getMaxElement('right', getAllElements());
        },
        taggedElement: function getTaggedElementsWidth() {
            return getTaggedElements('right', 'data-iframe-width');
        }
    };
    function sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth) {
        function resizeIFrame() {
            height = currentHeight;
            width = currentWidth;
            sendMsg(height, width, triggerEvent);
        }
        function isSizeChangeDetected() {
            function checkTolarance(a, b) {
                var retVal = Math.abs(a - b) <= tolerance;
                return !retVal;
            }
            currentHeight = undefined === customHeight ? getHeight[heightCalcMode]() : customHeight;
            currentWidth = undefined === customWidth ? getWidth[widthCalcMode]() : customWidth;
            return checkTolarance(height, currentHeight) || calculateWidth && checkTolarance(width, currentWidth);
        }
        function isForceResizableEvent() {
            return !(triggerEvent in {
                init: 1,
                interval: 1,
                size: 1
            });
        }
        function isForceResizableCalcMode() {
            return heightCalcMode in resetRequiredMethods || calculateWidth && widthCalcMode in resetRequiredMethods;
        }
        function logIgnored() {
            log('No change in size detected');
        }
        function checkDownSizing() {
            if (isForceResizableEvent() && isForceResizableCalcMode()) resetIFrame(triggerEventDesc);
            else if (!(triggerEvent in {
                interval: 1
            })) logIgnored();
        }
        var currentHeight, currentWidth;
        if (isSizeChangeDetected() || 'init' === triggerEvent) {
            lockTrigger();
            resizeIFrame();
        } else checkDownSizing();
    }
    var sizeIFrameThrottled = throttle(sizeIFrame);
    function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
        function recordTrigger() {
            if (!(triggerEvent in {
                reset: 1,
                resetPage: 1,
                init: 1
            })) log('Trigger event: ' + triggerEventDesc);
        }
        function isDoubleFiredEvent() {
            return triggerLocked && triggerEvent in doubleEventList;
        }
        if (isDoubleFiredEvent()) log('Trigger event cancelled: ' + triggerEvent);
        else {
            recordTrigger();
            if (triggerEvent === 'init') sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth);
            else sizeIFrameThrottled(triggerEvent, triggerEventDesc, customHeight, customWidth);
        }
    }
    function lockTrigger() {
        if (!triggerLocked) {
            triggerLocked = true;
            log('Trigger event lock on');
        }
        clearTimeout(triggerLockedTimer);
        triggerLockedTimer = setTimeout(function() {
            triggerLocked = false;
            log('Trigger event lock off');
            log('--');
        }, eventCancelTimer);
    }
    function triggerReset(triggerEvent) {
        height = getHeight[heightCalcMode]();
        width = getWidth[widthCalcMode]();
        sendMsg(height, width, triggerEvent);
    }
    function resetIFrame(triggerEventDesc) {
        var hcm = heightCalcMode;
        heightCalcMode = heightCalcModeDefault;
        log('Reset trigger event: ' + triggerEventDesc);
        lockTrigger();
        triggerReset('reset');
        heightCalcMode = hcm;
    }
    function sendMsg(height, width, triggerEvent, msg, targetOrigin) {
        function setTargetOrigin() {
            if (undefined === targetOrigin) targetOrigin = targetOriginDefault;
            else log('Message targetOrigin: ' + targetOrigin);
        }
        function sendToParent() {
            var size = height + ':' + width, message = myID + ':' + size + ':' + triggerEvent + (undefined === msg ? '' : ':' + msg);
            log('Sending message to host page (' + message + ')');
            target.postMessage(msgID + message, targetOrigin);
        }
        if (true === sendPermit) {
            setTargetOrigin();
            sendToParent();
        }
    }
    function receiver(event) {
        var processRequestFromParent = {
            init: function initFromParent() {
                initMsg = event.data;
                target = event.source;
                init();
                firstRun = false;
                setTimeout(function() {
                    initLock = false;
                }, eventCancelTimer);
            },
            reset: function resetFromParent() {
                if (initLock) log('Page reset ignored by init');
                else {
                    log('Page size reset by host page');
                    triggerReset('resetPage');
                }
            },
            resize: function resizeFromParent() {
                sendSize('resizeParent', 'Parent window requested size check');
            },
            moveToAnchor: function moveToAnchorF() {
                inPageLinks.findTarget(getData());
            },
            inPageLink: function inPageLinkF() {
                this.moveToAnchor();
            },
            pageInfo: function pageInfoFromParent() {
                var msgBody = getData();
                log('PageInfoFromParent called from parent: ' + msgBody);
                onPageInfo(JSON.parse(msgBody));
                log(' --');
            },
            message: function messageFromParent() {
                var msgBody = getData();
                log('onMessage called from parent: ' + msgBody);
                // eslint-disable-next-line sonarjs/no-extra-arguments
                onMessage(JSON.parse(msgBody));
                log(' --');
            }
        };
        function isMessageForUs() {
            return msgID === ('' + event.data).slice(0, msgIdLen) // ''+ Protects against non-string messages
            ;
        }
        function getMessageType() {
            return event.data.split(']')[1].split(':')[0];
        }
        function getData() {
            return event.data.slice(event.data.indexOf(':') + 1);
        }
        function isMiddleTier() {
            return !module.exports && 'iFrameResize' in window || window.jQuery !== undefined && 'iFrameResize' in window.jQuery.prototype;
        }
        function isInitMsg() {
            // Test if this message is from a child below us. This is an ugly test, however, updating
            // the message format would break backwards compatibility.
            return event.data.split(':')[2] in {
                true: 1,
                false: 1
            };
        }
        function callFromParent() {
            var messageType = getMessageType();
            if (messageType in processRequestFromParent) processRequestFromParent[messageType]();
            else if (!isMiddleTier() && !isInitMsg()) warn('Unexpected message (' + event.data + ')');
        }
        function processMessage() {
            if (false === firstRun) callFromParent();
            else if (isInitMsg()) processRequestFromParent.init();
            else log('Ignored message of type "' + getMessageType() + '". Received before initialization.');
        }
        if (isMessageForUs()) processMessage();
    }
    // Normally the parent kicks things off when it detects the iFrame has loaded.
    // If this script is async-loaded, then tell parent page to retry init.
    function chkLateLoaded() {
        if ('loading' !== document.readyState) window.parent.postMessage('[iFrameResizerChild]Ready', '*');
    }
    // Setup if not already running
    if (!('iframeResizer' in window)) {
        window.iframeChildListener = function(data) {
            receiver({
                data: data,
                sameDomian: true
            });
        };
        addEventListener(window, 'message', receiver);
        addEventListener(window, 'readystatechange', chkLateLoaded);
        chkLateLoaded();
    }
})();

});

parcelRegister("h48r4", function(module, exports) {

var $jH9cM = parcelRequire("jH9cM");


var $iDrrr = parcelRequire("iDrrr");


var $bEbDR = parcelRequire("bEbDR");


var $eL3mC = parcelRequire("eL3mC");

const $6547e6e0befefd50$var$packageVersion = "0.0.0-use.local";
const $6547e6e0befefd50$export$bb9823fd3fb51f9c = 'https://1210cfc4338849588134f2c80b99f75c@o55978.ingest.sentry.io/5988824';
const $6547e6e0befefd50$export$b7f7efe8cd791eed = 'https://a377d38318350e08236b26b7b13c8016@sentry.atlassian-us-gov-mod.com/23';

const $6547e6e0befefd50$export$faf06bc0661c564c = async ({ error: error, environment: environment, errorExtensionDetails: errorExtensionDetails, page: page, errorInfo: errorInfo, runtime: runtime, tracing: tracing })=>{
    try {
        const module = await Promise.resolve((parcelRequire("eieXD")));
        const { BrowserClient: BrowserClient, Hub: Hub } = module;
        // From https://sentry.io/settings/atlassian-2y/projects/forge-ui/keys/ and https://sentry.prod.services.kitt-inf-us-gov-mod.net/settings/sentry/projects/forge-ui/keys
        const dsn = (0, $jH9cM.isFedRamp)() ? $6547e6e0befefd50$export$b7f7efe8cd791eed : $6547e6e0befefd50$export$bb9823fd3fb51f9c;
        const client = new BrowserClient({
            environment: environment,
            dsn: dsn,
            release: `forge-ui@${$6547e6e0befefd50$var$packageVersion}`
        });
        const hub = new Hub(client);
        hub.withScope(async (scope)=>{
            if (tracing) {
                const breadcrumbs = tracing.getBreadcrumbs();
                breadcrumbs.forEach((bc)=>scope.addBreadcrumb(bc, 20));
            }
            if (errorInfo) scope.setExtra('componentTrace', {
                errorInfo: errorInfo,
                componentStack: errorInfo?.componentStack?.substring(0, 1000)
            });
            scope.setTag('extensionPoint', page);
            if (runtime && (0, $iDrrr.fg)('forge-ui-bridge-core-reset')) scope.setTag('forgeRuntime', runtime);
            if (errorExtensionDetails) {
                scope.setExtra('extensionProperties', errorExtensionDetails.properties);
                try {
                    const appIdFromId = (0, $bEbDR.parseExtensionId)(errorExtensionDetails.id ?? '').appId;
                    if (appIdFromId) scope.setTag('appId', appIdFromId);
                } catch (e) {
                // parseExtensionId() uses parse() form @atlassian/cs-ari, which throws an error if the ID is not valid
                }
                if (errorExtensionDetails.environmentType) scope.setTag('forgeEnvironment', errorExtensionDetails.environmentType);
                if (errorExtensionDetails.type) scope.setTag('extensionType', errorExtensionDetails.type);
                if (errorExtensionDetails.appOwnerAccountId) scope.setTag('appOwner', errorExtensionDetails.appOwnerAccountId);
            }
            hub.captureException(error);
        });
        return client.close();
    } catch (e) {
    // Error reporting failed, we don't want to cause a unhandledrejection event
    }
};
module.exports["captureAndReportError"] = $6547e6e0befefd50$export$faf06bc0661c564c;

});

parcelRegister("9ytZz", function(module, exports) {
const $ad49de79dc23691a$export$6f54f2843389780e = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    XLARGE: 'xlarge',
    MAX: 'max',
    FULLSCREEN: 'fullscreen',
    RESIZABLE: 'resizable'
};
const $ad49de79dc23691a$export$a1ac1511402c8dbf = (size)=>typeof size === 'string' && Object.values($ad49de79dc23691a$export$6f54f2843389780e).includes(size);
const $ad49de79dc23691a$export$e0b8baa8b7ed82d1 = (size)=>typeof size === 'object';
var $ad49de79dc23691a$export$d0163c7b07301739 = /*#__PURE__*/ function(FeatureFlagEnv) {
    FeatureFlagEnv["development"] = "development";
    FeatureFlagEnv["staging"] = "staging";
    FeatureFlagEnv["production"] = "production";
    return FeatureFlagEnv;
}({});
var $ad49de79dc23691a$export$35879154c49e2b67 = /*#__PURE__*/ function(FeatureFlagEventTypes) {
    FeatureFlagEventTypes["INITIALIZATION"] = "initialization";
    FeatureFlagEventTypes["CHECKFLAG"] = "checkFlag";
    return FeatureFlagEventTypes;
}({});
module.exports["isNamedSize"] = $ad49de79dc23691a$export$a1ac1511402c8dbf;
module.exports["isCustomDimensions"] = $ad49de79dc23691a$export$e0b8baa8b7ed82d1;
module.exports["FeatureFlagEnv"] = $ad49de79dc23691a$export$d0163c7b07301739;
module.exports["FeatureFlagEventTypes"] = $ad49de79dc23691a$export$35879154c49e2b67;

});

parcelRegister("1uMa2", function(module, exports) {
// This prefix is also used in ConfigPanelFieldsLoader.tsx in the
// @atlaskit/editor-plugin-extension package. The Editor package is public, so it
// cannot import this constant from @atlassian/forge-ui. Do not update this prefix
// without also doing so in the Editor package.
const $80a2919b34222f54$var$EVENT_PREFIX = 'forge.bridge.';
function $80a2919b34222f54$export$af631764ddc44097(event, callback, extension) {
    const wrappedCallback = (e)=>{
        if (!extension || !e.detail?.extension || extension.id === e.detail?.extension?.id && extension.installationId === e.detail?.extension?.installationId) callback(e.detail?.payload, e.detail?.extension);
    };
    window.document.addEventListener(`${$80a2919b34222f54$var$EVENT_PREFIX}${event}`, wrappedCallback);
    return {
        unsubscribe: ()=>window.document.removeEventListener(`${$80a2919b34222f54$var$EVENT_PREFIX}${event}`, wrappedCallback)
    };
}
const $80a2919b34222f54$export$2b8594f1cc80daad = (event, callback, extension)=>{
    const wrappedCallback = (e)=>{
        const allowedRecipients = e.detail?.allowedRecipients || [];
        if (allowedRecipients.includes('*') || allowedRecipients.includes(extension.appId)) callback(e.detail?.payload);
    };
    window.document.addEventListener(`${$80a2919b34222f54$var$EVENT_PREFIX}${event}`, wrappedCallback);
    return {
        unsubscribe: ()=>window.document.removeEventListener(`${$80a2919b34222f54$var$EVENT_PREFIX}${event}`, wrappedCallback)
    };
};
function $80a2919b34222f54$export$8f35fbd5db0f3634(event, payload, extension) {
    const newEvent = new CustomEvent(`${$80a2919b34222f54$var$EVENT_PREFIX}${event}`, {
        detail: {
            extension: extension,
            payload: payload
        }
    });
    window.document.dispatchEvent(newEvent);
} // emitPublic is implemented in useEmitPublicEvent hook
module.exports["on"] = $80a2919b34222f54$export$af631764ddc44097;
module.exports["onPublic"] = $80a2919b34222f54$export$2b8594f1cc80daad;
module.exports["emit"] = $80a2919b34222f54$export$8f35fbd5db0f3634;

});

parcelRegister("8yKod", function(module, exports) {
const $44000b8247dfb98e$export$4c5241daa4566af8 = (extension, entryPoint)=>{
    const { render: render, resource: resource } = extension.properties;
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
        return entryPointResource != null && entryPointRender !== 'native';
    }
    return resource != null && render !== 'native';
};
module.exports["isCustomUI"] = $44000b8247dfb98e$export$4c5241daa4566af8;

});

parcelRegister("9PdUw", function(module, exports) {
/**
 * @generated SignedSource<<4abaf3e73a42e763cec8f18a69f2deb9>>
 * @relayHash 6d284c4e2738019b6564014da1145298
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f02b9eff7aa36cbdef2d023444ef3574a2ca29a78d05ea41986c50fe24bbf5e7
const $55c5fc9d75288b23$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contextIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dataClassificationTags"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "environmentId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "environmentType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "environmentKey"
    }, v13 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v14 = {
        "kind": "ScalarField",
        "name": "type"
    }, v15 = {
        "concreteType": "AppInstallationLicense",
        "kind": "LinkedField",
        "name": "license",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "active"
            },
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "supportEntitlementNumber"
            },
            {
                "kind": "ScalarField",
                "name": "trialEndDate"
            },
            {
                "kind": "ScalarField",
                "name": "subscriptionEndDate"
            },
            {
                "kind": "ScalarField",
                "name": "isEvaluation"
            },
            {
                "kind": "ScalarField",
                "name": "billingPeriod"
            },
            {
                "kind": "ScalarField",
                "name": "ccpEntitlementId"
            },
            {
                "kind": "ScalarField",
                "name": "ccpEntitlementSlug"
            },
            {
                "kind": "ScalarField",
                "name": "capabilitySet"
            },
            {
                "kind": "ScalarField",
                "name": "modes"
            }
        ]
    }, v16 = {
        "concreteType": "UserAccess",
        "kind": "LinkedField",
        "name": "userAccess",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "enabled"
            },
            {
                "kind": "ScalarField",
                "name": "hasAccess"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "appVersion"
    }, v18 = {
        "kind": "ScalarField",
        "name": "installationId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "migrationKey"
    }, v20 = {
        "concreteType": "EcosystemAppInstallationConfigExtension",
        "kind": "LinkedField",
        "name": "installationConfig",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v21 = {
        "concreteType": "AppNetworkEgressPermissionExtension",
        "kind": "LinkedField",
        "name": "egress",
        "plural": true,
        "selections": [
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "addresses"
            },
            {
                "kind": "ScalarField",
                "name": "category"
            },
            {
                "kind": "ScalarField",
                "name": "inScopeEUD"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "sandboxPolicies"
    }, v23 = {
        "kind": "ScalarField",
        "name": "scopes"
    }, v24 = {
        "kind": "ScalarField",
        "name": "consentUrl"
    }, v25 = {
        "concreteType": "UserConsentExtension",
        "kind": "LinkedField",
        "name": "currentUserConsent",
        "plural": false,
        "selections": [
            {
                "concreteType": "UserConsentExtensionUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "aaid"
                    }
                ]
            },
            {
                "concreteType": "UserConsentExtensionAppEnvironmentVersion",
                "kind": "LinkedField",
                "name": "appEnvironmentVersion",
                "plural": false,
                "selections": [
                    v5 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "consentedAt"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "requiresUserConsent"
    }, v27 = {
        "args": [
            {
                "fields": [
                    {
                        "kind": "Variable",
                        "name": "dataClassificationTags",
                        "variableName": "dataClassificationTags"
                    }
                ],
                "kind": "ObjectValue",
                "name": "input"
            }
        ],
        "concreteType": "DataClassificationPolicyDecision",
        "kind": "LinkedField",
        "name": "dataClassificationPolicyDecision",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "getForgeUIExtensionsAsync_Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "appOwner",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v14 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "getForgeUIExtensionsAsync_Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "appOwner",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v9 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v14 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f02b9eff7aa36cbdef2d023444ef3574a2ca29a78d05ea41986c50fe24bbf5e7",
            "metadata": {},
            "name": "getForgeUIExtensionsAsync_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$55c5fc9d75288b23$var$node.hash = "59900f050a7e9e52914910a2298a2b90";
var $55c5fc9d75288b23$export$2e2bcd8739ae039 = $55c5fc9d75288b23$var$node;


/**
 * @generated SignedSource<<a92e3f7b5c304e5c0474f92901348fbf>>
 * @relayHash 8dbf1b2c42e006b46318fdb35dbd84c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9fbdabaf5dea7d056121f1a06179cc57d363d064051c644df62e338d32a47902
const $294ded3bdd1426fb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "sandboxPolicies"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getForgeUIExtensionsAsync_prefetchedQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getForgeUIExtensionsAsync_prefetchedQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "9fbdabaf5dea7d056121f1a06179cc57d363d064051c644df62e338d32a47902",
            "metadata": {},
            "name": "getForgeUIExtensionsAsync_prefetchedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$294ded3bdd1426fb$var$node.hash = "93483edca319981bfc263ad9ff337c9e";
var $294ded3bdd1426fb$export$2e2bcd8739ae039 = $294ded3bdd1426fb$var$node;



var $4o0zT = parcelRequire("4o0zT");


var $6SsN4 = parcelRequire("6SsN4");


var $f53nH = parcelRequire("f53nH");

var $hzmpb = parcelRequire("hzmpb");


var $2rD5H = parcelRequire("2rD5H");


var $iGKcz = parcelRequire("iGKcz");

/**
 * `fetchQuery` never reads the Relay store and only coalesces in-flight requests, so the
 * provider rebuilds spread across a page load each refetch the same extension list. The
 * TTL is what collapses them, so it has to outlive a page load without pinning a stale
 * list for the whole session.
 *
 * Kept per Relay environment so a rebuilt environment starts clean, and only used for the
 * prefiltered branch — the legacy branch serves bridge navigation lookups that run on user
 * action and must stay fresh.
 */ const $4952feaf3866c161$var$PREFILTERED_REQUEST_TTL_MS = 60000;
const $4952feaf3866c161$var$prefilteredRequests = new WeakMap();
const $4952feaf3866c161$var$readPrefilteredRequest = (environment, cacheKey)=>{
    const entry = $4952feaf3866c161$var$prefilteredRequests.get(environment)?.get(cacheKey);
    if (!entry) return undefined;
    if (entry.expiresAt <= Date.now()) {
        $4952feaf3866c161$var$prefilteredRequests.get(environment)?.delete(cacheKey);
        return undefined;
    }
    return entry.promise;
};
const $4952feaf3866c161$var$writePrefilteredRequest = (environment, cacheKey, promise)=>{
    let requestsForEnvironment = $4952feaf3866c161$var$prefilteredRequests.get(environment);
    if (!requestsForEnvironment) {
        requestsForEnvironment = new Map();
        $4952feaf3866c161$var$prefilteredRequests.set(environment, requestsForEnvironment);
    }
    const requests = requestsForEnvironment;
    const entry = {
        expiresAt: Date.now() + $4952feaf3866c161$var$PREFILTERED_REQUEST_TTL_MS,
        promise: promise
    };
    requests.set(cacheKey, entry);
    // Only evict our own entry: one that expired while in flight has already been replaced.
    const evict = ()=>{
        if (requests.get(cacheKey) === entry) requests.delete(cacheKey);
    };
    promise.then((result)=>{
        // A failed fetch resolves rather than rejects, so errors have to be read off the
        // result. On success the TTL restarts from when the data actually landed.
        if (result.errors?.length || result.extensions === null) {
            evict();
            return;
        }
        entry.expiresAt = Date.now() + $4952feaf3866c161$var$PREFILTERED_REQUEST_TTL_MS;
    }, evict);
    return promise;
};
const $4952feaf3866c161$export$f276dc1a7d0b17c5 = async ({ client: client, contextIds: contextIds, moduleType: moduleType, context: context, queryOptions: queryOptions, expandAppOwner: expandAppOwner, extensionsFilter: extensionsFilter, dataClassificationTagIds: dataClassificationTagIds, locale: locale, cloudId: cloudId, includeHidden: includeHidden, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall = false })=>{
    if (bypassNewForgeExtensionListCall === false) {
        const types = moduleType ? [
            moduleType
        ] : [];
        const requestOptions = (0, $hzmpb.createUsePrefilteredExtensionListQueryOptions)(cloudId ?? contextIds[0], context ?? {}, client, types, locale, includeHidden, queryOptions, contextIds);
        const { fetchPolicy: fetchPolicy, ...rest } = requestOptions;
        const { loading: loading, data: data, errors: errors } = await client.query({
            ...rest,
            query: (0, $2rD5H.FetchPreFilteredForgeAppsQuery),
            fetchPolicy: fetchPolicy === 'cache-and-network' ? 'network-only' : fetchPolicy
        });
        const extensions = (0, $hzmpb.getPrefilteredExtensionsGQLResult)({
            loading: loading,
            data: data
        });
        return {
            extensions: extensions,
            errors: errors
        };
    } else {
        const requestOptions = (0, $f53nH.createExtensionListQueryOptions)(client, contextIds, queryOptions, expandAppOwner, extensionsFilter, moduleType, dataClassificationTagIds, locale);
        const queryResult = await client.query(requestOptions);
        return {
            extensions: (0, $f53nH.getExtensionsFromGQLResult)(queryResult),
            errors: queryResult.errors
        };
    }
};
const $4952feaf3866c161$export$d9a2a57bbfd1461b = async ({ contextIds: contextIds, moduleType: moduleType, context: context, extensionsFilter: extensionsFilter, dataClassificationTagIds: dataClassificationTagIds, locale: locale, cloudId: cloudId, includeHidden: includeHidden, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall = false, relayEnvironment: relayEnvironment })=>{
    if (!relayEnvironment) return {
        extensions: null,
        errors: [
            new Error('Relay environment is required for getForgeUIExtensionsRelayAsync')
        ]
    };
    if (!bypassNewForgeExtensionListCall) {
        const types = moduleType ? [
            moduleType
        ] : [];
        const resolvedCloudId = cloudId ?? contextIds[0];
        const isRequestDedupeEnabled = (0, $4o0zT.isExperimentEnabled)('platform_forge_extension_list_perf');
        // Must stay in step with the `fetchQuery` variables below.
        const cacheKey = isRequestDedupeEnabled ? JSON.stringify({
            cloudId: resolvedCloudId,
            context: context ?? {},
            includeHidden: includeHidden,
            locale: locale,
            types: types
        }) : '';
        if (isRequestDedupeEnabled) {
            const dedupedRequest = $4952feaf3866c161$var$readPrefilteredRequest(relayEnvironment, cacheKey);
            if (dedupedRequest) return dedupedRequest;
        }
        const request = new Promise((resolve)=>{
            (0, $6SsN4.fetchQuery)(relayEnvironment, (0, $294ded3bdd1426fb$export$2e2bcd8739ae039), {
                cloudId: resolvedCloudId,
                // @ts-ignore - the generated types convert GQL Long to a number, which may truncate the id. The type will be changed to string
                context: context ?? {},
                includeHidden: includeHidden,
                locale: locale,
                types: types
            }, {
                networkCacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                        },
                        allowOnExternalPage: true
                    }
                }
            }).subscribe({
                next: (data)=>{
                    const extensions = (0, $hzmpb.getPrefilteredExtensionsGQLResult)({
                        data: data,
                        loading: false
                    });
                    resolve({
                        extensions: extensions
                    });
                },
                error: (error)=>{
                    resolve({
                        errors: [
                            error
                        ],
                        extensions: null
                    });
                }
            });
        });
        return isRequestDedupeEnabled ? $4952feaf3866c161$var$writePrefilteredRequest(relayEnvironment, cacheKey, request) : request;
    }
    const filter = extensionsFilter ?? [
        {
            type: 'EXTENSION_TYPE',
            value: [
                moduleType
            ]
        }
    ];
    return new Promise((resolve)=>{
        (0, $6SsN4.fetchQuery)(relayEnvironment, (0, $55c5fc9d75288b23$export$2e2bcd8739ae039), {
            contextIds: contextIds,
            locale: locale,
            filter: filter,
            dataClassificationTags: dataClassificationTagIds || []
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(contextIds.sort().join())
                    }
                }
            }
        }).subscribe({
            next: (data)=>{
                const extensions = (0, $f53nH.getExtensionsFromGQLResult)({
                    data: data,
                    loading: false
                });
                resolve({
                    extensions: extensions
                });
            },
            error: (error)=>{
                resolve({
                    errors: [
                        error
                    ],
                    extensions: null
                });
            }
        });
    });
};
module.exports["getForgeUIExtensionsRelayAsync"] = $4952feaf3866c161$export$d9a2a57bbfd1461b;

});

parcelRegister("f53nH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<48862e11f4baedbe0740559c8cb7395b>>
 * @relayHash 57ddf05e8be31435216e0057c9beb21c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bbfa50291cf702e569ab58a5d9f98f4ae8ae97b93557b250a04ec7ab73f92af8
const $8915ebf4f756438a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contextIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dataClassificationTags"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "environmentId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "environmentType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "environmentKey"
    }, v13 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v14 = {
        "kind": "ScalarField",
        "name": "type"
    }, v15 = {
        "concreteType": "AppInstallationLicense",
        "kind": "LinkedField",
        "name": "license",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "active"
            },
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "supportEntitlementNumber"
            },
            {
                "kind": "ScalarField",
                "name": "trialEndDate"
            },
            {
                "kind": "ScalarField",
                "name": "subscriptionEndDate"
            },
            {
                "kind": "ScalarField",
                "name": "isEvaluation"
            },
            {
                "kind": "ScalarField",
                "name": "billingPeriod"
            },
            {
                "kind": "ScalarField",
                "name": "ccpEntitlementId"
            },
            {
                "kind": "ScalarField",
                "name": "ccpEntitlementSlug"
            },
            {
                "kind": "ScalarField",
                "name": "capabilitySet"
            },
            {
                "kind": "ScalarField",
                "name": "modes"
            }
        ]
    }, v16 = {
        "concreteType": "UserAccess",
        "kind": "LinkedField",
        "name": "userAccess",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "enabled"
            },
            {
                "kind": "ScalarField",
                "name": "hasAccess"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "appVersion"
    }, v18 = {
        "kind": "ScalarField",
        "name": "installationId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "migrationKey"
    }, v20 = {
        "concreteType": "EcosystemAppInstallationConfigExtension",
        "kind": "LinkedField",
        "name": "installationConfig",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v21 = {
        "concreteType": "AppNetworkEgressPermissionExtension",
        "kind": "LinkedField",
        "name": "egress",
        "plural": true,
        "selections": [
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "addresses"
            },
            {
                "kind": "ScalarField",
                "name": "category"
            },
            {
                "kind": "ScalarField",
                "name": "inScopeEUD"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "sandboxPolicies"
    }, v23 = {
        "kind": "ScalarField",
        "name": "scopes"
    }, v24 = {
        "kind": "ScalarField",
        "name": "consentUrl"
    }, v25 = {
        "concreteType": "UserConsentExtension",
        "kind": "LinkedField",
        "name": "currentUserConsent",
        "plural": false,
        "selections": [
            {
                "concreteType": "UserConsentExtensionUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "aaid"
                    }
                ]
            },
            {
                "concreteType": "UserConsentExtensionAppEnvironmentVersion",
                "kind": "LinkedField",
                "name": "appEnvironmentVersion",
                "plural": false,
                "selections": [
                    v5 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "consentedAt"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "requiresUserConsent"
    }, v27 = {
        "args": [
            {
                "fields": [
                    {
                        "kind": "Variable",
                        "name": "dataClassificationTags",
                        "variableName": "dataClassificationTags"
                    }
                ],
                "kind": "ObjectValue",
                "name": "input"
            }
        ],
        "concreteType": "DataClassificationPolicyDecision",
        "kind": "LinkedField",
        "name": "dataClassificationPolicyDecision",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useExtensionList_forge_ui_Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "appOwner",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v14 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useExtensionList_forge_ui_Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "appOwner",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v9 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v14 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bbfa50291cf702e569ab58a5d9f98f4ae8ae97b93557b250a04ec7ab73f92af8",
            "metadata": {},
            "name": "useExtensionList_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8915ebf4f756438a$var$node.hash = "742e063d2685767c4281c7c87cca5034";
var $8915ebf4f756438a$export$2e2bcd8739ae039 = $8915ebf4f756438a$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $7EPz1 = parcelRequire("7EPz1");


var $ix7El = parcelRequire("ix7El");


var $DIyeF = parcelRequire("DIyeF");


var $2rD5H = parcelRequire("2rD5H");


var $9DHhW = parcelRequire("9DHhW");


var $852mP = parcelRequire("852mP");


var $4K6lC = parcelRequire("4K6lC");


var $iGKcz = parcelRequire("iGKcz");

const $dbb9d53e07431a8a$export$73c0408abd298d1b = (client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale, ssr = false)=>{
    const variables = filter ? {
        contextIds: contextIds,
        locale: locale,
        filter: filter
    } : {
        contextIds: contextIds,
        locale: locale,
        type: extensionType
    };
    const query = filter ? (0, $2rD5H.getExtensionListQuery)(expandAppOwner, dataClassificationTagIds) : (0, $2rD5H.getExtensionListQueryOld)(expandAppOwner, undefined, dataClassificationTagIds);
    // In SSR mode render and fetch is one-pass we can't do cache-and-network
    if (ssr && queryOptions?.fetchPolicy === 'cache-and-network') queryOptions.fetchPolicy = 'cache-first';
    return {
        variables: variables,
        ...queryOptions,
        query: query,
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(contextIds.sort().join())
            }
        }
    };
};
const $dbb9d53e07431a8a$export$1e6dc3c07340999 = ({ loading: loading, data: data })=>{
    if (!loading && data && data.extensionContexts && data.extensionContexts[0]) {
        if ('extensions' in data.extensionContexts[0]) // @ts-ignore
        return data.extensionContexts[0].extensions ?? null;
        else if ('extensionsByType' in data.extensionContexts[0]) return data.extensionContexts[0].extensionsByType ?? null;
    }
    return null;
};
const $dbb9d53e07431a8a$export$cab421e039d23b2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { contextIds: contextIds, type: extensionType, filter: filter, client: client, queryOptions: queryOptions, expandAppOwner: expandAppOwner, dataClassificationTagIds: dataClassificationTagIds, locale: locale } = t0;
    let t1;
    if ($[0] !== client || $[1] !== contextIds || $[2] !== dataClassificationTagIds || $[3] !== expandAppOwner || $[4] !== extensionType || $[5] !== filter || $[6] !== locale || $[7] !== queryOptions) {
        t1 = $dbb9d53e07431a8a$export$73c0408abd298d1b(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale);
        $[0] = client;
        $[1] = contextIds;
        $[2] = dataClassificationTagIds;
        $[3] = expandAppOwner;
        $[4] = extensionType;
        $[5] = filter;
        $[6] = locale;
        $[7] = queryOptions;
        $[8] = t1;
    } else t1 = $[8];
    const requestOptions = t1;
    let t2;
    if ($[9] !== expandAppOwner || $[10] !== filter) {
        t2 = filter ? (0, $2rD5H.getExtensionListQuery)(expandAppOwner) : (0, $2rD5H.getExtensionListQueryOld)(expandAppOwner);
        $[9] = expandAppOwner;
        $[10] = filter;
        $[11] = t2;
    } else t2 = $[11];
    const query = t2;
    const { error: error, loading: loading, data: data } = (0, $7EPz1.useQuery)(requestOptions.query || query, requestOptions);
    let t3;
    if ($[12] !== data || $[13] !== loading) {
        t3 = $dbb9d53e07431a8a$export$1e6dc3c07340999({
            loading: loading,
            data: data
        });
        $[12] = data;
        $[13] = loading;
        $[14] = t3;
    } else t3 = $[14];
    const extensions = t3;
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t4;
    let t5;
    if ($[15] !== createAnalyticsEvent || $[16] !== extensions || $[17] !== page) {
        t4 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "useExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t5 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[15] = createAnalyticsEvent;
        $[16] = extensions;
        $[17] = page;
        $[18] = t4;
        $[19] = t5;
    } else {
        t4 = $[18];
        t5 = $[19];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[20] !== createAnalyticsEvent || $[21] !== error || $[22] !== extensions || $[23] !== page) {
        t6 = ()=>{
            if (!extensions && error && error.graphQLErrors.length > 0) {
                const err_0 = error.graphQLErrors.find($dbb9d53e07431a8a$var$_temp);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "useExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t7 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[20] = createAnalyticsEvent;
        $[21] = error;
        $[22] = extensions;
        $[23] = page;
        $[24] = t6;
        $[25] = t7;
    } else {
        t6 = $[24];
        t7 = $[25];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[26] !== extensions) {
        t8 = extensions || [];
        $[26] = extensions;
        $[27] = t8;
    } else t8 = $[27];
    let t9;
    if ($[28] !== error || $[29] !== loading || $[30] !== t8) {
        t9 = {
            error: error,
            extensions: t8,
            loading: loading
        };
        $[28] = error;
        $[29] = loading;
        $[30] = t8;
        $[31] = t9;
    } else t9 = $[31];
    return t9;
} : ({ contextIds: contextIds, type: extensionType, filter: filter, client: client, queryOptions: queryOptions, expandAppOwner: expandAppOwner, dataClassificationTagIds: dataClassificationTagIds, locale: locale })=>{
    const requestOptions = $dbb9d53e07431a8a$export$73c0408abd298d1b(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale);
    const query = filter ? (0, $2rD5H.getExtensionListQuery)(expandAppOwner) : (0, $2rD5H.getExtensionListQueryOld)(expandAppOwner);
    const { error: error, loading: loading, data: data } = (0, $7EPz1.useQuery)(requestOptions.query || query, requestOptions);
    const extensions = $dbb9d53e07431a8a$export$1e6dc3c07340999({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'useExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err_0 = error.graphQLErrors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $dbb9d53e07431a8a$export$73b3e0afa63af44a = ({ contextIds: contextIds, type: extensionType, filter: extensionFilter, dataClassificationTagIds: dataClassificationTagIds, locale: locale, queryOptions: queryOptions })=>{
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const environment = (0, $6SsN4.useRelayEnvironment)();
    // Context ids only ever contains a single id.
    // Extract out the id so that the useEffect dependency is a string instead of an array
    const contextId = contextIds[0];
    const shouldSkip = queryOptions?.skip;
    const stringifiedFilter = JSON.stringify(extensionFilter);
    const filter = (0, $cozmU.useMemo)(()=>{
        return extensionFilter ?? [
            {
                type: 'EXTENSION_TYPE',
                value: [
                    extensionType
                ]
            }
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stringifiedFilter,
        extensionType
    ]);
    (0, $cozmU.useEffect)(()=>{
        const contextIds = [
            contextId
        ];
        if (!shouldSkip) (0, $6SsN4.fetchQuery)(environment, (0, $8915ebf4f756438a$export$2e2bcd8739ae039), {
            contextIds: contextIds,
            locale: locale,
            filter: filter,
            dataClassificationTags: dataClassificationTagIds || []
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(contextIds.sort().join())
                    }
                }
            }
        }).subscribe({
            next: (data)=>{
                const extensions = $dbb9d53e07431a8a$export$1e6dc3c07340999({
                    data: data,
                    loading: false
                });
                if (extensions) createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: 'succeeded',
                        actionSubject: 'forge.ui.webClient',
                        source: page,
                        tags: [
                            'forge'
                        ],
                        attributes: {
                            target: 'useExtensionList'
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
                setExtensions(extensions);
                setLoading(false);
            },
            error: (error)=>{
                setError(error);
                setLoading(false);
            }
        });
    }, [
        shouldSkip,
        contextId,
        filter,
        extensionType,
        locale,
        dataClassificationTagIds,
        environment,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
            const err = error.source.errors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err ? (0, $ix7El.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        extensions: extensions || [],
        loading: loading,
        error: error
    };
};
function $dbb9d53e07431a8a$var$_temp(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
module.exports["createExtensionListQueryOptions"] = $dbb9d53e07431a8a$export$73c0408abd298d1b;
module.exports["getExtensionsFromGQLResult"] = $dbb9d53e07431a8a$export$1e6dc3c07340999;
module.exports["useExtensionListRelay"] = $dbb9d53e07431a8a$export$73b3e0afa63af44a;

});

parcelRegister("hjngh", function(module, exports) {
const $5e5662d7b589cb97$export$a728e3e4d9df1392 = ()=>{
    if (!performance) return 0;
    return Math.trunc(performance.now());
};
module.exports["getPerformanceMark"] = $5e5662d7b589cb97$export$a728e3e4d9df1392;

});

parcelRegister("3nNWm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $fFIqL = parcelRequire("fFIqL");


var $iDrrr = parcelRequire("iDrrr");


var $87Lnp = parcelRequire("87Lnp");

const $335533cea19db929$export$8da39d297b8df514 = (0, $87Lnp.z).object({
    event: (0, $87Lnp.z).literal('click')
}).strip();
const $335533cea19db929$export$1226cd123c17e5c1 = (0, $87Lnp.z).object({
    event: (0, $87Lnp.z).literal('navigation-timing'),
    transferSize: (0, $87Lnp.z).number().nonnegative().finite(),
    duration: (0, $87Lnp.z).number().nonnegative().finite()
}).strict();
const $335533cea19db929$var$initiatorTypeValues = (0, $87Lnp.z).enum([
    'script',
    'fetch',
    'css',
    'link',
    'iframe',
    'img',
    'image',
    'xmlhttprequest',
    'other'
]);
const $335533cea19db929$export$53d51f558d70545c = (0, $87Lnp.z).object({
    event: (0, $87Lnp.z).literal('resource-timing'),
    start: (0, $87Lnp.z).number().nonnegative().finite(),
    duration: (0, $87Lnp.z).number().nonnegative().finite(),
    transferSize: (0, $87Lnp.z).number().nonnegative().finite(),
    initiatorType: (0, $87Lnp.z).string().pipe($335533cea19db929$var$initiatorTypeValues.catch($335533cea19db929$var$initiatorTypeValues.Values.other)).pipe((0, $87Lnp.z).string())
}).strict();
const $335533cea19db929$export$dcaedcbfb2a9bf04 = (0, $87Lnp.z).object({
    event: (0, $87Lnp.z).literal('dcls-score'),
    score: (0, $87Lnp.z).number().nonnegative().finite(),
    timestamp: (0, $87Lnp.z).number().nonnegative().finite(),
    inputFlag: (0, $87Lnp.z).boolean()
}).strict();
const $335533cea19db929$export$ea631521a752c0a8 = (0, $87Lnp.z).object({
    event: (0, $87Lnp.z).literal('fcp-snapshot'),
    start: (0, $87Lnp.z).number().nonnegative().finite()
}).strict();
const $335533cea19db929$export$23e438485c66108 = (0, $87Lnp.z).object({
    event: (0, $87Lnp.z).literal('lcp-snapshot'),
    size: (0, $87Lnp.z).number().nonnegative().finite(),
    start: (0, $87Lnp.z).number().nonnegative().finite()
}).strict();
const $335533cea19db929$var$serialisableValueSchema = (0, $87Lnp.z).lazy(()=>(0, $87Lnp.z).union([
        (0, $87Lnp.z).string(),
        (0, $87Lnp.z).number().finite(),
        (0, $87Lnp.z).boolean(),
        (0, $87Lnp.z).null(),
        (0, $87Lnp.z).array($335533cea19db929$var$serialisableValueSchema),
        (0, $87Lnp.z).record((0, $87Lnp.z).string(), $335533cea19db929$var$serialisableValueSchema)
    ]));
const $335533cea19db929$export$a4b565c65b9cd65 = (0, $87Lnp.z).object({
    event: (0, $87Lnp.z).literal('ufo-event'),
    name: (0, $87Lnp.z).string().min(1).max(256),
    payload: (0, $87Lnp.z).record((0, $87Lnp.z).string(), $335533cea19db929$var$serialisableValueSchema)
}).strict();
const $335533cea19db929$export$d659b0ed364a2533 = (0, $87Lnp.z).discriminatedUnion('event', [
    $335533cea19db929$export$8da39d297b8df514,
    $335533cea19db929$export$1226cd123c17e5c1,
    $335533cea19db929$export$53d51f558d70545c,
    $335533cea19db929$export$dcaedcbfb2a9bf04,
    $335533cea19db929$export$ea631521a752c0a8,
    $335533cea19db929$export$23e438485c66108,
    $335533cea19db929$export$a4b565c65b9cd65
]);



var $hjngh = parcelRequire("hjngh");

const $2f158b61d423d2ba$var$ClickedProfilingCapturableEventTransform = (0, $335533cea19db929$export$8da39d297b8df514).transform((_)=>{
    return {
        type: 'user-interacted',
        elapsed: (0, $hjngh.getPerformanceMark)()
    };
});
const $2f158b61d423d2ba$var$NavigationTimingProfilingCapturableEventTransform = (0, $335533cea19db929$export$1226cd123c17e5c1).transform((e)=>{
    return {
        type: 'navigation-timing',
        elapsed: (0, $hjngh.getPerformanceMark)(),
        duration: Math.trunc(e.duration),
        transferSize: e.transferSize
    };
});
const $2f158b61d423d2ba$var$ResourceTimingProfilingCapturableEventTransform = (0, $335533cea19db929$export$53d51f558d70545c).transform((e)=>{
    return {
        type: 'resource-timing',
        elapsed: (0, $hjngh.getPerformanceMark)(),
        start: Math.trunc(e.start),
        duration: Math.trunc(e.duration),
        transferSize: Math.trunc(e.transferSize),
        initiatorType: e.initiatorType
    };
});
const $2f158b61d423d2ba$var$LayoutShiftProfilingCapturableEventTransform = (0, $335533cea19db929$export$dcaedcbfb2a9bf04).transform((e)=>{
    return {
        type: 'dcls-score',
        elapsed: (0, $hjngh.getPerformanceMark)(),
        timestamp: Math.trunc(e.timestamp),
        // Transport 2dp truncated to avoid precision errors.
        score: Math.trunc(e.score * 100),
        inputFlag: e.inputFlag
    };
});
const $2f158b61d423d2ba$var$FCPProfilingCapturableEventTransform = (0, $335533cea19db929$export$ea631521a752c0a8).transform((e)=>{
    return {
        type: 'fcp-snapshot',
        elapsed: (0, $hjngh.getPerformanceMark)(),
        start: Math.trunc(e.start)
    };
});
const $2f158b61d423d2ba$var$LCPProfilingCapturableEventTransform = (0, $335533cea19db929$export$23e438485c66108).transform((e)=>{
    return {
        type: 'lcp-snapshot',
        elapsed: (0, $hjngh.getPerformanceMark)(),
        start: Math.trunc(e.start),
        size: Math.trunc(e.size)
    };
});
const $2f158b61d423d2ba$var$UFOFrameCapturableEventTransform = (0, $335533cea19db929$export$a4b565c65b9cd65).transform((e)=>({
        type: 'ufo-event',
        elapsed: (0, $hjngh.getPerformanceMark)(),
        name: e.name,
        payload: e.payload
    }));
// For each in-frame event type, there should be a transformer to a safely ingestible event.
const $2f158b61d423d2ba$var$transformers = {
    'navigation-timing': $2f158b61d423d2ba$var$NavigationTimingProfilingCapturableEventTransform,
    'resource-timing': $2f158b61d423d2ba$var$ResourceTimingProfilingCapturableEventTransform,
    'dcls-score': $2f158b61d423d2ba$var$LayoutShiftProfilingCapturableEventTransform,
    click: $2f158b61d423d2ba$var$ClickedProfilingCapturableEventTransform,
    'fcp-snapshot': $2f158b61d423d2ba$var$FCPProfilingCapturableEventTransform,
    'lcp-snapshot': $2f158b61d423d2ba$var$LCPProfilingCapturableEventTransform,
    'ufo-event': $2f158b61d423d2ba$var$UFOFrameCapturableEventTransform
};
const $2f158b61d423d2ba$export$d85e1d6e65aaba29 = (0, $335533cea19db929$export$d659b0ed364a2533).transform((e)=>$2f158b61d423d2ba$var$transformers[e.event].parse(e));


const $3ab307814f394ecf$export$a8c9835719b09864 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const timelineRef = (0, $cozmU.useContext)((0, $fFIqL.PerformanceAnalyticsContext));
    let t0;
    if ($[0] !== timelineRef) {
        t0 = (event)=>{
            if (!(0, $iDrrr.fg)("forge-ui-app-perf-tracking-enabled") || !timelineRef?.current) return;
            timelineRef.current.events.push(event);
            timelineRef.current.listeners.forEach((listener)=>listener(event));
        };
        $[0] = timelineRef;
        $[1] = t0;
    } else t0 = $[1];
    const captureEvent = t0;
    let t1;
    if ($[2] !== captureEvent) {
        t1 = (event_0)=>{
            if (!(0, $iDrrr.fg)("forge-ui-app-perf-tracking-enabled")) return;
            const result = (0, $2f158b61d423d2ba$export$d85e1d6e65aaba29).safeParse(event_0);
            if (!result.success) return;
            captureEvent(result.data);
        };
        $[2] = captureEvent;
        $[3] = t1;
    } else t1 = $[3];
    const captureUntrustedEvent = t1;
    let t2;
    if ($[4] !== captureEvent || $[5] !== captureUntrustedEvent) {
        t2 = {
            captureEvent: captureEvent,
            captureUntrustedEvent: captureUntrustedEvent
        };
        $[4] = captureEvent;
        $[5] = captureUntrustedEvent;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const timelineRef = (0, $cozmU.useContext)((0, $fFIqL.PerformanceAnalyticsContext));
    // Use for out-of-frame capture in platform code.
    const captureEvent = (0, $cozmU.useCallback)((event)=>{
        if (!(0, $iDrrr.fg)('forge-ui-app-perf-tracking-enabled') || !timelineRef?.current) return;
        timelineRef.current.events.push(event);
        timelineRef.current.listeners.forEach((listener)=>listener(event));
    }, [
        timelineRef
    ]);
    // Use for capturing events from untrusted sources (e.g. in-frame via bridge).
    const captureUntrustedEvent = (0, $cozmU.useCallback)((event_0)=>{
        if (!(0, $iDrrr.fg)('forge-ui-app-perf-tracking-enabled')) return;
        const result = (0, $2f158b61d423d2ba$export$d85e1d6e65aaba29).safeParse(event_0);
        if (!result.success) // TODO: log failed validations to detect contract mismatches/tampering.
        return;
        captureEvent(result.data);
    }, [
        captureEvent
    ]);
    return {
        captureEvent: captureEvent,
        captureUntrustedEvent: captureUntrustedEvent
    };
};
module.exports["usePerformanceAnalytics"] = $3ab307814f394ecf$export$a8c9835719b09864;

});

parcelRegister("iUEMs", function(module, exports) {

var $1uMa2 = parcelRequire("1uMa2");

const $529ca3c9f76ba8d6$var$EMIT_READY_EVENT_NAME = 'EXTENSION_READY';
const $529ca3c9f76ba8d6$var$UPDATE_BYLINE_ITEM_EVENT_NAME = 'FORGE_CONTENT_PROPERTY_UPDATED';
const $529ca3c9f76ba8d6$export$7691e780388a0497 = (eventKey, eventName)=>{
    if (!eventName) return false;
    return eventKey === 'emit' && !(eventName === $529ca3c9f76ba8d6$var$EMIT_READY_EVENT_NAME || eventName === $529ca3c9f76ba8d6$var$UPDATE_BYLINE_ITEM_EVENT_NAME);
};
const $529ca3c9f76ba8d6$export$b0842aa1e96f4de = (eventKey, dataToForward, postRobotSend, embeddedParentLocalId, extensionDetails)=>async ({ data: data })=>{
        // emitReadyEvent method calls the event method and also the actual emitReadyEvent method.
        // In use bridge we have 'emit' method and 'emitReadyEvent' method
        // This is referring to the former. For the latter, event key will be 'emitReadyEvent'
        if ($529ca3c9f76ba8d6$export$7691e780388a0497(eventKey, data?.event)) {
            // Emit event as usual unless it is emitReadyEvent or updateBylineProperties event
            (0, $1uMa2.emit)(data?.event, data?.payload, extensionDetails);
            return;
        }
        if (!postRobotSend || !embeddedParentLocalId) return;
        // This would need to be changed if we want to support multiple nesting levels
        const targetWindow = window.parent?.parent;
        if (!targetWindow || targetWindow === window) return;
        // Only forward to same hostname as FAUS for security (allow different ports for local dev)
        const targetDomain = `${window.location.protocol}//${window.location.hostname}`;
        // Check if data is an object or not.
        // E.g. updateMacroContent method's data is a type string.
        const originalPayload = typeof data === 'object' ? data : {
            data: data
        };
        const forwardedData = {
            eventKey: eventKey,
            ...dataToForward,
            ...originalPayload
        };
        try {
            const { data: data } = await postRobotSend(targetWindow, `messageFromEmbeddedFAUS_${embeddedParentLocalId}`, forwardedData, {
                domain: targetDomain
            });
            return data;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Failed to forward ${eventKey} to product:`, error);
        }
    };
module.exports["createMessageForwarder"] = $529ca3c9f76ba8d6$export$b0842aa1e96f4de;

});

parcelRegister("67Hav", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $852mP = parcelRequire("852mP");


var $jAjCC = parcelRequire("jAjCC");


var $aRGok = parcelRequire("aRGok");


var $4K6lC = parcelRequire("4K6lC");


var $c71c0 = parcelRequire("c71c0");


var $4POBX = parcelRequire("4POBX");


var $jQNFO = parcelRequire("jQNFO");


var $gFIer = parcelRequire("gFIer");


var $4El6d = parcelRequire("4El6d");


var $eKJPK = parcelRequire("eKJPK");


var $bEbDR = parcelRequire("bEbDR");

function $a3eff5cab67948a0$export$1702c47678c18fa6({ appId: appId, extension: extension }) {
    if (appId) return appId;
    if (extension.appId) return extension.appId;
    if (extension.id) try {
        return (0, $bEbDR.parseExtensionId)(extension.id).appId;
    } catch  {
        return undefined;
    }
    return undefined;
}
const $a3eff5cab67948a0$export$d0fd4b7106de2769 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useNavigation(t0) {
    const $ = (0, $bDgLe.c)(17);
    const { extension: extension, push: push, appId: appId, onNavigate: onNavigate, openNewTabAsPopupWindow: openNewTabAsPopupWindow } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            state: "closed"
        };
        $[0] = t1;
    } else t1 = $[0];
    const [modalState, setModalState] = (0, $cozmU.useState)(t1);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const egressService = (0, $gFIer.useEgressPermissionService)("FETCH_CLIENT_SIDE", extension.egress);
    let t2;
    if ($[1] !== appId || $[2] !== extension) {
        t2 = $a3eff5cab67948a0$export$1702c47678c18fa6({
            appId: appId,
            extension: extension
        });
        $[1] = appId;
        $[2] = extension;
        $[3] = t2;
    } else t2 = $[3];
    const resolvedAppId = t2;
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== egressService || $[6] !== onNavigate || $[7] !== openNewTabAsPopupWindow || $[8] !== push || $[9] !== resolvedAppId) {
        t3 = async (t4)=>{
            const { type: type, url: urlString } = t4;
            const url = (0, $4El6d.makeUrl)(urlString);
            const linkType = $a3eff5cab67948a0$export$8071740a02e53ce2(url, egressService);
            if (linkType === "invalid" || !url) throw new (0, $c71c0.BridgeClientError)(`link is invalid: ${urlString}`);
            if (linkType === "trusted") {
                onNavigate?.({
                    type: type,
                    url: url.href
                });
                (0, $4POBX.navigate)(url.href, type, push, resolvedAppId, openNewTabAsPopupWindow);
                return;
            }
            const analyticsAttributes = $a3eff5cab67948a0$export$e748b6351ba5f204(url);
            return new Promise((resolve, reject)=>{
                createAnalyticsEvent({
                    eventType: (0, $852mP.UI_EVENT_TYPE),
                    data: {
                        action: "viewed",
                        actionSubject: "externalLinkModal",
                        attributes: analyticsAttributes
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
                setModalState({
                    state: "open",
                    url: url,
                    onConfirm: ()=>{
                        onNavigate?.({
                            type: type,
                            url: url.href
                        });
                        (0, $4POBX.navigate)(url.href, type, push, resolvedAppId, openNewTabAsPopupWindow);
                        createAnalyticsEvent({
                            eventType: (0, $852mP.UI_EVENT_TYPE),
                            data: {
                                action: "approved",
                                actionSubject: "externalLinkModal",
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
                        resolve();
                    },
                    onCancel: ()=>{
                        createAnalyticsEvent({
                            eventType: (0, $852mP.UI_EVENT_TYPE),
                            data: {
                                action: "cancelled",
                                actionSubject: "externalLinkModal",
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
                        reject(new (0, $c71c0.BridgeClientError)("cancelled"));
                    }
                });
            });
        };
        $[4] = createAnalyticsEvent;
        $[5] = egressService;
        $[6] = onNavigate;
        $[7] = openNewTabAsPopupWindow;
        $[8] = push;
        $[9] = resolvedAppId;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== extension.properties?.title || $[12] !== modalState) {
        t4 = ()=>{
            if (modalState.state === "closed") return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null);
            return /*#__PURE__*/ $cozmU.createElement((0, $jAjCC.ExternalLinkModal), {
                url: modalState.url,
                extensionTitle: extension.properties?.title,
                onCancel: ()=>{
                    setModalState({
                        state: "closed"
                    });
                    modalState.onCancel();
                },
                onConfirm: ()=>{
                    modalState.onConfirm();
                    setModalState({
                        state: "closed"
                    });
                }
            });
        };
        $[11] = extension.properties?.title;
        $[12] = modalState;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== t3 || $[15] !== t4) {
        t5 = {
            onNavigate: t3,
            getModalJsx: t4
        };
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : function useNavigation({ extension: extension, push: push, appId: appId, onNavigate: onNavigate, openNewTabAsPopupWindow: openNewTabAsPopupWindow }) {
    const [modalState, setModalState] = (0, $cozmU.useState)({
        state: 'closed'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const egressService = (0, $gFIer.useEgressPermissionService)('FETCH_CLIENT_SIDE', extension.egress);
    const resolvedAppId = $a3eff5cab67948a0$export$1702c47678c18fa6({
        appId: appId,
        extension: extension
    });
    return {
        onNavigate: async ({ type: type, url: urlString })=>{
            const url = (0, $4El6d.makeUrl)(urlString);
            const linkType = $a3eff5cab67948a0$export$8071740a02e53ce2(url, egressService);
            if (linkType === 'invalid' || !url) throw new (0, $c71c0.BridgeClientError)(`link is invalid: ${urlString}`);
            if (linkType === 'trusted') {
                onNavigate?.({
                    type: type,
                    url: url.href
                });
                (0, $4POBX.navigate)(url.href, type, push, resolvedAppId, openNewTabAsPopupWindow);
                return;
            }
            const analyticsAttributes = $a3eff5cab67948a0$export$e748b6351ba5f204(url);
            return new Promise((resolve, reject)=>{
                // TODO: remove this event once we have switched over to the new event schema
                // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                createAnalyticsEvent({
                    eventType: (0, $852mP.UI_EVENT_TYPE),
                    data: {
                        action: 'viewed',
                        actionSubject: 'externalLinkModal',
                        attributes: analyticsAttributes
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
                setModalState({
                    state: 'open',
                    url: url,
                    onConfirm: ()=>{
                        onNavigate?.({
                            type: type,
                            url: url.href
                        });
                        (0, $4POBX.navigate)(url.href, type, push, resolvedAppId, openNewTabAsPopupWindow);
                        // TODO: remove this event once we have switched over to the new event schema
                        // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                        createAnalyticsEvent({
                            eventType: (0, $852mP.UI_EVENT_TYPE),
                            data: {
                                action: 'approved',
                                actionSubject: 'externalLinkModal',
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
                        resolve();
                    },
                    onCancel: ()=>{
                        // TODO: remove this event once we have switched over to the new event schema
                        // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                        createAnalyticsEvent({
                            eventType: (0, $852mP.UI_EVENT_TYPE),
                            data: {
                                action: 'cancelled',
                                actionSubject: 'externalLinkModal',
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
                        reject(new (0, $c71c0.BridgeClientError)('cancelled'));
                    }
                });
            });
        },
        getModalJsx: ()=>{
            if (modalState.state === 'closed') return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null);
            return /*#__PURE__*/ $cozmU.createElement((0, $jAjCC.ExternalLinkModal), {
                url: modalState.url,
                extensionTitle: extension.properties?.title,
                onCancel: ()=>{
                    setModalState({
                        state: 'closed'
                    });
                    modalState.onCancel();
                },
                onConfirm: ()=>{
                    modalState.onConfirm();
                    setModalState({
                        state: 'closed'
                    });
                }
            });
        }
    };
};
const $a3eff5cab67948a0$var$getRootDomain = (url)=>{
    const hostnameParts = url.hostname.split('.'); // Root domain consists of the last two parts of the hostname
    if (hostnameParts.length > 1) return hostnameParts.slice(-2).join('.');
    else // If there's only one part, return it (e.g., 'localhost')
    return url.hostname;
};
function $a3eff5cab67948a0$export$8071740a02e53ce2(url, egressService) {
    if (!url) return 'invalid';
    if (url.protocol === 'mailto:') return 'trusted';
    if (url.protocol === 'tel:') return 'trusted';
    try {
        // URL is listed under permissions in manifest
        if (egressService.isValidUrl(url.href)) return 'trusted';
         // URL is from same origin
        if (url.origin === (0, $jQNFO.getOrigin)()) return 'trusted';
         // URL is under a trusted atlassian domain
        const rootDomain = $a3eff5cab67948a0$var$getRootDomain(url);
        if ((0, $eKJPK.TRUSTED_ROOT_DOMAINS).includes(rootDomain)) return 'trusted';
        if ([
            'https:',
            'http:'
        ].includes(url.protocol)) return 'external';
    } catch  {}
    return 'invalid';
}
function $a3eff5cab67948a0$export$e748b6351ba5f204(url) {
    // Don't count the initial `?` in the query string length.
    const queryStringSize = url.search.length > 1 ? url.search.length - 1 : 0;
    return {
        url: url.href,
        queryStringSize: queryStringSize
    };
}
module.exports["resolveNavigationAppId"] = $a3eff5cab67948a0$export$1702c47678c18fa6;
module.exports["useNavigation"] = $a3eff5cab67948a0$export$d0fd4b7106de2769;
module.exports["getLinkType"] = $a3eff5cab67948a0$export$8071740a02e53ce2;
module.exports["getAnalyticsAttributes"] = $a3eff5cab67948a0$export$e748b6351ba5f204;

});

parcelRegister("gFIer", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b9C7C = parcelRequire("b9C7C");

const $490cd81d9317870d$export$440f6339165c68d2 = (permissionType, egress)=>{
    const egressUrls = (egress || []).find((permission)=>permission.type === permissionType);
    const allowedUrls = egressUrls ? egressUrls.addresses : [];
    return new (0, $b9C7C.EgressFilteringService)(allowedUrls);
};
const $490cd81d9317870d$export$8a0b6b45ac3015d5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (permissionType, egress)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== egress || $[1] !== permissionType) {
        t0 = $490cd81d9317870d$export$440f6339165c68d2(permissionType, egress);
        $[0] = egress;
        $[1] = permissionType;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (permissionType, egress)=>{
    return (0, $cozmU.useMemo)(()=>{
        return $490cd81d9317870d$export$440f6339165c68d2(permissionType, egress);
    }, [
        permissionType,
        egress
    ]);
};
module.exports["egressPermissionService"] = $490cd81d9317870d$export$440f6339165c68d2;
module.exports["useEgressPermissionService"] = $490cd81d9317870d$export$8a0b6b45ac3015d5;

});

parcelRegister("iBPxh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fbwmZ = parcelRequire("fbwmZ");


$fbwmZ.__exportStar((parcelRequire("flUWt")), module.exports);

$fbwmZ.__exportStar((parcelRequire("32nKa")), module.exports);

$fbwmZ.__exportStar((parcelRequire("i4tAX")), module.exports);

});

parcelRegister("flUWt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EgressFilteringService = void 0;

var $32nKa = parcelRequire("32nKa");


var $i4tAX = parcelRequire("i4tAX");

class $b2d4fcb2864d4bb7$var$EgressFilteringService {
    parseUrl(url) {
        return (0, $32nKa.parseUrl)(url);
    }
    containsWildCardEgress() {
        return this.allowsEverything;
    }
    isValidUrl(url) {
        if (this.allowsEverything) return true;
        const parsedUrl = this.parseUrl(url);
        return this.allowedDomainExact(parsedUrl, this.URLs) || this.allowedDomainPattern(parsedUrl, this.wildcardDomains);
    }
    allowedDomainExact(domain, allowList) {
        return allowList.filter((allowed)=>allowed.protocol === domain.protocol).some((url)=>url.hostname === domain.hostname);
    }
    allowedDomainPattern(domain, allowList) {
        return allowList.filter((allowed)=>allowed.protocol === domain.protocol).some((pattern)=>pattern.regex.test(domain.hostname));
    }
    constructor(allowList){
        this.URLs = allowList.filter((domainOrURL)=>!domainOrURL.startsWith('*')).map((url)=>this.parseUrl(url));
        this.wildcardDomains = allowList.filter((domainOrURL)=>domainOrURL !== '*').map((url)=>this.parseUrl(url)).filter((url)=>decodeURIComponent(url.hostname).startsWith('*')).map((url)=>({
                ...url,
                regex: (0, $i4tAX.globToRegex)(decodeURIComponent(url.hostname))
            }));
        this.allowsEverything = allowList.includes('*');
    }
}
module.exports.EgressFilteringService = $b2d4fcb2864d4bb7$var$EgressFilteringService;

});

parcelRegister("32nKa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseUrl = void 0;
function $2363f9f86634754e$var$parseUrl(url) {
    var _a, _b;
    const protocol = (_b = (_a = url.match(/^(.*?:)/)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : 'https:';
    const hostname = url.replace(protocol, '').replace(/^\/*/, '').replace(/^\\*/, '').split(/[\?\/]/)[0];
    return {
        protocol: protocol,
        hostname: hostname
    };
}
module.exports.parseUrl = $2363f9f86634754e$var$parseUrl;

});

parcelRegister("i4tAX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEgressesBasedOnToggles = module.exports.sortAndGroupEgressPermissionsByDomain = module.exports.EgressCategory = module.exports.EgressType = module.exports.globToRegex = void 0;

var $32nKa = parcelRequire("32nKa");

function $d27f8eb59492376d$var$globToRegex(pattern) {
    const escaped = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&');
    const regexPattern = escaped.replace(/\*/g, '.*');
    return new RegExp(`^${regexPattern}$`);
}
module.exports.globToRegex = $d27f8eb59492376d$var$globToRegex;
const $d27f8eb59492376d$var$sortAndGroupEgressPermissionsByDomain = (egressAddresses)=>{
    if ((egressAddresses === null || egressAddresses === void 0 ? void 0 : egressAddresses.length) === 0) return [];
    const protocolRegex = /^(.*?:\/\/)/;
    const domains = new Set();
    const wildcardDomains = [];
    egressAddresses.forEach((item)=>{
        const itemWithProtocol = protocolRegex.test(item) ? item : `https://${item}`;
        const url = (0, $32nKa.parseUrl)(itemWithProtocol);
        if (url.hostname.startsWith('*')) {
            domains.add(url.hostname.substring(2));
            wildcardDomains.push($d27f8eb59492376d$var$globToRegex(url.hostname));
        } else domains.add(url.hostname);
    });
    return [
        ...domains
    ].sort().reduce((grouped, domain)=>{
        if (!wildcardDomains.some((pattern)=>pattern.test(domain))) grouped.push(domain);
        return grouped;
    }, []);
};
module.exports.sortAndGroupEgressPermissionsByDomain = $d27f8eb59492376d$var$sortAndGroupEgressPermissionsByDomain;
var $d27f8eb59492376d$var$EgressType;
(function(EgressType) {
    EgressType["FetchBackendSide"] = "FETCH_BACKEND_SIDE";
    EgressType["FetchClientSide"] = "FETCH_CLIENT_SIDE";
    EgressType["Fonts"] = "FONTS";
    EgressType["Frames"] = "FRAMES";
    EgressType["Images"] = "IMAGES";
    EgressType["Media"] = "MEDIA";
    EgressType["Navigation"] = "NAVIGATION";
    EgressType["Scripts"] = "SCRIPTS";
    EgressType["Styles"] = "STYLES";
})($d27f8eb59492376d$var$EgressType = module.exports.EgressType || (module.exports.EgressType = {}));
var $d27f8eb59492376d$var$EgressCategory;
(function(EgressCategory) {
    EgressCategory["ANALYTICS"] = "ANALYTICS";
})($d27f8eb59492376d$var$EgressCategory = module.exports.EgressCategory || (module.exports.EgressCategory = {}));
const $d27f8eb59492376d$var$getEgressesBasedOnToggles = (input)=>{
    const filteredEgresses = input.egress.filter((egress)=>{
        var _a;
        if (((_a = egress.category) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === $d27f8eb59492376d$var$EgressCategory.ANALYTICS) {
            if (input.installationConfig) {
                const analyticsConfig = input.installationConfig.find((config)=>config.key.toUpperCase() === 'ALLOW_EGRESS_ANALYTICS');
                return (analyticsConfig === null || analyticsConfig === void 0 ? void 0 : analyticsConfig.value) !== false;
            } else return input.overrides.ALLOW_EGRESS_ANALYTICS !== false;
        }
        return true;
    });
    const egressByType = new Map();
    for (const egress of filteredEgresses){
        if (!egressByType.has(egress.type)) egressByType.set(egress.type, egress.addresses);
        egressByType.set(egress.type, [
            ...egressByType.get(egress.type),
            ...egress.addresses
        ]);
    }
    return [
        ...egressByType.entries()
    ].map(([type, egresses])=>({
            type: type,
            addresses: [
                ...new Set(egresses)
            ]
        }));
};
module.exports.getEgressesBasedOnToggles = $d27f8eb59492376d$var$getEgressesBasedOnToggles;

});

parcelRegister("lCGo1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");

const $dedbac02f079af72$export$3b0d6d7590275603 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _2fwxA5DIqT _0Of8r28HPE _1wydGW8HPE _39xV02N91d"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            testId: "forge-app-loading-spinner",
            size: "large"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2fwxA5DIqT _0Of8r28HPE _1wydGW8HPE _39xV02N91d"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        testId: "forge-app-loading-spinner",
        size: "large"
    }));
};
module.exports["Loader"] = $dedbac02f079af72$export$3b0d6d7590275603;

});

parcelRegister("1gaKI", function(module, exports) {
const $fa98c81161b6a5d7$export$45b306f42e1402e5 = (extension)=>{
    const { properties: properties } = extension;
    if (properties?.layout === 'bodied') return 'bodiedExtension';
    else if (properties?.layout === 'inline') return 'inlineExtension';
    return 'extension';
};
module.exports["getExtensionType"] = $fa98c81161b6a5d7$export$45b306f42e1402e5;

});

parcelRegister("l07HN", function(module, exports) {
// A dynamic resource (a runtime-supplied `openModal`/frame resource, not declared in `manifest.yml`)
// may select a multi-entry bundle's entry via a `<resourceKey>/<entryKey>` form. The entry maps to
// `${entryKey}.html` (the UIKit2 build output). Segments are limited to these characters.
const $fa335cb55531d4ed$var$RESOURCE_SEGMENT_PATTERN = /^[a-zA-Z0-9_-]+$/;
const $fa335cb55531d4ed$export$28bf3ed89c90d749 = (rawResource)=>{
    // No (or empty) resource — e.g. a UIKit extension with no resource — has nothing to parse, so
    // return it as-is with no entry rather than calling `.split` on an undefined value.
    if (!rawResource) return {
        resource: rawResource,
        resolvedResourceEntry: undefined
    };
    const [resource, entryKey, ...rest] = rawResource.split('/');
    // Only a single `<resourceKey>/<entryKey>` split with safe segments selects an entry. Anything
    // else (no slash, multiple slashes, or an unsafe entry) yields no entry — which also clears any
    // entry inherited from a parent extension so it can't bleed. The resource is always the first
    // segment, so e.g. "a/b/c" resolves to resource "a" with no entry.
    if (rest.length === 0 && $fa335cb55531d4ed$var$RESOURCE_SEGMENT_PATTERN.test(resource) && $fa335cb55531d4ed$var$RESOURCE_SEGMENT_PATTERN.test(entryKey ?? '')) return {
        resource: resource,
        resolvedResourceEntry: `${entryKey}.html`
    };
    return {
        resource: resource,
        resolvedResourceEntry: undefined
    };
};
module.exports["resolveDynamicResource"] = $fa335cb55531d4ed$export$28bf3ed89c90d749;

});

parcelRegister("5ELQr", function(module, exports) {
$parcel$export(module.exports, "default", () => $620e6a7e84dfdd22$export$2e2bcd8739ae039);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9mNkI = parcelRequire("9mNkI");










var $bLswh = parcelRequire("bLswh");


var $uWGCd = parcelRequire("uWGCd");


var $DIyeF = parcelRequire("DIyeF");


var $h48r4 = parcelRequire("h48r4");


var $9DHhW = parcelRequire("9DHhW");


var $852mP = parcelRequire("852mP");


var $4K6lC = parcelRequire("4K6lC");


var $fQ6eZ = parcelRequire("fQ6eZ");

class $b84569f6e6c78231$export$a707936a384f62f9 extends Error {
    constructor(error){
        super(error.logMessage);
        this.logMessage = void 0;
        this.errorTitle = void 0;
        this.errorBody = void 0;
        this.errorTitle = error.errorTitle;
        this.logMessage = error.logMessage;
        this.errorBody = error.errorBody;
    }
}
class $b84569f6e6c78231$var$GenericErrorBoundaryWithCreateAnalyticsEvent extends (0, $cozmU.Component) {
    componentDidCatch(error, errorInfo) {
        const { page: page, environment: environment } = this.context;
        const { createAnalyticsEvent: createAnalyticsEvent, extension: extension, runtime: runtime } = this.props;
        (0, $h48r4.captureAndReportError)({
            error: error,
            errorInfo: errorInfo,
            page: page,
            runtime: runtime,
            environment: environment || (0, $bLswh.ProductEnvironment).DEVELOPMENT,
            errorExtensionDetails: extension ? {
                type: extension.type,
                environmentType: extension.environmentType,
                appOwnerAccountId: extension.appOwner?.accountId,
                properties: extension.properties,
                id: extension?.id
            } : undefined
        });
        createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: error.name
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        if (error instanceof $b84569f6e6c78231$export$a707936a384f62f9) this.setState({
            thrownError: {
                error: {
                    name: 'error',
                    message: error.errorTitle,
                    errorMessage: error.errorBody
                },
                errorInfo: errorInfo
            }
        });
        else this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uWGCd.default), {
            error: thrownError.error,
            dispatch: this.props.dispatch
        });
    }
    constructor(...args){
        super(...args);
        this.context = void 0;
        this.state = {
            thrownError: undefined
        };
    }
}
$b84569f6e6c78231$var$GenericErrorBoundaryWithCreateAnalyticsEvent.contextType = (0, $DIyeF.MetricsContext);
const $b84569f6e6c78231$var$GenericErrorBoundary = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const runtime = (0, $fQ6eZ.useForgeUIRuntime)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== props || $[2] !== runtime) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b84569f6e6c78231$var$GenericErrorBoundaryWithCreateAnalyticsEvent, {
            ...props,
            createAnalyticsEvent: createAnalyticsEvent,
            runtime: runtime
        });
        $[0] = createAnalyticsEvent;
        $[1] = props;
        $[2] = runtime;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const runtime = (0, $fQ6eZ.useForgeUIRuntime)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b84569f6e6c78231$var$GenericErrorBoundaryWithCreateAnalyticsEvent, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        runtime: runtime
    });
};
var $b84569f6e6c78231$export$2e2bcd8739ae039 = $b84569f6e6c78231$var$GenericErrorBoundary;




class $34f6568d0ec0f0fe$var$IntegrationErrorHandlerBoundary extends (0, $cozmU.Component) {
    componentDidCatch(error) {
        if (this.props.onError) this.props.onError(error);
        throw error;
    }
    render() {
        return this.props.children;
    }
}
var $34f6568d0ec0f0fe$export$2e2bcd8739ae039 = $34f6568d0ec0f0fe$var$IntegrationErrorHandlerBoundary;



var $7abeR = parcelRequire("7abeR");


var $6ojvx = parcelRequire("6ojvx");

var $fTOZ6 = parcelRequire("fTOZ6");










var $1LXnB = parcelRequire("1LXnB");

const $bf5dc60088456890$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(0);
const $bf5dc60088456890$var$SCROLLBAR_WIDTH = 30;
const $bf5dc60088456890$export$7921e18173e8c666 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children } = t0;
    const [width, setWidth] = (0, $cozmU.useState)(0);
    let t1;
    if ($[0] !== width) {
        const handleWidthChange = (newWidth)=>{
            if (!newWidth || Math.abs(width - newWidth) < $bf5dc60088456890$var$SCROLLBAR_WIDTH) return;
            setWidth(newWidth);
        };
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
            setWidth: handleWidthChange
        });
        $[0] = width;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== width) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bf5dc60088456890$export$27e39f636459b9f.Provider, {
            value: width
        }, children);
        $[2] = children;
        $[3] = width;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children })=>{
    const [width, setWidth] = (0, $cozmU.useState)(0);
    const handleWidthChange = (newWidth)=>{
        // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
        if (!newWidth || Math.abs(width - newWidth) < $bf5dc60088456890$var$SCROLLBAR_WIDTH) return;
        setWidth(newWidth);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
        setWidth: handleWidthChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bf5dc60088456890$export$27e39f636459b9f.Provider, {
        value: width
    }, children));
};
const $bf5dc60088456890$export$5d8538aa831b6ebb = $bf5dc60088456890$export$27e39f636459b9f.Consumer;



var $lCGo1 = parcelRequire("lCGo1");







class $48683fd0a27e61f1$export$51ac3312edef55d7 extends Error {
    get issue() {
        return this._issue;
    }
    get property() {
        return this._property;
    }
    set property(value) {
        this._property = value;
    }
    constructor({ issue: issue, message: message }){
        super(message);
        this._issue = void 0;
        this._property = void 0;
        this._issue = issue;
        this._property = '';
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $48683fd0a27e61f1$export$51ac3312edef55d7.prototype);
    }
}
class $48683fd0a27e61f1$var$StyleErrorBoundary extends (0, $cozmU.Component) {
    componentDidCatch(error) {
        if (!(error instanceof $48683fd0a27e61f1$export$51ac3312edef55d7)) throw error;
        this.setState({
            error: error
        });
    }
    render() {
        const { error: error } = this.state;
        if (!error) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uWGCd.default), {
            error: {
                name: 'style-error',
                message: `Error was thrown on style property: ${error.property}`,
                errorMessage: `${error.issue}\n${error.message}`
            },
            isReloadPage: true
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: null
        };
    }
}
var $48683fd0a27e61f1$export$2e2bcd8739ae039 = $48683fd0a27e61f1$var$StyleErrorBoundary;



var $5z7ti = parcelRequire("5z7ti");


var $bEbDR = parcelRequire("bEbDR");


var $hfFJ2 = parcelRequire("hfFJ2");


var $67Hav = parcelRequire("67Hav");














var $6FQr4 = parcelRequire("6FQr4");




const $b653b6c81377e6c0$export$1e4237f96323a8a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: source } = (0, $DIyeF.useMetricsContext)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== source) {
        t0 = ()=>{
            (0, $6FQr4.trackRendererRendered)(createAnalyticsEvent, {
                source: source,
                target: "renderer"
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = t0;
    } else t0 = $[2];
    (0, $cozmU.useEffect)(t0);
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: source } = (0, $DIyeF.useMetricsContext)();
    (0, $cozmU.useEffect)(()=>{
        (0, $6FQr4.trackRendererRendered)(createAnalyticsEvent, {
            source: source,
            target: 'renderer'
        });
    });
};



var $exNk7 = parcelRequire("exNk7");


var $4AVLc = parcelRequire("4AVLc");


var $iyAN0 = parcelRequire("iyAN0");

const $620e6a7e84dfdd22$var$getLoadingComponent = (loadingComponent)=>{
    if (loadingComponent) // Wrapping loadingComponent in a valid react element (fragment)
    // ReactNode type is not necessarily a valid React element, unable to change this type as different extension points pass in various loadingComponent types
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, loadingComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lCGo1.Loader), null);
};
const $620e6a7e84dfdd22$var$getAppDomainName = (extension, environment)=>{
    const parsedExtension = extension && extension?.id ? (0, $bEbDR.parseExtensionId)(extension.id) : undefined;
    if (parsedExtension) {
        const iframeSrc = (0, $hfFJ2.createSrcFromExtension)(parsedExtension.appId, extension, environment, '');
        const iframeUrl = new URL(iframeSrc);
        return iframeUrl.host;
    }
    return;
};

const $620e6a7e84dfdd22$var$RendererNextLatest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>/* webpackChunkName: "forge-ui-renderer-with-components" */ (parcelRequire("fp1Iw")).then((module)=>({
            default: module.RendererNextLatest
        })));
// This extra component exists so errors from the "render" function are caught in the an error boundary
// Also the error boundary requires a suspense fallback
const $620e6a7e84dfdd22$var$RendererNextWithProviders = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(45);
    const { extension: extension, forgeDoc: forgeDoc, dispatch: dispatch, locale: locale, error: error } = props;
    const defaultDispatch = $620e6a7e84dfdd22$var$_temp;
    const forgeReactMajorVersion = forgeDoc?.forgeReactMajorVersion;
    const environment = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    let t0;
    if ($[0] !== environment || $[1] !== extension) {
        t0 = $620e6a7e84dfdd22$var$getAppDomainName(extension, environment);
        $[0] = environment;
        $[1] = extension;
        $[2] = t0;
    } else t0 = $[2];
    const domainName = t0;
    if (props.loading && !forgeDoc) {
        let t1;
        if ($[3] !== props.loadingComponent) {
            t1 = $620e6a7e84dfdd22$var$getLoadingComponent(props.loadingComponent);
            $[3] = props.loadingComponent;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
    if (error && (0, $iyAN0.shouldRenderForgeAppErrorMessage)(error)) {
        let t1;
        if ($[5] !== error || $[6] !== extension || $[7] !== props.modalExtension) {
            t1 = props.modalExtension ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $exNk7.ForgeExtensionPointModal), {
                modalExtension: props.modalExtension
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AVLc.ForgeAppErrorMessage), {
                extension: extension,
                error: error
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AVLc.ForgeAppErrorMessage), {
                extension: extension,
                error: error
            });
            $[5] = error;
            $[6] = extension;
            $[7] = props.modalExtension;
            $[8] = t1;
        } else t1 = $[8];
        return t1;
    }
    let t1;
    if ($[9] !== props.loadingComponent) {
        t1 = $620e6a7e84dfdd22$var$getLoadingComponent(props.loadingComponent);
        $[9] = props.loadingComponent;
        $[10] = t1;
    } else t1 = $[10];
    const t2 = props.onError;
    const t3 = locale ?? "en";
    const t4 = extension?.egress;
    const t5 = extension?.properties;
    const t6 = extension?.environmentType;
    let t7;
    if ($[11] !== extension) {
        t7 = (0, $67Hav.resolveNavigationAppId)({
            extension: extension ?? {}
        });
        $[11] = extension;
        $[12] = t7;
    } else t7 = $[12];
    const t8 = extension?.type;
    let t9;
    if ($[13] !== domainName || $[14] !== forgeReactMajorVersion || $[15] !== props.openNewTabAsPopupWindow || $[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = {
            egress: t4,
            properties: t5,
            forgeEnvironment: t6,
            forgeReactMajorVersion: forgeReactMajorVersion,
            appDomainName: domainName,
            appId: t7,
            extensionType: t8,
            openNewTabAsPopupWindow: props.openNewTabAsPopupWindow
        };
        $[13] = domainName;
        $[14] = forgeReactMajorVersion;
        $[15] = props.openNewTabAsPopupWindow;
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    const t10 = dispatch ?? defaultDispatch;
    let t11;
    if ($[22] !== props || $[23] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5z7ti.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($620e6a7e84dfdd22$var$RenderTrackingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($620e6a7e84dfdd22$var$RendererNextLatest, {
            ...props,
            dispatch: t10
        })));
        $[22] = props;
        $[23] = t10;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t11 || $[26] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7abeR.PortalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTOZ6.RendererContext).Provider, {
            value: t9
        }, t11));
        $[25] = t11;
        $[26] = t9;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== t12 || $[29] !== t3) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf5dc60088456890$export$7921e18173e8c666), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: t3,
            defaultLocale: "en"
        }, t12));
        $[28] = t12;
        $[29] = t3;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== props.onError || $[32] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $48683fd0a27e61f1$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34f6568d0ec0f0fe$export$2e2bcd8739ae039), {
            onError: t2
        }, t13));
        $[31] = props.onError;
        $[32] = t13;
        $[33] = t14;
    } else t14 = $[33];
    let t15;
    if ($[34] !== dispatch || $[35] !== extension || $[36] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9mNkI.default), {
            dispatch: dispatch,
            extension: extension
        }, t14);
        $[34] = dispatch;
        $[35] = extension;
        $[36] = t14;
        $[37] = t15;
    } else t15 = $[37];
    let t16;
    if ($[38] !== dispatch || $[39] !== extension || $[40] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b84569f6e6c78231$export$2e2bcd8739ae039), {
            dispatch: dispatch,
            extension: extension
        }, t15);
        $[38] = dispatch;
        $[39] = extension;
        $[40] = t15;
        $[41] = t16;
    } else t16 = $[41];
    let t17;
    if ($[42] !== t1 || $[43] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: t1
        }, t16);
        $[42] = t1;
        $[43] = t16;
        $[44] = t17;
    } else t17 = $[44];
    return t17;
} : (props)=>{
    const { extension: extension, forgeDoc: forgeDoc, dispatch: dispatch, locale: locale, error: error } = props;
    const defaultDispatch = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(async ()=>{}, []);
    const forgeReactMajorVersion = forgeDoc?.forgeReactMajorVersion;
    const environment = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const domainName = $620e6a7e84dfdd22$var$getAppDomainName(extension, environment);
    // true while fetching initial forgeDoc
    if (props.loading && !forgeDoc) return $620e6a7e84dfdd22$var$getLoadingComponent(props.loadingComponent);
    // TODO: This can be removed when to move over to the new InnerIframeV2 as the ForgeAppErrorMessage component is rendered within
    // packages/forge/forge-ui/src/bridge/methods/core.tsx
    if (error && (0, $iyAN0.shouldRenderForgeAppErrorMessage)(error)) return props.modalExtension ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $exNk7.ForgeExtensionPointModal), {
        modalExtension: props.modalExtension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AVLc.ForgeAppErrorMessage), {
        extension: extension,
        error: error
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AVLc.ForgeAppErrorMessage), {
        extension: extension,
        error: error
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: $620e6a7e84dfdd22$var$getLoadingComponent(props.loadingComponent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b84569f6e6c78231$export$2e2bcd8739ae039), {
        dispatch: dispatch,
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9mNkI.default), {
        dispatch: dispatch,
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $48683fd0a27e61f1$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34f6568d0ec0f0fe$export$2e2bcd8739ae039), {
        onError: props.onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf5dc60088456890$export$7921e18173e8c666), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale ?? 'en',
        defaultLocale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7abeR.PortalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTOZ6.RendererContext).Provider, {
        value: {
            egress: extension?.egress,
            properties: extension?.properties,
            forgeEnvironment: extension?.environmentType,
            forgeReactMajorVersion: forgeReactMajorVersion,
            appDomainName: domainName,
            appId: (0, $67Hav.resolveNavigationAppId)({
                extension: extension ?? {}
            }),
            extensionType: extension?.type,
            openNewTabAsPopupWindow: props.openNewTabAsPopupWindow
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5z7ti.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($620e6a7e84dfdd22$var$RenderTrackingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($620e6a7e84dfdd22$var$RendererNextLatest, {
        ...props,
        dispatch: dispatch ?? defaultDispatch
    }))))))))))));
};
const $620e6a7e84dfdd22$var$RenderTrackingWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    (0, $b653b6c81377e6c0$export$1e4237f96323a8a1)();
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    (0, $b653b6c81377e6c0$export$1e4237f96323a8a1)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
var $620e6a7e84dfdd22$export$2e2bcd8739ae039 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($620e6a7e84dfdd22$var$RendererNextWithProviders, props);
};
async function $620e6a7e84dfdd22$var$_temp() {}

});

parcelRegister("9mNkI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bLswh = parcelRequire("bLswh");


var $uWGCd = parcelRequire("uWGCd");


var $h48r4 = parcelRequire("h48r4");


var $9DHhW = parcelRequire("9DHhW");


var $852mP = parcelRequire("852mP");


var $4K6lC = parcelRequire("4K6lC");


var $DIyeF = parcelRequire("DIyeF");


var $fQ6eZ = parcelRequire("fQ6eZ");

class $4e84f06a12d7851d$export$925737f92c0570a1 extends Error {
    constructor(message, component){
        super(message);
        this.component = void 0;
        this.component = component;
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $4e84f06a12d7851d$export$925737f92c0570a1.prototype);
    }
}
class $4e84f06a12d7851d$var$ComponentErrorBoundaryWithCreateAnalyticsEvent extends (0, $cozmU.Component) {
    componentDidCatch(error, errorInfo) {
        // Filters out reporting errors for components that are not valid e.g. <Buton/>
        if (!(error instanceof $4e84f06a12d7851d$export$925737f92c0570a1)) throw error;
        const { extension: extension, runtime: runtime } = this.props;
        const { page: page, environment: environment } = this.context;
        (0, $h48r4.captureAndReportError)({
            error: error,
            errorInfo: errorInfo,
            page: page,
            runtime: runtime,
            environment: environment ?? (0, $bLswh.ProductEnvironment).DEVELOPMENT,
            errorExtensionDetails: extension ? {
                type: extension.type,
                environmentType: extension.environmentType,
                appOwnerAccountId: extension.appOwner?.accountId,
                properties: extension.properties,
                id: extension?.id
            } : undefined
        });
        this.props.createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: 'componentError',
                    component: error.component
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uWGCd.default), {
            error: thrownError.error,
            dispatch: this.props.dispatch
        });
    }
    constructor(...args){
        super(...args);
        this.context = void 0;
        this.state = {
            thrownError: undefined
        };
    }
}
$4e84f06a12d7851d$var$ComponentErrorBoundaryWithCreateAnalyticsEvent.contextType = (0, $DIyeF.MetricsContext);
const $4e84f06a12d7851d$var$ComponentErrorBoundary = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const runtime = (0, $fQ6eZ.useForgeUIRuntime)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== props || $[2] !== runtime) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e84f06a12d7851d$var$ComponentErrorBoundaryWithCreateAnalyticsEvent, {
            ...props,
            createAnalyticsEvent: createAnalyticsEvent,
            runtime: runtime
        });
        $[0] = createAnalyticsEvent;
        $[1] = props;
        $[2] = runtime;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const runtime = (0, $fQ6eZ.useForgeUIRuntime)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e84f06a12d7851d$var$ComponentErrorBoundaryWithCreateAnalyticsEvent, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        runtime: runtime
    });
};
var $4e84f06a12d7851d$export$2e2bcd8739ae039 = $4e84f06a12d7851d$var$ComponentErrorBoundary;
module.exports["ComponentError"] = $4e84f06a12d7851d$export$925737f92c0570a1;
module.exports["default"] = $4e84f06a12d7851d$export$2e2bcd8739ae039;

});

parcelRegister("fD3vt", function(module, exports) {

let $b60d37e700e1a2bc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b60d37e700e1a2bc$var$load("Wowvf"),
    $b60d37e700e1a2bc$var$load("aXpqC")
]).then(()=>parcelRequire('8RXuv'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("gsSr5", function(module, exports) {

let $bfc97caf3c31ea93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bfc97caf3c31ea93$var$load("Wowvf"),
    $bfc97caf3c31ea93$var$load("aXpqC")
]).then(()=>parcelRequire('ecAr3'));

});

parcelRegister("7abeR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cK21K = parcelRequire("cK21K");


var $jp2Q3 = parcelRequire("jp2Q3");

const $fab2e5d0e6dc9630$var$dest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $fab2e5d0e6dc9630$var$Provider = $fab2e5d0e6dc9630$var$dest.Provider;
const $fab2e5d0e6dc9630$export$7d41556b227a95c9 = $fab2e5d0e6dc9630$var$dest.Consumer;
const $fab2e5d0e6dc9630$export$6df4068a17305b10 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children } = t0;
    const [portal, setPortal] = (0, $cozmU.useState)();
    const [isPortalReady, setIsPortalReady] = (0, $cozmU.useState)(false);
    let t1;
    let t2;
    if ($[0] !== portal) {
        t1 = ()=>{
            if (portal !== null) setIsPortalReady(true);
        };
        t2 = [
            portal
        ];
        $[0] = portal;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children || $[4] !== isPortalReady || $[5] !== portal) {
        t3 = isPortalReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fab2e5d0e6dc9630$var$Provider, {
            value: portal
        }, children);
        $[3] = children;
        $[4] = isPortalReady;
        $[5] = portal;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
            zIndex: (0, $jp2Q3.layers).modal() + 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "forge-ui-portal",
            ref: setPortal
        }));
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t4);
        $[8] = t3;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ children: children })=>{
    const [portal, setPortal] = (0, $cozmU.useState)();
    const [isPortalReady, setIsPortalReady] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (portal !== null) setIsPortalReady(true);
    }, [
        portal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isPortalReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fab2e5d0e6dc9630$var$Provider, {
        value: portal
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: (0, $jp2Q3.layers).modal() + 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "forge-ui-portal",
        ref: setPortal
    })));
};
module.exports["PortalConsumer"] = $fab2e5d0e6dc9630$export$7d41556b227a95c9;
module.exports["PortalProvider"] = $fab2e5d0e6dc9630$export$6df4068a17305b10;

});

parcelRegister("exNk7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $6Ec6w = parcelRequire("6Ec6w");


var $cJ0FD = parcelRequire("cJ0FD");


var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $5WvJi = parcelRequire("5WvJi");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $9oYqV = parcelRequire("9oYqV");


var $f3Db5 = parcelRequire("f3Db5");


var $bLswh = parcelRequire("bLswh");


var $6FQr4 = parcelRequire("6FQr4");


var $1gaKI = parcelRequire("1gaKI");


var $lAA41 = parcelRequire("lAA41");

const $de58fcd80a7f5178$var$styles = {
    modalWrapper: "_1wydGWNHnM"
};
const $de58fcd80a7f5178$var$getExtensionIcon = (extension)=>{
    return extension?.properties?.config?.icon ?? extension?.properties?.icon;
};
const $de58fcd80a7f5178$var$ModalWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(17);
    const { closeModalExtension: closeModalExtension, extensionType: extensionType, modalSize: modalSize, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress } = props;
    let t0;
    if ($[0] !== extensionType) {
        t0 = extensionType && (0, $lAA41.FULLSCREEN_SUPPORTED_EXTENSION_TYPES).has(extensionType);
        $[0] = extensionType;
        $[1] = t0;
    } else t0 = $[1];
    const isFullscreenAllowed = t0;
    const isFullscreenModal = modalSize === "fullscreen";
    if (isFullscreenModal && isFullscreenAllowed) {
        let t1;
        if ($[2] !== closeModalExtension || $[3] !== props.children || $[4] !== shouldCloseOnEscapePress) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5WvJi.FullScreenModalDialog), {
                shouldCloseOnEscapePress: shouldCloseOnEscapePress,
                onClose: closeModalExtension
            }, props.children);
            $[2] = closeModalExtension;
            $[3] = props.children;
            $[4] = shouldCloseOnEscapePress;
            $[5] = t1;
        } else t1 = $[5];
        return t1;
    }
    const shouldFallbackFromFullscreen = isFullscreenModal && !isFullscreenAllowed;
    const t1 = modalSize === "resizable";
    let t2;
    if ($[6] !== modalSize || $[7] !== shouldFallbackFromFullscreen || $[8] !== t1) {
        t2 = (0, $f3Db5.resolveModalDimensions)({
            size: modalSize,
            shouldFallbackFromFullscreen: shouldFallbackFromFullscreen,
            isResizableSize: t1
        });
        $[6] = modalSize;
        $[7] = shouldFallbackFromFullscreen;
        $[8] = t1;
        $[9] = t2;
    } else t2 = $[9];
    const resolvedDimensions = t2;
    const width = resolvedDimensions.width;
    const height = resolvedDimensions.height;
    if (shouldFallbackFromFullscreen) console.warn("Forge fullscreen extension point modal is only supported in specific extension points. Refer to https://developer.atlassian.com/platform/forge/manifest-reference/modules/ for more guidance. The modal will be rendered with x-large width instead.");
    let t3;
    if ($[10] !== closeModalExtension || $[11] !== height || $[12] !== props.children || $[13] !== shouldCloseOnEscapePress || $[14] !== shouldCloseOnOverlayClick || $[15] !== width) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
            shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress,
            onClose: closeModalExtension,
            width: width,
            height: height
        }, props.children);
        $[10] = closeModalExtension;
        $[11] = height;
        $[12] = props.children;
        $[13] = shouldCloseOnEscapePress;
        $[14] = shouldCloseOnOverlayClick;
        $[15] = width;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
} : (props)=>{
    const { closeModalExtension: closeModalExtension, extensionType: extensionType, modalSize: modalSize, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress } = props;
    const isFullscreenAllowed = extensionType && (0, $lAA41.FULLSCREEN_SUPPORTED_EXTENSION_TYPES).has(extensionType);
    const isFullscreenModal = modalSize === 'fullscreen';
    if (isFullscreenModal && isFullscreenAllowed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5WvJi.FullScreenModalDialog), {
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        onClose: closeModalExtension
    }, props.children);
     // Fallback to 'x-large' if width is 'fullscreen' but not supported
    const shouldFallbackFromFullscreen = isFullscreenModal && !isFullscreenAllowed;
    const resolvedDimensions = (0, $f3Db5.resolveModalDimensions)({
        size: modalSize,
        shouldFallbackFromFullscreen: shouldFallbackFromFullscreen,
        isResizableSize: modalSize === 'resizable'
    });
    const width = resolvedDimensions.width;
    const height = resolvedDimensions.height;
    if (shouldFallbackFromFullscreen) // eslint-disable-next-line no-console
    console.warn('Forge fullscreen extension point modal is only supported in specific extension points. Refer to https://developer.atlassian.com/platform/forge/manifest-reference/modules/ for more guidance. The modal will be rendered with x-large width instead.');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        onClose: closeModalExtension,
        width: width,
        height: height
    }, props.children);
};
const $de58fcd80a7f5178$export$bf4fcca1fb0dca1e = ({ children: children, modalExtension: modalExtension, shouldShowFCFModalDeprecationMessage: shouldShowFCFModalDeprecationMessage, extension: extension })=>{
    const { closeModalExtension: closeModalExtension, title: title, modalWidth: modalSize, shouldCloseOnOverlayClick: // TODO: rename this prop on the product side
    shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, viewOnClose: viewOnClose } = modalExtension;
    const environmentType = extension?.environmentType;
    const extensionType = extension ? (0, $1gaKI.getExtensionType)(extension?.properties) : 'extension';
    const isMacroExtension = extensionType === 'extension' && extension?.type === (0, $bLswh.ConfluenceExtension).MACRO;
    const isFullscreenModal = modalSize === 'fullscreen';
    const extensionIcon = isMacroExtension ? $de58fcd80a7f5178$var$getExtensionIcon(extension) : undefined;
    const { trackExtensionLoaded: trackExtensionLoaded, trackBridgeSucceed: trackBridgeSucceed, trackBridgeFailed: trackBridgeFailed } = (0, $6FQr4.useForgeUiAnalyticsEvent)(); // Only tracking fullscreen modals
    (0, $cozmU.useEffect)(()=>{
        if (isFullscreenModal) trackExtensionLoaded({
            forgeEnvironment: environmentType,
            renderType: 'UIKit',
            extensionType: extensionType,
            viewportSize: 'fullscreen'
        });
    }, [
        isFullscreenModal,
        extensionType,
        environmentType,
        trackExtensionLoaded
    ]);
    const handleClose = async ()=>{
        if (viewOnClose) try {
            await viewOnClose();
            trackBridgeSucceed({
                method: 'onClose',
                forgeEnvironment: extension?.environmentType
            });
        } catch (error) {
            // Track failure but still close the modal
            trackBridgeFailed({
                method: 'onClose',
                errorName: error instanceof Error ? error.name : 'UnknownError',
                forgeEnvironment: extension?.environmentType
            });
        } finally{
            closeModalExtension();
        }
        else closeModalExtension();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de58fcd80a7f5178$var$ModalWrapper, {
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        closeModalExtension: handleClose,
        extensionType: extension?.type,
        modalSize: modalSize,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, isMacroExtension && isFullscreenModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, extensionIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: extensionIcon,
        alt: "Macro custom config icon",
        width: "24px",
        height: "24px"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
        label: "",
        color: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: "Close Modal",
        onClick: handleClose
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), {
        hasInlinePadding: !isFullscreenModal
    }, shouldShowFCFModalDeprecationMessage && extension ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9oYqV.ForgeModalDeprecationMessage), {
        extension: extension
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $de58fcd80a7f5178$var$styles.modalWrapper
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $de58fcd80a7f5178$var$styles.modalWrapper
    }, children)));
};
module.exports["ForgeExtensionPointModal"] = $de58fcd80a7f5178$export$bf4fcca1fb0dca1e;

});

parcelRegister("fp1Iw", function(module, exports) {

let $b36a85d0f5d70ec3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b36a85d0f5d70ec3$var$load("fEHF5"),
    $b36a85d0f5d70ec3$var$load("gkVge"),
    $b36a85d0f5d70ec3$var$load("6wr18"),
    $b36a85d0f5d70ec3$var$load("kEBma"),
    $b36a85d0f5d70ec3$var$load("1gATC"),
    $b36a85d0f5d70ec3$var$load("1xRFJ"),
    $b36a85d0f5d70ec3$var$load("ilUG7"),
    $b36a85d0f5d70ec3$var$load("efUj2"),
    $b36a85d0f5d70ec3$var$load("eUsnQ"),
    $b36a85d0f5d70ec3$var$load("6C7Vr"),
    $b36a85d0f5d70ec3$var$load("a8glC"),
    $b36a85d0f5d70ec3$var$load("iWnyc"),
    $b36a85d0f5d70ec3$var$load("Wowvf"),
    $b36a85d0f5d70ec3$var$load("7EorR"),
    $b36a85d0f5d70ec3$var$load("hhss7"),
    $b36a85d0f5d70ec3$var$load("ffEVr"),
    $b36a85d0f5d70ec3$var$load("953Uz"),
    $b36a85d0f5d70ec3$var$load("fwtVs")
]).then(()=>parcelRequire('hYxg8'));

});

parcelRegister("1CPZY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $c18c1fba8ba2b6b4$export$75ab56226e2d3efd = /*#__PURE__*/ (0, $cozmU.createContext)({
    inline: false
});
const $c18c1fba8ba2b6b4$export$3828d4e780bd54a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($c18c1fba8ba2b6b4$export$75ab56226e2d3efd);
} : ()=>(0, $cozmU.useContext)($c18c1fba8ba2b6b4$export$75ab56226e2d3efd);
module.exports["InlineContext"] = $c18c1fba8ba2b6b4$export$75ab56226e2d3efd;
module.exports["useInlineContext"] = $c18c1fba8ba2b6b4$export$3828d4e780bd54a;

});

parcelRegister("h9K7i", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<3509cab6dd90f1cdb1ca06db692800f9>>
 * @relayHash 31980ab6c38bae595f082e75d7d0e4e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ae24380b92626cb5b9d090bf5964371d7239e6db55abf05be39369ed495e6702
const $9268eab56b0408da$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "userpicker_forge_ui_usersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "userpicker_forge_ui_usersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ae24380b92626cb5b9d090bf5964371d7239e6db55abf05be39369ed495e6702",
            "metadata": {},
            "name": "userpicker_forge_ui_usersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9268eab56b0408da$var$node.hash = "bfc99cc46adea62c7037b11c133b2a46";
var $9268eab56b0408da$export$2e2bcd8739ae039 = $9268eab56b0408da$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");










// Key for registering and unregistering the subscriber
const $5e85f83c45004805$var$MENTION_SUBSCRIBER_KEY = 'forge-ui-user-select';
const $5e85f83c45004805$var$mentionResultsToUsers = (results)=>{
    return results.map((result)=>({
            id: result.id,
            name: result.name,
            avatarUrl: result.avatarUrl || '',
            type: 'user'
        })).filter((user)=>typeof user.name !== 'undefined');
};
const $5e85f83c45004805$export$f4d09562dcb13ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? (mentionProvider)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== mentionProvider) {
        t0 = async (search)=>{
            const provider = await mentionProvider;
            if (provider && search) return new Promise((resolve)=>{
                provider.filter(search);
                provider.subscribe($5e85f83c45004805$var$MENTION_SUBSCRIBER_KEY, (results)=>{
                    provider.unsubscribe($5e85f83c45004805$var$MENTION_SUBSCRIBER_KEY);
                    resolve($5e85f83c45004805$var$mentionResultsToUsers(results));
                }, ()=>{
                    provider.unsubscribe($5e85f83c45004805$var$MENTION_SUBSCRIBER_KEY);
                    resolve([]);
                });
            });
            return Promise.resolve([]);
        };
        $[0] = mentionProvider;
        $[1] = t0;
    } else t0 = $[1];
    const query = t0;
    if (mentionProvider) return query;
} : (mentionProvider)=>{
    const query = (0, $cozmU.useCallback)(async (search)=>{
        const provider = await mentionProvider;
        if (provider && search) return new Promise((resolve)=>{
            provider.filter(search);
            provider.subscribe($5e85f83c45004805$var$MENTION_SUBSCRIBER_KEY, (results)=>{
                provider.unsubscribe($5e85f83c45004805$var$MENTION_SUBSCRIBER_KEY);
                resolve($5e85f83c45004805$var$mentionResultsToUsers(results));
            }, ()=>{
                provider.unsubscribe($5e85f83c45004805$var$MENTION_SUBSCRIBER_KEY);
                resolve([]);
            });
        });
        return Promise.resolve([]);
    }, [
        mentionProvider
    ]);
    if (mentionProvider) return query;
};












var $kfLla = parcelRequire("kfLla");


var $24tIi = parcelRequire("24tIi");


var $9DzWa = parcelRequire("9DzWa");


var $7abeR = parcelRequire("7abeR");











var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


const $fd2bae31e6a73296$var$AKLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("ick2w")).then((module)=>({
            default: module.Label
        })));
const $fd2bae31e6a73296$export$b04be29aa201d4f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { isRequired: isRequired, label: label, name: name } = t0;
    const t1 = `${name}-label`;
    let t2;
    if ($[0] !== isRequired) {
        t2 = isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "strong",
            color: "color.text.danger",
            size: "small"
        }, "*");
        $[0] = isRequired;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== label || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.025"
        }, label, t2);
        $[2] = label;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== name || $[6] !== t1 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fd2bae31e6a73296$var$AKLabel, {
            htmlFor: name,
            id: t1
        }, t3);
        $[5] = name;
        $[6] = t1;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ isRequired: isRequired, label: label, name: name })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fd2bae31e6a73296$var$AKLabel, {
        htmlFor: name,
        id: `${name}-label`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.025"
    }, label, isRequired && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong",
        color: "color.text.danger",
        size: "small"
    }, "*")));
};


const $fc058009d7ea5d0a$var$BITBUCKET_FIELD_ID = 'BitbucketMentions';
// the value prop in UserPicker component can only take undefined for empty value.
// null is not allowed and will resulted in unexpected behavior.
const $fc058009d7ea5d0a$var$ensureUserPickerValue = (value)=>{
    if (!value || Array.isArray(value) && value.length === 0) return undefined;
    return value;
};
// by forcing a key update when defaultValue is present, we force the SmartUserPicker to re-render.
// this is because the SmartUserPicker does not re-render when the defaultValue changes in its
// current implementation.
const $fc058009d7ea5d0a$var$makeUserPickerKey = (id, defaultValue)=>{
    if (!defaultValue || Array.isArray(defaultValue) && defaultValue.length === 0) return id;
    return `${id}-with-default`;
};
const $fc058009d7ea5d0a$var$RawUserPicker = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { id: id, name: name, description: description, placeholder: placeholder, isMulti: isMulti, includeUsers: t1, includeGroups: t2, accountId: currentAccountId, cloudId: suppliedCloudId, productKey: productKey, baseUrl: baseUrl, onChange: onChange, query: query, defaultValue: defaultValue, value: providedValue, width: width, productAttributes: productAttributes } = t0;
    const includeUsers = t1 === undefined ? true : t1;
    const includeGroups = t2 === undefined ? false : t2;
    const [value, setValue] = (0, $cozmU.useState)(defaultValue);
    let t3;
    if ($[0] !== baseUrl || $[1] !== currentAccountId || $[2] !== defaultValue || $[3] !== description || $[4] !== id || $[5] !== includeGroups || $[6] !== includeUsers || $[7] !== isMulti || $[8] !== name || $[9] !== onChange || $[10] !== placeholder || $[11] !== productAttributes || $[12] !== productKey || $[13] !== providedValue || $[14] !== query || $[15] !== suppliedCloudId || $[16] !== value || $[17] !== width) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7abeR.PortalConsumer), null, (portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, suppliedCloudId && productKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $24tIi.default), {
                key: $fc058009d7ea5d0a$var$makeUserPickerKey(id, defaultValue),
                onChange: (user)=>onChange?.(user),
                isMulti: isMulti,
                menuPortalTarget: portal || undefined,
                noOptionsMessage: $fc058009d7ea5d0a$var$_temp,
                placeholder: placeholder,
                width: width,
                fieldId: productKey === "bitbucket" ? $fc058009d7ea5d0a$var$BITBUCKET_FIELD_ID : id,
                debounceTime: 400,
                includeUsers: includeUsers,
                includeGroups: includeGroups,
                siteId: suppliedCloudId,
                productAttributes: productAttributes,
                principalId: currentAccountId ?? "Context",
                productKey: productKey,
                baseUrl: baseUrl,
                inputId: name || id,
                defaultValue: defaultValue,
                styles: {
                    control: $fc058009d7ea5d0a$var$_temp2
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kfLla.UserPicker), {
                value: $fc058009d7ea5d0a$var$ensureUserPickerValue(providedValue ?? value),
                onChange: (user_0)=>{
                    setValue(user_0);
                    onChange?.(user_0);
                },
                styles: {
                    control: $fc058009d7ea5d0a$var$_temp3
                },
                isMulti: isMulti,
                menuPortalTarget: portal || undefined,
                noOptionsMessage: $fc058009d7ea5d0a$var$_temp4,
                placeholder: placeholder,
                width: width,
                loadOptions: query,
                fieldId: null,
                inputId: id,
                defaultValue: defaultValue
            }), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9DzWa.HelperMessage), null, description)));
        $[0] = baseUrl;
        $[1] = currentAccountId;
        $[2] = defaultValue;
        $[3] = description;
        $[4] = id;
        $[5] = includeGroups;
        $[6] = includeUsers;
        $[7] = isMulti;
        $[8] = name;
        $[9] = onChange;
        $[10] = placeholder;
        $[11] = productAttributes;
        $[12] = productKey;
        $[13] = providedValue;
        $[14] = query;
        $[15] = suppliedCloudId;
        $[16] = value;
        $[17] = width;
        $[18] = t3;
    } else t3 = $[18];
    return t3;
} : ({ id: id, name: name, description: description, placeholder: placeholder, isMulti: isMulti, includeUsers: includeUsers = true, includeGroups: includeGroups = false, accountId: currentAccountId, cloudId: suppliedCloudId, productKey: productKey, baseUrl: baseUrl, onChange: onChange, query: query, defaultValue: defaultValue, value: providedValue, width: width, productAttributes: productAttributes })=>{
    const [value, setValue] = (0, $cozmU.useState)(defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7abeR.PortalConsumer), null, (portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, suppliedCloudId && productKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $24tIi.default), {
            key: $fc058009d7ea5d0a$var$makeUserPickerKey(id, defaultValue),
            onChange: (user)=>onChange?.(user),
            isMulti: isMulti,
            menuPortalTarget: portal || undefined,
            noOptionsMessage: ()=>null,
            placeholder: placeholder,
            width: width,
            fieldId: // Bitbucket User Recommendations does not support generic contextType
            productKey === 'bitbucket' ? $fc058009d7ea5d0a$var$BITBUCKET_FIELD_ID : id,
            debounceTime: 400,
            includeUsers: includeUsers,
            includeGroups: includeGroups,
            siteId: suppliedCloudId,
            productAttributes: productAttributes,
            // If principalId === 'Context', upstream attempts to use other context
            // to discover the principal ID
            principalId: currentAccountId ?? 'Context',
            productKey: productKey,
            baseUrl: baseUrl,
            inputId: name || id,
            defaultValue: defaultValue,
            // Override the default height of user picker so that it aligns with other input components from design system
            styles: {
                control: (base)=>({
                        ...base,
                        minHeight: '40px',
                        height: '40px'
                    })
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kfLla.UserPicker), {
            value: $fc058009d7ea5d0a$var$ensureUserPickerValue(providedValue ?? value),
            onChange: (user_0)=>{
                setValue(user_0);
                onChange?.(user_0);
            },
            // Override the default height of user picker so that it aligns with other input components from design system
            styles: {
                control: (base_0)=>({
                        ...base_0,
                        minHeight: '40px',
                        height: '40px'
                    })
            },
            isMulti: isMulti,
            menuPortalTarget: portal || undefined,
            noOptionsMessage: ()=>null,
            placeholder: placeholder,
            width: width,
            loadOptions: query,
            fieldId: null,
            inputId: id,
            defaultValue: defaultValue
        }), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9DzWa.HelperMessage), null, description)));
};
const $fc058009d7ea5d0a$export$83e0c73b09b3a9cd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    const uid = (0, $cozmU.useId)();
    const { name: name, isRequired: isRequired, label: label } = props;
    const id = name || uid;
    let t0;
    if ($[0] !== isRequired || $[1] !== label || $[2] !== name) {
        t0 = label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fd2bae31e6a73296$export$b04be29aa201d4f5), {
            name: name,
            isRequired: isRequired,
            label: label
        });
        $[0] = isRequired;
        $[1] = label;
        $[2] = name;
        $[3] = t0;
    } else t0 = $[3];
    let t1;
    if ($[4] !== id || $[5] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fc058009d7ea5d0a$var$RawUserPicker, {
            id: id,
            width: "100%",
            ...props
        });
        $[4] = id;
        $[5] = props;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== t0 || $[8] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0, t1);
        $[7] = t0;
        $[8] = t1;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : (props)=>{
    const uid = (0, $cozmU.useId)();
    const { name: name, isRequired: isRequired, label: label } = props;
    const id = name || uid;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fd2bae31e6a73296$export$b04be29aa201d4f5), {
        name: name,
        isRequired: isRequired,
        label: label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fc058009d7ea5d0a$var$RawUserPicker, {
        id: id,
        width: "100%",
        ...props
    }));
};
function $fc058009d7ea5d0a$var$_temp() {
    return null;
}
function $fc058009d7ea5d0a$var$_temp2(base) {
    return {
        ...base,
        minHeight: "40px",
        height: "40px"
    };
}
function $fc058009d7ea5d0a$var$_temp3(base_0) {
    return {
        ...base_0,
        minHeight: "40px",
        height: "40px"
    };
}
function $fc058009d7ea5d0a$var$_temp4() {
    return null;
}



// Format the values(UserData) returned from useUsers hook, to pass to defaultValue prop
const $1de9b4994ef41256$var$hydrateDefaultValue = (users, isMulti = false)=>{
    const defaultValues = [];
    for(const userId in users){
        const { name: name, picture: picture } = users[userId];
        // Only grabbing the values where user name exist
        if (name) defaultValues.push({
            name: name,
            avatarUrl: picture,
            id: userId,
            type: 'user'
        });
    }
    return isMulti ? defaultValues : defaultValues[0];
};
const $1de9b4994ef41256$var$extractUsers = (data)=>{
    let users = {};
    if (data && data.users) users = data.users.reduce((prev, user)=>{
        if (user.accountId) prev[user.accountId] = {
            picture: user.picture,
            accountId: user.accountId,
            name: user.name
        };
        return prev;
    }, {});
    return users;
};
const $1de9b4994ef41256$var$UserPickerFn = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productAttributes: productAttributes, productKey: productKey, baseUrl: baseUrl, props: props } = t0;
    const { name: name, label: label, placeholder: placeholder, description: description, defaultValue: t1, isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups, onChange: onChange } = props;
    const defaultUserValue = t1 === undefined ? "" : t1;
    const query = (0, $5e85f83c45004805$export$f4d09562dcb13ab)(mentionProvider);
    let t2;
    if ($[0] !== defaultUserValue) {
        t2 = Array.isArray(defaultUserValue) ? defaultUserValue : [
            defaultUserValue
        ];
        $[0] = defaultUserValue;
        $[1] = t2;
    } else t2 = $[1];
    const accountIds = t2;
    let t3;
    if ($[2] !== accountIds) {
        t3 = {
            accountIds: accountIds
        };
        $[2] = accountIds;
        $[3] = t3;
    } else t3 = $[3];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $9268eab56b0408da$export$2e2bcd8739ae039), t3);
    let t4;
    if ($[4] !== data || $[5] !== isMulti) {
        const users = $1de9b4994ef41256$var$extractUsers(data);
        t4 = $1de9b4994ef41256$var$hydrateDefaultValue(users, isMulti);
        $[4] = data;
        $[5] = isMulti;
        $[6] = t4;
    } else t4 = $[6];
    const hydratedDefaultValue = t4;
    let t5;
    if ($[7] !== accountId || $[8] !== baseUrl || $[9] !== cloudId || $[10] !== description || $[11] !== hydratedDefaultValue || $[12] !== includeGroups || $[13] !== includeUsers || $[14] !== isMulti || $[15] !== isRequired || $[16] !== label || $[17] !== mentionProvider || $[18] !== name || $[19] !== onChange || $[20] !== placeholder || $[21] !== productAttributes || $[22] !== productKey || $[23] !== query) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fc058009d7ea5d0a$export$83e0c73b09b3a9cd), {
            accountId: accountId,
            cloudId: cloudId,
            productAttributes: productAttributes,
            productKey: productKey,
            mentionProvider: mentionProvider,
            name: name,
            label: label,
            placeholder: placeholder,
            description: description,
            defaultValue: hydratedDefaultValue,
            isRequired: isRequired,
            isMulti: isMulti,
            includeUsers: includeUsers,
            includeGroups: includeGroups,
            baseUrl: baseUrl,
            onChange: onChange,
            query: query
        });
        $[7] = accountId;
        $[8] = baseUrl;
        $[9] = cloudId;
        $[10] = description;
        $[11] = hydratedDefaultValue;
        $[12] = includeGroups;
        $[13] = includeUsers;
        $[14] = isMulti;
        $[15] = isRequired;
        $[16] = label;
        $[17] = mentionProvider;
        $[18] = name;
        $[19] = onChange;
        $[20] = placeholder;
        $[21] = productAttributes;
        $[22] = productKey;
        $[23] = query;
        $[24] = t5;
    } else t5 = $[24];
    return t5;
} : ({ mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productAttributes: productAttributes, productKey: productKey, baseUrl: baseUrl, props: props })=>{
    const { name: name, label: label, placeholder: placeholder, description: description, // Warning: Smart user picker ONLY supports default value hydration
    // of *users*, not groups!
    defaultValue: defaultUserValue = '', isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups, onChange: onChange } = props;
    const query = (0, $5e85f83c45004805$export$f4d09562dcb13ab)(mentionProvider);
    const accountIds = Array.isArray(defaultUserValue) ? defaultUserValue : [
        defaultUserValue
    ];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $9268eab56b0408da$export$2e2bcd8739ae039), {
        accountIds: accountIds
    });
    // Hydrate the default value ourselves, since we are controlling value from <Field>
    // component value. It will get passed into the user picker as simply `value`.
    const users = $1de9b4994ef41256$var$extractUsers(data);
    const hydratedDefaultValue = $1de9b4994ef41256$var$hydrateDefaultValue(users, isMulti);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fc058009d7ea5d0a$export$83e0c73b09b3a9cd), {
        accountId: accountId,
        cloudId: cloudId,
        productAttributes: productAttributes,
        productKey: productKey,
        mentionProvider: mentionProvider,
        name: name,
        label: label,
        placeholder: placeholder,
        description: description,
        defaultValue: hydratedDefaultValue,
        isRequired: isRequired,
        isMulti: isMulti,
        includeUsers: includeUsers,
        includeGroups: includeGroups,
        baseUrl: baseUrl,
        onChange: onChange,
        query: query
    });
};
const $1de9b4994ef41256$export$89c0f5a165dc562a = ({ query: query, accountId: accountId, cloudId: cloudId, productKey: productKey, baseUrl: baseUrl })=>{
    return function UserPickerNext({ forgeDoc: { props: props } }) {
        const { name: name, label: label, placeholder: placeholder, description: description, isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups, onChange: onChange, defaultValue: defaultUserId } = props;
        const [defaultValueLoaded, setDefaultValueLoaded] = (0, $cozmU.useState)(!defaultUserId);
        const [defaultValue, setDefaultValue] = (0, $cozmU.useState)();
        (0, $cozmU.useEffect)(()=>{
            if (defaultUserId && !defaultValueLoaded) query().then((users)=>{
                const targetUsers = users.filter(({ id: id })=>Array.isArray(defaultUserId) ? defaultUserId.includes(id) : defaultUserId === id);
                if (targetUsers.length === 0) setDefaultValue(undefined);
                else if (isMulti) setDefaultValue(targetUsers);
                else setDefaultValue(targetUsers[0]);
                setDefaultValueLoaded(true);
            });
        }, [
            isMulti,
            defaultUserId,
            defaultValueLoaded,
            setDefaultValue,
            setDefaultValueLoaded
        ]);
        if (!defaultValueLoaded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fc058009d7ea5d0a$export$83e0c73b09b3a9cd), {
            accountId: accountId,
            cloudId: cloudId,
            productKey: productKey,
            baseUrl: baseUrl,
            name: name,
            label: label,
            placeholder: placeholder,
            description: description,
            isRequired: isRequired,
            isMulti: isMulti,
            includeUsers: includeUsers,
            includeGroups: includeGroups,
            onChange: onChange,
            query: query,
            defaultValue: defaultValue
        });
    };
};
const $1de9b4994ef41256$export$57fb7dc1c2438e62 = ({ mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productKey: productKey, baseUrl: baseUrl, productAttributes: productAttributes })=>{
    return function UserPickerNext({ forgeDoc: { props: props } }) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1de9b4994ef41256$var$UserPickerFn, {
            props: props,
            mentionProvider: mentionProvider,
            accountId: accountId,
            cloudId: cloudId,
            productAttributes: productAttributes,
            productKey: productKey,
            baseUrl: baseUrl
        });
    };
};
module.exports["makeMockUserPicker"] = $1de9b4994ef41256$export$89c0f5a165dc562a;
module.exports["makeNativeUserPicker"] = $1de9b4994ef41256$export$57fb7dc1c2438e62;

});

parcelRegister("ick2w", function(module, exports) {

let $d3f8e4732c2bc96a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d3f8e4732c2bc96a$var$load("iWnyc"),
    $d3f8e4732c2bc96a$var$load("hhss7"),
    $d3f8e4732c2bc96a$var$load("3P62u")
]).then(()=>parcelRequire('lSDj5'));

});

parcelRegister("8J8AQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3BY7M = parcelRequire("3BY7M");


var $jTt8P = parcelRequire("jTt8P");


var $hRnS5 = parcelRequire("hRnS5");


var $lNvN4 = parcelRequire("lNvN4");


var $6BvLK = parcelRequire("6BvLK");


var $fTOZ6 = parcelRequire("fTOZ6");


var $gFIer = parcelRequire("gFIer");


var $HHXWG = parcelRequire("HHXWG");


var $67Hav = parcelRequire("67Hav");


var $9XnlZ = parcelRequire("9XnlZ");


var $4v1ex = parcelRequire("4v1ex");

const $b5004965e3772208$var$EMPTY_EXTENSION_VIEW_DATA = Object.freeze({});
const $b5004965e3772208$var$filterInvalidMediaUrls = (appDomainName, egressServices, document)=>{
    const invalidUrls = new Set();
    const visitors = {
        media: (node)=>{
            const url = node?.attrs?.url;
            if (url && !egressServices.some((service)=>(0, $HHXWG.isValidImageUrl)(url, service, appDomainName))) {
                invalidUrls.add(url);
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        // Remove the URL so it fails to load
                        // We use a space because an empty string causes an infinite loading spinner
                        url: ' '
                    }
                };
            }
        }
    };
    const filteredDocument = (0, $jTt8P.traverse)(document, visitors);
    return {
        filteredDocument: filteredDocument ? filteredDocument : document,
        invalidUrls: Array.from(invalidUrls)
    };
};
const $b5004965e3772208$var$useSupportsMedia = ()=>{
    try {
        (0, $lNvN4.useMediaClient)();
        return true;
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
        // Throws if no MediaClientProvider is found
        return false;
    }
};
const $b5004965e3772208$export$a504d7ec22d4b3f4 = ({ bridge: bridge, onNavigate: onNavigate })=>{
    return function ADFRendererNext(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b5004965e3772208$export$c334f442ba514f7d, {
            bridge: bridge,
            onNavigate: onNavigate,
            ...props
        });
    };
};
const $b5004965e3772208$export$c334f442ba514f7d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(29);
    const supportsMedia = $b5004965e3772208$var$useSupportsMedia();
    const { egress: egress, properties: properties, appDomainName: appDomainName, forgeEnvironment: forgeEnvironment, appId: appId, openNewTabAsPopupWindow: openNewTabAsPopupWindow } = (0, $cozmU.useContext)((0, $fTOZ6.RendererContext));
    const hostOnNavigate = props.onNavigate;
    const imagesEgressService = (0, $gFIer.useEgressPermissionService)("IMAGES", egress);
    const mediaEgressService = (0, $gFIer.useEgressPermissionService)("MEDIA", egress);
    const egressServices = [
        imagesEgressService,
        mediaEgressService
    ];
    const bridge = props.bridge;
    let t0;
    if ($[0] !== egress || $[1] !== properties) {
        t0 = {
            egress: egress,
            properties: properties
        };
        $[0] = egress;
        $[1] = properties;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== appId || $[4] !== hostOnNavigate || $[5] !== openNewTabAsPopupWindow || $[6] !== t0) {
        t1 = {
            extension: t0,
            appId: appId,
            onNavigate: hostOnNavigate,
            openNewTabAsPopupWindow: openNewTabAsPopupWindow
        };
        $[3] = appId;
        $[4] = hostOnNavigate;
        $[5] = openNewTabAsPopupWindow;
        $[6] = t0;
        $[7] = t1;
    } else t1 = $[7];
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $67Hav.useNavigation)(t1);
    const t2 = props.forgeDoc.props;
    let adfRendererProps;
    let document;
    let documentWithoutMedia;
    if ($[8] !== t2) {
        ({ document: document, documentWithoutMedia: documentWithoutMedia, ...adfRendererProps } = t2);
        $[8] = t2;
        $[9] = adfRendererProps;
        $[10] = document;
        $[11] = documentWithoutMedia;
    } else {
        adfRendererProps = $[9];
        document = $[10];
        documentWithoutMedia = $[11];
    }
    const doc = !supportsMedia && documentWithoutMedia ? documentWithoutMedia : document;
    if (!doc) {
        let t3;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
            $[12] = t3;
        } else t3 = $[12];
        return t3;
    }
    const { filteredDocument: filteredDocument, invalidUrls: invalidUrls } = $b5004965e3772208$var$filterInvalidMediaUrls(appDomainName, egressServices, doc);
    const t3 = forgeEnvironment === "DEVELOPMENT" && invalidUrls.map($b5004965e3772208$var$_temp);
    let t4;
    if ($[13] !== getModalJsx) {
        t4 = getModalJsx();
        $[13] = getModalJsx;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== adfRendererProps?.eventHandlers?.link || $[16] !== onNavigate) {
        t5 = {
            link: {
                onClick: (e)=>{
                    e.preventDefault();
                    adfRendererProps?.eventHandlers?.link?.onClick?.(e, e.currentTarget.href);
                    onNavigate({
                        type: "same-tab",
                        url: (0, $9XnlZ.sanitizeUrl)(e.currentTarget.href)
                    });
                }
            }
        };
        $[15] = adfRendererProps?.eventHandlers?.link;
        $[16] = onNavigate;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== bridge) {
        t6 = {
            "com.atlassian.ecosystem": (props_0)=>{
                const { localId: localId, parameters: parameters } = props_0;
                const { extension: extension, extensionData: extensionData, accountId: accountId, cloudId: cloudId, contextIds: contextIds } = parameters.extensionProperties;
                const config = parameters.guestParams || parameters.config;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4v1ex.ForgeUIRenderer), {
                    accountId: accountId,
                    cloudId: cloudId,
                    contextIds: contextIds,
                    extension: extension,
                    extensionData: extensionData,
                    extensionPayload: config ? {
                        config: config
                    } : undefined,
                    localId: localId,
                    product: "confluence",
                    bridge: bridge,
                    extensionViewData: $b5004965e3772208$var$EMPTY_EXTENSION_VIEW_DATA,
                    isEmbeddedMacro: true
                });
            }
        };
        $[18] = bridge;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== adfRendererProps || $[21] !== filteredDocument || $[22] !== t5 || $[23] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
            ...adfRendererProps,
            eventHandlers: t5,
            document: filteredDocument,
            extensionHandlers: t6
        }));
        $[20] = adfRendererProps;
        $[21] = filteredDocument;
        $[22] = t5;
        $[23] = t6;
        $[24] = t7;
    } else t7 = $[24];
    let t8;
    if ($[25] !== t3 || $[26] !== t4 || $[27] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t4, t7);
        $[25] = t3;
        $[26] = t4;
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : (props)=>{
    const supportsMedia = $b5004965e3772208$var$useSupportsMedia();
    const { egress: egress, properties: properties, appDomainName: appDomainName, forgeEnvironment: forgeEnvironment, appId: appId, openNewTabAsPopupWindow: openNewTabAsPopupWindow } = (0, $cozmU.useContext)((0, $fTOZ6.RendererContext));
    const hostOnNavigate = props.onNavigate;
    const imagesEgressService = (0, $gFIer.useEgressPermissionService)('IMAGES', egress);
    const mediaEgressService = (0, $gFIer.useEgressPermissionService)('MEDIA', egress);
    const egressServices = [
        imagesEgressService,
        mediaEgressService
    ];
    const bridge = props.bridge;
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $67Hav.useNavigation)({
        extension: {
            egress: egress,
            properties: properties
        },
        appId: appId,
        onNavigate: hostOnNavigate,
        openNewTabAsPopupWindow: openNewTabAsPopupWindow
    });
    const { document: document, documentWithoutMedia: documentWithoutMedia, ...adfRendererProps } = props.forgeDoc.props;
    // The client provides both the document with media and without media, as it doesn't know whether the MediaClientProvider is present
    // Then, in the parent product, we can decide whether to render the document with media or without media
    const doc = !supportsMedia && documentWithoutMedia ? documentWithoutMedia : document;
    if (!doc) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    const { filteredDocument: filteredDocument, invalidUrls: invalidUrls } = $b5004965e3772208$var$filterInvalidMediaUrls(appDomainName, egressServices, doc);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, forgeEnvironment === 'DEVELOPMENT' && invalidUrls.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6BvLK.EgressErrorMessage), {
            key: url,
            url: url
        })), getModalJsx(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        ...adfRendererProps,
        eventHandlers: {
            link: {
                onClick: (e)=>{
                    e.preventDefault();
                    adfRendererProps?.eventHandlers?.link?.onClick?.(e, e.currentTarget.href);
                    onNavigate({
                        type: 'same-tab',
                        url: (0, $9XnlZ.sanitizeUrl)(e.currentTarget.href)
                    });
                }
            }
        },
        document: filteredDocument,
        extensionHandlers: {
            'com.atlassian.ecosystem': (props_0)=>{
                const { localId: localId, parameters: parameters } = props_0;
                const { extension: extension, extensionData: extensionData, accountId: accountId, cloudId: cloudId, contextIds: contextIds } = parameters.extensionProperties;
                // Extract config from extension parameters (can be in guestParams or config)
                const config = parameters.guestParams || parameters.config;
                // ForgeUIRenderer will fetch fresh extension data from XLS when isEmbeddedMacro is true
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4v1ex.ForgeUIRenderer), {
                    accountId: accountId,
                    cloudId: cloudId,
                    contextIds: contextIds,
                    extension: extension,
                    extensionData: extensionData,
                    // Pass config via extensionPayload so it's available in context.extension.config
                    extensionPayload: config ? {
                        config: config
                    } : undefined,
                    localId: localId,
                    product: 'confluence',
                    bridge: bridge,
                    // Only required for bodied macros. Since we are currently not supporting embedded bodied macros, this should be empty.
                    extensionViewData: $b5004965e3772208$var$EMPTY_EXTENSION_VIEW_DATA,
                    isEmbeddedMacro: true
                });
            }
        }
    })));
};
function $b5004965e3772208$var$_temp(url) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6BvLK.EgressErrorMessage), {
        key: url,
        url: url
    });
}
module.exports["makeADFRenderer"] = $b5004965e3772208$export$a504d7ec22d4b3f4;
module.exports["AdfRenderer"] = $b5004965e3772208$export$c334f442ba514f7d;

});

parcelRegister("6BvLK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $fTOZ6 = parcelRequire("fTOZ6");


var $4aRua = parcelRequire("4aRua");


var $1VhsF = parcelRequire("1VhsF");


var $i1t43 = parcelRequire("i1t43");


var $kSwu1 = parcelRequire("kSwu1");

const $e1f51d3022ae5b60$var$messages = (0, $kSwu1.defineMessages)({
    pleaseUseThe: {
        id: "forge-ui.egressErrorMessage.please-use-the",
        defaultMessage: "Please use the"
    },
    dataImage: {
        id: "forge-ui.egressErrorMessage.data-image",
        defaultMessage: "data:image"
    },
    schemeForAnImageSource: {
        id: "forge-ui.egressErrorMessage.scheme-for-an-image-source",
        defaultMessage: "scheme for an image source"
    },
    egressPermissionsFor: {
        id: "forge-ui.egressErrorMessage.egress-permissions-for",
        defaultMessage: "Egress permissions for"
    },
    missingInTheManifestForMoreInformation: {
        id: "forge-ui.egressErrorMessage.missing-in-the-manifest-for-more-information",
        defaultMessage: "missing in the manifest. For more information"
    },
    seeReferenceDocs: {
        id: "forge-ui.egressErrorMessage.see-reference-docs",
        defaultMessage: "see reference docs"
    },
    unableToDisplayDueToImageLinkIssue: {
        id: "forge-ui.egressErrorMessage.unableToDisplayDueToImageLinkIssue",
        defaultMessage: "Unable to display due to an image link issue."
    }
});
const $e1f51d3022ae5b60$export$5cfbc54f19d7d1a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { url: url } = t0;
    const { forgeEnvironment: forgeEnvironment } = (0, $cozmU.useContext)((0, $fTOZ6.RendererContext));
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /^data/;
        $[0] = t1;
    } else t1 = $[0];
    const dataUriRegex = t1;
    let t2;
    if ($[1] !== url) {
        t2 = dataUriRegex.test(url);
        $[1] = url;
        $[2] = t2;
    } else t2 = $[2];
    const isDataUri = t2;
    const intl = (0, $kSwu1.useIntl)();
    if (forgeEnvironment === "DEVELOPMENT") {
        let t3;
        if ($[3] !== intl || $[4] !== isDataUri || $[5] !== url) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
                appearance: "error",
                testId: "egress-error-message"
            }, isDataUri ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage($e1f51d3022ae5b60$var$messages.pleaseUseThe), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "strong"
            }, intl.formatMessage($e1f51d3022ae5b60$var$messages.dataImage)), " ", intl.formatMessage($e1f51d3022ae5b60$var$messages.schemeForAnImageSource)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage($e1f51d3022ae5b60$var$messages.egressPermissionsFor), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: url,
                target: "_blank"
            }, url), " ", intl.formatMessage($e1f51d3022ae5b60$var$messages.missingInTheManifestForMoreInformation), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: "https://developer.atlassian.com/platform/forge/manifest-reference/permissions/#images",
                target: "_blank"
            }, intl.formatMessage($e1f51d3022ae5b60$var$messages.seeReferenceDocs)), "."));
            $[3] = intl;
            $[4] = isDataUri;
            $[5] = url;
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    let t3;
    if ($[7] !== intl) {
        t3 = intl.formatMessage($e1f51d3022ae5b60$var$messages.unableToDisplayDueToImageLinkIssue);
        $[7] = intl;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            appearance: "error"
        }, t3);
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ url: url })=>{
    const { forgeEnvironment: forgeEnvironment } = (0, $cozmU.useContext)((0, $fTOZ6.RendererContext));
    const dataUriRegex = /^data/;
    const isDataUri = dataUriRegex.test(url);
    const intl = (0, $kSwu1.useIntl)();
    if (forgeEnvironment === 'DEVELOPMENT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "error",
        testId: "egress-error-message"
    }, isDataUri ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage($e1f51d3022ae5b60$var$messages.pleaseUseThe), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong"
    }, intl.formatMessage($e1f51d3022ae5b60$var$messages.dataImage)), ' ', intl.formatMessage($e1f51d3022ae5b60$var$messages.schemeForAnImageSource)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage($e1f51d3022ae5b60$var$messages.egressPermissionsFor), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: url,
        target: "_blank"
    }, url), ' ', intl.formatMessage($e1f51d3022ae5b60$var$messages.missingInTheManifestForMoreInformation), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: "https://developer.atlassian.com/platform/forge/manifest-reference/permissions/#images",
        target: "_blank"
    }, intl.formatMessage($e1f51d3022ae5b60$var$messages.seeReferenceDocs)), "."));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "error"
    }, intl.formatMessage($e1f51d3022ae5b60$var$messages.unableToDisplayDueToImageLinkIssue));
};
module.exports["EgressErrorMessage"] = $e1f51d3022ae5b60$export$5cfbc54f19d7d1a4;

});

parcelRegister("HHXWG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jH9cM = parcelRequire("jH9cM");

var $i3S9F = parcelRequire("i3S9F");

var $8B1kb = parcelRequire("8B1kb");


var $bLswh = parcelRequire("bLswh");


var $gFIer = parcelRequire("gFIer");


var $6ojvx = parcelRequire("6ojvx");

var $fTOZ6 = parcelRequire("fTOZ6");


var $5cSJl = parcelRequire("5cSJl");


var $fmh8m = parcelRequire("fmh8m");

// --------------------------------------------------------------------------------------------------------------------
//
// NOTE: any changes to these hosts MUST BE applied to the Forge Monorepo -- and vice versa.
// See packages/forge-csp/src/csp/csp-injection-service.ts for the original source code.
//
// --------------------------------------------------------------------------------------------------------------------
/**
 * Media API is used to store product attachments.
 * URLs are defined here: https://developer.atlassian.com/platform/media/support/faq/#which-environment-should-i-use-
 */ const $2366eacaa9780503$var$ATLASSIAN_API_GATEWAY_HOST = {
    dev: 'https://api.dev.atlassian.com',
    stg: 'https://api.stg.atlassian.com',
    prod: 'https://api.atlassian.com',
    'fedramp-stg': 'https://api.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://api.atlassian-us-gov-mod.com'
};
const $2366eacaa9780503$var$ATLASSIAN_ASSETS_MEDIA_HOST = {
    dev: 'https://assets-media.stg.atlassian.com',
    stg: 'https://assets-media.stg.atlassian.com',
    prod: 'https://assets-media.atlassian.com',
    'fedramp-stg': 'https://assets-media.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://assets-media.atlassian-us-gov-mod.com'
};
const $2366eacaa9780503$var$ATLASSIAN_MEDIA_GATEWAY_HOST = {
    dev: 'https://media.dev.atl-paas.net',
    stg: 'https://media.staging.atl-paas.net',
    prod: 'https://api.media.atlassian.com',
    'fedramp-stg': 'https://api-media.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://api-media.atlassian-us-gov-mod.com'
};
const $2366eacaa9780503$var$ATLASSIAN_AVATAR_HOST = {
    dev: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
    stg: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
    prod: 'avatar-management--avatars.us-west-2.prod.public.atl-paas.net',
    'fedramp-stg': 'avatar-management--avatars.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
    'fedramp-prod': 'avatar-management--avatars.us-east-1.prod.cdn.atlassian-us-gov-mod.com'
};
const $2366eacaa9780503$var$ATLASSIAN_EMOJIS_HOST = {
    dev: 'https://pf-emoji-service.ddev.frontend.public.atl-paas.net',
    stg: 'https://pf-emoji-service.stg-east.frontend.public.atl-paas.net',
    prod: 'https://pf-emoji-service.prod-east.frontend.public.atl-paas.net',
    'fedramp-stg': 'https://pf-emoji-service.frontend.staging.cdn.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://pf-emoji-service.frontend.cdn.atlassian-us-gov-mod.com'
};
const $2366eacaa9780503$var$ATLASSIAN_TEAM_HEADER_HOST = {
    dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
    stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
    prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/gradients/',
    'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
    'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/'
};
const $2366eacaa9780503$var$ATLASSIAN_TEAM_AVATAR_HOST = {
    dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
    stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
    prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/',
    'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
    'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/'
};
/**
 * Atlassian products use Wordpress as a proxy to serve avatar images in certain conditions.
 * Not allowing them by default forces developers to add the `*.wp.com` domain to the CSP image policy.
 * See: https://hello.atlassian.net/wiki/x/XJpuCgE
 */ const $2366eacaa9780503$var$ATLASSIAN_IMAGES_HOSTS = {
    dev: [
        `https://${$2366eacaa9780503$var$ATLASSIAN_AVATAR_HOST['dev']}`,
        `https://*.wp.com/${$2366eacaa9780503$var$ATLASSIAN_AVATAR_HOST['dev']}/`,
        $2366eacaa9780503$var$ATLASSIAN_API_GATEWAY_HOST['dev'],
        $2366eacaa9780503$var$ATLASSIAN_MEDIA_GATEWAY_HOST['dev'],
        $2366eacaa9780503$var$ATLASSIAN_EMOJIS_HOST['dev'],
        $2366eacaa9780503$var$ATLASSIAN_TEAM_AVATAR_HOST['dev'],
        $2366eacaa9780503$var$ATLASSIAN_TEAM_HEADER_HOST['dev'],
        $2366eacaa9780503$var$ATLASSIAN_ASSETS_MEDIA_HOST['dev']
    ],
    stg: [
        `https://${$2366eacaa9780503$var$ATLASSIAN_AVATAR_HOST['stg']}`,
        `https://*.wp.com/${$2366eacaa9780503$var$ATLASSIAN_AVATAR_HOST['stg']}/`,
        $2366eacaa9780503$var$ATLASSIAN_API_GATEWAY_HOST['stg'],
        $2366eacaa9780503$var$ATLASSIAN_MEDIA_GATEWAY_HOST['stg'],
        $2366eacaa9780503$var$ATLASSIAN_EMOJIS_HOST['stg'],
        $2366eacaa9780503$var$ATLASSIAN_TEAM_AVATAR_HOST['stg'],
        $2366eacaa9780503$var$ATLASSIAN_TEAM_HEADER_HOST['stg'],
        $2366eacaa9780503$var$ATLASSIAN_ASSETS_MEDIA_HOST['stg']
    ],
    prod: [
        `https://${$2366eacaa9780503$var$ATLASSIAN_AVATAR_HOST['prod']}`,
        `https://*.wp.com/${$2366eacaa9780503$var$ATLASSIAN_AVATAR_HOST['prod']}/`,
        $2366eacaa9780503$var$ATLASSIAN_API_GATEWAY_HOST['prod'],
        $2366eacaa9780503$var$ATLASSIAN_MEDIA_GATEWAY_HOST['prod'],
        $2366eacaa9780503$var$ATLASSIAN_EMOJIS_HOST['prod'],
        $2366eacaa9780503$var$ATLASSIAN_TEAM_AVATAR_HOST['prod'],
        $2366eacaa9780503$var$ATLASSIAN_TEAM_HEADER_HOST['prod'],
        $2366eacaa9780503$var$ATLASSIAN_ASSETS_MEDIA_HOST['prod']
    ],
    'fedramp-stg': [
        `https://${$2366eacaa9780503$var$ATLASSIAN_AVATAR_HOST['fedramp-stg']}`,
        `https://*.wp.com/${$2366eacaa9780503$var$ATLASSIAN_AVATAR_HOST['fedramp-stg']}/`,
        $2366eacaa9780503$var$ATLASSIAN_API_GATEWAY_HOST['fedramp-stg'],
        $2366eacaa9780503$var$ATLASSIAN_MEDIA_GATEWAY_HOST['fedramp-stg'],
        $2366eacaa9780503$var$ATLASSIAN_EMOJIS_HOST['fedramp-stg'],
        $2366eacaa9780503$var$ATLASSIAN_TEAM_AVATAR_HOST['fedramp-stg'],
        $2366eacaa9780503$var$ATLASSIAN_TEAM_HEADER_HOST['fedramp-stg'],
        $2366eacaa9780503$var$ATLASSIAN_ASSETS_MEDIA_HOST['fedramp-stg']
    ],
    'fedramp-prod': [
        `https://${$2366eacaa9780503$var$ATLASSIAN_AVATAR_HOST['fedramp-prod']}`,
        `https://*.wp.com/${$2366eacaa9780503$var$ATLASSIAN_AVATAR_HOST['fedramp-prod']}/`,
        $2366eacaa9780503$var$ATLASSIAN_API_GATEWAY_HOST['fedramp-prod'],
        $2366eacaa9780503$var$ATLASSIAN_MEDIA_GATEWAY_HOST['fedramp-prod'],
        $2366eacaa9780503$var$ATLASSIAN_EMOJIS_HOST['fedramp-prod'],
        $2366eacaa9780503$var$ATLASSIAN_TEAM_AVATAR_HOST['fedramp-prod'],
        $2366eacaa9780503$var$ATLASSIAN_TEAM_HEADER_HOST['fedramp-prod'],
        $2366eacaa9780503$var$ATLASSIAN_ASSETS_MEDIA_HOST['fedramp-prod']
    ]
};
// --------------------------------------------------------------------------------------------------------------------
/**
 * Gravatar is still used internally to serve legacy Atlassian avatars.
 * Unsplash is integrated by default in Confluence to the header image picker functionality.
 */ const $2366eacaa9780503$var$EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = [
    'https://secure.gravatar.com',
    'https://images.unsplash.com'
];
const $2366eacaa9780503$export$189ea7794c50ff15 = (url, iframeDomainName)=>{
    if (!iframeDomainName) return false;
    let imageSrcUrl;
    try {
        imageSrcUrl = new URL(url);
        // Image is valid if it comes from the same domain as the iframe OR if it's being served from localhost (when using forge tunnel)
        return iframeDomainName === imageSrcUrl.host || imageSrcUrl.hostname === 'localhost';
    } catch (e) {
        return false;
    }
};
const $2366eacaa9780503$var$getImageHostsEnvironment = (environment)=>{
    if ((0, $jH9cM.isFedRamp)()) {
        if (environment === (0, $bLswh.ProductEnvironment).STAGING) return 'fedramp-stg';
        return 'fedramp-prod';
    }
    return (0, $5cSJl.getCDNEnvironment)(environment);
};
const $2366eacaa9780503$var$getImageHostsEnvironmentForIC = (environment)=>{
    return environment === (0, $bLswh.ProductEnvironment).PRODUCTION ? 'ic-prod' : 'ic-stg';
};
const $2366eacaa9780503$var$getAtlassianImageHosts = (environment)=>{
    if ((0, $i3S9F.isIsolatedCloud)()) {
        const icImageHostsEnvironment = $2366eacaa9780503$var$getImageHostsEnvironmentForIC(environment);
        return (0, $fmh8m.getAtlassianImageHost)(icImageHostsEnvironment, {
            getICDomain: ()=>(0, $8B1kb.isolatedCloudDomain)()
        });
    }
    const imageHostsEnvironment = $2366eacaa9780503$var$getImageHostsEnvironment(environment);
    return (0, $fmh8m.getAtlassianImageHost)(imageHostsEnvironment);
};
const $2366eacaa9780503$export$3a08b61b3ed9a4da = (0, $gtMdU.isReactCompilerActivePlatform)() ? (url)=>{
    const $ = (0, $bDgLe.c)(13);
    const { egress: egress, appDomainName: appDomainName } = (0, $cozmU.useContext)((0, $fTOZ6.RendererContext));
    const environment = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    let t0;
    if ($[0] !== environment) {
        t0 = [
            window.location.hostname,
            ...$2366eacaa9780503$var$getAtlassianImageHosts(environment),
            ...$2366eacaa9780503$var$EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS
        ];
        $[0] = environment;
        $[1] = t0;
    } else t0 = $[1];
    const allowListedImageHosts = t0;
    let t1;
    if ($[2] !== egress) {
        t1 = egress || [];
        $[2] = egress;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== allowListedImageHosts) {
        t2 = {
            type: "IMAGES",
            addresses: allowListedImageHosts
        };
        $[4] = allowListedImageHosts;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
        t3 = [
            ...t1,
            t2
        ];
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    const egressService = (0, $gFIer.useEgressPermissionService)("IMAGES", t3);
    let t4;
    if ($[9] !== appDomainName || $[10] !== egressService || $[11] !== url) {
        t4 = $2366eacaa9780503$export$6e0a24fd7459483a(url, egressService, appDomainName);
        $[9] = appDomainName;
        $[10] = egressService;
        $[11] = url;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : (url)=>{
    const { egress: egress, appDomainName: appDomainName } = (0, $cozmU.useContext)((0, $fTOZ6.RendererContext));
    const environment = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const allowListedImageHosts = [
        window.location.hostname,
        ...$2366eacaa9780503$var$getAtlassianImageHosts(environment),
        ...$2366eacaa9780503$var$EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS
    ];
    const egressService = (0, $gFIer.useEgressPermissionService)('IMAGES', [
        ...egress || [],
        {
            type: 'IMAGES',
            addresses: allowListedImageHosts
        }
    ]);
    return $2366eacaa9780503$export$6e0a24fd7459483a(url, egressService, appDomainName);
};
const $2366eacaa9780503$export$6e0a24fd7459483a = (url, egressService, appDomainName)=>{
    const dataImageUrlRegex = /^data:image/;
    try {
        const isValidUrl = $2366eacaa9780503$export$189ea7794c50ff15(url, appDomainName) || dataImageUrlRegex.test(url) || egressService.isValidUrl(url);
        return isValidUrl;
    } catch (e) {
        return false;
    }
};
module.exports["useIsValidImageUrl"] = $2366eacaa9780503$export$3a08b61b3ed9a4da;
module.exports["isValidImageUrl"] = $2366eacaa9780503$export$6e0a24fd7459483a;

});

parcelRegister("l1S8W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fbwmZ = parcelRequire("fbwmZ");


$fbwmZ.__exportStar((parcelRequire("cdeoi")), module.exports);

$fbwmZ.__exportStar((parcelRequire("iftLz")), module.exports);

});

parcelRegister("cdeoi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CSPInjectionService = module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = module.exports.getAtlassianImageHost = void 0;

var $gq22v = parcelRequire("gq22v");

const $024b6286f43753db$var$isICEnvKey = (env)=>env === 'ic-prod' || env === 'ic-stg';
const $024b6286f43753db$var$makeICDomain = (env, icLabel)=>`${icLabel}.${env === 'ic-prod' ? 'atlassian-isolated.net' : 'oasis-stg.com'}`;
const $024b6286f43753db$var$getICDomain = (env, icOptions)=>{
    if ('getICDomain' in icOptions) return icOptions.getICDomain();
    return $024b6286f43753db$var$makeICDomain(env, icOptions.icLabel);
};
const $024b6286f43753db$var$makeICHosts = (targetHostFunction)=>{
    return {
        'ic-stg': (icOptions)=>targetHostFunction('ic-stg', icOptions),
        'ic-prod': (icOptions)=>targetHostFunction('ic-prod', icOptions)
    };
};
const $024b6286f43753db$var$ATLASSIAN_HOST = {
    ATLASSIAN_API_GATEWAY_HOST: {
        dev: 'https://api.dev.atlassian.com',
        stg: 'https://api.stg.atlassian.com',
        prod: 'https://api.atlassian.com',
        'fedramp-stg': 'https://api.stg.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://api.atlassian-us-gov-mod.com',
        ...$024b6286f43753db$var$makeICHosts((env, icOptions)=>`https://api.${$024b6286f43753db$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_MEDIA_GATEWAY_HOST: {
        dev: 'https://media.dev.atl-paas.net',
        stg: 'https://media.staging.atl-paas.net',
        prod: 'https://api.media.atlassian.com',
        'fedramp-stg': 'https://api-media.stg.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://api-media.atlassian-us-gov-mod.com',
        ...$024b6286f43753db$var$makeICHosts((env, icOptions)=>`https://media-api.${$024b6286f43753db$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_ASSETS_MEDIA_HOST: {
        dev: 'https://assets-media.stg.atlassian.com',
        stg: 'https://assets-media.stg.atlassian.com',
        prod: 'https://assets-media.atlassian.com',
        'fedramp-stg': 'https://assets-media.stg.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://assets-media.atlassian-us-gov-mod.com',
        ...$024b6286f43753db$var$makeICHosts((env, icOptions)=>`https://assets-media.${$024b6286f43753db$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_ANALYTICS_GATEWAY_HOST: {
        dev: 'https://as.dev.atl-paas.net',
        stg: 'https://as.staging.atl-paas.net',
        prod: 'https://as.atlassian.com',
        'fedramp-stg': 'https://as.stg.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://as.atlassian-us-gov-mod.com',
        ...$024b6286f43753db$var$makeICHosts((env, icOptions)=>`https://as.${$024b6286f43753db$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_AVATAR_HOST: {
        dev: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
        stg: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
        prod: 'avatar-management--avatars.us-west-2.prod.public.atl-paas.net',
        'fedramp-stg': 'avatar-management--avatars.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
        'fedramp-prod': 'avatar-management--avatars.us-east-1.prod.cdn.atlassian-us-gov-mod.com',
        ...$024b6286f43753db$var$makeICHosts((env, icOptions)=>`avatar-management.services.${$024b6286f43753db$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_TEAM_HEADER_HOST: {
        dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
        stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
        prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/gradients/',
        'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        ...$024b6286f43753db$var$makeICHosts((env, icOptions)=>`https://teams-directory-frontend.services.${$024b6286f43753db$var$getICDomain(env, icOptions)}/bfa/`)
    },
    ATLASSIAN_TEAM_AVATAR_HOST: {
        dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
        stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
        prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/',
        'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        ...$024b6286f43753db$var$makeICHosts((env, icOptions)=>`https://teams-directory-frontend.services.${$024b6286f43753db$var$getICDomain(env, icOptions)}/bfa/`)
    },
    ATLASSIAN_EMOJIS_HOST: {
        dev: 'https://pf-emoji-service.ddev.frontend.public.atl-paas.net',
        stg: 'https://pf-emoji-service.stg-east.frontend.public.atl-paas.net',
        prod: 'https://pf-emoji-service.prod-east.frontend.public.atl-paas.net',
        'fedramp-stg': 'https://pf-emoji-service.frontend.staging.cdn.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://pf-emoji-service.frontend.cdn.atlassian-us-gov-mod.com',
        ...$024b6286f43753db$var$makeICHosts((env, icOptions)=>`https://pf-emoji-service.${$024b6286f43753db$var$getICDomain(env, icOptions)}/bfa/emoji-service/`)
    },
    ATLASSIAN_REACTIONS_HOST: {
        dev: 'https://pf-reactions-service.ddev.frontend.public.atl-paas.net',
        stg: 'https://pf-reactions-service.stg-east.frontend.public.atl-paas.net',
        prod: 'https://pf-reactions-service.prod-east.frontend.public.atl-paas.net',
        'fedramp-stg': 'https://pf-reactions-service.frontend.staging.cdn.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://pf-reactions-service.frontend.cdn.atlassian-us-gov-mod.com',
        ...$024b6286f43753db$var$makeICHosts((env, icOptions)=>`https://pf-reactions-service.services.${$024b6286f43753db$var$getICDomain(env, icOptions)}/bfa/reactions-service/`)
    },
    ATLASSIAN_FOP_GE_HOST: {
        dev: 'https://forge-outbound-proxy.dev.services.atlassian.com',
        stg: 'https://forge-outbound-proxy.stg.services.atlassian.com',
        prod: 'https://forge-outbound-proxy.services.atlassian.com',
        'fedramp-stg': '',
        'fedramp-prod': '',
        ...$024b6286f43753db$var$makeICHosts((env, icOptions)=>'')
    },
    ATLASSIAN_FOS_HOST: {
        dev: 'https://tdp-os.dev.services.atlassian.com',
        stg: 'https://tdp-os.stg.services.atlassian.com',
        prod: 'https://tdp-os.services.atlassian.com',
        'fedramp-stg': 'https://tdp-os.stg.services.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://tdp-os.services.atlassian-us-gov-mod.com',
        ...$024b6286f43753db$var$makeICHosts((env, icOptions)=>`https://tdp-os.services.${$024b6286f43753db$var$getICDomain(env, icOptions)}`)
    }
};
const $024b6286f43753db$var$getAtlassianHost = (hostType, microsEnv, icOptions)=>{
    const hostMap = $024b6286f43753db$var$ATLASSIAN_HOST[hostType];
    if ($024b6286f43753db$var$isICEnvKey(microsEnv)) {
        if (!icOptions) throw new Error('Missing IC label');
        return hostMap[microsEnv](icOptions);
    }
    return hostMap[microsEnv];
};
const $024b6286f43753db$var$FOS_CDN_STANDARD_HOST = {
    dev: 'https://object-store.stg.atlassian.com',
    stg: 'https://object-store.stg.atlassian.com',
    prod: 'https://object-store.atlassian.com'
};
const $024b6286f43753db$var$FOS_CDN_IC_HOST = $024b6286f43753db$var$makeICHosts((env, icOptions)=>`https://object-store.${$024b6286f43753db$var$getICDomain(env, icOptions)}`);
const $024b6286f43753db$var$FOS_CDN_PATH = '/os/ecosystem/installation/';
const $024b6286f43753db$var$getFOSCDNHost = (microsEnv, icOptions)=>{
    if ($024b6286f43753db$var$isICEnvKey(microsEnv)) return icOptions ? $024b6286f43753db$var$FOS_CDN_IC_HOST[microsEnv](icOptions) : undefined;
    return $024b6286f43753db$var$FOS_CDN_STANDARD_HOST[microsEnv];
};
const $024b6286f43753db$var$getFOSHostDownload = (microsEnv, icOptions)=>{
    const fosHost = $024b6286f43753db$var$getAtlassianHost('ATLASSIAN_FOS_HOST', microsEnv, icOptions);
    return $024b6286f43753db$var$isICEnvKey(microsEnv) ? [
        `${fosHost}/fos/app/download/`,
        `${fosHost}/fos/cdn/download/`
    ] : [
        `${fosHost}/fos-eap/download/`,
        `${fosHost}/fos/app/download/`,
        `${fosHost}/fos/cdn/download/`
    ];
};
const $024b6286f43753db$var$getFOSHostUpload = (microsEnv, icOptions)=>{
    const fosHost = $024b6286f43753db$var$getAtlassianHost('ATLASSIAN_FOS_HOST', microsEnv, icOptions);
    return $024b6286f43753db$var$isICEnvKey(microsEnv) ? [
        `${fosHost}/fos/app/upload/`,
        `${fosHost}/fos/cdn/upload/`
    ] : [
        `${fosHost}/fos-eap/upload/`,
        `${fosHost}/fos/app/upload/`,
        `${fosHost}/fos/cdn/upload/`
    ];
};
const $024b6286f43753db$var$getFOSCDNUrls = (microsEnv, icOptions)=>{
    const fosCDNHost = $024b6286f43753db$var$getFOSCDNHost(microsEnv, icOptions);
    return fosCDNHost ? [
        `${fosCDNHost}${$024b6286f43753db$var$FOS_CDN_PATH}`
    ] : [];
};
const $024b6286f43753db$var$getReactionsImageHost = (microsEnv, icOptions)=>{
    const host = $024b6286f43753db$var$getAtlassianHost('ATLASSIAN_REACTIONS_HOST', microsEnv, icOptions);
    return host ? [
        host
    ] : [];
};
const $024b6286f43753db$var$getAtlassianImageHost = (microsEnv, icOptions)=>{
    return [
        `https://${$024b6286f43753db$var$getAtlassianHost('ATLASSIAN_AVATAR_HOST', microsEnv, icOptions)}`,
        `https://*.wp.com/${$024b6286f43753db$var$getAtlassianHost('ATLASSIAN_AVATAR_HOST', microsEnv, icOptions)}/`,
        $024b6286f43753db$var$getAtlassianHost('ATLASSIAN_API_GATEWAY_HOST', microsEnv, icOptions),
        $024b6286f43753db$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions),
        $024b6286f43753db$var$getAtlassianHost('ATLASSIAN_EMOJIS_HOST', microsEnv, icOptions),
        ...$024b6286f43753db$var$getReactionsImageHost(microsEnv, icOptions),
        $024b6286f43753db$var$getAtlassianHost('ATLASSIAN_ASSETS_MEDIA_HOST', microsEnv, icOptions),
        $024b6286f43753db$var$getAtlassianHost('ATLASSIAN_TEAM_AVATAR_HOST', microsEnv, icOptions),
        $024b6286f43753db$var$getAtlassianHost('ATLASSIAN_TEAM_HEADER_HOST', microsEnv, icOptions),
        ...$024b6286f43753db$var$getFOSHostDownload(microsEnv, icOptions),
        ...$024b6286f43753db$var$getFOSCDNUrls(microsEnv, icOptions)
    ];
};
module.exports.getAtlassianImageHost = $024b6286f43753db$var$getAtlassianImageHost;
module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = [
    'https://secure.gravatar.com',
    'https://images.unsplash.com'
];
class $024b6286f43753db$var$CSPInjectionService {
    getCSPReportUri(microsEnv, icOptions) {
        const serviceName = $024b6286f43753db$var$isICEnvKey(microsEnv) && icOptions ? icOptions.serviceName : 'forge-cdn';
        if (microsEnv === 'dev' || microsEnv === 'stg') return `https://web-security-reports.stg.services.atlassian.com/csp-report/${serviceName}`;
        return `https://web-security-reports.services.atlassian.com/csp-report/${serviceName}`;
    }
    getForgeGlobalCSP(microsEnv, isFedRAMP = false, icOptions) {
        if ($024b6286f43753db$var$isICEnvKey(microsEnv) && icOptions) return `https://forge.forge-cdn.${$024b6286f43753db$var$getICDomain(microsEnv, icOptions)}`;
        return isFedRAMP ? `https://forge.cdn.${microsEnv.split('-')[1]}.atlassian-dev-us-gov-mod.net` : `https://forge.cdn.${microsEnv}.atlassian-dev.net`;
    }
    getMetalClientCSP(microsEnv, icOptions) {
        if ($024b6286f43753db$var$isICEnvKey(microsEnv) && icOptions) return `https://api.${$024b6286f43753db$var$getICDomain(microsEnv, icOptions)}/metal/ingest`;
        return `https://api.${microsEnv === 'prod' ? '' : 'stg.'}atlassian.com/metal/ingest`;
    }
    getExistingCSPDetails(cspType, cspDetails) {
        var _a;
        return (_a = cspDetails[cspType]) !== null && _a !== void 0 ? _a : [];
    }
    getConnectSrc(microsEnv, isTunnelling, icOptions) {
        const allowed = [];
        if (isTunnelling) allowed.push(...[
            'ws://localhost:*',
            'http://localhost:*'
        ]);
        const metalClientCSP = this.getMetalClientCSP(microsEnv, icOptions);
        allowed.push(metalClientCSP);
        allowed.push(`${$024b6286f43753db$var$getAtlassianHost('ATLASSIAN_API_GATEWAY_HOST', microsEnv, icOptions)}/gateway/api/emoji/`);
        allowed.push(`${$024b6286f43753db$var$getAtlassianHost('ATLASSIAN_API_GATEWAY_HOST', microsEnv, icOptions)}/gateway/api/elements/emoji`);
        allowed.push($024b6286f43753db$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions));
        allowed.push($024b6286f43753db$var$getAtlassianHost('ATLASSIAN_ANALYTICS_GATEWAY_HOST', microsEnv, icOptions));
        const fopGeHost = $024b6286f43753db$var$getAtlassianHost('ATLASSIAN_FOP_GE_HOST', microsEnv, icOptions);
        if (fopGeHost) allowed.push(fopGeHost);
        allowed.push(...$024b6286f43753db$var$getFOSHostDownload(microsEnv, icOptions));
        allowed.push(...$024b6286f43753db$var$getFOSHostUpload(microsEnv, icOptions));
        allowed.push(...$024b6286f43753db$var$getFOSCDNUrls(microsEnv, icOptions));
        return allowed;
    }
    getFrameAncestors(microsEnv, hostname, icOptions, macroParentHost, connectMacroParentDomain, parentEmbeddingDomain) {
        let frameAncestors = [];
        const localhostWithPortRegex = /^localhost:\d+$/;
        switch(microsEnv){
            case 'dev':
            case 'stg':
                frameAncestors = [
                    '*.jira-dev.com',
                    'http://localhost:*',
                    'http://devbucket.localhost',
                    'https://integration.bb-inf.net',
                    '*.atl-paas.net',
                    '*.stg.atlassian.com'
                ];
                if (macroParentHost && !localhostWithPortRegex.test(macroParentHost)) frameAncestors.push(`${macroParentHost}.cdn.stg.atlassian-dev.net`);
                break;
            case 'fedramp-stg':
                frameAncestors = [
                    '*.atlassian-stg-fedm.net'
                ];
                break;
            case 'fedramp-prod':
                frameAncestors = [
                    '*.atlassian-us-gov-mod.net'
                ];
                break;
            case 'ic-stg':
            case 'ic-prod':
                if (icOptions) frameAncestors = [
                    `*.${$024b6286f43753db$var$getICDomain(microsEnv, icOptions)}`
                ];
                break;
            case 'prod':
            default:
                frameAncestors = [
                    '*.atlassian.net',
                    'bitbucket.org',
                    '*.jira.com',
                    '*.atlassian.com',
                    '*.frontend.public.atl-paas.net'
                ];
                if (macroParentHost) {
                    if (localhostWithPortRegex.test(macroParentHost)) frameAncestors.push(`http://${macroParentHost}`);
                    else frameAncestors.push(`${macroParentHost}.cdn.prod.atlassian-dev.net`);
                }
                break;
        }
        if (connectMacroParentDomain) frameAncestors.push(connectMacroParentDomain);
        if (parentEmbeddingDomain) frameAncestors.push(parentEmbeddingDomain);
        if (hostname) frameAncestors.push(hostname);
        return frameAncestors;
    }
    constructor(){
        this.getInjectableCSP = ({ existingCSPDetails: existingCSPDetails, microsEnv: microsEnv, tunnelCSPReporterUri: tunnelCSPReporterUri, hostname: hostname, isFedRAMP: isFedRAMP, icOptions: icOptions, macroParentHost: macroParentHost, connectMacroParentDomain: connectMacroParentDomain, parentEmbeddingDomain: parentEmbeddingDomain })=>{
            const reportUri = tunnelCSPReporterUri || this.getCSPReportUri(microsEnv, icOptions);
            const fosCDNUrls = $024b6286f43753db$var$getFOSCDNUrls(microsEnv, icOptions);
            const defaultSrc = [
                "'self'",
                ...$024b6286f43753db$var$getFOSHostDownload(microsEnv, icOptions),
                ...fosCDNUrls
            ].join(' ');
            const frameAncestors = [
                "'self'",
                ...this.getFrameAncestors(microsEnv, hostname, icOptions, macroParentHost, connectMacroParentDomain, parentEmbeddingDomain),
                ...$024b6286f43753db$var$getFOSHostDownload(microsEnv, icOptions),
                ...fosCDNUrls
            ].join(' ');
            const frameSrc = [
                "'self'",
                hostname,
                $024b6286f43753db$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions),
                ...this.getExistingCSPDetails($gq22v.ExternalCspType.FRAME_SRC, existingCSPDetails),
                ...$024b6286f43753db$var$getFOSHostDownload(microsEnv, icOptions),
                ...fosCDNUrls
            ].filter((a)=>a).join(' ');
            const fontSrc = [
                "'self'",
                ...$024b6286f43753db$var$getFOSHostDownload(microsEnv, icOptions),
                ...fosCDNUrls,
                ...this.getExistingCSPDetails($gq22v.ExternalCspType.FONT_SRC, existingCSPDetails)
            ].join(' ');
            const imgSrc = [
                "'self'",
                'data:',
                'blob:',
                hostname,
                ...module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS,
                ...(0, module.exports.getAtlassianImageHost)(microsEnv, icOptions),
                ...this.getExistingCSPDetails($gq22v.ExternalCspType.IMG_SRC, existingCSPDetails)
            ].filter((a)=>a).join(' ');
            const mediaSrc = [
                "'self'",
                'data:',
                'blob:',
                hostname,
                $024b6286f43753db$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions),
                ...this.getExistingCSPDetails($gq22v.ExternalCspType.MEDIA_SRC, existingCSPDetails),
                ...$024b6286f43753db$var$getFOSHostDownload(microsEnv, icOptions),
                ...fosCDNUrls
            ].filter((a)=>a).join(' ');
            const connectSrc = [
                "'self'",
                hostname,
                ...this.getConnectSrc(microsEnv, !!tunnelCSPReporterUri, icOptions),
                this.getForgeGlobalCSP(microsEnv, isFedRAMP, icOptions),
                ...this.getExistingCSPDetails($gq22v.ExternalCspType.CONNECT_SRC, existingCSPDetails)
            ].filter((a)=>a).join(' ');
            const scriptSrc = [
                "'self'",
                this.getForgeGlobalCSP(microsEnv, isFedRAMP, icOptions),
                ...$024b6286f43753db$var$getFOSHostDownload(microsEnv, icOptions),
                ...fosCDNUrls,
                ...this.getExistingCSPDetails($gq22v.ExternalCspType.SCRIPT_SRC, existingCSPDetails)
            ].join(' ');
            const styleSrc = [
                "'self'",
                hostname,
                this.getForgeGlobalCSP(microsEnv, isFedRAMP, icOptions),
                ...$024b6286f43753db$var$getFOSHostDownload(microsEnv, icOptions),
                ...fosCDNUrls,
                ...this.getExistingCSPDetails($gq22v.ExternalCspType.STYLE_SRC, existingCSPDetails)
            ].filter((a)=>a).join(' ');
            return [
                `default-src ${defaultSrc}`,
                `frame-ancestors ${frameAncestors}`,
                `frame-src ${frameSrc}`,
                `font-src ${fontSrc}`,
                `img-src ${imgSrc}`,
                `media-src ${mediaSrc}`,
                `connect-src ${connectSrc}`,
                `script-src ${scriptSrc}`,
                `style-src ${styleSrc}`,
                `form-action 'self'`,
                `sandbox allow-popups allow-popups-to-escape-sandbox allow-downloads allow-forms allow-modals allow-pointer-lock allow-same-origin allow-scripts`,
                `report-uri ${reportUri}`
            ];
        };
    }
}
module.exports.CSPInjectionService = $024b6286f43753db$var$CSPInjectionService;

});

parcelRegister("gq22v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExternalCspType = void 0;
var $bf40a80e72d5f084$var$ExternalCspType;
(function(ExternalCspType) {
    ExternalCspType["IMG_SRC"] = "img-src";
    ExternalCspType["MEDIA_SRC"] = "media-src";
    ExternalCspType["SCRIPT_SRC"] = "script-src";
    ExternalCspType["STYLE_SRC"] = "style-src";
    ExternalCspType["CONNECT_SRC"] = "connect-src";
    ExternalCspType["FONT_SRC"] = "font-src";
    ExternalCspType["FRAME_SRC"] = "frame-src";
})($bf40a80e72d5f084$var$ExternalCspType || (module.exports.ExternalCspType = $bf40a80e72d5f084$var$ExternalCspType = {}));

});

parcelRegister("iftLz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CSPProcessingService = module.exports.InvalidConnectSrc = void 0;

var $fbwmZ = parcelRequire("fbwmZ");


const $d490b7aafc613b68$var$content_security_policy_parser_1 = $fbwmZ.__importDefault((parcelRequire("23uMP")));

const $d490b7aafc613b68$var$crypto_1 = $fbwmZ.__importDefault((parcelRequire("5rA68")));
class $d490b7aafc613b68$var$InvalidConnectSrc extends Error {
    constructor(){
        super('fetch.client should be an array of strings');
    }
}
module.exports.InvalidConnectSrc = $d490b7aafc613b68$var$InvalidConnectSrc;
class $d490b7aafc613b68$var$CSPProcessingService {
    getCspDetails(body, permissions) {
        var _a, _b;
        const { scripts: scripts, styles: styles } = (_a = permissions === null || permissions === void 0 ? void 0 : permissions.content) !== null && _a !== void 0 ? _a : {
            scripts: [],
            styles: []
        };
        const external = (_b = permissions === null || permissions === void 0 ? void 0 : permissions.external) !== null && _b !== void 0 ? _b : {};
        const $ = this.cheerioLoader(body, {
            xml: {
                xmlMode: false
            }
        });
        const { 'script-src': scriptSrc, 'style-src': styleSrc, ...mappedExternalCsp } = this.mapExternalPermissionsToCsp(external);
        return {
            'style-src': [
                ...this.getStyleSrc($, styles),
                ...styleSrc
            ],
            'script-src': [
                ...this.getScriptSrc($, scripts),
                ...scriptSrc
            ],
            ...mappedExternalCsp
        };
    }
    getInvalidCspPermissions(contentPermissions) {
        var _a, _b;
        const { styles: styles, scripts: scripts } = contentPermissions;
        const invalidStyles = (_a = styles === null || styles === void 0 ? void 0 : styles.filter((styleSrc)=>!this.isValidUserStyleSrc(`'${styleSrc}'`))) !== null && _a !== void 0 ? _a : [];
        const invalidScripts = (_b = scripts === null || scripts === void 0 ? void 0 : scripts.filter((scriptSrc)=>!this.isValidUserScriptSrc(scriptSrc))) !== null && _b !== void 0 ? _b : [];
        return [
            ...invalidStyles,
            ...invalidScripts
        ];
    }
    assertValidFetchClient(fetch) {
        if (fetch === null || fetch === void 0 ? void 0 : fetch.client) for (const client of fetch === null || fetch === void 0 ? void 0 : fetch.client){
            if (typeof client !== 'string') throw new $d490b7aafc613b68$var$InvalidConnectSrc();
        }
    }
    egressesToStringMap(externalPermissions) {
        return externalPermissions === null || externalPermissions === void 0 ? void 0 : externalPermissions.map((egress)=>typeof egress === 'object' ? egress.address : egress);
    }
    mapExternalPermissionsToCsp(externalPermissions) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { images: images, media: media, scripts: scripts, fetch: fetch, styles: styles, fonts: fonts, frames: frames } = externalPermissions;
        this.assertValidFetchClient(fetch);
        return {
            'img-src': (_a = this.egressesToStringMap(images)) !== null && _a !== void 0 ? _a : [],
            'media-src': (_b = this.egressesToStringMap(media)) !== null && _b !== void 0 ? _b : [],
            'script-src': (_c = this.egressesToStringMap(scripts)) !== null && _c !== void 0 ? _c : [],
            'style-src': (_d = this.egressesToStringMap(styles)) !== null && _d !== void 0 ? _d : [],
            'connect-src': (_e = fetch === null || fetch === void 0 ? void 0 : fetch.client) !== null && _e !== void 0 ? _e : [],
            'font-src': (_f = this.egressesToStringMap(fonts)) !== null && _f !== void 0 ? _f : [],
            'frame-src': (_g = this.egressesToStringMap(frames)) !== null && _g !== void 0 ? _g : []
        };
    }
    getStyleSrc($, userStyleSrc) {
        var _a, _b;
        const quotedUserStyleSrc = (_a = userStyleSrc === null || userStyleSrc === void 0 ? void 0 : userStyleSrc.map((x)=>`'${x}'`)) !== null && _a !== void 0 ? _a : [];
        const deprecatedUserStyleSrc = (_b = this.getDeprecatedUserCsp($)['style-src']) !== null && _b !== void 0 ? _b : [];
        const uniqueStyleSrc = [
            ...new Set([
                ...deprecatedUserStyleSrc,
                ...quotedUserStyleSrc
            ])
        ];
        return uniqueStyleSrc.filter((x)=>this.isValidUserStyleSrc(x));
    }
    getScriptSrc($, userScriptSrc) {
        var _a;
        const validUserScriptSrc = (_a = userScriptSrc === null || userScriptSrc === void 0 ? void 0 : userScriptSrc.filter((x)=>this.isValidUserScriptSrc(x))) !== null && _a !== void 0 ? _a : [];
        const generatedScriptHashes = validUserScriptSrc.includes('unsafe-inline') ? [] : this.getInlineScriptHashes($);
        const { scriptSrc: scriptSrc, userScriptHashes: userScriptHashes } = this.extractUniqueHashes(validUserScriptSrc, generatedScriptHashes);
        return [
            ...scriptSrc,
            ...generatedScriptHashes,
            ...userScriptHashes
        ].map((x)=>this.formatScriptSrc(x));
    }
    extractUniqueHashes(userScriptSrc, existingScriptHashes) {
        var _a;
        const userScriptHashes = [];
        const scriptSrc = (_a = userScriptSrc === null || userScriptSrc === void 0 ? void 0 : userScriptSrc.filter((scriptSrc)=>{
            const isValidHash = this.isValidHash(scriptSrc);
            if (isValidHash && !existingScriptHashes.includes(scriptSrc)) userScriptHashes.push(scriptSrc);
            return !isValidHash;
        })) !== null && _a !== void 0 ? _a : [];
        return {
            scriptSrc: scriptSrc,
            userScriptHashes: userScriptHashes
        };
    }
    getInlineScriptHashes($) {
        return $('script:not([src])').map((_index, script)=>{
            const html = $(script).html();
            return html && `sha256-${this.hashScript(html)}`;
        }).get();
    }
    hashScript(content) {
        const sha256 = $d490b7aafc613b68$var$crypto_1.default.createHash('sha256');
        return sha256.update(content).digest('base64');
    }
    formatScriptSrc(scriptSrc) {
        if (this.UNQUOTED_SCRIPT_SRC_ALLOWLIST.includes(scriptSrc)) return scriptSrc;
        return `'${scriptSrc}'`;
    }
    isValidUserScriptSrc(scriptSrc) {
        if (!this.isSafeCsp(scriptSrc)) return false;
        return this.isValidHash(scriptSrc) || this.SCRIPT_SRC_ALLOWLIST.includes(scriptSrc);
    }
    isValidUserStyleSrc(styleSrc) {
        if (!this.isSafeCsp(styleSrc)) {
            this.logger.info('discarding potentially-malicious CSP');
            return false;
        }
        return this.STYLE_SRC_ALLOWLIST.includes(styleSrc);
    }
    isSafeCsp(cspString) {
        return /^([a-zA-Z0-9='"+\/ -]|blob:)*$/.test(cspString);
    }
    isValidHash(cspString) {
        return this.BASE_64_HASH_PATTERNS.some((pattern)=>pattern.test(cspString));
    }
    getDeprecatedUserCsp($) {
        const cspContent = $('meta[http-equiv="Content-Security-Policy"]').attr('content');
        if (!cspContent) return {};
        if (!this.isSafeCsp(cspContent)) {
            this.logger.info('discarding potentially-malicious CSP');
            return {};
        }
        return Object.fromEntries((0, $d490b7aafc613b68$var$content_security_policy_parser_1.default)(cspContent));
    }
    constructor(logger, cheerioLoader){
        this.logger = logger;
        this.cheerioLoader = cheerioLoader;
        this.STYLE_SRC_ALLOWLIST = [
            `'unsafe-inline'`
        ];
        this.QUOTED_SCRIPT_SRC_ALLOWLIST = [
            'unsafe-inline',
            'unsafe-eval',
            'unsafe-hashes'
        ];
        this.UNQUOTED_SCRIPT_SRC_ALLOWLIST = [
            'blob:'
        ];
        this.SCRIPT_SRC_ALLOWLIST = [
            ...this.QUOTED_SCRIPT_SRC_ALLOWLIST,
            ...this.UNQUOTED_SCRIPT_SRC_ALLOWLIST
        ];
        this.BASE_64_HASH_PATTERNS = [
            /^sha256-[a-zA-Z0-9=+/]{44}$/,
            /^sha384-[a-zA-Z0-9=+/]{64}$/,
            /^sha512-[a-zA-Z0-9=+/]{88}$/
        ];
    }
}
module.exports.CSPProcessingService = $d490b7aafc613b68$var$CSPProcessingService;

});

parcelRegister("23uMP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// "ASCII whitespace is U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, or
// U+0020 SPACE."
//
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $17f3be27aecd83b5$var$ASCII_WHITESPACE_CHARS = "\t\n\f\r ";
const $17f3be27aecd83b5$var$ASCII_WHITESPACE = RegExp(`[${$17f3be27aecd83b5$var$ASCII_WHITESPACE_CHARS}]+`);
const $17f3be27aecd83b5$var$ASCII_WHITESPACE_AT_START = RegExp(`^[${$17f3be27aecd83b5$var$ASCII_WHITESPACE_CHARS}]+`);
const $17f3be27aecd83b5$var$ASCII_WHITESPACE_AT_END = RegExp(`[${$17f3be27aecd83b5$var$ASCII_WHITESPACE_CHARS}]+$`);
// "An ASCII code point is a code point in the range U+0000 NULL to
// U+007F DELETE, inclusive." See <https://infra.spec.whatwg.org/#ascii-string>.
// deno-lint-ignore no-control-regex
const $17f3be27aecd83b5$var$ASCII = /^[\x00-\x7f]*$/;
/**
 * Parse a serialized Content Security Policy via [the spec][0].
 *
 * [0]: https://w3c.github.io/webappsec-csp/#parse-serialized-policy
 *
 * @param policy The serialized Content Security Policy to parse.
 * @returns A Map of Content Security Policy directives.
 * @example
 * parseContentSecurityPolicy(
 *   "default-src 'self'; script-src 'unsafe-eval' scripts.example; object-src; style-src styles.example",
 * );
 * // => Map(4) {
 * //      "default-src" => ["'self'"],
 * //      "script-src" => ["'unsafe-eval'", "scripts.example"],
 * //      "object-src" => [],
 * //      "style-src" => ["styles.example"],
 * //    }
 */ function $17f3be27aecd83b5$var$parseContentSecurityPolicy(policy) {
    const result = new Map();
    // "For each token returned by strictly splitting serialized on the
    // U+003B SEMICOLON character (;):"
    for (let token of policy.split(";")){
        // "1. Strip leading and trailing ASCII whitespace from token."
        token = token.replace($17f3be27aecd83b5$var$ASCII_WHITESPACE_AT_START, "").replace($17f3be27aecd83b5$var$ASCII_WHITESPACE_AT_END, "");
        // "2. If token is an empty string, or if token is not an ASCII string,
        //     continue."
        if (!token || !$17f3be27aecd83b5$var$ASCII.test(token)) continue;
        // We do these at the same time:
        // "3. Let directive name be the result of collecting a sequence of
        //     code points from token which are not ASCII whitespace."
        // "6. Let directive value be the result of splitting token on
        //     ASCII whitespace."
        const [rawDirectiveName, ...directiveValue] = token.split($17f3be27aecd83b5$var$ASCII_WHITESPACE);
        // "4. Set directive name to be the result of running ASCII lowercase on
        //     directive name."
        const directiveName = rawDirectiveName.toLowerCase();
        // "5. If policy's directive set contains a directive whose name is
        //     directive name, continue."
        if (result.has(directiveName)) continue;
        // "7. Let directive be a new directive whose name is directive name, and
        //     value is directive value."
        // "8. Append directive to policy's directive set."
        result.set(directiveName, directiveValue);
    }
    return result;
}
module.exports.default = $17f3be27aecd83b5$var$parseContentSecurityPolicy;

});

parcelRegister("9XnlZ", function(module, exports) {
// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
const $d2a4617183cfd5d5$export$4da13fcc37d580b4 = [
    'javascript:',
    'data:',
    'vbscript:',
    'view-source:',
    'resource:',
    'about:',
    'chrome:',
    'livescript:',
    'mocha:',
    'file:',
    'mhtml:',
    'smb:'
];
const $d2a4617183cfd5d5$export$300bd6d67c49dbfc = (urlString)=>{
    const url = new URL(urlString || '', window.location.href);
    return $d2a4617183cfd5d5$export$4da13fcc37d580b4.includes(url.protocol) ? 'about:blank' : url.toString();
};
module.exports["sanitizeUrl"] = $d2a4617183cfd5d5$export$300bd6d67c49dbfc;

});

parcelRegister("4v1ex", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $ah4BL = parcelRequire("ah4BL");


var $d5gEx = parcelRequire("d5gEx");


var $jKlwt = parcelRequire("jKlwt");











var $8m50u = parcelRequire("8m50u");





var $5ELQr = parcelRequire("5ELQr");


var $3dDsm = parcelRequire("3dDsm");

var $h9K7i = parcelRequire("h9K7i");


var $8J8AQ = parcelRequire("8J8AQ");


var $cJZA6 = parcelRequire("cJZA6");














var $dGVOK = parcelRequire("dGVOK");

const $a873df2f22efbae1$export$aab0d259c363afda = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, viewportDimensions: viewportDimensions } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("forge-ui-app-perf-tracking-enabled");
        $[0] = t1;
    } else t1 = $[0];
    const isEnabled = t1;
    let t2;
    if ($[1] !== viewportDimensions) {
        t2 = {
            isEnabled: isEnabled,
            viewportDimensions: viewportDimensions
        };
        $[1] = viewportDimensions;
        $[2] = t2;
    } else t2 = $[2];
    const { containerRef: containerRef } = (0, $dGVOK.useResizeAnalytics)(t2);
    if (isEnabled) {
        let t3;
        if ($[3] !== children || $[4] !== containerRef) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ref: containerRef,
                id: "forge-ui-height-observer-wrapper"
            }, children);
            $[3] = children;
            $[4] = containerRef;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    let t3;
    if ($[6] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[6] = children;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, viewportDimensions: viewportDimensions })=>{
    const isEnabled = (0, $iDrrr.fg)('forge-ui-app-perf-tracking-enabled');
    const { containerRef: containerRef } = (0, $dGVOK.useResizeAnalytics)({
        isEnabled: isEnabled,
        viewportDimensions: viewportDimensions
    });
    if (isEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: containerRef,
        id: "forge-ui-height-observer-wrapper"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};



var $kvlRh = parcelRequire("kvlRh");











var $fMV63 = parcelRequire("fMV63");


var $5xQdV = parcelRequire("5xQdV");














var $cVuzC = parcelRequire("cVuzC");










/**
 * Module-level singleton for a shared, lazily-created sandboxed iframe.
 *
 * A single hidden <iframe> is appended to document.body on first access and
 * reused by every WorkerWebRuntime instance in the same page. The iframe is
 * intentionally managed imperatively (outside of React) so that the React
 * reconciler can never unmount or reorder it.
 *
 * Usage:
 *   const iframe = getOrCreateSandboxIframe();
 *   destroySandboxIframe();                    // teardown / test cleanup
 */ 
var $5itFi = parcelRequire("5itFi");


var $iyPp3 = parcelRequire("iyPp3");


var $hfFJ2 = parcelRequire("hfFJ2");

const $29cc5365151e7bc3$export$610aba4956682285 = (environment)=>{
    return `https://forge.${(0, $5itFi.getForgeCDNBaseDomain)(environment)}`;
};
const $29cc5365151e7bc3$export$b13327eb43ebc8bd = (environment)=>{
    return `${$29cc5365151e7bc3$export$610aba4956682285(environment)}/runtime/sandbox.html`;
};
const $29cc5365151e7bc3$export$93ff7914791b9d75 = (extension)=>{
    return (0, $hfFJ2.urlSafeB64)((0, $iyPp3.getEncodedAppContext)(extension));
};


const $9857bac18e23de07$export$6646fca33a54bb24 = '__forge-worker-sandbox__';
let $9857bac18e23de07$var$iframe = null;
const $9857bac18e23de07$var$createSandboxIframe = (document1, environment)=>{
    const iframeEl = document1.createElement('iframe');
    iframeEl.id = $9857bac18e23de07$export$6646fca33a54bb24;
    // technically we could remove 'allow-same-origin' and this will ensure all
    // worker runtime code is completely isolated (not able to read cookies or localStorage)
    // but this could prevent potential future features that require same-origin access,
    // (e.g. service-worker, indexdb etc.), so we'll keep it in place for now and revisit if needed.
    //
    // in order to secure the worker runtime, we will be utilising the security shim
    // script suggested in: https://hello.atlassian.net/wiki/x/dDy-hAE
    iframeEl.setAttribute('sandbox', 'allow-scripts allow-same-origin');
    iframeEl.src = (0, $29cc5365151e7bc3$export$b13327eb43ebc8bd)(environment);
    // Keep the iframe invisible but laid out so the browser doesn't defer script
    // execution inside it. `display:none` can suspend execution in some browsers.
    Object.assign(iframeEl.style, {
        position: 'absolute',
        width: '0',
        height: '0',
        border: 'none',
        top: '-9999px',
        left: '-9999px',
        visibility: 'hidden'
    });
    iframeEl.setAttribute('tabindex', '-1');
    iframeEl.setAttribute('aria-hidden', 'true');
    return iframeEl;
};
const $9857bac18e23de07$export$174dd467067cc3dc = (environment)=>{
    if (typeof document === 'undefined') // SSR guard — no DOM available
    return null;
    // Fast path: module-level cache (same module instance, same call).
    if ($9857bac18e23de07$var$iframe !== null) return $9857bac18e23de07$var$iframe;
    // Recovery path: find an existing iframe created by a different module
    // instance (Module Federation) or a previous module load (HMR).
    const existing = document.getElementById($9857bac18e23de07$export$6646fca33a54bb24);
    if (existing !== null) {
        $9857bac18e23de07$var$iframe = existing;
        return $9857bac18e23de07$var$iframe;
    }
    // First-ever creation: build the element and stamp it with the stable id.
    const iframeEl = $9857bac18e23de07$var$createSandboxIframe(document, environment);
    document.body.appendChild(iframeEl);
    $9857bac18e23de07$var$iframe = iframeEl;
    return $9857bac18e23de07$var$iframe;
};
const $9857bac18e23de07$export$dce981fb8c927a47 = ()=>{
    // Query the DOM directly rather than relying solely on the module variable.
    // A different module instance may have been the one to create the iframe,
    // so `iframeEl` could be null here even if the element exists in the DOM.
    const el = $9857bac18e23de07$var$iframe ?? (typeof document !== 'undefined' ? document.getElementById($9857bac18e23de07$export$6646fca33a54bb24) : null);
    if (el !== null) el.remove();
    $9857bac18e23de07$var$iframe = null;
};



var $lvKd7 = parcelRequire("lvKd7");


/**
 * Well-known key used to attach the connection promise directly to the iframe
 * DOM element.
 *
 * Storing it on the element means Module Federation / HMR cannot cause a
 * second handshake: any module instance that receives the same DOM node will
 * find the already-initiated promise.
 */ const $e57f9ed9326b2753$var$SANDBOX_CONNECTION_KEY = '__forge-sandbox-connection-promise__';
const $e57f9ed9326b2753$export$dd439767100c493e = (iframe)=>{
    const el = iframe;
    el[$e57f9ed9326b2753$var$SANDBOX_CONNECTION_KEY]?.then((conn)=>conn.destroy()).catch(()=>{});
    delete el[$e57f9ed9326b2753$var$SANDBOX_CONNECTION_KEY];
};
/**
 * Returns (and lazily initiates) the single shared sandbox connection promise.
 * The promise is stored on the iframe element so it survives across module
 * instances — only the first caller triggers the handshake.
 */ const $e57f9ed9326b2753$var$getOrCreateConnectionPromise = (iframe, contentWindow, environment)=>{
    const el = iframe;
    const existing = el[$e57f9ed9326b2753$var$SANDBOX_CONNECTION_KEY];
    if (existing) return existing;
    const promise = (0, $lvKd7.setupSandboxController)(contentWindow, (0, $29cc5365151e7bc3$export$610aba4956682285)(environment));
    el[$e57f9ed9326b2753$var$SANDBOX_CONNECTION_KEY] = promise;
    return promise;
};
const $e57f9ed9326b2753$export$e888e640efbbe682 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (environment)=>{
    const $ = (0, $bDgLe.c)(10);
    const [connection, setConnection] = (0, $cozmU.useState)(null);
    let t0;
    let t1;
    if ($[0] !== environment) {
        t0 = ()=>{
            const iframe = (0, $9857bac18e23de07$export$174dd467067cc3dc)(environment);
            if (iframe === null) return;
            let cancelled = false;
            const initConnection = ()=>{
                const { contentWindow: contentWindow } = iframe;
                if (!contentWindow) return;
                $e57f9ed9326b2753$var$getOrCreateConnectionPromise(iframe, contentWindow, environment).then((conn)=>{
                    if (!cancelled) setConnection(conn);
                }).catch($e57f9ed9326b2753$var$_temp);
            };
            if (iframe.contentDocument === null) initConnection();
            else iframe.addEventListener("load", initConnection, {
                once: true
            });
            return ()=>{
                cancelled = true;
                iframe.removeEventListener("load", initConnection);
                setConnection(null);
            };
        };
        t1 = [
            environment
        ];
        $[0] = environment;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[3] !== environment) {
        t2 = (0, $9857bac18e23de07$export$174dd467067cc3dc)(environment);
        $[3] = environment;
        $[4] = t2;
    } else t2 = $[4];
    const iframeEl = t2;
    if (iframeEl && connection !== null) {
        let t3;
        if ($[5] !== connection || $[6] !== iframeEl) {
            t3 = {
                ready: true,
                connection: connection,
                iframeEl: iframeEl
            };
            $[5] = connection;
            $[6] = iframeEl;
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    let t3;
    if ($[8] !== iframeEl) {
        t3 = {
            ready: false,
            connection: null,
            iframeEl: iframeEl
        };
        $[8] = iframeEl;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : (environment)=>{
    const [connection, setConnection] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        const iframe = (0, $9857bac18e23de07$export$174dd467067cc3dc)(environment);
        if (iframe === null) // Non-browser environment (SSR) — nothing to do.
        return;
        let cancelled = false;
        const initConnection = ()=>{
            const { contentWindow: contentWindow } = iframe;
            if (!contentWindow) // Should not happen after the load event — guard for detached iframe edge case.
            return;
            $e57f9ed9326b2753$var$getOrCreateConnectionPromise(iframe, contentWindow, environment).then((conn)=>{
                if (!cancelled) setConnection(conn);
            }).catch(()=>{
            // Handshake failed — connection remains null.
            });
        };
        // TODO: Will need a better way or API to detect when the sadbox is ready.
        if (iframe.contentDocument === null) // contentDocument is null when the iframe has navigated to a cross-origin
        // page (i.e. the CDN sandbox has already loaded) — safe to connect now.
        initConnection();
        else // Still at about:blank (same-origin, contentDocument accessible) —
        // wait for the actual CDN src to load before attempting the handshake.
        iframe.addEventListener('load', initConnection, {
            once: true
        });
        return ()=>{
            cancelled = true;
            iframe.removeEventListener('load', initConnection);
            // Do NOT destroy the shared connection on cleanup — other mounted
            // hook instances are still using it.
            setConnection(null);
        };
    }, [
        environment
    ]);
    const iframeEl = (0, $9857bac18e23de07$export$174dd467067cc3dc)(environment);
    if (iframeEl && connection !== null) return {
        ready: true,
        connection: connection,
        iframeEl: iframeEl
    };
    return {
        ready: false,
        connection: null,
        iframeEl: iframeEl
    };
};
function $e57f9ed9326b2753$var$_temp() {}




var $6ojvx = parcelRequire("6ojvx");

var $DIyeF = parcelRequire("DIyeF");






var $d6OEY = parcelRequire("d6OEY");


var $givIf = parcelRequire("givIf");


var $2fpEe = parcelRequire("2fpEe");


var $lHaWf = parcelRequire("lHaWf");


var $3mbzJ = parcelRequire("3mbzJ");


var $acDpC = parcelRequire("acDpC");


var $eL3mC = parcelRequire("eL3mC");


var $eYWSl = parcelRequire("eYWSl");


var $bxg0J = parcelRequire("bxg0J");

/**
 * Renders a Forge app using the worker-based runtime.
 *
 * Instead of an `<iframe>` per app (as the classic {@link Iframe} renderer does),
 * this component runs all app code inside dedicated module Workers spawned from a
 * single shared hidden sandbox `<iframe>`. This improves isolation and reduces
 * browser resource usage when multiple Forge apps are on the same page.
 *
 * **Lifecycle**
 * 1. On mount, waits for the shared sandbox connection to be established
 *    (see {@link useSharedSandbox}).
 * 2. Calls `connection.controller.createApp()` to spin up a Worker for this app
 *    and receives a `workerId`.
 * 3. Opens a {@link createWorkerBridge} channel to the Worker for bridge
 *    communication (UI events, resolver calls, etc.).
 * 4. On unmount, closes the bridge and calls `terminateApp(workerId)` to tear
 *    down the Worker.
 * 5. On page unload (`beforeunload`), destroys the shared sandbox connection and
 *    removes the singleton iframe from the DOM.
 *
 * This component renders `null` — it has no visible DOM output of its own.
 * The sandbox `<iframe>` is managed imperatively outside React so the reconciler
 * can never unmount or reorder it.
 */ const $c258392d9ab82a2d$var$WorkerWebRuntimeBase = (props)=>{
    const { appId: appId, extension: extension, entryPoint: entryPoint } = props;
    const environment = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    // Shared, lazily-created sandbox iframe — a single <iframe> in document.body
    // is reused across all WorkerWebRuntime instances on the same page.
    const sandbox = (0, $e57f9ed9326b2753$export$e888e640efbbe682)(environment);
    // Tracks the active worker id so the unmount cleanup can terminate it.
    const workerIdRef = (0, $cozmU.useRef)(null);
    const { getBridgeFeatures: getBridgeFeatures, destroy: cleanupBridgeFeatures, overlay: overlay } = $c258392d9ab82a2d$var$useBridgeFeatures(props);
    // Worker lifecycle: create on mount (once sandbox is ready), terminate on unmount.
    (0, $cozmU.useEffect)(()=>{
        if (!sandbox.ready) return;
        const { connection: connection, iframeEl: iframeEl } = sandbox;
        const encodedAppContext = (0, $29cc5365151e7bc3$export$93ff7914791b9d75)(extension);
        // Resolve both the resource and its resolvedResourceEntry from the active entry point
        // together, matching the iframe runtime, so a top-level resource's HTML filename does not
        // bleed into a sub-entry-point's (config/edit/view/create/contextConfig) module URL.
        const { resource: resource, resolvedResourceEntry: resolvedResourceEntry } = (0, $d6OEY.getExtensionEntryPoint)(extension, entryPoint);
        // [TODO] we will need to review if it is possible that appContext can be changed during the lifecyle of the component.
        // If that is case, we might need to add appContext in the dependency array of useEffect and handle the update of appContext accordingly.
        const appContext = {
            appId: appId,
            extension: {
                installationId: extension.installationId,
                environmentId: extension.environmentId,
                appVersion: extension.appVersion,
                properties: {
                    resourceUploadId: extension.properties.resourceUploadId,
                    resource: resource,
                    resolvedResourceEntry: resolvedResourceEntry
                },
                type: extension.type
            },
            environment: environment,
            encodedAppContext: encodedAppContext
        };
        let bridgeClose = null;
        let cancelled = false;
        connection.controller.createApp(appContext).then((workerId)=>{
            // If the component unmounted while createApp() was in-flight, immediately
            // tear down the spawned worker so it isn't leaked.
            if (cancelled) {
                connection.controller.terminateApp(workerId).catch(()=>{});
                return;
            }
            workerIdRef.current = workerId;
            const bridge = (0, $lvKd7.createWorkerBridge)({
                workerId: workerId,
                withWindow: iframeEl.contentWindow,
                withDomain: (0, $29cc5365151e7bc3$export$610aba4956682285)(environment),
                features: getBridgeFeatures(),
                sendHandshakeMetric: (...args)=>{
                    // TODO: implement proper metrics here. For now we just log to console to verify that the bridge is working.
                    // eslint-disable-next-line no-console
                    console.log('[worker] Handshake metric', ...args);
                }
            });
            return bridge.open();
        }).then((result)=>{
            if (result) bridgeClose = result.close;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('Failed to create worker app', err);
        });
        return ()=>{
            cancelled = true;
            cleanupBridgeFeatures();
            bridgeClose?.();
            if (workerIdRef.current !== null) {
                connection.controller.terminateApp(workerIdRef.current).catch((err_0)=>{
                    // eslint-disable-next-line no-console
                    console.error(`Failed to terminate worker with id ${workerIdRef.current}`, err_0);
                });
                workerIdRef.current = null;
            }
        };
    }, [
        sandbox.ready
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Page-level cleanup — fires when the tab/window is closed or navigated away.
    // Destroys the shared connection and removes the singleton iframe entirely.
    (0, $cozmU.useEffect)(()=>{
        const handleUnload = ()=>{
            const iframe = (0, $9857bac18e23de07$export$174dd467067cc3dc)(environment);
            if (iframe !== null) {
                (0, $e57f9ed9326b2753$export$dd439767100c493e)(iframe);
                (0, $9857bac18e23de07$export$dce981fb8c927a47)();
            }
        };
        window.addEventListener('beforeunload', handleUnload);
        return ()=>window.removeEventListener('beforeunload', handleUnload);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // Note that we intentionally do NOT include `environment` in the dependency array here.
    // The unload handler should be added only once and always refer to the same shared iframe,
    // The iframe is appended imperatively to document.body by the singleton —
    // overlay is null by default and populated only when a bridge method
    // calls overlayController.show().
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, overlay);
};
const $c258392d9ab82a2d$export$62283308bb95b4ba = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eL3mC.TracingProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c258392d9ab82a2d$var$WorkerWebRuntimeBase, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eL3mC.TracingProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c258392d9ab82a2d$var$WorkerWebRuntimeBase, props));
});
const $c258392d9ab82a2d$export$a84c406ba9bc5e09 = (extension, entryPoint)=>{
    // renderRuntimeType describes how a specific resource bundle is executed, so it travels with the
    // resource. Read it from the entry point only when that entry point owns its own resource bundle;
    // otherwise the entry point shares the module's top-level bundle (and its runtime type). This keeps
    // the runtime decision aligned with the bundle `getExtensionEntryPoint` resolves — a worker-built
    // bundle is never forced into an iframe (or vice versa) by inheriting an unrelated runtime type.
    const entryPointProperties = entryPoint ? extension.properties?.[entryPoint] : extension.properties;
    const resolvedProperties = entryPointProperties?.resource ? entryPointProperties : extension.properties;
    return resolvedProperties?.renderRuntimeType === 'webworker';
};
const $c258392d9ab82a2d$var$useBridgeFeatures = (props)=>{
    const environment = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    // Single overlay slot — bridge methods call overlayController.show()/hide() to
    // render overlay UI into this slot. Animated mode (default) wraps in
    // <ModalTransition> for ADS modals; inline mode (animated=false) renders
    // ThreeLOPrompt directly without transition.
    const { overlay: overlay, overlayController: overlayController } = (0, $3mbzJ.useRuntimeOverlayController)();
    // Shared presenter: Forge app error overlay + host-renderer suppression + i18n.
    // Exposed as the `showAppError` bridge service for the withErrorDisplay middleware.
    const showAppError = (0, $acDpC.useRuntimeErrorOverlay)({
        overlayController: overlayController,
        extension: props.extension,
        setShouldShowRenderer: props.setShouldShowRenderer,
        onError: props.onError
    });
    // WorkerWebRuntime has no iframe to hide and no setIsThreeLOPromptVisible prop
    // (IframeProps vs InnerIframeProps), so renderThreeLOPrompt is a minimal
    // implementation — retry queue only, no visibility side-effects.
    const invokeRetriesRef = (0, $cozmU.useRef)([]);
    const latestRef = (0, $cozmU.useRef)({
        overlayController: overlayController,
        extension: props.extension
    });
    latestRef.current = {
        overlayController: overlayController,
        extension: props.extension
    };
    const renderThreeLOPrompt = (0, $5xQdV.useCallbackOne)((authUrl, retry)=>new Promise((resolve)=>{
            const { overlayController: overlayController_0, extension: extension } = latestRef.current;
            invokeRetriesRef.current.push(retry);
            overlayController_0.show(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVuzC.default), {
                authUrl: authUrl,
                onSuccess: async ()=>{
                    resolve();
                    overlayController_0.hide();
                    try {
                        await Promise.all(invokeRetriesRef.current.map((r)=>r()));
                    } finally{
                        invokeRetriesRef.current = [];
                    }
                },
                metadata: {
                    moduleType: extension.type
                }
            }), true);
        }), []);
    // Assembles host-side capabilities (invoker, tracing, token, modal) for bridge methods.
    // Returns a getter rather than a snapshot so services are always current at call time.
    const { getServices: getServices } = (0, $lHaWf.useBridgeServices)(props, overlayController, renderThreeLOPrompt, showAppError);
    const { customBridgeMethods: legacyCustomBridgeMethods, customBridge: customBridge, ...bridgeContextProps } = props;
    // Legacy (v1) methods are tracked live because some modules recreate them after initial render.
    const getLegacyCustomBridgeMethods = (0, $bxg0J.useLiveMethodMap)(legacyCustomBridgeMethods);
    // [Important] the implementation of getBridgeContext is stable and does not change across the lifecycle of the component, so it is safe to include it in the dependency array of createBridgeFeatures
    // without causing unnecessary re-renders or re-creations of the bridge features.
    const { getBridgeContext: getBridgeContext, destroy: destroy } = (0, $2fpEe.useBridgeContext)({
        ...bridgeContextProps,
        environment: environment,
        page: page,
        runtime: 'webworker'
    }, getServices, props.contextChangeListeners);
    const getBridgeFeatures = (0, $5xQdV.useCallbackOne)(()=>{
        return (0, $givIf.createBridgeFeatures)(getBridgeContext, (baseBridgeMethods)=>(0, $eYWSl.consolidateCustomBridge)(baseBridgeMethods, getLegacyCustomBridgeMethods(), // v2 customBridge is a stable-reference contract — passed through directly, not tracked live.
            customBridge));
    }, []);
    return {
        overlay: overlay,
        destroy: destroy,
        getBridgeFeatures: getBridgeFeatures
    };
};





const $fa8a82457099ade3$export$c9565324b088e0b8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(70);
    let accountId;
    let bridge;
    let components;
    let contextIds;
    let coreData;
    let embeddedMacroParentType;
    let entryPoint;
    let extension;
    let extensionData;
    let extensionPayload;
    let extensionViewData;
    let getContextToken;
    let isEmbeddedMacro;
    let locale;
    let restProps;
    let setError;
    let setForgeDoc;
    let timezone;
    if ($[0] !== t0) {
        ({ setForgeDoc: setForgeDoc, setError: setError, accountId: accountId, contextIds: contextIds, extension: extension, components: components, coreData: coreData, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, timezone: timezone, locale: locale, bridge: bridge, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, entryPoint: entryPoint, ...restProps } = t0);
        $[0] = t0;
        $[1] = accountId;
        $[2] = bridge;
        $[3] = components;
        $[4] = contextIds;
        $[5] = coreData;
        $[6] = embeddedMacroParentType;
        $[7] = entryPoint;
        $[8] = extension;
        $[9] = extensionData;
        $[10] = extensionPayload;
        $[11] = extensionViewData;
        $[12] = getContextToken;
        $[13] = isEmbeddedMacro;
        $[14] = locale;
        $[15] = restProps;
        $[16] = setError;
        $[17] = setForgeDoc;
        $[18] = timezone;
    } else {
        accountId = $[1];
        bridge = $[2];
        components = $[3];
        contextIds = $[4];
        coreData = $[5];
        embeddedMacroParentType = $[6];
        entryPoint = $[7];
        extension = $[8];
        extensionData = $[9];
        extensionPayload = $[10];
        extensionViewData = $[11];
        getContextToken = $[12];
        isEmbeddedMacro = $[13];
        locale = $[14];
        restProps = $[15];
        setError = $[16];
        setForgeDoc = $[17];
        timezone = $[18];
    }
    const forgeReactMajorVersion = (0, $cozmU.useRef)(null);
    let t1;
    if ($[19] !== setError) {
        t1 = (t2)=>{
            const { error: error } = t2;
            if (setError) setError(error);
        };
        $[19] = setError;
        $[20] = t1;
    } else t1 = $[20];
    let t2;
    if ($[21] !== setForgeDoc) {
        t2 = (t3)=>{
            const { forgeDoc: forgeDoc } = t3;
            Object.freeze(forgeDoc);
            setForgeDoc(forgeDoc);
            if (forgeReactMajorVersion.current === null && forgeDoc.forgeReactMajorVersion) forgeReactMajorVersion.current = forgeDoc.forgeReactMajorVersion;
        };
        $[21] = setForgeDoc;
        $[22] = t2;
    } else t2 = $[22];
    let t3;
    if ($[23] !== bridge || $[24] !== t1 || $[25] !== t2) {
        t3 = {
            onError: t1,
            ...bridge,
            reconcile: t2
        };
        $[23] = bridge;
        $[24] = t1;
        $[25] = t2;
        $[26] = t3;
    } else t3 = $[26];
    const combinedBridge = t3;
    let t4;
    let t5;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>forgeReactMajorVersion.current;
        t5 = [
            forgeReactMajorVersion
        ];
        $[27] = t4;
        $[28] = t5;
    } else {
        t4 = $[27];
        t5 = $[28];
    }
    const getCurrentForgeReactMajorVersion = (0, $5xQdV.useCallbackOne)(t4, t5);
    if ((0, $c258392d9ab82a2d$export$a84c406ba9bc5e09)(extension, entryPoint) && (0, $iDrrr.fg)("forge-ui-worker-runtime")) {
        let t6;
        if ($[29] !== setError) {
            t6 = (err)=>setError && setError(new Error(err));
            $[29] = setError;
            $[30] = t6;
        } else t6 = $[30];
        let t7;
        if ($[31] !== accountId || $[32] !== combinedBridge || $[33] !== components || $[34] !== contextIds || $[35] !== coreData || $[36] !== entryPoint || $[37] !== extension || $[38] !== extensionData || $[39] !== extensionPayload || $[40] !== extensionViewData || $[41] !== getContextToken || $[42] !== getCurrentForgeReactMajorVersion || $[43] !== locale || $[44] !== restProps || $[45] !== t6 || $[46] !== timezone) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c258392d9ab82a2d$export$62283308bb95b4ba), {
                accountId: accountId,
                contextIds: contextIds,
                extension: extension,
                coreData: coreData,
                components: components,
                extensionData: extensionData,
                extensionPayload: extensionPayload,
                extensionViewData: extensionViewData,
                getContextToken: getContextToken,
                getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
                timezone: timezone,
                locale: locale,
                bridge: combinedBridge,
                appId: extension.appId,
                entryPoint: entryPoint,
                ...restProps,
                onError: t6
            });
            $[31] = accountId;
            $[32] = combinedBridge;
            $[33] = components;
            $[34] = contextIds;
            $[35] = coreData;
            $[36] = entryPoint;
            $[37] = extension;
            $[38] = extensionData;
            $[39] = extensionPayload;
            $[40] = extensionViewData;
            $[41] = getContextToken;
            $[42] = getCurrentForgeReactMajorVersion;
            $[43] = locale;
            $[44] = restProps;
            $[45] = t6;
            $[46] = timezone;
            $[47] = t7;
        } else t7 = $[47];
        return t7;
    }
    const t6 = ((0, $iDrrr.fg)("platform_forge_ui_refactor_macro_parent_type") ? !!embeddedMacroParentType : isEmbeddedMacro) && (0, $iDrrr.fg)("platform_forge_ui_embedded_inline_macro") ? "0px" : undefined;
    let t7;
    if ($[48] !== setError) {
        t7 = (err_0)=>setError && setError(new Error(err_0));
        $[48] = setError;
        $[49] = t7;
    } else t7 = $[49];
    let t8;
    if ($[50] !== accountId || $[51] !== combinedBridge || $[52] !== components || $[53] !== contextIds || $[54] !== coreData || $[55] !== embeddedMacroParentType || $[56] !== entryPoint || $[57] !== extension || $[58] !== extensionData || $[59] !== extensionPayload || $[60] !== extensionViewData || $[61] !== getContextToken || $[62] !== getCurrentForgeReactMajorVersion || $[63] !== isEmbeddedMacro || $[64] !== locale || $[65] !== restProps || $[66] !== t6 || $[67] !== t7 || $[68] !== timezone) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fMV63.Iframe), {
            accountId: accountId,
            contextIds: contextIds,
            extension: extension,
            coreData: coreData,
            components: components,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            extensionViewData: extensionViewData,
            getContextToken: getContextToken,
            timezone: timezone,
            locale: locale,
            bridge: combinedBridge,
            isHidden: true,
            isEmbeddedMacro: isEmbeddedMacro,
            embeddedMacroParentType: embeddedMacroParentType,
            entryPoint: entryPoint,
            getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
            ...restProps,
            height: t6,
            onError: t7
        });
        $[50] = accountId;
        $[51] = combinedBridge;
        $[52] = components;
        $[53] = contextIds;
        $[54] = coreData;
        $[55] = embeddedMacroParentType;
        $[56] = entryPoint;
        $[57] = extension;
        $[58] = extensionData;
        $[59] = extensionPayload;
        $[60] = extensionViewData;
        $[61] = getContextToken;
        $[62] = getCurrentForgeReactMajorVersion;
        $[63] = isEmbeddedMacro;
        $[64] = locale;
        $[65] = restProps;
        $[66] = t6;
        $[67] = t7;
        $[68] = timezone;
        $[69] = t8;
    } else t8 = $[69];
    return t8;
} : ({ setForgeDoc: setForgeDoc, setError: setError, accountId: accountId, contextIds: contextIds, extension: extension, components: components, coreData: coreData, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, timezone: timezone, locale: locale, bridge: bridge, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, entryPoint: entryPoint, ...restProps })=>{
    const forgeReactMajorVersion = (0, $cozmU.useRef)(null);
    const combinedBridge = {
        onError: ({ error: error })=>{
            if (setError) setError(error);
        },
        ...bridge,
        reconcile: ({ forgeDoc: forgeDoc })=>{
            Object.freeze(forgeDoc);
            setForgeDoc(forgeDoc);
            if (forgeReactMajorVersion.current === null && forgeDoc.forgeReactMajorVersion) forgeReactMajorVersion.current = forgeDoc.forgeReactMajorVersion;
        }
    };
    const getCurrentForgeReactMajorVersion = (0, $5xQdV.useCallbackOne)(()=>{
        return forgeReactMajorVersion.current;
    }, [
        forgeReactMajorVersion
    ]);
    // this is essential based on feature gate for now.
    // In the future, this check should inspect extension / manifest prop to
    // determine whether to use the worker runtime or not.
    if ((0, $c258392d9ab82a2d$export$a84c406ba9bc5e09)(extension, entryPoint) && (0, $iDrrr.fg)('forge-ui-worker-runtime')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c258392d9ab82a2d$export$62283308bb95b4ba), {
        accountId: accountId,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        components: components,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
        timezone: timezone,
        locale: locale,
        bridge: combinedBridge,
        appId: extension.appId,
        entryPoint: entryPoint,
        ...restProps,
        onError: (err)=>setError && setError(new Error(err))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fMV63.Iframe), {
        accountId: accountId,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        components: components,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        timezone: timezone,
        locale: locale,
        bridge: combinedBridge,
        isHidden: true,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedMacroParentType: embeddedMacroParentType,
        entryPoint: entryPoint,
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
        ...restProps,
        // The hidden UI Kit iframe defaults to height: '100%' when viewportSize is set
        // (because viewportSize makes isResizable false which disables iframeResizer, falling back to height: 100%).
        // For embedded UI Kit macros, this inflates the iframe's bodyScroll measurement,
        // causing the outer faus adf-renderer iframe to grow unexpectedly. Setting '0px' prevents this.
        height: ((0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? !!embeddedMacroParentType : isEmbeddedMacro) && (0, $iDrrr.fg)('platform_forge_ui_embedded_inline_macro') ? '0px' : undefined,
        onError: (err_0)=>setError && setError(new Error(err_0))
    });
};



var $foY7i = parcelRequire("foY7i");

const $f5ddd1bbf56ef9be$var$UIKitRendererOld = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(70);
    const { accountId: accountId, bridge: bridge, components: components, coreData: coreData, contextIds: contextIds, contextChangeListeners: contextChangeListeners, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionViewData: extensionViewData, getContextToken: getContextToken, mentionProvider: mentionProvider, product: product, locale: locale, modalExtension: modalExtension, onForgeDocUpdated: onForgeDocUpdated, getThreeLOPrompt: getThreeLOPrompt, customBridgeMethods: customBridgeMethods, customBridge: customBridge, customBridgeContext: customBridgeContext, loadingComponent: loadingComponent, onError: onError, extensionPayload: extensionPayload, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId, viewOnClose: viewOnClose } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const [forgeDoc, setForgeDoc] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [shouldShowRenderer, setShouldShowRenderer] = (0, $cozmU.useState)(true);
    const isMacro = extension.type === "xen:macro";
    const hostOnNavigate = bridge?.onNavigate;
    let t0;
    if ($[0] !== components) {
        t0 = components ? Object.keys(components).reduce((acc, key)=>{
            const Component = components[key];
            return {
                ...acc,
                [key]: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                        ...args,
                        key: args.forgeDoc.key
                    })
            };
        }, {}) : {};
        $[0] = components;
        $[1] = t0;
    } else t0 = $[1];
    const injectedComponentsWithKey = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $3dDsm.makeUser)();
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== accountId || $[4] !== cloudId || $[5] !== mentionProvider || $[6] !== product || $[7] !== workspaceId) {
        t2 = (0, $h9K7i.makeNativeUserPicker)({
            mentionProvider: mentionProvider,
            accountId: accountId,
            ...workspaceId ? {
                cloudId: "bitbucket"
            } : {
                cloudId: cloudId
            },
            productAttributes: workspaceId ? {
                workspaceIds: [
                    (0, $foY7i.uncurlyUuid)(workspaceId)
                ]
            } : undefined,
            productKey: product
        });
        $[3] = accountId;
        $[4] = cloudId;
        $[5] = mentionProvider;
        $[6] = product;
        $[7] = workspaceId;
        $[8] = t2;
    } else t2 = $[8];
    const t3 = bridge?.onNavigate;
    let t4;
    if ($[9] !== bridge || $[10] !== t3) {
        t4 = (0, $8J8AQ.makeADFRenderer)({
            bridge: bridge,
            onNavigate: t3
        });
        $[9] = bridge;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== t4) {
        t5 = {
            AdfRenderer: t4
        };
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t2 || $[15] !== t5) {
        t6 = {
            Avatar: t1,
            AvatarStack: (0, $cJZA6.UserGroup),
            UserPicker: t2,
            ...t5
        };
        $[14] = t2;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    const wiredComponents = t6;
    let t7;
    if ($[17] !== injectedComponentsWithKey || $[18] !== wiredComponents) {
        t7 = (defaults)=>({
                ...defaults,
                ...wiredComponents,
                ...injectedComponentsWithKey
            });
        $[17] = injectedComponentsWithKey;
        $[18] = wiredComponents;
        $[19] = t7;
    } else t7 = $[19];
    const getComponents = t7;
    let t8;
    if ($[20] !== onAppError || $[21] !== onError) {
        t8 = (error_0)=>{
            if (onError) onError(error_0.message);
            if (onAppError) onAppError(error_0.message);
        };
        $[20] = onAppError;
        $[21] = onError;
        $[22] = t8;
    } else t8 = $[22];
    const handleError = t8;
    let t10;
    let t9;
    if ($[23] !== error || $[24] !== onAppError || $[25] !== onError) {
        t9 = ()=>{
            if (onError && error) onError(error.message);
            if (onAppError && error) onAppError(error.message);
        };
        t10 = [
            error,
            onError,
            onAppError
        ];
        $[23] = error;
        $[24] = onAppError;
        $[25] = onError;
        $[26] = t10;
        $[27] = t9;
    } else {
        t10 = $[26];
        t9 = $[27];
    }
    (0, $cozmU.useEffect)(t9, t10);
    const t11 = isMacro ? viewportDimensions : undefined;
    let t12;
    if ($[28] !== bridge?.openNewTabAsPopupWindow || $[29] !== error?.message || $[30] !== extension || $[31] !== extensionData || $[32] !== extensionPayload || $[33] !== forgeDoc || $[34] !== getComponents || $[35] !== handleError || $[36] !== hostOnNavigate || $[37] !== loadingComponent || $[38] !== modalExtension || $[39] !== onSuccess || $[40] !== shouldShowRenderer || $[41] !== viewOnClose) {
        t12 = shouldShowRenderer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ELQr.default), {
            forgeDoc: forgeDoc,
            extension: extension,
            error: error?.message,
            components: getComponents,
            modalExtension: modalExtension ? {
                ...modalExtension,
                viewOnClose: viewOnClose
            } : modalExtension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            extensionType: extensionData.type,
            loading: true,
            loadingComponent: loadingComponent,
            onError: handleError,
            onSuccess: onSuccess,
            onNavigate: hostOnNavigate,
            openNewTabAsPopupWindow: bridge?.openNewTabAsPopupWindow
        });
        $[28] = bridge?.openNewTabAsPopupWindow;
        $[29] = error?.message;
        $[30] = extension;
        $[31] = extensionData;
        $[32] = extensionPayload;
        $[33] = forgeDoc;
        $[34] = getComponents;
        $[35] = handleError;
        $[36] = hostOnNavigate;
        $[37] = loadingComponent;
        $[38] = modalExtension;
        $[39] = onSuccess;
        $[40] = shouldShowRenderer;
        $[41] = viewOnClose;
        $[42] = t12;
    } else t12 = $[42];
    let t13;
    if ($[43] !== onForgeDocUpdated) {
        t13 = (forgeDoc_0)=>{
            if (forgeDoc_0.type !== "MacroConfig") setForgeDoc(forgeDoc_0);
            onForgeDocUpdated?.(forgeDoc_0);
        };
        $[43] = onForgeDocUpdated;
        $[44] = t13;
    } else t13 = $[44];
    let t14;
    if ($[45] !== accountId || $[46] !== bridge || $[47] !== contextChangeListeners || $[48] !== contextIds || $[49] !== coreData || $[50] !== customBridge || $[51] !== customBridgeContext || $[52] !== customBridgeMethods || $[53] !== embeddedMacroParentType || $[54] !== embeddedParentLocalId || $[55] !== entryPoint || $[56] !== extension || $[57] !== extensionData || $[58] !== extensionPayload || $[59] !== extensionViewData || $[60] !== getContextToken || $[61] !== getThreeLOPrompt || $[62] !== isEmbeddedMacro || $[63] !== locale || $[64] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fa8a82457099ade3$export$c9565324b088e0b8), {
            accountId: accountId,
            setForgeDoc: t13,
            setError: setError,
            components: getThreeLOPrompt,
            contextIds: contextIds,
            extension: extension,
            coreData: coreData,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            extensionViewData: extensionViewData,
            locale: locale,
            bridge: bridge,
            getContextToken: getContextToken,
            entryPoint: entryPoint,
            customBridgeMethods: customBridgeMethods,
            customBridge: customBridge,
            customBridgeContext: customBridgeContext,
            setShouldShowRenderer: setShouldShowRenderer,
            isEmbeddedMacro: isEmbeddedMacro,
            embeddedMacroParentType: embeddedMacroParentType,
            embeddedParentLocalId: embeddedParentLocalId,
            contextChangeListeners: contextChangeListeners
        });
        $[45] = accountId;
        $[46] = bridge;
        $[47] = contextChangeListeners;
        $[48] = contextIds;
        $[49] = coreData;
        $[50] = customBridge;
        $[51] = customBridgeContext;
        $[52] = customBridgeMethods;
        $[53] = embeddedMacroParentType;
        $[54] = embeddedParentLocalId;
        $[55] = entryPoint;
        $[56] = extension;
        $[57] = extensionData;
        $[58] = extensionPayload;
        $[59] = extensionViewData;
        $[60] = getContextToken;
        $[61] = getThreeLOPrompt;
        $[62] = isEmbeddedMacro;
        $[63] = locale;
        $[64] = t13;
        $[65] = t14;
    } else t14 = $[65];
    let t15;
    if ($[66] !== t11 || $[67] !== t12 || $[68] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a873df2f22efbae1$export$aab0d259c363afda), {
            viewportDimensions: t11
        }, t12, t14);
        $[66] = t11;
        $[67] = t12;
        $[68] = t14;
        $[69] = t15;
    } else t15 = $[69];
    return t15;
} : (props)=>{
    const { accountId: accountId, bridge: bridge, components: components, coreData: coreData, contextIds: contextIds, contextChangeListeners: contextChangeListeners, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionViewData: extensionViewData, getContextToken: getContextToken, mentionProvider: mentionProvider, product: product, locale: locale, modalExtension: modalExtension, onForgeDocUpdated: onForgeDocUpdated, getThreeLOPrompt: getThreeLOPrompt, customBridgeMethods: customBridgeMethods, customBridge: customBridge, customBridgeContext: customBridgeContext, loadingComponent: loadingComponent, onError: onError, extensionPayload: extensionPayload, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId, viewOnClose: viewOnClose } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const [forgeDoc, setForgeDoc] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [shouldShowRenderer, setShouldShowRenderer] = (0, $cozmU.useState)(true);
    const isMacro = extension.type === 'xen:macro';
    // Custom UI already receives this via the iframe bridge. UI Kit has no
    // equivalent channel, so it is handed to the components that navigate.
    const hostOnNavigate = bridge?.onNavigate;
    const injectedComponentsWithKey = (0, $cozmU.useMemo)(()=>{
        return components ? Object.keys(components).reduce((acc, key)=>{
            const Component = components[key];
            return {
                ...acc,
                // A key is required to ensure React creates new component instances when forgeDoc.key changes.
                // Without this key, React reuses the same component instance across different forgeDoc updates,
                // causing hook call order violations when the component structure changes between renders.
                [key]: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                        ...args,
                        key: args.forgeDoc.key
                    })
            };
        }, {}) : {};
    }, [
        components
    ]);
    const wiredComponents = (0, $cozmU.useMemo)(()=>({
            Avatar: (0, $3dDsm.makeUser)(),
            AvatarStack: (0, $cJZA6.UserGroup),
            UserPicker: (0, $h9K7i.makeNativeUserPicker)({
                mentionProvider: mentionProvider,
                accountId: accountId,
                ...workspaceId ? {
                    cloudId: 'bitbucket'
                } : {
                    cloudId: cloudId
                },
                productAttributes: workspaceId ? {
                    workspaceIds: [
                        (0, $foY7i.uncurlyUuid)(workspaceId)
                    ]
                } : undefined,
                productKey: product
            }),
            AdfRenderer: (0, $8J8AQ.makeADFRenderer)({
                bridge: bridge,
                onNavigate: bridge?.onNavigate
            })
        }), [
        accountId,
        cloudId,
        mentionProvider,
        product,
        workspaceId,
        bridge
    ]);
    const getComponents = (0, $cozmU.useCallback)((defaults)=>({
            ...defaults,
            ...wiredComponents,
            ...injectedComponentsWithKey
        }), [
        injectedComponentsWithKey,
        wiredComponents
    ]);
    const handleError = (0, $cozmU.useCallback)((error_0)=>{
        if (onError) onError(error_0.message);
        if (onAppError) onAppError(error_0.message);
    }, [
        onError,
        onAppError
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (onError && error) onError(error.message);
        if (onAppError && error) onAppError(error.message);
    }, [
        error,
        onError,
        onAppError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a873df2f22efbae1$export$aab0d259c363afda), {
        viewportDimensions: isMacro ? viewportDimensions : undefined
    }, shouldShowRenderer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ELQr.default), {
        forgeDoc: forgeDoc,
        extension: extension,
        error: error?.message,
        components: getComponents,
        modalExtension: modalExtension ? {
            ...modalExtension,
            viewOnClose: viewOnClose
        } : modalExtension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionType: extensionData.type,
        loading: true,
        loadingComponent: loadingComponent,
        onError: handleError,
        onSuccess: onSuccess,
        onNavigate: hostOnNavigate,
        openNewTabAsPopupWindow: bridge?.openNewTabAsPopupWindow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fa8a82457099ade3$export$c9565324b088e0b8), {
        accountId: accountId,
        setForgeDoc: (forgeDoc_0)=>{
            if (forgeDoc_0.type !== 'MacroConfig') setForgeDoc(forgeDoc_0);
            onForgeDocUpdated?.(forgeDoc_0);
        },
        setError: setError,
        components: getThreeLOPrompt,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        locale: locale,
        bridge: bridge,
        getContextToken: getContextToken,
        entryPoint: entryPoint,
        customBridgeMethods: customBridgeMethods,
        customBridge: customBridge,
        customBridgeContext: customBridgeContext,
        setShouldShowRenderer: setShouldShowRenderer,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedMacroParentType: embeddedMacroParentType,
        embeddedParentLocalId: embeddedParentLocalId,
        contextChangeListeners: contextChangeListeners
    }));
};
const $f5ddd1bbf56ef9be$var$UIKitRendererNew = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(59);
    const { accountId: accountId, bridge: bridge, components: components, coreData: coreData, contextIds: contextIds, contextChangeListeners: contextChangeListeners, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionViewData: extensionViewData, getContextToken: getContextToken, mentionProvider: mentionProvider, product: product, locale: locale, modalExtension: modalExtension, onForgeDocUpdated: onForgeDocUpdated, getThreeLOPrompt: getThreeLOPrompt, customBridgeMethods: customBridgeMethods, customBridge: customBridge, customBridgeContext: customBridgeContext, loadingComponent: loadingComponent, onError: onError, extensionPayload: extensionPayload, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId, viewOnClose: viewOnClose, isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const [forgeDoc, setForgeDoc] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [shouldShowRenderer, setShouldShowRenderer] = (0, $cozmU.useState)(true);
    const isMacro = extension.type === "xen:macro";
    const hostOnNavigate = bridge?.onNavigate;
    let t0;
    if ($[0] !== accountId || $[1] !== bridge || $[2] !== cloudId || $[3] !== components || $[4] !== mentionProvider || $[5] !== product || $[6] !== workspaceId) {
        t0 = {
            accountId: accountId,
            bridge: bridge,
            cloudId: cloudId,
            workspaceId: workspaceId,
            mentionProvider: mentionProvider,
            product: product,
            components: components
        };
        $[0] = accountId;
        $[1] = bridge;
        $[2] = cloudId;
        $[3] = components;
        $[4] = mentionProvider;
        $[5] = product;
        $[6] = workspaceId;
        $[7] = t0;
    } else t0 = $[7];
    const getComponents = (0, $kvlRh.useUIKitComponents)(t0);
    let t1;
    if ($[8] !== onAppError || $[9] !== onError) {
        t1 = (error_0)=>{
            if (onError) onError(error_0.message);
            if (onAppError) onAppError(error_0.message);
        };
        $[8] = onAppError;
        $[9] = onError;
        $[10] = t1;
    } else t1 = $[10];
    const handleError = t1;
    let t2;
    let t3;
    if ($[11] !== error || $[12] !== onAppError || $[13] !== onError) {
        t2 = ()=>{
            if (onError && error) onError(error.message);
            if (onAppError && error) onAppError(error.message);
        };
        t3 = [
            error,
            onError,
            onAppError
        ];
        $[11] = error;
        $[12] = onAppError;
        $[13] = onError;
        $[14] = t2;
        $[15] = t3;
    } else {
        t2 = $[14];
        t3 = $[15];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = isMacro ? viewportDimensions : undefined;
    let t5;
    if ($[16] !== bridge?.openNewTabAsPopupWindow || $[17] !== error?.message || $[18] !== extension || $[19] !== extensionData || $[20] !== extensionPayload || $[21] !== forgeDoc || $[22] !== getComponents || $[23] !== handleError || $[24] !== hostOnNavigate || $[25] !== isEmbeddedUIKitInCustomUI || $[26] !== loadingComponent || $[27] !== modalExtension || $[28] !== onSuccess || $[29] !== shouldShowRenderer || $[30] !== viewOnClose) {
        t5 = shouldShowRenderer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ELQr.default), {
            forgeDoc: forgeDoc,
            extension: extension,
            error: error?.message,
            components: getComponents,
            modalExtension: modalExtension ? {
                ...modalExtension,
                viewOnClose: viewOnClose
            } : modalExtension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            extensionType: extensionData.type,
            loading: true,
            loadingComponent: loadingComponent,
            onError: handleError,
            onSuccess: onSuccess,
            onNavigate: hostOnNavigate,
            isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI,
            openNewTabAsPopupWindow: bridge?.openNewTabAsPopupWindow
        });
        $[16] = bridge?.openNewTabAsPopupWindow;
        $[17] = error?.message;
        $[18] = extension;
        $[19] = extensionData;
        $[20] = extensionPayload;
        $[21] = forgeDoc;
        $[22] = getComponents;
        $[23] = handleError;
        $[24] = hostOnNavigate;
        $[25] = isEmbeddedUIKitInCustomUI;
        $[26] = loadingComponent;
        $[27] = modalExtension;
        $[28] = onSuccess;
        $[29] = shouldShowRenderer;
        $[30] = viewOnClose;
        $[31] = t5;
    } else t5 = $[31];
    let t6;
    if ($[32] !== onForgeDocUpdated) {
        t6 = (forgeDoc_0)=>{
            if (forgeDoc_0.type !== "MacroConfig") setForgeDoc(forgeDoc_0);
            onForgeDocUpdated?.(forgeDoc_0);
        };
        $[32] = onForgeDocUpdated;
        $[33] = t6;
    } else t6 = $[33];
    let t7;
    if ($[34] !== accountId || $[35] !== bridge || $[36] !== contextChangeListeners || $[37] !== contextIds || $[38] !== coreData || $[39] !== customBridge || $[40] !== customBridgeContext || $[41] !== customBridgeMethods || $[42] !== embeddedMacroParentType || $[43] !== embeddedParentLocalId || $[44] !== entryPoint || $[45] !== extension || $[46] !== extensionData || $[47] !== extensionPayload || $[48] !== extensionViewData || $[49] !== getContextToken || $[50] !== getThreeLOPrompt || $[51] !== isEmbeddedMacro || $[52] !== locale || $[53] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fa8a82457099ade3$export$c9565324b088e0b8), {
            accountId: accountId,
            setForgeDoc: t6,
            setError: setError,
            components: getThreeLOPrompt,
            contextIds: contextIds,
            extension: extension,
            coreData: coreData,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            extensionViewData: extensionViewData,
            locale: locale,
            bridge: bridge,
            getContextToken: getContextToken,
            entryPoint: entryPoint,
            customBridgeMethods: customBridgeMethods,
            customBridge: customBridge,
            customBridgeContext: customBridgeContext,
            setShouldShowRenderer: setShouldShowRenderer,
            isEmbeddedMacro: isEmbeddedMacro,
            embeddedMacroParentType: embeddedMacroParentType,
            embeddedParentLocalId: embeddedParentLocalId,
            contextChangeListeners: contextChangeListeners
        });
        $[34] = accountId;
        $[35] = bridge;
        $[36] = contextChangeListeners;
        $[37] = contextIds;
        $[38] = coreData;
        $[39] = customBridge;
        $[40] = customBridgeContext;
        $[41] = customBridgeMethods;
        $[42] = embeddedMacroParentType;
        $[43] = embeddedParentLocalId;
        $[44] = entryPoint;
        $[45] = extension;
        $[46] = extensionData;
        $[47] = extensionPayload;
        $[48] = extensionViewData;
        $[49] = getContextToken;
        $[50] = getThreeLOPrompt;
        $[51] = isEmbeddedMacro;
        $[52] = locale;
        $[53] = t6;
        $[54] = t7;
    } else t7 = $[54];
    let t8;
    if ($[55] !== t4 || $[56] !== t5 || $[57] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a873df2f22efbae1$export$aab0d259c363afda), {
            viewportDimensions: t4
        }, t5, t7);
        $[55] = t4;
        $[56] = t5;
        $[57] = t7;
        $[58] = t8;
    } else t8 = $[58];
    return t8;
} : (props)=>{
    const { accountId: accountId, bridge: bridge, components: components, coreData: coreData, contextIds: contextIds, contextChangeListeners: contextChangeListeners, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionViewData: extensionViewData, getContextToken: getContextToken, mentionProvider: mentionProvider, product: product, locale: locale, modalExtension: modalExtension, onForgeDocUpdated: onForgeDocUpdated, getThreeLOPrompt: getThreeLOPrompt, customBridgeMethods: customBridgeMethods, customBridge: customBridge, customBridgeContext: customBridgeContext, loadingComponent: loadingComponent, onError: onError, extensionPayload: extensionPayload, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId, viewOnClose: viewOnClose, isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const [forgeDoc, setForgeDoc] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [shouldShowRenderer, setShouldShowRenderer] = (0, $cozmU.useState)(true);
    const isMacro = extension.type === 'xen:macro';
    // Custom UI already receives this via the iframe bridge. UI Kit has no
    // equivalent channel, so it is handed to the components that navigate.
    const hostOnNavigate = bridge?.onNavigate;
    const getComponents = (0, $kvlRh.useUIKitComponents)({
        accountId: accountId,
        bridge: bridge,
        cloudId: cloudId,
        workspaceId: workspaceId,
        mentionProvider: mentionProvider,
        product: product,
        components: components
    });
    const handleError = (0, $cozmU.useCallback)((error_0)=>{
        if (onError) onError(error_0.message);
        if (onAppError) onAppError(error_0.message);
    }, [
        onError,
        onAppError
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (onError && error) onError(error.message);
        if (onAppError && error) onAppError(error.message);
    }, [
        error,
        onError,
        onAppError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a873df2f22efbae1$export$aab0d259c363afda), {
        viewportDimensions: isMacro ? viewportDimensions : undefined
    }, shouldShowRenderer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ELQr.default), {
        forgeDoc: forgeDoc,
        extension: extension,
        error: error?.message,
        components: getComponents,
        modalExtension: modalExtension ? {
            ...modalExtension,
            viewOnClose: viewOnClose
        } : modalExtension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionType: extensionData.type,
        loading: true,
        loadingComponent: loadingComponent,
        onError: handleError,
        onSuccess: onSuccess,
        onNavigate: hostOnNavigate,
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI,
        openNewTabAsPopupWindow: bridge?.openNewTabAsPopupWindow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fa8a82457099ade3$export$c9565324b088e0b8), {
        accountId: accountId,
        setForgeDoc: (forgeDoc_0)=>{
            if (forgeDoc_0.type !== 'MacroConfig') setForgeDoc(forgeDoc_0);
            onForgeDocUpdated?.(forgeDoc_0);
        },
        setError: setError,
        components: getThreeLOPrompt,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        locale: locale,
        bridge: bridge,
        getContextToken: getContextToken,
        entryPoint: entryPoint,
        customBridgeMethods: customBridgeMethods,
        customBridge: customBridge,
        customBridgeContext: customBridgeContext,
        setShouldShowRenderer: setShouldShowRenderer,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedMacroParentType: embeddedMacroParentType,
        embeddedParentLocalId: embeddedParentLocalId,
        contextChangeListeners: contextChangeListeners
    }));
};
const $f5ddd1bbf56ef9be$export$9ca39743052e068e = (0, $8m50u.componentWithCondition)(()=>(0, $iDrrr.fg)('platform_forge_ui_uikit_modal_in_custom_ui_parent'), $f5ddd1bbf56ef9be$var$UIKitRendererNew, $f5ddd1bbf56ef9be$var$UIKitRendererOld);












var $5z7ti = parcelRequire("5z7ti");


var $iZJMv = parcelRequire("iZJMv");

const $b25768cf0d56e477$var$Frame = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { forgeDoc: forgeDoc, IframeRenderer: IframeRenderer } = t0;
    const { setFrameCount: setFrameCount } = (0, $cozmU.useContext)((0, $5z7ti.FrameCount));
    let t1;
    let t2;
    if ($[0] !== setFrameCount) {
        t1 = ()=>{
            setFrameCount($b25768cf0d56e477$var$_temp);
            return ()=>setFrameCount($b25768cf0d56e477$var$_temp2);
        };
        t2 = [
            setFrameCount
        ];
        $[0] = setFrameCount;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const { dispatch: dispatch, resource: resource, height: height, width: width } = forgeDoc.props;
    let t3;
    if ($[3] !== IframeRenderer || $[4] !== dispatch || $[5] !== height || $[6] !== resource || $[7] !== width) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IframeRenderer, {
            dispatch: dispatch,
            resource: resource,
            height: height,
            width: width
        });
        $[3] = IframeRenderer;
        $[4] = dispatch;
        $[5] = height;
        $[6] = resource;
        $[7] = width;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ forgeDoc: forgeDoc, IframeRenderer: IframeRenderer })=>{
    const { setFrameCount: setFrameCount } = (0, $cozmU.useContext)((0, $5z7ti.FrameCount));
    (0, $cozmU.useEffect)(()=>{
        setFrameCount((prevCount)=>prevCount + 1);
        return ()=>setFrameCount((prevCount_0)=>prevCount_0 - 1);
    }, [
        setFrameCount
    ]);
    const { dispatch: dispatch, resource: resource, height: height, width: width } = forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IframeRenderer, {
        dispatch: dispatch,
        resource: resource,
        height: height,
        width: width
    });
};
const $b25768cf0d56e477$var$FrameMemo = /*#__PURE__*/ (0, $cozmU.memo)($b25768cf0d56e477$var$Frame, (0, $iZJMv.forgePropsAreEqual));
const $b25768cf0d56e477$export$1f1ebfe6da5b177c = (IframeRenderer)=>{
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b25768cf0d56e477$var$FrameMemo, {
            ...props,
            IframeRenderer: IframeRenderer
        });
};
function $b25768cf0d56e477$var$_temp(prevCount) {
    return prevCount + 1;
}
function $b25768cf0d56e477$var$_temp2(prevCount_0) {
    return prevCount_0 - 1;
}


var $gOQX2 = parcelRequire("gOQX2");




var $bTHR7 = parcelRequire("bTHR7");


var $cIUmi = parcelRequire("cIUmi");


var $fQ6eZ = parcelRequire("fQ6eZ");





const $d55c0d830881fe1a$export$2faef82157961d5 = (extension, entryPoint)=>{
    if ((0, $c258392d9ab82a2d$export$a84c406ba9bc5e09)(extension, entryPoint) && (0, $iDrrr.fg)('forge-ui-worker-runtime')) return 'webworker';
    if ((0, $iDrrr.fg)('forge-ui-bridge-core-reset')) return 'iframev2';
    return 'iframe';
};



var $8yKod = parcelRequire("8yKod");


var $l07HN = parcelRequire("l07HN");


var $fFIqL = parcelRequire("fFIqL");














var $hjngh = parcelRequire("hjngh");





var $3nNWm = parcelRequire("3nNWm");





var $b8pma = parcelRequire("b8pma");

// Maximum time we would expect an app initialization to take.
const $6727d736affe6924$var$HOLD_MS_APP_INIT_TIMEOUT = 6000;
const $6727d736affe6924$var$HOLD_MS_FRAME_INITIALISED = 2000;
const $6727d736affe6924$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT = 5000;
const $6727d736affe6924$var$HOLD_MS_CATCH_LATENT_REQUESTS = 350;
const $6727d736affe6924$var$holdResourceStartEvents = new Set([
    'product-api-request-initiated',
    'resolver-invoke-initiated'
]);
const $6727d736affe6924$var$holdResourceEndEvents = new Set([
    'product-api-requested',
    'resolver-invoked'
]);
const $6727d736affe6924$var$holdAffectingEvents = new Set([
    ...$6727d736affe6924$var$holdResourceStartEvents,
    ...$6727d736affe6924$var$holdResourceEndEvents,
    'navigation-timing',
    'user-interacted'
]);
const $6727d736affe6924$export$e286348a1f2b0a60 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { children: children } = t0;
    const timelineRef = (0, $cozmU.useContext)((0, $fFIqL.PerformanceAnalyticsContext));
    const { captureEvent: captureEvent } = (0, $3nNWm.usePerformanceAnalytics)();
    const appRuntimeInitiated = (0, $cozmU.useRef)(false);
    const [holdState, setHoldState] = (0, $cozmU.useState)("holding");
    const releaseTimeoutRef = (0, $cozmU.useRef)();
    const holdResourcesStartedCountRef = (0, $cozmU.useRef)(0);
    const holdResourcesFinishedCountRef = (0, $cozmU.useRef)(0);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            clearTimeout(releaseTimeoutRef.current);
            setHoldState("released");
        };
        $[0] = t1;
    } else t1 = $[0];
    const releaseHold = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (holdFor)=>{
            clearTimeout(releaseTimeoutRef.current);
            releaseTimeoutRef.current = setTimeout(releaseHold, holdFor);
        };
        $[1] = t2;
    } else t2 = $[1];
    const retainHoldFor = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (event)=>{
            if (!$6727d736affe6924$var$holdAffectingEvents.has(event.type)) return;
            if (event.type === "user-interacted") {
                releaseHold();
                return;
            }
            const resourceHoldStarted = $6727d736affe6924$var$holdResourceStartEvents.has(event.type);
            const resourceHoldFinished = $6727d736affe6924$var$holdResourceEndEvents.has(event.type);
            if (resourceHoldStarted) holdResourcesStartedCountRef.current = holdResourcesStartedCountRef.current + 1;
            else if (resourceHoldFinished) holdResourcesFinishedCountRef.current = holdResourcesFinishedCountRef.current + 1;
            const activeResourceRequests = holdResourcesStartedCountRef.current - holdResourcesFinishedCountRef.current;
            if (!appRuntimeInitiated.current) {
                if (event.type === "navigation-timing") {
                    appRuntimeInitiated.current = true;
                    retainHoldFor(activeResourceRequests > 0 ? $6727d736affe6924$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT : $6727d736affe6924$var$HOLD_MS_FRAME_INITIALISED);
                }
                return;
            }
            if (resourceHoldStarted) retainHoldFor($6727d736affe6924$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT);
            if (activeResourceRequests > 0) return;
            retainHoldFor($6727d736affe6924$var$HOLD_MS_CATCH_LATENT_REQUESTS);
        };
        $[2] = t3;
    } else t3 = $[2];
    const handleEvent = t3;
    let t4;
    let t5;
    if ($[3] !== timelineRef) {
        t4 = ()=>{
            retainHoldFor($6727d736affe6924$var$HOLD_MS_APP_INIT_TIMEOUT);
            const { listeners: listeners } = timelineRef.current;
            listeners.add(handleEvent);
            return ()=>{
                clearTimeout(releaseTimeoutRef.current);
                listeners.delete(handleEvent);
            };
        };
        t5 = [
            timelineRef,
            handleEvent,
            retainHoldFor
        ];
        $[3] = timelineRef;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[6] !== captureEvent || $[7] !== holdState) {
        t6 = ()=>()=>{
                if (holdState === "holding") captureEvent({
                    type: "page-hold-released",
                    elapsed: (0, $hjngh.getPerformanceMark)()
                });
            };
        t7 = [
            holdState,
            captureEvent
        ];
        $[6] = captureEvent;
        $[7] = holdState;
        $[8] = t6;
        $[9] = t7;
    } else {
        t6 = $[8];
        t7 = $[9];
    }
    (0, $cozmU.useEffect)(t6, t7);
    const t8 = holdState === "holding";
    let t9;
    if ($[10] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "forge-ui-app-content-ttai-wait-v2",
            hold: t8
        });
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== children || $[13] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t9, children);
        $[12] = children;
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    return t10;
} : ({ children: children })=>{
    const timelineRef = (0, $cozmU.useContext)((0, $fFIqL.PerformanceAnalyticsContext));
    const { captureEvent: captureEvent } = (0, $3nNWm.usePerformanceAnalytics)();
    const appRuntimeInitiated = (0, $cozmU.useRef)(false);
    const [holdState, setHoldState] = (0, $cozmU.useState)('holding');
    const releaseTimeoutRef = (0, $cozmU.useRef)();
    const holdResourcesStartedCountRef = (0, $cozmU.useRef)(0);
    const holdResourcesFinishedCountRef = (0, $cozmU.useRef)(0);
    const releaseHold = (0, $cozmU.useCallback)(()=>{
        clearTimeout(releaseTimeoutRef.current);
        setHoldState('released');
    }, [
        setHoldState
    ]);
    const retainHoldFor = (0, $cozmU.useCallback)((holdFor)=>{
        clearTimeout(releaseTimeoutRef.current);
        releaseTimeoutRef.current = setTimeout(releaseHold, holdFor);
    }, [
        releaseHold
    ]);
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        if (!$6727d736affe6924$var$holdAffectingEvents.has(event.type)) return;
        // Drop holds on user interaction (timeline invalidated).
        if (event.type === 'user-interacted') {
            releaseHold();
            return;
        }
        // Keep track of requests starting and finished, don't consider in holding
        // logic until the app has initialised.
        const resourceHoldStarted = $6727d736affe6924$var$holdResourceStartEvents.has(event.type);
        const resourceHoldFinished = $6727d736affe6924$var$holdResourceEndEvents.has(event.type);
        if (resourceHoldStarted) holdResourcesStartedCountRef.current += 1;
        else if (resourceHoldFinished) holdResourcesFinishedCountRef.current += 1;
        const activeResourceRequests = holdResourcesStartedCountRef.current - holdResourcesFinishedCountRef.current;
        // Retain unconditional hold until 'navigation-timing' is received to indicate
        // that the frame runtime has initialised correctly.
        if (!appRuntimeInitiated.current) {
            if (event.type === 'navigation-timing') {
                appRuntimeInitiated.current = true;
                retainHoldFor(activeResourceRequests > 0 ? $6727d736affe6924$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT : $6727d736affe6924$var$HOLD_MS_FRAME_INITIALISED);
            }
            return;
        }
        // On new resource holds, reset to default resource request timeout.
        if (resourceHoldStarted) retainHoldFor($6727d736affe6924$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT);
        // Retain hold until all active requests are finished.
        if (activeResourceRequests > 0) return;
        // No active resource requests, wait a moment to catch any new resource
        // requests initiated by the app runtime.
        retainHoldFor($6727d736affe6924$var$HOLD_MS_CATCH_LATENT_REQUESTS);
    }, [
        releaseHold,
        retainHoldFor
    ]);
    // Event listener management.
    (0, $cozmU.useEffect)(()=>{
        // Default timeout for app init, so we don't indefinitely on e.g. for
        // unhandled app errors.
        retainHoldFor($6727d736affe6924$var$HOLD_MS_APP_INIT_TIMEOUT);
        const { listeners: listeners } = timelineRef.current;
        listeners.add(handleEvent);
        return ()=>{
            clearTimeout(releaseTimeoutRef.current);
            listeners.delete(handleEvent);
        };
    }, [
        timelineRef,
        handleEvent,
        retainHoldFor
    ]);
    (0, $cozmU.useEffect)(()=>{
        // On hold state change or component dismount: flag release in timeline.
        return ()=>{
            if (holdState === 'holding') captureEvent({
                type: 'page-hold-released',
                elapsed: (0, $hjngh.getPerformanceMark)()
            });
        };
    }, [
        holdState,
        captureEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "forge-ui-app-content-ttai-wait-v2",
        hold: holdState === 'holding'
    }), children);
};
const $6727d736affe6924$export$4304f91d6e983d05 = (0, $8m50u.componentWithCondition)(()=>(0, $iDrrr.fg)('forge-ui-app-perf-tracking-enabled'), $6727d736affe6924$export$e286348a1f2b0a60, (0, $cozmU.Fragment));



var $5Zman = parcelRequire("5Zman");

/**
 * Inner wrapper rendered inside PerformanceAnalyticsProviderRollout so it can
 * access PerformanceAnalyticsContext and wire up UFOThirdPartySegment's iframe
 * behavior via onRegisterIframeEventListener.
 */ const $16bbca7bf93a7e97$var$UFOThirdPartySegmentWithPerfTimeline = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UFOThirdPartySegmentWithPerfTimeline(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { children: children, name: name, extraData: extraData, moduleType: moduleType, isBackgroundModule: isBackgroundModule } = t0;
    const timelineRef = (0, $cozmU.useContext)((0, $fFIqL.PerformanceAnalyticsContext));
    let t1;
    if ($[0] !== timelineRef) {
        t1 = (listener)=>{
            const timeline = timelineRef?.current;
            if (!timeline) return $16bbca7bf93a7e97$var$_temp;
            timeline.listeners.add(listener);
            return ()=>{
                timeline.listeners.delete(listener);
            };
        };
        $[0] = timelineRef;
        $[1] = t1;
    } else t1 = $[1];
    const onRegisterIframeEventListener = t1;
    let t2;
    if ($[2] !== extraData || $[3] !== name) {
        t2 = {
            name: name,
            ...extraData,
            excludedFromMetrics: true,
            reason: "background-script"
        };
        $[2] = extraData;
        $[3] = name;
        $[4] = t2;
    } else t2 = $[4];
    const excludedData = t2;
    const isBackground = isBackgroundModule || moduleType?.endsWith(":backgroundScript");
    if (isBackground && (0, $iDrrr.fg)("platform_forge_ufo_exclude_bg_scripts_from_3p")) {
        let t3;
        if ($[5] !== children || $[6] !== excludedData || $[7] !== name) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
                name: name,
                excludeFromMetrics: true,
                excludedData: excludedData
            }, children);
            $[5] = children;
            $[6] = excludedData;
            $[7] = name;
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    let t3;
    if ($[9] !== children || $[10] !== extraData || $[11] !== name || $[12] !== onRegisterIframeEventListener) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: name,
            onRegisterIframeEventListener: onRegisterIframeEventListener,
            extraData: extraData
        }, children);
        $[9] = children;
        $[10] = extraData;
        $[11] = name;
        $[12] = onRegisterIframeEventListener;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : function UFOThirdPartySegmentWithPerfTimeline({ children: children, name: name, extraData: extraData, moduleType: moduleType, isBackgroundModule: isBackgroundModule }) {
    const timelineRef = (0, $cozmU.useContext)((0, $fFIqL.PerformanceAnalyticsContext));
    const onRegisterIframeEventListener = (0, $cozmU.useCallback)((listener)=>{
        const timeline = timelineRef?.current;
        if (!timeline) return ()=>{};
        timeline.listeners.add(listener);
        return ()=>{
            timeline.listeners.delete(listener);
        };
    }, [
        timelineRef
    ]);
    // Stable reference for the excluded-module breadcrumb so the segment's writer records it.
    // `extraData` is stable in practice (memoized upstream as `ufoSegmentExtraData`)
    const excludedData = (0, $cozmU.useMemo)(()=>({
            name: name,
            ...extraData,
            excludedFromMetrics: true,
            reason: 'background-script'
        }), [
        name,
        extraData
    ]);
    // Background modules render no visible UI but keep an iframe alive that would otherwise
    // register a long-lived `forge-ui-requests` third-party hold. That hold never cleanly releases,
    // deferring the interaction's third-party metric window until it is force-closed and
    // massively inflating `ttai_include_third_party`.
    // Render a plain third-party segment without the iframe timeline wiring, so no metric-affecting
    // hold is registered.
    //
    // Products own their module taxonomy and opt in by passing `isBackgroundModule`. The
    // `*:backgroundScript` suffix is a generic, product-agnostic fallback for callers that do not.
    const isBackground = isBackgroundModule || moduleType?.endsWith(':backgroundScript');
    if (isBackground && (0, $iDrrr.fg)('platform_forge_ufo_exclude_bg_scripts_from_3p')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
        name: name,
        excludeFromMetrics: true,
        excludedData: excludedData
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
        name: name,
        onRegisterIframeEventListener: onRegisterIframeEventListener,
        extraData: extraData
    }, children);
};
function $16bbca7bf93a7e97$var$_temp() {}
const $16bbca7bf93a7e97$export$b89b612df1c715da = (props)=>{
    const { accountId: accountId, bridge: bridge, components: components, consentMessage: consentMessage, contextIds: contextIds, contextChangeListeners: contextChangeListeners, customBridgeMethods: customBridgeMethods, customBridge: customBridge, customBridgeContext: customBridgeContext, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, hasModalConsentPrompt: hasModalConsentPrompt, height: height, width: width, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, getContextToken: getContextToken, loadingComponent: loadingComponent, locale: locale, localId: localId, mentionProvider: mentionProvider, modalExtension: modalExtension, modalStyles: modalStyles, modalProvider: modalProvider, onConsentModalClose: onConsentModalClose, onConsentSuccess: onConsentSuccess, onConsentInitialization: onConsentInitialization, onError: onError, onForgeDocUpdated: onForgeDocUpdated, onIframeLoad: onIframeLoad, onInitialRender: onInitialRender, product: product, timezone: timezone, getModalWidth: getModalWidth, onModalExtensionClose: onModalExtensionClose, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedParentLocalId: embeddedParentLocalId, isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI } = props;
    let cloudId;
    let workspaceId;
    if ('cloudId' in props) cloudId = props.cloudId;
    else if ('workspaceId' in props) workspaceId = props.workspaceId;
    const cloudOrWorkspaceId = cloudId ? {
        cloudId: cloudId
    } : {
        workspaceId: workspaceId
    };
    const { id: extensionId, environmentId: environmentId, environmentType: environmentType } = extension;
    (0, $cozmU.useEffect)(()=>{
        onInitialRender?.();
    }, [
        onInitialRender
    ]);
    const coreData = (0, $cozmU.useMemo)(()=>({
            workspaceId: workspaceId,
            cloudId: cloudId,
            localId: localId || extensionId,
            environmentId: environmentId,
            environmentType: environmentType
        }), [
        cloudId,
        environmentId,
        environmentType,
        extensionId,
        localId,
        workspaceId
    ]);
    const getThreeLOPrompt = (0, $cozmU.useCallback)(()=>({
            ThreeLOPrompt: modalExtension || hasModalConsentPrompt ? (0, $gOQX2.makeModalThreeLOPromptForCustomUI)({
                appName: extension.properties.title,
                isBlanketHidden: true,
                onClose: onConsentModalClose
            }) : (0, $cVuzC.makeThreeLOPromptForCustomUI)({
                appName: extension.properties.title,
                onSuccess: onConsentSuccess,
                message: consentMessage,
                onInitialization: onConsentInitialization
            })
        }), [
        extension.properties.title,
        consentMessage,
        hasModalConsentPrompt,
        modalExtension,
        onConsentSuccess,
        onConsentModalClose,
        onConsentInitialization
    ]);
    const customUIProps = {
        accountId: accountId,
        bridge: bridge,
        consentMessage: consentMessage,
        contextIds: contextIds,
        contextChangeListeners: contextChangeListeners,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        customBridge: customBridge,
        customBridgeContext: customBridgeContext,
        dialogs: dialogs,
        entryPoint: entryPoint,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        getThreeLOPrompt: getThreeLOPrompt,
        height: height,
        loadingComponent: loadingComponent,
        locale: locale,
        localId: localId,
        mentionProvider: mentionProvider,
        modalExtension: modalExtension,
        modalStyles: modalStyles,
        modalProvider: modalProvider,
        onConsentModalClose: onConsentModalClose,
        onConsentSuccess: onConsentSuccess,
        onError: onError,
        onForgeDocUpdated: onForgeDocUpdated,
        onIframeLoad: onIframeLoad,
        product: product,
        timezone: timezone,
        isIframeHidden: isIframeHidden,
        isIframeResizable: isIframeResizable,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    };
    const uiKitEmbeddedMacroProps = {
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    };
    const [viewOnClose, setViewOnClose] = (0, $cozmU.useState)();
    // this function has known deps listed already in deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const FrameResizable = (0, $cozmU.useCallback)((0, $b25768cf0d56e477$export$1f1ebfe6da5b177c)((inputProps)=>{
        const { height: height, width: width, dispatch: dispatch } = inputProps;
        // If height or width is provided by app code, the iframe does not automatically resize to contents
        const isIframeResizable = height || width ? false : true;
        // A Frame resource is supplied at runtime by app code, so it supports the same
        // `<resourceKey>/<entryKey>` multi-entry convention as dynamic modal resources.
        const { resource: resource, resolvedResourceEntry: resolvedResourceEntry } = (0, $l07HN.resolveDynamicResource)(inputProps.resource);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKlwt.CustomUIRenderer), {
            ...customUIProps,
            bridge: {
                ...customUIProps.bridge,
                getFrameDispatch: ()=>dispatch
            },
            extension: {
                ...extension,
                properties: {
                    ...extension.properties,
                    resource: resource,
                    resolvedResourceEntry: resolvedResourceEntry
                }
            },
            // Ensure extensions that are rendered as entryPoints aren't passing through the very same entryPoint to the Frame
            entryPoint: undefined,
            // Ensures Frame is always resized to the full height of the content
            // Required because Jira leaves isIframeResizable as false
            isIframeResizable: isIframeResizable,
            height: height,
            width: width
        });
    }), // need eslint here as re-render only depends on extensionData & extensionPayload
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        customUIProps.extensionData,
        customUIProps.extensionPayload,
        extension
    ]);
    const ufoSegmentExtraData = (0, $cozmU.useMemo)(()=>{
        const idParts = (0, $cIUmi.extensionIdToAnalyticsAttributes)(props.extension.id);
        return {
            appType: (0, $8yKod.isCustomUI)(props.extension, props.entryPoint) ? 'CustomUI' : 'UIKit',
            extensionKey: idParts?.extensionKey,
            appId: idParts?.appId ?? props.extension.appId,
            envId: idParts?.environmentId ?? props.extension.environmentId,
            envType: props.extension.environmentType,
            installationId: props.extension.installationId,
            moduleType: props.extension.type,
            appVersion: props.extension.appVersion
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.extension.id,
        props.extension.environmentId,
        props.extension.environmentType,
        props.extension.installationId,
        props.extension.type,
        props.extension.appVersion,
        props.entryPoint
    ]);
    // Derived at render time from the extension + feature gates. ForgeUIRenderer is an ancestor of
    // every runtime terminal (WorkerWebRuntime / InnerIframe v1/v2 via WebRuntime/Iframe), so this
    // single context tags all events fired below it — both renderer-level events (forge.ui.renderer,
    // forge.ui.extension/loaded) and the terminal bridge/app events. Keep getForgeRuntimeType in sync
    // with the gate decisions in WebRuntime and Iframe.
    const runtimeType = (0, $d55c0d830881fe1a$export$2faef82157961d5)(props.extension, props.entryPoint);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bTHR7.ForgeUIExtensionAnalyticsContext), {
        extensionId: props.extension.id,
        localId: props.localId || props.extension.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fQ6eZ.ForgeUIRuntimeAnalyticsContext), {
        runtime: runtimeType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fFIqL.PerformanceAnalyticsProviderRollout), {
        profileKey: `${props.extension.id}-${props.extension.key}-${props.entryPoint}`,
        appType: (0, $8yKod.isCustomUI)(props.extension, props.entryPoint) ? 'CustomUI' : 'UIKit',
        forgeEnvironment: props.extension.environmentType,
        extensionType: props.extension.type,
        appVersion: props.extension.appVersion
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16bbca7bf93a7e97$var$UFOThirdPartySegmentWithPerfTimeline, {
        name: "forge-ui-app-content-root",
        extraData: ufoSegmentExtraData,
        moduleType: props.extension.type,
        isBackgroundModule: props.isBackgroundModule
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6727d736affe6924$export$4304f91d6e983d05), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Zman.UserAccessProvider), {
        accountId: accountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        hidden: true,
        id: "forge-ui-renderer"
    }), !(0, $8yKod.isCustomUI)(extension, entryPoint) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5ddd1bbf56ef9be$export$9ca39743052e068e), {
        coreData: coreData,
        getThreeLOPrompt: getThreeLOPrompt,
        accountId: accountId,
        contextIds: contextIds,
        customBridge: customBridge,
        customBridgeContext: customBridgeContext,
        extension: extension,
        extensionData: extensionData,
        extensionViewData: extensionViewData,
        product: product,
        bridge: {
            // spread down here so product can override the default onClose
            ...modalExtension ? {
                onClose: (callback)=>{
                    setViewOnClose(()=>callback.data);
                    return true;
                }
            } : {},
            ...bridge
        },
        customBridgeMethods: customBridgeMethods,
        components: {
            Frame: FrameResizable,
            ...components
        },
        consentMessage: consentMessage,
        entryPoint: entryPoint,
        getContextToken: getContextToken,
        locale: locale,
        localId: localId,
        mentionProvider: mentionProvider,
        modalExtension: modalExtension,
        onConsentSuccess: onConsentSuccess,
        onForgeDocUpdated: onForgeDocUpdated,
        timezone: timezone,
        onConsentModalClose: onConsentModalClose,
        onError: onError,
        loadingComponent: loadingComponent,
        extensionPayload: extensionPayload,
        onSuccess: onSuccess,
        ...cloudOrWorkspaceId,
        onAppError: onAppError,
        viewportDimensions: viewportDimensions,
        viewOnClose: viewOnClose,
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI,
        contextChangeListeners: contextChangeListeners,
        ...uiKitEmbeddedMacroProps
    }) : modalExtension ? // getModalWidth not applied here since all modal extensions are defaulted to medium width
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKlwt.ModalCustomUIRenderer), {
        ...customUIProps,
        bridge: {
            ...modalExtension ? {
                onClose: (callback)=>{
                    setViewOnClose(()=>callback.data);
                    // stores the callback for when modal is closed
                    return true;
                }
            } : {},
            // spread down here so product can override the default onClose
            ...customUIProps.bridge
        },
        modalOnClose: onModalExtensionClose,
        closeOnEscape: modalExtension?.shouldCloseOnEscapePress ?? true,
        closeOnOverlayClick: modalExtension?.shouldCloseOnOverlayClick ?? true,
        viewOnClose: viewOnClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKlwt.CustomUIRenderer), {
        ...customUIProps,
        getModalWidth: getModalWidth,
        width: width
    }))))))));
};
module.exports["ForgeUIRenderer"] = $16bbca7bf93a7e97$export$b89b612df1c715da;

});

parcelRegister("iZJMv", function(module, exports) {
/**
 * this function assume the inputs are not same object, and hence
 * it doesn't check for reference equality.
 *
 * Additionally, it check keys of the object and then check the values
 * for better performance.
 */ const $183cbcf42564c679$var$objectValuesAreEqual = (prev, next, valuesAreEqual)=>{
    const keys = Object.keys(prev);
    const length = keys.length;
    if (length !== Object.keys(next).length) return false;
    // there are two small optimization techniques used in this file:
    // 1. using decrementing for loop instead of incrementing for loop,
    //    to reduce 1 instruction per iteration.
    // 2. for object equality check, we check the key match first and then
    //    the value match. This is to identify the inequality as soon as possible.
    for(let i = length; i-- !== 0;){
        if (!(keys[i] in next)) return false;
    }
    for(let i = length; i-- !== 0;){
        const key = keys[i];
        if (!valuesAreEqual(prev[key], next[key])) return false;
    }
    return true;
};
/**
 * Some of the ideas are based on https://github.com/FormidableLabs/react-fast-compare
 */ const $183cbcf42564c679$var$forgeDocPropValuesAreEqual = (prev, next)=>{
    if (prev === next) return true;
    else if (!prev || !next) return false;
    else if (typeof prev === 'function' && typeof next === 'function') // if the function is a crossDomainFunctionWrapper (i.e. post-bot),
    // then we can check if the function is the same by looking at the
    // __id__ property.
    return prev.__id__ === next.__id__;
    else if (typeof prev === 'object' && typeof next === 'object') {
        if (prev.constructor !== next.constructor) return false;
        else if (Array.isArray(prev)) {
            const length = prev.length;
            if (length !== next.length) return false;
            for(let i = length; i-- !== 0;){
                if (!$183cbcf42564c679$var$forgeDocPropValuesAreEqual(prev[i], next[i])) return false;
            }
            return true;
        } else if (prev.valueOf !== Object.prototype.valueOf && typeof prev.valueOf === 'function' && typeof next.valueOf === 'function') return prev.valueOf() === next.valueOf();
        else if (prev.toString !== Object.prototype.toString && typeof prev.toString === 'function' && typeof next.toString === 'function') return prev.toString() === next.toString();
        return $183cbcf42564c679$var$objectValuesAreEqual(prev, next, $183cbcf42564c679$var$forgeDocPropValuesAreEqual);
    }
    return false;
};
const $183cbcf42564c679$var$forgeDocPropsAreEqual = (prev, next)=>{
    if (prev === next) return true;
    else if (!prev || !next) return false;
    return $183cbcf42564c679$var$objectValuesAreEqual(prev, next, $183cbcf42564c679$var$forgeDocPropValuesAreEqual);
};
/**
 * the function is used to cache the hasChanged value in the ForgeDoc.
 * Please note, the cached result need to be stored in the next prop not the prev prop.
 * This is because react internally caches the props, and the cache become stale
 * at every render, if the calculation depends on the prev prop, the stale cache
 * will impact the accuracy of the result.
 */ const $183cbcf42564c679$var$cacheForgeDocHasChanged = (nextDoc, hasChanged)=>{
    nextDoc.hasChanged = hasChanged;
    return !hasChanged;
};
const $183cbcf42564c679$var$forgeDocsAreEqual = (prev, next)=>{
    if (next.hasChanged !== undefined) return !next.hasChanged;
    else if (prev === next) return $183cbcf42564c679$var$cacheForgeDocHasChanged(next, false);
    else if (!prev || !next) return next ? $183cbcf42564c679$var$cacheForgeDocHasChanged(next, true) : false;
    if (prev.type !== next.type || prev.key !== next.key) return $183cbcf42564c679$var$cacheForgeDocHasChanged(next, true);
    else if (prev.children !== next.children) {
        if (prev.children?.length !== next.children?.length) return $183cbcf42564c679$var$cacheForgeDocHasChanged(next, true);
        const length = prev.children?.length ?? 0;
        for(let i = length; i-- !== 0;){
            if (!$183cbcf42564c679$var$forgeDocsAreEqual(prev.children[i], next.children[i])) return $183cbcf42564c679$var$cacheForgeDocHasChanged(next, true);
        }
    }
    return $183cbcf42564c679$var$cacheForgeDocHasChanged(next, !$183cbcf42564c679$var$forgeDocPropsAreEqual(prev.props, next.props));
};
const $183cbcf42564c679$export$5d1c9ea31ee6a28f = (prev, next)=>$183cbcf42564c679$var$forgeDocsAreEqual(prev.forgeDoc, next.forgeDoc);
module.exports["forgePropsAreEqual"] = $183cbcf42564c679$export$5d1c9ea31ee6a28f;

});

parcelRegister("gOQX2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cuaBm = parcelRequire("cuaBm");


var $4aRua = parcelRequire("4aRua");


const $d1caaa81e83764e5$var$AKModalDialog = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("cSxir")));

const $d1caaa81e83764e5$var$AKModalTransition = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("cSxir")).then((module)=>({
            default: module.ModalTransition
        })));

const $d1caaa81e83764e5$var$AKModalHeader = /*#__PURE__*/ (0, $cozmU.lazy)(()=>Promise.resolve((parcelRequire("9Umtx"))));

const $d1caaa81e83764e5$var$AKModalTitle = /*#__PURE__*/ (0, $cozmU.lazy)(()=>Promise.resolve((parcelRequire("jq995"))));

const $d1caaa81e83764e5$var$AKModalBody = /*#__PURE__*/ (0, $cozmU.lazy)(()=>Promise.resolve((parcelRequire("fEPJS"))));

const $d1caaa81e83764e5$var$AKModalFooter = /*#__PURE__*/ (0, $cozmU.lazy)(()=>Promise.resolve((parcelRequire("eQiT1"))));

const $d1caaa81e83764e5$var$AKButton = /*#__PURE__*/ (0, $cozmU.lazy)(()=>Promise.resolve((parcelRequire("vIR70"))));

const $d1caaa81e83764e5$var$SectionMessage = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("fD3vt")));
const $d1caaa81e83764e5$var$ModalThreeLOPrompt = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    let isBlanketHidden;
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ onClose: t1, isBlanketHidden: isBlanketHidden, ...props } = t0);
        $[0] = t0;
        $[1] = isBlanketHidden;
        $[2] = props;
        $[3] = t1;
    } else {
        isBlanketHidden = $[1];
        props = $[2];
        t1 = $[3];
    }
    const onClose = t1 === undefined ? $d1caaa81e83764e5$var$_temp : t1;
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $cuaBm.useAuth)(props);
    const { authUrl: authUrl } = props;
    const isAuthUrlEmpty = !authUrl || authUrl === "";
    const intl = (0, $kSwu1.useIntl)();
    let t2;
    if ($[4] !== intl || $[5] !== isAuthUrlEmpty || $[6] !== promptMessage) {
        t2 = isAuthUrlEmpty ? {
            modalTitle: intl.formatMessage($d1caaa81e83764e5$var$messages.modalErrorTitle),
            modalBody: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$SectionMessage, {
                appearance: "error"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "p"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d1caaa81e83764e5$var$messages.noAuthURLErrorMessage)))
        } : {
            modalTitle: intl.formatMessage($d1caaa81e83764e5$var$messages.modalAccessRequiredTitle),
            modalBody: promptMessage
        };
        $[4] = intl;
        $[5] = isAuthUrlEmpty;
        $[6] = promptMessage;
        $[7] = t2;
    } else t2 = $[7];
    const { modalTitle: modalTitle, modalBody: modalBody } = t2;
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(true);
    let t3;
    if ($[8] !== buttonText || $[9] !== intl || $[10] !== isAuthUrlEmpty || $[11] !== isBlanketHidden || $[12] !== isModalOpen || $[13] !== loading || $[14] !== modalBody || $[15] !== modalTitle || $[16] !== onClose || $[17] !== startAuth) {
        t3 = isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKModalDialog, {
            onClose: ()=>{
                setIsModalOpen(false);
                onClose();
            },
            isBlanketHidden: isBlanketHidden
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKModalHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKModalTitle, null, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKModalBody, null, modalBody), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKModalFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKButton, {
            appearance: "subtle",
            onClick: ()=>{
                setIsModalOpen(false);
                onClose();
            }
        }, intl.formatMessage($d1caaa81e83764e5$var$messages.cancelButtonLabel)), !isAuthUrlEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKButton, {
            appearance: "primary",
            autoFocus: true,
            isLoading: loading,
            onClick: startAuth
        }, buttonText)));
        $[8] = buttonText;
        $[9] = intl;
        $[10] = isAuthUrlEmpty;
        $[11] = isBlanketHidden;
        $[12] = isModalOpen;
        $[13] = loading;
        $[14] = modalBody;
        $[15] = modalTitle;
        $[16] = onClose;
        $[17] = startAuth;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKModalTransition, null, t3);
        $[19] = t3;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
} : ({ onClose: onClose = ()=>{}, isBlanketHidden: isBlanketHidden, ...props })=>{
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $cuaBm.useAuth)(props);
    const { authUrl: authUrl } = props;
    const isAuthUrlEmpty = !authUrl || authUrl === '';
    const intl = (0, $kSwu1.useIntl)();
    const { modalTitle: modalTitle, modalBody: modalBody } = isAuthUrlEmpty ? {
        modalTitle: intl.formatMessage($d1caaa81e83764e5$var$messages.modalErrorTitle),
        modalBody: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$SectionMessage, {
            appearance: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d1caaa81e83764e5$var$messages.noAuthURLErrorMessage)))
    } : {
        modalTitle: intl.formatMessage($d1caaa81e83764e5$var$messages.modalAccessRequiredTitle),
        modalBody: promptMessage
    };
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKModalTransition, null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKModalDialog, {
        onClose: ()=>{
            setIsModalOpen(false);
            onClose();
        },
        isBlanketHidden: isBlanketHidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKModalHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKModalTitle, null, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKModalBody, null, modalBody), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKModalFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKButton, {
        appearance: "subtle",
        onClick: ()=>{
            setIsModalOpen(false);
            onClose();
        }
    }, intl.formatMessage($d1caaa81e83764e5$var$messages.cancelButtonLabel)), !isAuthUrlEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$AKButton, {
        appearance: "primary",
        autoFocus: true,
        isLoading: loading,
        onClick: startAuth
    }, buttonText))));
};
var $d1caaa81e83764e5$export$2e2bcd8739ae039 = $d1caaa81e83764e5$var$ModalThreeLOPrompt;
const $d1caaa81e83764e5$export$ee02671eeeecd75 = ({ onClose: onClose, appName: appName })=>{
    return function modalThreeLOPrompt({ forgeDoc: { props: props }, dispatch: dispatch }) {
        const { message: message, authUrl: authUrl, promptText: promptText } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$ModalThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            onSuccess: ()=>dispatch({
                    type: 'render',
                    extensionData: {}
                }),
            appName: appName,
            onClose: onClose
        });
    };
};
const $d1caaa81e83764e5$export$85a504818a81117d = ({ onClose: onClose, appName: appName, isBlanketHidden: isBlanketHidden = false })=>{
    return (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1caaa81e83764e5$var$ModalThreeLOPrompt, {
            ...props,
            appName: appName,
            onClose: onClose,
            isBlanketHidden: isBlanketHidden
        });
    };
};
const $d1caaa81e83764e5$var$messages = (0, $kSwu1.defineMessages)({
    noAuthURLErrorMessage: {
        id: "confluence.threeLOPrompt.modal.no.authURL.error-message",
        defaultMessage: "Consent URL not found. Please refresh the page and try again."
    },
    modalErrorTitle: {
        id: "confluence.threeLOPrompt.modal.error.title",
        defaultMessage: "Error"
    },
    modalAccessRequiredTitle: {
        id: "confluence.threeLOPrompt.modal.access.required.title",
        defaultMessage: "Access required"
    },
    cancelButtonLabel: {
        id: "forge-ui.threeLOPrompt.modal.cancel.button.label",
        defaultMessage: "Cancel"
    }
});
function $d1caaa81e83764e5$var$_temp() {}
module.exports["makeModalThreeLOPrompt"] = $d1caaa81e83764e5$export$ee02671eeeecd75;
module.exports["makeModalThreeLOPromptForCustomUI"] = $d1caaa81e83764e5$export$85a504818a81117d;

});

parcelRegister("cSxir", function(module, exports) {

let $96045b240aff7858$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $96045b240aff7858$var$load("9iwvP").then(()=>parcelRequire('aWOcj'));

});

parcelRegister("bTHR7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");


var $cIUmi = parcelRequire("cIUmi");


var $jAJ6s = parcelRequire("jAJ6s");

const $99d4de14da471662$export$5c431bb5ef7d7900 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { extensionId: extensionId, localId: localId, children: children } = t0;
    (0, $jAJ6s.setupContextKeysFromSessionStorage)();
    let t1;
    if ($[0] !== extensionId) {
        t1 = (0, $cIUmi.extensionIdToAnalyticsAttributes)(extensionId);
        $[0] = extensionId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== localId || $[3] !== t1) {
        t2 = {
            forgeUIAttributes: {
                localId: localId,
                ...t1
            }
        };
        $[2] = localId;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: t2
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ extensionId: extensionId, localId: localId, children: children })=>{
    (0, $jAJ6s.setupContextKeysFromSessionStorage)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: {
            forgeUIAttributes: {
                localId: localId,
                ...(0, $cIUmi.extensionIdToAnalyticsAttributes)(extensionId)
            }
        }
    }, children);
};
module.exports["ForgeUIExtensionAnalyticsContext"] = $99d4de14da471662$export$5c431bb5ef7d7900;

});

parcelRegister("cIUmi", function(module, exports) {

var $9cGsb = parcelRequire("9cGsb");

function $8c01080324ab9f29$export$d4650cd03b563908(extensionId) {
    if (!extensionId) return {};
    try {
        const ari = (0, $9cGsb.parse)(extensionId);
        if (!ari.resourceId) return {};
        const [appId, environmentId, groupId, extensionKey] = ari.resourceId.split('/');
        return {
            appId: appId,
            environmentId: environmentId,
            groupId: groupId,
            extensionKey: extensionKey
        };
    } catch  {
        return {};
    }
}
module.exports["extensionIdToAnalyticsAttributes"] = $8c01080324ab9f29$export$d4650cd03b563908;

});

parcelRegister("1JyKZ", function(module, exports) {
/**
 * @generated SignedSource<<44676e88351503ec74d9733ae15d6987>>
 * @relayHash bfc43724fd2fc3a6f132a6d5f7e9da68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aebc4ac6f19efb4f09e20cf9c09e3afa223b9374353fd6d698d7b653144dd21f
const $dc4f7aee3cccfa96$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceForgeContextTokenPayload",
            "kind": "LinkedField",
            "name": "confluence_generateForgeContextToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceForgeContextToken",
                    "kind": "LinkedField",
                    "name": "forgeContextToken",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "jwt"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "expiresAt"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "extensionId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useGetContextTokenMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useGetContextTokenMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "bfc43724fd2fc3a6f132a6d5f7e9da68",
            "id": "aebc4ac6f19efb4f09e20cf9c09e3afa223b9374353fd6d698d7b653144dd21f",
            "metadata": {},
            "name": "useGetContextTokenMutation",
            "operationKind": "mutation",
            "text": "mutation useGetContextTokenMutation($cloudId:ID!,$input:ConfluenceForgeContextTokenRequestInput!){confluence_generateForgeContextToken(cloudId:$cloudId,input:$input){success,errors{message},forgeContextToken{jwt,expiresAt,extensionId}}}"
        }
    };
}();
$dc4f7aee3cccfa96$var$node.hash = "881cc660c7be5fb9164424934214d110";
var $dc4f7aee3cccfa96$export$2e2bcd8739ae039 = $dc4f7aee3cccfa96$var$node;



var $cozmU = parcelRequire("cozmU");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $8a9Dm = parcelRequire("8a9Dm");

var $765515c26d11d063$var$_ContextTokenCache;
class $765515c26d11d063$var$ContextTokenCache {
    static getInstance() {
        if (!$765515c26d11d063$var$ContextTokenCache.instance) $765515c26d11d063$var$ContextTokenCache.instance = new $765515c26d11d063$var$ContextTokenCache();
        return $765515c26d11d063$var$ContextTokenCache.instance;
    }
    get(key) {
        return this.promiseCache.get(key);
    }
    set(key, value) {
        this.promiseCache.set(key, value);
    }
    delete(key) {
        this.promiseCache.delete(key);
    }
    constructor(){
        this.promiseCache = void 0;
        this.promiseCache = new Map();
    }
}
$765515c26d11d063$var$_ContextTokenCache = $765515c26d11d063$var$ContextTokenCache;
$765515c26d11d063$var$ContextTokenCache.instance = void 0;
const $765515c26d11d063$var$EXTRA_BUFFER_MS = 30000; // extra 30 seconds buffer for clock skew
// GraphQL mutation to get context token
const $765515c26d11d063$var$UseGetContextTokenMutation = (0, $dc4f7aee3cccfa96$export$2e2bcd8739ae039);
const $765515c26d11d063$export$42cd66ed92f75ea0 = ({ extension: extension, extensionData: extensionData, localId: localId, contextIds: contextIds, cachingEnabled: cachingEnabled = false })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [runMutation] = (0, $308Wd.useMutationInterop)($765515c26d11d063$var$UseGetContextTokenMutation, {
        interopApolloAggClient: true,
        __callerPackage__: "forge-ui"
    });
    return (0, $cozmU.useMemo)(()=>{
        const fetchTokenFromServer = async (effectiveContextIds, effectiveExtension, effectiveLocalId, cache, cacheKey)=>{
            try {
                // Build the input according to the schema
                const input = {
                    contextIds: effectiveContextIds,
                    extensionSpecificContexts: {
                        appVersion: effectiveExtension.appVersion ?? '',
                        context: {
                            appVersion: effectiveExtension.appVersion,
                            environmentId: effectiveExtension.environmentId,
                            environmentType: effectiveExtension.environmentType,
                            siteUrl: window?.location?.origin,
                            extension: {
                                location: undefined,
                                content: extensionData?.content ? {
                                    id: extensionData.content.id,
                                    type: extensionData.content.type,
                                    subtype: extensionData.content.subtype,
                                    version: extensionData.content?.version,
                                    status: extensionData.content.status
                                } : undefined,
                                isEditing: extensionData?.isEditing,
                                macro: extensionData?.macro ? {
                                    isConfiguring: extensionData.macro.isConfiguring,
                                    isInserting: extensionData.macro.isInserting,
                                    layout: extensionData.macro.layout
                                } : undefined,
                                space: extensionData?.space ? {
                                    id: extensionData.space.id,
                                    key: extensionData.space.key
                                } : undefined,
                                ...extensionData?.template?.id && {
                                    template: {
                                        id: extensionData.template.id
                                    }
                                },
                                type: extensionData.type,
                                selectedText: extensionData?.selectedText
                            },
                            localId: effectiveLocalId,
                            moduleKey: (0, $8a9Dm.getModuleKey)(effectiveExtension),
                            isConfig: extensionData?.isConfig,
                            spaceKey: extensionData?.space?.key,
                            contentId: extensionData?.content?.id,
                            type: extensionData.type,
                            content: extensionData?.content ? {
                                id: extensionData.content.id,
                                type: extensionData.content.type,
                                subtype: extensionData.content.subtype,
                                status: extensionData.content.status,
                                version: extensionData.content.version
                            } : undefined,
                            space: extensionData?.space ? {
                                id: extensionData.space.id,
                                key: extensionData.space.key
                            } : undefined,
                            macro: effectiveExtension.properties?.body ? {
                                body: JSON.stringify(effectiveExtension.properties.body)
                            } : null
                        },
                        extensionId: effectiveExtension.id,
                        extensionType: effectiveExtension.type,
                        installationId: effectiveExtension.installationId
                    }
                };
                const { data: data } = await runMutation({
                    variables: {
                        cloudId: cloudId,
                        input: input
                    }
                });
                if (!data?.confluence_generateForgeContextToken?.success) {
                    const errors = data?.confluence_generateForgeContextToken?.errors || [];
                    const errorMessage = errors.map((e)=>e.message).join(', ') || 'Unknown error';
                    throw new Error(`Token generation failed: ${errorMessage}`);
                }
                const forgeContextToken = data.confluence_generateForgeContextToken.forgeContextToken;
                if (!forgeContextToken?.jwt) throw new Error('No JWT token received from GraphQL endpoint');
                // Update cache with expiry info if available
                if (cachingEnabled) {
                    const cachedEntry = cache.get(cacheKey);
                    if (cachedEntry && forgeContextToken.expiresAt) cachedEntry.expiresAt = Number(forgeContextToken.expiresAt);
                }
                return forgeContextToken.jwt;
            } catch (error) {
                // Remove from cache on error so next call will retry
                if (cachingEnabled) cache.delete(cacheKey);
                throw new Error(`Failed to get context token: ${error.message}`);
            }
        };
        // Supports both contextIdsOverride and extensionOverride for embedded macros
        async function getForgeContextToken(options) {
            if (!cloudId) throw new Error('CloudId is required but not available');
            const { contextIdsOverride: contextIdsOverride, extensionOverride: extensionOverride } = options ?? {};
            // Use override values if provided (for embedded macros), otherwise use parent values
            const effectiveExtension_0 = extensionOverride?.extension ?? extension;
            const effectiveLocalId_0 = extensionOverride?.localId ?? localId;
            const effectiveContextIds_0 = contextIdsOverride ?? contextIds;
            const cacheKey_0 = JSON.stringify({
                id: effectiveLocalId_0 || effectiveExtension_0.id,
                data: extensionData,
                contextIds: effectiveContextIds_0
            });
            const cache_0 = $765515c26d11d063$var$ContextTokenCache.getInstance();
            const cached = cache_0.get(cacheKey_0);
            if (cachingEnabled) {
                if (cached) {
                    if (typeof cached.expiresAt !== 'number') return cached.promise;
                    if (Date.now() + $765515c26d11d063$var$EXTRA_BUFFER_MS < cached.expiresAt) return cached.promise;
                }
                const issuedAt = Date.now();
                const tokenPromise = fetchTokenFromServer(effectiveContextIds_0, effectiveExtension_0, effectiveLocalId_0, cache_0, cacheKey_0);
                cache_0.set(cacheKey_0, {
                    promise: tokenPromise,
                    expiresAt: undefined,
                    issuedAt: issuedAt
                });
                return tokenPromise;
            }
            return fetchTokenFromServer(effectiveContextIds_0, effectiveExtension_0, effectiveLocalId_0, cache_0, cacheKey_0);
        }
        return getForgeContextToken;
    }, [
        extension,
        extensionData,
        localId,
        cloudId,
        runMutation,
        contextIds,
        cachingEnabled
    ]);
};
module.exports["useGetContextToken"] = $765515c26d11d063$export$42cd66ed92f75ea0;

});

parcelRegister("aF5bm", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $bQm3c = parcelRequire("bQm3c");

const $3217b30f8fcccab4$export$c922e8420e7a46c9 = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $3217b30f8fcccab4$export$3c417c5065f4ac35 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== activationId || $[1] !== cloudId) {
        t0 = $3217b30f8fcccab4$export$c922e8420e7a46c9({
            cloudId: cloudId,
            activationId: activationId
        });
        $[0] = activationId;
        $[1] = cloudId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    return $3217b30f8fcccab4$export$c922e8420e7a46c9({
        cloudId: cloudId,
        activationId: activationId
    });
};
module.exports["getWorkspaceARI"] = $3217b30f8fcccab4$export$c922e8420e7a46c9;
module.exports["useWorkspaceARI"] = $3217b30f8fcccab4$export$3c417c5065f4ac35;

});

parcelRegister("iop2R", function(module, exports) {

var $dtVue = parcelRequire("dtVue");

const $73be7110bebeb936$export$6742408d91365687 = (cloudId, environment, userId)=>{
    return (0, $dtVue.createMentionsConfig)(cloudId, userId).then((config)=>config.mentionResource).catch((err)=>{
        if (environment !== 'PRODUCTION') // eslint-disable-next-line no-console
        console.error`Failed to initialise mention resource ${err}`;
        return Promise.reject();
    });
};
module.exports["getMentionProvider"] = $73be7110bebeb936$export$6742408d91365687;

});

parcelRegister("9B424", function(module, exports) {
/* @flow */ // $FlowFixMe

module.exports = (parcelRequire("hnAIF")); // eslint-disable-line import/no-commonjs
// $FlowFixMe
module.exports.default = module.exports; // eslint-disable-line import/no-commonjs

});

parcelRegister("efN0P", function(module, exports) {
"use strict";
var $a6087c409a698c2b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a6087c409a698c2b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SANDBOX_CONNECTION_TIMEOUT_MS = module.exports.SANDBOX_HANDSHAKE_TIMEOUT_MS = module.exports.SANDBOX_CONTROLLER_REQUEST_EVENT = module.exports.BRIDGE_ACK_TIMEOUT_MS = module.exports.BRIDGE_HANDSHAKE_TIMEOUT_MS = module.exports.THEME_CHANGE_EVENT = module.exports.THEME_ENABLE_EVENT = module.exports.READY_EVENT = module.exports.handleMissingHandlerError = module.exports.firstToResolve = void 0;
var $a6087c409a698c2b$var$invertPromise = function(p) {
    return new Promise(function(resolve, reject) {
        return p.then(reject, resolve);
    });
};
var $a6087c409a698c2b$var$firstToResolve = function(promises) {
    return $a6087c409a698c2b$var$__awaiter(void 0, void 0, void 0, function() {
        var err_1;
        return $a6087c409a698c2b$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $a6087c409a698c2b$var$invertPromise(Promise.all(promises.map($a6087c409a698c2b$var$invertPromise)))
                    ];
                case 1:
                    return [
                        2,
                        _a.sent()
                    ];
                case 2:
                    err_1 = _a.sent();
                    throw err_1[0];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
};
module.exports.firstToResolve = $a6087c409a698c2b$var$firstToResolve;
var $a6087c409a698c2b$var$PORT_RPC_HANDLER_NOT_FOUND_CODE = 'HANDLER_NOT_FOUND';
var $a6087c409a698c2b$var$handleMissingHandlerError = function(error) {
    if ((error === null || error === void 0 ? void 0 : error.code) === $a6087c409a698c2b$var$PORT_RPC_HANDLER_NOT_FOUND_CODE || (error === null || error === void 0 ? void 0 : error.message.startsWith('No handler found for post message:'))) return Promise.resolve();
    else return Promise.reject("Error while sending bridge message: ".concat(error === null || error === void 0 ? void 0 : error.message));
};
module.exports.handleMissingHandlerError = $a6087c409a698c2b$var$handleMissingHandlerError;
module.exports.READY_EVENT = '__ready';
module.exports.THEME_ENABLE_EVENT = '__theme_enable';
module.exports.THEME_CHANGE_EVENT = '__theme_change';
module.exports.BRIDGE_HANDSHAKE_TIMEOUT_MS = 20000;
module.exports.BRIDGE_ACK_TIMEOUT_MS = 10000;
module.exports.SANDBOX_CONTROLLER_REQUEST_EVENT = '__sandbox_controller_request';
module.exports.SANDBOX_HANDSHAKE_TIMEOUT_MS = 10000;
module.exports.SANDBOX_CONNECTION_TIMEOUT_MS = 10000;

});

parcelRegister("eL3mC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $0941e712e3e0e9cf$export$e775b9769343d051 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $0941e712e3e0e9cf$export$73f470ced5fdc319 = (props)=>{
    const breadCrumbs = (0, $cozmU.useRef)([]);
    const tracingService = (0, $cozmU.useRef)({
        getBreadcrumbs: ()=>breadCrumbs.current,
        recordBridgeCall: (description)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    category: `forge.bridge`,
                    message: description,
                    timestamp: new Date().toISOString()
                }
            ],
        recordGqlCall: (description_0)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    type: 'http',
                    category: 'gql',
                    timestamp: new Date().toISOString(),
                    data: {
                        url: description_0
                    }
                }
            ],
        recordConsentFlow: (description_1, result)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    category: `user.consent`,
                    message: description_1,
                    timestamp: new Date().toISOString(),
                    ...result ? {
                        data: {
                            result: result
                        }
                    } : {}
                }
            ]
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0941e712e3e0e9cf$export$e775b9769343d051.Provider, {
        value: tracingService.current
    }, props.children);
};
const $0941e712e3e0e9cf$export$1bd6b93107e60cf1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const tracingContext = (0, $cozmU.useContext)($0941e712e3e0e9cf$export$e775b9769343d051);
    return tracingContext;
} : ()=>{
    const tracingContext = (0, $cozmU.useContext)($0941e712e3e0e9cf$export$e775b9769343d051);
    return tracingContext;
};
module.exports["TracingProvider"] = $0941e712e3e0e9cf$export$73f470ced5fdc319;
module.exports["useTracingContext"] = $0941e712e3e0e9cf$export$1bd6b93107e60cf1;

});

parcelRegister("hfFJ2", function(module, exports) {

var $i3S9F = parcelRequire("i3S9F");

var $8B1kb = parcelRequire("8B1kb");


var $bLswh = parcelRequire("bLswh");


var $5itFi = parcelRequire("5itFi");


var $iyPp3 = parcelRequire("iyPp3");

const $c2ad826e26d72d17$var$SAFE_RESOURCE_ENTRY_PATTERN = /^[\w][\w.-]*$/;
const $c2ad826e26d72d17$export$71a53c8753c032be = (baseUrl, resolvedResourceEntry)=>{
    if (resolvedResourceEntry === undefined) return baseUrl;
    if (!$c2ad826e26d72d17$var$SAFE_RESOURCE_ENTRY_PATTERN.test(resolvedResourceEntry)) throw new Error('Invalid resource entry specified.');
    return `${baseUrl}${resolvedResourceEntry}`;
};
const $c2ad826e26d72d17$export$9b5c32eaf7c2ac3d = {
    [(0, $bLswh.ProductEnvironment).PRODUCTION]: 'prod',
    [(0, $bLswh.ProductEnvironment).STAGING]: 'stg',
    [(0, $bLswh.ProductEnvironment).DEVELOPMENT]: 'stg'
};
const $c2ad826e26d72d17$export$158d41afab8f2af8 = (appId, extension, environment, entryPoint, extensionViewData, resolvedResourceEntry)=>{
    return (0, $i3S9F.isIsolatedCloud)() ? $c2ad826e26d72d17$export$d68551323b971eed(appId, extension, entryPoint, extensionViewData, resolvedResourceEntry) : $c2ad826e26d72d17$export$b1a4a6ad329e6bd2(appId, extension, environment, entryPoint, extensionViewData, resolvedResourceEntry);
};
const $c2ad826e26d72d17$export$b1a4a6ad329e6bd2 = (appId, extension, environment, entryPoint, extensionViewData, resolvedResourceEntry)=>{
    const { installationId: installationId, environmentId: environmentId, appVersion: appVersion, properties: properties } = extension;
    const resourceUploadId = properties.resourceUploadId || appVersion;
    const domain = `${$c2ad826e26d72d17$export$d4a94ef9062fefbf(installationId)}--${$c2ad826e26d72d17$export$d4a94ef9062fefbf(appId)}.${(0, $5itFi.getForgeCDNBaseDomain)(environment)}`;
    /**
   * The appId is also included in the subdomain so that it can be compared against the appId in the
   * resource path. This comparison is performed by the routing Lambda@ Edge to prevent a malicious
   * developer from appending their malicious app path to a legitimate installation id.
   */ const encodedAppContext = (0, $iyPp3.getEncodedAppContext)(extension, extensionViewData);
    const urlSafeContext = $c2ad826e26d72d17$export$223741b87b7c6af6(encodedAppContext);
    const baseUrl = `https://${domain}/${appId}/${environmentId}/${resourceUploadId}/${entryPoint}/_ctx_${urlSafeContext}/`;
    return $c2ad826e26d72d17$export$71a53c8753c032be(baseUrl, resolvedResourceEntry);
};
const $c2ad826e26d72d17$export$d68551323b971eed = (appId, extension, entryPoint, extensionViewData, resolvedResourceEntry)=>{
    const { installationId: installationId, environmentId: environmentId, appVersion: appVersion, properties: properties } = extension;
    const resourceUploadId = properties.resourceUploadId || appVersion;
    const icDomain = (0, $8B1kb.isolatedCloudDomain)();
    const domain = `${$c2ad826e26d72d17$export$d4a94ef9062fefbf(installationId)}--${$c2ad826e26d72d17$export$d4a94ef9062fefbf(appId)}.forge-cdn.${icDomain}`;
    const encodedAppContext = (0, $iyPp3.getEncodedAppContext)(extension, extensionViewData);
    const urlSafeContext = $c2ad826e26d72d17$export$223741b87b7c6af6(encodedAppContext);
    const baseUrl = `https://${domain}/forge-cdn/${appId}/${environmentId}/${resourceUploadId}/${entryPoint}/_ctx_${urlSafeContext}/`;
    return $c2ad826e26d72d17$export$71a53c8753c032be(baseUrl, resolvedResourceEntry);
};
function $c2ad826e26d72d17$export$d4a94ef9062fefbf(uuid) {
    const [a, b, c, d, e] = uuid.split('-');
    const combinedUuid = [
        a,
        `${b}${c}${d}`,
        e
    ];
    return combinedUuid.map((s)=>parseInt(s, 16)).map((s)=>s.toString(36)).join('-');
}
function $c2ad826e26d72d17$export$824f5b1835a75769(shortenedUuid) {
    const [a, b, c] = shortenedUuid.split('-').map((s)=>parseInt(s, 36)).map((s)=>s.toString(16));
    // expands the middle segment into the original UUID
    // ffffffff-abcdabcdabcd-ffffffffffff ===> ffffffff-abcd-abcd-abcd-ffffffffffff
    const middleExpanded = b.match(/.{1,4}/g) || b;
    return [
        a,
        ...middleExpanded,
        c
    ].join('-');
}
function $c2ad826e26d72d17$export$223741b87b7c6af6(str) {
    return str.replace(/\+/g, '-') // Replace '+' with '-'
    .replace(/\//g, '_') // Replace '/' with '_'
    .replace(/=+$/, ''); // Remove padding
}
module.exports["appendResolvedResourceEntry"] = $c2ad826e26d72d17$export$71a53c8753c032be;
module.exports["createSrcFromExtension"] = $c2ad826e26d72d17$export$158d41afab8f2af8;
module.exports["urlSafeB64"] = $c2ad826e26d72d17$export$223741b87b7c6af6;

});

parcelRegister("4DMV4", function(module, exports) {
const $b450192a71e9ec24$export$563e375d286a76a7 = ()=>{
    if (navigator.languages) return navigator.languages[0];
    return navigator.language;
};
module.exports["getBrowserLocale"] = $b450192a71e9ec24$export$563e375d286a76a7;

});

parcelRegister("1Bv8Y", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $9050de1323b893c6$export$bd17c6970f4d989e = ()=>{
    const platformFeatureFlags = [];
    // Add feature flags that are required to be passed down to the iframe
    // EXAMPLE:
    // if (fg(<flag-name>)) {
    // 	platformFeatureFlags.push(<flag-name>);
    // }
    if ((0, $iDrrr.fg)('forge-ui-app-perf-tracking-enabled')) platformFeatureFlags.push('forge-ui-iframe-analytics');
    if ((0, $iDrrr.fg)('forge-ui-bridge-core-reset')) platformFeatureFlags.push('forge-ui-bridge-core-reset');
    // TODO: clean up later when Forge CDN repo is ready
    platformFeatureFlags.push('forge-ui-iframe-ufo-perf-observers');
    if ((0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) platformFeatureFlags.push('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $iDrrr.fg)('platform-dst-shape-theme-default')) platformFeatureFlags.push('platform-dst-shape-theme-default');
    if ((0, $iDrrr.fg)('platform-dst-motion-uplift-popup')) platformFeatureFlags.push('platform-dst-motion-uplift-popup');
    if ((0, $iDrrr.fg)('platform-dst-motion-uplift-modal')) platformFeatureFlags.push('platform-dst-motion-uplift-modal');
    if ((0, $iDrrr.fg)('platform-dst-motion-uplift-spotlight')) platformFeatureFlags.push('platform-dst-motion-uplift-spotlight');
    if ((0, $iDrrr.fg)('platform-dst-motion-uplift')) platformFeatureFlags.push('platform-dst-motion-uplift');
    if ((0, $iDrrr.fg)('platform-dst-motion-theme-default')) platformFeatureFlags.push('platform-dst-motion-theme-default');
    return platformFeatureFlags;
};



var $hfFJ2 = parcelRequire("hfFJ2");

const $b150030ffcfebfca$export$6dd3d030a75d6dba = (tunnels, extensionResource, defaultUrl, urlSafeContext, resolvedResourceEntry)=>{
    const matchTunnel = tunnels.find((tunnel)=>tunnel.resourceKey === extensionResource);
    const platformFeatureFlags = (0, $9050de1323b893c6$export$bd17c6970f4d989e)();
    const queryParams = new URLSearchParams({
        ...platformFeatureFlags.length > 0 ? {
            platformFeatureFlags: platformFeatureFlags.join(',')
        } : {},
        // when tunnelling, pass hostname into query param to be passed into CSP
        ...matchTunnel ? {
            hostname: window.location.hostname,
            ctx: urlSafeContext
        } : {}
    }).toString();
    const query = queryParams ? `?${queryParams}` : '';
    if (matchTunnel) return `${(0, $hfFJ2.appendResolvedResourceEntry)(matchTunnel.tunnelUrl, resolvedResourceEntry)}${query}`;
    return `${defaultUrl}${query}`;
};
const $b150030ffcfebfca$export$6f3f630a07b3a5ad = (src)=>{
    try {
        return new URL(src).hostname === 'localhost';
    } catch  {
        return false;
    }
};
module.exports["getSrcUrl"] = $b150030ffcfebfca$export$6dd3d030a75d6dba;
module.exports["isTunnelSrc"] = $b150030ffcfebfca$export$6f3f630a07b3a5ad;

});

parcelRegister("iuxS5", function(module, exports) {
const $5a4bdde3d83d7ff5$export$c34ac5b863279caa = (coreData, extensionData)=>({
        ...coreData,
        extension: extensionData
    });
module.exports["getResolverContext"] = $5a4bdde3d83d7ff5$export$c34ac5b863279caa;

});

parcelRegister("fXNFR", function(module, exports) {

var $524dz = parcelRequire("524dz");

const $58ab321e64a0b5af$export$68ca3577dbf1f96c = (scopes = [], egress = [])=>{
    // Create a map to store egress data by type then loop through the map to populate the external permissions object
    const egressMap = new Map();
    egress.forEach(({ type: type, addresses: addresses })=>{
        egressMap.set(type, addresses);
    });
    // Construct external permissions from the map
    const externalPermissions = {
        fetch: {
            backend: egressMap.get('FETCH_BACKEND_SIDE') ?? [],
            client: egressMap.get('FETCH_CLIENT_SIDE') ?? []
        },
        fonts: egressMap.get('FONTS') ?? [],
        styles: egressMap.get('STYLES') ?? [],
        frames: egressMap.get('FRAMES') ?? [],
        images: egressMap.get('IMAGES') ?? [],
        media: egressMap.get('MEDIA') ?? [],
        scripts: egressMap.get('SCRIPTS') ?? []
    };
    return {
        scopes: scopes,
        external: externalPermissions
    };
};
const $58ab321e64a0b5af$export$20af16720c0f9c71 = ({ resolverContext: resolverContext, accountId: accountId, extension: extension, timezone: timezone, locale: locale, location: location, extensionPayload: extensionPayload, extensionViewData: extensionViewData, theme: theme, surfaceColor: surfaceColor })=>{
    // Combine the static macro extension data with the dynamic extension view data (macro body) into a single macro object
    const macro = {
        ...resolverContext.extension?.macro,
        ...extensionViewData?.macro,
        ...extensionPayload?.macro
    };
    /* adding hasAccess separately instead of using userAccess as a whole is to avoid appending __typename in the context */ const userAccess = extension.userAccess ?? {
        enabled: false,
        hasAccess: false
    };
    // Construct permissions object from scopes and egress
    const permissions = $58ab321e64a0b5af$export$68ca3577dbf1f96c(extension?.scopes || [], extension?.egress || []);
    const contexts = [
        ...extension?.installationContext ? [
            (0, $524dz.parseContextAri)(extension.installationContext)
        ] : [],
        ...extension?.secondaryInstallationContexts?.map((0, $524dz.parseContextAri)) ?? []
    ];
    return {
        ...resolverContext,
        extension: {
            ...resolverContext.extension,
            ...extensionViewData,
            ...extensionPayload,
            ...Object.keys(macro).length > 0 ? {
                macro: macro
            } : {},
            location: location
        },
        accountId: accountId,
        ...contexts.length > 0 ? {
            installation: {
                id: extension.installationId,
                contexts: contexts
            }
        } : {},
        license: extension?.license || null,
        timezone: timezone,
        locale: locale,
        theme: theme,
        surfaceColor: surfaceColor,
        userAccess: userAccess,
        permissions: permissions
    };
};
module.exports["getViewContext"] = $58ab321e64a0b5af$export$20af16720c0f9c71;

});

parcelRegister("dK9hN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $iDrrr = parcelRequire("iDrrr");


var $cozmU = parcelRequire("cozmU");


var $i3S9F = parcelRequire("i3S9F");

const $9b10051f124ae824$export$98b91f32256d29a8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = $9b10051f124ae824$export$a6dd2b5c1fe5c76e();
        $[0] = t0;
    } else t0 = $[0];
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(t0);
    let t1;
    let t2;
    if ($[1] !== isLoading) {
        t1 = ()=>{
            let cancelled = false;
            if (isLoading) $9b10051f124ae824$var$loadCDNAuthSignedCookie().catch($9b10051f124ae824$var$_temp).finally(()=>{
                if (!cancelled) setIsLoading(false);
            });
            return ()=>{
                cancelled = true;
            };
        };
        t2 = [
            isLoading
        ];
        $[1] = isLoading;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return isLoading;
} : ()=>{
    const [isLoading, setIsLoading] = (0, $cozmU.useState)($9b10051f124ae824$export$a6dd2b5c1fe5c76e());
    (0, $cozmU.useEffect)(()=>{
        let cancelled = false;
        if (isLoading) $9b10051f124ae824$var$loadCDNAuthSignedCookie().catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('Error loading CDN auth signed cookie:', err);
        }).finally(()=>{
            if (!cancelled) setIsLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        isLoading
    ]);
    return isLoading;
};
const $9b10051f124ae824$var$MAX_SIGNED_COOKIE_AGE_MS = 1800000; // 30 minutes
let $9b10051f124ae824$var$lastSignedCookieFetchTime = 0;
let $9b10051f124ae824$var$loadingPromise = null;
const $9b10051f124ae824$var$doLoadCDNAuthSignedCookie = async ()=>{
    // Step 1: Get the signed cookies URL from our backend -> session token based auth
    const signedCookiesUrlResponse = await fetch('/gateway/api/forge-cdn/signed-cookies-url');
    if (!signedCookiesUrlResponse.ok) throw new Error(`Failed to get signed cookies URL: ${signedCookiesUrlResponse.statusText}`);
    // Step 2: Fetch the signed cookies using the obtained URL (with signed URL) -> this will set the cookies in the browser
    const { data: signedCookiesUrl } = await signedCookiesUrlResponse.json();
    if (!signedCookiesUrl || typeof signedCookiesUrl !== 'string') throw new Error('Invalid signed cookies URL received from backend');
    const response = await fetch(signedCookiesUrl, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new Error(`Failed to fetch signed cookies: ${response.statusText}`);
};
const $9b10051f124ae824$var$loadCDNAuthSignedCookie = async ()=>{
    if (Date.now() - $9b10051f124ae824$var$lastSignedCookieFetchTime < $9b10051f124ae824$var$MAX_SIGNED_COOKIE_AGE_MS) return;
    // this is to ensure only one loadingPromise is active at a time (to avoid multiple simultaneous requests)
    if ($9b10051f124ae824$var$loadingPromise) await $9b10051f124ae824$var$loadingPromise;
    else {
        $9b10051f124ae824$var$loadingPromise = (async ()=>{
            try {
                await $9b10051f124ae824$var$doLoadCDNAuthSignedCookie();
                $9b10051f124ae824$var$lastSignedCookieFetchTime = Date.now();
            } finally{
                $9b10051f124ae824$var$loadingPromise = null;
            }
        })();
        await $9b10051f124ae824$var$loadingPromise;
    }
};
const $9b10051f124ae824$export$a6dd2b5c1fe5c76e = ()=>{
    return (0, $iDrrr.fg)('forge-ui-cdn-auth') && (0, $i3S9F.isIsolatedCloud)();
};
const $9b10051f124ae824$export$1b22f04514004ab6 = ()=>{
    $9b10051f124ae824$var$lastSignedCookieFetchTime = 0;
    $9b10051f124ae824$var$loadingPromise = null;
};
function $9b10051f124ae824$var$_temp(err) {
    console.error("Error loading CDN auth signed cookie:", err);
}
module.exports["useCDNAuthSignedCookie"] = $9b10051f124ae824$export$98b91f32256d29a8;
module.exports["shouldUseCDNAuth"] = $9b10051f124ae824$export$a6dd2b5c1fe5c76e;

});

parcelRegister("jBLwT", function(module, exports) {
/*
 * File: iframeResizer.js
 * Desc: Force iframes to size to content.
 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 * Doc: https://iframe-resizer.com
 * Author: David J. Bradshaw - info@iframe-resizer.com
 */ console.info(`
IFRAME-RESIZER

Iframe-Resizer 5 is now available via the following two packages:

 * @iframe-resizer/parent
 * @iframe-resizer/child

Additionally their are also new versions of iframe-resizer for React, Vue, and jQuery.

Version 5 of iframe-resizer has been extensively rewritten to use modern browser APIs, which has enabled significantly better performance and greater accuracy in the detection of content resizing events.

Please see https://iframe-resizer.com/upgrade for more details.
`);
(function(undefined) {
    if (typeof window === 'undefined') return; // don't run for server side render
    // var VERSION = '4.3.11'
    var count = 0, destroyObserver, logEnabled = false, hiddenCheckEnabled = false, msgHeader = 'message', msgHeaderLen = msgHeader.length, msgId = '[iFrameSizer]', msgIdLen = msgId.length, pagePosition = null, requestAnimationFrame = window.requestAnimationFrame, resetRequiredMethods = Object.freeze({
        max: 1,
        scroll: 1,
        bodyScroll: 1,
        documentElementScroll: 1
    }), settings = {}, timer = null, defaults = Object.freeze({
        autoResize: true,
        bodyBackground: null,
        bodyMargin: null,
        bodyMarginV1: 8,
        bodyPadding: null,
        checkOrigin: true,
        inPageLinks: false,
        enablePublicMethods: true,
        heightCalculationMethod: 'bodyOffset',
        id: 'iFrameResizer',
        interval: 32,
        license: '1jqr0si6pnt',
        log: false,
        maxHeight: Infinity,
        maxWidth: Infinity,
        minHeight: 0,
        minWidth: 0,
        mouseEvents: true,
        resizeFrom: 'parent',
        scrolling: false,
        sizeHeight: true,
        sizeWidth: false,
        warningTimeout: 5000,
        tolerance: 0,
        widthCalculationMethod: 'scroll',
        onClose: function() {
            return true;
        },
        onClosed: function() {},
        onInit: function() {},
        onMessage: function() {
            warn('onMessage function not defined');
        },
        onMouseEnter: function() {},
        onMouseLeave: function() {},
        onResized: function() {},
        onScroll: function() {
            return true;
        }
    });
    function getMutationObserver() {
        return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    }
    function addEventListener(el, evt, func) {
        el.addEventListener(evt, func, false);
    }
    function removeEventListener(el, evt, func) {
        el.removeEventListener(evt, func, false);
    }
    function setupRequestAnimationFrame() {
        var vendors = [
            'moz',
            'webkit',
            'o',
            'ms'
        ];
        var x;
        // Remove vendor prefixing if prefixed and break early if not
        for(x = 0; x < vendors.length && !requestAnimationFrame; x += 1)requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        if (requestAnimationFrame) // Firefox extension content-scripts have a globalThis object that is not the same as window.
        // Binding `requestAnimationFrame` to window allows the function to work and prevents errors
        // being thrown when run in that context, and should be a no-op in every other context.
        requestAnimationFrame = requestAnimationFrame.bind(window);
        else log('setup', 'RequestAnimationFrame not supported');
    }
    function getMyID(iframeId) {
        var retStr = 'Host page: ' + iframeId;
        if (window.top !== window.self) retStr = window.parentIFrame && window.parentIFrame.getId ? window.parentIFrame.getId() + ': ' + iframeId : 'Nested host page: ' + iframeId;
        return retStr;
    }
    function formatLogHeader(iframeId) {
        return msgId + '[' + getMyID(iframeId) + ']';
    }
    function isLogEnabled(iframeId) {
        return settings[iframeId] ? settings[iframeId].log : logEnabled;
    }
    function log(iframeId, msg) {
        output('log', iframeId, msg, isLogEnabled(iframeId));
    }
    function info(iframeId, msg) {
        output('info', iframeId, msg, isLogEnabled(iframeId));
    }
    function warn(iframeId, msg) {
        output('warn', iframeId, msg, true);
    }
    function output(type, iframeId, msg, enabled) {
        if (true === enabled && 'object' === typeof window.console) // eslint-disable-next-line no-console
        console[type](formatLogHeader(iframeId), msg);
    }
    function iFrameListener(event) {
        function resizeIFrame() {
            function resize() {
                setSize(messageData);
                setPagePosition(iframeId);
                on('onResized', messageData);
            }
            ensureInRange('Height');
            ensureInRange('Width');
            syncResize(resize, messageData, 'init');
        }
        function processMsg() {
            var data = msg.slice(msgIdLen).split(':');
            var height = data[1] ? parseInt(data[1], 10) : 0;
            var iframe = settings[data[0]] && settings[data[0]].iframe;
            var compStyle = getComputedStyle(iframe);
            return {
                iframe: iframe,
                id: data[0],
                height: height + getPaddingEnds(compStyle) + getBorderEnds(compStyle),
                width: data[2],
                type: data[3]
            };
        }
        function getPaddingEnds(compStyle) {
            if (compStyle.boxSizing !== 'border-box') return 0;
            var top = compStyle.paddingTop ? parseInt(compStyle.paddingTop, 10) : 0;
            var bot = compStyle.paddingBottom ? parseInt(compStyle.paddingBottom, 10) : 0;
            return top + bot;
        }
        function getBorderEnds(compStyle) {
            if (compStyle.boxSizing !== 'border-box') return 0;
            var top = compStyle.borderTopWidth ? parseInt(compStyle.borderTopWidth, 10) : 0;
            var bot = compStyle.borderBottomWidth ? parseInt(compStyle.borderBottomWidth, 10) : 0;
            return top + bot;
        }
        function ensureInRange(Dimension) {
            var max = Number(settings[iframeId]['max' + Dimension]), min = Number(settings[iframeId]['min' + Dimension]), dimension = Dimension.toLowerCase(), size = Number(messageData[dimension]);
            log(iframeId, 'Checking ' + dimension + ' is in range ' + min + '-' + max);
            if (size < min) {
                size = min;
                log(iframeId, 'Set ' + dimension + ' to min value');
            }
            if (size > max) {
                size = max;
                log(iframeId, 'Set ' + dimension + ' to max value');
            }
            messageData[dimension] = '' + size;
        }
        function isMessageFromIFrame() {
            function checkAllowedOrigin() {
                function checkList() {
                    var i = 0, retCode = false;
                    log(iframeId, 'Checking connection is from allowed list of origins: ' + checkOrigin);
                    for(; i < checkOrigin.length; i++)if (checkOrigin[i] === origin) {
                        retCode = true;
                        break;
                    }
                    return retCode;
                }
                function checkSingle() {
                    var remoteHost = settings[iframeId] && settings[iframeId].remoteHost;
                    log(iframeId, 'Checking connection is from: ' + remoteHost);
                    return origin === remoteHost;
                }
                return checkOrigin.constructor === Array ? checkList() : checkSingle();
            }
            var origin = event.origin, checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin;
            if (checkOrigin && '' + origin !== 'null' && !checkAllowedOrigin()) throw new Error('Unexpected message received from: ' + origin + ' for ' + messageData.iframe.id + '. Message was: ' + event.data + '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.');
            return true;
        }
        function isMessageForUs() {
            return msgId === ('' + msg).slice(0, msgIdLen) && msg.slice(msgIdLen).split(':')[0] in settings // ''+Protects against non-string msg
            ;
        }
        function isMessageFromMetaParent() {
            // Test if this message is from a parent above us. This is an ugly test, however, updating
            // the message format would break backwards compatibility.
            var retCode = messageData.type in {
                true: 1,
                false: 1,
                undefined: 1
            };
            if (retCode) log(iframeId, 'Ignoring init message from meta parent page');
            return retCode;
        }
        function getMsgBody(offset) {
            return msg.slice(msg.indexOf(':') + msgHeaderLen + offset);
        }
        function forwardMsgFromIFrame(msgBody) {
            log(iframeId, 'onMessage passed: {iframe: ' + messageData.iframe.id + ', message: ' + msgBody + '}');
            on('onMessage', {
                iframe: messageData.iframe,
                message: JSON.parse(msgBody)
            });
            log(iframeId, '--');
        }
        function getPageInfo() {
            var bodyPosition = document.body.getBoundingClientRect(), iFramePosition = messageData.iframe.getBoundingClientRect();
            return JSON.stringify({
                iframeHeight: iFramePosition.height,
                iframeWidth: iFramePosition.width,
                clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
                clientWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                offsetTop: parseInt(iFramePosition.top - bodyPosition.top, 10),
                offsetLeft: parseInt(iFramePosition.left - bodyPosition.left, 10),
                scrollTop: window.pageYOffset,
                scrollLeft: window.pageXOffset,
                documentHeight: document.documentElement.clientHeight,
                documentWidth: document.documentElement.clientWidth,
                windowHeight: window.innerHeight,
                windowWidth: window.innerWidth
            });
        }
        function sendPageInfoToIframe(iframe, iframeId) {
            function debouncedTrigger() {
                trigger('Send Page Info', 'pageInfo:' + getPageInfo(), iframe, iframeId);
            }
            debounceFrameEvents(debouncedTrigger, 32, iframeId);
        }
        function startPageInfoMonitor() {
            function setListener(type, func) {
                function sendPageInfo() {
                    if (settings[id]) sendPageInfoToIframe(settings[id].iframe, id);
                    else stop();
                }
                [
                    'scroll',
                    'resize'
                ].forEach(function(evt) {
                    log(id, type + evt + ' listener for sendPageInfo');
                    func(window, evt, sendPageInfo);
                });
            }
            function stop() {
                setListener('Remove ', removeEventListener);
            }
            function start() {
                setListener('Add ', addEventListener);
            }
            var id = iframeId // Create locally scoped copy of iFrame ID
            ;
            start();
            if (settings[id]) settings[id].stopPageInfo = stop;
        }
        function stopPageInfoMonitor() {
            if (settings[iframeId] && settings[iframeId].stopPageInfo) {
                settings[iframeId].stopPageInfo();
                delete settings[iframeId].stopPageInfo;
            }
        }
        function checkIFrameExists() {
            var retBool = true;
            if (null === messageData.iframe) {
                warn(iframeId, 'IFrame (' + messageData.id + ') not found');
                retBool = false;
            }
            return retBool;
        }
        function getElementPosition(target) {
            var iFramePosition = target.getBoundingClientRect();
            getPagePosition(iframeId);
            return {
                x: Math.floor(Number(iFramePosition.left) + Number(pagePosition.x)),
                y: Math.floor(Number(iFramePosition.top) + Number(pagePosition.y))
            };
        }
        function scrollRequestFromChild(addOffset) {
            /* istanbul ignore next */ // Not testable in Karma
            function reposition() {
                pagePosition = newPosition;
                scrollTo();
                log(iframeId, '--');
            }
            function calcOffset() {
                return {
                    x: Number(messageData.width) + offset.x,
                    y: Number(messageData.height) + offset.y
                };
            }
            function scrollParent() {
                if (window.parentIFrame) window.parentIFrame['scrollTo' + (addOffset ? 'Offset' : '')](newPosition.x, newPosition.y);
                else warn(iframeId, 'Unable to scroll to requested position, window.parentIFrame not found');
            }
            var offset = addOffset ? getElementPosition(messageData.iframe) : {
                x: 0,
                y: 0
            }, newPosition = calcOffset();
            log(iframeId, 'Reposition requested from iFrame (offset x:' + offset.x + ' y:' + offset.y + ')');
            if (window.top === window.self) reposition();
            else scrollParent();
        }
        function scrollTo() {
            if (false === on('onScroll', pagePosition)) unsetPagePosition();
            else setPagePosition(iframeId);
        }
        function findTarget(location) {
            function jumpToTarget() {
                var jumpPosition = getElementPosition(target);
                log(iframeId, 'Moving to in page link (#' + hash + ') at x: ' + jumpPosition.x + ' y: ' + jumpPosition.y);
                pagePosition = {
                    x: jumpPosition.x,
                    y: jumpPosition.y
                };
                scrollTo();
                log(iframeId, '--');
            }
            function jumpToParent() {
                if (window.parentIFrame) window.parentIFrame.moveToAnchor(hash);
                else log(iframeId, 'In page link #' + hash + ' not found and window.parentIFrame not found');
            }
            var hash = location.split('#')[1] || '', hashData = decodeURIComponent(hash), target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
            if (target) jumpToTarget();
            else if (window.top === window.self) log(iframeId, 'In page link #' + hash + ' not found');
            else jumpToParent();
        }
        function onMouse(event) {
            var mousePos = {};
            if (Number(messageData.width) === 0 && Number(messageData.height) === 0) {
                var data = getMsgBody(9).split(':');
                mousePos = {
                    x: data[1],
                    y: data[0]
                };
            } else mousePos = {
                x: messageData.width,
                y: messageData.height
            };
            on(event, {
                iframe: messageData.iframe,
                screenX: Number(mousePos.x),
                screenY: Number(mousePos.y),
                type: messageData.type
            });
        }
        function on(funcName, val) {
            return chkEvent(iframeId, funcName, val);
        }
        function actionMsg() {
            if (settings[iframeId] && settings[iframeId].firstRun) firstRun();
            switch(messageData.type){
                case 'close':
                    closeIFrame(messageData.iframe);
                    break;
                case 'message':
                    forwardMsgFromIFrame(getMsgBody(6));
                    break;
                case 'mouseenter':
                    onMouse('onMouseEnter');
                    break;
                case 'mouseleave':
                    onMouse('onMouseLeave');
                    break;
                case 'autoResize':
                    settings[iframeId].autoResize = JSON.parse(getMsgBody(9));
                    break;
                case 'scrollTo':
                    scrollRequestFromChild(false);
                    break;
                case 'scrollToOffset':
                    scrollRequestFromChild(true);
                    break;
                case 'pageInfo':
                    sendPageInfoToIframe(settings[iframeId] && settings[iframeId].iframe, iframeId);
                    startPageInfoMonitor();
                    break;
                case 'pageInfoStop':
                    stopPageInfoMonitor();
                    break;
                case 'inPageLink':
                    findTarget(getMsgBody(9));
                    break;
                case 'reset':
                    resetIFrame(messageData);
                    break;
                case 'init':
                    resizeIFrame();
                    on('onInit', messageData.iframe);
                    break;
                default:
                    if (Number(messageData.width) === 0 && Number(messageData.height) === 0) warn('Unsupported message received (' + messageData.type + '), this is likely due to the iframe containing a later ' + 'version of iframe-resizer than the parent page');
                    else resizeIFrame();
            }
        }
        function hasSettings(iframeId) {
            var retBool = true;
            if (!settings[iframeId]) {
                retBool = false;
                warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
            }
            return retBool;
        }
        function iFrameReadyMsgReceived() {
            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for(var iframeId in settings)trigger('iFrame requested init', createOutgoingMsg(iframeId), settings[iframeId].iframe, iframeId);
        }
        function firstRun() {
            if (settings[iframeId]) settings[iframeId].firstRun = false;
        }
        var msg = event.data, messageData = {}, iframeId = null;
        if ('[iFrameResizerChild]Ready' === msg) iFrameReadyMsgReceived();
        else if (isMessageForUs()) {
            messageData = processMsg();
            iframeId = messageData.id;
            if (settings[iframeId]) settings[iframeId].loaded = true;
            if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
                log(iframeId, 'Received: ' + msg);
                if (checkIFrameExists() && isMessageFromIFrame()) actionMsg();
            }
        } else info(iframeId, 'Ignored: ' + msg);
    }
    function chkEvent(iframeId, funcName, val) {
        var func = null, retVal = null;
        if (settings[iframeId]) {
            func = settings[iframeId][funcName];
            if ('function' === typeof func) retVal = func(val);
            else throw new TypeError(funcName + ' on iFrame[' + iframeId + '] is not a function');
        }
        return retVal;
    }
    function removeIframeListeners(iframe) {
        var iframeId = iframe.id;
        delete settings[iframeId];
    }
    function closeIFrame(iframe) {
        var iframeId = iframe.id;
        if (chkEvent(iframeId, 'onClose', iframeId) === false) {
            log(iframeId, 'Close iframe cancelled by onClose event');
            return;
        }
        log(iframeId, 'Removing iFrame: ' + iframeId);
        try {
            // Catch race condition error with React
            if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        } catch (error) {
            warn(error);
        }
        chkEvent(iframeId, 'onClosed', iframeId);
        log(iframeId, '--');
        removeIframeListeners(iframe);
        if (destroyObserver) {
            destroyObserver.disconnect();
            destroyObserver = null;
        }
    }
    function getPagePosition(iframeId) {
        if (null === pagePosition) {
            pagePosition = {
                x: window.pageXOffset === undefined ? document.documentElement.scrollLeft : window.pageXOffset,
                y: window.pageYOffset === undefined ? document.documentElement.scrollTop : window.pageYOffset
            };
            log(iframeId, 'Get page position: ' + pagePosition.x + ',' + pagePosition.y);
        }
    }
    function setPagePosition(iframeId) {
        if (null !== pagePosition) {
            window.scrollTo(pagePosition.x, pagePosition.y);
            log(iframeId, 'Set page position: ' + pagePosition.x + ',' + pagePosition.y);
            unsetPagePosition();
        }
    }
    function unsetPagePosition() {
        pagePosition = null;
    }
    function resetIFrame(messageData) {
        function reset() {
            setSize(messageData);
            trigger('reset', 'reset', messageData.iframe, messageData.id);
        }
        log(messageData.id, 'Size reset requested by ' + ('init' === messageData.type ? 'host page' : 'iFrame'));
        getPagePosition(messageData.id);
        syncResize(reset, messageData, 'reset');
    }
    function setSize(messageData) {
        function setDimension(dimension) {
            if (!messageData.id) {
                log('undefined', 'messageData id not set');
                return;
            }
            messageData.iframe.style[dimension] = messageData[dimension] + 'px';
            log(messageData.id, 'IFrame (' + iframeId + ') ' + dimension + ' set to ' + messageData[dimension] + 'px');
        }
        function chkZero(dimension) {
            // FireFox sets dimension of hidden iFrames to zero.
            // So if we detect that set up an event to check for
            // when iFrame becomes visible.
            /* istanbul ignore next */ // Not testable in PhantomJS
            if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
                hiddenCheckEnabled = true;
                log(iframeId, 'Hidden iFrame detected, creating visibility listener');
                fixHiddenIFrames();
            }
        }
        function processDimension(dimension) {
            setDimension(dimension);
            chkZero(dimension);
        }
        var iframeId = messageData.iframe.id;
        if (settings[iframeId]) {
            if (settings[iframeId].sizeHeight) processDimension('height');
            if (settings[iframeId].sizeWidth) processDimension('width');
        }
    }
    function syncResize(func, messageData, doNotSync) {
        /* istanbul ignore if */ // Not testable in PhantomJS
        if (doNotSync !== messageData.type && requestAnimationFrame && // including check for jasmine because had trouble getting spy to work in unit test using requestAnimationFrame
        !window.jasmine) {
            log(messageData.id, 'Requesting animation frame');
            requestAnimationFrame(func);
        } else func();
    }
    function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
        function postMessageToIFrame() {
            var target = settings[id] && settings[id].targetOrigin;
            log(id, '[' + calleeMsg + '] Sending msg to iframe[' + id + '] (' + msg + ') targetOrigin: ' + target);
            iframe.contentWindow.postMessage(msgId + msg, target);
        }
        function iFrameNotFound() {
            warn(id, '[' + calleeMsg + '] IFrame(' + id + ') not found');
        }
        function chkAndSend() {
            if (iframe && 'contentWindow' in iframe && null !== iframe.contentWindow) // Null test for PhantomJS
            postMessageToIFrame();
            else iFrameNotFound();
        }
        function warnOnNoResponse() {
            function warning() {
                if (settings[id] && !settings[id].loaded && !errorShown) {
                    errorShown = true;
                    warn(id, 'IFrame has not responded within ' + settings[id].warningTimeout / 1000 + ' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.');
                }
            }
            if (!!noResponseWarning && settings[id] && !!settings[id].warningTimeout) settings[id].msgTimeout = setTimeout(warning, settings[id].warningTimeout);
        }
        var errorShown = false;
        id = id || iframe.id;
        if (settings[id]) {
            chkAndSend();
            warnOnNoResponse();
        }
    }
    function createOutgoingMsg(iframeId) {
        return iframeId + ':' + settings[iframeId].bodyMarginV1 + ':' + settings[iframeId].sizeWidth + ':' + settings[iframeId].log + ':' + settings[iframeId].interval + ':' + settings[iframeId].enablePublicMethods + ':' + settings[iframeId].autoResize + ':' + settings[iframeId].bodyMargin + ':' + settings[iframeId].heightCalculationMethod + ':' + settings[iframeId].bodyBackground + ':' + settings[iframeId].bodyPadding + ':' + settings[iframeId].tolerance + ':' + settings[iframeId].inPageLinks + ':' + settings[iframeId].resizeFrom + ':' + settings[iframeId].widthCalculationMethod + ':' + settings[iframeId].mouseEvents;
    }
    function isNumber(value) {
        return typeof value === 'number';
    }
    function setupIFrame(iframe, options) {
        function setLimits() {
            function addStyle(style) {
                var styleValue = settings[iframeId][style];
                if (Infinity !== styleValue && 0 !== styleValue) {
                    iframe.style[style] = isNumber(styleValue) ? styleValue + 'px' : styleValue;
                    log(iframeId, 'Set ' + style + ' = ' + iframe.style[style]);
                }
            }
            function chkMinMax(dimension) {
                if (settings[iframeId]['min' + dimension] > settings[iframeId]['max' + dimension]) throw new Error('Value for min' + dimension + ' can not be greater than max' + dimension);
            }
            chkMinMax('Height');
            chkMinMax('Width');
            addStyle('maxHeight');
            addStyle('minHeight');
            addStyle('maxWidth');
            addStyle('minWidth');
        }
        function newId() {
            var id = options && options.id || defaults.id + count++;
            if (null !== document.getElementById(id)) id += count++;
            return id;
        }
        function ensureHasId(iframeId) {
            if (typeof iframeId !== 'string') throw new TypeError('Invaild id for iFrame. Expected String');
            if ('' === iframeId) {
                // eslint-disable-next-line no-multi-assign
                iframe.id = iframeId = newId();
                logEnabled = (options || {}).log;
                log(iframeId, 'Added missing iframe ID: ' + iframeId + ' (' + iframe.src + ')');
            }
            return iframeId;
        }
        function setScrolling() {
            log(iframeId, 'IFrame scrolling ' + (settings[iframeId] && settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
            iframe.style.overflow = false === (settings[iframeId] && settings[iframeId].scrolling) ? 'hidden' : 'auto';
            switch(settings[iframeId] && settings[iframeId].scrolling){
                case 'omit':
                    break;
                case true:
                    iframe.scrolling = 'yes';
                    break;
                case false:
                    iframe.scrolling = 'no';
                    break;
                default:
                    iframe.scrolling = settings[iframeId] ? settings[iframeId].scrolling : 'no';
            }
        }
        // The V1 iFrame script expects an int, where as in V2 expects a CSS
        // string value such as '1px 3em', so if we have an int for V2, set V1=V2
        // and then convert V2 to a string PX value.
        function setupBodyMarginValues() {
            if ('number' === typeof (settings[iframeId] && settings[iframeId].bodyMargin) || '0' === (settings[iframeId] && settings[iframeId].bodyMargin)) {
                settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
                settings[iframeId].bodyMargin = '' + settings[iframeId].bodyMargin + 'px';
            }
        }
        function checkReset() {
            // Reduce scope of firstRun to function, because IE8's JS execution
            // context stack is borked and this value gets externally
            // changed midway through running this function!!!
            var firstRun = settings[iframeId] && settings[iframeId].firstRun, resetRequertMethod = settings[iframeId] && settings[iframeId].heightCalculationMethod in resetRequiredMethods;
            if (!firstRun && resetRequertMethod) resetIFrame({
                iframe: iframe,
                height: 0,
                width: 0,
                type: 'init'
            });
        }
        function setupIFrameObject() {
            if (settings[iframeId]) settings[iframeId].iframe.iFrameResizer = {
                close: closeIFrame.bind(null, settings[iframeId].iframe),
                removeListeners: removeIframeListeners.bind(null, settings[iframeId].iframe),
                resize: trigger.bind(null, 'Window resize', 'resize', settings[iframeId].iframe),
                moveToAnchor: function(anchor) {
                    trigger('Move to anchor', 'moveToAnchor:' + anchor, settings[iframeId].iframe, iframeId);
                },
                sendMessage: function(message) {
                    message = JSON.stringify(message);
                    trigger('Send Message', 'message:' + message, settings[iframeId].iframe, iframeId);
                }
            };
        }
        // We have to call trigger twice, as we can not be sure if all
        // iframes have completed loading when this code runs. The
        // event listener also catches the page changing in the iFrame.
        function init(msg) {
            function iFrameLoaded() {
                trigger('iFrame.onload', msg, iframe, undefined, true);
                checkReset();
            }
            function createDestroyObserver(MutationObserver) {
                if (!iframe.parentNode) return null;
                var destroyObserver = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        var removedNodes = Array.prototype.slice.call(mutation.removedNodes) // Transform NodeList into an Array
                        ;
                        removedNodes.forEach(function(removedNode) {
                            if (removedNode === iframe) closeIFrame(iframe);
                        });
                    });
                });
                destroyObserver.observe(iframe.parentNode, {
                    childList: true
                });
                return destroyObserver;
            }
            var MutationObserver = getMutationObserver();
            if (MutationObserver) destroyObserver = createDestroyObserver(MutationObserver);
            addEventListener(iframe, 'load', iFrameLoaded);
            trigger('init', msg, iframe, undefined, true);
        }
        function checkOptions(options) {
            if ('object' !== typeof options) throw new TypeError('Options is not an object');
        }
        function copyOptions(options) {
            // eslint-disable-next-line no-restricted-syntax
            for(var option in defaults)if (Object.prototype.hasOwnProperty.call(defaults, option)) settings[iframeId][option] = Object.prototype.hasOwnProperty.call(options, option) ? options[option] : defaults[option];
        }
        function getTargetOrigin(remoteHost) {
            return '' === remoteHost || null !== remoteHost.match(/^(about:blank|javascript:|file:\/\/)/) ? '*' : remoteHost;
        }
        function depricate(key) {
            var splitName = key.split('Callback');
            if (splitName.length === 2) {
                var name = 'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1);
                this[name] = this[key];
                delete this[key];
                warn(iframeId, "Deprecated: '" + key + "' has been renamed '" + name + "'. The old method will be removed in the next major version.");
            }
        }
        function processOptions(options) {
            options = options || {};
            settings[iframeId] = Object.create(null); // Protect against prototype attacks
            settings[iframeId].iframe = iframe;
            settings[iframeId].firstRun = true;
            settings[iframeId].remoteHost = iframe.src && iframe.src.split('/').slice(0, 3).join('/');
            checkOptions(options);
            Object.keys(options).forEach(depricate, options);
            copyOptions(options);
            if (settings[iframeId]) settings[iframeId].targetOrigin = true === settings[iframeId].checkOrigin ? getTargetOrigin(settings[iframeId].remoteHost) : '*';
        }
        function beenHere() {
            return iframeId in settings && 'iFrameResizer' in iframe;
        }
        var iframeId = ensureHasId(iframe.id);
        if (beenHere()) warn(iframeId, 'Ignored iFrame, already setup.');
        else {
            processOptions(options);
            setScrolling();
            setLimits();
            setupBodyMarginValues();
            init(createOutgoingMsg(iframeId));
            setupIFrameObject();
        }
    }
    function debouce(fn, time) {
        if (null === timer) timer = setTimeout(function() {
            timer = null;
            fn();
        }, time);
    }
    var frameTimer = {};
    function debounceFrameEvents(fn, time, frameId) {
        if (!frameTimer[frameId]) frameTimer[frameId] = setTimeout(function() {
            frameTimer[frameId] = null;
            fn();
        }, time);
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function fixHiddenIFrames() {
        function checkIFrames() {
            function checkIFrame(settingId) {
                function chkDimension(dimension) {
                    return '0px' === (settings[settingId] && settings[settingId].iframe.style[dimension]);
                }
                function isVisible(el) {
                    return null !== el.offsetParent;
                }
                if (settings[settingId] && isVisible(settings[settingId].iframe) && (chkDimension('height') || chkDimension('width'))) trigger('Visibility change', 'resize', settings[settingId].iframe, settingId);
            }
            Object.keys(settings).forEach(function(key) {
                checkIFrame(key);
            });
        }
        function mutationObserved(mutations) {
            log('window', 'Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type);
            debouce(checkIFrames, 16);
        }
        function createMutationObserver() {
            var target = document.querySelector('body'), config = {
                attributes: true,
                attributeOldValue: false,
                characterData: true,
                characterDataOldValue: false,
                childList: true,
                subtree: true
            }, observer = new MutationObserver(mutationObserved);
            observer.observe(target, config);
        }
        var MutationObserver = getMutationObserver();
        if (MutationObserver) createMutationObserver();
    }
    function resizeIFrames(event) {
        function resize() {
            sendTriggerMsg('Window ' + event, 'resize');
        }
        log('window', 'Trigger event: ' + event);
        debouce(resize, 16);
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function tabVisible() {
        function resize() {
            sendTriggerMsg('Tab Visible', 'resize');
        }
        if ('hidden' !== document.visibilityState) {
            log('document', 'Trigger event: Visibility change');
            debouce(resize, 16);
        }
    }
    function sendTriggerMsg(eventName, event) {
        function isIFrameResizeEnabled(iframeId) {
            return settings[iframeId] && 'parent' === settings[iframeId].resizeFrom && settings[iframeId].autoResize && !settings[iframeId].firstRun;
        }
        Object.keys(settings).forEach(function(iframeId) {
            if (isIFrameResizeEnabled(iframeId)) trigger(eventName, event, settings[iframeId].iframe, iframeId);
        });
    }
    function setupEventListeners() {
        addEventListener(window, 'message', iFrameListener);
        addEventListener(window, 'resize', function() {
            resizeIFrames('resize');
        });
        addEventListener(document, 'visibilitychange', tabVisible);
        addEventListener(document, '-webkit-visibilitychange', tabVisible);
    }
    function factory() {
        function init(options, element) {
            function chkType() {
                if (!element.tagName) throw new TypeError('Object is not a valid DOM element');
                else if ('IFRAME' !== element.tagName.toUpperCase()) throw new TypeError('Expected <IFRAME> tag, found <' + element.tagName + '>');
            }
            if (element) {
                chkType();
                setupIFrame(element, options);
                iFrames.push(element);
            }
        }
        function warnDeprecatedOptions(options) {
            if (options && options.enablePublicMethods) warn('enablePublicMethods option has been removed, public methods are now always available in the iFrame');
        }
        var iFrames;
        setupRequestAnimationFrame();
        setupEventListeners();
        return function iFrameResizeF(options, target) {
            iFrames = []; // Only return iFrames past in on this call
            warnDeprecatedOptions(options);
            switch(typeof target){
                case 'undefined':
                case 'string':
                    Array.prototype.forEach.call(document.querySelectorAll(target || 'iframe'), init.bind(undefined, options));
                    break;
                case 'object':
                    init(options, target);
                    break;
                default:
                    throw new TypeError('Unexpected data type (' + typeof target + ')');
            }
            return iFrames;
        };
    }
    function createJQueryPublicMethod($) {
        if (!$.fn) info('', 'Unable to bind to jQuery, it is not fully loaded.');
        else if (!$.fn.iFrameResize) $.fn.iFrameResize = function $iFrameResizeF(options) {
            function init(index, element) {
                setupIFrame(element, options);
            }
            return this.filter('iframe').each(init).end();
        };
    }
    if (window.jQuery !== undefined) createJQueryPublicMethod(window.jQuery);
    if (typeof define === 'function' && define.amd) define([], factory);
    else if (typeof module.exports === 'object') // Node for browserfy
    module.exports = factory();
    window.iFrameResize = window.iFrameResize || factory();
})();

});

parcelRegister("5Wwa0", function(module, exports) {
const $1b1c30087a01bce3$var$messages = [
    'Window closed for',
    'Window did not load after'
];
const $1b1c30087a01bce3$export$fab3177d2bcbd98a = (error)=>error instanceof Error && $1b1c30087a01bce3$var$messages.some((message)=>error.message.startsWith(message));
module.exports["isUnrecoverableError"] = $1b1c30087a01bce3$export$fab3177d2bcbd98a;

});

parcelRegister("bEbDR", function(module, exports) {

var $9cGsb = parcelRequire("9cGsb");

const $8bb421eb0b905a01$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $9cGsb.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};
module.exports["parseExtensionId"] = $8bb421eb0b905a01$export$bae42cbaf7fa3e1b;

});

parcelRegister("fFIqL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $8m50u = parcelRequire("8m50u");


var $iDrrr = parcelRequire("iDrrr");


var $cozmU = parcelRequire("cozmU");


var $hjngh = parcelRequire("hjngh");


var $gid8j = parcelRequire("gid8j");


var $1y5uw = parcelRequire("1y5uw");


var $03RpJ = parcelRequire("03RpJ");

const $e7d82341cfe32f77$export$433ff3d294755246 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $e7d82341cfe32f77$export$e943a7fca26f09e4 = 10000;
const $e7d82341cfe32f77$var$offsetElapsedTimestamps = (events, elapsedBaselineMark)=>{
    return events.map((event)=>{
        const evaluatedElapsedTime = event.elapsed - elapsedBaselineMark;
        event.elapsed = evaluatedElapsedTime;
        return event;
    });
};
const $e7d82341cfe32f77$export$9cdba3450d9c6cdc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { children: children, appType: appType, forgeEnvironment: forgeEnvironment, profileKey: profileKey, extensionType: extensionType, appVersion: appVersion } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            events: [],
            listeners: new Set()
        };
        $[0] = t1;
    } else t1 = $[0];
    const performanceTimelineRef = (0, $cozmU.useRef)(t1);
    const hasSent = (0, $cozmU.useRef)(false);
    const elapsedBaselineMark = (0, $cozmU.useRef)(0);
    const profileIdRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[1] !== extensionType) {
        t2 = (0, $gid8j.getAppPerfCaptureConfig)({
            module: extensionType
        });
        $[1] = extensionType;
        $[2] = t2;
    } else t2 = $[2];
    const captureConfig = t2;
    let t3;
    if ($[3] !== captureConfig || $[4] !== profileKey) {
        t3 = {
            config: captureConfig,
            samplingKey: profileKey
        };
        $[3] = captureConfig;
        $[4] = profileKey;
        $[5] = t3;
    } else t3 = $[5];
    const { enabled: enabled, capture: capture } = (0, $1y5uw.useAppPerfCaptureStrategy)(t3);
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            hasSent.current = false;
            performanceTimelineRef.current.events = [];
            elapsedBaselineMark.current = (0, $hjngh.getPerformanceMark)();
            profileIdRef.current = null;
        };
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== profileKey) {
        t5 = [
            profileKey
        ];
        $[7] = profileKey;
        $[8] = t5;
    } else t5 = $[8];
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[9] !== appType || $[10] !== appVersion || $[11] !== captureConfig.version || $[12] !== forgeEnvironment) {
        t6 = {
            appType: appType,
            forgeEnvironment: forgeEnvironment,
            appVersion: appVersion,
            eventVersion: captureConfig.version
        };
        $[9] = appType;
        $[10] = appVersion;
        $[11] = captureConfig.version;
        $[12] = forgeEnvironment;
        $[13] = t6;
    } else t6 = $[13];
    const staticAttributes = t6;
    let t7;
    if ($[14] !== capture || $[15] !== staticAttributes) {
        t7 = ()=>{
            if (!profileIdRef.current) profileIdRef.current = (0, $03RpJ.default)();
            capture({
                profileId: profileIdRef.current,
                events: $e7d82341cfe32f77$var$offsetElapsedTimestamps(performanceTimelineRef.current.events, elapsedBaselineMark.current),
                navigationTimeStart: elapsedBaselineMark.current,
                ...staticAttributes
            });
            hasSent.current = true;
        };
        $[14] = capture;
        $[15] = staticAttributes;
        $[16] = t7;
    } else t7 = $[16];
    const captureAnalytics = t7;
    let t8;
    let t9;
    if ($[17] !== captureAnalytics || $[18] !== enabled) {
        t8 = ()=>{
            if (!enabled || hasSent.current) return;
            const timeout = setTimeout(()=>{
                captureAnalytics();
            }, $e7d82341cfe32f77$export$e943a7fca26f09e4);
            return ()=>{
                clearTimeout(timeout);
            };
        };
        t9 = [
            enabled,
            captureAnalytics
        ];
        $[17] = captureAnalytics;
        $[18] = enabled;
        $[19] = t8;
        $[20] = t9;
    } else {
        t8 = $[19];
        t9 = $[20];
    }
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[21] !== children) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e7d82341cfe32f77$export$433ff3d294755246.Provider, {
            value: performanceTimelineRef
        }, children);
        $[21] = children;
        $[22] = t10;
    } else t10 = $[22];
    return t10;
} : ({ children: children, appType: appType, forgeEnvironment: forgeEnvironment, profileKey: profileKey, extensionType: extensionType, appVersion: appVersion })=>{
    // Rely on refs to avoid re-rendering all children components when the state changes
    const performanceTimelineRef = (0, $cozmU.useRef)({
        events: [],
        listeners: new Set()
    });
    const hasSent = (0, $cozmU.useRef)(false);
    const elapsedBaselineMark = (0, $cozmU.useRef)(0);
    // Store profile ID in ref to generate once per session and reuse
    const profileIdRef = (0, $cozmU.useRef)(null);
    const captureConfig = (0, $gid8j.getAppPerfCaptureConfig)({
        module: extensionType
    });
    const { enabled: enabled, capture: capture } = (0, $1y5uw.useAppPerfCaptureStrategy)({
        config: captureConfig,
        samplingKey: profileKey
    });
    // Reset state when profileKey changes
    (0, $cozmU.useEffect)(()=>{
        hasSent.current = false;
        performanceTimelineRef.current.events = [];
        elapsedBaselineMark.current = (0, $hjngh.getPerformanceMark)();
        profileIdRef.current = null; // Reset profile ID for new session
    // Use `profileKey` to reset all state when the extension or entryPoint changes to collect a new set of analytics
    }, [
        profileKey
    ]);
    // Memoize static attributes to avoid recreating on every render
    const staticAttributes = (0, $cozmU.useMemo)(()=>({
            appType: appType,
            forgeEnvironment: forgeEnvironment,
            appVersion: appVersion,
            eventVersion: captureConfig.version
        }), [
        appType,
        forgeEnvironment,
        appVersion,
        captureConfig.version
    ]);
    // Create stable callback for capturing analytics
    const captureAnalytics = (0, $cozmU.useCallback)(()=>{
        // Generate profile ID once per session
        if (!profileIdRef.current) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        profileIdRef.current = (0, $03RpJ.default)();
        capture({
            profileId: profileIdRef.current,
            events: $e7d82341cfe32f77$var$offsetElapsedTimestamps(performanceTimelineRef.current.events, elapsedBaselineMark.current),
            // Time difference since this event was fired and since page loaded
            navigationTimeStart: elapsedBaselineMark.current,
            ...staticAttributes
        });
        hasSent.current = true;
    }, [
        capture,
        staticAttributes
    ]);
    // Send all collected performance related analytics in a single event
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || hasSent.current) return;
        const timeout = setTimeout(()=>{
            captureAnalytics();
        }, $e7d82341cfe32f77$export$e943a7fca26f09e4);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        enabled,
        captureAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e7d82341cfe32f77$export$433ff3d294755246.Provider, {
        value: performanceTimelineRef
    }, children);
};
const $e7d82341cfe32f77$export$ec3453941beb4064 = (0, $8m50u.componentWithCondition)(()=>(0, $iDrrr.fg)('forge-ui-app-perf-tracking-enabled'), $e7d82341cfe32f77$export$9cdba3450d9c6cdc, (0, $cozmU.Fragment));
module.exports["PerformanceAnalyticsContext"] = $e7d82341cfe32f77$export$433ff3d294755246;
module.exports["PERFORMANCE_ANALYTICS_INTERVAL"] = $e7d82341cfe32f77$export$e943a7fca26f09e4;
module.exports["PerformanceAnalyticsProviderRollout"] = $e7d82341cfe32f77$export$ec3453941beb4064;

});

parcelRegister("jAjCC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $4aRua = parcelRequire("4aRua");


var $7aRdF = parcelRequire("7aRdF");


var $eQiT1 = parcelRequire("eQiT1");


var $fEPJS = parcelRequire("fEPJS");


var $jq995 = parcelRequire("jq995");


var $9Umtx = parcelRequire("9Umtx");


var $aRGok = parcelRequire("aRGok");

const $9faa886c23639db6$var$cssActionItem = null;
const $9faa886c23639db6$var$messages = (0, $kSwu1.defineMessages)({
    navigationWarningTitle: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-title",
        defaultMessage: "Opening external page on {hostname}"
    },
    navigationWarningBody: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-body",
        defaultMessage: "is sending you to an external page. Ensure you trust that page before you continue."
    },
    navigationWarningBodyNoAppName: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-body-no-app-name",
        defaultMessage: "This app is sending you to an external page. Ensure you trust that page before you continue."
    },
    navigationWarningAppSecurityLink: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-app-security-link",
        defaultMessage: "Learn more about app security"
    },
    navigationWarningCancelButton: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-cancel-button",
        defaultMessage: "Cancel"
    },
    navigationWarningContinueButton: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-continue-button",
        defaultMessage: "Continue"
    }
});
const $9faa886c23639db6$var$ModalFooter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { onCancel: onCancel, onConfirm: onConfirm } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuI7V3 _39xV02N91d"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _4FNLNUdnbC _0wyYyZdnbC _05nT0YdnbC _08IXD0dnbC"
        ]);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== intl) {
        t3 = intl.formatMessage($9faa886c23639db6$var$messages.navigationWarningAppSecurityLink);
        $[2] = intl;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
            href: "https://go.atlassian.com/forge-help-app-security",
            appearance: "subtle-link",
            target: "_blank",
            rel: "noopener noreferrer",
            className: t2
        }, t3);
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_3iDTPbccYA _313842dnbC _0adFHs5UaJ _1DCdHidnbC _2XsHFM5UaJ"
        ]);
        t6 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEIZbP _313842dnbC _0adFHs1Y8M _1DCdHidnbC _2XsHFM1Y8M"
        ]);
        $[6] = t5;
        $[7] = t6;
    } else {
        t5 = $[6];
        t6 = $[7];
    }
    let t7;
    if ($[8] !== intl) {
        t7 = intl.formatMessage($9faa886c23639db6$var$messages.navigationWarningCancelButton);
        $[8] = intl;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== onCancel || $[11] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t6
        }, /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
            appearance: "subtle",
            onClick: onCancel
        }, t7));
        $[10] = onCancel;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEIZbP _313842dnbC _0adFHs1Y8M _1DCdHidnbC _2XsHFM1Y8M"
        ]);
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== intl) {
        t10 = intl.formatMessage($9faa886c23639db6$var$messages.navigationWarningContinueButton);
        $[14] = intl;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== onConfirm || $[17] !== t10) {
        t11 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t9
        }, /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
            appearance: "warning",
            onClick: onConfirm
        }, t10));
        $[16] = onConfirm;
        $[17] = t10;
        $[18] = t11;
    } else t11 = $[18];
    let t12;
    if ($[19] !== t11 || $[20] !== t8) {
        t12 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t5
        }, t8, t11);
        $[19] = t11;
        $[20] = t8;
        $[21] = t12;
    } else t12 = $[21];
    let t13;
    if ($[22] !== t12 || $[23] !== t4) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, t4, t12));
        $[22] = t12;
        $[23] = t4;
        $[24] = t13;
    } else t13 = $[24];
    return t13;
} : ({ onCancel: onCancel, onConfirm: onConfirm })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- to avoid import of css module from @compiled/react
    , {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuI7V3 _39xV02N91d"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
        href: "https://go.atlassian.com/forge-help-app-security",
        appearance: "subtle-link",
        target: "_blank",
        rel: "noopener noreferrer",
        className: (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _4FNLNUdnbC _0wyYyZdnbC _05nT0YdnbC _08IXD0dnbC"
        ])
    }, intl.formatMessage($9faa886c23639db6$var$messages.navigationWarningAppSecurityLink)), /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_3iDTPbccYA _313842dnbC _0adFHs5UaJ _1DCdHidnbC _2XsHFM5UaJ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEIZbP _313842dnbC _0adFHs1Y8M _1DCdHidnbC _2XsHFM1Y8M"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: onCancel
    }, intl.formatMessage($9faa886c23639db6$var$messages.navigationWarningCancelButton))), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEIZbP _313842dnbC _0adFHs1Y8M _1DCdHidnbC _2XsHFM1Y8M"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
        appearance: "warning",
        onClick: onConfirm
    }, intl.formatMessage($9faa886c23639db6$var$messages.navigationWarningContinueButton))))));
};
const $9faa886c23639db6$export$72ece4fe8d8dbff9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { url: url, extensionTitle: extensionTitle, onConfirm: onConfirm, onCancel: onCancel } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl || $[1] !== url.hostname) {
        t1 = intl.formatMessage($9faa886c23639db6$var$messages.navigationWarningTitle, {
            hostname: url.hostname
        });
        $[0] = intl;
        $[1] = url.hostname;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), null, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), {
            appearance: "warning"
        }, t1));
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== extensionTitle || $[6] !== intl) {
        t3 = extensionTitle ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "p"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "strong"
        }, extensionTitle), " ", intl.formatMessage($9faa886c23639db6$var$messages.navigationWarningBody)) : /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "p"
        }, intl.formatMessage($9faa886c23639db6$var$messages.navigationWarningBodyNoAppName));
        $[5] = extensionTitle;
        $[6] = intl;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== url.href) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "p",
            maxLines: 1
        }, url.href);
        $[8] = url.href;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, t3, t4);
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== onCancel || $[14] !== onConfirm) {
        t6 = /*#__PURE__*/ $cozmU.createElement($9faa886c23639db6$var$ModalFooter, {
            onCancel: onCancel,
            onConfirm: onConfirm
        });
        $[13] = onCancel;
        $[14] = onConfirm;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== onCancel || $[17] !== t2 || $[18] !== t5 || $[19] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
            onClose: onCancel
        }, t2, t5, t6));
        $[16] = onCancel;
        $[17] = t2;
        $[18] = t5;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : ({ url: url, extensionTitle: extensionTitle, onConfirm: onConfirm, onCancel: onCancel })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: onCancel
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), null, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), {
        appearance: "warning"
    }, intl.formatMessage($9faa886c23639db6$var$messages.navigationWarningTitle, {
        hostname: url.hostname
    }))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, extensionTitle ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "p"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "strong"
    }, extensionTitle), ' ', intl.formatMessage($9faa886c23639db6$var$messages.navigationWarningBody)) : /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "p"
    }, intl.formatMessage($9faa886c23639db6$var$messages.navigationWarningBodyNoAppName)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "p",
        maxLines: 1
    }, url.href)), /*#__PURE__*/ $cozmU.createElement($9faa886c23639db6$var$ModalFooter, {
        onCancel: onCancel,
        onConfirm: onConfirm
    })));
};
module.exports["ExternalLinkModal"] = $9faa886c23639db6$export$72ece4fe8d8dbff9;

});

parcelRegister("c71c0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $2N0qz = parcelRequire("2N0qz");


var $cozmU = parcelRequire("cozmU");


var $2j0AL = parcelRequire("2j0AL");


var $6Rin8 = parcelRequire("6Rin8");


var $9DHhW = parcelRequire("9DHhW");


var $jH9cM = parcelRequire("jH9cM");


var $gqUuL = parcelRequire("gqUuL");


var $kq02L = parcelRequire("kq02L");


var $bSxWl = parcelRequire("bSxWl");


var $9ytZz = parcelRequire("9ytZz");


var $1uMa2 = parcelRequire("1uMa2");


var $h48r4 = parcelRequire("h48r4");

var $eL3mC = parcelRequire("eL3mC");


var $DIyeF = parcelRequire("DIyeF");


var $ixV18 = parcelRequire("ixV18");


var $eqEJl = parcelRequire("eqEJl");


var $6SsN4 = parcelRequire("6SsN4");


var $8yKod = parcelRequire("8yKod");

var $bEbDR = parcelRequire("bEbDR");


var $cTycZ = parcelRequire("cTycZ");


var $iDrrr = parcelRequire("iDrrr");


var $dNEbC = parcelRequire("dNEbC");


var $8j9ei = parcelRequire("8j9ei");


var $6FQr4 = parcelRequire("6FQr4");


var $hjngh = parcelRequire("hjngh");


var $3nNWm = parcelRequire("3nNWm");


var $llM9z = parcelRequire("llM9z");


var $5xQdV = parcelRequire("5xQdV");


var $iUEMs = parcelRequire("iUEMs");


var $CJweT = parcelRequire("CJweT");

let $4a17c08eaedb714c$var$storedBaseUrlRelay = '';
let $4a17c08eaedb714c$var$createIframeBridge = null;
let $4a17c08eaedb714c$var$postRobotSend = null;


// bridge-core import relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
    $4a17c08eaedb714c$var$createIframeBridge = (parcelRequire("9rzZK")).createIframeBridge;
    $4a17c08eaedb714c$var$postRobotSend = (parcelRequire("9rzZK")).postRobotSend;
}
const $4a17c08eaedb714c$var$mapCustomBridgeMethods = ({ customBridgeMethods: customBridgeMethods, withFausMessageForwarder: withFausMessageForwarder, isUIKitEmbeddedMacro: isUIKitEmbeddedMacro, embeddedMacroLocalId: embeddedMacroLocalId })=>{
    if (!customBridgeMethods) return {};
    return Object.keys(customBridgeMethods).reduce((acc, key)=>{
        return {
            ...acc,
            [key]: withFausMessageForwarder(key, (payload)=>{
                const data = isUIKitEmbeddedMacro ? (0, $CJweT.transformDataForEmbeddedMacros)(key, embeddedMacroLocalId, payload?.data) : payload?.data;
                return customBridgeMethods[key](data);
            })
        };
    }, {});
};
class $4a17c08eaedb714c$export$d86296fe47e644cc extends Error {
    constructor(cause){
        super(cause);
    }
}
const $4a17c08eaedb714c$var$MACRO_MODULE_NAME = 'xen:macro';
const $4a17c08eaedb714c$export$c2bd95920a67f979 = 'forge-adf-renderer';
// Tracks re-initialisation of the bridge and logs a warning to console and analytics
const $4a17c08eaedb714c$var$useBridgeReinitTracker = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6FQr4.useForgeUiAnalyticsEvent)();
    const mountedCount = (0, $cozmU.useRef)(0);
    let t0;
    let t1;
    if ($[0] !== trackExtensionRemounted) {
        t0 = ()=>{
            try {
                mountedCount.current = mountedCount.current + 1;
                if (mountedCount.current > 1) {
                    trackExtensionRemounted({
                        mountCount: mountedCount.current,
                        isUseBridgeReinit: true
                    });
                    console.warn(`Warning: useBridge re-initialised the bridge ${mountedCount.current} times.`);
                }
            } catch  {}
        };
        t1 = [
            mountedCount,
            trackExtensionRemounted
        ];
        $[0] = trackExtensionRemounted;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    const trackBridgeReinited = (0, $5xQdV.useCallbackOne)(t0, t1);
    return trackBridgeReinited;
} : ()=>{
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6FQr4.useForgeUiAnalyticsEvent)();
    const mountedCount = (0, $cozmU.useRef)(0);
    const trackBridgeReinited = (0, $5xQdV.useCallbackOne)(()=>{
        try {
            mountedCount.current += 1;
            if (mountedCount.current > 1) {
                trackExtensionRemounted({
                    mountCount: mountedCount.current,
                    isUseBridgeReinit: true
                });
                // eslint-disable-next-line no-console
                console.warn(`Warning: useBridge re-initialised the bridge ${mountedCount.current} times.`);
            }
        } catch  {}
    }, [
        mountedCount,
        trackExtensionRemounted
    ]);
    return trackBridgeReinited;
};
const $4a17c08eaedb714c$export$23a7a1286dcfa590 = ({ cloudId: cloudId, theme: theme, surfaceColor: surfaceColor, origin: origin, api: api, customBridgeMethods: customBridgeMethods, onLoad: onLoad, isResizable: isResizable, height: height, environment: environment, extension: extension, iframeRef: iframeRef, contextIds: contextIds, isInModal: isInModal, localId: localId, isEmbeddedMacro: isEmbeddedMacro = false, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId, extensionPayload: extensionPayload, extensionData: extensionData })=>{
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [loadedAt, setLoadedAt] = (0, $cozmU.useState)(null);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    // This ref avoids the api object ending up in the dep array
    // of the effect that calls createIframeBridge. It means that
    // people can pass anonymous functions as the api without the
    // bridge being re-created every render.
    const apiRef = (0, $cozmU.useRef)(api);
    (0, $cozmU.useEffect)(()=>{
        apiRef.current = api;
    }, [
        api
    ]);
    // Used for passing embedded macro extension object to
    // parent bodied macro Custom UI renderer.
    const extensionRef = (0, $cozmU.useRef)(extension);
    // Used for passing embedded macro extensionPayload to  modal renderer.
    // Only used in editor view mode so config will always be up to date.
    const extensionPayloadRef = (0, $cozmU.useRef)(extensionPayload);
    // Used for passing embedded macro extensionData to modal renderer
    // Extension data is a static object containing context values for the app, so no update needed.
    const extensionDataRef = (0, $cozmU.useRef)(extensionData);
    const enableThemingRef = (0, $cozmU.useRef)();
    const setThemeRef = (0, $cozmU.useRef)();
    // this ref tracks the initial theme to avoid unnecessary theme updates.
    // specifically, it is used in createIframeBridge during the initial forge runtime initialization,
    // so that the iframe can set the theme correctly on the ready event (initial handshake).
    // however, subsequent theme should not cause createIframeBridge to be called again.
    const initialThemeRef = (0, $cozmU.useRef)({
        theme: theme,
        surfaceColor: surfaceColor
    });
    const trackBridgeReinited = $4a17c08eaedb714c$var$useBridgeReinitTracker();
    (0, $cozmU.useEffect)(()=>{
        if (!setThemeRef.current) return;
        // we track the theme changes here to avoid calling createIframeBridge (expensive and error prone) unnecessarily
        initialThemeRef.current = {
            theme: theme,
            surfaceColor: surfaceColor
        };
        setThemeRef.current(theme, surfaceColor, environment);
        (0, $1uMa2.emit)('FORGE_CORE_THEME_CHANGED', {
            theme: theme
        });
    }, [
        theme,
        surfaceColor,
        loading,
        environment
    ]);
    // same as above, but for customBridgeMethods
    const customBridgeMethodsRef = (0, $cozmU.useRef)(customBridgeMethods);
    (0, $cozmU.useEffect)(()=>{
        customBridgeMethodsRef.current = customBridgeMethods;
    }, [
        customBridgeMethods
    ]);
    const [errorExtensionDetails, setErrorExtensionDetails] = (0, $cozmU.useState)({
        id: extension.id,
        properties: extension.properties,
        type: extension.type,
        environmentType: extension.environmentType,
        appOwnerAccountId: extension.appOwner?.accountId
    });
    const tracing = (0, $eL3mC.useTracingContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { trackForgeFeatureFlagEvent: trackForgeFeatureFlagEvent, trackObjectStoreAction: trackObjectStoreAction, trackHandShakeMetric: trackHandShakeMetric } = (0, $6FQr4.useForgeUiAnalyticsEvent)();
    (0, $cozmU.useEffect)(()=>{
        const { type: type, environmentType: environmentType, properties: properties, appOwnerAccountId: appOwnerAccountId, id: id } = errorExtensionDetails;
        if (extension.id !== id || extension.type !== type || extension.environmentType !== environmentType || extension.appOwner?.accountId !== appOwnerAccountId || !(0, (/*@__PURE__*/$parcel$interopDefault($2j0AL)))(extension.properties, properties)) setErrorExtensionDetails({
            id: extension.id,
            properties: extension.properties,
            type: extension.type,
            environmentType: extension.environmentType,
            appOwnerAccountId: extension.appOwner?.accountId
        });
    }, [
        extension,
        errorExtensionDetails
    ]);
    const { id: id, installationId: installationId } = extension;
    // Need to retrieve appId here because extension.appId could be undefined in certain products. For example, Jira extensions do not provide the appId.
    const appId = extension.appId ?? (0, $bEbDR.parseExtensionId)(extension.id).appId;
    const getAppForgeUIExtensions = (0, $cTycZ.useGetAppForgeUIExtensions)({
        appId: appId,
        environmentId: extension.environmentId,
        moduleType: extension.type,
        contextIds: contextIds,
        context: {},
        includeHidden: false,
        cloudId: cloudId,
        bypassNewForgeExtensionListCall: true
    });
    const relayContext = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext));
    const relayEnvironment = relayContext?.environment;
    // Query to retrieve the base url of a tenant.
    // The same Atlassian tenant could have a different custom domain for each product.
    // We retrieve the underlying Atlassian domain here to use for URL creation in routing to support cross custom domain routing
    const getBaseUrl = (0, $cozmU.useCallback)(async ()=>{
        if (!cloudId) return window.location.origin;
        if (relayEnvironment) {
            if ($4a17c08eaedb714c$var$storedBaseUrlRelay) return $4a17c08eaedb714c$var$storedBaseUrlRelay;
            const observable = (0, $eqEJl.fetchQuery)(relayEnvironment, (0, $2N0qz.default), {
                cloudIds: [
                    cloudId
                ]
            });
            return new Promise((resolve, reject)=>{
                let settled = false;
                observable.subscribe({
                    next: (data)=>{
                        if (settled) return;
                        settled = true;
                        const baseUrl = data?.tenantContexts?.[0]?.cloudUrl ?? '';
                        $4a17c08eaedb714c$var$storedBaseUrlRelay = baseUrl;
                        resolve(baseUrl);
                    },
                    error: (err)=>{
                        if (!settled) {
                            settled = true;
                            reject(err);
                        }
                    },
                    complete: ()=>{
                        if (!settled) {
                            settled = true;
                            resolve($4a17c08eaedb714c$var$storedBaseUrlRelay ?? '');
                        }
                    }
                });
            });
        } else return window.location.origin;
    }, [
        cloudId,
        relayEnvironment
    ]);
    const appType = (0, $cozmU.useMemo)(()=>(0, $8yKod.isCustomUI)(extension) ? 'CustomUI' : 'UIKit', [
        extension
    ]);
    const { captureEvent: captureEvent, captureUntrustedEvent: captureUntrustedEvent } = (0, $3nNWm.usePerformanceAnalytics)();
    // The event subscription need to be maintained outside of useEffect to avoid missing events when the createIframeBridge is re-created
    // specifically, createIframeBridge could be re-created when the app "re-render", however, in such cases we do not want to lose the existing event subscriptions
    // after all, we should consider ensure createIframeBridge not to be re-created unnecessarily (only when completely app re-mount is really needed)
    const eventCallbacksRef = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            for (const subscription of eventCallbacksRef.current)subscription.unsubscribe();
            eventCallbacksRef.current = [];
        };
    }, []);
    const { properties: { layout: layout }, type: type, environmentType: environmentType } = extension;
    (0, $cozmU.useEffect)(()=>{
        //this should never happen on client side
        if (!$4a17c08eaedb714c$var$createIframeBridge) return;
        const iframeEl = iframeRef.current;
        if (iframeEl?.contentWindow && !loading && typeof loadedAt === 'number') {
            const extensionDetails = {
                appId: appId,
                id: id.split('/').slice(0, 3).join('/'),
                installationId: installationId
            };
            const sendHandshakeMetric = (page)=>{
                return (success, error)=>{
                    trackHandShakeMetric({
                        source: page,
                        success: success,
                        error: error
                    });
                    if (error) {
                        const handshakeError = error instanceof Error ? new Error(`Bridge handshake error: ${error.message}`) : new Error('Unknown bridge handshake error');
                        (0, $h48r4.captureAndReportError)({
                            error: handshakeError,
                            environment: environment,
                            errorExtensionDetails: errorExtensionDetails,
                            page: page,
                            tracing: tracing
                        });
                    }
                };
            };
            // Only forward when we're the gateway (FAUS). Product (e.g. forge-ui-kit adf-renderer) uses bridge directly.
            // TODO: isEmbeddedMacro prop can be removed after rollout of platform_forge_ui_refactor_macro_parent_type
            const isRenderedInFAUS = page === $4a17c08eaedb714c$export$c2bd95920a67f979;
            const embeddedMacroAdditionalForwardedData = {
                sourceAppId: appId,
                sourceInstallationId: extensionRef.current.installationId,
                sourceEnvironmentId: extensionRef.current.environmentId,
                extension: extensionRef.current,
                isEmbeddedMacroModal: true,
                extensionPayload: extensionPayloadRef.current,
                extensionData: extensionDataRef.current,
                embeddedMacroExtensionDetails: extensionDetails,
                embeddedMacroLocalId: localId
            };
            const withFausMessageForwarder = (methodName, bridgeMethodFn)=>{
                // Only forward when we're the gateway (FAUS). Product (e.g. forge-ui-kit adf-renderer) uses bridge directly.
                const isRenderedInFAUS = page === $4a17c08eaedb714c$export$c2bd95920a67f979;
                const shouldUseMessageForwarder = (0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? embeddedMacroParentType === 'CustomUI' : isEmbeddedMacro && isRenderedInFAUS;
                return shouldUseMessageForwarder ? (0, $iUEMs.createMessageForwarder)(methodName, embeddedMacroAdditionalForwardedData, $4a17c08eaedb714c$var$postRobotSend, embeddedParentLocalId, extensionDetails) : bridgeMethodFn;
            };
            // Only bodied macros should receive embedded macro messages
            const isBodiedMacro = layout === 'bodied';
            // Confluence embed card has the same origin as top level product
            const isNativeConfluenceEmbeddedCard = ()=>{
                try {
                    window.parent.location.href;
                    return true;
                } catch  {
                    return false;
                }
            };
            const isProductLevel = typeof window !== 'undefined' && (window.location.ancestorOrigins?.length === 0 || isNativeConfluenceEmbeddedCard()) && !isInModal;
            const { open: open } = $4a17c08eaedb714c$var$createIframeBridge({
                theme: initialThemeRef.current.theme,
                surfaceColor: initialThemeRef.current.surfaceColor,
                withDomain: origin,
                withWindow: iframeEl.contentWindow,
                metadata: {
                    env: environment,
                    module: type,
                    product: type.split(':')[0],
                    isFedRamp: (0, $jH9cM.isFedRamp)(),
                    localId: localId
                },
                features: (0, $kq02L.withMetricsAndAnalytics)({
                    features: {
                        invoke: async ({ data: data })=>{
                            const performanceStart = (0, $hjngh.getPerformanceMark)();
                            captureEvent({
                                type: 'resolver-invoke-initiated',
                                elapsed: performanceStart
                            });
                            const { onInvoke: onInvoke, onThreeLO: onThreeLO } = apiRef.current;
                            const result = await onInvoke(data);
                            if (result.type === '3lo') return new Promise((resolve, reject)=>{
                                onThreeLO(result.authUrl, ()=>{
                                    const performanceAuthEnd = (0, $hjngh.getPerformanceMark)();
                                    return onInvoke(data).then((res)=>{
                                        const performanceEnd = (0, $hjngh.getPerformanceMark)();
                                        captureEvent({
                                            type: 'resolver-invoked',
                                            duration: performanceEnd - performanceStart,
                                            authDuration: performanceAuthEnd - performanceStart,
                                            elapsed: performanceEnd
                                        });
                                        if (res.type === 'ok') {
                                            if (!!data.metadata && (0, $iDrrr.fg)('forge-ui-return-invocation-metadata')) {
                                                const optsInToRateLimitProperties = data.metadata?.rateLimitProperties === true;
                                                resolve({
                                                    body: res.response,
                                                    metadata: {
                                                        ...optsInToRateLimitProperties ? {
                                                            rateLimitProperties: res.metadata?.rateLimitProperties ?? null
                                                        } : {}
                                                    }
                                                });
                                            } else resolve(res.response);
                                        }
                                        // Unexpected case where 3LO consent requested again after consenting
                                        reject();
                                    }, reject);
                                });
                            });
                            const performanceEnd = (0, $hjngh.getPerformanceMark)();
                            captureEvent({
                                type: 'resolver-invoked',
                                duration: performanceEnd - performanceStart,
                                authDuration: 0,
                                elapsed: performanceEnd
                            });
                            if (result.type === 'err') throw new Error(result.message);
                            if (!!data.metadata && (0, $iDrrr.fg)('forge-ui-return-invocation-metadata')) {
                                const optsInToRateLimitProperties = data.metadata?.rateLimitProperties === true;
                                return {
                                    body: result.response,
                                    metadata: {
                                        ...optsInToRateLimitProperties ? {
                                            rateLimitProperties: result.metadata?.rateLimitProperties ?? null
                                        } : {}
                                    }
                                };
                            }
                            return result.response;
                        },
                        initFeatureFlags: async ({ data: data })=>{
                            if (!(0, $iDrrr.fg)('platform_forge_ff_client_sdk')) return {};
                            const { onInitFeatureFlags: onInitFeatureFlags } = apiRef.current;
                            const result = await onInitFeatureFlags(data);
                            if ((0, $iDrrr.fg)('platform_forge_ff_ui_analytics')) trackForgeFeatureFlagEvent({
                                appType: appType,
                                appId: appId,
                                baseUrl: window.location.origin,
                                eventType: (0, $9ytZz.FeatureFlagEventTypes).INITIALIZATION,
                                success: result.type !== 'err',
                                featureFlagEnv: data.user?.statsigEnvironment?.tier || (0, $9ytZz.FeatureFlagEnv).development,
                                forgeEnvironment: environmentType
                            });
                            if (result.type === 'err') return {};
                            return result.response;
                        },
                        emitFrontendCustomMetric: async ({ data: data })=>{
                            if (!(0, $iDrrr.fg)('platform_forge_frontend_custom_metrics')) return;
                            try {
                                await apiRef.current.onEmitFrontendCustomMetric?.(data);
                            } catch  {
                            // Silent fail: emitting a metric must never surface an error to the app.
                            }
                        },
                        emitFrontendLogs: async ({ data: data })=>{
                            if (!(0, $iDrrr.fg)('platform_forge_frontend_logs')) return;
                            try {
                                await apiRef.current.onEmitFrontendLogs?.(data);
                            } catch  {
                            // Silent fail: emitting logs must never surface an error to the app.
                            }
                        },
                        trackFeatureFlagEvent: async ({ data: data })=>{
                            if (!(0, $iDrrr.fg)('platform_forge_ff_ui_analytics')) return;
                            const allowedEventTypes = [
                                (0, $9ytZz.FeatureFlagEventTypes).CHECKFLAG.toUpperCase()
                            ];
                            try {
                                // basic validations
                                if (!data.type || !allowedEventTypes.includes(data.type.toUpperCase())) return;
                                if (data.type.toUpperCase() === (0, $9ytZz.FeatureFlagEventTypes).CHECKFLAG.toUpperCase() && data.properties.name && (data.properties.name.length < 3 || data.properties.name.length > 50)) return;
                                if (typeof data.properties.success !== 'boolean') return;
                                if (!(data.properties.environment && data.properties.environment.toLowerCase() in (0, $9ytZz.FeatureFlagEnv))) return;
                                trackForgeFeatureFlagEvent({
                                    appType: appType,
                                    appId: appId,
                                    baseUrl: window.location.origin,
                                    flagName: data.properties.name || '',
                                    eventType: data.type,
                                    success: data.properties.success,
                                    featureFlagEnv: data.properties.environment,
                                    forgeEnvironment: environmentType
                                });
                            } catch  {
                            // all errors are ignored
                            }
                            return;
                        },
                        'iframe-analytics': async ({ data: data })=>{
                            captureUntrustedEvent(data);
                        },
                        'ufo-event': async ({ data: data })=>{
                            captureUntrustedEvent(data);
                        },
                        getUrl: async ({ data: data })=>{
                            if (data.target) {
                                const path = await (0, $ixV18.createNavigateTargetPath)(data, {
                                    getContext: apiRef.current.getContext,
                                    getAppForgeUIExtensions: getAppForgeUIExtensions
                                });
                                if (!path) return null;
                                // If the current domain is a custom domain, we need to request for the base url
                                const baseUrl = (0, $8j9ei.isCustomDomain)(window.location.hostname) ? await getBaseUrl() : window.location.origin;
                                // `getUrl` from `@forge/bridge` will return a URL object.
                                // We are returning a string here as a URL object will serialised into a string when being passed across the bridge
                                return `${baseUrl}${path}`;
                            }
                            return null;
                        },
                        navigate: withFausMessageForwarder('navigate', async ({ data: data })=>{
                            // If a NavigationLocation object was provided:
                            if ('target' in data && data.target) {
                                const path = await (0, $ixV18.createNavigateTargetPath)(data, {
                                    getContext: apiRef.current.getContext,
                                    getAppForgeUIExtensions: getAppForgeUIExtensions
                                });
                                if (!path) {
                                    // eslint-disable-next-line no-console
                                    console.warn('Path was not found for the parameters provided');
                                    return;
                                }
                                // Request for the base url if the current domain is a custom domain
                                if ((0, $8j9ei.isCustomDomain)(window.location.hostname)) {
                                    const baseUrl = await getBaseUrl();
                                    return apiRef.current.onNavigate({
                                        type: data.type,
                                        url: `${baseUrl}${path}`
                                    });
                                } else return apiRef.current.onNavigate({
                                    type: data.type,
                                    url: path
                                });
                            }
                            return apiRef.current.onNavigate(data);
                        }),
                        reconcile: async ({ data: data })=>{
                            return apiRef.current.reconcile(data);
                        },
                        onError: async ({ data: data })=>{
                            return apiRef.current.onError(data);
                        },
                        reload: withFausMessageForwarder('reload', async ()=>{
                            (0, $bSxWl.reload)();
                        }),
                        refresh: async ()=>{
                            return apiRef.current.refresh();
                        },
                        // WARNING — BAD PAYLOAD SHAPE FOR V2 (do not replicate for new bridge methods)
                        //
                        // The handlers below (`submit`, `onClose`, `close`, `openModal`) incorrectly pass
                        // the raw port-rpc event object `{ data: payload }` to `apiRef.current.*` instead
                        // of the unwrapped `payload` directly. This means product-side `BridgeConfig`
                        // callbacks receive `{ data: payload }` and must access `opts.data` to get the
                        // actual value — a leaky abstraction.
                        //
                        // New bridge methods should follow the pattern used by `fetchProduct`/`fetchRemote`/`reconcile`
                        // below: destructure `{ data }` from the port-rpc event and pass `data` directly
                        // to `apiRef.current.*`. The v2 bridge path (`bridge-config-delegates.ts`) already
                        // re-wraps these specific keys as `{ data: payload }` to maintain backward
                        // compatibility with existing product callbacks.
                        //
                        // Do NOT copy this pattern for new bridge methods.
                        submit: async (payload)=>{
                            return apiRef.current.submit(payload);
                        },
                        open: withFausMessageForwarder('open', async ()=>{
                            return apiRef.current.open();
                        }),
                        onClose: async (payload)=>{
                            return apiRef.current.onClose(payload);
                        },
                        close: async (payload)=>{
                            return apiRef.current.close(payload);
                        },
                        emitReadyEvent: withFausMessageForwarder('emitReadyEvent', async ()=>{
                            captureEvent({
                                type: 'emit-ready-event',
                                elapsed: (0, $hjngh.getPerformanceMark)()
                            });
                            return apiRef.current.emitReadyEvent();
                        }),
                        getContext: ()=>{
                            return apiRef.current.getContext();
                        },
                        openModal: withFausMessageForwarder('openModal', async (payload)=>{
                            return apiRef.current.openModal(payload);
                        }),
                        createHistory: async ()=>{
                            return apiRef.current.createHistory();
                        },
                        fetchProduct: async ({ data: data })=>{
                            return apiRef.current.fetchProduct(data);
                        },
                        fetchRemote: async ({ data: data })=>{
                            return apiRef.current.fetchRemote(data);
                        },
                        showFlag: withFausMessageForwarder('showFlag', async ({ data: data })=>{
                            const flagActions = data.actions?.map((action)=>{
                                const { onClick: onClick } = action;
                                return {
                                    ...action,
                                    onClick: onClick ? ()=>onClick() : ()=>{}
                                };
                            });
                            return apiRef.current.showFlag({
                                ...data,
                                actions: flagActions
                            });
                        }),
                        closeFlag: withFausMessageForwarder('closeFlag', async ({ data: data })=>apiRef.current.closeFlag(data)),
                        on: async (payload)=>{
                            const { event: event, callback: callback } = payload.data;
                            const subscription = (0, $1uMa2.on)(event, callback, extensionDetails);
                            eventCallbacksRef.current.push(subscription);
                            return {
                                unsubscribe: ()=>{
                                    eventCallbacksRef.current.splice(eventCallbacksRef.current.indexOf(subscription), 1);
                                    subscription.unsubscribe();
                                }
                            };
                        },
                        onPublic: async (payload)=>{
                            const { event: event, callback: callback } = payload.data;
                            const subscription = (0, $1uMa2.onPublic)(event, callback, extensionDetails);
                            eventCallbacksRef.current.push(subscription);
                            return {
                                unsubscribe: ()=>{
                                    eventCallbacksRef.current.splice(eventCallbacksRef.current.indexOf(subscription), 1);
                                    subscription.unsubscribe();
                                }
                            };
                        },
                        emitPublic: async (payload)=>{
                            return apiRef.current.emitPublic?.(payload.data);
                        },
                        emit: withFausMessageForwarder('emit', async (payload)=>{
                            return (0, $1uMa2.emit)(payload.data.event, payload.data.payload, payload.data.embeddedMacroExtensionDetails || extensionDetails);
                        }),
                        enableTheming: async ()=>{
                            await enableThemingRef.current?.();
                            const currentTheme = (0, $gqUuL.getGlobalTheme)();
                            const surfaceColor = null;
                            setThemeRef.current?.(currentTheme, surfaceColor, environment);
                        },
                        changeWindowTitle: async ({ data: data })=>{
                            apiRef.current.changeWindowTitle(data);
                        },
                        getFrameId: async ()=>{
                            return apiRef.current.getFrameId();
                        },
                        getFrameDispatch: async ()=>{
                            return apiRef.current.getFrameDispatch();
                        },
                        subscribeRealtimeChannel: async (payload)=>{
                            return apiRef.current.subscribeRealtimeChannel?.(payload);
                        },
                        publishRealtimeChannel: async (payload)=>{
                            return apiRef.current.publishRealtimeChannel?.(payload);
                        },
                        openRovo: withFausMessageForwarder('openRovo', async ({ data: data })=>{
                            return apiRef.current.openRovo?.(data);
                        }),
                        requestTeamworkGraph: async ({ data: data })=>{
                            return (0, $iDrrr.fg)('forge-ui-enable-requestteamworkgraph-bridge-method') ? apiRef.current.requestTeamworkGraph?.(data) : undefined;
                        },
                        fetchUserRecommendations: async ({ data: data })=>{
                            return (0, $iDrrr.fg)('forge-ui-fetch-user-recommendations-bridge-method') ? apiRef.current.fetchUserRecommendations?.(data) : undefined;
                        },
                        isRovoEnabled: withFausMessageForwarder('isRovoEnabled', async ()=>{
                            if (!cloudId) return false;
                            return (0, $dNEbC.getIsRovoEnabled)({
                                cloudId: cloudId,
                                relayEnvironment: relayEnvironment
                            });
                        }),
                        trackObjectStoreAction: async ({ data: data })=>{
                            trackObjectStoreAction({
                                appType: appType,
                                appId: appId,
                                action: data.action,
                                forgeEnvironment: environmentType
                            });
                        },
                        ...(0, $llM9z.getUseBridgePermissionFunctions)(apiRef),
                        ...$4a17c08eaedb714c$var$mapCustomBridgeMethods({
                            customBridgeMethods: customBridgeMethodsRef.current,
                            isUIKitEmbeddedMacro: (0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? embeddedMacroParentType === 'UIKit' : isEmbeddedMacro && !isRenderedInFAUS,
                            embeddedMacroLocalId: localId,
                            withFausMessageForwarder: withFausMessageForwarder
                        })
                    },
                    page: page,
                    environment: environment,
                    forgeEnvironment: environmentType,
                    errorExtensionDetails: errorExtensionDetails,
                    createAnalyticsEvent: createAnalyticsEvent,
                    tracing: tracing
                }),
                sendHandshakeMetric: sendHandshakeMetric(page),
                shouldReceiveEmbeddedMacroMessages: isBodiedMacro && isProductLevel
            });
            if (isResizable) {
                const isInNonJSMResizableModal = isInModal && !type?.startsWith('jiraServiceManagement');
                const isInInlineMacro = layout === 'inline' && type === $4a17c08eaedb714c$var$MACRO_MODULE_NAME;
                (0, $6Rin8.iframeResizer)({
                    heightCalculationMethod: 'bodyScroll',
                    widthCalculationMethod: 'bodyScroll',
                    scrolling: true,
                    // @ts-ignore minHeight can be a string
                    minHeight: height,
                    sizeWidth: isInNonJSMResizableModal || isInInlineMacro,
                    initCallback: (iframe)=>{
                        iframe?.iFrameResizer?.resize();
                    }
                }, iframeEl);
            }
            const { close: close, enableTheming: enableTheming, setTheme: setTheme } = open();
            setThemeRef.current = setTheme;
            enableThemingRef.current = enableTheming;
            // this tracking is to identify re-initializations of the bridge, which should never happen (or we should try avoid)
            // during the lifecycle of a Forge app. re-initialise bridge could be expensive and error prone (losing existing event subscriptions, etc)
            trackBridgeReinited();
            return ()=>{
                close?.(); // close may be undefined here if createIframeBridge call fails
                iframeEl?.iFrameResizer && iframeEl?.iFrameResizer.removeListeners();
            };
        }
    // We intentionally add react-hooks/exhaustive-deps disable here, so that we don't blindly
    // add new dependencies without considering the impact of re-creating the bridge.
    // The following dependencies are excluded for the reasons stated:
    //   - trackBridgeReinited - it's memoised and used for observability and should not trigger bridge recreation
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getBaseUrl,
        iframeRef,
        origin,
        loading,
        page,
        isResizable,
        height,
        environment,
        errorExtensionDetails,
        id,
        layout,
        type,
        environmentType,
        installationId,
        tracing,
        createAnalyticsEvent,
        loadedAt,
        getAppForgeUIExtensions,
        appType,
        captureEvent,
        captureUntrustedEvent,
        appId,
        trackForgeFeatureFlagEvent,
        trackObjectStoreAction,
        isInModal,
        localId,
        isEmbeddedMacro,
        embeddedMacroParentType,
        embeddedParentLocalId
    ]);
    // [WARN] Please take careful consideration when adding new dependencies to the above useEffect.
    // createIframeBridge is expensive to call and re-creating the bridge could lead to lost event subscriptions.
    // - Try to avoid adding dependencies that could change on every render (e.g. objects or functions defined inline).
    // - If you need to add a function, consider wrapping it in useCallbackOne / useRef / useMemoOne to stabilise the reference.
    // - Please ensure multiple revewers in the Forge UI team review and approve the change.
    // - As the standard lint for dependency array is disabled, please ensure the dependency array is kept up to date with necessary dependencies.
    return {
        loading: loading,
        iframeProps: {
            ref: iframeRef,
            onLoad: ()=>{
                onLoad && onLoad();
                setLoading(false);
                setLoadedAt(Date.now());
            }
        }
    };
};
module.exports["BridgeClientError"] = $4a17c08eaedb714c$export$d86296fe47e644cc;
module.exports["useBridge"] = $4a17c08eaedb714c$export$23a7a1286dcfa590;

});

parcelRegister("4POBX", function(module, exports) {
const $42c7df34509a91b0$export$462dc93a327ffa44 = new Set([
    '11995cbf-629c-4d90-890c-7fdd0ed69c49',
    '094945a8-4d32-4f0f-8ab9-76245e467a82',
    '60add9ed-404d-42e8-8301-b659329d4ad0',
    '90b44d4a-14b7-4501-bd2c-5fe4a3fbc4e0',
    '11995cbf-629c-4d90-890c-7fdd0ed69c46',
    '326a35e4-bcbf-4c3e-886b-7e34b32f0c1b'
]);
const $42c7df34509a91b0$var$POPUP_WIDTH = 480;
const $42c7df34509a91b0$var$POPUP_HEIGHT = 720;
function $42c7df34509a91b0$var$getCenteredPopupWindowFeatures() {
    const left = Math.max(0, Math.round((window.screen.availWidth - $42c7df34509a91b0$var$POPUP_WIDTH) / 2));
    const top = Math.max(0, Math.round((window.screen.availHeight - $42c7df34509a91b0$var$POPUP_HEIGHT) / 2));
    return `popup,width=${$42c7df34509a91b0$var$POPUP_WIDTH},height=${$42c7df34509a91b0$var$POPUP_HEIGHT},left=${left},top=${top},noopener,noreferrer`;
}
function $42c7df34509a91b0$export$ff7962acd6052c28(url, type, push, appId, openNewTabAsPopupWindow) {
    switch(type){
        case 'new-tab':
            {
                // Popup sizing is opt-in per host surface: a dialog-embedded app keeps the
                // user anchored to the dialog, whereas a full-page host has no such need.
                const usePopupSizedWindow = !!openNewTabAsPopupWindow && !!appId && $42c7df34509a91b0$export$462dc93a327ffa44.has(appId);
                window.open(url, '_blank', usePopupSizedWindow ? $42c7df34509a91b0$var$getCenteredPopupWindowFeatures() : 'noopener noreferrer');
                break;
            }
        case 'same-tab':
            if (push) push(url);
            else window.location.href = url;
            break;
    }
}
module.exports["navigate"] = $42c7df34509a91b0$export$ff7962acd6052c28;

});

parcelRegister("jQNFO", function(module, exports) {
const $d7322cde7b08dc73$export$5a759dc7a1cfb72a = ()=>{
    return window.location.origin;
};
module.exports["getOrigin"] = $d7322cde7b08dc73$export$5a759dc7a1cfb72a;

});

parcelRegister("4El6d", function(module, exports) {

var $jQNFO = parcelRequire("jQNFO");

const $725ddc48720accc3$var$emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Filters out all parameters that may be used for malicious purposes such as attaching local files or adding bcc recipients
// Only subject and body are allowed
const $725ddc48720accc3$var$filterMailtoParams = (mailtoLink)=>{
    try {
        const url = new URL(mailtoLink);
        const params = url.searchParams;
        const email = url.pathname;
        let newParams = '';
        if (!$725ddc48720accc3$var$emailRegex.test(email)) // throw empty error for makeUrl to catch
        throw new Error();
        if (params.has('subject')) newParams += 'subject=' + encodeURIComponent(params.get('subject') || '');
        if (params.has('body')) {
            newParams += newParams ? '&body=' : 'body=';
            newParams += encodeURIComponent(params.get('body') || '');
        }
        return `${url.protocol}${email}` + (newParams ? '?' + newParams : '');
    } catch (error) {
        // throw empty error for makeUrl to catch
        throw new Error();
    }
};
function $725ddc48720accc3$export$e98ca45c96b2aafe(urlString) {
    try {
        if (urlString.startsWith('mailto:')) return new URL($725ddc48720accc3$var$filterMailtoParams(urlString));
        if (urlString.startsWith('tel:')) // For telephone links, we just return the URL as is
        return new URL(urlString);
        // Check if URL starts with a custom URL scheme (e.g., forge:\\, spotify:, etc.)
        const customURLSchemeRegex = /^[a-zA-Z]+:(\\\\)?/;
        if (customURLSchemeRegex.test(urlString)) return new URL(urlString);
        // We decode the URL string to handle cases where a malicious app might pass in a URL with encoded characters to bypass our egress checks
        const decodedUrlString = decodeURIComponent(urlString);
        const fullUrl = decodedUrlString.startsWith('/') ? `${(0, $jQNFO.getOrigin)()}${urlString}` : urlString;
        // Checks if `fullUrl` has a protocol(eg. http://, https://, etc), if not, add the `https://` protocol
        const protocolRegex = /^(.*?:\/\/)/;
        const urlWithProtocol = protocolRegex.test(fullUrl) ? fullUrl : `https://${fullUrl}`;
        // We use the URL constructor to validate the URL
        const url = new URL(urlWithProtocol);
        return url;
    } catch  {
        return undefined;
    }
}
module.exports["makeUrl"] = $725ddc48720accc3$export$e98ca45c96b2aafe;

});

parcelRegister("eKJPK", function(module, exports) {
// domains from https://support.atlassian.com/organization-administration/docs/ip-addresses-and-domains-for-atlassian-cloud-products/
const $20fd9f1a390b6d3c$export$bbc6c05835b799fc = [
    'atl-paas.net',
    'atlassian.com',
    'atlassian.net',
    'ss-inf.net',
    'jira.com',
    'bitbucket.org',
    'atlassian-us-gov-mod.com',
    'atlassian-us-gov-mod.net'
];
module.exports["TRUSTED_ROOT_DOMAINS"] = $20fd9f1a390b6d3c$export$bbc6c05835b799fc;

});

parcelRegister("b9C7C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fbwmZ = parcelRequire("fbwmZ");


$fbwmZ.__exportStar((parcelRequire("iBPxh")), module.exports);

});

parcelRegister("4AVLc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3tjju = parcelRequire("3tjju");


var $fXF7L = parcelRequire("fXF7L");


var $iyAN0 = parcelRequire("iyAN0");

const $f36df986612987d5$export$773a0bb3e5560a3d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { error: error, extension: extension } = props;
    if ((0, $iyAN0.isDeveloperSpaceError)(error ?? "")) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3tjju.ForgeDevSpaceErrorMessage), null);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    const t0 = error ?? "";
    let t1;
    if ($[1] !== extension || $[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fXF7L.ForgeDeprecationMessage), {
            error: t0,
            extension: extension
        });
        $[1] = extension;
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const { error: error, extension: extension } = props;
    if ((0, $iyAN0.isDeveloperSpaceError)(error ?? '')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3tjju.ForgeDevSpaceErrorMessage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fXF7L.ForgeDeprecationMessage), {
        error: error ?? '',
        extension: extension
    });
};
module.exports["ForgeAppErrorMessage"] = $f36df986612987d5$export$773a0bb3e5560a3d;

});

parcelRegister("iyAN0", function(module, exports) {
/**
 * Pure (React-free) error-type constants + classifier shared by the bridge layer
 * (`bridge/methods/core.ts`, `bridge/middleware/withErrorDisplay.ts`) and the React
 * error components in this folder. Kept free of component imports so the bridge
 * layer can classify errors without pulling React in.
 */ /** Backend `errorType` returned when a Forge app invokes a deprecated sandbox runtime. */ const $178cacc1a725de0b$export$22d69806bfc9e8c1 = 'INVALID_INVOCATION_RUNTIME_ERROR';
const $178cacc1a725de0b$var$DEVELOPER_SPACE_SETUP_INCOMPLETE = 'DEVELOPER_SPACE_SETUP_INCOMPLETE';
const $178cacc1a725de0b$var$MISSING_DEVELOPER_SPACE = 'MISSING_DEVELOPER_SPACE';
const $178cacc1a725de0b$var$DEVELOPER_SPACE_ERRORS = [
    $178cacc1a725de0b$var$DEVELOPER_SPACE_SETUP_INCOMPLETE,
    $178cacc1a725de0b$var$MISSING_DEVELOPER_SPACE
];
const $178cacc1a725de0b$export$8f341ade5f91f587 = (errorCode)=>{
    return $178cacc1a725de0b$var$DEVELOPER_SPACE_ERRORS.includes(errorCode);
};
const $178cacc1a725de0b$export$575b7edf2360f53e = (error)=>{
    return $178cacc1a725de0b$export$8f341ade5f91f587(error) || error === $178cacc1a725de0b$export$22d69806bfc9e8c1;
};
module.exports["SANDBOX_DEPRECATION_ERROR"] = $178cacc1a725de0b$export$22d69806bfc9e8c1;
module.exports["isDeveloperSpaceError"] = $178cacc1a725de0b$export$8f341ade5f91f587;
module.exports["shouldRenderForgeAppErrorMessage"] = $178cacc1a725de0b$export$575b7edf2360f53e;

});

parcelRegister("uWGCd", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $lCGo1 = parcelRequire("lCGo1");

function $66915a269e01b0e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $66915a269e01b0e3$var$AKSectionMessage = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("fD3vt")));

const $66915a269e01b0e3$var$SectionMessageAction = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("gsSr5")));
const $66915a269e01b0e3$var$textWrapCss = {
    name: "1089mxj",
    styles: "white-space:pre-wrap"
};
var $66915a269e01b0e3$var$_ref = {
    name: "1axjbqe",
    styles: "width:100%;ul{padding-left:0;}"
};
const $66915a269e01b0e3$var$ErrorPanel = ({ error: error, dispatch: dispatch, isReloadPage: isReloadPage })=>{
    const { message: message, errorDetails: errorDetails, errorMessage: errorMessage } = error;
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const intl = (0, $kSwu1.useIntl)();
    const reinitializeApp = async ()=>{
        if (isReloadPage) window.location.reload();
        setIsLoading(true);
        try {
            if (dispatch) await dispatch({
                type: 'render',
                extensionData: {}
            });
        } finally{
            setIsLoading(false);
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lCGo1.Loader), null);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: $66915a269e01b0e3$var$_ref
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($66915a269e01b0e3$var$AKSectionMessage, {
        appearance: "error",
        title: message,
        actions: [
            {
                key: 'refresh',
                text: intl.formatMessage(isReloadPage ? $66915a269e01b0e3$var$messages.reloadPage : $66915a269e01b0e3$var$messages.refreshApp),
                onClick: reinitializeApp
            }
        ].map(({ text: text, key: key, onClick: onClick })=>/*#__PURE__*/ (0, $lOiVq.jsx)($66915a269e01b0e3$var$SectionMessageAction, {
                key: key,
                onClick: onClick
            }, text))
    }, errorMessage && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $iMnC5.Box), {
        xcss: $66915a269e01b0e3$var$textWrapCss
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4aRua.Text), {
        as: "p"
    }, errorMessage)), errorDetails && /*#__PURE__*/ (0, $lOiVq.jsx)("pre", {
        css: $66915a269e01b0e3$var$textWrapCss
    }, errorDetails)));
};
var $66915a269e01b0e3$export$2e2bcd8739ae039 = $66915a269e01b0e3$var$ErrorPanel;
const $66915a269e01b0e3$export$1fe699079d0f690f = ({ forgeDoc: forgeDoc, dispatch: dispatch })=>{
    const { error: error } = forgeDoc.props;
    return /*#__PURE__*/ (0, $lOiVq.jsx)($66915a269e01b0e3$var$ErrorPanel, {
        key: "error",
        error: error,
        dispatch: dispatch
    });
};
const $66915a269e01b0e3$var$messages = (0, $kSwu1.defineMessages)({
    refreshApp: {
        id: "confluence.error.panel.refresh.app",
        defaultMessage: "Refresh app"
    },
    reloadPage: {
        id: "confluence.error.panel.reload.page",
        defaultMessage: "Reload page"
    }
});
module.exports["default"] = $66915a269e01b0e3$export$2e2bcd8739ae039;

});

parcelRegister("fQ6eZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");


var $iDrrr = parcelRequire("iDrrr");

// Read via the useForgeUIRuntime hook, not directly.
const $0fe4b76e88111189$var$ForgeUIRuntimeContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $0fe4b76e88111189$export$63eb6a8e3cf9ab23 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($0fe4b76e88111189$var$ForgeUIRuntimeContext);
} : ()=>(0, $cozmU.useContext)($0fe4b76e88111189$var$ForgeUIRuntimeContext);
const $0fe4b76e88111189$export$7b0cb68140ccacd4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { runtime: runtime, children: children } = t0;
    if (!(0, $iDrrr.fg)("forge-ui-bridge-core-reset")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== runtime) {
        t1 = {
            forgeUIAttributes: {
                runtime: runtime
            }
        };
        $[2] = runtime;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: t1
        }, children);
        $[4] = children;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== runtime || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0fe4b76e88111189$var$ForgeUIRuntimeContext.Provider, {
            value: runtime
        }, t2);
        $[7] = runtime;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ runtime: runtime, children: children })=>{
    // Gate the attribute on the bridge-core v2 rollout: only emit `runtime` once
    // `forge-ui-bridge-core-reset` is on, leaving legacy v1 analytics untouched.
    if (!(0, $iDrrr.fg)('forge-ui-bridge-core-reset')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0fe4b76e88111189$var$ForgeUIRuntimeContext.Provider, {
        value: runtime
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: {
            forgeUIAttributes: {
                runtime: runtime
            }
        }
    }, children));
};
module.exports["useForgeUIRuntime"] = $0fe4b76e88111189$export$63eb6a8e3cf9ab23;
module.exports["ForgeUIRuntimeAnalyticsContext"] = $0fe4b76e88111189$export$7b0cb68140ccacd4;

});

parcelRegister("9oYqV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $6M43m = parcelRequire("6M43m");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $1VhsF = parcelRequire("1VhsF");


var $kSwu1 = parcelRequire("kSwu1");


var $iGKcz = parcelRequire("iGKcz");


var $gDqww = parcelRequire("gDqww");

/**
 * This message is displayed when a forge custom field is using a deprecated modal experience for rendering on the Jira issue view.
 * It is displayed in a modal dialog and is not dismissible.
 * It is one of the steps related to the deprecation of the modal experience which was decided here:
 * https://hello.atlassian.net/wiki/spaces/Ditto/pages/5092641172/DACI+-+Modal+experience+for+the+Forge+custom+fields+on+issue+view+clean-up?focusedCommentId=5111022370
 */ const $632bef4e53964394$var$ForgeModalDeprecationMessageInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(11);
    const { extension: extension } = props;
    const t0 = extension?.id || "";
    let t1;
    if ($[0] !== t0) {
        t1 = {
            id: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        "atl-attribution": (0, $iGKcz.createAtlAttributionHeader)()
                    }
                }
            }
        };
        $[2] = t2;
    } else t2 = $[2];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $6M43m.default), t1, t2);
    const intl = (0, $kSwu1.useIntl)();
    let t3;
    if ($[3] !== intl) {
        t3 = intl.formatMessage($632bef4e53964394$var$messages.title);
        $[3] = intl;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== data.app?.name || $[6] !== intl) {
        t4 = intl.formatMessage($632bef4e53964394$var$messages.message, {
            appName: data.app?.name
        });
        $[5] = data.app?.name;
        $[6] = intl;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: t3,
            appearance: "error"
        }, t4);
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : (props)=>{
    const { extension: extension } = props;
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $6M43m.default), {
        id: extension?.id || ''
    }, {
        networkCacheConfig: {
            metadata: {
                headers: {
                    'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)()
                }
            }
        }
    });
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: intl.formatMessage($632bef4e53964394$var$messages.title),
        appearance: "error"
    }, intl.formatMessage($632bef4e53964394$var$messages.message, {
        appName: data.app?.name
    }));
};
const $632bef4e53964394$var$ForgeModalDeprecationMessageFallback = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    const intl = (0, $kSwu1.useIntl)();
    const appName = props.extension?.properties.title;
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($632bef4e53964394$var$messages.title);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== appName || $[3] !== intl) {
        t1 = intl.formatMessage($632bef4e53964394$var$messages.message, {
            appName: appName
        });
        $[2] = appName;
        $[3] = intl;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: t0,
            appearance: "error"
        }, t1);
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (props)=>{
    const intl = (0, $kSwu1.useIntl)();
    const appName = props.extension?.properties.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: intl.formatMessage($632bef4e53964394$var$messages.title),
        appearance: "error"
    }, intl.formatMessage($632bef4e53964394$var$messages.message, {
        appName: appName
    }));
};
const $632bef4e53964394$export$5b67d59ebd4f147c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($632bef4e53964394$var$ForgeModalDeprecationMessageFallback, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const fallback = t0;
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($632bef4e53964394$var$ForgeModalDeprecationMessageInner, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== fallback || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gDqww.RelaySuspensefulBoundary), {
            fallback: fallback,
            errorFallback: fallback
        }, t1);
        $[4] = fallback;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (props)=>{
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($632bef4e53964394$var$ForgeModalDeprecationMessageFallback, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gDqww.RelaySuspensefulBoundary), {
        fallback: fallback,
        errorFallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($632bef4e53964394$var$ForgeModalDeprecationMessageInner, props));
};
const $632bef4e53964394$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "forge.modal.deprecation.title",
        defaultMessage: "Update your app"
    },
    message: {
        id: "forge.modal.deprecation.message",
        defaultMessage: "Your app {appName} uses the deprecated modal editing experience for custom fields, which is being phased out. Please have your system admin update the app to use inline editing instead. If issues remain, contact the app developer."
    }
});
module.exports["ForgeModalDeprecationMessage"] = $632bef4e53964394$export$5b67d59ebd4f147c;

});

parcelRegister("f3Db5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $fEPJS = parcelRequire("fEPJS");


var $9ytZz = parcelRequire("9ytZz");

const $5512fc36042caee0$var$sizeStyles = {
    small: "_0bjKvDzXzM _0jFU0VxGtS _4kiQYAsz7G _0KLXruoI2d",
    medium: "_0bjKvDzXzM _0jFU0VRTEh _4kiQYAxf28 _0KLXruoI2d",
    large: "_0bjKvDzXzM _0jFU0VBM7N _4kiQYA5m2b _0KLXruoI2d",
    xlarge: "_0bjKvDzXzM _0jFU0V3DHH _4kiQYAUMig _0KLXruoI2d",
    max: "_0bjKvDzXzM _0jFU0VN91d _0KLXruoI2d",
    fullscreen: "_0jFU0VN91d _0KLXruoI2d",
    resizable: "_4bt5LAIZbP _2WAcuGIZbP _0bjKvDzXzM _4ouGXIHakr _1EqgXlw4ra _4kiQYAsz7G _0NUa3rN91d _39xV02IZbP _0jFU0VIZbP _3iDTPbQ4SZ _0aFT5vbt8w _0KLXruoI2d"
};
const $5512fc36042caee0$var$resizableStyles = {
    jsmModal: "_4bt5LAIZbP _2WAcuGIZbP _0jFU0VIZbP",
    namedSize: "_4bt5LAIZbP _2WAcuGIZbP _0jFU0VIZbP",
    default: "_4bt5LAIZbP _2WAcuGIZbP _0bjKvDzXzM _4ouGXIHakr _1EqgXlw4ra _4kiQYAsz7G _0NUa3rN91d _39xV02IZbP _0jFU0VIZbP _3iDTPbQ4SZ _0aFT5vbt8w _0KLXruoI2d"
};
const $5512fc36042caee0$var$namedSizes = new Set(Object.keys($5512fc36042caee0$var$sizeStyles));
const $5512fc36042caee0$export$a6d6b74199964ee4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { children: children, size: size, styles: styles, isResizable: isResizable, isJsmModule: isJsmModule } = t0;
    const namedSizeKey = $5512fc36042caee0$var$namedSizes.has(size) ? size : null;
    if (!namedSizeKey) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    if (isJsmModule) {
        const supportsJsmResizable = isResizable && namedSizeKey !== "max" && namedSizeKey !== "fullscreen";
        const t1 = $5512fc36042caee0$var$sizeStyles[namedSizeKey];
        const t2 = supportsJsmResizable && $5512fc36042caee0$var$resizableStyles.jsmModal;
        let t3;
        if ($[2] !== t1 || $[3] !== t2) {
            t3 = (0, $hekY6.default)([
                t1,
                t2
            ]);
            $[2] = t1;
            $[3] = t2;
            $[4] = t3;
        } else t3 = $[4];
        let t4;
        if ($[5] !== children || $[6] !== styles || $[7] !== t3) {
            t4 = /*#__PURE__*/ $cozmU.createElement("div", {
                style: styles,
                className: t3
            }, children);
            $[5] = children;
            $[6] = styles;
            $[7] = t3;
            $[8] = t4;
        } else t4 = $[8];
        return t4;
    }
    const supportsResizable = isResizable && namedSizeKey !== "max" && namedSizeKey !== "fullscreen";
    const useFullResizableModalStyles = supportsResizable && namedSizeKey === "resizable";
    if (useFullResizableModalStyles) {
        const t1 = $5512fc36042caee0$var$sizeStyles[namedSizeKey];
        let t2;
        if ($[9] !== t1) {
            t2 = (0, $hekY6.default)([
                t1,
                $5512fc36042caee0$var$resizableStyles.default
            ]);
            $[9] = t1;
            $[10] = t2;
        } else t2 = $[10];
        let t3;
        if ($[11] !== children || $[12] !== styles || $[13] !== t2) {
            t3 = /*#__PURE__*/ $cozmU.createElement("div", {
                style: styles,
                className: t2
            }, children);
            $[11] = children;
            $[12] = styles;
            $[13] = t2;
            $[14] = t3;
        } else t3 = $[14];
        return t3;
    }
    const t1 = $5512fc36042caee0$var$sizeStyles[namedSizeKey];
    const t2 = supportsResizable && $5512fc36042caee0$var$resizableStyles.namedSize;
    let t3;
    if ($[15] !== t1 || $[16] !== t2) {
        t3 = (0, $hekY6.default)([
            t1,
            t2
        ]);
        $[15] = t1;
        $[16] = t2;
        $[17] = t3;
    } else t3 = $[17];
    let t4;
    if ($[18] !== children || $[19] !== styles || $[20] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("div", {
            style: styles,
            className: t3
        }, children);
        $[18] = children;
        $[19] = styles;
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
} : ({ children: children, size: size, styles: styles, isResizable: isResizable, isJsmModule: isJsmModule })=>{
    const namedSizeKey = $5512fc36042caee0$var$namedSizes.has(size) ? size : null;
    if (!namedSizeKey) return /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, children);
     // Modals in JSM modules have only been resizable height-wise but not width wise.
    // We are unsure on the business context behind this, so maintain the existing styling in case we break something.
    // For JSM: apply resizableStyles to any non-max/non-fullscreen named size (existing behaviour).
    // For non-JSM: only apply resizableStyles when the size is explicitly 'resizable' — named sizes like
    // 'xlarge' must not have their fixed vh height overridden by resizableStyles (which sets height: auto).
    if (isJsmModule) {
        const supportsJsmResizable = isResizable && namedSizeKey !== 'max' && namedSizeKey !== 'fullscreen';
        return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        , {
            style: styles,
            className: (0, $hekY6.default)([
                $5512fc36042caee0$var$sizeStyles[namedSizeKey],
                supportsJsmResizable && $5512fc36042caee0$var$resizableStyles.jsmModal
            ])
        }, children);
    } // For the 'resizable' size, apply the full resizable modal styles.
    // For other named sizes, apply only the minimal overflow/height styles (matching pre-EXT-4856 behaviour).
    const supportsResizable = isResizable && namedSizeKey !== 'max' && namedSizeKey !== 'fullscreen';
    const useFullResizableModalStyles = supportsResizable && namedSizeKey === 'resizable';
    if (useFullResizableModalStyles) return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: styles,
        className: (0, $hekY6.default)([
            $5512fc36042caee0$var$sizeStyles[namedSizeKey],
            $5512fc36042caee0$var$resizableStyles.default
        ])
    }, children);
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: styles,
        className: (0, $hekY6.default)([
            $5512fc36042caee0$var$sizeStyles[namedSizeKey],
            supportsResizable && $5512fc36042caee0$var$resizableStyles.namedSize
        ])
    }, children);
};
const $5512fc36042caee0$export$ca177c112881662a = (modalSize)=>{
    if (modalSize === 'xlarge') return 'x-large';
    if (modalSize === 'max' || modalSize === 'fullscreen') return '100%';
    if (modalSize === 'resizable') return 'auto';
    return modalSize;
};
const $5512fc36042caee0$export$437c376ee7467324 = (extension)=>{
    return extension?.properties?.config?.icon ?? extension?.properties?.icon;
};
const $5512fc36042caee0$var$getHeight = ({ customDimensions: customDimensions, isResizableSize: isResizableSize, namedSize: namedSize, shouldFallbackFromFullscreen: shouldFallbackFromFullscreen })=>{
    if (customDimensions?.height) return customDimensions.height;
    if (isResizableSize) return 'auto';
    if (namedSize === 'max' || shouldFallbackFromFullscreen) return '100%';
    return undefined;
}; /**
    * Consolidates all modal dimension logic into one place.
    *
    * Priority for named size: modalWidthForMacroCustomConfig → size (string) → viewportSize → 'medium'
    * Priority for width: getModalWidth override → customDimensions.width → ADS named width
    * Priority for height: customDimensions.height → 'auto' (for isResizableSize) → '100%' (for max/fullscreen fallback) → undefined (ModalContentWrapper handles it)
    */ 
const $5512fc36042caee0$export$ad12395fd71244a5 = ({ size: size, getModalWidth: getModalWidth, shouldFallbackFromFullscreen: shouldFallbackFromFullscreen, isResizableSize: isResizableSize })=>{
    const hasCustomDimensions = !!size && (0, $9ytZz.isCustomDimensions)(size);
    const customDimensions = hasCustomDimensions ? size : undefined;
    const namedSize = size !== undefined && (0, $9ytZz.isNamedSize)(size) ? size : 'medium';
    const namedWidth = getModalWidth ? getModalWidth(namedSize) : $5512fc36042caee0$export$ca177c112881662a(namedSize);
    const resolvedWidth = customDimensions?.width ?? namedWidth;
    const width = shouldFallbackFromFullscreen ? '100%' : resolvedWidth;
    const height = $5512fc36042caee0$var$getHeight({
        customDimensions: customDimensions,
        isResizableSize: isResizableSize,
        namedSize: namedSize,
        shouldFallbackFromFullscreen: shouldFallbackFromFullscreen
    }); // When custom dimensions are provided, the <Modal> component is sized via explicit width/height props.
    // ModalContentWrapper must use 'max' (height: 100%) so the iframe fills the full modal height
    // rather than being constrained to a named size's fixed vh value (e.g. 'medium' = 40vh).
    const contentSize = customDimensions ? 'max' : namedSize;
    return {
        width: width,
        height: height,
        contentSize: contentSize
    };
};
module.exports["ModalContentWrapper"] = $5512fc36042caee0$export$a6d6b74199964ee4;
module.exports["getExtensionIcon"] = $5512fc36042caee0$export$437c376ee7467324;
module.exports["resolveModalDimensions"] = $5512fc36042caee0$export$ad12395fd71244a5;

});

parcelRegister("lAA41", function(module, exports) {

var $bLswh = parcelRequire("bLswh");

const $c6cce3f5ad0eaaba$export$cdf18e5be3e1a776 = new Set([
    (0, $bLswh.ConfluenceExtension).MACRO,
    (0, $bLswh.ConfluenceExtension).BYLINE
]);
module.exports["FULLSCREEN_SUPPORTED_EXTENSION_TYPES"] = $c6cce3f5ad0eaaba$export$cdf18e5be3e1a776;

});

parcelRegister("5cSJl", function(module, exports) {

var $bLswh = parcelRequire("bLswh");


var $jH9cM = parcelRequire("jH9cM");

const $d46fba3fdde88fe7$export$d86e18ec9052db2c = (productEnvironment)=>{
    if ((0, $jH9cM.isFedRamp)()) {
        if (productEnvironment === (0, $bLswh.ProductEnvironment).STAGING) return (0, $bLswh.ForgeCDNEnvironment).STAGING;
        else return (0, $bLswh.ForgeCDNEnvironment).PRODUCTION;
    }
    if (productEnvironment === (0, $bLswh.ProductEnvironment).DEVELOPMENT) return (0, $bLswh.ForgeCDNEnvironment).DEVELOPMENT;
    else if (productEnvironment === (0, $bLswh.ProductEnvironment).STAGING) return (0, $bLswh.ForgeCDNEnvironment).STAGING;
    else return (0, $bLswh.ForgeCDNEnvironment).PRODUCTION;
};
module.exports["getCDNEnvironment"] = $d46fba3fdde88fe7$export$d86e18ec9052db2c;

});

parcelRegister("fmh8m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fbwmZ = parcelRequire("fbwmZ");


$fbwmZ.__exportStar((parcelRequire("l1S8W")), module.exports);

$fbwmZ.__exportStar((parcelRequire("gq22v")), module.exports);

});

parcelRegister("3dDsm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $fgcBS = parcelRequire("fgcBS");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6SsN4 = parcelRequire("6SsN4");


var $kSwu1 = parcelRequire("kSwu1");


var $1CPZY = parcelRequire("1CPZY");


var $arQY7 = parcelRequire("arQY7");


var $2QrXF = parcelRequire("2QrXF");


var $jLnA6 = parcelRequire("jLnA6");


var $gDqww = parcelRequire("gDqww");

const $f2287014ad046eb3$var$containerStyle = null;
const $f2287014ad046eb3$var$messages = (0, $kSwu1.defineMessages)({
    unknownUser: {
        id: "confluence.user.unknown.user.message",
        defaultMessage: "Unknown User"
    }
});
const $f2287014ad046eb3$var$Avatar = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { name: name, picture: picture, hideDisplayName: hideDisplayName } = t0;
    if (hideDisplayName) {
        let t1;
        if ($[0] !== name || $[1] !== picture) {
            t1 = /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
                name: name,
                src: picture
            });
            $[0] = name;
            $[1] = picture;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_3uPjOfdnbC _446nnCjOvk _00clH718ZR"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== name || $[5] !== picture) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            name: name,
            src: picture
        });
        $[4] = name;
        $[5] = picture;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== name || $[8] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $2QrXF.default), {
            avatar: t2,
            primaryText: name
        });
        $[7] = name;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== t1 || $[11] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, t3);
        $[10] = t1;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ name: name, picture: picture, hideDisplayName: hideDisplayName })=>{
    if (hideDisplayName) return /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
        name: name,
        src: picture
    });
    return /*#__PURE__*/ $cozmU.createElement("div" // Reduce Atlaskit padding to vertically-align with other components
    , {
        className: (0, $hekY6.default)([
            "_3uPjOfdnbC _446nnCjOvk _00clH718ZR"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $2QrXF.default), {
        avatar: /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            name: name,
            src: picture
        }),
        primaryText: name
    }));
};
const $f2287014ad046eb3$var$UserInline = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UserInline(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl || $[1] !== name) {
        t1 = name || intl.formatMessage($f2287014ad046eb3$var$messages.unknownUser);
        $[0] = intl;
        $[1] = name;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $jLnA6.default), {
            appearance: "primary"
        }, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function UserInline({ name: name }) {
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $jLnA6.default), {
        appearance: "primary"
    }, name || intl.formatMessage($f2287014ad046eb3$var$messages.unknownUser));
};
const $f2287014ad046eb3$var$User = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { accountId: accountId, hideDisplayName: hideDisplayName } = t0;
    let t1;
    if ($[0] !== accountId) {
        t1 = {
            accountId: accountId
        };
        $[0] = accountId;
        $[1] = t1;
    } else t1 = $[1];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $fgcBS.default), t1);
    let t2;
    if ($[2] !== data?.user) {
        t2 = data?.user ?? {
            picture: "",
            name: ""
        };
        $[2] = data?.user;
        $[3] = t2;
    } else t2 = $[3];
    const { picture: picture, name: name } = t2;
    const { inline: inline } = (0, $1CPZY.useInlineContext)();
    if (!picture && !name) return null;
    if (inline) {
        let t3;
        if ($[4] !== name) {
            t3 = /*#__PURE__*/ $cozmU.createElement($f2287014ad046eb3$var$UserInline, {
                name: name
            });
            $[4] = name;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    let t3;
    if ($[6] !== hideDisplayName || $[7] !== name || $[8] !== picture) {
        t3 = /*#__PURE__*/ $cozmU.createElement($f2287014ad046eb3$var$Avatar, {
            name: name,
            picture: picture,
            hideDisplayName: hideDisplayName
        });
        $[6] = hideDisplayName;
        $[7] = name;
        $[8] = picture;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ accountId: accountId, hideDisplayName: hideDisplayName })=>{
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $fgcBS.default), {
        accountId: accountId
    });
    const { picture: picture, name: name } = data?.user ?? {
        picture: '',
        name: ''
    };
    const { inline: inline } = (0, $1CPZY.useInlineContext)();
    if (!picture && !name) return null;
    if (inline) return /*#__PURE__*/ $cozmU.createElement($f2287014ad046eb3$var$UserInline, {
        name: name
    });
    return /*#__PURE__*/ $cozmU.createElement($f2287014ad046eb3$var$Avatar, {
        name: name,
        picture: picture,
        hideDisplayName: hideDisplayName
    });
};
const $f2287014ad046eb3$export$4e4c41e4152a9f8a = ()=>{
    return function UserFnNext({ forgeDoc: { props: props } }) {
        const { accountId: accountId, hideDisplayName: hideDisplayName } = props;
        return /*#__PURE__*/ $cozmU.createElement((0, $gDqww.RelaySuspensefulBoundary), null, /*#__PURE__*/ $cozmU.createElement($f2287014ad046eb3$var$User, {
            accountId: accountId,
            hideDisplayName: hideDisplayName
        }));
    };
};
module.exports["makeUser"] = $f2287014ad046eb3$export$4e4c41e4152a9f8a;

});

parcelRegister("cJZA6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $4ej2P = parcelRequire("4ej2P");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $bcDqz = parcelRequire("bcDqz");


var $jLnA6 = parcelRequire("jLnA6");


var $1CPZY = parcelRequire("1CPZY");


var $6SsN4 = parcelRequire("6SsN4");


var $gDqww = parcelRequire("gDqww");

const $d2d2e9bf3fd5a641$export$fec8fa59b6e2a0db = (users, accountIds, intl)=>{
    // order should match accountIds
    return accountIds.map((key)=>{
        const { name: name = intl.formatMessage($d2d2e9bf3fd5a641$var$messages.unknownUserMessage), picture: picture = '' } = users[key] || {};
        return {
            key: key,
            name: name,
            src: picture
        };
    });
};
const $d2d2e9bf3fd5a641$export$7962e827ea8ac95f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { data: data } = t0;
    let t1;
    if ($[0] !== data) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
            appearance: "stack",
            data: data
        });
        $[0] = data;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ data: data })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
        appearance: "stack",
        data: data
    });
};
const $d2d2e9bf3fd5a641$export$d440bfe209149ca5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { data: data } = t0;
    const t1 = `+${data.length}`;
    let t2;
    if ($[0] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), null, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    return t2;
} : ({ data: data })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), null, `+${data.length}`);
};
const $d2d2e9bf3fd5a641$export$82c3b28526691c79 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { data: data } = t0;
    const end = Math.max(Math.min(8, data.length), 0);
    let hasMore;
    let more;
    let t1;
    if ($[0] !== data || $[1] !== end) {
        const shown = data.slice(0, end);
        more = data.slice(end);
        hasMore = more.length > 0;
        let t2;
        if ($[5] !== end || $[6] !== hasMore) {
            t2 = (t3, i)=>{
                const { name: name } = t3;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), {
                    appearance: "primary"
                }, name), hasMore || i !== end - 1 ? " " : null);
            };
            $[5] = end;
            $[6] = hasMore;
            $[7] = t2;
        } else t2 = $[7];
        t1 = shown.map(t2);
        $[0] = data;
        $[1] = end;
        $[2] = hasMore;
        $[3] = more;
        $[4] = t1;
    } else {
        hasMore = $[2];
        more = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[8] !== hasMore || $[9] !== more) {
        t2 = hasMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2d2e9bf3fd5a641$export$d440bfe209149ca5, {
            data: more
        }) : null;
        $[8] = hasMore;
        $[9] = more;
        $[10] = t2;
    } else t2 = $[10];
    let t3;
    if ($[11] !== t1 || $[12] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, t1, t2);
        $[11] = t1;
        $[12] = t2;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : ({ data: data })=>{
    const end = Math.max(Math.min(8, data.length), 0); // 4 would be the same as AvatarStack
    const shown = data.slice(0, end);
    const more = data.slice(end);
    const hasMore = more.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, shown.map(({ name: name }, i)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), {
            appearance: "primary"
        }, name), hasMore || i !== end - 1 ? ' ' : null);
    }), hasMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2d2e9bf3fd5a641$export$d440bfe209149ca5, {
        data: more
    }) : null);
};
// @ts-ignore setting z index to 0 so that the avatars do not overlap other components
const $d2d2e9bf3fd5a641$var$avatarStackWrapper = (0, $buxP3.xcss)({
    zIndex: 0,
    position: 'relative'
});
const $d2d2e9bf3fd5a641$export$2475c2afa469f7f7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { accountIds: accountIds } = t0;
    let t1;
    if ($[0] !== accountIds) {
        t1 = accountIds.filter($d2d2e9bf3fd5a641$var$_temp);
        $[0] = accountIds;
        $[1] = t1;
    } else t1 = $[1];
    const nonEmptyAccountIds = t1;
    let t2;
    if ($[2] !== nonEmptyAccountIds) {
        t2 = {
            accountIds: nonEmptyAccountIds
        };
        $[2] = nonEmptyAccountIds;
        $[3] = t2;
    } else t2 = $[3];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $4ej2P.default), t2);
    let users = {};
    if (data && data.users) users = data.users.reduce($d2d2e9bf3fd5a641$var$_temp2, {});
    const intl = (0, $kSwu1.useIntl)();
    const avatarStackData = $d2d2e9bf3fd5a641$export$fec8fa59b6e2a0db(users, accountIds, intl);
    const { inline: inline } = (0, $1CPZY.useInlineContext)();
    if (inline) {
        let t3;
        if ($[4] !== avatarStackData) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2d2e9bf3fd5a641$export$82c3b28526691c79, {
                data: avatarStackData
            });
            $[4] = avatarStackData;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    let t3;
    if ($[6] !== avatarStackData) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $d2d2e9bf3fd5a641$var$avatarStackWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2d2e9bf3fd5a641$export$7962e827ea8ac95f, {
            data: avatarStackData
        }));
        $[6] = avatarStackData;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ accountIds: accountIds })=>{
    const nonEmptyAccountIds = accountIds.filter((id)=>!(id === ''));
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $4ej2P.default), {
        accountIds: nonEmptyAccountIds
    });
    let users = {};
    if (data && data.users) users = data.users.reduce((prev, user)=>{
        if (user.accountId) prev[user.accountId] = {
            picture: user.picture,
            accountId: user.accountId,
            name: user.name
        };
        return prev;
    }, {});
    const intl = (0, $kSwu1.useIntl)();
    const avatarStackData = $d2d2e9bf3fd5a641$export$fec8fa59b6e2a0db(users, accountIds, intl);
    const { inline: inline } = (0, $1CPZY.useInlineContext)();
    if (inline) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2d2e9bf3fd5a641$export$82c3b28526691c79, {
        data: avatarStackData
    });
    return(// Each avatar in an avatar stack has a z index value applied.
    // Setting a container with a z index here to 0 so that the avatars do no overlap other components such as the Select menu
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $d2d2e9bf3fd5a641$var$avatarStackWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2d2e9bf3fd5a641$export$7962e827ea8ac95f, {
        data: avatarStackData
    })));
};
const $d2d2e9bf3fd5a641$export$6f1d3bf96df15c79 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] !== props.forgeDoc.children) {
        t0 = props.forgeDoc.children.map($d2d2e9bf3fd5a641$var$_temp3).filter($d2d2e9bf3fd5a641$var$_temp4);
        $[0] = props.forgeDoc.children;
        $[1] = t0;
    } else t0 = $[1];
    const accountIds = t0;
    let t1;
    if ($[2] !== accountIds) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gDqww.RelaySuspensefulBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2d2e9bf3fd5a641$export$2475c2afa469f7f7, {
            accountIds: accountIds
        }));
        $[2] = accountIds;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const accountIds = props.forgeDoc.children.map((child)=>{
        if (child.type !== 'User' && child.type !== 'Avatar') return '';
        const { props: props_0 } = child;
        const { accountId: accountId } = props_0;
        return accountId;
    }).filter((x)=>x);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gDqww.RelaySuspensefulBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2d2e9bf3fd5a641$export$2475c2afa469f7f7, {
        accountIds: accountIds
    }));
};
const $d2d2e9bf3fd5a641$var$messages = (0, $kSwu1.defineMessages)({
    unknownUserMessage: {
        id: "confluence.user.group.unknown.user.message",
        defaultMessage: "Unknown User"
    }
});
function $d2d2e9bf3fd5a641$var$_temp(id) {
    return !(id === "");
}
function $d2d2e9bf3fd5a641$var$_temp2(prev, user) {
    if (user.accountId) prev[user.accountId] = {
        picture: user.picture,
        accountId: user.accountId,
        name: user.name
    };
    return prev;
}
function $d2d2e9bf3fd5a641$var$_temp3(child) {
    if (child.type !== "User" && child.type !== "Avatar") return "";
    const { props: props_0 } = child;
    const { accountId: accountId } = props_0;
    return accountId;
}
function $d2d2e9bf3fd5a641$var$_temp4(x) {
    return x;
}
module.exports["UserGroup"] = $d2d2e9bf3fd5a641$export$6f1d3bf96df15c79;

});

parcelRegister("dGVOK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hjngh = parcelRequire("hjngh");


var $kogLA = parcelRequire("kogLA");


var $3nNWm = parcelRequire("3nNWm");


var $fFIqL = parcelRequire("fFIqL");

const $9d5b65c10836b7b5$export$1b708c663f12db29 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { isEnabled: isEnabled, viewportDimensions: viewportDimensions } = t0;
    const { captureEvent: captureEvent } = (0, $3nNWm.usePerformanceAnalytics)();
    const { containerRef: containerRef, height: height } = (0, $kogLA.useHeightObserver)();
    const isTrackingRef = (0, $cozmU.useRef)(true);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const timeoutId = setTimeout(()=>{
                isTrackingRef.current = false;
            }, (0, $fFIqL.PERFORMANCE_ANALYTICS_INTERVAL));
            return ()=>clearTimeout(timeoutId);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[2] !== captureEvent || $[3] !== height || $[4] !== isEnabled || $[5] !== viewportDimensions?.measuredHeight || $[6] !== viewportDimensions?.viewportHeight) {
        t3 = ()=>{
            if (height !== null && isEnabled && isTrackingRef.current) captureEvent({
                type: "resized",
                height: height,
                measuredHeight: viewportDimensions?.measuredHeight,
                viewportHeight: viewportDimensions?.viewportHeight,
                elapsed: (0, $hjngh.getPerformanceMark)()
            });
        };
        $[2] = captureEvent;
        $[3] = height;
        $[4] = isEnabled;
        $[5] = viewportDimensions?.measuredHeight;
        $[6] = viewportDimensions?.viewportHeight;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== captureEvent || $[9] !== height || $[10] !== isEnabled || $[11] !== viewportDimensions) {
        t4 = [
            height,
            isEnabled,
            captureEvent,
            viewportDimensions
        ];
        $[8] = captureEvent;
        $[9] = height;
        $[10] = isEnabled;
        $[11] = viewportDimensions;
        $[12] = t4;
    } else t4 = $[12];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[13] !== containerRef) {
        t5 = {
            containerRef: containerRef
        };
        $[13] = containerRef;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ isEnabled: isEnabled, viewportDimensions: viewportDimensions })=>{
    const { captureEvent: captureEvent } = (0, $3nNWm.usePerformanceAnalytics)();
    const { containerRef: containerRef, height: height } = (0, $kogLA.useHeightObserver)();
    const isTrackingRef = (0, $cozmU.useRef)(true);
    // Initialize tracking timeout on mount, clear on unmount
    (0, $cozmU.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            isTrackingRef.current = false;
        }, (0, $fFIqL.PERFORMANCE_ANALYTICS_INTERVAL));
        return ()=>clearTimeout(timeoutId);
    }, []);
    // Capture resize events when height changes and tracking is active
    (0, $cozmU.useEffect)(()=>{
        // Only capture if height is valid, feature is enabled, and we're still tracking
        if (height !== null && isEnabled && isTrackingRef.current) captureEvent({
            type: 'resized',
            height: height,
            measuredHeight: viewportDimensions?.measuredHeight,
            viewportHeight: viewportDimensions?.viewportHeight,
            elapsed: (0, $hjngh.getPerformanceMark)()
        });
    }, [
        height,
        isEnabled,
        captureEvent,
        viewportDimensions
    ]);
    return {
        containerRef: containerRef
    };
};
module.exports["useResizeAnalytics"] = $9d5b65c10836b7b5$export$1b708c663f12db29;

});

parcelRegister("kvlRh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3dDsm = parcelRequire("3dDsm");

var $h9K7i = parcelRequire("h9K7i");


var $8J8AQ = parcelRequire("8J8AQ");


var $cJZA6 = parcelRequire("cJZA6");


var $foY7i = parcelRequire("foY7i");

const $ba979633c1583055$export$58982618823f55fc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { accountId: accountId, bridge: bridge, cloudId: cloudId, workspaceId: workspaceId, mentionProvider: mentionProvider, product: product, components: components } = t0;
    let t1;
    if ($[0] !== components) {
        t1 = components ? Object.keys(components).reduce((acc, key)=>{
            const Component = components[key];
            return {
                ...acc,
                [key]: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                        ...args,
                        key: args.forgeDoc.key
                    })
            };
        }, {}) : {};
        $[0] = components;
        $[1] = t1;
    } else t1 = $[1];
    const injectedComponentsWithKey = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $3dDsm.makeUser)();
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== accountId || $[4] !== cloudId || $[5] !== mentionProvider || $[6] !== product || $[7] !== workspaceId) {
        t3 = (0, $h9K7i.makeNativeUserPicker)({
            mentionProvider: mentionProvider,
            accountId: accountId,
            ...workspaceId ? {
                cloudId: "bitbucket"
            } : {
                cloudId: cloudId
            },
            productAttributes: workspaceId ? {
                workspaceIds: [
                    (0, $foY7i.uncurlyUuid)(workspaceId)
                ]
            } : undefined,
            productKey: product
        });
        $[3] = accountId;
        $[4] = cloudId;
        $[5] = mentionProvider;
        $[6] = product;
        $[7] = workspaceId;
        $[8] = t3;
    } else t3 = $[8];
    const t4 = bridge?.onNavigate;
    let t5;
    if ($[9] !== bridge || $[10] !== t4) {
        t5 = (0, $8J8AQ.makeADFRenderer)({
            bridge: bridge,
            onNavigate: t4
        });
        $[9] = bridge;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t5) {
        t6 = {
            AdfRenderer: t5
        };
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== t3 || $[15] !== t6) {
        t7 = {
            Avatar: t2,
            AvatarStack: (0, $cJZA6.UserGroup),
            UserPicker: t3,
            ...t6
        };
        $[14] = t3;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    const wiredComponents = t7;
    let t8;
    if ($[17] !== injectedComponentsWithKey || $[18] !== wiredComponents) {
        t8 = (defaults)=>({
                ...defaults,
                ...wiredComponents,
                ...injectedComponentsWithKey
            });
        $[17] = injectedComponentsWithKey;
        $[18] = wiredComponents;
        $[19] = t8;
    } else t8 = $[19];
    const getComponents = t8;
    return getComponents;
} : ({ accountId: accountId, bridge: bridge, cloudId: cloudId, workspaceId: workspaceId, mentionProvider: mentionProvider, product: product, components: components })=>{
    const injectedComponentsWithKey = (0, $cozmU.useMemo)(()=>{
        return components ? Object.keys(components).reduce((acc, key)=>{
            const Component = components[key];
            return {
                ...acc,
                // A key is required to ensure React creates new component instances when forgeDoc.key changes.
                // Without this key, React reuses the same component instance across different forgeDoc updates,
                // causing hook call order violations when the component structure changes between renders.
                [key]: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                        ...args,
                        key: args.forgeDoc.key
                    })
            };
        }, {}) : {};
    }, [
        components
    ]);
    const wiredComponents = (0, $cozmU.useMemo)(()=>({
            Avatar: (0, $3dDsm.makeUser)(),
            AvatarStack: (0, $cJZA6.UserGroup),
            UserPicker: (0, $h9K7i.makeNativeUserPicker)({
                mentionProvider: mentionProvider,
                accountId: accountId,
                ...workspaceId ? {
                    cloudId: 'bitbucket'
                } : {
                    cloudId: cloudId
                },
                productAttributes: workspaceId ? {
                    workspaceIds: [
                        (0, $foY7i.uncurlyUuid)(workspaceId)
                    ]
                } : undefined,
                productKey: product
            }),
            AdfRenderer: (0, $8J8AQ.makeADFRenderer)({
                bridge: bridge,
                onNavigate: bridge?.onNavigate
            })
        }), [
        accountId,
        cloudId,
        mentionProvider,
        product,
        workspaceId,
        bridge
    ]);
    const getComponents = (0, $cozmU.useCallback)((defaults)=>({
            ...defaults,
            ...wiredComponents,
            ...injectedComponentsWithKey
        }), [
        injectedComponentsWithKey,
        wiredComponents
    ]);
    return getComponents;
};
module.exports["useUIKitComponents"] = $ba979633c1583055$export$58982618823f55fc;

});

parcelRegister("fMV63", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $koUFz = parcelRequire("koUFz");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $6ojvx = parcelRequire("6ojvx");


var $bEbDR = parcelRequire("bEbDR");

var $fO0Vm = parcelRequire("fO0Vm");


var $3zbll = parcelRequire("3zbll");


var $eL3mC = parcelRequire("eL3mC");


var $hfFJ2 = parcelRequire("hfFJ2");

var $4DMV4 = parcelRequire("4DMV4");

var $jerTb = parcelRequire("jerTb");

var $iuxS5 = parcelRequire("iuxS5");

var $1Bv8Y = parcelRequire("1Bv8Y");

var $fXNFR = parcelRequire("fXNFR");

var $dK9hN = parcelRequire("dK9hN");


var $d6OEY = parcelRequire("d6OEY");


var $et00U = parcelRequire("et00U");


var $1y2Zu = parcelRequire("1y2Zu");


var $7vufB = parcelRequire("7vufB");


var $6FQr4 = parcelRequire("6FQr4");


var $1gaKI = parcelRequire("1gaKI");


var $1UkXE = parcelRequire("1UkXE");


var $iyPp3 = parcelRequire("iyPp3");





var $iDrrr = parcelRequire("iDrrr");


var $402vX = parcelRequire("402vX");

const $bcf8288e84377730$var$styles = {
    hostedResourcesIframeContainer: "_1mT5xdRAKS",
    box: "_39xV02N91d _0jFU0VN91d"
};
const $bcf8288e84377730$var$ReloadOnContextChangeWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { context: context, children: children, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion } = t0;
    if (getCurrentForgeReactMajorVersion) {
        let t1;
        if ($[0] !== children || $[1] !== context || $[2] !== getCurrentForgeReactMajorVersion) {
            t1 = /*#__PURE__*/ $cozmU.createElement((0, $1UkXE.ContextChangeObserverWrapper), {
                context: context,
                getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion
            }, children);
            $[0] = children;
            $[1] = context;
            $[2] = getCurrentForgeReactMajorVersion;
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    let t1;
    if ($[4] !== context) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($3zbll)))(context);
        $[4] = context;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== children || $[7] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), {
            key: t1
        }, children);
        $[6] = children;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ context: context, children: children, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion })=>{
    if (getCurrentForgeReactMajorVersion) return /*#__PURE__*/ $cozmU.createElement((0, $1UkXE.ContextChangeObserverWrapper), {
        context: context,
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion
    }, children);
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), {
        key: (0, (/*@__PURE__*/$parcel$interopDefault($3zbll)))(context)
    }, children);
};
const $bcf8288e84377730$export$5137ec99f248330b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ accountId: accountId, extension: extension, contextIds: contextIds, components: components, coreData: coreData, extensionData: extensionData, extensionViewData: extensionViewData, loadingComponent: loadingComponent, onLoad: onLoad, height: height = '100%', width: width = '100%', bridge: bridge, customBridgeMethods: customBridgeMethods, customBridge: customBridge, customBridgeContext: customBridgeContext, isResizable: isResizable = true, entryPoint: entryPoint, extensionPayload: extensionPayload, getContextToken: getContextToken, timezone: timezone, locale: locale, isHidden: isHidden = false, isInModal: isInModal = false, setShouldShowRenderer: setShouldShowRenderer, setIsLoading: setIsLoading, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion, onError: onError, isEmbeddedMacro: isEmbeddedMacro = false, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId, contextChangeListeners: contextChangeListeners }, iframeRef)=>{
    const environment = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext)); // ARKEN-856: useThemeObserver() is a bit noisy, it returns copies of the same theme which breaks useBridge() dependencies
    // We use useMemoizedStateObject() to properly memoize its output doing a deep-equality check
    const theme = (0, $fO0Vm.useMemoizedStateObject)((0, $IQ4Dz.useThemeObserver)());
    const iframeWrapperRef = (0, $cozmU.useRef)(null);
    const [surfaceColor, setSurfaceColor] = (0, $cozmU.useState)(null);
    const { trackExtensionLoaded: trackExtensionLoaded } = (0, $6FQr4.useForgeUiAnalyticsEvent)();
    (0, $cozmU.useEffect)(()=>{
        if (!iframeWrapperRef.current) return;
        const nextSurfaceColor = getComputedStyle(iframeWrapperRef.current).getPropertyValue((0, $koUFz.CURRENT_SURFACE_CSS_VAR));
        setSurfaceColor(nextSurfaceColor);
    }, [
        theme
    ]);
    const { appId: appId, moduleKey: moduleKey } = (0, $bEbDR.parseExtensionId)(extension.id);
    const { environmentId: environmentId, environmentType: environmentType } = extension; // getExtensionEntryPoint resolves both the resource and its resolvedResourceEntry from the
    // active entryPoint together, so the top-level resource's HTML filename does not bleed into a
    // sub-entry-point's (config/edit/view/create/contextConfig) CDN URL.
    const { resource: extensionEntryPoint, resolvedResourceEntry: activeResolvedResourceEntry } = (0, $d6OEY.getExtensionEntryPoint)(extension, entryPoint);
    const extensionViewDataMemoKey = (0, (/*@__PURE__*/$parcel$interopDefault($3zbll)))(extensionViewData); // eslint-disable-next-line react-hooks/exhaustive-deps -- extensionViewDataMemoKey is a deep-equality proxy; extensionViewData is intentionally excluded to avoid referential-inequality re-renders.
    const stableExtensionViewData = (0, $cozmU.useMemo)(()=>extensionViewData, [
        extensionViewDataMemoKey
    ]);
    const urlSafeContext = (0, $cozmU.useMemo)(()=>(0, $hfFJ2.urlSafeB64)((0, $iyPp3.getEncodedAppContext)(extension, stableExtensionViewData)), [
        extension,
        stableExtensionViewData
    ]);
    const defaultSrc = (0, $cozmU.useMemo)(()=>(0, $hfFJ2.createSrcFromExtension)(appId, extension, environment, extensionEntryPoint, stableExtensionViewData, activeResolvedResourceEntry), [
        appId,
        extension,
        environment,
        extensionEntryPoint,
        stableExtensionViewData,
        activeResolvedResourceEntry
    ]);
    const isSignedCookieLoading = (0, $dK9hN.useCDNAuthSignedCookie)();
    (0, $cozmU.useEffect)(()=>{
        const renderType = extension?.properties?.render === 'native' ? 'UIKit' : 'CustomUI';
        const extensionType = (0, $1gaKI.getExtensionType)(extension);
        trackExtensionLoaded({
            forgeEnvironment: extension?.environmentType,
            renderType: renderType,
            extensionType: extensionType
        }); // This should run for each new unique appId/moduleKey combination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        appId,
        moduleKey
    ]);
    const [isThreeLOPromptVisible, setIsThreeLOPromptVisible] = (0, $cozmU.useState)(false);
    const coreDataInner = {
        ...coreData,
        environmentId: environmentId,
        environmentType: environmentType,
        moduleKey: moduleKey,
        siteUrl: window.location.origin
    };
    const viewportSize = extension.properties.viewportSize; // Manifest viewportSize normally disables iframe auto-resize (fixed shell heights).
    // viewportSize: 'resizable' is paired with resizable modal chrome — keep iframe resizer on.
    const isResizableViewportSize = viewportSize === 'resizable';
    const resizingEnabled = isResizable && (!viewportSize || isResizableViewportSize); // moves specific macro extension data (isEditing, macro) to extensionData instead of extensionPayload as this is required for Tempo (#hot-300905)
    // the first check enables the feature for Tempo specifically, the second check enables the feature for all extensions if needed
    const enabledForTempo = appId === '76206a70-b9d6-4328-9e20-db79196c548a' && (0, $iDrrr.fg)('forge-ui-move-macro-data-for-tempo');
    const shouldIncludeMacroDataInExtensionData = enabledForTempo || (0, $iDrrr.fg)('forge-ui-move-macro-data-to-extension-data');
    return /*#__PURE__*/ $cozmU.createElement((0, $7vufB.TunnelsProvider), {
        environmentType: extension.environmentType,
        appId: appId,
        contextIds: contextIds,
        environmentId: environmentId
    }, ({ tunnels: tunnels, loading: loading })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            ref: iframeWrapperRef,
            testId: "hosted-resources-iframe-container",
            xcss: $bcf8288e84377730$var$styles.hostedResourcesIframeContainer,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: isThreeLOPromptVisible || isHidden || ((0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? !!embeddedMacroParentType : isEmbeddedMacro) ? undefined : height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: resizingEnabled || isThreeLOPromptVisible || isHidden ? undefined : height,
                width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width
            }
        }, (loading || (0, $dK9hN.shouldUseCDNAuth)() && isSignedCookieLoading) && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $bcf8288e84377730$var$styles.box
        }, loading && !isHidden && (0, $1y2Zu.getLoadingComponent)(loadingComponent))), !(loading || (0, $dK9hN.shouldUseCDNAuth)() && isSignedCookieLoading) && /*#__PURE__*/ $cozmU.createElement((0, $eL3mC.TracingProvider), null, (0, $iDrrr.fg)('forge-ui-bridge-core-reset') ? /*#__PURE__*/ $cozmU.createElement((0, $402vX.InnerIframe), {
            accountId: accountId,
            extension: extension,
            contextIds: contextIds,
            components: components,
            coreData: coreDataInner,
            customBridge: customBridge,
            customBridgeContext: customBridgeContext,
            extensionData: extensionData,
            extensionViewData: extensionViewData,
            loadingComponent: loadingComponent,
            onLoad: onLoad,
            height: height,
            width: width,
            src: (0, $1Bv8Y.getSrcUrl)(tunnels, extensionEntryPoint, defaultSrc, urlSafeContext, activeResolvedResourceEntry),
            bridge: bridge,
            customBridgeMethods: customBridgeMethods,
            isResizable: resizingEnabled,
            getContextToken: getContextToken,
            timezone: timezone,
            locale: locale,
            setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
            setShouldShowRenderer: setShouldShowRenderer,
            extensionPayload: extensionPayload,
            isHidden: isHidden,
            theme: theme,
            surfaceColor: surfaceColor,
            appId: appId,
            ref: iframeRef,
            isInModal: isInModal,
            setIsLoading: setIsLoading,
            onError: onError,
            isEmbeddedMacro: isEmbeddedMacro,
            embeddedMacroParentType: embeddedMacroParentType,
            embeddedParentLocalId: embeddedParentLocalId,
            contextChangeListeners: contextChangeListeners
        }) : /*#__PURE__*/ $cozmU.createElement($bcf8288e84377730$var$ReloadOnContextChangeWrapper, {
            getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
            context: (0, $fXNFR.getViewContext)({
                resolverContext: (0, $iuxS5.getResolverContext)(coreDataInner, extensionData),
                accountId: accountId,
                extension: extension,
                timezone: timezone ?? (0, $jerTb.getBrowserTimezone)(),
                locale: locale ?? (0, $4DMV4.getBrowserLocale)(),
                extensionViewData: extensionViewData,
                extensionPayload: {
                    config: extensionPayload?.config,
                    macro: shouldIncludeMacroDataInExtensionData ? extensionData?.macro : extensionPayload?.macro,
                    isEditing: shouldIncludeMacroDataInExtensionData ? extensionData?.isEditing : extensionPayload?.isEditing
                }
            })
        }, /*#__PURE__*/ $cozmU.createElement((0, $et00U.InnerIframe), {
            accountId: accountId,
            extension: extension,
            contextIds: contextIds,
            components: components,
            coreData: coreDataInner,
            extensionData: extensionData,
            extensionViewData: extensionViewData,
            loadingComponent: loadingComponent,
            onLoad: onLoad,
            height: height,
            width: width,
            src: (0, $1Bv8Y.getSrcUrl)(tunnels, extensionEntryPoint, defaultSrc, urlSafeContext, activeResolvedResourceEntry),
            bridge: bridge,
            customBridgeMethods: customBridgeMethods,
            isResizable: resizingEnabled,
            getContextToken: getContextToken,
            timezone: timezone,
            locale: locale,
            setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
            setShouldShowRenderer: setShouldShowRenderer,
            extensionPayload: extensionPayload,
            isHidden: isHidden,
            theme: theme,
            surfaceColor: surfaceColor,
            appId: appId,
            ref: iframeRef,
            isInModal: isInModal,
            setIsLoading: setIsLoading,
            onError: onError,
            isEmbeddedMacro: isEmbeddedMacro,
            embeddedMacroParentType: embeddedMacroParentType,
            embeddedParentLocalId: embeddedParentLocalId
        })))));
});
module.exports["Iframe"] = $bcf8288e84377730$export$5137ec99f248330b;

});

parcelRegister("iyPp3", function(module, exports) {

var $3zbll = parcelRequire("3zbll");


var $13PMQ = parcelRequire("13PMQ");


var $1hQ0e = parcelRequire("1hQ0e");


var $iDrrr = parcelRequire("iDrrr");


var $aWrCr = parcelRequire("aWrCr");

const $1dadf70a46515fde$export$423a62223c29d468 = (extension, extensionViewData)=>{
    const { egress: egress = [], installationConfig: installationConfig = [] } = extension;
    const getMacroParentHostDomain = ()=>{
        const doc = (0, $1hQ0e.getDocument)(); // browser stips off referer and origin.
        const { hostname: hostname, pathname: pathname } = window.location;
        // Allow all origins for local Confluence development where the FAUS ADF renderer
        // runs at /forge-apps/adf-renderer and the browser strips off the referrer/origin.
        if (hostname === 'localhost' && pathname === '/forge-apps/adf-renderer') return '*';
        if (doc?.referrer && extension.type === 'xen:macro') {
            const referrerUrl = new URL(doc.referrer);
            const hostnameParts = referrerUrl.hostname.split('.');
            // Check if the second subdomain is 'cdn' to confirm it's a CDN URL
            const isCdnUrl = hostnameParts.length > 1 && hostnameParts[1] === 'cdn';
            if (isCdnUrl) return hostnameParts[0];
            const isLocalHost = referrerUrl.hostname === 'localhost';
            if (isLocalHost) return referrerUrl.host;
        }
    };
    const macroParentHostDomain = getMacroParentHostDomain();
    const shouldIncludeConnectMacroParentDomain = Boolean(extensionViewData?.connectMacroOrigin) && (0, $iDrrr.fg)('forge_nbm_set_frame_ancestors');
    // Resolve the cross-domain embedding origin directly off the embedding (host) window so the
    // Forge CDN can add it to the iframe's `frame-ancestors` CSP; without it the iframe is blocked
    // when the host page is embedded cross-domain (e.g. on a custom domain). Reading it here — rather
    // than threading it via `extensionViewData` — covers every extension type and runtime, not just
    // macros. Keep the whole resolver behind the gate so the new code path stays fully killable.
    const crossDomainEmbeddingOrigin = (0, $iDrrr.fg)('forge-ui-embedded-confluence-custom-domain-csp') ? (0, $aWrCr.getCrossDomainEmbeddingOrigin)() : undefined;
    const contextPayload = {
        egress: egress,
        installationConfig: installationConfig,
        hostname: window.location.hostname,
        ...macroParentHostDomain ? {
            macroParentHostDomain: macroParentHostDomain,
            macroParentHost: macroParentHostDomain
        } : {},
        ...shouldIncludeConnectMacroParentDomain ? {
            connectMacroParentDomain: extensionViewData?.connectMacroOrigin
        } : {},
        ...crossDomainEmbeddingOrigin ? {
            parentEmbeddingDomain: crossDomainEmbeddingOrigin
        } : {}
    };
    return $1dadf70a46515fde$var$gzipAndB64Encode(contextPayload);
};
const $1dadf70a46515fde$var$gzipAndB64Encode = (json)=>{
    const jsonString = (0, (/*@__PURE__*/$parcel$interopDefault($3zbll)))(json); // We use fast-json-stable-stringify to ensure that the JSON is deterministic
    try {
        const zippedData = (0, $13PMQ.gzipSync)(new TextEncoder().encode(jsonString), {
            level: 9,
            // Max compression,
            mtime: 0 // We set the mtime to 0 to ensure that the output is deterministic
        });
        return btoa(String.fromCharCode(...zippedData));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err.message);
    }
    return '';
};
module.exports["getEncodedAppContext"] = $1dadf70a46515fde$export$423a62223c29d468;

});

parcelRegister("lvKd7", function(module, exports) {
(()=>{
    "use strict";
    var e = {
        167 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.deserializeError = t.deserialize = void 0;
            const n = r(438), o = (e)=>"proxyCache" in e && "functionRegistry" in e;
            t.deserialize = (e, r, n = new WeakSet())=>{
                if (null == e) return e;
                if ("object" != typeof e) return e;
                if (a(e)) switch(e.__type__){
                    case "port_rpc_function":
                        return s(e, r);
                    case "port_rpc_error":
                        return (0, t.deserializeError)(e);
                    case "port_rpc_regex":
                        return c(e);
                }
                return e instanceof Date || e instanceof ArrayBuffer || ArrayBuffer.isView(e) ? e : n.has(e) ? void 0 : (n.add(e), i(e, r, n));
            };
            const i = (e, r, n)=>{
                if (Array.isArray(e)) return e.map((e)=>(0, t.deserialize)(e, r, n));
                if (e instanceof Map) {
                    const o = new Map();
                    for (const [i, s] of e)o.set(i, (0, t.deserialize)(s, r, n));
                    return o;
                }
                if (e instanceof Set) {
                    const o = new Set();
                    for (const i of e)o.add((0, t.deserialize)(i, r, n));
                    return o;
                }
                const o = {};
                for (const i of Object.keys(e))o[i] = (0, t.deserialize)(e[i], r, n);
                return o;
            }, s = (e, t)=>{
                const r = e[n.PROXY_ID_FIELD], { __name__: i } = e;
                if (o(t)) {
                    const e = t.functionStore.get(r);
                    if (e) return e;
                }
                if (o(t)) {
                    const e = t.proxyCache.get(r)?.deref();
                    if (e) return e;
                }
                const s = async (...e)=>t.send(`${n.FUNCTION_CALL_PREFIX}:${r}`, {
                        args: e
                    });
                return s[n.PROXY_ID_SYMBOL] = r, s[n.PROXY_ID_FIELD] = r, Object.defineProperty(s, "name", {
                    value: `proxy<${i}>`,
                    configurable: !0
                }), o(t) && (s[n.PROXY_OWNER_SYMBOL] = t.functionStore, t.proxyCache.set(r, new WeakRef(s)), t.functionRegistry.register(s, r, s)), s;
            };
            t.deserializeError = (e)=>{
                const t = new Error(e.message);
                return e.stack && (t.stack = e.stack), e.name && (t.name = e.name), e.code && (t.code = e.code), t;
            };
            const c = (e)=>new RegExp(e.source, e.flags), a = (e)=>"object" == typeof e && null !== e && "__type__" in e && "string" == typeof e.__type__;
        },
        227 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.establish = void 0;
            const n = r(438), o = r(402), i = r(441), s = r(690), c = r(259), a = (e)=>{
                e.settled = !0;
                try {
                    e.port1.postMessage({
                        type: "DISCONNECT",
                        id: (0, n.uniqueID)()
                    });
                } catch  {}
                try {
                    e.port1.close();
                } catch  {}
            };
            t.establish = (e, t)=>{
                const { timeout: r, origin: d = "*", context: u, verify: l, waitForReady: f, connectionOptions: _ } = t ?? {}, p = r ?? (u ? n.ROUTED_HANDSHAKE_TIMEOUT : n.HANDSHAKE_TIMEOUT), h = (t)=>new Promise((r, c)=>{
                        const f = (0, s.resolveTarget)(e, d, "establish"), { port1: p, port2: h } = new MessageChannel(), E = {
                            port1: p,
                            timer: void 0,
                            settled: !1,
                            verify: l,
                            resolve: r,
                            reject: c,
                            connectionOptions: _
                        };
                        E.timer = setTimeout(()=>{
                            E.settled || (a(E), c(new i.TimeoutError(`Handshake timeout: no response within ${t}ms`)));
                        }, t), p.onmessage = ((e)=>async (t)=>{
                                if (e.settled) return;
                                const r = t.data;
                                r?.type !== n.ROUTE_REJECT_TYPE ? r?.type === n.HANDSHAKE_ACK_TYPE && await (async (e, t)=>{
                                    if (e.verify) try {
                                        const r = await e.verify(t.verificationData);
                                        if (e.settled) return;
                                        if (!r) return clearTimeout(e.timer), a(e), void e.reject(new i.VerificationError());
                                    } catch (t) {
                                        if (e.settled) return;
                                        return clearTimeout(e.timer), a(e), void e.reject(new i.VerificationError(t instanceof Error ? t.message : "Verification failed"));
                                    }
                                    e.settled || (clearTimeout(e.timer), e.settled = !0, e.port1.onmessage = null, e.resolve(new o.ConnectionImpl(e.port1, e.connectionOptions)));
                                })(e, r) : ((e, t)=>{
                                    clearTimeout(e.timer), a(e), e.reject(new i.RoutingError(t.error || "Route rejected"));
                                })(e, r);
                            })(E);
                        const m = {
                            type: n.HANDSHAKE_MSG_TYPE,
                            ...u ? {
                                context: u
                            } : {}
                        };
                        try {
                            f.post(m, [
                                h
                            ]);
                        } catch (e) {
                            clearTimeout(E.timer), a(E), c(new i.RoutingError(`Failed to send handshake: ${e instanceof Error ? e.message : String(e)}`));
                        }
                    });
                if (!f) return h(p);
                const E = Date.now();
                return (0, c.waitForReady)(e, {
                    origin: d,
                    timeout: p
                }).then(()=>{
                    const e = Math.max(0, p - (Date.now() - E));
                    return h(e);
                });
            };
        },
        259 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.waitForReady = void 0;
            const n = r(438), o = r(441), i = r(690);
            t.waitForReady = (e, t)=>{
                const { origin: r = "*", timeout: s = n.READY_TIMEOUT, interval: c = n.READY_PROBE_INTERVAL } = t ?? {};
                return new Promise((t, a)=>{
                    let d;
                    try {
                        d = ((e, t)=>{
                            if ("undefined" != typeof HTMLIFrameElement && e instanceof HTMLIFrameElement) {
                                const r = e.contentWindow;
                                if (!r) throw new o.PortRpcError("Cannot waitForReady: iframe has no contentWindow (not yet loaded?)");
                                if ("undefined" == typeof window) throw new o.PortRpcError("waitForReady requires a window context for Window/iframe targets");
                                return {
                                    listenTarget: window,
                                    post: (e)=>r.postMessage(e, t),
                                    expectedSource: r
                                };
                            }
                            if ("undefined" != typeof Worker && e instanceof Worker) return {
                                listenTarget: e,
                                post: (t)=>e.postMessage(t),
                                expectedSource: void 0
                            };
                            if ((0, i.isWindow)(e)) {
                                if ("undefined" == typeof window) throw new o.PortRpcError("waitForReady requires a window context for Window targets");
                                return {
                                    listenTarget: window,
                                    post: (r)=>e.postMessage(r, t),
                                    expectedSource: e
                                };
                            }
                            throw new o.PortRpcError("Unsupported waitForReady target");
                        })(e, r);
                    } catch (e) {
                        return void a(e instanceof Error ? e : new o.PortRpcError(String(e)));
                    }
                    const { listenTarget: u, post: l, expectedSource: f } = d, _ = (0, n.uniqueID)();
                    let p = !1;
                    const h = ()=>{
                        p = !0, clearInterval(g), clearTimeout(y), u.removeEventListener("message", E);
                    }, E = (e)=>{
                        if (p) return;
                        const r = e.data;
                        r && r.type === n.READY_TYPE && r.nonce === _ && (f && e.source && e.source !== f || (h(), t()));
                    };
                    u.addEventListener("message", E);
                    const m = ()=>{
                        try {
                            l({
                                type: n.READY_PROBE_TYPE,
                                nonce: _
                            });
                        } catch  {}
                    };
                    m();
                    const g = setInterval(m, c), y = setTimeout(()=>{
                        p || (h(), a(new o.TimeoutError(`waitForReady timeout: no ready signal within ${s}ms`)));
                    }, s);
                });
            };
        },
        304 (e, t, r) {
            t.GJ = t._4 = void 0;
            var n = r(227);
            Object.defineProperty(t, "_4", {
                enumerable: !0,
                get: function() {
                    return n.establish;
                }
            });
            var o = r(930);
            Object.defineProperty(t, "GJ", {
                enumerable: !0,
                get: function() {
                    return o.onConnect;
                }
            });
            r(629), r(441);
        },
        402 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.ConnectionImpl = void 0;
            const n = r(438), o = r(906), i = r(167), s = r(441);
            t.ConnectionImpl = class {
                on(e, t) {
                    if (this.requestListeners.has(e)) throw new s.DuplicateListenerError(e);
                    return this.requestListeners.set(e, {
                        handler: t,
                        once: !1
                    }), {
                        cancel: ()=>{
                            this.requestListeners.delete(e);
                        }
                    };
                }
                once(e, t) {
                    if (this.requestListeners.has(e)) throw new s.DuplicateListenerError(e);
                    return this.requestListeners.set(e, {
                        handler: t,
                        once: !0
                    }), {
                        cancel: ()=>{
                            this.requestListeners.delete(e);
                        }
                    };
                }
                send(e, t, r) {
                    if (this.destroyed) return Promise.reject(new s.ConnectionClosedError("Cannot send on a destroyed connection"));
                    const i = r?.fireAndForget ?? !1, c = r?.ackTimeout ?? this.defaultAckTimeout, a = r?.timeout ?? this.defaultResponseTimeout, d = `${e}_${(0, n.uniqueID)()}`, u = {
                        type: "REQUEST",
                        id: d,
                        name: e,
                        data: (0, o.serialize)(t, this.functionStore, this.fnToId),
                        ...i ? {
                            fireAndForget: !0
                        } : {}
                    };
                    try {
                        this.port.postMessage(u);
                    } catch (e) {
                        return Promise.reject(e);
                    }
                    return i ? Promise.resolve(void 0) : this.awaitResponse(d, e, c, a);
                }
                awaitResponse(e, t, r, n) {
                    return new Promise((o, i)=>{
                        const c = {
                            resolve: o,
                            reject: i,
                            ackTimer: null,
                            responseTimer: null,
                            acked: !1
                        };
                        !1 !== r && r > 0 && (c.ackTimer = setTimeout(()=>{
                            c.acked || (this.pendingRequests.delete(e), this.clearPendingTimers(c), i(new s.TimeoutError(`ACK timeout: no ACK received for "${t}" within ${r}ms`)));
                        }, r)), n > 0 && (c.responseTimer = setTimeout(()=>{
                            this.pendingRequests.delete(e), this.clearPendingTimers(c), i(new s.TimeoutError(`Response timeout: no response for "${t}" within ${n}ms`));
                        }, n)), this.pendingRequests.set(e, c);
                    });
                }
                async ping(e) {
                    if (this.destroyed) return !1;
                    const t = e ?? n.PING_TIMEOUT;
                    try {
                        return await this.send(n.PING_NAME, void 0, {
                            timeout: t,
                            ackTimeout: t
                        }), !0;
                    } catch  {
                        return !1;
                    }
                }
                onDisconnect(e) {
                    return this.disconnectHandlers.add(e), {
                        cancel: ()=>{
                            this.disconnectHandlers.delete(e);
                        }
                    };
                }
                destroy() {
                    if (!this.destroyed) {
                        this.destroyed = !0;
                        try {
                            this.port.postMessage({
                                type: "DISCONNECT",
                                id: (0, n.uniqueID)()
                            });
                        } catch  {}
                        this.teardown();
                    }
                }
                handleMessage(e) {
                    switch(e.type){
                        case "REQUEST":
                            this.handleRequest(e);
                            break;
                        case "RESPONSE":
                            this.handleResponse(e);
                            break;
                        case "ACK":
                            this.handleAck(e);
                            break;
                        case "DISCONNECT":
                            this.handleDisconnect();
                            break;
                        case "FUNCTION_RELEASE":
                            this.handleFunctionRelease(e);
                    }
                }
                handleRequest(e) {
                    const { id: t, name: r, data: o, fireAndForget: c } = e;
                    if (c) return void this.handleFireAndForget(r, o);
                    if (this.sendAck(t), r === n.PING_NAME) return void this.sendResponse(t, void 0);
                    if (r.startsWith(`${n.FUNCTION_CALL_PREFIX}:`)) {
                        const e = r.slice(n.FUNCTION_CALL_PREFIX.length + 1), c = this.functionStore.get(e);
                        if (!c) return void this.sendErrorResponse(t, new s.HandlerNotFoundError(`function:${e}`));
                        const a = (0, i.deserialize)(o, this);
                        return void this.invokeHandlerAndRespond(t, ()=>c(...a?.args ?? []));
                    }
                    const a = this.requestListeners.get(r);
                    if (!a) return void this.sendErrorResponse(t, new s.HandlerNotFoundError(r));
                    a.once && this.requestListeners.delete(r);
                    const d = {
                        data: (0, i.deserialize)(o, this)
                    };
                    this.invokeHandlerAndRespond(t, ()=>a.handler(d));
                }
                handleResponse(e) {
                    const t = this.pendingRequests.get(e.id);
                    t && (this.pendingRequests.delete(e.id), this.clearPendingTimers(t), e.error ? t.reject((0, i.deserializeError)(e.error)) : t.resolve((0, i.deserialize)(e.data, this)));
                }
                handleAck(e) {
                    const t = this.pendingRequests.get(e.id);
                    t && (t.acked = !0, null !== t.ackTimer && (clearTimeout(t.ackTimer), t.ackTimer = null));
                }
                handleDisconnect() {
                    this.destroyed || (this.destroyed = !0, this.teardown());
                }
                handleFunctionRelease(e) {
                    const { functionId: t } = e, r = this.functionStore.get(t);
                    r && (this.fnToId.delete(r), this.functionStore.delete(t));
                }
                sendAck(e) {
                    try {
                        this.port.postMessage({
                            type: "ACK",
                            id: e
                        });
                    } catch  {}
                }
                sendFunctionRelease(e) {
                    if (!this.destroyed) try {
                        this.port.postMessage({
                            type: "FUNCTION_RELEASE",
                            functionId: e
                        });
                    } catch  {}
                }
                sendResponse(e, t) {
                    try {
                        const r = (0, o.serialize)(t, this.functionStore, this.fnToId);
                        this.port.postMessage({
                            type: "RESPONSE",
                            id: e,
                            data: r
                        });
                    } catch (t) {
                        try {
                            this.sendErrorResponse(e, t instanceof Error ? t : new Error(String(t)));
                        } catch  {}
                    }
                }
                sendErrorResponse(e, t) {
                    const r = t instanceof Error ? t : new Error(String(t)), n = {
                        message: r.message,
                        stack: r.stack,
                        name: r.name,
                        code: r.code
                    };
                    try {
                        this.port.postMessage({
                            type: "RESPONSE",
                            id: e,
                            error: n
                        });
                    } catch  {}
                }
                handleFireAndForget(e, t) {
                    if (e === n.PING_NAME) return;
                    if (e.startsWith(`${n.FUNCTION_CALL_PREFIX}:`)) {
                        const r = e.slice(n.FUNCTION_CALL_PREFIX.length + 1), o = this.functionStore.get(r);
                        if (!o) return;
                        const s = (0, i.deserialize)(t, this);
                        return void this.invokeAndForget(o, s?.args ?? []);
                    }
                    const r = this.requestListeners.get(e);
                    if (!r) return;
                    r.once && this.requestListeners.delete(e);
                    const o = {
                        data: (0, i.deserialize)(t, this)
                    };
                    try {
                        const e = r.handler(o);
                        e instanceof Promise && e.catch(()=>{});
                    } catch  {}
                }
                invokeAndForget(e, t) {
                    try {
                        const r = e(...t);
                        r instanceof Promise && r.catch(()=>{});
                    } catch  {}
                }
                invokeHandlerAndRespond(e, t) {
                    try {
                        const r = t();
                        r instanceof Promise ? r.then((t)=>this.sendResponse(e, t), (t)=>this.sendErrorResponse(e, t)) : this.sendResponse(e, r);
                    } catch (t) {
                        this.sendErrorResponse(e, t);
                    }
                }
                teardown() {
                    const e = new s.ConnectionClosedError();
                    for (const [, t] of this.pendingRequests)this.clearPendingTimers(t), t.reject(e);
                    for (const e of this.disconnectHandlers)try {
                        e();
                    } catch  {}
                    this.requestListeners.clear(), this.pendingRequests.clear(), this.functionStore.clear(), this.fnToId.clear();
                    for (const e of this.proxyCache.values()){
                        const t = e.deref();
                        t && this.functionRegistry.unregister(t);
                    }
                    this.proxyCache.clear(), this.disconnectHandlers.clear();
                    try {
                        this.port.close();
                    } catch  {}
                }
                clearPendingTimers(e) {
                    null !== e.ackTimer && (clearTimeout(e.ackTimer), e.ackTimer = null), null !== e.responseTimer && (clearTimeout(e.responseTimer), e.responseTimer = null);
                }
                constructor(e, t){
                    this.requestListeners = new Map(), this.pendingRequests = new Map(), this.functionStore = new Map(), this.fnToId = new Map(), this.proxyCache = new Map(), this.functionRegistry = new FinalizationRegistry((e)=>{
                        this.proxyCache.delete(e), this.sendFunctionRelease(e);
                    }), this.disconnectHandlers = new Set(), this.destroyed = !1, this.port = e, this.defaultAckTimeout = t?.ackTimeout ?? n.DEFAULT_ACK_TIMEOUT, this.defaultResponseTimeout = t?.timeout ?? n.RESPONSE_TIMEOUT, this.port.onmessage = (e)=>{
                        this.handleMessage(e.data);
                    };
                }
            };
        },
        438 (e, t) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.uniqueID = t.READY_TIMEOUT = t.READY_PROBE_INTERVAL = t.READY_TYPE = t.READY_PROBE_TYPE = t.PING_TIMEOUT = t.PROXY_ID_FIELD = t.PROXY_OWNER_SYMBOL = t.PROXY_ID_SYMBOL = t.PING_NAME = t.ROUTE_REJECT_TYPE = t.FUNCTION_RELEASE_TYPE = t.FUNCTION_CALL_PREFIX = t.HANDSHAKE_ACK_TYPE = t.HANDSHAKE_MSG_TYPE = t.ROUTED_HANDSHAKE_TIMEOUT = t.HANDSHAKE_TIMEOUT = t.RESPONSE_TIMEOUT = t.DEFAULT_ACK_TIMEOUT = void 0, t.DEFAULT_ACK_TIMEOUT = 2e3, t.RESPONSE_TIMEOUT = -1, t.HANDSHAKE_TIMEOUT = 5e3, t.ROUTED_HANDSHAKE_TIMEOUT = 1e4, t.HANDSHAKE_MSG_TYPE = "__port_rpc_handshake__", t.HANDSHAKE_ACK_TYPE = "__port_rpc_handshake_ack__", t.FUNCTION_CALL_PREFIX = "__port_rpc_fn__", t.FUNCTION_RELEASE_TYPE = "__port_rpc_fn_release__", t.ROUTE_REJECT_TYPE = "__port_rpc_route_reject__", t.PING_NAME = "__port_rpc_ping__", t.PROXY_ID_SYMBOL = Symbol.for("port_rpc_proxy_id"), t.PROXY_OWNER_SYMBOL = Symbol.for("port_rpc_proxy_owner"), t.PROXY_ID_FIELD = "__id__", t.PING_TIMEOUT = 2e3, t.READY_PROBE_TYPE = "__port_rpc_ready_probe__", t.READY_TYPE = "__port_rpc_ready__", t.READY_PROBE_INTERVAL = 100, t.READY_TIMEOUT = 5e3;
            let r = 0;
            t.uniqueID = ()=>`uid_${Math.random().toString(36).substring(2)}_${++r}`;
        },
        441 (e, t) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.RoutingError = t.VerificationError = t.DuplicateListenerError = t.HandlerNotFoundError = t.ConnectionClosedError = t.TimeoutError = t.PortRpcError = void 0;
            class r extends Error {
                constructor(e, t = "PORT_RPC_ERROR"){
                    super(e), this.code = t, this.name = "PortRpcError";
                }
            }
            t.PortRpcError = r, t.TimeoutError = class extends r {
                constructor(e = "Operation timed out"){
                    super(e, "TIMEOUT"), this.name = "TimeoutError";
                }
            }, t.ConnectionClosedError = class extends r {
                constructor(e = "Connection is closed"){
                    super(e, "CONNECTION_CLOSED"), this.name = "ConnectionClosedError";
                }
            }, t.HandlerNotFoundError = class extends r {
                constructor(e){
                    super(`No handler registered for "${e}"`, "HANDLER_NOT_FOUND"), this.name = "HandlerNotFoundError";
                }
            }, t.DuplicateListenerError = class extends r {
                constructor(e){
                    super(`A listener is already registered for "${e}"`, "DUPLICATE_LISTENER"), this.name = "DuplicateListenerError";
                }
            }, t.VerificationError = class extends r {
                constructor(e = "Verification failed"){
                    super(e, "VERIFICATION_FAILED"), this.name = "VerificationError";
                }
            }, t.RoutingError = class extends r {
                constructor(e = "Routing failed"){
                    super(e, "ROUTING_FAILED"), this.name = "RoutingError";
                }
            };
        },
        629 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.forward = void 0;
            const n = r(930);
            t.forward = (e, t)=>(0, n.registerForwardResolver)(e, t);
        },
        690 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.resolveTarget = t.isWindow = void 0;
            const n = r(441);
            t.isWindow = (e)=>{
                if (!e) return !1;
                try {
                    const t = e;
                    return "function" == typeof t.postMessage && "object" == typeof t.self && null !== t.self;
                } catch (e) {
                    return e instanceof DOMException && "SecurityError" === e.name;
                }
            }, t.resolveTarget = (e, r, o = "connect")=>{
                if ("undefined" != typeof HTMLIFrameElement && e instanceof HTMLIFrameElement) {
                    const t = e.contentWindow;
                    if (!t) throw new n.PortRpcError(`Cannot ${o}: iframe has no contentWindow (not yet loaded?)`);
                    return {
                        post (e, n) {
                            t.postMessage(e, r, n);
                        }
                    };
                }
                if ("undefined" != typeof Worker && e instanceof Worker) return {
                    post (t, r) {
                        e.postMessage(t, r);
                    }
                };
                if ((0, t.isWindow)(e)) return {
                    post (t, n) {
                        e.postMessage(t, r, n);
                    }
                };
                throw new n.PortRpcError(`Unsupported ${o} target`);
            };
        },
        906 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.serialize = void 0;
            const n = r(438);
            t.serialize = (e, t, r, n = new WeakSet())=>{
                if (null == e) return e;
                if ("function" == typeof e) return i(e, t, r);
                if (e instanceof Error) return s(e);
                if (e instanceof RegExp) return c(e);
                if (e instanceof Date || e instanceof ArrayBuffer || ArrayBuffer.isView(e)) return e;
                if ("object" == typeof e) {
                    if (n.has(e)) return;
                    n.add(e);
                    const i = o(e, t, r, n);
                    return n.delete(e), i;
                }
                return "symbol" != typeof e ? e : void 0;
            };
            const o = (e, r, n, o)=>{
                if (Array.isArray(e)) return e.map((e)=>(0, t.serialize)(e, r, n, o));
                if (e instanceof Map) {
                    const i = new Map();
                    for (const [s, c] of e)i.set(s, (0, t.serialize)(c, r, n, o));
                    return i;
                }
                if (e instanceof Set) {
                    const i = new Set();
                    for (const s of e)i.add((0, t.serialize)(s, r, n, o));
                    return i;
                }
                const i = {};
                for (const s of Object.keys(e))i[s] = (0, t.serialize)(e[s], r, n, o);
                return i;
            }, i = (e, t, r)=>{
                const o = e, i = o[n.PROXY_ID_SYMBOL];
                if (i && "string" == typeof i) {
                    const s = o[n.PROXY_OWNER_SYMBOL];
                    if (void 0 === s || s === t) return {
                        __type__: "port_rpc_function",
                        __id__: i,
                        __name__: e.name || "anonymous"
                    };
                    const c = r.get(e) ?? (0, n.uniqueID)();
                    return r.set(e, c), t.set(c, e), {
                        __type__: "port_rpc_function",
                        __id__: c,
                        __name__: e.name || "anonymous"
                    };
                }
                const s = r.get(e);
                if (s) return {
                    __type__: "port_rpc_function",
                    __id__: s,
                    __name__: e.name || "anonymous"
                };
                const c = e[n.PROXY_ID_FIELD] || (0, n.uniqueID)();
                return r.set(e, c), t.set(c, e), {
                    __type__: "port_rpc_function",
                    __id__: c,
                    __name__: e.name || "anonymous"
                };
            }, s = (e)=>({
                    __type__: "port_rpc_error",
                    message: e.message,
                    stack: e.stack,
                    code: e.code,
                    name: e.name
                }), c = (e)=>({
                    __type__: "port_rpc_regex",
                    source: e.source,
                    flags: e.flags
                });
        },
        930 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t._resetDispatcher = t.registerForwardResolver = t.onConnect = t.accept = void 0;
            const n = r(438), o = r(402), i = r(441), s = r(690), c = [], a = [];
            let d = null, u = null;
            const l = ()=>"undefined" != typeof DedicatedWorkerGlobalScope && self instanceof DedicatedWorkerGlobalScope, f = ()=>{
                if (d) return;
                const e = (()=>{
                    if (l()) return self;
                    if ("undefined" != typeof window) return window;
                    throw new i.PortRpcError("Cannot detect accept/forward context");
                })(), t = (e)=>{
                    const t = e.data;
                    if (t?.type === n.READY_PROBE_TYPE) {
                        const r = l() ? "worker" : e.origin ?? "unknown";
                        return void (w(r) && R(e, t.nonce ?? ""));
                    }
                    m(e);
                };
                u = e, d = t, e.addEventListener("message", t);
            }, _ = ()=>{
                u && d && u.removeEventListener("message", d), u = null, d = null;
            }, p = (e, t)=>{
                const r = e.indexOf(t);
                return -1 !== r && (e.splice(r, 1), 0 === c.length && 0 === a.length && _(), !0);
            }, h = async (e, t, r, n)=>e.consumed ? "next" : !e.allowedOrigins || l() || e.allowedOrigins.includes(n) ? e.matcher ? E(e, t, r) : (e.resolve && (e.consumed = !0), y(t, !0), g(e, new o.ConnectionImpl(t, e.connectionOptions), r), "consumed") : "next", E = async (e, t, r)=>{
                let n;
                try {
                    n = await e.matcher(r);
                } catch  {
                    return "next";
                }
                return !1 === n ? "next" : e.consumed ? "restart" : (e.resolve && (e.consumed = !0), y(t, "object" != typeof n || n), g(e, new o.ConnectionImpl(t, e.connectionOptions), r), "consumed");
            }, m = async (e)=>{
                const t = e.data;
                if (!t || t.type !== n.HANDSHAKE_MSG_TYPE) return;
                const r = e.ports?.[0];
                if (!r) return;
                const o = "context" in t && null != t.context ? t.context : void 0, i = l() ? "worker" : e.origin ?? "unknown";
                if (o && await (async (e, t, r)=>{
                    for (const n of [
                        ...c
                    ]){
                        if (n.options?.allowedOrigins && !l() && !n.options.allowedOrigins.includes(r)) continue;
                        let o;
                        try {
                            o = await n.resolver(t);
                        } catch (t) {
                            return T(e, t instanceof Error ? t.message : String(t)), !0;
                        }
                        if (null != o) return O(e, t, o, r), !0;
                    }
                    return !1;
                })(r, o, i)) return;
                const s = o ? {
                    ...o,
                    origin: i
                } : {
                    origin: i
                };
                if (!await (async (e, t, r)=>{
                    let n = !1;
                    do {
                        n = !1;
                        for (const o of a){
                            const i = await h(o, e, t, r);
                            if ("consumed" === i) return !0;
                            if ("restart" === i) {
                                n = !0;
                                break;
                            }
                        }
                    }while (n);
                    return !1;
                })(r, s, i)) try {
                    r.close();
                } catch  {}
            }, g = (e, t, r)=>{
                e.resolve ? (p(a, e), e.resolve(t, r)) : e.handler && e.handler(t, r);
            }, y = (e, t)=>{
                const r = {
                    type: n.HANDSHAKE_ACK_TYPE,
                    verificationData: t
                };
                try {
                    e.postMessage(r);
                } catch  {}
            }, T = (e, t)=>{
                const r = {
                    type: n.ROUTE_REJECT_TYPE,
                    error: t
                };
                try {
                    e.postMessage(r);
                } catch  {}
            }, w = (e)=>{
                if (l()) return !0;
                for (const t of a)if (!t.allowedOrigins || t.allowedOrigins.includes(e)) return !0;
                for (const t of c)if (!t.options?.allowedOrigins || t.options.allowedOrigins.includes(e)) return !0;
                return !1;
            }, R = (e, t)=>{
                const r = {
                    type: n.READY_TYPE,
                    nonce: t
                };
                if (l()) {
                    try {
                        self.postMessage(r);
                    } catch  {}
                    return;
                }
                const o = e.source;
                if (o && "function" == typeof o.postMessage) try {
                    o.postMessage(r, e.origin || "*");
                } catch  {}
            }, O = (e, t, r, o)=>{
                const i = {
                    ...t,
                    origin: o
                }, c = r.origin ?? "*", a = {
                    type: n.HANDSHAKE_MSG_TYPE,
                    context: i
                };
                try {
                    (0, s.resolveTarget)(r.target, c, "forward").post(a, [
                        e
                    ]);
                } catch (t) {
                    T(e, `Forward failed: ${t instanceof Error ? t.message : String(t)}`);
                }
            };
            t.accept = (e)=>{
                f();
                const t = e?.timeout ?? n.HANDSHAKE_TIMEOUT;
                return new Promise((r, n)=>{
                    const o = {
                        matcher: e?.matcher,
                        allowedOrigins: e?.allowedOrigins,
                        connectionOptions: e?.connectionOptions,
                        resolve: (e)=>{
                            clearTimeout(s), r(e);
                        },
                        reject: n
                    };
                    a.push(o);
                    const s = setTimeout(()=>{
                        o.consumed || (p(a, o), n(new i.TimeoutError(`Accept timeout: no connection received within ${t}ms`)));
                    }, t);
                });
            }, t.onConnect = (e, t)=>{
                f();
                const r = new Set(), n = {
                    matcher: t?.matcher,
                    allowedOrigins: t?.allowedOrigins,
                    connectionOptions: t?.connectionOptions,
                    handler: (t, n)=>{
                        r.add(t), t.onDisconnect(()=>{
                            r.delete(t);
                        }), e(t, n);
                    }
                };
                a.push(n);
                const o = {
                    connections: r,
                    cancel () {
                        p(a, n);
                    },
                    destroyAll () {
                        o.cancel();
                        for (const e of [
                            ...r
                        ])e.destroy();
                        r.clear();
                    }
                };
                return o;
            }, t.registerForwardResolver = (e, t)=>{
                f();
                const r = {
                    resolver: e,
                    options: t
                };
                return c.push(r), {
                    cancel () {
                        p(c, r);
                    }
                };
            }, t._resetDispatcher = ()=>{
                for (const e of a)e.consumed = !0;
                c.length = 0, a.length = 0, _();
            };
        }
    }, t = {};
    function r(n) {
        var o = t[n];
        if (void 0 !== o) return o.exports;
        var i = t[n] = {
            exports: {}
        };
        return e[n](i, i.exports, r), i.exports;
    }
    r.d = (e, t)=>{
        for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
            enumerable: !0,
            get: t[n]
        });
    }, r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    };
    var n = {};
    r.r(n), r.d(n, {
        createEmbeddedMacroBridgeListener: ()=>_,
        createEmbeddedMacroListener: ()=>p,
        createIframeBridge: ()=>f,
        createWorkerBridge: ()=>E,
        establishConnectionWithProductHost: ()=>h,
        setupSandboxController: ()=>m
    });
    var o = r(304), i = function(e) {
        return "HANDLER_NOT_FOUND" === (null == e ? void 0 : e.code) || (null == e ? void 0 : e.message.startsWith("No handler found for post message:")) ? Promise.resolve() : Promise.reject("Error while sending bridge message: ".concat(null == e ? void 0 : e.message));
    }, s = "__ready", c = 2e4, a = 1e4, d = function(e, t) {
        return Object.entries(t).map(function(t) {
            var r = t[0], n = t[1];
            return e.on(r, function(e) {
                return n ? n(e) : Promise.resolve();
            });
        });
    }, u = function(e, t, r, n) {
        e.send(s, t, {
            timeout: c,
            ackTimeout: !1
        }).then(function() {
            r(!0);
        }).catch(function(e) {
            return r(!1, e), i(e);
        }).catch(function(e) {
            console.error(n, e);
        });
    }, l = function() {
        return l = Object.assign || function(e) {
            for(var t, r = 1, n = arguments.length; r < n; r++)for(var o in t = arguments[r])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
        }, l.apply(this, arguments);
    }, f = function(e) {
        if (!e.withWindow) throw new Error("Target window to setup the bridge with is not defined");
        return {
            open: function() {
                var t = e.withWindow, r = e.withDomain, n = e.features, f = e.theme, _ = e.surfaceColor, p = e.sendHandshakeMetric, h = e.metadata, E = e.shouldWaitForReady;
                return (0, o._4)(t, {
                    origin: r,
                    timeout: c,
                    connectionOptions: {
                        ackTimeout: a
                    },
                    waitForReady: E,
                    context: {
                        type: "iframe-bridge",
                        metadata: h
                    }
                }).then(function(e) {
                    var t = d(e, n), r = e.on(s, function() {
                        return null;
                    });
                    return u(e, l({
                        theme: f,
                        surfaceColor: _
                    }, h || {}), p, "Iframe bridge: unexpected error in READY_EVENT handler:"), {
                        enableTheming: function() {
                            e.send("__theme_enable", null).catch(i);
                        },
                        setTheme: function(t, r, n) {
                            e.send("__theme_change", {
                                theme: t,
                                surfaceColor: r,
                                env: n,
                                isFedRamp: null == h ? void 0 : h.isFedRamp
                            }).catch(i);
                        },
                        close: function() {
                            r.cancel(), t.forEach(function(e) {
                                return (0, e.cancel)();
                            }), e.destroy();
                        }
                    };
                });
            }
        };
    }, _ = function(e) {
        var t = window.location.origin;
        return (0, o.GJ)(function(t) {
            d(t, e);
        }, {
            matcher: function(e) {
                return "embeddedMacro" === e.type && e.origin === t && {
                    origin: t
                };
            }
        });
    }, p = function(e) {
        var t = _(e);
        return {
            close: function() {
                return t.destroyAll();
            }
        };
    }, h = function(e, t, r) {
        return (0, o._4)(e, {
            timeout: c,
            connectionOptions: {
                ackTimeout: a
            },
            waitForReady: r,
            context: {
                type: "embeddedMacro",
                origin: t
            },
            verify: function(e) {
                return e.origin === t;
            }
        });
    }, E = function(e) {
        if (!e.withWindow) throw new Error("Target window to setup the bridge with is not defined");
        return {
            open: function() {
                var t = e.withWindow, r = e.withDomain, n = e.features, i = e.sendHandshakeMetric, s = e.metadata, l = e.workerId, f = e.shouldWaitForReady;
                return (0, o._4)(t, {
                    origin: r,
                    timeout: c,
                    connectionOptions: {
                        ackTimeout: a
                    },
                    waitForReady: f,
                    context: {
                        type: "worker-bridge",
                        workerId: l,
                        metadata: s
                    }
                }).then(function(e) {
                    var t = d(e, n);
                    return u(e, null, i, "Worker bridge: unexpected error in READY_EVENT handler:"), {
                        enableTheming: function() {},
                        setTheme: function() {},
                        close: function() {
                            t.forEach(function(e) {
                                return (0, e.cancel)();
                            }), e.destroy();
                        }
                    };
                });
            }
        };
    }, m = function(e, t, r) {
        return (0, o._4)(e, {
            origin: t,
            timeout: 1e4,
            connectionOptions: {
                ackTimeout: a
            },
            waitForReady: r
        }).then(function(e) {
            return e.send("__sandbox_controller_request", null, {
                timeout: 1e4,
                ackTimeout: !1
            }).then(function(t) {
                return {
                    controller: t,
                    destroy: function() {
                        return e.destroy();
                    }
                };
            }).catch(function(r) {
                throw e.destroy(), new Error("Sandbox did not provide a controller (origin: ".concat(t, "): ").concat(r.message));
            });
        }, function(e) {
            throw new Error("Sandbox handshake failed (origin: ".concat(t, "): ").concat(e.message));
        });
    };
    module.exports = n;
})();

});

parcelRegister("d6OEY", function(module, exports) {
const $ac4d985363480f50$export$5dfdba3e408a8d60 = (extension, entryPoint)=>{
    const entryPointProperties = entryPoint ? extension.properties[entryPoint] : extension.properties;
    // The entry point owns the resource+entry pair only when it declares its own resource bundle.
    if (entryPointProperties?.resource) return {
        resource: entryPointProperties.resource,
        resolvedResourceEntry: entryPointProperties.resolvedResourceEntry
    };
    // Otherwise borrow the top-level resource bundle, served at its default entry (no entry carried over).
    return {
        resource: extension.properties.resource,
        resolvedResourceEntry: undefined
    };
};
module.exports["getExtensionEntryPoint"] = $ac4d985363480f50$export$5dfdba3e408a8d60;

});

parcelRegister("givIf", function(module, exports) {

var $jP2xl = parcelRequire("jP2xl");


var $lJt1v = parcelRequire("lJt1v");


var $8IpiJ = parcelRequire("8IpiJ");

/**
 * Middlewares applied to every bridge method across all runtimes.
 * Order is outermost-first: the first entry wraps all subsequent ones.
 *
 * `withErrorDisplay` is outermost so it catches errors after `withMetrics` has
 * reported them (Sentry/analytics), then surfaces an error from the Forge app for
 * classified `ForgeAppError`s before the error continues rejecting to the app.
 */ const $8b3fc3db8a473e08$var$DEFAULT_MIDDLEWARES = [
    (0, $8IpiJ.withErrorDisplay),
    (0, $lJt1v.withMetrics)
];
const $8b3fc3db8a473e08$var$applyMiddleware = (method, methodName, middlewares)=>middlewares.reduceRight((m, mw)=>mw(m, methodName), method);
const $8b3fc3db8a473e08$export$35cddec71f2b332c = (getBridgeContext, adaptBridgeMethods, adaptMiddlewares = (defaults)=>defaults)=>{
    const middlewares = adaptMiddlewares([
        ...$8b3fc3db8a473e08$var$DEFAULT_MIDDLEWARES
    ]);
    const bridgeMethods = adaptBridgeMethods ? adaptBridgeMethods((0, $jP2xl.bridgeMethods)) : (0, $jP2xl.bridgeMethods);
    return Object.entries(bridgeMethods).reduce((features, [methodName, method])=>{
        const wrapped = $8b3fc3db8a473e08$var$applyMiddleware(method, methodName, middlewares);
        features[methodName] = $8b3fc3db8a473e08$var$convertToBridgeInvokeHandler((payload)=>{
            // Call getBridgeContext() at invocation time, not creation time, so each
            // bridge call always uses the latest context rather than a stale snapshot.
            return wrapped(getBridgeContext(), payload);
        });
        return features;
    }, {});
};
const $8b3fc3db8a473e08$var$convertToBridgeInvokeHandler = (method)=>{
    return async ({ data: data })=>{
        if (method) return await method(data) ?? true;
        return false;
    };
};
module.exports["createBridgeFeatures"] = $8b3fc3db8a473e08$export$35cddec71f2b332c;

});

parcelRegister("2fpEe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5xQdV = parcelRequire("5xQdV");


var $gwFiU = parcelRequire("gwFiU");


var $1uMa2 = parcelRequire("1uMa2");

const $8b80dbb6e430cd00$export$e28a9b61f2b3f391 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props, getServices, contextChangeListeners)=>{
    const $ = (0, $bDgLe.c)(25);
    const contextObjectRef = (0, $cozmU.useRef)(null);
    if (contextObjectRef.current === null) {
        let t0;
        if ($[0] !== getServices || $[1] !== props) {
            t0 = new (0, $gwFiU.BridgeContextObject)(props, getServices);
            $[0] = getServices;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        contextObjectRef.current = t0;
    }
    let t0;
    if ($[3] !== props) {
        t0 = ()=>{
            contextObjectRef.current.update(props);
        };
        $[3] = props;
        $[4] = t0;
    } else t0 = $[4];
    (0, $cozmU.useEffect)(t0);
    let t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>contextObjectRef.current.get();
        t2 = [];
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    const getBridgeContext = (0, $5xQdV.useCallbackOne)(t1, t2);
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>contextObjectRef.current.destroy();
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    const destroy = (0, $5xQdV.useCallbackOne)(t3, t4);
    let t5;
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (listener)=>contextObjectRef.current.onChange(listener);
        t6 = [];
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    const onChange = (0, $5xQdV.useCallbackOne)(t5, t6);
    let t7;
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (controls)=>contextObjectRef.current.setBridgeControl(controls);
        t8 = [];
        $[11] = t7;
        $[12] = t8;
    } else {
        t7 = $[11];
        t8 = $[12];
    }
    const setBridgeControl = (0, $5xQdV.useCallbackOne)(t7, t8);
    let t10;
    let t9;
    if ($[13] !== onChange) {
        t9 = ()=>onChange($8b80dbb6e430cd00$var$_temp);
        t10 = [
            onChange
        ];
        $[13] = onChange;
        $[14] = t10;
        $[15] = t9;
    } else {
        t10 = $[14];
        t9 = $[15];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    let t12;
    if ($[16] !== contextChangeListeners || $[17] !== onChange) {
        t11 = ()=>{
            if (!contextChangeListeners?.length) return;
            const unsubs = contextChangeListeners.map((listener_0)=>onChange(listener_0));
            return ()=>unsubs.forEach($8b80dbb6e430cd00$var$_temp2);
        };
        t12 = [
            onChange,
            contextChangeListeners
        ];
        $[16] = contextChangeListeners;
        $[17] = onChange;
        $[18] = t11;
        $[19] = t12;
    } else {
        t11 = $[18];
        t12 = $[19];
    }
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    if ($[20] !== destroy || $[21] !== getBridgeContext || $[22] !== onChange || $[23] !== setBridgeControl) {
        t13 = {
            getBridgeContext: getBridgeContext,
            destroy: destroy,
            onChange: onChange,
            setBridgeControl: setBridgeControl
        };
        $[20] = destroy;
        $[21] = getBridgeContext;
        $[22] = onChange;
        $[23] = setBridgeControl;
        $[24] = t13;
    } else t13 = $[24];
    return t13;
} : (props, getServices, contextChangeListeners)=>{
    // Created once for the lifetime of the component.
    // BridgeContextObject owns all memoization and change notification internally.
    const contextObjectRef = (0, $cozmU.useRef)(null);
    if (contextObjectRef.current === null) contextObjectRef.current = new (0, $gwFiU.BridgeContextObject)(props, getServices);
    // Update after every commit. Bridge calls arrive via postRobot (async message events)
    // so the context will always be current before any bridge method is invoked.
    (0, $cozmU.useEffect)(()=>{
        contextObjectRef.current.update(props);
    });
    const getBridgeContext = (0, $5xQdV.useCallbackOne)(()=>contextObjectRef.current.get(), []);
    const destroy = (0, $5xQdV.useCallbackOne)(()=>contextObjectRef.current.destroy(), []);
    const onChange = (0, $5xQdV.useCallbackOne)((listener)=>contextObjectRef.current.onChange(listener), []);
    const setBridgeControl = (0, $5xQdV.useCallbackOne)((controls)=>contextObjectRef.current.setBridgeControl(controls), []);
    // This registers general bridge context change events that is common to all
    // bridge runtimes and Forge modules.
    (0, $cozmU.useEffect)(()=>{
        return onChange((_prev, next, changes)=>{
            if (changes.theme || changes.surfaceColor) (0, $1uMa2.emit)('FORGE_CORE_THEME_CHANGED', {
                theme: next.theme
            });
        });
    }, [
        onChange
    ]);
    // Register integrator-supplied context change listeners (e.g. from xen-editor-provider).
    // Listeners must be stable module-level references to avoid re-registration on each render.
    (0, $cozmU.useEffect)(()=>{
        if (!contextChangeListeners?.length) return;
        const unsubs = contextChangeListeners.map((listener_0)=>onChange(listener_0));
        return ()=>unsubs.forEach((unsub)=>unsub());
    }, [
        onChange,
        contextChangeListeners
    ]);
    return {
        getBridgeContext: getBridgeContext,
        destroy: destroy,
        onChange: onChange,
        setBridgeControl: setBridgeControl
    };
};
function $8b80dbb6e430cd00$var$_temp(_prev, next, changes) {
    if (changes.theme || changes.surfaceColor) (0, $1uMa2.emit)("FORGE_CORE_THEME_CHANGED", {
        theme: next.theme
    });
}
function $8b80dbb6e430cd00$var$_temp2(unsub) {
    return unsub();
}
module.exports["useBridgeContext"] = $8b80dbb6e430cd00$export$e28a9b61f2b3f391;

});

parcelRegister("lHaWf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $6FQr4 = parcelRequire("6FQr4");


var $3nNWm = parcelRequire("3nNWm");


var $lBErP = parcelRequire("lBErP");


var $eL3mC = parcelRequire("eL3mC");


var $6ojvx = parcelRequire("6ojvx");


var $2MUrL = parcelRequire("2MUrL");


var $igFAK = parcelRequire("igFAK");


var $2lRPc = parcelRequire("2lRPc");


var $hdBxM = parcelRequire("hdBxM");

const $46313ec0e9937195$var$ROVO_TOPIC = 'ai-mate';
const $46313ec0e9937195$export$74964fd55d087734 = (props, overlayController, renderThreeLOPrompt, showAppError)=>{
    // renderThreeLOPrompt is read from props at service-assembly time (see servicesRef below).
    const invoker = (0, $lBErP.useInvokeExtension)(props.contextIds, props.extension.id);
    const tracing = (0, $eL3mC.useTracingContext)();
    const environment = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $6ojvx.EnvironmentContext));
    const relayContext = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $6SsN4.ReactRelayContext));
    const isAnonymousAccessSupportedByApp = props.extension.properties?.unlicensedAccess?.includes('anonymous') ?? false;
    // Adapts the two-argument renderThreeLOPrompt into the single-argument shape
    // expected by useProductFetchClient. Falls back to a no-op when the extension
    // has no consentUrl (e.g. sandbox/test environments).
    const productRenderThreeLOPrompt = (retry)=>{
        const consentUrl = props.extension.consentUrl;
        if (!consentUrl) return Promise.resolve();
        return renderThreeLOPrompt(consentUrl, retry);
    };
    const remoteFetchClient = (0, $2lRPc.useRemoteFetchClient)();
    const permissionFetchClient = (0, $igFAK.usePermissionFetchClient)({
        appId: props.appId,
        installationId: props.extension.installationId,
        contextIds: props.contextIds,
        extensionId: props.extension.id,
        renderThreeLOPrompt: productRenderThreeLOPrompt
    });
    const productFetchClient = (0, $2MUrL.useProductFetchClient)({
        appId: props.appId,
        environment: environment,
        contextIds: props.contextIds,
        cloudId: props.coreData.cloudId,
        workspaceId: props.coreData.workspaceId,
        extensionId: props.extension.id,
        isAnonymousAccessSupportedByApp: isAnonymousAccessSupportedByApp,
        renderThreeLOPrompt: productRenderThreeLOPrompt
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const analyticsTracker = (0, $6FQr4.useForgeUiAnalyticsEvent)();
    const { captureUntrustedEvent: captureUntrustedEvent } = (0, $3nNWm.usePerformanceAnalytics)();
    const rovoPublisher = (0, $hdBxM.usePublish)($46313ec0e9937195$var$ROVO_TOPIC);
    // All hook calls must precede the tracing guard below.
    // servicesRef holds the latest assembled BridgeServices snapshot and is updated
    // synchronously every render. The stable getter reads from it at bridge-call time,
    // so every service (invoker, getContextToken, productFetchClient, etc.) is always
    // current — regardless of which dep changed — without per-service ref boilerplate.
    const servicesRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const getServices = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(()=>servicesRef.current).current;
    if (!tracing) throw new Error('WorkerWebRuntime: TracingProvider not found in the component tree. ');
    if (!relayContext?.environment) throw new Error('useBridgeServices: RelayEnvironmentProvider not found in the component tree.');
    // Assembled fresh every render; updates the ref synchronously so any in-flight
    // bridge call that fires after this render always sees the latest values.
    servicesRef.current = {
        invoker: invoker,
        getContextToken: props.getContextToken ?? $46313ec0e9937195$var$nullGetContextToken,
        tracing: tracing,
        overlayController: overlayController,
        onThreeLO: renderThreeLOPrompt,
        showAppError: showAppError,
        productFetchClient: productFetchClient,
        permissionFetchClient: permissionFetchClient,
        remoteFetchClient: remoteFetchClient,
        relayEnvironment: relayContext.environment,
        analytics: {
            createAnalyticsEvent: createAnalyticsEvent,
            fireUIEvent: (payload)=>(0, $6FQr4.fireUIEvent)(createAnalyticsEvent, payload),
            tracker: analyticsTracker,
            captureUntrustedEvent: captureUntrustedEvent
        },
        rovoPublisher: rovoPublisher
    };
    return {
        getServices: getServices
    };
};
// TODO: currently sandbox does not support getContextToken (unlike other products),
// so we provide a noop implementation to avoid having to guard every bridge method that uses it.
const $46313ec0e9937195$var$nullGetContextToken = ()=>undefined;
module.exports["useBridgeServices"] = $46313ec0e9937195$export$74964fd55d087734;

});

parcelRegister("3mbzJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $aa0e79db171987e6$export$38896ac4f3cfe88b = ()=>{
    const [overlayContent, setOverlayContent] = (0, $cozmU.useState)(null);
    const [isOverlayOpen, setIsOverlayOpen] = (0, $cozmU.useState)(false);
    const [affectsLayout, setAffectsLayout] = (0, $cozmU.useState)(false);
    // Stable object — never recreated, always points at the current setter.
    const overlayControllerRef = (0, $cozmU.useRef)({
        show: (content, willAffectsLayout = false)=>{
            setOverlayContent(content);
            setAffectsLayout(willAffectsLayout);
            setIsOverlayOpen(true);
        },
        hide: ()=>setIsOverlayOpen(false)
    });
    const overlay = isOverlayOpen ? overlayContent : null;
    return {
        overlay: overlay,
        overlayController: overlayControllerRef.current,
        isInlineActive: affectsLayout && isOverlayOpen
    };
};
module.exports["useRuntimeOverlayController"] = $aa0e79db171987e6$export$38896ac4f3cfe88b;

});

parcelRegister("acDpC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5xQdV = parcelRequire("5xQdV");


var $4AVLc = parcelRequire("4AVLc");

const $19e98a53c3da397e$export$52e78aa5a2993420 = ({ overlayController: overlayController, extension: extension, setShouldShowRenderer: setShouldShowRenderer, onError: onError })=>{
    // Always-current values so the stable callback never reads stale props.
    const latestRef = (0, $cozmU.useRef)({
        overlayController: overlayController,
        extension: extension,
        setShouldShowRenderer: setShouldShowRenderer,
        onError: onError
    });
    latestRef.current = {
        overlayController: overlayController,
        extension: extension,
        setShouldShowRenderer: setShouldShowRenderer,
        onError: onError
    };
    return (0, $5xQdV.useCallbackOne)((error)=>{
        const { overlayController: overlayController_0, extension: extension_0, setShouldShowRenderer: setShouldShowRenderer_0, onError: onError_0 } = latestRef.current;
        overlayController_0.show(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AVLc.ForgeAppErrorMessage), {
            extension: extension_0,
            error: error.errorType
        }), true);
        setShouldShowRenderer_0?.(false);
        // Notify the product. Display is handled above; in UIKit `setShouldShowRenderer(false)` keeps
        // RendererNext suppressed, so this only fires the `onError`/`onAppError` side-effects.
        onError_0?.(error.errorType);
    }, []);
};
module.exports["useRuntimeErrorOverlay"] = $19e98a53c3da397e$export$52e78aa5a2993420;

});

parcelRegister("eYWSl", function(module, exports) {
const $251e61029d2aac88$export$f4f2aa6cb4b9798b = (method)=>async (_ctx, payload)=>{
        return await method(payload);
    };
const $251e61029d2aac88$export$19e15058b637a8c7 = (baseBridgeMethods, legacyCustomBridgeMethods, customBridge)=>{
    if (!legacyCustomBridgeMethods && !customBridge) return baseBridgeMethods;
    const convertedLegacyMethods = legacyCustomBridgeMethods ? Object.entries(legacyCustomBridgeMethods).reduce((acc, [methodName, method])=>{
        acc[methodName] = $251e61029d2aac88$export$f4f2aa6cb4b9798b(method);
        return acc;
    }, {}) : {};
    return {
        ...baseBridgeMethods,
        ...convertedLegacyMethods,
        ...customBridge
    };
};
module.exports["consolidateCustomBridge"] = $251e61029d2aac88$export$19e15058b637a8c7;

});

parcelRegister("bxg0J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5xQdV = parcelRequire("5xQdV");

/**
 * Snapshots the method names in `ref` but resolves each implementation from `ref.current` at call
 * time. `undefined` when empty, so `consolidateCustomBridge` keeps its "no custom methods" fast path.
 */ const $19d7d930990bf420$var$toLiveMethodMap = (ref)=>{
    const current = ref.current;
    if (!current) return undefined;
    return Object.keys(current).reduce((acc, methodName)=>{
        acc[methodName] = (...args)=>ref.current?.[methodName]?.(...args);
        return acc;
    }, {});
};
const $19d7d930990bf420$export$70ff6cde1420714f = (methods)=>{
    const ref = (0, $cozmU.useRef)(methods);
    ref.current = methods; // keep in sync with the latest props every render
    // Stable identity: the liveness lives in the wrappers, so the getter never needs to change.
    return (0, $5xQdV.useCallbackOne)(()=>$19d7d930990bf420$var$toLiveMethodMap(ref), []);
};
module.exports["useLiveMethodMap"] = $19d7d930990bf420$export$70ff6cde1420714f;

});

parcelRegister("foY7i", function(module, exports) {
const $8cbebdeba4198532$var$uuidRe = new RegExp('^{([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})}$');
const $8cbebdeba4198532$export$3a1a8bfb58a690be = (uuid)=>{
    const match = $8cbebdeba4198532$var$uuidRe.exec(uuid);
    if (!match) return '';
    return match[1];
};
module.exports["uncurlyUuid"] = $8cbebdeba4198532$export$3a1a8bfb58a690be;

});

parcelRegister("5z7ti", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $52f29010a7f095d6$export$61945ff869c3ddb = /*#__PURE__*/ (0, $cozmU.createContext)({
    frameCount: 0,
    setFrameCount: ()=>{}
});
const $52f29010a7f095d6$var$FrameCountProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children } = t0;
    const [frameCount, setFrameCount] = (0, $cozmU.useState)(0);
    let t1;
    if ($[0] !== frameCount) {
        t1 = {
            frameCount: frameCount,
            setFrameCount: setFrameCount
        };
        $[0] = frameCount;
        $[1] = t1;
    } else t1 = $[1];
    const value = t1;
    let t2;
    let t3;
    if ($[2] !== frameCount) {
        t2 = ()=>{
            if (frameCount > 1) throw new Error("Max limit of one frame component per module.");
        };
        t3 = [
            frameCount
        ];
        $[2] = frameCount;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[5] !== children || $[6] !== value) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52f29010a7f095d6$export$61945ff869c3ddb.Provider, {
            value: value
        }, children);
        $[5] = children;
        $[6] = value;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children })=>{
    const [frameCount, setFrameCount] = (0, $cozmU.useState)(0);
    const value = {
        frameCount: frameCount,
        setFrameCount: setFrameCount
    };
    (0, $cozmU.useEffect)(()=>{
        if (frameCount > 1) throw new Error('Max limit of one frame component per module.');
    }, [
        frameCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52f29010a7f095d6$export$61945ff869c3ddb.Provider, {
        value: value
    }, children);
};
var $52f29010a7f095d6$export$2e2bcd8739ae039 = $52f29010a7f095d6$var$FrameCountProvider;
module.exports["FrameCount"] = $52f29010a7f095d6$export$61945ff869c3ddb;
module.exports["default"] = $52f29010a7f095d6$export$2e2bcd8739ae039;

});

parcelRegister("5Zman", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1G3WB = parcelRequire("1G3WB");


var $rECdA = parcelRequire("rECdA");

const $aa1199fe6b38d1ca$var$createUserAccessContext = ()=>/*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $aa1199fe6b38d1ca$var$createNoopContext = ()=>/*#__PURE__*/ (0, $cozmU.createContext)({
        accountId: undefined,
        isUserAnonymous: false
    });
const $aa1199fe6b38d1ca$export$45572a5e2c7b827f = (0, $1G3WB.functionWithFG)('forge-ui-allow-anon-rest-calls', $aa1199fe6b38d1ca$var$createUserAccessContext, $aa1199fe6b38d1ca$var$createNoopContext)();
const $aa1199fe6b38d1ca$var$UserAccessProviderImpl = ({ accountId: accountId, children: children })=>{
    const value = (0, $cozmU.useMemo)(()=>{
        return {
            accountId: accountId,
            // Determine whether a user is anonymously accessing the Forge app UI.
            // Future: enhance to incorporate product account types, and Forge
            // decoupled licensing logic.
            get isUserAnonymous () {
                return !accountId;
            }
        };
    }, [
        accountId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aa1199fe6b38d1ca$export$45572a5e2c7b827f.Provider, {
        value: value
    }, children);
};
const $aa1199fe6b38d1ca$export$413b4e1df9bd6693 = (0, $rECdA.componentWithFG)('forge-ui-allow-anon-rest-calls', $aa1199fe6b38d1ca$var$UserAccessProviderImpl, (0, $cozmU.Fragment));
module.exports["UserAccessContext"] = $aa1199fe6b38d1ca$export$45572a5e2c7b827f;
module.exports["UserAccessProvider"] = $aa1199fe6b38d1ca$export$413b4e1df9bd6693;

});

parcelRegister("cuaBm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $doGLo = parcelRequire("doGLo");


var $kSwu1 = parcelRequire("kSwu1");


var $1l0kj = parcelRequire("1l0kj");


var $lMGh1 = parcelRequire("lMGh1");


var $75u2V = parcelRequire("75u2V");


var $iDrrr = parcelRequire("iDrrr");

// TODO: We should make appName non-optional later: http://go/j/AUX-570
// appName was made optional because it isn't in already inserted apps prior to the change in http://go/j/AUX-411
const $37e0f4e4c5d04688$var$defaultPromptMessage = (intl, appName)=>{
    return intl.formatMessage((0, $iDrrr.fg)('product-terminology-refresh') ? $37e0f4e4c5d04688$var$messages.defaultPromptMessageAppify : $37e0f4e4c5d04688$var$messages.defaultPromptMessage, {
        appString: appName ? appName : intl.formatMessage($37e0f4e4c5d04688$var$messages.thisAppLower)
    });
};
const $37e0f4e4c5d04688$var$externalAuthPromptMessage = (intl, appName)=>{
    return intl.formatMessage($37e0f4e4c5d04688$var$messages.externalAuthPromptMessage, {
        appString: appName ? appName : intl.formatMessage($37e0f4e4c5d04688$var$messages.thisAppUpper)
    });
};
const $37e0f4e4c5d04688$export$1d39dc5b47e56ff0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { message: message, promptText: promptText, appName: appName, authUrl: authUrl, onSuccess: onSuccess } = t0;
    const [failedToAuthenticate, setFailedToAuthenticate] = (0, $cozmU.useState)(false);
    const [authFailureMessage, setAuthFailureMessage] = (0, $cozmU.useState)(false);
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== authUrl) {
        t1 = (0, $doGLo.isExternalAuth)(authUrl);
        $[0] = authUrl;
        $[1] = t1;
    } else t1 = $[1];
    const promptIsForExternalAuth = t1;
    const intl = (0, $kSwu1.useIntl)();
    let t2;
    if ($[2] !== authUrl || $[3] !== onSuccess) {
        t2 = ()=>{
            setLoading(true);
            setAuthFailureMessage(false);
            (0, $doGLo.safeAuth)(authUrl).then(()=>{
                onSuccess().then((callbackAfterConsentFlowHasFinished)=>{
                    setLoading(false);
                    setFailedToAuthenticate(false);
                    if (callbackAfterConsentFlowHasFinished && typeof callbackAfterConsentFlowHasFinished === "function") callbackAfterConsentFlowHasFinished();
                });
            }, (err)=>{
                setLoading(false);
                setFailedToAuthenticate(true);
                if ((0, $75u2V.isOfTypeAuthError)(err.type)) setAuthFailureMessage(err.message);
            });
        };
        $[2] = authUrl;
        $[3] = onSuccess;
        $[4] = t2;
    } else t2 = $[4];
    const startAuth = t2;
    let t3;
    if ($[5] !== appName || $[6] !== authFailureMessage || $[7] !== failedToAuthenticate || $[8] !== intl || $[9] !== message || $[10] !== promptIsForExternalAuth) {
        t3 = failedToAuthenticate ? authFailureMessage || intl.formatMessage($37e0f4e4c5d04688$var$messages.defaultFailedToAuthMessage) : message || (promptIsForExternalAuth ? $37e0f4e4c5d04688$var$externalAuthPromptMessage(intl, appName) : $37e0f4e4c5d04688$var$defaultPromptMessage(intl, appName));
        $[5] = appName;
        $[6] = authFailureMessage;
        $[7] = failedToAuthenticate;
        $[8] = intl;
        $[9] = message;
        $[10] = promptIsForExternalAuth;
        $[11] = t3;
    } else t3 = $[11];
    const promptMessage = t3;
    let t4;
    if ($[12] !== intl) {
        t4 = intl.formatMessage($37e0f4e4c5d04688$var$messages.externalAuthWarning);
        $[12] = intl;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
            label: t4,
            color: "var(--ds-icon-warning, #E06C00)",
            spacing: "spacious"
        });
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== promptMessage || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center"
        }, t5, promptMessage);
        $[16] = promptMessage;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    const content = t6;
    let t7;
    if ($[19] !== intl) {
        t7 = intl.formatMessage($37e0f4e4c5d04688$var$messages.configureAccess);
        $[19] = intl;
        $[20] = t7;
    } else t7 = $[20];
    const externalAuthButtonText = t7;
    let t8;
    if ($[21] !== externalAuthButtonText || $[22] !== intl || $[23] !== promptIsForExternalAuth || $[24] !== promptText) {
        t8 = promptText || (promptIsForExternalAuth ? externalAuthButtonText : intl.formatMessage($37e0f4e4c5d04688$var$messages.allowAccess));
        $[21] = externalAuthButtonText;
        $[22] = intl;
        $[23] = promptIsForExternalAuth;
        $[24] = promptText;
        $[25] = t8;
    } else t8 = $[25];
    const buttonText = t8;
    let t9;
    if ($[26] !== buttonText || $[27] !== content || $[28] !== loading || $[29] !== startAuth) {
        t9 = {
            loading: loading,
            startAuth: startAuth,
            promptMessage: content,
            buttonText: buttonText
        };
        $[26] = buttonText;
        $[27] = content;
        $[28] = loading;
        $[29] = startAuth;
        $[30] = t9;
    } else t9 = $[30];
    return t9;
} : ({ message: message, promptText: promptText, appName: appName, authUrl: authUrl, onSuccess: onSuccess, metadata: metadata })=>{
    const [failedToAuthenticate, setFailedToAuthenticate] = (0, $cozmU.useState)(false);
    const [authFailureMessage, setAuthFailureMessage] = (0, $cozmU.useState)(false);
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const promptIsForExternalAuth = (0, $doGLo.isExternalAuth)(authUrl);
    const intl = (0, $kSwu1.useIntl)();
    const startAuth = (0, $cozmU.useCallback)(()=>{
        setLoading(true);
        setAuthFailureMessage(false);
        (0, $doGLo.safeAuth)(authUrl).then(()=>{
            onSuccess().then((callbackAfterConsentFlowHasFinished)=>{
                setLoading(false);
                setFailedToAuthenticate(false);
                if (callbackAfterConsentFlowHasFinished && typeof callbackAfterConsentFlowHasFinished === 'function') callbackAfterConsentFlowHasFinished();
            });
        }, (err)=>{
            setLoading(false);
            setFailedToAuthenticate(true);
            if ((0, $75u2V.isOfTypeAuthError)(err.type)) setAuthFailureMessage(err.message);
        });
    }, [
        authUrl,
        onSuccess,
        setLoading,
        setFailedToAuthenticate,
        setAuthFailureMessage
    ]);
    const promptMessage = failedToAuthenticate ? authFailureMessage || intl.formatMessage($37e0f4e4c5d04688$var$messages.defaultFailedToAuthMessage) : message || (promptIsForExternalAuth ? $37e0f4e4c5d04688$var$externalAuthPromptMessage(intl, appName) : $37e0f4e4c5d04688$var$defaultPromptMessage(intl, appName));
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        label: intl.formatMessage($37e0f4e4c5d04688$var$messages.externalAuthWarning),
        color: "var(--ds-icon-warning, #E06C00)",
        spacing: "spacious"
    }), promptMessage);
    const externalAuthButtonText = intl.formatMessage($37e0f4e4c5d04688$var$messages.configureAccess);
    const buttonText = promptText || (promptIsForExternalAuth ? externalAuthButtonText : intl.formatMessage($37e0f4e4c5d04688$var$messages.allowAccess));
    return {
        loading: loading,
        startAuth: startAuth,
        promptMessage: content,
        buttonText: buttonText
    };
};
const $37e0f4e4c5d04688$var$messages = (0, $kSwu1.defineMessages)({
    defaultPromptMessage: {
        id: "confluence.threeLOPrompt.use-auth.default.prompt.message",
        defaultMessage: "For {appString} to display, you need to allow the app to access Atlassian products on your behalf."
    },
    defaultPromptMessageAppify: {
        id: "confluence.threeLOPrompt.use-auth.default.prompt.message-appify",
        defaultMessage: "For {appString} to display, you need to grant it access to Atlassian apps on your behalf."
    },
    externalAuthPromptMessage: {
        id: "confluence.threeLOPrompt.use-auth.external.auth.prompt.message",
        defaultMessage: "{appString} requires additional access to your account."
    },
    thisAppUpper: {
        id: "confluence.threeLOPrompt.use-auth.this.app.upper.message",
        defaultMessage: "This app"
    },
    thisAppLower: {
        id: "confluence.threeLOPrompt.use-auth.this.app.lower.message",
        defaultMessage: "this app"
    },
    defaultFailedToAuthMessage: {
        id: "confluence.threeLOPrompt.use-auth.default.failed.to.auth.message",
        defaultMessage: "Failed to authenticate."
    },
    externalAuthWarning: {
        id: "confluence.threeLOPrompt.use-auth.external.auth.warning.message",
        defaultMessage: "External Auth Warning"
    },
    configureAccess: {
        id: "confluence.threeLOPrompt.use-auth.configure.access.button.text",
        defaultMessage: "Configure access"
    },
    allowAccess: {
        id: "confluence.threeLOPrompt.use-auth.allow.access.button.text",
        defaultMessage: "Allow access"
    }
});
module.exports["useAuth"] = $37e0f4e4c5d04688$export$1d39dc5b47e56ff0;

});

parcelRegister("jAJ6s", function(module, exports) {

var $7dBf8 = parcelRequire("7dBf8");

const $81c5cbb6dbf0f155$var$SESSION_APPS_KEY = 'forge-ui.seen-app-keys';
/**
 *  This module is used to track the seen app context keys in session storage specifically
 *  for the forge.ui.extension loaded analytic event
 *  - Stores the last accessed date and the seen app context keys in session storage
 *  - The last accessed date is used to determine if the session is expired
 *  - The seen app context keys are used to determine if the event has already been sent
 *  - Session storage is used to avoid sending duplicate events on page refreshes or navigations
 */ let $81c5cbb6dbf0f155$var$storageState = {
    lastUpdated: null,
    appKeys: null
};
// Use a number for faster comparisons
const $81c5cbb6dbf0f155$var$getTodayAsNumberOfDaysSinceEpoch = ()=>{
    return Math.floor(Date.now() / 86400000);
};
const $81c5cbb6dbf0f155$var$checkIsExpired = ()=>{
    const today = $81c5cbb6dbf0f155$var$getTodayAsNumberOfDaysSinceEpoch();
    // If the last updated date is not today, the state has expired and so we reset it
    return today !== $81c5cbb6dbf0f155$var$storageState.lastUpdated;
};
const $81c5cbb6dbf0f155$var$resetState = ()=>{
    $81c5cbb6dbf0f155$var$storageState.appKeys = new Set();
    $81c5cbb6dbf0f155$var$storageState.lastUpdated = $81c5cbb6dbf0f155$var$getTodayAsNumberOfDaysSinceEpoch();
};
const $81c5cbb6dbf0f155$export$b103ab7a7dac10e9 = ()=>{
    // If the app context keys have values, this call has already been made by another renderer and so we can return here
    if ($81c5cbb6dbf0f155$var$storageState.appKeys !== null) return;
    // Check for the app context keys in session storage and store it into memory
    // This is called once across any number of ForgeUIRenderers on the page guarded by the above `if` statement
    try {
        const appKeyfilterSessionStorageContextInStorage = JSON.parse((0, $7dBf8.AtlBrowserStorageSession).getItem($81c5cbb6dbf0f155$var$SESSION_APPS_KEY) ?? '{}');
        $81c5cbb6dbf0f155$var$storageState = {
            appKeys: new Set(appKeyfilterSessionStorageContextInStorage.appKeys),
            lastUpdated: Number(appKeyfilterSessionStorageContextInStorage.lastUpdated)
        };
        // If the state is expired, we reset it
        if ($81c5cbb6dbf0f155$var$checkIsExpired()) {
            $81c5cbb6dbf0f155$var$resetState();
            return;
        }
    } catch  {
        $81c5cbb6dbf0f155$var$resetState();
    }
};
const $81c5cbb6dbf0f155$var$writeToSessionStorage = ()=>{
    try {
        // Set a limit to avoid overloading session storage
        if ($81c5cbb6dbf0f155$var$storageState?.appKeys?.size && $81c5cbb6dbf0f155$var$storageState?.appKeys?.size < 100) (0, $7dBf8.AtlBrowserStorageSession).setItem($81c5cbb6dbf0f155$var$SESSION_APPS_KEY, JSON.stringify({
            appKeys: Array.from($81c5cbb6dbf0f155$var$storageState.appKeys ?? []),
            lastUpdated: $81c5cbb6dbf0f155$var$getTodayAsNumberOfDaysSinceEpoch()
        }));
    } catch  {
    // If session storage is not available, we don't want to throw an error
    }
};
// Catches navigation or page refresh events and writes to session storage synchronously
window.addEventListener('beforeunload', ()=>{
    $81c5cbb6dbf0f155$var$writeToSessionStorage();
});
const $81c5cbb6dbf0f155$var$shouldAllowAndTrackEvent = (contextKey)=>{
    // State has expired
    if ($81c5cbb6dbf0f155$var$checkIsExpired()) {
        $81c5cbb6dbf0f155$var$resetState();
        $81c5cbb6dbf0f155$var$storageState.appKeys?.add(contextKey);
        return true;
    }
    if ($81c5cbb6dbf0f155$var$storageState.appKeys?.has(contextKey)) return false;
    $81c5cbb6dbf0f155$var$storageState.appKeys?.add(contextKey);
    return true;
};
const $81c5cbb6dbf0f155$var$findAppContextKeyInEvent = (event)=>{
    if (!event.context) return undefined;
    for (const context of event.context){
        const { appId: appId, extensionKey: extensionKey } = context.forgeUIAttributes ?? {};
        if (appId && extensionKey) return `${appId}/${extensionKey}`;
    }
    return undefined;
};
const $81c5cbb6dbf0f155$export$8869481ff1a02956 = (event)=>{
    try {
        const appContextKey = $81c5cbb6dbf0f155$var$findAppContextKeyInEvent(event);
        if (appContextKey) {
            const shouldAllow = $81c5cbb6dbf0f155$var$shouldAllowAndTrackEvent(appContextKey);
            return shouldAllow;
        }
    } catch  {
    // in case of any error, we let the event through, so we don't accidentally break analytics
    }
    return true;
};
module.exports["setupContextKeysFromSessionStorage"] = $81c5cbb6dbf0f155$export$b103ab7a7dac10e9;
module.exports["extensionLoadedEventFilter"] = $81c5cbb6dbf0f155$export$8869481ff1a02956;

});

parcelRegister("5itFi", function(module, exports) {

var $jH9cM = parcelRequire("jH9cM");


var $bLswh = parcelRequire("bLswh");


var $5cSJl = parcelRequire("5cSJl");

function $6df9aa245a533de6$export$faef963e38d4b894(environment) {
    const cdnEnv = (0, $5cSJl.getCDNEnvironment)(environment);
    // DEVELOPMENT has no dedicated CDN; fall back to STAGING assets.
    const urlEnv = cdnEnv === (0, $bLswh.ForgeCDNEnvironment).DEVELOPMENT ? (0, $bLswh.ForgeCDNEnvironment).STAGING : cdnEnv;
    const secondLevelDomain = (0, $jH9cM.isFedRamp)() ? 'atlassian-dev-us-gov-mod' : 'atlassian-dev';
    return `cdn.${urlEnv}.${secondLevelDomain}.net`;
}
module.exports["getForgeCDNBaseDomain"] = $6df9aa245a533de6$export$faef963e38d4b894;

});

parcelRegister("524dz", function(module, exports) {
const $1d4cedb54e51d8e8$export$ff4020ec1b0acf35 = (ari)=>{
    const segments = ari.split(':');
    // Expect `ari:cloud:<owner>:<cloudId>:<resourceType>/<resourceId>`.
    if (segments.length < 5 || segments[0] !== 'ari') return {
        ari: ari
    };
    const resourceOwner = segments[2];
    const cloudIdSegment = segments[3];
    const resource = segments[4];
    const [resourceType, resourceId] = resource.split('/');
    if (!resourceType || !resourceId) return {
        ari: ari
    };
    const result = {
        ari: ari
    };
    if (resourceOwner) result.resourceOwner = resourceOwner;
    if (resourceType === 'site') {
        // Site ARIs encode the cloudId as the resource id and leave segment 4 empty.
        result.cloudId = resourceId;
        return result;
    }
    if (cloudIdSegment) result.cloudId = cloudIdSegment;
    if (resourceType === 'workspace') result.workspaceId = resourceId;
    return result;
};
module.exports["parseContextAri"] = $1d4cedb54e51d8e8$export$ff4020ec1b0acf35;

});

parcelRegister("gid8j", function(module, exports) {

var $5Wwmi = parcelRequire("5Wwmi");

const $6f9ed0acae13107a$var$disabledPerfCaptureConfig = {
    enabled: false,
    sampleRate: 0.0
};
const $6f9ed0acae13107a$export$3e4354104e72ffa1 = ({ module: module })=>{
    const isModuleEnabled = (0, $5Wwmi.enabledModulesForPerfCapture).indexOf(module) > -1;
    // Space to apply gates and experiments.
    return isModuleEnabled ? (0, $5Wwmi.defaultPerfCaptureConfig) : $6f9ed0acae13107a$var$disabledPerfCaptureConfig;
};
module.exports["getAppPerfCaptureConfig"] = $6f9ed0acae13107a$export$3e4354104e72ffa1;

});

parcelRegister("1y5uw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");


var $6FQr4 = parcelRequire("6FQr4");


var $cozmU = parcelRequire("cozmU");


var $DIyeF = parcelRequire("DIyeF");


var $iDrrr = parcelRequire("iDrrr");

const $f2a182041841bfae$export$587370d4749ec188 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { config: config, samplingKey: samplingKey } = t0;
    const { page: source } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    bb0: {
        if (!samplingKey) {
            t1 = false;
            break bb0;
        }
        if (!config.enabled || !(0, $iDrrr.fg)("forge-ui-app-perf-tracking-enabled")) {
            t1 = false;
            break bb0;
        }
        const captureAllFlag = (0, $iDrrr.fg)("forge-ui-app-perf-capture-all-enabled");
        if (captureAllFlag) {
            t1 = true;
            break bb0;
        }
        const captureSampleFlag = (0, $iDrrr.fg)("forge-ui-app-perf-capture-sampling-enabled");
        if (captureSampleFlag && Math.random() <= config.sampleRate) {
            t1 = true;
            break bb0;
        }
        t1 = false;
    }
    const enabled = t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== enabled || $[2] !== source) {
        t2 = (attributes)=>{
            if (!enabled) return;
            (0, $6FQr4.fireEvent)(createAnalyticsEvent, {
                action: "performance.profiled",
                actionSubject: "forge.ui.extension",
                attributes: attributes,
                source: source
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = enabled;
        $[2] = source;
        $[3] = t2;
    } else t2 = $[3];
    const capture = t2;
    let t3;
    if ($[4] !== capture || $[5] !== enabled) {
        t3 = {
            enabled: enabled,
            capture: capture
        };
        $[4] = capture;
        $[5] = enabled;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ config: config, samplingKey: samplingKey })=>{
    const { page: source } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const enabled = (0, $cozmU.useMemo)(()=>{
        if (!samplingKey) return false;
        if (!config.enabled || !(0, $iDrrr.fg)('forge-ui-app-perf-tracking-enabled')) return false;
        // Override: capture all events.
        const captureAllFlag = (0, $iDrrr.fg)('forge-ui-app-perf-capture-all-enabled');
        if (captureAllFlag) return true;
        // Capture a sample of events.
        const captureSampleFlag = (0, $iDrrr.fg)('forge-ui-app-perf-capture-sampling-enabled');
        if (captureSampleFlag && Math.random() <= config.sampleRate) return true;
        return false;
    }, [
        config,
        samplingKey
    ]);
    const capture = (0, $cozmU.useCallback)((attributes)=>{
        if (!enabled) return;
        (0, $6FQr4.fireEvent)(createAnalyticsEvent, {
            action: 'performance.profiled',
            actionSubject: 'forge.ui.extension',
            attributes: attributes,
            source: source
        });
    }, [
        source,
        createAnalyticsEvent,
        enabled
    ]);
    return {
        enabled: enabled,
        capture: capture
    };
};
module.exports["useAppPerfCaptureStrategy"] = $f2a182041841bfae$export$587370d4749ec188;

});

parcelRegister("2N0qz", function(module, exports) {
/**
 * @generated SignedSource<<01a63b7d5e7ff313a9ca48c171279668>>
 * @relayHash 03405d83b15f59d0889abdb0c63674a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 94a10998312c3467f8472075ae93ba6a72f87e0e5fc80ed56a84b36ab8800138
const $7c645f72c05e0ec8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIds"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudIds",
                    "variableName": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "cloudUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBridge_tenantUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBridge_tenantUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "94a10998312c3467f8472075ae93ba6a72f87e0e5fc80ed56a84b36ab8800138",
            "metadata": {},
            "name": "useBridge_tenantUserQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7c645f72c05e0ec8$var$node.hash = "608300bf42cc1b2188141c51b357201e";
var $7c645f72c05e0ec8$export$2e2bcd8739ae039 = $7c645f72c05e0ec8$var$node;
module.exports["default"] = $7c645f72c05e0ec8$export$2e2bcd8739ae039;

});

parcelRegister("6Rin8", function(module, exports) {

var $jBLwT = parcelRequire("jBLwT");


module.exports = {
    iframeResize: $jBLwT,
    iframeResizer: $jBLwT,
    contentWindow: (parcelRequire("8e5a1"))
};

});

parcelRegister("kq02L", function(module, exports) {

var $852mP = parcelRequire("852mP");


var $h48r4 = parcelRequire("h48r4");


var $c71c0 = parcelRequire("c71c0");


var $3db8V = parcelRequire("3db8V");


var $4K6lC = parcelRequire("4K6lC");


var $6FQr4 = parcelRequire("6FQr4");


var $5Wwa0 = parcelRequire("5Wwa0");

const $9c97aee9a7edf800$export$60b209a72f44cb2e = (bridgeMethod, payload, isSucceed)=>{
    if (bridgeMethod === 'submit' && isSucceed) {
        const payloadFields = Array.from(Object.entries(payload?.data ?? {})).filter(([, value])=>value).map(([key])=>key);
        return {
            payloadFields: payloadFields
        };
    }
    if (bridgeMethod === 'navigate') {
        const { target: target, url: url, type: type } = payload?.data ?? {};
        const navigationContext = {
            target: 'trusted',
            type: type
        };
        if (url && typeof url === 'string') try {
            if ([
                'https:',
                'http:'
            ].includes(new URL(url).protocol)) navigationContext.target = 'external';
        } catch  {}
        else if (target && typeof target === 'string') navigationContext.target = target;
        return navigationContext;
    }
    if (bridgeMethod === 'openRovo' && isSucceed) {
        const { agentName: agentName, agentKey: agentKey, sourceAppId: sourceAppId } = payload?.data ?? {};
        const agentDetails = {
            agentName: agentName,
            agentKey: agentKey,
            sourceAppId: sourceAppId,
            isForgeAgent: false
        };
        if (agentName && agentKey) agentDetails.isForgeAgent = true;
        return agentDetails;
    }
    return {};
};
const $9c97aee9a7edf800$var$wrapFeatureWithMetricsAndAnalytics = ({ feature: feature, createAnalyticsEvent: createAnalyticsEvent, page: page, bridgeMethod: bridgeMethod, environment: environment, forgeEnvironment: forgeEnvironment, errorExtensionDetails: errorExtensionDetails, tracing: tracing })=>async (payload)=>{
        try {
            tracing?.recordBridgeCall(`${bridgeMethod}() - start`);
            const result = await feature(payload);
            tracing?.recordBridgeCall(`${bridgeMethod}() - end`);
            if (bridgeMethod === 'on') createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'subscribed',
                    actionSubject: 'bridgeEvent',
                    attributes: {
                        // TODO: remove the condition (and related test) once Developer UGC spec is ready
                        event: payload.data.event === 'JIRA_ISSUE_CHANGED' ? 'JIRA_ISSUE_CHANGED' : 'other'
                    },
                    source: page,
                    tags: [
                        'forge'
                    ]
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            // this replaces the BRIDGE_REQUEST_RECEIVED metal client event
            (0, $6FQr4.trackBridgeSucceed)(createAnalyticsEvent, {
                source: page,
                method: bridgeMethod,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: $9c97aee9a7edf800$export$60b209a72f44cb2e(bridgeMethod, payload, true)
            });
            return result;
        } catch (err) {
            const error = err instanceof Error ? err : new Error(`Unknown Custom UI Bridge error: ${typeof err}`);
            if (!(error instanceof (0, $c71c0.BridgeClientError))) {
                if (!(0, $3db8V.blocklistedErrorMessagePatterns).some((pattern)=>pattern.test(error.message))) {
                    (0, $6FQr4.trackBridgeFailed)(createAnalyticsEvent, {
                        source: page,
                        errorName: error.name,
                        method: bridgeMethod,
                        forgeEnvironment: forgeEnvironment,
                        additionalAttributes: {
                            ...$9c97aee9a7edf800$export$60b209a72f44cb2e(bridgeMethod, payload, false),
                            reason: error.message,
                            isUnrecoverable: (0, $5Wwa0.isUnrecoverableError)(error)
                        }
                    });
                    (0, $h48r4.captureAndReportError)({
                        error: error,
                        environment: environment,
                        errorExtensionDetails: errorExtensionDetails,
                        page: page,
                        tracing: tracing
                    });
                }
            }
            throw err;
        }
    };
const $9c97aee9a7edf800$export$68a362b9cb2811d7 = ({ features: features, createAnalyticsEvent: createAnalyticsEvent, page: page, environment: environment, forgeEnvironment: forgeEnvironment, errorExtensionDetails: errorExtensionDetails, tracing: tracing })=>Object.entries(features).reduce((acc, [key, feature])=>({
            ...acc,
            [key]: $9c97aee9a7edf800$var$wrapFeatureWithMetricsAndAnalytics({
                feature: feature,
                createAnalyticsEvent: createAnalyticsEvent,
                page: page,
                bridgeMethod: key,
                environment: environment,
                forgeEnvironment: forgeEnvironment,
                errorExtensionDetails: errorExtensionDetails,
                tracing: tracing
            })
        }), {});
module.exports["prepareBridgeEventAttributes"] = $9c97aee9a7edf800$export$60b209a72f44cb2e;
module.exports["withMetricsAndAnalytics"] = $9c97aee9a7edf800$export$68a362b9cb2811d7;

});

parcelRegister("bSxWl", function(module, exports) {
function $32eb7b0d1867f085$export$32da5b5043dcd88c() {
    window.location.reload();
}
module.exports["reload"] = $32eb7b0d1867f085$export$32da5b5043dcd88c;

});

parcelRegister("ixV18", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $e1sLx = parcelRequire("e1sLx");


var $ivMdx = parcelRequire("ivMdx");


var $6UBMp = parcelRequire("6UBMp");


var $42HAj = parcelRequire("42HAj");


var $jGJD6 = parcelRequire("jGJD6");


var $glUKJ = parcelRequire("glUKJ");

const $53d125477b203641$var$extensionURLHelpers = {
    ...(0, $e1sLx.bitbucketExtensionURLHelpers),
    ...(0, $ivMdx.confluenceExtensionURLHelpers),
    ...(0, $42HAj.jiraExtensionURLHelpers),
    ...(0, $jGJD6.globalExtensionURLHelpers)
};
const $53d125477b203641$var$navigationTargetHandlers = {
    ...(0, $42HAj.jiraNavigationTargetHandlers),
    ...(0, $ivMdx.confluenceNavigationTargetURLHelpers),
    userProfile: async ({ accountId: accountId })=>(0, $glUKJ.ensureURLPath)(`/people/${accountId}`),
    module: async ({ moduleKey: moduleKey, path: path, ...params }, { getAppForgeUIExtensions: getAppForgeUIExtensions })=>{
        if (!moduleKey) throw (0, $6UBMp.NavigationError).MissingProperty('moduleKey');
        const module = await (0, $6UBMp.getModuleByKey)(getAppForgeUIExtensions, moduleKey);
        if (!module || !module.appId || !module.environmentId || !module.environmentKey) throw (0, $6UBMp.NavigationError).ModuleNotFound(moduleKey);
        const moduleUrlHelper = $53d125477b203641$var$extensionURLHelpers[module.type];
        if (!moduleUrlHelper) throw (0, $6UBMp.NavigationError).NotSupportedExtensionType(module.type);
        const basePath = await moduleUrlHelper(module, params);
        if (basePath && path && (0, $iDrrr.fg)('forge-ui-navigate-module-path')) return `${basePath}${path}`;
        return basePath;
    }
};
const $53d125477b203641$export$6aa8556afece32b2 = async (targetInfo, utils)=>{
    const { target: target, ...payload } = targetInfo;
    const handler = $53d125477b203641$var$navigationTargetHandlers[target];
    if (!handler) return null;
    try {
        const path = await handler(payload, utils);
        return path;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e.message);
        return null;
    }
};
module.exports["createNavigateTargetPath"] = $53d125477b203641$export$6aa8556afece32b2;

});

parcelRegister("cTycZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $9PdUw = parcelRequire("9PdUw");


var $ix7El = parcelRequire("ix7El");


var $3u5lg = parcelRequire("3u5lg");

const $2ef3aab898559d92$var$useCustomCompareMemo = (factory, dependency, isEqual)=>{
    const dependencyRef = (0, $cozmU.useRef)(dependency);
    const valueRef = (0, $cozmU.useRef)(factory());
    if (!isEqual(dependency, dependencyRef.current)) {
        dependencyRef.current = dependency;
        valueRef.current = factory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $cozmU.useMemo)(()=>valueRef.current, [
        dependencyRef.current
    ]);
};
const $2ef3aab898559d92$var$isSameDeps = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return false;
    const [relayEnvironmentA, appIdA, environmentIdA, contextIdsA] = a;
    const [relayEnvironmentB, appIdB, environmentIdB, contextIdsB] = b;
    return relayEnvironmentA === relayEnvironmentB && appIdA === appIdB && environmentIdA === environmentIdB && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(contextIdsA.sort(), contextIdsB.sort());
};
const $2ef3aab898559d92$export$10dcd63d9a8843c4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { appId: appId, environmentId: environmentId, contextIds: contextIds, cloudId: cloudId, includeHidden: includeHidden, moduleType: moduleType, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall } = t0;
    const relayEnvironment = (0, $6SsN4.useRelayEnvironment)();
    let t1;
    if ($[0] !== appId || $[1] !== bypassNewForgeExtensionListCall || $[2] !== cloudId || $[3] !== contextIds || $[4] !== environmentId || $[5] !== includeHidden || $[6] !== moduleType || $[7] !== relayEnvironment) {
        t1 = ()=>async (params)=>await (0, $9PdUw.getForgeUIExtensionsRelayAsync)({
                    contextIds: contextIds,
                    extensionsFilter: [
                        {
                            type: (0, $ix7El.GQLExtensionContextsFilterType).AppIdEnvironmentId,
                            value: [
                                `${appId}:${environmentId}`
                            ]
                        }
                    ],
                    ...params,
                    cloudId: cloudId,
                    includeHidden: includeHidden,
                    moduleType: moduleType,
                    bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall,
                    relayEnvironment: relayEnvironment
                });
        $[0] = appId;
        $[1] = bypassNewForgeExtensionListCall;
        $[2] = cloudId;
        $[3] = contextIds;
        $[4] = environmentId;
        $[5] = includeHidden;
        $[6] = moduleType;
        $[7] = relayEnvironment;
        $[8] = t1;
    } else t1 = $[8];
    let t2;
    if ($[9] !== appId || $[10] !== contextIds || $[11] !== environmentId || $[12] !== relayEnvironment) {
        t2 = [
            relayEnvironment,
            appId,
            environmentId,
            contextIds
        ];
        $[9] = appId;
        $[10] = contextIds;
        $[11] = environmentId;
        $[12] = relayEnvironment;
        $[13] = t2;
    } else t2 = $[13];
    return $2ef3aab898559d92$var$useCustomCompareMemo(t1, t2, $2ef3aab898559d92$var$isSameDeps);
} : ({ appId: appId, environmentId: environmentId, contextIds: contextIds, cloudId: cloudId, includeHidden: includeHidden, moduleType: moduleType, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall })=>{
    const relayEnvironment = (0, $6SsN4.useRelayEnvironment)();
    return $2ef3aab898559d92$var$useCustomCompareMemo(()=>{
        return async (params)=>{
            return await (0, $9PdUw.getForgeUIExtensionsRelayAsync)({
                contextIds: contextIds,
                extensionsFilter: [
                    {
                        type: (0, $ix7El.GQLExtensionContextsFilterType).AppIdEnvironmentId,
                        value: [
                            `${appId}:${environmentId}`
                        ]
                    }
                ],
                ...params,
                cloudId: cloudId,
                includeHidden: includeHidden,
                moduleType: moduleType,
                bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall,
                relayEnvironment: relayEnvironment
            });
        };
    }, [
        relayEnvironment,
        appId,
        environmentId,
        contextIds
    ], $2ef3aab898559d92$var$isSameDeps);
};
module.exports["useGetAppForgeUIExtensions"] = $2ef3aab898559d92$export$10dcd63d9a8843c4;

});

parcelRegister("dNEbC", function(module, exports) {

var $bmXU6 = parcelRequire("bmXU6");


var $6SsN4 = parcelRequire("6SsN4");


var $iGKcz = parcelRequire("iGKcz");

const $bbb7581ec56611f1$export$24d1d5a4c1bec897 = async ({ cloudId: cloudId, relayEnvironment: relayEnvironment })=>{
    if (relayEnvironment) {
        const observable = (0, $6SsN4.fetchQuery)(relayEnvironment, (0, $bmXU6.default), {
            cloudId: cloudId
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)()
                    }
                }
            }
        });
        return new Promise((resolve)=>{
            observable.subscribe({
                next: (data)=>{
                    resolve(data?.atlassianStudio_userSiteContext?.isRovoEnabled ?? false);
                },
                error: ()=>{
                    resolve(false);
                }
            });
        });
    }
    return false;
};
module.exports["getIsRovoEnabled"] = $bbb7581ec56611f1$export$24d1d5a4c1bec897;

});

parcelRegister("8j9ei", function(module, exports) {

var $eKJPK = parcelRequire("eKJPK");

const $e1479de0e5ae3a77$export$97f4c254b641e719 = (hostname)=>{
    return ![
        ...(0, $eKJPK.TRUSTED_ROOT_DOMAINS),
        'localhost',
        'jira-dev.com'
    ].some((trustedDomain)=>hostname.includes(trustedDomain));
};
module.exports["isCustomDomain"] = $e1479de0e5ae3a77$export$97f4c254b641e719;

});

parcelRegister("llM9z", function(module, exports) {
/* usePermission.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * @deprecated
 * This hook implements the v1 (stateful, React hook-based) permission bridge.
 *
 * New code should use the v2 stateless bridge methods instead:
 *   `platform/packages/forge/forge-ui/src/bridge/methods/permissions/index.tsx`
 *
 * The v2 methods (`egressGet`, `egressSet`, `egressDeleteDomain`,
 * `egressDeleteGroup`, `remoteGet`, `remoteSet`) are registered as
 * `__permission__*` bridge methods and are gated by
 * `fg('configurable-egress-mvp-frontend')`.
 *
 * This file is retained to support the legacy custom-UI iframe bridge path
 * (`usePermission` hook consumed via `useBridge`). Do not add new permission
 * logic here.
 */ 
var $cozmU = parcelRequire("cozmU");


var $c71c0 = parcelRequire("c71c0");


var $dlclU = parcelRequire("dlclU");


var $aYo0f = parcelRequire("aYo0f");


var $iDrrr = parcelRequire("iDrrr");


var $igFAK = parcelRequire("igFAK");


var $8OfFZ = parcelRequire("8OfFZ");


var $hYBRd = parcelRequire("hYBRd");


var $6FQr4 = parcelRequire("6FQr4");

const $73fda7d970802ab1$export$9d631cbf20f994be = [
    'egressSet',
    'egressGet',
    'egressDeleteDomain',
    'egressDeleteGroup',
    'remoteGet',
    'remoteSet'
];
const $73fda7d970802ab1$export$e6656e96c25a61f6 = '__permission__';
const $73fda7d970802ab1$var$RATE_LIMIT_MS = 5000;
const $73fda7d970802ab1$export$6adf362786c5a28e = (apiRef)=>({
        __permission__egressSet: async ({ data: data })=>{
            return apiRef.current.__permission__egressSet?.(data);
        },
        __permission__egressGet: async ({ data: data })=>{
            return apiRef.current.__permission__egressGet?.(data);
        },
        __permission__egressDeleteDomain: async ({ data: data })=>{
            return apiRef.current.__permission__egressDeleteDomain?.(data);
        },
        __permission__egressDeleteGroup: async ({ data: data })=>{
            return apiRef.current.__permission__egressDeleteGroup?.(data);
        },
        __permission__remoteGet: async ({ data: data })=>{
            return apiRef.current.__permission__remoteGet?.(data);
        },
        __permission__remoteSet: async ({ data: data })=>{
            return apiRef.current.__permission__remoteSet?.(data);
        }
    });
const $73fda7d970802ab1$export$dc21730956491a4c = (bridge)=>Object.fromEntries($73fda7d970802ab1$export$9d631cbf20f994be.map((method)=>[
            `${$73fda7d970802ab1$export$e6656e96c25a61f6}${method}`,
            (0, $8OfFZ.createBridgeMethod)(bridge?.[`${$73fda7d970802ab1$export$e6656e96c25a61f6}${method}`])
        ]));
function $73fda7d970802ab1$export$d7376454a3cf5ab4({ appId: appId, installationId: installationId, contextIds: contextIds, extensionId: extensionId, renderThreeLOPrompt: renderThreeLOPrompt }) {
    const [modalState, setModalState] = (0, $cozmU.useState)({
        state: 'closed'
    });
    const [isRateLimited, setIsRateLimited] = (0, $cozmU.useState)(false);
    const { trackPermissionAction: trackPermissionAction } = (0, $6FQr4.useForgeUiAnalyticsEvent)(); // ── Queue state (used when forge-ui-permission-consent-modal-improvements is ON) ──
    const queueRef = (0, $cozmU.useRef)([]);
    const isModalOpenRef = (0, $cozmU.useRef)(false); // ── WithQueue modal state (individual props for AdminConsentModalWithQueue) ──
    const [withQueueModalState, setWithQueueModalState] = (0, $cozmU.useState)(null);
    const waitForModalSlot = ()=>{
        if (!isModalOpenRef.current) {
            isModalOpenRef.current = true;
            return Promise.resolve();
        }
        return new Promise((resolve)=>{
            queueRef.current.push(()=>{
                isModalOpenRef.current = true;
                resolve();
            });
        });
    };
    const releaseModalSlot = ()=>{
        isModalOpenRef.current = false;
        setWithQueueModalState(null);
        const next = queueRef.current.shift();
        if (next) next();
    };
    const permissionFetchClient = (0, $igFAK.usePermissionFetchClient)({
        appId: appId,
        installationId: installationId,
        contextIds: contextIds,
        extensionId: extensionId,
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    const queryForgeApp = (0, $hYBRd.useForgeAppQuery)();
    const fetchAppData = async (id, contextIds_0)=>{
        try {
            return await queryForgeApp(id, contextIds_0);
        } catch (e) {
            if (e instanceof Error) {
                const error = new (0, $c71c0.BridgeClientError)(e.message);
                error.stack = e.stack;
                throw error;
            }
            throw new (0, $c71c0.BridgeClientError)(typeof e === 'string' ? e : String(e));
        }
    };
    const canOpenModal = ()=>{
        return modalState.state === 'closed' && !isRateLimited;
    };
    const noteModalOpened = ()=>{
        setIsRateLimited(true);
        setTimeout(()=>{
            setIsRateLimited(false);
        }, $73fda7d970802ab1$var$RATE_LIMIT_MS);
    };
    return {
        getModalJsx: ()=>{
            if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return null;
            if (withQueueModalState && (0, $iDrrr.fg)('forge-ui-permission-consent-modal-improvements')) return /*#__PURE__*/ $cozmU.createElement((0, $aYo0f.AdminConsentModal), {
                appName: withQueueModalState.appName,
                domainInfo: withQueueModalState.domainInfo,
                onCancel: withQueueModalState.onCancel,
                onConfirm: withQueueModalState.onConfirm,
                termsOfUseLink: withQueueModalState.termsOfUseLink,
                privacyPolicyLink: withQueueModalState.privacyPolicyLink
            });
            return /*#__PURE__*/ $cozmU.createElement((0, $dlclU.AdminModal), {
                modalState: modalState
            });
        },
        egressSet: async (payload)=>{
            if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'egressSet'
            }); // ── Queue path (forge-ui-permission-consent-modal-improvements) ──
            if ((0, $iDrrr.fg)('forge-ui-permission-consent-modal-improvements')) {
                await waitForModalSlot();
                let app;
                try {
                    app = await fetchAppData(appId, contextIds);
                } catch (err) {
                    releaseModalSlot();
                    throw err;
                }
                const dryRunResp = await permissionFetchClient.egressSet(payload, true);
                if (!dryRunResp.ok) {
                    releaseModalSlot();
                    throw new (0, $c71c0.BridgeClientError)('Dry run failed');
                }
                return new Promise((resolve_0, reject)=>{
                    setWithQueueModalState({
                        appName: app.name,
                        domainInfo: {
                            type: 'EGRESS',
                            payload: payload
                        },
                        termsOfUseLink: app.termsOfService,
                        privacyPolicyLink: app.privacyPolicy,
                        onCancel: ()=>{
                            releaseModalSlot();
                            reject(new (0, $c71c0.BridgeClientError)('Setting egress was rejected by admin'));
                        },
                        onConfirm: async ()=>{
                            const setResp = await permissionFetchClient.egressSet(payload, false);
                            const json = await setResp.json();
                            if (!setResp.ok) throw new (0, $c71c0.BridgeClientError)(JSON.stringify(json, null, 2));
                            releaseModalSlot();
                            resolve_0(json);
                        }
                    });
                });
            }
            // ── Legacy rate-limit path ──
            const app_0 = await fetchAppData(appId, contextIds);
            const response = await permissionFetchClient.egressSet(payload, true);
            if (!response.ok) throw new (0, $c71c0.BridgeClientError)('Dry run failed');
            if (!canOpenModal()) throw new (0, $c71c0.BridgeClientError)('Permission request rate limited. Please wait before making another request.');
            return new Promise((resolve_1, reject_0)=>{
                noteModalOpened();
                setModalState({
                    state: 'open',
                    onCancel: ()=>{
                        setModalState({
                            state: 'closed'
                        });
                        reject_0('Setting egress was rejected by admin');
                    },
                    onConfirm: async ()=>{
                        try {
                            const setEgressResp = await permissionFetchClient.egressSet(payload, false);
                            const json_0 = await setEgressResp.json();
                            if (!setEgressResp.ok) throw new (0, $c71c0.BridgeClientError)(JSON.stringify(json_0, null, 2));
                            setModalState({
                                state: 'closed'
                            });
                            resolve_1(json_0);
                        } catch (err_0) {
                            reject_0(err_0);
                        }
                    },
                    domainInfo: {
                        type: 'EGRESS',
                        payload: payload
                    },
                    appName: app_0.name,
                    termsOfUseLink: app_0.termsOfService,
                    privacyPolicyLink: app_0.privacyPolicy
                });
            });
        },
        egressGet: async (payload_0)=>{
            if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'egressGet'
            });
            try {
                const getEgressResp = await permissionFetchClient.egressGet(payload_0);
                const json_1 = await getEgressResp.json();
                if (!getEgressResp.ok) throw new (0, $c71c0.BridgeClientError)(JSON.stringify(json_1, null, 2));
                return json_1;
            } catch (err_1) {
                throw new (0, $c71c0.BridgeClientError)(`Could not get egress due to: ${err_1}`);
            }
        },
        egressDeleteDomain: async (payload_1)=>{
            if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'egressDeleteDomain'
            });
            try {
                const egressDeleteDomainResp = await permissionFetchClient.egressDeleteDomain(payload_1);
                if (egressDeleteDomainResp.ok && egressDeleteDomainResp.status === 204) return undefined;
                const json_2 = await egressDeleteDomainResp.json();
                if (!egressDeleteDomainResp.ok) throw new (0, $c71c0.BridgeClientError)(JSON.stringify(json_2, null, 2));
                return json_2;
            } catch (err_2) {
                throw new (0, $c71c0.BridgeClientError)(`Could not delete egress domain due to ${err_2}`);
            }
        },
        egressDeleteGroup: async (payload_2)=>{
            if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'egressDeleteGroup'
            });
            try {
                const egressDeleteGroupResp = await permissionFetchClient.egressDeleteGroup(payload_2);
                if (egressDeleteGroupResp.ok && egressDeleteGroupResp.status === 204) return undefined;
                const json_3 = await egressDeleteGroupResp.json();
                if (!egressDeleteGroupResp.ok) throw new (0, $c71c0.BridgeClientError)(JSON.stringify(json_3, null, 2));
                return json_3;
            } catch (err_3) {
                throw new (0, $c71c0.BridgeClientError)(`Could not delete egress group due to ${err_3}`);
            }
        },
        remoteGet: async (payload_3)=>{
            if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'remoteGet'
            });
            try {
                const remoteGetResp = await permissionFetchClient.remoteGet(payload_3);
                const json_4 = await remoteGetResp.json();
                if (!remoteGetResp.ok) throw new (0, $c71c0.BridgeClientError)(JSON.stringify(json_4, null, 2));
                return json_4;
            } catch (err_4) {
                throw new (0, $c71c0.BridgeClientError)(`Could not get remote due to: ${err_4}`);
            }
        },
        remoteSet: async (payload_4)=>{
            if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'remoteSet'
            }); // ── Queue path (forge-ui-permission-consent-modal-improvements) ──
            if ((0, $iDrrr.fg)('forge-ui-permission-consent-modal-improvements')) {
                await waitForModalSlot();
                let app_1;
                try {
                    app_1 = await fetchAppData(appId, contextIds);
                } catch (err_5) {
                    releaseModalSlot();
                    throw err_5;
                }
                const dryRunResp_0 = await permissionFetchClient.remoteSet(payload_4, true);
                if (!dryRunResp_0.ok) {
                    releaseModalSlot();
                    throw new (0, $c71c0.BridgeClientError)('Dry run failed');
                }
                const node = (app_1.installationsByContexts?.edges ?? [])[0]?.node;
                const payloadKeys = new Set(payload_4.remotes.map((r)=>r.key));
                const manifestRemoteMap = (node?.appEnvironmentVersion?.extensions?.nodes ?? []).filter((e_0)=>e_0 && e_0.extensionData.type === 'core:remote' && payloadKeys.has(e_0.extensionData.key)).reduce((acc, e_1)=>{
                    if (e_1?.extensionData) acc[e_1.extensionData.key] = e_1.extensionData.configurable;
                    return acc;
                }, {});
                return new Promise((resolve_2, reject_1)=>{
                    setWithQueueModalState({
                        appName: app_1.name,
                        domainInfo: {
                            type: 'REMOTE',
                            payload: payload_4,
                            manifestRemoteMap: manifestRemoteMap
                        },
                        termsOfUseLink: app_1.termsOfService,
                        privacyPolicyLink: app_1.privacyPolicy,
                        onCancel: ()=>{
                            releaseModalSlot();
                            reject_1(new (0, $c71c0.BridgeClientError)('Setting remote was rejected by admin'));
                        },
                        onConfirm: async ()=>{
                            const setResp_0 = await permissionFetchClient.remoteSet(payload_4, false);
                            if (!setResp_0.ok) throw new (0, $c71c0.BridgeClientError)(setResp_0.statusText);
                            releaseModalSlot();
                            resolve_2(undefined);
                        }
                    });
                });
            } // ── Legacy rate-limit path ──
            const app_2 = await fetchAppData(appId, contextIds);
            const response_0 = await permissionFetchClient.remoteSet(payload_4, true);
            if (!response_0.ok) throw new (0, $c71c0.BridgeClientError)('Dry run failed');
            if (!canOpenModal()) throw new (0, $c71c0.BridgeClientError)('Permission request rate limited. Please wait before making another request.');
            const node_0 = (app_2.installationsByContexts?.edges ?? [])[0]?.node;
            const payloadKeys_0 = new Set(payload_4.remotes.map((r_0)=>r_0.key));
            const manifestRemoteMap_0 = (node_0?.appEnvironmentVersion?.extensions?.nodes ?? []).filter((e_2)=>e_2 && e_2.extensionData.type === 'core:remote' && payloadKeys_0.has(e_2.extensionData.key)).reduce((acc_0, e_3)=>{
                if (e_3?.extensionData) acc_0[e_3.extensionData.key] = e_3.extensionData.configurable;
                return acc_0;
            }, {});
            return new Promise((resolve_3, reject_2)=>{
                noteModalOpened();
                setModalState({
                    state: 'open',
                    onCancel: ()=>{
                        setModalState({
                            state: 'closed'
                        });
                        reject_2(new (0, $c71c0.BridgeClientError)('Setting remote was rejected by admin'));
                    },
                    onConfirm: async ()=>{
                        try {
                            const remoteSetResp = await permissionFetchClient.remoteSet(payload_4, false);
                            if (!remoteSetResp.ok) throw new (0, $c71c0.BridgeClientError)(remoteSetResp.statusText);
                            setModalState({
                                state: 'closed'
                            });
                            resolve_3();
                        } catch (err_6) {
                            reject_2(new (0, $c71c0.BridgeClientError)(`API call was rejected with the following error: ${err_6}`));
                        }
                    },
                    domainInfo: {
                        type: 'REMOTE',
                        payload: payload_4,
                        manifestRemoteMap: manifestRemoteMap_0
                    },
                    appName: app_2.name,
                    termsOfUseLink: app_2.termsOfService,
                    privacyPolicyLink: app_2.privacyPolicy
                });
            });
        }
    };
}
module.exports["permissionMethods"] = $73fda7d970802ab1$export$9d631cbf20f994be;
module.exports["PERMISSION_METHOD_PREFIX"] = $73fda7d970802ab1$export$e6656e96c25a61f6;
module.exports["getUseBridgePermissionFunctions"] = $73fda7d970802ab1$export$6adf362786c5a28e;
module.exports["getCreateBridgeApiPermissionFunctions"] = $73fda7d970802ab1$export$dc21730956491a4c;
module.exports["usePermission"] = $73fda7d970802ab1$export$d7376454a3cf5ab4;

});

parcelRegister("CJweT", function(module, exports) {
const $585d92e5457daac5$export$684c8d19f84f3f84 = (key, embeddedMacroLocalId, data)=>{
    if (key === 'getMacroContent' || key === 'updateMacroContent') return {
        ...typeof data === 'object' ? data : {},
        embeddedMacroLocalId: embeddedMacroLocalId
    };
    return data;
};
module.exports["transformDataForEmbeddedMacros"] = $585d92e5457daac5$export$684c8d19f84f3f84;

});

parcelRegister("3tjju", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1VhsF = parcelRequire("1VhsF");


var $kSwu1 = parcelRequire("kSwu1");

const $237e07fb54783cb0$var$messages = (0, $kSwu1.defineMessages)({
    developerSpaceErrorTitle: {
        id: "forge-ui.renderer.errorMessages.ForgeDevSpaceErrorMessage.developerSpaceErrorTitle",
        defaultMessage: "This app is currently unavailable"
    },
    developerSpaceErrorBody: {
        id: "forge-ui.renderer.errorMessages.ForgeDevSpaceErrorMessage.developerSpaceErrorBody",
        defaultMessage: "The app developer needs to complete required setup before this app can become available. Contact your app provider for more information or to request support."
    }
});
const $237e07fb54783cb0$export$fab3d5a87354bfa8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($237e07fb54783cb0$var$messages.developerSpaceErrorTitle);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage($237e07fb54783cb0$var$messages.developerSpaceErrorBody);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: t0,
            appearance: "error"
        }, t1);
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: intl.formatMessage($237e07fb54783cb0$var$messages.developerSpaceErrorTitle),
        appearance: "error"
    }, intl.formatMessage($237e07fb54783cb0$var$messages.developerSpaceErrorBody));
};
module.exports["ForgeDevSpaceErrorMessage"] = $237e07fb54783cb0$export$fab3d5a87354bfa8;

});

parcelRegister("fXF7L", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hqafU = parcelRequire("hqafU");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $1VhsF = parcelRequire("1VhsF");


var $iGKcz = parcelRequire("iGKcz");


var $gDqww = parcelRequire("gDqww");


var $iyAN0 = parcelRequire("iyAN0");

const $9266a1741c0c4a4d$var$buildMessage = (title, error)=>{
    if (error === (0, $iyAN0.SANDBOX_DEPRECATION_ERROR)) return `Your app ${title} is no longer working as it uses a deprecated platform feature. Please check if an update for this app is available through Atlassian Administration, or ask the app developer to upgrade the app.\nIf the app is listed on the marketplace, contact the developer using the Support tab.`;
    return `${title} version is outdated due to a deprecated platform component.\nThe app developer needs to update it to a compatible version.\nPlease ask your admin to check for updates or contact the app developer.`;
};
const $9266a1741c0c4a4d$var$ForgeDeprecationMessageInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    const { extension: extension, error: error } = props;
    const t0 = extension?.id;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            id: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        "atl-attribution": (0, $iGKcz.createAtlAttributionHeader)()
                    }
                }
            }
        };
        $[2] = t2;
    } else t2 = $[2];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $hqafU.default), t1, t2);
    const title = data.app?.name ? data.app?.name : extension.properties.title;
    let t3;
    if ($[3] !== error || $[4] !== title) {
        t3 = $9266a1741c0c4a4d$var$buildMessage(title, error);
        $[3] = error;
        $[4] = title;
        $[5] = t3;
    } else t3 = $[5];
    const message = t3;
    let t4;
    if ($[6] !== message) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: "App update required",
            appearance: "error"
        }, message);
        $[6] = message;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : (props)=>{
    const { extension: extension, error: error } = props;
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $hqafU.default), {
        id: extension?.id
    }, {
        networkCacheConfig: {
            metadata: {
                headers: {
                    'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)()
                }
            }
        }
    });
    const title = data.app?.name ? data.app?.name : extension.properties.title;
    const message = $9266a1741c0c4a4d$var$buildMessage(title, error);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: "App update required",
        appearance: "error"
    }, message);
};
const $9266a1741c0c4a4d$var$ForgeDeprecationMessageFallback = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { extension: extension, error: error } = props;
    const title = extension.properties.title;
    let t0;
    if ($[0] !== error || $[1] !== title) {
        t0 = $9266a1741c0c4a4d$var$buildMessage(title, error);
        $[0] = error;
        $[1] = title;
        $[2] = t0;
    } else t0 = $[2];
    const message = t0;
    let t1;
    if ($[3] !== message) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: "App update required",
            appearance: "error"
        }, message);
        $[3] = message;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { extension: extension, error: error } = props;
    const title = extension.properties.title;
    const message = $9266a1741c0c4a4d$var$buildMessage(title, error);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: "App update required",
        appearance: "error"
    }, message);
};
const $9266a1741c0c4a4d$export$e812f4e5298c004d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9266a1741c0c4a4d$var$ForgeDeprecationMessageFallback, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const fallback = t0;
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9266a1741c0c4a4d$var$ForgeDeprecationMessageInner, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== fallback || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gDqww.RelaySuspensefulBoundary), {
            fallback: fallback,
            errorFallback: fallback
        }, t1);
        $[4] = fallback;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (props)=>{
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9266a1741c0c4a4d$var$ForgeDeprecationMessageFallback, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gDqww.RelaySuspensefulBoundary), {
        fallback: fallback,
        errorFallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9266a1741c0c4a4d$var$ForgeDeprecationMessageInner, props));
};
module.exports["ForgeDeprecationMessage"] = $9266a1741c0c4a4d$export$e812f4e5298c004d;

});

parcelRegister("6M43m", function(module, exports) {
/**
 * @generated SignedSource<<8e95e05a6faa0da7a3f16bed87ddef4a>>
 * @relayHash 0d86d9514ed0dc62ec55c47550347432
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10ddb346add2537047e9d08fed9494c213c3fbe41490cba82af8d9314e0e9855
const $74d8292c05ea637b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ForgeModalDeprecationMessage_appQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ForgeModalDeprecationMessage_appQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "10ddb346add2537047e9d08fed9494c213c3fbe41490cba82af8d9314e0e9855",
            "metadata": {},
            "name": "ForgeModalDeprecationMessage_appQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$74d8292c05ea637b$var$node.hash = "6249f13b9dc8b658b8478b0412f6a152";
var $74d8292c05ea637b$export$2e2bcd8739ae039 = $74d8292c05ea637b$var$node;
module.exports["default"] = $74d8292c05ea637b$export$2e2bcd8739ae039;

});

parcelRegister("gDqww", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hq6tn = parcelRequire("hq6tn");

const $3f607a4f5bceaa3c$export$4234d7cd582aba17 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, fallback: t1, errorFallback: t2 } = t0;
    const fallback = t1 === undefined ? null : t1;
    const errorFallback = t2 === undefined ? null : t2;
    let t3;
    if ($[0] !== children || $[1] !== fallback) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: fallback
        }, children);
        $[0] = children;
        $[1] = fallback;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== errorFallback || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hq6tn.RelayErrorBoundary), {
            fallback: errorFallback
        }, t3);
        $[3] = errorFallback;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ children: children, fallback: fallback = null, errorFallback: errorFallback = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hq6tn.RelayErrorBoundary), {
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallback
    }, children));
module.exports["RelaySuspensefulBoundary"] = $3f607a4f5bceaa3c$export$4234d7cd582aba17;

});

parcelRegister("fgcBS", function(module, exports) {
/**
 * @generated SignedSource<<845dc4dc6ae5e67e36d3cbb2c72ca965>>
 * @relayHash ebca7fca92ead3748b535be27a7da2d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9b2fb272613065d86d17a8320d95aabce6cbe3c4fe87e476268744b2c438c43
const $c62a149a9658ec98$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "user_forge_ui_userQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "user_forge_ui_userQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c9b2fb272613065d86d17a8320d95aabce6cbe3c4fe87e476268744b2c438c43",
            "metadata": {},
            "name": "user_forge_ui_userQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c62a149a9658ec98$var$node.hash = "d05625ee70ba3d55ce9b8d550af8d0eb";
var $c62a149a9658ec98$export$2e2bcd8739ae039 = $c62a149a9658ec98$var$node;
module.exports["default"] = $c62a149a9658ec98$export$2e2bcd8739ae039;

});

parcelRegister("4ej2P", function(module, exports) {
/**
 * @generated SignedSource<<f9f8a732fc0bc8e97cfa59a06dddcaed>>
 * @relayHash 803200a52f130572caf872b4e016fb1a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2792700d56c071d783bc368a3b8cec5a1a1b6af55acd17a1b662a73ae865bd12
const $a58751284524b2a0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usergroup_forge_ui_usersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usergroup_forge_ui_usersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2792700d56c071d783bc368a3b8cec5a1a1b6af55acd17a1b662a73ae865bd12",
            "metadata": {},
            "name": "usergroup_forge_ui_usersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a58751284524b2a0$var$node.hash = "d0105c23c646ed326ba46ee28241752a";
var $a58751284524b2a0$export$2e2bcd8739ae039 = $a58751284524b2a0$var$node;
module.exports["default"] = $a58751284524b2a0$export$2e2bcd8739ae039;

});

parcelRegister("kogLA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $4e619e1385620f74$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS = 15;
const $4e619e1385620f74$export$9de303ca9515c607 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    const containerRef = (0, $cozmU.useRef)(null);
    const [height, setHeight] = (0, $cozmU.useState)(null);
    const [observationInvalidatedReason, setObservationInvalidatedReason] = (0, $cozmU.useState)(null);
    const uniqueSizeObservationsRef = (0, $cozmU.useRef)(0);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (newHeight)=>{
            setHeight((prevHeight)=>{
                if (prevHeight !== newHeight) uniqueSizeObservationsRef.current = uniqueSizeObservationsRef.current + 1;
                return newHeight;
            });
        };
        $[0] = t0;
    } else t0 = $[0];
    const handleHeightChange = t0;
    let t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if (!containerRef.current) return;
            uniqueSizeObservationsRef.current = 0;
            const observer = new ResizeObserver((t3)=>{
                const [entry] = t3;
                const newHeight_0 = Math.trunc(entry.contentRect.height);
                handleHeightChange(newHeight_0);
                if (uniqueSizeObservationsRef.current >= $4e619e1385620f74$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS) {
                    observer.disconnect();
                    setObservationInvalidatedReason(`Stopped counting after ${$4e619e1385620f74$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS} unique resize events`);
                }
            });
            observer.observe(containerRef.current);
            return ()=>observer.disconnect();
        };
        t2 = [
            handleHeightChange
        ];
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== height || $[4] !== observationInvalidatedReason) {
        t3 = {
            containerRef: containerRef,
            height: height,
            observationInvalidatedReason: observationInvalidatedReason
        };
        $[3] = height;
        $[4] = observationInvalidatedReason;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ()=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const [height, setHeight] = (0, $cozmU.useState)(null);
    const [observationInvalidatedReason, setObservationInvalidatedReason] = (0, $cozmU.useState)(null);
    const uniqueSizeObservationsRef = (0, $cozmU.useRef)(0);
    // Memoize the observer callback to handle height changes
    const handleHeightChange = (0, $cozmU.useCallback)((newHeight)=>{
        setHeight((prevHeight)=>{
            if (prevHeight !== newHeight) uniqueSizeObservationsRef.current++;
            return newHeight;
        });
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!containerRef.current) return;
        // Reset observation counter for this instance
        uniqueSizeObservationsRef.current = 0;
        const observer = new ResizeObserver(([entry])=>{
            const newHeight_0 = Math.trunc(entry.contentRect.height);
            handleHeightChange(newHeight_0);
            // Break after too many unique changes to prevent excessive tracking
            if (uniqueSizeObservationsRef.current >= $4e619e1385620f74$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS) {
                observer.disconnect();
                setObservationInvalidatedReason(`Stopped counting after ${$4e619e1385620f74$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS} unique resize events`);
            }
        });
        observer.observe(containerRef.current);
        // Cleanup observer on unmount
        return ()=>observer.disconnect();
    }, [
        handleHeightChange
    ]);
    return {
        containerRef: containerRef,
        height: height,
        observationInvalidatedReason: observationInvalidatedReason
    };
};
module.exports["useHeightObserver"] = $4e619e1385620f74$export$9de303ca9515c607;

});

parcelRegister("fO0Vm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

const $6dff73353e9bc529$export$cc725e2aa41de44a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (data, t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const equalityCheck = t0 === undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))) : t0;
    const [memoizedData, setMemoizedData] = (0, $cozmU.useState)(data);
    let t1;
    let t2;
    if ($[0] !== data || $[1] !== equalityCheck || $[2] !== memoizedData) {
        t1 = ()=>{
            if (!equalityCheck(data, memoizedData)) setMemoizedData(data);
        };
        t2 = [
            data,
            memoizedData,
            equalityCheck
        ];
        $[0] = data;
        $[1] = equalityCheck;
        $[2] = memoizedData;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return memoizedData;
} : (data, equalityCheck = (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))))=>{
    const [memoizedData, setMemoizedData] = (0, $cozmU.useState)(data);
    (0, $cozmU.useEffect)(()=>{
        if (!equalityCheck(data, memoizedData)) setMemoizedData(data);
    }, [
        data,
        memoizedData,
        equalityCheck
    ]);
    return memoizedData;
};
module.exports["useMemoizedStateObject"] = $6dff73353e9bc529$export$cc725e2aa41de44a;

});

parcelRegister("jerTb", function(module, exports) {

var $hfFJ2 = parcelRequire("hfFJ2");


var $1Bv8Y = parcelRequire("1Bv8Y");


var $4DMV4 = parcelRequire("4DMV4");


var $iuxS5 = parcelRequire("iuxS5");


var $fXNFR = parcelRequire("fXNFR");




var $dK9hN = parcelRequire("dK9hN");

const $af76dd039643d4b2$export$9b96caef38763092 = ()=>{
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
module.exports["getBrowserTimezone"] = $af76dd039643d4b2$export$9b96caef38763092;

});

parcelRegister("et00U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iIo47 = parcelRequire("iIo47");


var $iMnC5 = parcelRequire("iMnC5");


var $2VwyL = parcelRequire("2VwyL");


var $iDrrr = parcelRequire("iDrrr");


var $6SsN4 = parcelRequire("6SsN4");


var $6ojvx = parcelRequire("6ojvx");


var $6YMeN = parcelRequire("6YMeN");

var $lBErP = parcelRequire("lBErP");

var $7Y94N = parcelRequire("7Y94N");

var $fccjA = parcelRequire("fccjA");


var $gJkLc = parcelRequire("gJkLc");


var $84ihY = parcelRequire("84ihY");


var $cVuzC = parcelRequire("cVuzC");


var $8OfFZ = parcelRequire("8OfFZ");

var $2gSYB = parcelRequire("2gSYB");

var $2MUrL = parcelRequire("2MUrL");

var $c71c0 = parcelRequire("c71c0");

var $67Hav = parcelRequire("67Hav");

var $llM9z = parcelRequire("llM9z");

var $l2msJ = parcelRequire("l2msJ");


var $eL3mC = parcelRequire("eL3mC");


var $4DMV4 = parcelRequire("4DMV4");

var $jerTb = parcelRequire("jerTb");

var $iuxS5 = parcelRequire("iuxS5");

var $fXNFR = parcelRequire("fXNFR");


var $4pyQd = parcelRequire("4pyQd");


var $1y2Zu = parcelRequire("1y2Zu");


var $iyAN0 = parcelRequire("iyAN0");


var $dGVOK = parcelRequire("dGVOK");


var $8yKod = parcelRequire("8yKod");

var $bEbDR = parcelRequire("bEbDR");


var $gFIer = parcelRequire("gFIer");


var $fmBaq = parcelRequire("fmBaq");


var $9ZDPN = parcelRequire("9ZDPN");


var $7arEA = parcelRequire("7arEA");


var $2lRPc = parcelRequire("2lRPc");




let $e82f4af620d7771f$var$postRobotOn = null;

if (typeof window !== 'undefined') $e82f4af620d7771f$var$postRobotOn = (parcelRequire("9rzZK")).postRobotOn;
const $e82f4af620d7771f$var$styles = {
    threeLOInfo: "_39xV02N91d _0jFU0VN91d",
    box: "_1mT5xdRAKS"
}; // TODO: no styles defined for resizable modals yet.
// Only Jira enables resizing on modals at the moment.
const $e82f4af620d7771f$var$modalIframeStyles = null;
const $e82f4af620d7771f$var$iframeStyles = null;
const $e82f4af620d7771f$var$hiddenIframeStyles = null;
const $e82f4af620d7771f$var$nonResizeableIframeStyles = null;
const $e82f4af620d7771f$var$defaultComponents = {
    ThreeLOPrompt: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVuzC.default), props)
}; /**
    * Hook for determining default IFrame React ref, using parent ref when provided
    *
    * @param parentIframeRef parent IFrame React ref
    * @returns default IFrame React ref
    */ 
const $e82f4af620d7771f$var$useDefaultIframeRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useDefaultIframeRef(parentIframeRef) {
    const $ = (0, $bDgLe.c)(2);
    const localIframeRef = (0, $cozmU.useRef)(null);
    let t0;
    if ($[0] !== parentIframeRef) {
        t0 = [
            parentIframeRef,
            localIframeRef
        ];
        $[0] = parentIframeRef;
        $[1] = t0;
    } else t0 = $[1];
    const mergedRef = (0, $2VwyL.useMergeRefs)(t0);
    return mergedRef;
} : function useDefaultIframeRef(parentIframeRef) {
    const localIframeRef = (0, $cozmU.useRef)(null);
    const mergedRef = (0, $2VwyL.useMergeRefs)([
        parentIframeRef,
        localIframeRef
    ]);
    return mergedRef;
};
const $e82f4af620d7771f$export$3c4d31cb85fd39c5 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ accountId: accountId, extension: extension, contextIds: contextIds, components: components, coreData: coreData, extensionData: extensionData, extensionViewData: extensionViewData, loadingComponent: loadingComponent, onLoad: onLoad, height: height = '100%', width: width = '100%', src: src, bridge: bridge, customBridgeMethods: customBridgeMethods, isResizable: isResizable, getContextToken: getContextToken, timezone: timezone, locale: locale, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, extensionPayload: extensionPayload, isHidden: isHidden, theme: theme, surfaceColor: surfaceColor, appId: appId, isInModal: isInModal, setIsLoading: setIsLoading, onError: onError, entryPoint: entryPoint, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId }, parentIframeRef)=>{
    const { ThreeLOPrompt: ThreeLOPrompt } = components ? components($e82f4af620d7771f$var$defaultComponents) : $e82f4af620d7771f$var$defaultComponents;
    const appIsAuthenticated = (0, $4pyQd.isAppConsentedLocally)(appId, accountId);
    const { appVersion: appVersion, consentUrl: consentUrl, currentUserConsent: currentUserConsent, requiresUserConsent: requiresUserConsent, properties: { frameId: frameId, layout: layout } } = extension;
    const [userConsentRequired, setUserConsentRequired] = (0, $cozmU.useState)(consentUrl && !currentUserConsent && requiresUserConsent && !appIsAuthenticated);
    const productContext = (0, $cozmU.useMemo)(()=>{
        const resolverContext = (0, $iuxS5.getResolverContext)({
            ...coreData,
            appVersion: appVersion
        }, extensionData);
        const viewContext = (0, $fXNFR.getViewContext)({
            resolverContext: resolverContext,
            accountId: accountId,
            extension: extension,
            timezone: timezone ?? (0, $jerTb.getBrowserTimezone)(),
            locale: locale ?? (0, $4DMV4.getBrowserLocale)(),
            extensionPayload: extensionPayload,
            extensionViewData: extensionViewData,
            theme: theme,
            surfaceColor: surfaceColor,
            location: window.location.toString()
        });
        return {
            resolverContext: resolverContext,
            viewContext: viewContext
        };
    }, [
        appVersion,
        coreData,
        extensionData,
        extensionViewData,
        accountId,
        extension,
        timezone,
        locale,
        extensionPayload,
        theme,
        surfaceColor
    ]); // For embedded macros, create context token options to pass to getContextToken
    // This ensures the token is generated for the embedded macro's context, not the parent's
    const embeddedMacroContextTokenOptions = ((0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? !!embeddedMacroParentType : isEmbeddedMacro) ? {
        extensionOverride: {
            extension: extension,
            localId: coreData.localId
        }
    } : undefined; /**
                  * Wrapper for getContextToken that handles both embedded macro and regular cases.
                  * For embedded macros, includes the extension override to generate a token scoped to the embedded macro.
                  * Falls back to cached token when getContextToken is not available.
                  */ 
    const getContextTokenWrapper = async (contextIdsOverride)=>{
        if (!getContextToken) return contextTokenRef.current?.jwt;
        if ((0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? !!embeddedMacroParentType : isEmbeddedMacro) return getContextToken({
            extensionOverride: {
                extension: extension,
                localId: coreData.localId
            },
            ...contextIdsOverride && {
                contextIdsOverride: contextIdsOverride
            }
        });
        return contextIdsOverride ? getContextToken({
            contextIdsOverride: contextIdsOverride
        }) : getContextToken();
    };
    const tracing = (0, $eL3mC.useTracingContext)();
    const contextTokenRef = (0, $cozmU.useRef)(undefined);
    const [threeLOInfo, setThreeLOInfo] = (0, $cozmU.useState)(null);
    const invokeRetriesRef = (0, $cozmU.useRef)([]);
    const iframeRef = $e82f4af620d7771f$var$useDefaultIframeRef(parentIframeRef);
    (0, $cozmU.useEffect)(()=>{
        const clearThreeLOInfo = async ()=>setThreeLOInfo(null);
        if (userConsentRequired) {
            tracing?.recordConsentFlow('consent flow - start');
            setThreeLOInfo({
                authUrl: consentUrl,
                onSuccess: async ()=>{
                    tracing?.recordConsentFlow('consent flow - end', 'success');
                    setUserConsentRequired(false);
                    setIsThreeLOPromptVisible(false);
                    (0, $4pyQd.setAppConsentLocal)(appId, accountId);
                    return clearThreeLOInfo();
                },
                onReject: ()=>{
                    tracing?.recordConsentFlow('consent flow - end', 'rejected');
                    return clearThreeLOInfo();
                }
            });
            setIsThreeLOPromptVisible(true);
            setShouldShowRenderer?.(false);
            if (onLoad) onLoad();
        }
    }, [
        onLoad,
        setIsThreeLOPromptVisible,
        setShouldShowRenderer,
        tracing,
        appId,
        accountId,
        consentUrl,
        userConsentRequired
    ]);
    const navigation = (0, $67Hav.useNavigation)({
        extension: extension,
        push: bridge?.spaPush,
        appId: appId,
        onNavigate: bridge?.onNavigate,
        openNewTabAsPopupWindow: bridge?.openNewTabAsPopupWindow
    });
    const navigationRef = (0, $cozmU.useRef)(navigation);
    navigationRef.current = navigation; // Skip FAUS navigate listener setup when this is the UI Kit macro custom config view (current resource is the config resource).
    const isMacroConfigView = Boolean(extension.properties?.config?.resource && extension.properties?.resource === extension.properties?.config?.resource); // Listen for navigate events from FAUS (e.g. link clicks in forge-adf-renderer). Skip when in modal or UI Kit macro custom config so only the macro body registers.
    (0, $cozmU.useEffect)(()=>{
        if (layout === 'bodied' && coreData.localId && $e82f4af620d7771f$var$postRobotOn && !isInModal && !isMacroConfigView && (0, $iDrrr.fg)('platform_faus_navigate_to_product')) {
            const allowedDomain = (0, $2gSYB.getProductDomain)();
            try {
                const listener = $e82f4af620d7771f$var$postRobotOn(`navigateFromEmbeddedFAUS_${coreData.localId}`, {
                    domain: allowedDomain
                }, async ({ data: data })=>{
                    if (!data?.url) return;
                    navigationRef.current.onNavigate({
                        type: 'new-tab',
                        url: data.url
                    }).catch(()=>{});
                });
                return ()=>{
                    listener.cancel();
                }; // eslint-disable-next-line no-unused-vars
            } catch (_) {
                // eslint-disable-next-line no-console
                console.log('Failed to set up navigation listener');
            }
        }
    }, [
        layout,
        coreData.localId,
        isInModal,
        isMacroConfigView
    ]);
    const invoker = (0, $lBErP.useInvokeExtension)(contextIds, extension.id); // The hash generated here should match the one created in the Realtime service when it hashes extension.context
    // in the FCT.
    // If this is flaky because of differences between extensionData and the FCT's extension.context, then
    // use the decoded FCT context directly here as well.
    const extensionContext = (()=>{
        try {
            const { modal: // eslint-disable-next-line no-unused-vars
            modal, ...productExtensionData } = extensionData;
            return (0, (/*@__PURE__*/$parcel$interopDefault($iIo47)))(productExtensionData || {}); // eslint-disable-next-line no-unused-vars
        } catch (__0) {
            // eslint-disable-next-line no-console
            console.error('Product context is not a serializable object.');
            return '';
        }
    })(); // the realtime hooks below have no side effect (i.e. does not actively trigger any network calls or actively makes any subscription).
    // It is because everything inside this hook is lazily initialized.
    // Importantly:
    // - SubscribeRealtimeChannel is called by the client (i.e. @forge/bridge)
    const subscribeRealtimeChannel = (0, $fccjA.useSubscribeRealtimeChannel)(extension.installationId, extensionContext, getContextToken, embeddedMacroContextTokenOptions);
    const publishRealtimeChannel = (0, $7Y94N.usePublishRealtimeChannel)(extension.installationId, extensionContext, appId);
    const renderThreeLOPrompt = (retry)=>{
        return new Promise((resolve, reject)=>{
            const authUrl = threeLOInfo?.authUrl || consentUrl;
            if (authUrl) {
                invokeRetriesRef.current.push(retry);
                tracing?.recordConsentFlow('consent flow - start');
                setThreeLOInfo({
                    authUrl: authUrl,
                    onSuccess: ()=>{
                        tracing?.recordConsentFlow('consent flow - end', 'success');
                        resolve();
                        setThreeLOInfo(null);
                        setIsThreeLOPromptVisible(false);
                        setShouldShowRenderer?.(true);
                        return Promise.all(invokeRetriesRef.current.map((retry_0)=>retry_0())).then(()=>{
                            invokeRetriesRef.current = [];
                        });
                    },
                    onReject: ()=>{
                        tracing?.recordConsentFlow('consent flow - end', 'rejected');
                        return reject();
                    }
                });
                setIsThreeLOPromptVisible(true);
                setShouldShowRenderer?.(false);
            }
        });
    };
    const environment = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const relayEnvironment = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext))?.environment;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const rovoChat = (0, $l2msJ.useRovoAgentsChat)(extension.type, appId, cloudId, extension.installationId, extension.environmentId);
    const isAnonymousAccessSupportedByApp = extension.properties?.unlicensedAccess?.includes('anonymous') ?? false;
    const productFetchClient = (0, $2MUrL.useProductFetchClient)({
        appId: appId,
        environment: environment,
        contextIds: contextIds,
        cloudId: cloudId,
        workspaceId: workspaceId,
        extensionId: extension.id,
        renderThreeLOPrompt: renderThreeLOPrompt,
        isAnonymousAccessSupportedByApp: isAnonymousAccessSupportedByApp
    });
    const permissions = (0, $llM9z.usePermission)({
        appId: appId,
        installationId: extension.installationId,
        contextIds: contextIds,
        extensionId: extension.id,
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    const emitPublicEvent = (0, $6YMeN.useEmitPublicEvent)(contextIds[0], {
        appId: extension.appId,
        id: extension.id.split('/').slice(0, 3).join('/'),
        installationId: extension.installationId
    });
    const fetchRemoteClient = (0, $2lRPc.useRemoteFetchClient)();
    const permissionFunctions = Object.fromEntries((0, $llM9z.permissionMethods).map((method)=>[
            `${(0, $llM9z.PERMISSION_METHOD_PREFIX)}${method}`,
            permissions[method]
        ]));
    const { loading: loading, iframeProps: { onLoad: onLoadIframeFromProps } } = (0, $c71c0.useBridge)({
        cloudId: cloudId,
        theme: theme,
        surfaceColor: surfaceColor,
        origin: new URL(src).origin,
        api: {
            ...(0, $8OfFZ.createBridgeApi)(bridge, {
                userConsentRequired: !!userConsentRequired
            }),
            openRovo: rovoChat.openRovo,
            onInvoke: async (payload)=>{
                const contextToken = await getContextTokenWrapper(contextIds);
                tracing?.recordGqlCall('invokeExtension - start');
                const { data: data_0 } = await invoker({
                    call: payload,
                    context: {
                        ...productContext.resolverContext
                    },
                    extensionPayload: extensionPayload,
                    contextToken: contextToken
                }); // Default to using the regular invocation response
                var resp = data_0?.invokeExtension;
                if (!resp?.success) {
                    const error = resp?.errors?.[0];
                    if (error?.extensions.errorType === 'USER_CONSENT_REQUIRED') return {
                        type: '3lo',
                        authUrl: error?.extensions.fields?.authInfoUrl
                    };
                    if ((error?.extensions.errorType === (0, $iyAN0.SANDBOX_DEPRECATION_ERROR) || (0, $iyAN0.isDeveloperSpaceError)(error?.extensions.errorType)) && onError) onError(error?.extensions.errorType);
                    return {
                        type: 'err',
                        message: error?.message ?? 'An error occurred while trying to invoke.'
                    };
                }
                tracing?.recordGqlCall('invokeExtension - end');
                contextTokenRef.current = resp?.contextToken;
                return {
                    type: 'ok',
                    response: resp?.response?.body,
                    metadata: {
                        rateLimitProperties: resp?.rateLimitProperties
                    }
                };
            },
            onInitFeatureFlags: async (data_1)=>{
                const contextToken_0 = await getContextTokenWrapper();
                tracing?.recordBridgeCall('getFeatureFlags - start');
                try {
                    const resp_0 = await (0, $fmBaq.getFeatureFlags)(appId, data_1.user, data_1.config, environment, contextToken_0);
                    tracing?.recordBridgeCall('getFeatureFlags - end');
                    return {
                        type: 'ok',
                        response: resp_0
                    };
                } catch (err) {
                    tracing?.recordBridgeCall('getFeatureFlags - end'); // eslint-disable-next-line no-console
                    console.error('There were errors while initialising feature flags client ', err);
                    return {
                        type: 'err',
                        message: 'An error occurred while trying to initialise feature flags client.'
                    };
                }
            },
            onEmitFrontendCustomMetric: async (data_2)=>{
                // Bail without a context ARI or Relay env. `contextIds[0]` is typed `string` but is `undefined` for an empty array.
                const contextAri = contextIds[0];
                if (!contextAri || !relayEnvironment) return;
                tracing?.recordBridgeCall('emitFrontendCustomMetric - start');
                try {
                    // `extension.type` is the module *type* (e.g. `jira:issuePanel`); the module *key* is the
                    // last segment of the extension ARI — parse it the same way Iframe.tsx does.
                    const { moduleKey: moduleKey } = (0, $bEbDR.parseExtensionId)(extension.id);
                    await (0, $9ZDPN.emitFrontendCustomMetric)({
                        relayEnvironment: relayEnvironment,
                        contextAri: contextAri,
                        appId: appId,
                        installationId: extension.installationId,
                        moduleKey: moduleKey,
                        customMetricName: data_2.customMetricName,
                        value: data_2.value
                    });
                } catch  {}
                tracing?.recordBridgeCall('emitFrontendCustomMetric - end');
            },
            onEmitFrontendLogs: async (data_3)=>{
                const contextAri_0 = contextIds[0];
                if (!contextAri_0 || !relayEnvironment || !Array.isArray(data_3.logs) || data_3.logs.length === 0) return;
                tracing?.recordBridgeCall('emitFrontendLogs - start');
                try {
                    await (0, $7arEA.emitFrontendLogs)({
                        relayEnvironment: relayEnvironment,
                        contextAri: contextAri_0,
                        appId: appId,
                        installationId: extension.installationId,
                        extensionId: extension.id,
                        logs: data_3.logs
                    });
                } catch  {}
                tracing?.recordBridgeCall('emitFrontendLogs - end');
            },
            onNavigate: navigation.onNavigate,
            onThreeLO: async (authUrl_0, retry_1)=>{
                return new Promise((resolve_0, reject_0)=>{
                    invokeRetriesRef.current.push(retry_1);
                    tracing?.recordConsentFlow('consent flow - start');
                    setThreeLOInfo({
                        authUrl: authUrl_0,
                        onSuccess: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'success');
                            resolve_0();
                            setThreeLOInfo(null);
                            setIsThreeLOPromptVisible(false);
                            setShouldShowRenderer?.(true);
                            return Promise.all(invokeRetriesRef.current.map((retry_2)=>retry_2())).then(()=>{
                                invokeRetriesRef.current = [];
                            });
                        },
                        onReject: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'rejected');
                            return reject_0();
                        }
                    });
                    setIsThreeLOPromptVisible(true);
                    setShouldShowRenderer?.(false);
                });
            },
            getContext: async ()=>({
                    ...productContext.viewContext
                }),
            fetchProduct: async ({ restPath: restPath, product: product, fetchRequestInit: fetchRequestInit, isMultipartFormData: isMultipartFormData })=>{
                const response = await productFetchClient(restPath, product, fetchRequestInit, isMultipartFormData);
                const { status: status, statusText: statusText } = response;
                const headers = Object.fromEntries(response.headers.entries());
                const isAttachment = (0, $2MUrL.isBinaryContentType)(response.headers.get('content-type'));
                const body = response.body ? await response.text() : undefined;
                return {
                    headers: headers,
                    status: status,
                    statusText: statusText,
                    body: body,
                    isAttachment: isAttachment
                };
            },
            fetchRemote: async ({ remoteKey: remoteKey, fetchRequestInit: fetchRequestInit_0, isMultipartFormData: isMultipartFormData_0 })=>{
                const { path: path, ...init } = fetchRequestInit_0;
                const contextToken_1 = await getContextTokenWrapper();
                const response_0 = await fetchRemoteClient(remoteKey, init, isMultipartFormData_0, path, contextToken_1);
                const { status: status_0, statusText: statusText_0 } = response_0;
                const headers_0 = Object.fromEntries(response_0.headers.entries());
                const isAttachment_0 = (0, $2MUrL.isBinaryContentType)(response_0.headers.get('content-type'));
                const body_0 = response_0.body ? await response_0.text() : undefined;
                return {
                    headers: headers_0,
                    status: status_0,
                    statusText: statusText_0,
                    body: body_0,
                    isAttachment: isAttachment_0
                };
            },
            ...(0, $iDrrr.fg)('forge-ui-enable-requestteamworkgraph-bridge-method') ? {
                requestTeamworkGraph: async (payload_0)=>{
                    // NOTE : The bridge v2 method is to be used as the source of truth for this implementation.
                    const teamworkGraphSpecificParams = {
                        path: (0, $84ihY.TEAMWORK_GRAPH_GATEWAY_PATH),
                        product: 'teamwork-graph',
                        fetchRequestInit: {
                            method: 'POST',
                            headers: {
                                'content-type': 'application/json',
                                'X-Query-Context': `${contextIds[0]}`
                            },
                            body: JSON.stringify(payload_0)
                        },
                        isMultipartFormData: false
                    };
                    const response_1 = await productFetchClient(teamworkGraphSpecificParams.path, teamworkGraphSpecificParams.product, teamworkGraphSpecificParams.fetchRequestInit, teamworkGraphSpecificParams.isMultipartFormData);
                    if (!response_1.ok) {
                        const errorText = await response_1.text();
                        throw new Error(`Unexpected error encountered in requestTeamworkGraph. Status: ${response_1.status} ${response_1.statusText}. Response: ${errorText}`);
                    }
                    const { data: data_4, errors: errors } = await response_1.json();
                    return {
                        data: data_4,
                        errors: errors
                    };
                }
            } : {},
            ...(0, $iDrrr.fg)('forge-ui-fetch-user-recommendations-bridge-method') ? {
                fetchUserRecommendations: async (payload_1)=>(0, $gJkLc.fetchUserRecommendations)({
                        contextIds: contextIds,
                        viewContext: productContext.viewContext
                    }, payload_1)
            } : {},
            getFrameId: ()=>frameId ?? null,
            subscribeRealtimeChannel: async (payload_2)=>{
                return subscribeRealtimeChannel(payload_2);
            },
            publishRealtimeChannel: async (payload_3)=>{
                const contextToken_2 = await getContextTokenWrapper();
                return publishRealtimeChannel(payload_3, contextToken_2);
            },
            emitPublic: emitPublicEvent,
            ...permissionFunctions
        },
        customBridgeMethods: customBridgeMethods,
        onLoad: onLoad,
        isResizable: isResizable,
        height: height,
        environment: environment,
        extension: extension,
        iframeRef: iframeRef,
        contextIds: contextIds,
        isInModal: isInModal,
        localId: coreData.localId,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedMacroParentType: embeddedMacroParentType,
        embeddedParentLocalId: embeddedParentLocalId,
        extensionPayload: extensionPayload,
        extensionData: extensionData
    });
    (0, $cozmU.useEffect)(()=>{
        setIsLoading?.(loading);
    }, [
        loading,
        setIsLoading
    ]);
    const { containerRef: containerRef } = (0, $dGVOK.useResizeAnalytics)({
        // need to check if the extension is custom UI as well since this component is used in WebRuntime for UI Kit
        isEnabled: (0, $8yKod.isCustomUI)(extension, entryPoint) && (0, $iDrrr.fg)('forge-ui-app-perf-tracking-enabled')
    });
    const sandboxAttributeRules = [
        'allow-downloads',
        'allow-forms',
        'allow-modals',
        'allow-pointer-lock',
        'allow-same-origin',
        'allow-scripts'
    ];
    try {
        const egressService = (0, $gFIer.egressPermissionService)('FETCH_CLIENT_SIDE', extension.egress);
        const containsWildCardEgress = egressService.containsWildCardEgress();
        if (containsWildCardEgress) sandboxAttributeRules.push('allow-popups', 'allow-popups-to-escape-sandbox');
         // eslint-disable-next-line no-unused-vars
    } catch (__1) {}
    if (extension.sandboxPolicies?.includes('allow_storage_access_by_user_activation') && (0, $iDrrr.fg)('allow_storage_access_by_user_activation_attribute')) sandboxAttributeRules.push('allow-storage-access-by-user-activation');
    let framePermissionsPolicy = 'camera; clipboard-write; display-capture; fullscreen; microphone';
    if ((0, $iDrrr.fg)('platform_forge-ui_frame-allow-local-network-access')) framePermissionsPolicy += '; local-network-access';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: containerRef,
        xcss: $e82f4af620d7771f$var$styles.box,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: isResizable || threeLOInfo ? undefined : height,
            width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width
        }
    }, navigation.getModalJsx(), permissions.getModalJsx(), (loading || threeLOInfo) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e82f4af620d7771f$var$styles.threeLOInfo
    }, loading && !threeLOInfo && !isHidden && (0, $1y2Zu.getLoadingComponent)(loadingComponent), threeLOInfo && ThreeLOPrompt({
        authUrl: threeLOInfo.authUrl,
        onSuccess: threeLOInfo.onSuccess,
        metadata: {
            moduleType: extension.type
        }
    })), !userConsentRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        "data-testid": "hosted-resources-iframe",
        "data-forge-iframe": true,
        sandbox: sandboxAttributeRules.join(' '),
        allow: framePermissionsPolicy,
        src: src,
        ref: iframeRef,
        onLoad: onLoadIframeFromProps,
        title: `Embedded app content for ${extension.properties?.name ?? appId}`,
        className: (0, $hekY6.default)([
            "_30huDKYbGa _3iDTPbvLZJ _39xV02N91d",
            (loading || threeLOInfo || isHidden) && "_3iDTPbYbGa",
            isInModal && "_0bjKvDzXzM _0jFU0VN91d",
            !isResizable && "_0jFU0VN91d"
        ])
    })));
});
module.exports["InnerIframe"] = $e82f4af620d7771f$export$3c4d31cb85fd39c5;

});

parcelRegister("1y2Zu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lCGo1 = parcelRequire("lCGo1");

const $8472600fe3457814$export$aee5524fcec014ce = (loadingComponent)=>{
    if (loadingComponent) return typeof loadingComponent === 'function' ? loadingComponent() : loadingComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lCGo1.Loader), null);
};
module.exports["getLoadingComponent"] = $8472600fe3457814$export$aee5524fcec014ce;

});

parcelRegister("7vufB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $f96Dm = parcelRequire("f96Dm");


var $hq6tn = parcelRequire("hq6tn");

const $1963bdc5863e00c4$var$TunnelsLoader = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { appId: appId, contextIds: contextIds, environmentId: environmentId, children: children } = t0;
    let t1;
    if ($[0] !== appId || $[1] !== contextIds || $[2] !== environmentId) {
        t1 = {
            appId: appId,
            environmentId: environmentId,
            contextIds: contextIds
        };
        $[0] = appId;
        $[1] = contextIds;
        $[2] = environmentId;
        $[3] = t1;
    } else t1 = $[3];
    const { tunnels: tunnels } = (0, $f96Dm.useCustomUITunnelsListRelay)(t1);
    let t2;
    if ($[4] !== children || $[5] !== tunnels) {
        t2 = children({
            loading: false,
            tunnels: tunnels
        });
        $[4] = children;
        $[5] = tunnels;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ appId: appId, contextIds: contextIds, environmentId: environmentId, children: children })=>{
    const { tunnels: tunnels } = (0, $f96Dm.useCustomUITunnelsListRelay)({
        appId: appId,
        environmentId: environmentId,
        contextIds: contextIds
    });
    return children({
        loading: false,
        tunnels: tunnels
    });
};
const $1963bdc5863e00c4$export$ac05e5a66b1a4559 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { environmentType: environmentType, appId: appId, contextIds: contextIds, environmentId: environmentId, children: children } = t0;
    let t1;
    if ($[0] !== appId || $[1] !== children || $[2] !== contextIds || $[3] !== environmentId || $[4] !== environmentType) {
        t1 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const fallbackResult = {
                tunnels: [],
                loading: true
            };
            if (environmentType === "DEVELOPMENT") {
                let t2;
                if ($[6] !== children) {
                    t2 = children({
                        tunnels: [],
                        loading: false
                    });
                    $[6] = children;
                    $[7] = t2;
                } else t2 = $[7];
                let t3;
                if ($[8] !== appId || $[9] !== children || $[10] !== contextIds || $[11] !== environmentId) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1963bdc5863e00c4$var$TunnelsLoader, {
                        appId: appId,
                        contextIds: contextIds,
                        environmentId: environmentId,
                        children: children
                    });
                    $[8] = appId;
                    $[9] = children;
                    $[10] = contextIds;
                    $[11] = environmentId;
                    $[12] = t3;
                } else t3 = $[12];
                const t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                    fallback: children(fallbackResult)
                }, t3);
                let t5;
                if ($[13] !== t2 || $[14] !== t4) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hq6tn.RelayErrorBoundary), {
                        fallback: t2
                    }, t4);
                    $[13] = t2;
                    $[14] = t4;
                    $[15] = t5;
                } else t5 = $[15];
                t1 = t5;
                break bb0;
            }
        }
        $[0] = appId;
        $[1] = children;
        $[2] = contextIds;
        $[3] = environmentId;
        $[4] = environmentType;
        $[5] = t1;
    } else t1 = $[5];
    if (t1 !== Symbol.for("react.early_return_sentinel")) return t1;
    let t2;
    if ($[16] !== children) {
        t2 = children({
            loading: false,
            tunnels: []
        });
        $[16] = children;
        $[17] = t2;
    } else t2 = $[17];
    return t2;
} : ({ environmentType: environmentType, appId: appId, contextIds: contextIds, environmentId: environmentId, children: children })=>{
    const fallbackResult = {
        tunnels: [],
        loading: true
    };
    if (environmentType === 'DEVELOPMENT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hq6tn.RelayErrorBoundary), {
        fallback: children({
            tunnels: [],
            loading: false
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: children(fallbackResult)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1963bdc5863e00c4$var$TunnelsLoader, {
        appId: appId,
        contextIds: contextIds,
        environmentId: environmentId,
        children: children
    })));
    return children({
        loading: false,
        tunnels: []
    });
};
module.exports["TunnelsProvider"] = $1963bdc5863e00c4$export$ac05e5a66b1a4559;

});

parcelRegister("1UkXE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1uMa2 = parcelRequire("1uMa2");


var $3zbll = parcelRequire("3zbll");


var $5xQdV = parcelRequire("5xQdV");


var $6FQr4 = parcelRequire("6FQr4");

const $4c3e4c3b56127cbc$export$5585193a0b9bb43d = ({ context: context, children: children, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion })=>{
    const forgeReactMajorVersion = (0, $cozmU.useRef)(null);
    const initialConfigKey = (0, $cozmU.useRef)(null);
    const { config: config, ...extensionWithoutConfig } = context.extension ?? {};
    const currentConfigKey = (0, (/*@__PURE__*/$parcel$interopDefault($3zbll)))(config);
    const baseContextKey = (0, (/*@__PURE__*/$parcel$interopDefault($3zbll)))({
        ...context,
        extension: extensionWithoutConfig
    });
    const trackWrappedComponentMounted = $4c3e4c3b56127cbc$var$useWrappedComponentMountTracker();
    (0, $cozmU.useEffect)(()=>{
        (0, $1uMa2.emit)('FORGE_CORE_MACRO_CONFIG_CHANGED', {
            config: config
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentConfigKey
    ]);
    if (forgeReactMajorVersion.current === null) forgeReactMajorVersion.current = getCurrentForgeReactMajorVersion();
    if (initialConfigKey.current === null) initialConfigKey.current = currentConfigKey;
    // for existing apps we need to ensure backwards compatibility
    const shouldContextKeyChangeOnConfigChange = forgeReactMajorVersion.current === null || forgeReactMajorVersion.current < 11;
    // if the app is using the new version of Forge react, we always uses the initial config key
    const key = baseContextKey + (shouldContextKeyChangeOnConfigChange ? currentConfigKey : initialConfigKey.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4c3e4c3b56127cbc$var$WrappedComponent, {
        key: key,
        onMounted: trackWrappedComponentMounted
    }, children);
};
const $4c3e4c3b56127cbc$var$useWrappedComponentMountTracker = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6FQr4.useForgeUiAnalyticsEvent)();
    const mountedCount = (0, $cozmU.useRef)(0);
    let t0;
    let t1;
    if ($[0] !== trackExtensionRemounted) {
        t0 = ()=>{
            mountedCount.current = mountedCount.current + 1;
            if (mountedCount.current > 1) trackExtensionRemounted({
                mountCount: mountedCount.current
            });
        };
        t1 = [
            mountedCount,
            trackExtensionRemounted
        ];
        $[0] = trackExtensionRemounted;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    const trackWrappedComponentMounted = (0, $5xQdV.useCallbackOne)(t0, t1);
    return trackWrappedComponentMounted;
} : ()=>{
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6FQr4.useForgeUiAnalyticsEvent)();
    const mountedCount = (0, $cozmU.useRef)(0);
    const trackWrappedComponentMounted = (0, $5xQdV.useCallbackOne)(()=>{
        mountedCount.current += 1;
        if (mountedCount.current > 1) trackExtensionRemounted({
            mountCount: mountedCount.current
        });
    }, [
        mountedCount,
        trackExtensionRemounted
    ]);
    return trackWrappedComponentMounted;
};
const $4c3e4c3b56127cbc$var$WrappedComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, onMounted: onMounted } = t0;
    let t1;
    let t2;
    if ($[0] !== onMounted) {
        t1 = ()=>{
            onMounted();
        };
        t2 = [
            onMounted
        ];
        $[0] = onMounted;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, onMounted: onMounted })=>{
    (0, $cozmU.useEffect)(()=>{
        onMounted();
    }, [
        onMounted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["ContextChangeObserverWrapper"] = $4c3e4c3b56127cbc$export$5585193a0b9bb43d;

});

parcelRegister("402vX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5xQdV = parcelRequire("5xQdV");


var $iMnC5 = parcelRequire("iMnC5");


var $2VwyL = parcelRequire("2VwyL");


var $lvKd7 = parcelRequire("lvKd7");


var $6Rin8 = parcelRequire("6Rin8");


var $6ojvx = parcelRequire("6ojvx");

var $DIyeF = parcelRequire("DIyeF");


var $10qVl = parcelRequire("10qVl");


var $3mbzJ = parcelRequire("3mbzJ");


var $acDpC = parcelRequire("acDpC");


var $lHaWf = parcelRequire("lHaWf");


var $1y2Zu = parcelRequire("1y2Zu");


var $1Bv8Y = parcelRequire("1Bv8Y");


var $6FQr4 = parcelRequire("6FQr4");


var $2fpEe = parcelRequire("2fpEe");


var $givIf = parcelRequire("givIf");


var $gFIer = parcelRequire("gFIer");


var $iDrrr = parcelRequire("iDrrr");


var $eYWSl = parcelRequire("eYWSl");


var $bxg0J = parcelRequire("bxg0J");


var $h48r4 = parcelRequire("h48r4");

var $eL3mC = parcelRequire("eL3mC");


var $dgxed = parcelRequire("dgxed");


var $2PcLo = parcelRequire("2PcLo");

const $c73966a4dcfa1523$var$styles = {
    box: "_1mT5xdRAKS",
    loadingOverlay: "_39xV02N91d _0jFU0VN91d"
}; // TODO: no styles defined for resizable modals yet.
// Only Jira enables resizing on modals at the moment.
const $c73966a4dcfa1523$var$modalIframeStyles = null;
const $c73966a4dcfa1523$var$iframeStyles = null; // Hide via `visibility: hidden` (not `display: none`): some browsers (e.g. Safari) suspend scripts in
// non-rendered iframes, breaking app init / the bridge handshake. `height: 0` then collapses the box —
// otherwise the in-flow iframe falls back to the ~150px replaced-element default, leaving whitespace
// (e.g. under hidden UI Modifications apps).
const $c73966a4dcfa1523$var$hiddenIframeStyles = null;
const $c73966a4dcfa1523$var$nonResizableIframeStyles = null;
const $c73966a4dcfa1523$var$MACRO_MODULE_NAME = 'xen:macro'; // All permissions granted unconditionally — this is a fresh implementation with no legacy rollout gates.
const $c73966a4dcfa1523$var$FRAME_PERMISSIONS_POLICY = 'camera; clipboard-write; display-capture; fullscreen; microphone; local-network-access'; // Base sandbox rules always applied to every hosted-resource iframe.
const $c73966a4dcfa1523$var$BASE_SANDBOX_RULES = [
    'allow-downloads',
    'allow-forms',
    'allow-modals',
    'allow-pointer-lock',
    'allow-same-origin',
    'allow-scripts'
]; /**
                                                                                                                                                       * Returns the sandbox attribute string for the iframe.
                                                                                                                                                       * Apps with a wildcard egress rule are granted popup permissions so they can
                                                                                                                                                       * open third-party URLs in new tabs/windows.
                                                                                                                                                       */ 
const $c73966a4dcfa1523$var$getSandboxAttribute = (egress, sandboxPolicies)=>{
    const rules = [
        ...$c73966a4dcfa1523$var$BASE_SANDBOX_RULES
    ];
    try {
        if ((0, $gFIer.egressPermissionService)('FETCH_CLIENT_SIDE', egress).containsWildCardEgress()) rules.push('allow-popups', 'allow-popups-to-escape-sandbox');
         // eslint-disable-next-line no-unused-vars
    } catch (_) {}
    if (sandboxPolicies?.includes('allow_storage_access_by_user_activation') && (0, $iDrrr.fg)('allow_storage_access_by_user_activation_attribute')) rules.push('allow-storage-access-by-user-activation');
    return rules.join(' ');
};
const $c73966a4dcfa1523$export$3c4d31cb85fd39c5 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, parentIframeRef)=>{
    const $ = (0, $bDgLe.c)(98);
    const { accountId: accountId, appId: appId, bridge: bridge, customBridgeMethods: legacyCustomBridgeMethods, customBridge: customBridge, customBridgeContext: customBridgeContext, components: components, contextIds: contextIds, coreData: coreData, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, height: t1, isHidden: isHidden, isInModal: isInModal, isResizable: isResizable, loadingComponent: loadingComponent, locale: locale, onError: onError, onLoad: onLoad, src: src, setIsLoading: setIsLoading, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, surfaceColor: surfaceColor, theme: theme, timezone: timezone, width: t2, contextChangeListeners: contextChangeListeners } = t0;
    const height = t1 === undefined ? "100%" : t1;
    const width = t2 === undefined ? "100%" : t2;
    const { overlay: overlay, overlayController: overlayController, isInlineActive: isInlineActive } = (0, $3mbzJ.useRuntimeOverlayController)();
    let t3;
    if ($[0] !== extension || $[1] !== onError || $[2] !== overlayController || $[3] !== setShouldShowRenderer) {
        t3 = {
            overlayController: overlayController,
            extension: extension,
            setShouldShowRenderer: setShouldShowRenderer,
            onError: onError
        };
        $[0] = extension;
        $[1] = onError;
        $[2] = overlayController;
        $[3] = setShouldShowRenderer;
        $[4] = t3;
    } else t3 = $[4];
    const showAppError = (0, $acDpC.useRuntimeErrorOverlay)(t3);
    let t4;
    if ($[5] !== accountId || $[6] !== appId || $[7] !== components || $[8] !== extension || $[9] !== onLoad || $[10] !== overlayController || $[11] !== setIsThreeLOPromptVisible || $[12] !== setShouldShowRenderer) {
        t4 = {
            extension: extension,
            appId: appId,
            accountId: accountId,
            components: components,
            onLoad: onLoad,
            setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
            setShouldShowRenderer: setShouldShowRenderer,
            overlayController: overlayController
        };
        $[5] = accountId;
        $[6] = appId;
        $[7] = components;
        $[8] = extension;
        $[9] = onLoad;
        $[10] = overlayController;
        $[11] = setIsThreeLOPromptVisible;
        $[12] = setShouldShowRenderer;
        $[13] = t4;
    } else t4 = $[13];
    const { userConsentRequired: userConsentRequired, renderThreeLOPrompt: renderThreeLOPrompt } = (0, $10qVl.useInitialAppState)(t4);
    let t5;
    if ($[14] !== accountId || $[15] !== appId || $[16] !== bridge || $[17] !== contextChangeListeners || $[18] !== contextIds || $[19] !== coreData || $[20] !== customBridgeContext || $[21] !== extension || $[22] !== extensionData || $[23] !== extensionPayload || $[24] !== extensionViewData || $[25] !== getContextToken || $[26] !== locale || $[27] !== surfaceColor || $[28] !== theme || $[29] !== timezone) {
        t5 = {
            accountId: accountId,
            appId: appId,
            bridge: bridge,
            contextIds: contextIds,
            coreData: coreData,
            customBridgeContext: customBridgeContext,
            extension: extension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            extensionViewData: extensionViewData,
            getContextToken: getContextToken,
            locale: locale,
            surfaceColor: surfaceColor,
            theme: theme,
            timezone: timezone,
            contextChangeListeners: contextChangeListeners
        };
        $[14] = accountId;
        $[15] = appId;
        $[16] = bridge;
        $[17] = contextChangeListeners;
        $[18] = contextIds;
        $[19] = coreData;
        $[20] = customBridgeContext;
        $[21] = extension;
        $[22] = extensionData;
        $[23] = extensionPayload;
        $[24] = extensionViewData;
        $[25] = getContextToken;
        $[26] = locale;
        $[27] = surfaceColor;
        $[28] = theme;
        $[29] = timezone;
        $[30] = t5;
    } else t5 = $[30];
    const { getBridgeFeatures: getBridgeFeatures, getBridgeContext: getBridgeContext, destroy: cleanupBridge, setBridgeControl: setBridgeControl, onChange: onChange } = $c73966a4dcfa1523$var$useBridgeFeatures(t5, overlayController, renderThreeLOPrompt, showAppError, legacyCustomBridgeMethods, customBridge);
    const localIframeRef = (0, $cozmU.useRef)(null);
    let t6;
    if ($[31] !== parentIframeRef) {
        t6 = [
            parentIframeRef,
            localIframeRef
        ];
        $[31] = parentIframeRef;
        $[32] = t6;
    } else t6 = $[32];
    const iframeRef = (0, $2VwyL.useMergeRefs)(t6);
    const iframeTitle = $c73966a4dcfa1523$var$useIframeTitle(extension.properties?.name, appId);
    let t7;
    if ($[33] !== customBridge || $[34] !== extension || $[35] !== getBridgeContext || $[36] !== legacyCustomBridgeMethods) {
        t7 = {
            extension: extension,
            getBridgeContext: getBridgeContext,
            legacyCustomBridgeMethods: legacyCustomBridgeMethods,
            customBridge: customBridge
        };
        $[33] = customBridge;
        $[34] = extension;
        $[35] = getBridgeContext;
        $[36] = legacyCustomBridgeMethods;
        $[37] = t7;
    } else t7 = $[37];
    (0, $dgxed.useEmbeddedMacroConnection)(t7);
    const sendHandshakeMetric = $c73966a4dcfa1523$var$useSendHandshakeMetric(extension);
    const [loadVersion, setLoadVersion] = (0, $cozmU.useState)(null);
    let t8;
    if ($[38] !== cleanupBridge || $[39] !== getBridgeFeatures || $[40] !== loadVersion || $[41] !== onLoad || $[42] !== sendHandshakeMetric || $[43] !== setBridgeControl || $[44] !== src || $[45] !== surfaceColor || $[46] !== theme) {
        t8 = {
            iframeRef: localIframeRef,
            loadVersion: loadVersion,
            src: src,
            theme: theme,
            surfaceColor: surfaceColor,
            getBridgeFeatures: getBridgeFeatures,
            cleanupBridge: cleanupBridge,
            onLoad: onLoad,
            setBridgeControl: setBridgeControl,
            sendHandshakeMetric: sendHandshakeMetric
        };
        $[38] = cleanupBridge;
        $[39] = getBridgeFeatures;
        $[40] = loadVersion;
        $[41] = onLoad;
        $[42] = sendHandshakeMetric;
        $[43] = setBridgeControl;
        $[44] = src;
        $[45] = surfaceColor;
        $[46] = theme;
        $[47] = t8;
    } else t8 = $[47];
    const { isBridgeReady: isBridgeReady, reloadIframe: reloadIframe } = $c73966a4dcfa1523$var$useIframeBridgeConnection(t8);
    let t10;
    let t9;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>{
            setLoadVersion($c73966a4dcfa1523$var$_temp);
        };
        t10 = [];
        $[48] = t10;
        $[49] = t9;
    } else {
        t10 = $[48];
        t9 = $[49];
    }
    const handleIframeLoad = (0, $5xQdV.useCallbackOne)(t9, t10);
    let t11;
    if ($[50] !== extension || $[51] !== extensionData || $[52] !== extensionPayload || $[53] !== onChange || $[54] !== reloadIframe) {
        t11 = {
            extension: extension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            onChange: onChange,
            reloadIframe: reloadIframe
        };
        $[50] = extension;
        $[51] = extensionData;
        $[52] = extensionPayload;
        $[53] = onChange;
        $[54] = reloadIframe;
        $[55] = t11;
    } else t11 = $[55];
    (0, $2PcLo.useReloadOnMacroConfigChange)(t11);
    const loading = !isBridgeReady;
    const isIframeVisible = !(loading || isInlineActive || isHidden);
    let t12;
    if ($[56] !== isIframeVisible) {
        t12 = (0, $iDrrr.fg)("forge-ui-bridge-v2-frame-resizer-fix") ? isIframeVisible : true;
        $[56] = isIframeVisible;
        $[57] = t12;
    } else t12 = $[57];
    const isResizerReady = t12;
    let t13;
    if ($[58] !== extension.properties.layout || $[59] !== extension.type || $[60] !== height || $[61] !== isInModal || $[62] !== isResizable || $[63] !== isResizerReady || $[64] !== loadVersion) {
        t13 = {
            iframeRef: localIframeRef,
            loadVersion: loadVersion,
            isResizable: isResizable,
            isReady: isResizerReady,
            height: height,
            isInModal: isInModal,
            layout: extension.properties.layout,
            type: extension.type
        };
        $[58] = extension.properties.layout;
        $[59] = extension.type;
        $[60] = height;
        $[61] = isInModal;
        $[62] = isResizable;
        $[63] = isResizerReady;
        $[64] = loadVersion;
        $[65] = t13;
    } else t13 = $[65];
    $c73966a4dcfa1523$var$useIframeResizer(t13);
    let t14;
    let t15;
    if ($[66] !== loading || $[67] !== setIsLoading) {
        t14 = ()=>{
            setIsLoading?.(loading);
        };
        t15 = [
            loading,
            setIsLoading
        ];
        $[66] = loading;
        $[67] = setIsLoading;
        $[68] = t14;
        $[69] = t15;
    } else {
        t14 = $[68];
        t15 = $[69];
    }
    (0, $cozmU.useEffect)(t14, t15);
    let t16;
    if ($[70] !== extension.egress || $[71] !== extension.sandboxPolicies) {
        t16 = $c73966a4dcfa1523$var$getSandboxAttribute(extension.egress, extension.sandboxPolicies);
        $[70] = extension.egress;
        $[71] = extension.sandboxPolicies;
        $[72] = t16;
    } else t16 = $[72];
    const sandbox = t16;
    const t17 = isResizable || isInlineActive ? undefined : height;
    let t18;
    if ($[73] !== t17 || $[74] !== width) {
        t18 = {
            height: t17,
            width: width
        };
        $[73] = t17;
        $[74] = width;
        $[75] = t18;
    } else t18 = $[75];
    let t19;
    if ($[76] !== isHidden || $[77] !== isInlineActive || $[78] !== loading || $[79] !== loadingComponent) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c73966a4dcfa1523$var$IframeLoadingOverlay, {
            loading: loading,
            isInlineActive: isInlineActive,
            isHidden: isHidden,
            loadingComponent: loadingComponent
        });
        $[76] = isHidden;
        $[77] = isInlineActive;
        $[78] = loading;
        $[79] = loadingComponent;
        $[80] = t19;
    } else t19 = $[80];
    let t20;
    if ($[81] !== handleIframeLoad || $[82] !== iframeRef || $[83] !== iframeTitle || $[84] !== isHidden || $[85] !== isInModal || $[86] !== isInlineActive || $[87] !== isResizable || $[88] !== loading || $[89] !== sandbox || $[90] !== src || $[91] !== userConsentRequired) {
        t20 = !userConsentRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
            "data-testid": "hosted-resources-iframe",
            "data-forge-iframe": true,
            sandbox: sandbox,
            allow: $c73966a4dcfa1523$var$FRAME_PERMISSIONS_POLICY,
            src: src,
            ref: iframeRef,
            onLoad: handleIframeLoad,
            title: iframeTitle,
            className: (0, $hekY6.default)([
                "_30huDKYbGa _3iDTPbvLZJ _39xV02N91d",
                isInModal && "_0bjKvDzXzM _0jFU0VN91d",
                !isResizable && "_0jFU0VN91d",
                (loading || isInlineActive || isHidden) && "_4bt5LAnQyn _2WAcuGnQyn _0fKRyPnQyn _0jFU0VdnbC"
            ])
        });
        $[81] = handleIframeLoad;
        $[82] = iframeRef;
        $[83] = iframeTitle;
        $[84] = isHidden;
        $[85] = isInModal;
        $[86] = isInlineActive;
        $[87] = isResizable;
        $[88] = loading;
        $[89] = sandbox;
        $[90] = src;
        $[91] = userConsentRequired;
        $[92] = t20;
    } else t20 = $[92];
    let t21;
    if ($[93] !== overlay || $[94] !== t18 || $[95] !== t19 || $[96] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c73966a4dcfa1523$var$styles.box,
            style: t18
        }, t19, overlay, t20);
        $[93] = overlay;
        $[94] = t18;
        $[95] = t19;
        $[96] = t20;
        $[97] = t21;
    } else t21 = $[97];
    return t21;
} : ({ accountId: accountId, appId: appId, bridge: bridge, customBridgeMethods: legacyCustomBridgeMethods, customBridge: customBridge, customBridgeContext: customBridgeContext, components: components, contextIds: contextIds, coreData: coreData, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, height: height = '100%', isHidden: isHidden, isInModal: isInModal, isResizable: isResizable, loadingComponent: loadingComponent, locale: locale, onError: onError, onLoad: onLoad, src: src, setIsLoading: setIsLoading, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, surfaceColor: surfaceColor, theme: theme, timezone: timezone, width: width = '100%', contextChangeListeners: contextChangeListeners }, parentIframeRef)=>{
    const { overlay: overlay, overlayController: overlayController, isInlineActive: isInlineActive } = (0, $3mbzJ.useRuntimeOverlayController)(); // Shared presenter: shows a Forge app error in the overlay + suppresses the host
    // renderer (UIKit) + provides i18n. Exposed as the `showAppError` bridge service
    // for the withErrorDisplay middleware to call on classified bridge errors.
    const showAppError = (0, $acDpC.useRuntimeErrorOverlay)({
        overlayController: overlayController,
        extension: extension,
        setShouldShowRenderer: setShouldShowRenderer,
        onError: onError
    });
    const { userConsentRequired: userConsentRequired, renderThreeLOPrompt: renderThreeLOPrompt } = (0, $10qVl.useInitialAppState)({
        extension: extension,
        appId: appId,
        accountId: accountId,
        components: components,
        onLoad: onLoad,
        setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
        setShouldShowRenderer: setShouldShowRenderer,
        overlayController: overlayController
    });
    const { getBridgeFeatures: getBridgeFeatures, getBridgeContext: getBridgeContext, destroy: cleanupBridge, setBridgeControl: setBridgeControl, onChange: onChange } = $c73966a4dcfa1523$var$useBridgeFeatures({
        accountId: accountId,
        appId: appId,
        bridge: bridge,
        contextIds: contextIds,
        coreData: coreData,
        customBridgeContext: customBridgeContext,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        locale: locale,
        surfaceColor: surfaceColor,
        theme: theme,
        timezone: timezone,
        contextChangeListeners: contextChangeListeners
    }, overlayController, renderThreeLOPrompt, showAppError, legacyCustomBridgeMethods, customBridge);
    const localIframeRef = (0, $cozmU.useRef)(null);
    const iframeRef = (0, $2VwyL.useMergeRefs)([
        parentIframeRef,
        localIframeRef
    ]);
    const iframeTitle = $c73966a4dcfa1523$var$useIframeTitle(extension.properties?.name, appId);
    (0, $dgxed.useEmbeddedMacroConnection)({
        extension: extension,
        getBridgeContext: getBridgeContext,
        legacyCustomBridgeMethods: legacyCustomBridgeMethods,
        customBridge: customBridge
    });
    const sendHandshakeMetric = $c73966a4dcfa1523$var$useSendHandshakeMetric(extension); // `null` until the iframe fires its first `load` event; incremented on each subsequent
    // reload (e.g. tunnel-mode hot-reload). Both useIframeBridgeConnection and useIframeResizer
    // depend on it so they automatically re-run their setup+cleanup cycle on every reload.
    const [loadVersion, setLoadVersion] = (0, $cozmU.useState)(null);
    const { isBridgeReady: isBridgeReady, reloadIframe: reloadIframe } = $c73966a4dcfa1523$var$useIframeBridgeConnection({
        iframeRef: localIframeRef,
        loadVersion: loadVersion,
        src: src,
        theme: theme,
        surfaceColor: surfaceColor,
        getBridgeFeatures: getBridgeFeatures,
        cleanupBridge: cleanupBridge,
        onLoad: onLoad,
        setBridgeControl: setBridgeControl,
        sendHandshakeMetric: sendHandshakeMetric
    });
    const handleIframeLoad = (0, $5xQdV.useCallbackOne)(()=>{
        setLoadVersion((v)=>(v ?? 0) + 1);
    }, []); // TODO: temporary workaround — remove this call and delete useReloadOnMacroConfigChange once
    // every macro observes config changes through the event-based API (e.g. useConfig). At that
    // point we do not want to reload the iframe at all. See that file.
    (0, $2PcLo.useReloadOnMacroConfigChange)({
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        onChange: onChange,
        reloadIframe: reloadIframe
    });
    const loading = !isBridgeReady; // Same predicate that drives `hiddenIframeStyles` below: true only when the iframe is shown.
    const isIframeVisible = !(loading || isInlineActive || isHidden); // Gate the resizer on visibility so it never measures a hidden iframe (wrong-width modals).
    // Off: legacy behaviour, resizer inits on `load`.
    const isResizerReady = (0, $iDrrr.fg)('forge-ui-bridge-v2-frame-resizer-fix') ? isIframeVisible : true;
    $c73966a4dcfa1523$var$useIframeResizer({
        iframeRef: localIframeRef,
        loadVersion: loadVersion,
        isResizable: isResizable,
        isReady: isResizerReady,
        height: height,
        isInModal: isInModal,
        layout: extension.properties.layout,
        type: extension.type
    });
    (0, $cozmU.useEffect)(()=>{
        setIsLoading?.(loading);
    }, [
        loading,
        setIsLoading
    ]);
    const sandbox = $c73966a4dcfa1523$var$getSandboxAttribute(extension.egress, extension.sandboxPolicies);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c73966a4dcfa1523$var$styles.box,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: isResizable || isInlineActive ? undefined : height,
            width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c73966a4dcfa1523$var$IframeLoadingOverlay, {
        loading: loading,
        isInlineActive: isInlineActive,
        isHidden: isHidden,
        loadingComponent: loadingComponent
    }), overlay, !userConsentRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        "data-testid": "hosted-resources-iframe",
        "data-forge-iframe": true,
        sandbox: sandbox,
        allow: $c73966a4dcfa1523$var$FRAME_PERMISSIONS_POLICY,
        src: src,
        ref: iframeRef,
        onLoad: handleIframeLoad,
        title: iframeTitle,
        className: (0, $hekY6.default)([
            "_30huDKYbGa _3iDTPbvLZJ _39xV02N91d",
            isInModal && "_0bjKvDzXzM _0jFU0VN91d",
            !isResizable && "_0jFU0VN91d",
            (loading || isInlineActive || isHidden) && "_4bt5LAnQyn _2WAcuGnQyn _0fKRyPnQyn _0jFU0VdnbC"
        ])
    }));
});
const $c73966a4dcfa1523$var$IframeLoadingOverlay = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { loading: loading, isInlineActive: isInlineActive, isHidden: isHidden, loadingComponent: loadingComponent } = t0;
    if (!loading || isInlineActive || isHidden) return null;
    let t1;
    if ($[0] !== loadingComponent) {
        t1 = (0, $1y2Zu.getLoadingComponent)(loadingComponent);
        $[0] = loadingComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c73966a4dcfa1523$var$styles.loadingOverlay
        }, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ loading: loading, isInlineActive: isInlineActive, isHidden: isHidden, loadingComponent: loadingComponent })=>{
    if (!loading || isInlineActive || isHidden) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c73966a4dcfa1523$var$styles.loadingOverlay
    }, (0, $1y2Zu.getLoadingComponent)(loadingComponent));
};
const $c73966a4dcfa1523$var$useIframeTitle = (appName, appId)=>{
    return `Embedded app content for ${appName ?? appId}`;
};
const $c73966a4dcfa1523$var$useIframeBridgeConnection = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { iframeRef: iframeRef, loadVersion: loadVersion, src: src, theme: theme, surfaceColor: surfaceColor, getBridgeFeatures: getBridgeFeatures, cleanupBridge: cleanupBridge, onLoad: onLoad, setBridgeControl: setBridgeControl, sendHandshakeMetric: sendHandshakeMetric } = t0;
    const [isBridgeReady, setIsBridgeReady] = (0, $cozmU.useState)(false);
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6FQr4.useForgeUiAnalyticsEvent)();
    const reloadPendingRef = (0, $cozmU.useRef)(false);
    let t1;
    if ($[0] !== getBridgeFeatures || $[1] !== iframeRef || $[2] !== loadVersion || $[3] !== onLoad || $[4] !== sendHandshakeMetric || $[5] !== setBridgeControl || $[6] !== src || $[7] !== surfaceColor || $[8] !== theme || $[9] !== trackExtensionRemounted) {
        t1 = ()=>{
            if (loadVersion === null) return;
            reloadPendingRef.current = false;
            setIsBridgeReady(false);
            const contentWindow = iframeRef.current?.contentWindow;
            if (!contentWindow) return;
            let cancelled = false;
            (0, $lvKd7.createIframeBridge)({
                withWindow: contentWindow,
                withDomain: new URL(src).origin,
                features: getBridgeFeatures(),
                theme: theme,
                surfaceColor: surfaceColor,
                sendHandshakeMetric: sendHandshakeMetric
            }).open().then((controls)=>{
                if (cancelled || reloadPendingRef.current) {
                    controls.close();
                    return;
                }
                setBridgeControl(controls);
                setIsBridgeReady(true);
                onLoad?.();
                if (loadVersion > 1 && !(0, $1Bv8Y.isTunnelSrc)(src)) trackExtensionRemounted({
                    mountCount: loadVersion
                });
            }).catch($c73966a4dcfa1523$var$_temp2);
            return ()=>{
                cancelled = true;
            };
        };
        $[0] = getBridgeFeatures;
        $[1] = iframeRef;
        $[2] = loadVersion;
        $[3] = onLoad;
        $[4] = sendHandshakeMetric;
        $[5] = setBridgeControl;
        $[6] = src;
        $[7] = surfaceColor;
        $[8] = theme;
        $[9] = trackExtensionRemounted;
        $[10] = t1;
    } else t1 = $[10];
    let t2;
    if ($[11] !== loadVersion) {
        t2 = [
            loadVersion
        ];
        $[11] = loadVersion;
        $[12] = t2;
    } else t2 = $[12];
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[13] !== cleanupBridge) {
        t3 = ()=>cleanupBridge;
        t4 = [
            cleanupBridge
        ];
        $[13] = cleanupBridge;
        $[14] = t3;
        $[15] = t4;
    } else {
        t3 = $[14];
        t4 = $[15];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[16] !== iframeRef || $[17] !== src) {
        t5 = ()=>{
            const contentWindow_0 = iframeRef.current?.contentWindow;
            if (!contentWindow_0 || reloadPendingRef.current) return;
            reloadPendingRef.current = true;
            try {
                contentWindow_0.location.replace(src);
            } catch (t7) {
                reloadPendingRef.current = false;
                return;
            }
            setIsBridgeReady(false);
        };
        t6 = [
            src,
            iframeRef
        ];
        $[16] = iframeRef;
        $[17] = src;
        $[18] = t5;
        $[19] = t6;
    } else {
        t5 = $[18];
        t6 = $[19];
    }
    const reloadIframe = (0, $5xQdV.useCallbackOne)(t5, t6);
    let t7;
    if ($[20] !== isBridgeReady || $[21] !== reloadIframe) {
        t7 = {
            isBridgeReady: isBridgeReady,
            reloadIframe: reloadIframe
        };
        $[20] = isBridgeReady;
        $[21] = reloadIframe;
        $[22] = t7;
    } else t7 = $[22];
    return t7;
} : ({ iframeRef: iframeRef, loadVersion: loadVersion, src: src, theme: theme, surfaceColor: surfaceColor, getBridgeFeatures: getBridgeFeatures, cleanupBridge: cleanupBridge, onLoad: onLoad, setBridgeControl: setBridgeControl, sendHandshakeMetric: sendHandshakeMetric })=>{
    const [isBridgeReady, setIsBridgeReady] = (0, $cozmU.useState)(false);
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6FQr4.useForgeUiAnalyticsEvent)(); // True from a reload request until the resulting `load` event, so bursts coalesce.
    const reloadPendingRef = (0, $cozmU.useRef)(false); // Keyed solely on loadVersion: other inputs are stable after mount, and theme/surfaceColor
    // changes flow through useBridgeFeatures' onChange listener (which calls controls.setTheme
    // on the live connection) rather than re-triggering the handshake.
    (0, $cozmU.useEffect)(()=>{
        if (loadVersion === null) return;
        reloadPendingRef.current = false;
        setIsBridgeReady(false);
        const contentWindow = iframeRef.current?.contentWindow;
        if (!contentWindow) return;
        let cancelled = false;
        (0, $lvKd7.createIframeBridge)({
            withWindow: contentWindow,
            withDomain: new URL(src).origin,
            features: getBridgeFeatures(),
            theme: theme,
            surfaceColor: surfaceColor,
            sendHandshakeMetric: sendHandshakeMetric
        }).open().then((controls)=>{
            // `reloadPendingRef` covers a reload requested while this handshake was in flight:
            // the effect has not re-run yet (loadVersion is unchanged), so `cancelled` is still
            // false, but these controls belong to the document we just navigated away from.
            if (cancelled || reloadPendingRef.current) {
                controls.close();
                return;
            }
            setBridgeControl(controls);
            setIsBridgeReady(true);
            onLoad?.(); // Tunnel hot-reloads are expected dev-loop noise; only track reloads in non-tunnel src.
            if (loadVersion > 1 && !(0, $1Bv8Y.isTunnelSrc)(src)) trackExtensionRemounted({
                mountCount: loadVersion
            });
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('Failed to open iframe bridge', err);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        loadVersion
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Full teardown on unmount: BridgeContextObject.destroy() closes any live connection.
    // Effect body is intentionally empty — `cleanupBridge` is returned as the cleanup function,
    // invoked by React on unmount (and when `cleanupBridge` changes, which it shouldn't in practice).
    (0, $cozmU.useEffect)(()=>cleanupBridge, [
        cleanupBridge
    ]); // TODO: Note, this is a temporary solution to allow reload (for macros)
    // we should try avoid and disable this pattern in the future.
    // Re-navigates the iframe to `src`, which fires `load` and drives a fresh handshake via
    // `loadVersion`. `location.replace` is cross-origin accessible and, unlike assigning `src`,
    // does not push a session-history entry.
    const reloadIframe = (0, $5xQdV.useCallbackOne)(()=>{
        const contentWindow_0 = iframeRef.current?.contentWindow;
        if (!contentWindow_0 || reloadPendingRef.current) return;
        reloadPendingRef.current = true;
        try {
            contentWindow_0.location.replace(src);
        } catch (e) {
            // Navigation never started. Leave the current document alone rather than hiding it, and
            // clear the pending flag so later config changes are not silently dropped.
            reloadPendingRef.current = false;
            return;
        } // After `replace` so the failure path above leaves the iframe visible, but still well before
        // the new document's `load` event — otherwise stale content shows and then collapses.
        setIsBridgeReady(false);
    }, [
        src,
        iframeRef
    ]);
    return {
        isBridgeReady: isBridgeReady,
        reloadIframe: reloadIframe
    };
};
const $c73966a4dcfa1523$var$useIframeResizer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { iframeRef: iframeRef, loadVersion: loadVersion, isResizable: isResizable, isReady: isReady, height: height, isInModal: isInModal, layout: layout, type: type } = t0;
    let t1;
    if ($[0] !== height || $[1] !== iframeRef || $[2] !== isInModal || $[3] !== isReady || $[4] !== isResizable || $[5] !== layout || $[6] !== loadVersion || $[7] !== type) {
        t1 = ()=>{
            if (!isResizable || loadVersion === null || !isReady) return;
            const iframeEl = iframeRef.current;
            if (!iframeEl) return;
            const isInNonJSMResizableModal = isInModal && !type?.startsWith("jiraServiceManagement");
            const isInInlineMacro = layout === "inline" && type === $c73966a4dcfa1523$var$MACRO_MODULE_NAME;
            const sizeWidth = isInNonJSMResizableModal || isInInlineMacro;
            (0, $6Rin8.iframeResizer)({
                heightCalculationMethod: "bodyScroll",
                widthCalculationMethod: "bodyScroll",
                scrolling: true,
                minHeight: height,
                sizeWidth: sizeWidth,
                initCallback: $c73966a4dcfa1523$var$_temp3
            }, iframeEl);
            return ()=>{
                iframeEl?.iFrameResizer?.removeListeners();
            };
        };
        $[0] = height;
        $[1] = iframeRef;
        $[2] = isInModal;
        $[3] = isReady;
        $[4] = isResizable;
        $[5] = layout;
        $[6] = loadVersion;
        $[7] = type;
        $[8] = t1;
    } else t1 = $[8];
    let t2;
    if ($[9] !== isReady || $[10] !== isResizable || $[11] !== loadVersion) {
        t2 = [
            loadVersion,
            isResizable,
            isReady
        ];
        $[9] = isReady;
        $[10] = isResizable;
        $[11] = loadVersion;
        $[12] = t2;
    } else t2 = $[12];
    (0, $cozmU.useEffect)(t1, t2);
} : ({ iframeRef: iframeRef, loadVersion: loadVersion, isResizable: isResizable, isReady: isReady, height: height, isInModal: isInModal, layout: layout, type: type })=>{
    // Deps are intentionally narrowed to [loadVersion, isResizable, isReady]. `height`, `isInModal`,
    // `layout`, and `type` are captured by closure from whichever render last fired a `load`
    // event, matching v1's "init once per load with the values current at that moment" behaviour.
    // `isReady` re-inits (or tears down) the resizer on visibility changes; it is constant `true`
    // when the gate is off. `iframeRef` is a stable ref object and never triggers re-runs.
    //
    // Latent assumption: this hook does NOT react to mid-lifecycle changes of those values. They
    // configure `minHeight` and `sizeWidth` at init time and the library has no runtime API to
    // update them on a live instance. In current usage they are effectively static after mount
    // (layout/type/isInModal come from extension + host chrome; height is parent-supplied). If a
    // product ever mutates them at runtime while `isResizable=true`, re-init on change or replace
    // the library with one that supports in-place updates.
    (0, $cozmU.useEffect)(()=>{
        if (!isResizable || loadVersion === null || !isReady) return;
        const iframeEl = iframeRef.current;
        if (!iframeEl) return;
         // JSM modals are always height resizable, but not width resizable.
        // TODO: Can remove this once aligned with JSM on width resizing
        const isInNonJSMResizableModal = isInModal && !type?.startsWith('jiraServiceManagement');
        const isInInlineMacro = layout === 'inline' && type === $c73966a4dcfa1523$var$MACRO_MODULE_NAME;
        const sizeWidth = isInNonJSMResizableModal || isInInlineMacro;
        (0, $6Rin8.iframeResizer)({
            heightCalculationMethod: 'bodyScroll',
            widthCalculationMethod: 'bodyScroll',
            scrolling: true,
            // @ts-expect-error minHeight accepts a CSS string at runtime but the TS type only allows number
            minHeight: height,
            sizeWidth: sizeWidth,
            initCallback: (iframe)=>{
                iframe?.iFrameResizer?.resize();
            }
        }, iframeEl);
        return ()=>{
            iframeEl?.iFrameResizer?.removeListeners();
        };
    }, [
        loadVersion,
        isResizable,
        isReady
    ]); // eslint-disable-line react-hooks/exhaustive-deps
};
const $c73966a4dcfa1523$var$useSendHandshakeMetric = (extension)=>{
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const environment = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const tracing = (0, $eL3mC.useTracingContext)();
    const { trackHandShakeMetric: trackHandShakeMetric } = (0, $6FQr4.useForgeUiAnalyticsEvent)(); // Keep a ref so the callback always reads the latest extension without needing
    // it as a dependency — avoids recreating the callback on every render when the
    // extension object reference changes but its identity (id, type, etc.) has not.
    const extensionRef = (0, $cozmU.useRef)(extension);
    extensionRef.current = extension;
    return (0, $5xQdV.useCallbackOne)((success, error)=>{
        trackHandShakeMetric({
            source: page,
            success: success,
            error: error
        });
        if (error) {
            const { id: id, type: type, environmentType: environmentType, appOwner: appOwner, properties: properties } = extensionRef.current;
            const handshakeError = error instanceof Error ? new Error(`Bridge handshake error: ${error.message}`) : new Error('Unknown bridge handshake error');
            (0, $h48r4.captureAndReportError)({
                error: handshakeError,
                environment: environment,
                errorExtensionDetails: {
                    id: id,
                    type: type,
                    environmentType: environmentType,
                    appOwnerAccountId: appOwner?.accountId,
                    properties: properties
                },
                page: page,
                runtime: 'iframev2',
                tracing: tracing
            });
        }
    }, [
        page,
        environment,
        tracing,
        trackHandShakeMetric
    ]);
};
const $c73966a4dcfa1523$var$useBridgeFeatures = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props, overlayController, renderThreeLOPrompt, showAppError, legacyCustomBridgeMethods, customBridge)=>{
    const $ = (0, $bDgLe.c)(17);
    const getLegacyCustomBridgeMethods = (0, $bxg0J.useLiveMethodMap)(legacyCustomBridgeMethods);
    const environment = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { getServices: getServices } = (0, $lHaWf.useBridgeServices)(props, overlayController, renderThreeLOPrompt, showAppError);
    let t0;
    if ($[0] !== environment || $[1] !== page || $[2] !== props) {
        t0 = {
            ...props,
            environment: environment,
            page: page,
            runtime: "iframev2"
        };
        $[0] = environment;
        $[1] = page;
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    const { getBridgeContext: getBridgeContext, destroy: destroy, onChange: onChange, setBridgeControl: setBridgeControl } = (0, $2fpEe.useBridgeContext)(t0, getServices, props.contextChangeListeners);
    let t1;
    let t2;
    if ($[4] !== onChange) {
        t1 = ()=>onChange($c73966a4dcfa1523$var$_temp4);
        t2 = [
            onChange
        ];
        $[4] = onChange;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== customBridge || $[8] !== getBridgeContext || $[9] !== getLegacyCustomBridgeMethods) {
        t3 = ()=>(0, $givIf.createBridgeFeatures)(getBridgeContext, (baseBridgeMethods)=>(0, $eYWSl.consolidateCustomBridge)(baseBridgeMethods, getLegacyCustomBridgeMethods(), customBridge));
        $[7] = customBridge;
        $[8] = getBridgeContext;
        $[9] = getLegacyCustomBridgeMethods;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== destroy || $[12] !== getBridgeContext || $[13] !== onChange || $[14] !== setBridgeControl || $[15] !== t3) {
        t4 = {
            destroy: destroy,
            getBridgeContext: getBridgeContext,
            onChange: onChange,
            getBridgeFeatures: t3,
            setBridgeControl: setBridgeControl
        };
        $[11] = destroy;
        $[12] = getBridgeContext;
        $[13] = onChange;
        $[14] = setBridgeControl;
        $[15] = t3;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : (props, overlayController, renderThreeLOPrompt, showAppError, legacyCustomBridgeMethods, customBridge)=>{
    // Legacy (v1) methods are tracked live because some modules recreate them after initial render.
    const getLegacyCustomBridgeMethods = (0, $bxg0J.useLiveMethodMap)(legacyCustomBridgeMethods);
    const environment = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { page: page } = (0, $DIyeF.useMetricsContext)(); // Assembles host-side capabilities (invoker, fetch client, tracing, etc.) for bridge methods.
    // Returns a getter rather than a snapshot so services are always current at call time.
    const { getServices: getServices } = (0, $lHaWf.useBridgeServices)(props, overlayController, renderThreeLOPrompt, showAppError); // [Important] getBridgeContext is stable and does not change across the lifecycle of the component,
    // so it is safe to include it in the dependency array of createBridgeFeatures without causing
    // unnecessary re-renders or re-creations of the bridge features.
    const { getBridgeContext: getBridgeContext, destroy: destroy, onChange: onChange, setBridgeControl: setBridgeControl } = (0, $2fpEe.useBridgeContext)({
        ...props,
        environment: environment,
        page: page,
        runtime: 'iframev2'
    }, getServices, props.contextChangeListeners); // Registered once — `onChange` is stable and `destroy()` clears the listener on unmount.
    (0, $cozmU.useEffect)(()=>{
        return onChange((_prev, next, changes, getContext)=>{
            // Push theme/surfaceColor changes to the open bridge connection whenever they change.
            // Custom UI only — we only do this for iframe based runtime, as this is only
            // relevant for Custom UI app, as the Custom UI app will need to update the theme style assets.
            if (changes.theme || changes.surfaceColor) getContext().bridgeControls?.setTheme(next.theme ?? null, next.surfaceColor ?? null, next.environment);
        });
    }, [
        onChange
    ]);
    return {
        destroy: destroy,
        getBridgeContext: getBridgeContext,
        onChange: onChange,
        getBridgeFeatures: ()=>(0, $givIf.createBridgeFeatures)(getBridgeContext, (baseBridgeMethods)=>(0, $eYWSl.consolidateCustomBridge)(baseBridgeMethods, getLegacyCustomBridgeMethods(), // v2 customBridge is a stable-reference contract — passed through directly, not tracked live.
                customBridge)),
        setBridgeControl: setBridgeControl
    };
};
function $c73966a4dcfa1523$var$_temp(v) {
    return (v ?? 0) + 1;
}
function $c73966a4dcfa1523$var$_temp2(err) {
    console.error("Failed to open iframe bridge", err);
}
function $c73966a4dcfa1523$var$_temp3(iframe) {
    iframe?.iFrameResizer?.resize();
}
function $c73966a4dcfa1523$var$_temp4(_prev, next, changes, getContext) {
    if (changes.theme || changes.surfaceColor) getContext().bridgeControls?.setTheme(next.theme ?? null, next.surfaceColor ?? null, next.environment);
}
module.exports["InnerIframe"] = $c73966a4dcfa1523$export$3c4d31cb85fd39c5;

});

parcelRegister("aWrCr", function(module, exports) {
const $8a0e18a076ac7950$var$isValidOuterOrigin = (candidate)=>{
    // Must be a genuinely different (outer) origin — never echo this frame's own origin.
    if (typeof candidate !== 'string' || candidate === window.location.origin) return false;
    try {
        const url = new URL(candidate);
        // Require a canonical https origin (scheme + host [+ port] and nothing else). Comparing
        // against `url.origin` rejects any path, query, whitespace, or injected CSP tokens, so a
        // malformed / attacker-shaped value can never reach the macro's `frame-ancestors` directive.
        return url.protocol === 'https:' && url.origin === candidate;
    } catch  {
        return false;
    }
};
// Server-injected origin, present only on verified custom-domain SSR renders.
const $8a0e18a076ac7950$var$getSsrEmbeddingOrigin = ()=>{
    const origin = window.__SSR_EMBEDDING_ORIGIN__;
    return $8a0e18a076ac7950$var$isValidOuterOrigin(origin) ? origin : undefined;
};
// Embedded-confluence connect context (`options.hostOrigin`) serialised into `window.name`.
// This is specific for connect and a temp solution in case
// getSsrEmbeddingOrigin does not work as expected.
const $8a0e18a076ac7950$var$getConnectContextEmbeddingOrigin = ()=>{
    try {
        const parsed = JSON.parse(window.name);
        const hostOrigin = parsed?.options?.hostOrigin;
        return $8a0e18a076ac7950$var$isValidOuterOrigin(hostOrigin) ? hostOrigin : undefined;
    } catch  {
        return undefined;
    }
};
const $8a0e18a076ac7950$export$2ce427565fc21b44 = ()=>$8a0e18a076ac7950$var$getSsrEmbeddingOrigin() ?? $8a0e18a076ac7950$var$getConnectContextEmbeddingOrigin();
module.exports["getCrossDomainEmbeddingOrigin"] = $8a0e18a076ac7950$export$2ce427565fc21b44;

});

parcelRegister("jP2xl", function(module, exports) {

var $c0YtQ = parcelRequire("c0YtQ");


var $4hk2D = parcelRequire("4hk2D");


var $5GHXA = parcelRequire("5GHXA");


var $04D7M = parcelRequire("04D7M");


var $j2j0X = parcelRequire("j2j0X");


var $21ZKL = parcelRequire("21ZKL");


var $2sLfT = parcelRequire("2sLfT");


var $6gtkV = parcelRequire("6gtkV");


var $gJkLc = parcelRequire("gJkLc");


var $84ihY = parcelRequire("84ihY");


var $6cgNn = parcelRequire("6cgNn");


var $fG2vF = parcelRequire("fG2vF");


var $4HYkN = parcelRequire("4HYkN");


var $dQO8T = parcelRequire("dQO8T");


var $b3CvB = parcelRequire("b3CvB");


var $bAnXF = parcelRequire("bAnXF");


var $aV0pR = parcelRequire("aV0pR");


var $24ctJ = parcelRequire("24ctJ");

const $f5d8c728371c8e23$export$d0f4e0785e15fc49 = {
    ...(0, $21ZKL.bridgeConfigDelegates),
    getContext: // Core methods
    $c0YtQ.getContext,
    invoke: $c0YtQ.invoke,
    getFrameId: $c0YtQ.getFrameId,
    reload: $c0YtQ.reload,
    fetchProduct: // Fetch methods
    $2sLfT.fetchProduct,
    fetchRemote: $6gtkV.fetchRemote,
    fetchUserRecommendations: $gJkLc.fetchUserRecommendations,
    requestTeamworkGraph: $84ihY.requestTeamworkGraph,
    enableTheming: // Theming methods
    $6cgNn.enableTheming,
    on: // Event methods
    $fG2vF.on,
    emit: $fG2vF.emit,
    onPublic: // Public event methods
    $4HYkN.onPublic,
    emitPublic: $4HYkN.emitPublic,
    subscribeRealtimeChannel: // Realtime methods
    $dQO8T.subscribeRealtimeChannel,
    publishRealtimeChannel: $dQO8T.publishRealtimeChannel,
    getUrl: // Navigation methods
    $b3CvB.getUrl,
    navigate: $b3CvB.navigate,
    createHistory: // History methods
    $bAnXF.createHistory,
    initFeatureFlags: // Feature flag methods
    $4hk2D.initFeatureFlags,
    trackFeatureFlagEvent: $4hk2D.trackFeatureFlagEvent,
    emitFrontendCustomMetric: // Frontend observability
    $5GHXA.emitFrontendCustomMetric,
    emitFrontendLogs: $04D7M.emitFrontendLogs,
    // Telemetry methods
    'iframe-analytics': (0, $j2j0X.iframeAnalytics),
    trackObjectStoreAction: $j2j0X.trackObjectStoreAction,
    'ufo-event': (0, $j2j0X.ufoEvent),
    isRovoEnabled: // Rovo methods
    $aV0pR.isRovoEnabled,
    openRovo: $aV0pR.openRovo,
    // Permission methods
    ...(0, $24ctJ.permissionBridgeMethods)
};
module.exports["bridgeMethods"] = $f5d8c728371c8e23$export$d0f4e0785e15fc49;

});

parcelRegister("lJt1v", function(module, exports) {

var $h48r4 = parcelRequire("h48r4");


var $c71c0 = parcelRequire("c71c0");


var $kq02L = parcelRequire("kq02L");


var $3db8V = parcelRequire("3db8V");


var $5Wwa0 = parcelRequire("5Wwa0");

const $835a9bc495d2faf6$export$14e56d7f5d3f917c = (method, methodName)=>async (context, payload)=>{
        const { services: { analytics: analytics, tracing: tracing }, extension: extension, environment: environment, page: page, runtime: runtime } = context;
        const forgeEnvironment = extension.environmentType;
        try {
            tracing.recordBridgeCall(`${methodName}() - start`);
            // invoke the original implementation
            const result = await method(context, payload);
            tracing.recordBridgeCall(`${methodName}() - end`);
            analytics.tracker.trackBridgeSucceed({
                method: methodName,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: (0, $kq02L.prepareBridgeEventAttributes)(methodName, {
                    data: payload
                }, true)
            });
            return result;
        } catch (err) {
            const error = err instanceof Error ? err : new Error(`Unknown Custom UI Bridge error: ${typeof err}`);
            if (!(error instanceof (0, $c71c0.BridgeClientError))) {
                if (!(0, $3db8V.blocklistedErrorMessagePatterns).some((pattern)=>pattern.test(error.message))) {
                    analytics.tracker.trackBridgeFailed({
                        method: methodName,
                        errorName: error.name,
                        forgeEnvironment: forgeEnvironment,
                        additionalAttributes: {
                            ...(0, $kq02L.prepareBridgeEventAttributes)(methodName, {
                                data: payload
                            }, false),
                            reason: error.message,
                            isUnrecoverable: (0, $5Wwa0.isUnrecoverableError)(error)
                        }
                    });
                    (0, $h48r4.captureAndReportError)({
                        error: error,
                        environment: environment,
                        errorExtensionDetails: {
                            id: extension.id,
                            type: extension.type,
                            environmentType: extension.environmentType,
                            properties: extension.properties,
                            appOwnerAccountId: extension.appOwner?.accountId
                        },
                        page: page,
                        runtime: runtime,
                        tracing: tracing
                    });
                }
            }
            throw err;
        }
    };
module.exports["withMetrics"] = $835a9bc495d2faf6$export$14e56d7f5d3f917c;

});

parcelRegister("8IpiJ", function(module, exports) {

var $j3WkY = parcelRequire("j3WkY");


var $iyAN0 = parcelRequire("iyAN0");

const $097168d9d01c0c22$export$e628d863fc52abdc = (method)=>async (context, payload)=>{
        try {
            return await method(context, payload);
        } catch (err) {
            if (err instanceof (0, $j3WkY.ForgeAppError) && (0, $iyAN0.shouldRenderForgeAppErrorMessage)(err.errorType)) context.services.showAppError(err);
            throw err;
        }
    };
module.exports["withErrorDisplay"] = $097168d9d01c0c22$export$e628d863fc52abdc;

});

parcelRegister("gwFiU", function(module, exports) {

var $4DMV4 = parcelRequire("4DMV4");

var $jerTb = parcelRequire("jerTb");

var $iuxS5 = parcelRequire("iuxS5");

var $fXNFR = parcelRequire("fXNFR");


var $bEbDR = parcelRequire("bEbDR");


var $1uMa2 = parcelRequire("1uMa2");


var $aQTdX = parcelRequire("aQTdX");


var $lVeki = parcelRequire("lVeki");

/**
 * A single lazily-computed slot. Call `get(factory)` to read (computing on first access),
 * and `invalidate()` to clear so the next `get()` recomputes.
 *
 * Note: `T` must not be `null` — `null` is used as the uncomputed sentinel.
 */ class $ba3c673e2d68d40c$var$LazyCell {
    get(compute) {
        if (this.value === null) this.value = compute();
        return this.value;
    }
    invalidate() {
        this.value = null;
    }
    constructor(){
        this.value = null;
    }
}
/**
 * Unified registry for per-instance bridge resources.
 * Each resource defines its own create and destroy lifecycle.
 * BridgeContextObject.destroy() calls destroy(state) for every claimed resource.
 */ class $ba3c673e2d68d40c$var$BridgeResourceRegistry {
    destroy() {
        for (const { resource: resource, state: state } of this.entries.values())resource.destroy(state);
        this.entries.clear();
    }
    constructor(){
        this.entries = new Map();
        this.claimBridgeResource = (resource)=>{
            if (this.entries.has(resource.id)) return this.entries.get(resource.id).state;
            const state = resource.create();
            this.entries.set(resource.id, {
                resource: resource,
                state: state
            });
            return state;
        };
    }
}
class $ba3c673e2d68d40c$export$692584c74926c9b3 {
    /**
   * Registers the live bridge-core v2 connection.
   *
   * Called once on initial load and again on each iframe reload (e.g. tunnel mode hot-reload).
   * On reload, the previous connection is closed before the new one is stored, so the old
   * bridge-core channel is torn down without destroying the bridge context or resource registry.
   */ setBridgeControl(controls) {
        if (this.bridgeControls !== null) {
            // eslint-disable-next-line no-console
            console.debug('close and refresh existing bridge control');
            this.bridgeControls.close();
        }
        this.bridgeControls = controls;
    }
    /**
   * Tears down all resources owned by this object. Should be called on component
   * unmount to prevent memory leaks.
   */ destroy() {
        // Close the connection before destroying resources — prevents new bridge calls arriving after teardown.
        this.bridgeControls?.close();
        this.bridgeControls = null;
        this.resourceRegistry.destroy();
        this.changeListeners.clear();
    }
    /**
   * Registers a listener that is called whenever one or more props change.
   * The listener receives the previous props, the new props, and a lazy `getContext()`
   * accessor — call it only if you need the context, as it allocates on first call.
   * Returns an unsubscribe function — call it to stop receiving notifications.
   *
   * Listeners only fire when something actually changed (`changes.__all__` is true).
   * They are cleared automatically on `destroy()`.
   */ onChange(listener) {
        this.changeListeners.add(listener);
        return ()=>this.changeListeners.delete(listener);
    }
    /**
   * Diffs incoming props against stored props, clears the cache, and emits
   * change events for updated BridgeContext fields.
   *
   * Must be called inside useEffect (not during render) because it emits DOM events.
   */ update(nextProps) {
        const prevProps = this.props;
        const changes = (0, $lVeki.computeBridgeContextChanges)(prevProps, nextProps);
        this.props = nextProps;
        if (changes.__all__) {
            // Brief always-on log; deep diff opt-in via DEBUG_ENABLED in BridgeContextDebug.ts.
            (0, $aQTdX.logBridgeContextChange)(prevProps, nextProps, changes);
            this.resolverContextCell.invalidate();
            this.viewContextCell.invalidate();
            this.extensionDetailsCell.invalidate();
            // Lazy: computed at most once, only if a listener actually reads it.
            let contextCache;
            // note, ??= is currently not supported in our build environment, hence will need to be rewritten when we upgrade to a newer TypeScript version
            const getContext = ()=>contextCache !== undefined ? contextCache : contextCache = this.get();
            for (const listener of this.changeListeners)listener(prevProps, nextProps, changes, getContext);
        }
    }
    /**
   * Returns the current BridgeContext.
   *
   * Fields that involve non-trivial work are getter properties — deferred until
   * the bridge method actually reads them.
   *
   * Pass-through fields are direct values, since reading a prop is O(1).
   */ get() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        return {
            // Deferred — resolved only when the bridge method accesses the field.
            get resolverContext () {
                return self.resolverContext;
            },
            get viewContext () {
                return self.viewContext;
            },
            get extensionDetails () {
                return self.extensionDetails;
            },
            get services () {
                return self.getServices();
            },
            // Immediate — direct prop reads, no benefit to deferring.
            bridgeConfig: this.props.bridge ?? {},
            bridgeControls: this.bridgeControls,
            claimBridgeResource: this.resourceRegistry.claimBridgeResource,
            contextIds: this.props.contextIds,
            customBridgeContext: this.props.customBridgeContext,
            environment: this.props.environment,
            page: this.props.page,
            runtime: this.props.runtime,
            extension: this.props.extension,
            extensionPayload: this.props.extensionPayload,
            // Exposed on context rather than via services to give change listeners
            // a scoped emit without needing to import the events module directly.
            emit: (event, payload)=>(0, $1uMa2.emit)(event, payload, self.extensionDetails)
        };
    }
    get resolverContext() {
        return this.resolverContextCell.get(()=>(0, $iuxS5.getResolverContext)({
                ...this.props.coreData,
                appVersion: this.props.extension.appVersion
            }, this.props.extensionData));
    }
    get extensionDetails() {
        return this.extensionDetailsCell.get(()=>{
            const { extension: extension } = this.props;
            return {
                appId: extension.appId ?? (0, $bEbDR.parseExtensionId)(extension.id).appId,
                id: extension.id.split('/').slice(0, 3).join('/'),
                installationId: extension.installationId
            };
        });
    }
    get viewContext() {
        const viewContext = this.viewContextCell.get(()=>this.buildViewContext(this.props, this.resolverContext));
        // Read live: the URL can change via History API navigation with no prop update,
        // so it must not be baked into the memoized view context. See buildViewContext.
        viewContext.extension.location = window.location.toString();
        return viewContext;
    }
    buildViewContext(props, resolverContext) {
        return (0, $fXNFR.getViewContext)({
            resolverContext: resolverContext,
            accountId: props.accountId,
            extension: props.extension,
            timezone: props.timezone ?? (0, $jerTb.getBrowserTimezone)(),
            locale: props.locale ?? (0, $4DMV4.getBrowserLocale)(),
            extensionPayload: props.extensionPayload,
            extensionViewData: props.extensionViewData,
            theme: props.theme,
            surfaceColor: props.surfaceColor
        });
    }
    constructor(props, getServices){
        this.props = void 0;
        this.getServices = void 0;
        this.bridgeControls = null;
        this.changeListeners = new Set();
        this.resolverContextCell = new $ba3c673e2d68d40c$var$LazyCell();
        this.viewContextCell = new $ba3c673e2d68d40c$var$LazyCell();
        this.extensionDetailsCell = new $ba3c673e2d68d40c$var$LazyCell();
        this.resourceRegistry = new $ba3c673e2d68d40c$var$BridgeResourceRegistry();
        this.props = props;
        this.getServices = getServices;
    }
}
module.exports["BridgeContextObject"] = $ba3c673e2d68d40c$export$692584c74926c9b3;

});

parcelRegister("2MUrL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jH9cM = parcelRequire("jH9cM");

var $i3S9F = parcelRequire("i3S9F");

var $8B1kb = parcelRequire("8B1kb");


var $aqd0l = parcelRequire("aqd0l");

var $5cSJl = parcelRequire("5cSJl");


var $iDrrr = parcelRequire("iDrrr");


var $9cGsb = parcelRequire("9cGsb");


var $hjngh = parcelRequire("hjngh");


var $3nNWm = parcelRequire("3nNWm");


var $kn1J6 = parcelRequire("kn1J6");


var $kyUPS = parcelRequire("kyUPS");


var $6SsN4 = parcelRequire("6SsN4");


var $5Zman = parcelRequire("5Zman");

const $6ff957d04b48dc7f$var$validProducts = [
    'confluence',
    'jira',
    'bitbucket',
    'teamwork-graph'
];
const $6ff957d04b48dc7f$var$apiGatewayUrlMap = {
    dev: 'api.stg.atlassian.com',
    stg: 'api.stg.atlassian.com',
    prod: 'api.atlassian.com'
};
const $6ff957d04b48dc7f$var$getApiGatewayUrl = (environment)=>{
    const apiBase = $6ff957d04b48dc7f$var$apiGatewayUrlMap[environment];
    const url = (0, $jH9cM.isFedRamp)() ? apiBase.replace('atlassian.com', 'atlassian-us-gov-mod.com') : apiBase;
    if (!url) throw new Error(`Invalid environment: ${environment}`);
    return url;
};
const $6ff957d04b48dc7f$var$getBaseUrlForIsolatedCloud = (product, cloudId)=>{
    if (product === 'bitbucket' || product === 'teamwork-graph') throw new Error('product not supported in Isolated Cloud yet.');
    const apiBase = `api.${(0, $8B1kb.isolatedCloudDomain)()}`;
    return `https://${apiBase}/ex/${product}/${cloudId}`;
};
function $6ff957d04b48dc7f$var$getBaseUrlForCommercialAndFedRamp(environment, product, cloudId) {
    if (product === 'bitbucket') return environment === 'prod' ? 'https://api.bitbucket.org' : 'https://api.integration.bb-inf.net';
    const apiBase = $6ff957d04b48dc7f$var$getApiGatewayUrl(environment);
    if (product === 'teamwork-graph') {
        if ((0, $jH9cM.isFedRamp)()) throw new Error('product not supported in FedRAMP yet.');
        return `https://${apiBase}`;
    }
    return `https://${apiBase}/ex/${product}/${cloudId}`;
}
function $6ff957d04b48dc7f$var$getBaseUrl(environment, product, cloudId) {
    return (0, $i3S9F.isIsolatedCloud)() ? $6ff957d04b48dc7f$var$getBaseUrlForIsolatedCloud(product, cloudId) : $6ff957d04b48dc7f$var$getBaseUrlForCommercialAndFedRamp(environment, product, cloudId);
}
function $6ff957d04b48dc7f$var$createProductUrl(environment, product, restPath, cloudId) {
    const baseUrl = $6ff957d04b48dc7f$var$getBaseUrl(environment, product, cloudId);
    const fullUrl = // bitbucket requests could be made with absolute URLs
    // e.g. when following href links in API responses
    product === 'bitbucket' && restPath.startsWith(`${baseUrl}/`) ? restPath : `${baseUrl}${restPath}`;
    const productUrl = new URL(fullUrl).toString();
    if (!productUrl.startsWith(`${baseUrl}/`)) throw new Error('Invalid product URL');
    return productUrl;
}
function $6ff957d04b48dc7f$export$d1a8c8b605234fe8(token) {
    return !!(token && token.expiry > Date.now());
}
function $6ff957d04b48dc7f$var$isProduct(product) {
    return $6ff957d04b48dc7f$var$validProducts.includes(product);
}
function $6ff957d04b48dc7f$export$da8d8c42bfb20907(contentType) {
    return Boolean(contentType && !contentType.includes('application/json') && contentType.search(/text\//) === -1);
}
function $6ff957d04b48dc7f$var$parseFormData(formLike) {
    const form = new FormData();
    for (const [key, value] of Object.entries(formLike))if (key === 'file') {
        const fileName = formLike['__fileName'];
        const mimeType = formLike['__fileType'];
        // convert back from base64 to File (Blob)
        const blob = (0, $aqd0l.base64ToBlob)(value, mimeType);
        const file = new File([
            blob
        ], fileName, {
            type: mimeType
        });
        form.append('file', file);
    } else form.append(key, value);
    // remove request metadata properties
    form.delete('__fileName');
    form.delete('__fileType');
    return form;
}
const $6ff957d04b48dc7f$var$requestProduct = async (url, init)=>{
    const response = await fetch(url, init);
    const isAttachment = $6ff957d04b48dc7f$export$da8d8c42bfb20907(response.headers.get('content-type'));
    if (response.ok && response.body !== null && response.status !== 204 && isAttachment) {
        const b64Content = await (0, $aqd0l.blobToBase64)(await response.blob());
        return new Response(b64Content, {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
    }
    return response;
};
const $6ff957d04b48dc7f$export$2f041121bdb61a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useProductFetchClient(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { appId: appId, extensionId: extensionId, environment: environment, cloudId: cloudId, workspaceId: workspaceId, renderThreeLOPrompt: renderThreeLOPrompt, contextIds: t1, isAnonymousAccessSupportedByApp: t2 } = t0;
    let t3;
    if ($[0] !== t1) {
        t3 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t3;
    } else t3 = $[1];
    const contextIds = t3;
    const isAnonymousAccessSupportedByApp = t2 === undefined ? false : t2;
    const { captureEvent: captureEvent } = (0, $3nNWm.usePerformanceAnalytics)();
    const userAccess = (0, $cozmU.useContext)((0, $5Zman.UserAccessContext));
    const authTokenRef = (0, $cozmU.useRef)(undefined);
    const isUserAnonymous = userAccess?.isUserAnonymous ?? false;
    const anonymousRequestsEnabled = (0, $cozmU.useRef)(isUserAnonymous && isAnonymousAccessSupportedByApp);
    const relayContext = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext));
    const relayEnvironment = relayContext?.environment;
    let t4;
    if ($[2] !== renderThreeLOPrompt) {
        t4 = {
            renderThreeLOPrompt: renderThreeLOPrompt
        };
        $[2] = renderThreeLOPrompt;
        $[3] = t4;
    } else t4 = $[3];
    const fetchOAuthToken = (0, $kn1J6.useFetchAuthToken)(t4);
    if (!cloudId && !workspaceId) return $6ff957d04b48dc7f$var$_temp;
    let t5;
    if ($[4] !== environment) {
        t5 = (0, $5cSJl.getCDNEnvironment)(environment);
        $[4] = environment;
        $[5] = t5;
    } else t5 = $[5];
    const cdnEnvironment = t5;
    let t6;
    if ($[6] !== appId || $[7] !== captureEvent || $[8] !== cdnEnvironment || $[9] !== cloudId || $[10] !== contextIds || $[11] !== extensionId || $[12] !== fetchOAuthToken || $[13] !== isAnonymousAccessSupportedByApp || $[14] !== relayEnvironment) {
        t6 = async (restPath, product, init, isMultipartFormData)=>{
            if (!$6ff957d04b48dc7f$var$isProduct(product)) throw new Error(`Invalid product: ${product}`);
            const requestAuthStartMark = (0, $hjngh.getPerformanceMark)();
            captureEvent?.({
                type: "product-api-request-initiated",
                elapsed: requestAuthStartMark
            });
            const prerequisites = [];
            const headers = new Headers(init.headers);
            if ((0, $iDrrr.fg)("forge-ui-enable-region-steering")) prerequisites.push((0, $kyUPS.getTenantRegion)({
                product: product,
                cloudId: cloudId,
                relayEnvironment: relayEnvironment
            }).then((targetRegion)=>{
                if (!!targetRegion) headers.set("atl-edge-region-hint", targetRegion);
            }).catch($6ff957d04b48dc7f$var$_temp2));
            const isAccessValid = anonymousRequestsEnabled.current || $6ff957d04b48dc7f$export$d1a8c8b605234fe8(authTokenRef.current);
            if (!isAccessValid) prerequisites.push(fetchOAuthToken(extensionId, contextIds).then((token)=>{
                authTokenRef.current = token;
            }).catch((e)=>{
                if (isAnonymousAccessSupportedByApp && (0, $iDrrr.fg)("forge-ui-allow-anon-rest-calls")) {
                    anonymousRequestsEnabled.current = true;
                    return;
                }
                throw e;
            }));
            await Promise.all(prerequisites);
            if (!anonymousRequestsEnabled.current) headers.set("Authorization", `Bearer ${authTokenRef.current?.token}`);
            const appAri = (0, $9cGsb.createAppAri)({
                appId: appId
            }).toString();
            headers.set("x-ecosystem-user-agent", `forge ${appAri}`);
            const body = isMultipartFormData ? $6ff957d04b48dc7f$var$parseFormData(JSON.parse(init.body)) : init.body;
            if (isMultipartFormData) headers.delete("content-type");
            const request = $6ff957d04b48dc7f$var$requestProduct($6ff957d04b48dc7f$var$createProductUrl(cdnEnvironment, product, restPath, cloudId), {
                credentials: (0, $iDrrr.fg)("forge-ui-allow-anon-rest-calls") ? "omit" : undefined,
                ...init,
                body: body,
                headers: headers
            });
            if ((0, $iDrrr.fg)("forge-ui-app-perf-tracking-enabled")) {
                const requestAuthEndMark = (0, $hjngh.getPerformanceMark)();
                request.then(()=>{
                    const requestEndMark = (0, $hjngh.getPerformanceMark)();
                    captureEvent?.({
                        type: "product-api-requested",
                        duration: requestEndMark - requestAuthStartMark,
                        authDuration: requestAuthEndMark - requestAuthStartMark,
                        elapsed: requestEndMark
                    });
                });
            }
            return request;
        };
        $[6] = appId;
        $[7] = captureEvent;
        $[8] = cdnEnvironment;
        $[9] = cloudId;
        $[10] = contextIds;
        $[11] = extensionId;
        $[12] = fetchOAuthToken;
        $[13] = isAnonymousAccessSupportedByApp;
        $[14] = relayEnvironment;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : function useProductFetchClient({ appId: appId, extensionId: extensionId, environment: environment, cloudId: cloudId, workspaceId: workspaceId, renderThreeLOPrompt: renderThreeLOPrompt, contextIds: contextIds = [], isAnonymousAccessSupportedByApp: isAnonymousAccessSupportedByApp = false }) {
    const { captureEvent: captureEvent } = (0, $3nNWm.usePerformanceAnalytics)();
    const userAccess = (0, $cozmU.useContext)((0, $5Zman.UserAccessContext));
    const authTokenRef = (0, $cozmU.useRef)(undefined);
    const isUserAnonymous = userAccess?.isUserAnonymous ?? false;
    const anonymousRequestsEnabled = (0, $cozmU.useRef)(isUserAnonymous && isAnonymousAccessSupportedByApp);
    const relayContext = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext));
    const relayEnvironment = relayContext?.environment;
    const fetchOAuthToken = (0, $kn1J6.useFetchAuthToken)({
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    /**
   * Workspace based products like Trello and Bitbucket will not pass in cloudId,
   * they will pass in workspaceId instead.
   */ if (!cloudId && !workspaceId) return async ()=>{
        throw new Error('Product APIs are not available in this module. Remove requestConfluence, requestJira or requestBitbucket from your code.');
    };
    const cdnEnvironment = (0, $5cSJl.getCDNEnvironment)(environment);
    return async (restPath, product, init, isMultipartFormData)=>{
        if (!$6ff957d04b48dc7f$var$isProduct(product)) throw new Error(`Invalid product: ${product}`);
        const requestAuthStartMark = (0, $hjngh.getPerformanceMark)();
        captureEvent?.({
            type: 'product-api-request-initiated',
            elapsed: requestAuthStartMark
        });
        const prerequisites = [];
        const headers = new Headers(init.headers);
        if ((0, $iDrrr.fg)('forge-ui-enable-region-steering')) // We need to fetch the tenant region to know which region to steer the request to.
        prerequisites.push((0, $kyUPS.getTenantRegion)({
            product: product,
            cloudId: cloudId,
            relayEnvironment: relayEnvironment
        }).then((targetRegion)=>{
            if (!!targetRegion) headers.set('atl-edge-region-hint', targetRegion);
        })// Fallback to no steering.
        .catch(()=>null));
        const isAccessValid = anonymousRequestsEnabled.current || $6ff957d04b48dc7f$export$d1a8c8b605234fe8(authTokenRef.current);
        if (!isAccessValid) // Non-anonymous user -> fetch an OAuth token for API auth
        prerequisites.push(fetchOAuthToken(extensionId, contextIds).then((token)=>{
            // Token valid -> use in API calls
            authTokenRef.current = token;
        }).catch((e)=>{
            // Failure -> fallback to anon access if supported by app
            if (isAnonymousAccessSupportedByApp && (0, $iDrrr.fg)('forge-ui-allow-anon-rest-calls')) {
                anonymousRequestsEnabled.current = true;
                return;
            }
            // Expecting token -> Rethrow
            throw e;
        }));
        await Promise.all(prerequisites);
        if (!anonymousRequestsEnabled.current) headers.set('Authorization', `Bearer ${authTokenRef.current?.token}`);
        // this header is used to identify requests made by Forge, based on:
        // https://hello.atlassian.net/wiki/x/O5jUIwE?atlOrigin=eyJpIjoiM2NhNjU1MDUxOWJkNDcxNThiNzJjNWU1NzE5Y2FmZTMiLCJwIjoiYyJ9
        const appAri = (0, $9cGsb.createAppAri)({
            appId: appId
        }).toString();
        headers.set('x-ecosystem-user-agent', `forge ${appAri}`);
        const body = isMultipartFormData ? $6ff957d04b48dc7f$var$parseFormData(JSON.parse(init.body)) : init.body;
        if (isMultipartFormData) // let the fetch api correctly set the multipart/form-data content-type
        // https://github.com/github/fetch/issues/505#issuecomment-293064470
        headers.delete('content-type');
        const request = $6ff957d04b48dc7f$var$requestProduct($6ff957d04b48dc7f$var$createProductUrl(cdnEnvironment, product, restPath, cloudId), {
            // Defensive assumption: only token & anonymous auth is supported; prevent unintended
            // fallback to other auth mechanisms by omitting credentials (e.g. cookies).
            credentials: (0, $iDrrr.fg)('forge-ui-allow-anon-rest-calls') ? 'omit' : undefined,
            ...init,
            body: body,
            headers: headers
        });
        if ((0, $iDrrr.fg)('forge-ui-app-perf-tracking-enabled')) {
            const requestAuthEndMark = (0, $hjngh.getPerformanceMark)();
            request.then(()=>{
                const requestEndMark = (0, $hjngh.getPerformanceMark)();
                captureEvent?.({
                    type: 'product-api-requested',
                    duration: requestEndMark - requestAuthStartMark,
                    authDuration: requestAuthEndMark - requestAuthStartMark,
                    elapsed: requestEndMark
                });
            });
        }
        return request;
    };
};
function $6ff957d04b48dc7f$var$_temp2() {
    return null;
}
async function $6ff957d04b48dc7f$var$_temp() {
    throw new Error("Product APIs are not available in this module. Remove requestConfluence, requestJira or requestBitbucket from your code.");
}
module.exports["isTokenValid"] = $6ff957d04b48dc7f$export$d1a8c8b605234fe8;
module.exports["isBinaryContentType"] = $6ff957d04b48dc7f$export$da8d8c42bfb20907;
module.exports["useProductFetchClient"] = $6ff957d04b48dc7f$export$2f041121bdb61a5;

});

parcelRegister("igFAK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hjngh = parcelRequire("hjngh");


var $3nNWm = parcelRequire("3nNWm");


var $2MUrL = parcelRequire("2MUrL");


var $9cGsb = parcelRequire("9cGsb");


var $kn1J6 = parcelRequire("kn1J6");

const $21d571b81e33ca19$var$EGRESS_GET = ()=>({
        method: 'GET',
        route: '/forge/installation/v1/dynamic/egress'
    });
const $21d571b81e33ca19$var$EGRESS_SET = (installationId, dryRun = false)=>({
        method: 'PUT',
        route: `/forge/installation/v1/${installationId}/dynamic/egress?dryRun=${dryRun}`
    });
const $21d571b81e33ca19$var$EGRESS_DELETE_GROUP = (installationId)=>({
        method: 'DELETE',
        route: `/forge/installation/v1/${installationId}/dynamic/egress`
    });
const $21d571b81e33ca19$var$EGRESS_DELETE_DOMAIN = (installationId)=>({
        method: 'PATCH',
        route: `/forge/installation/v1/${installationId}/dynamic/egress/delete-domain`
    });
const $21d571b81e33ca19$var$REMOTE_GET = ()=>({
        method: 'GET',
        route: '/forge/installation/v1/dynamic/remote'
    });
const $21d571b81e33ca19$var$REMOTE_SET = (installationId, dryRun = false)=>({
        method: 'PUT',
        route: `/forge/installation/v1/${installationId}/dynamic/remote?dryRun=${dryRun}`
    });
const $21d571b81e33ca19$export$70250d945629938a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function usePermissionFetchClient(t0) {
    const $ = (0, $bDgLe.c)(30);
    const { appId: appId, installationId: installationId, extensionId: extensionId, accountType: accountType, renderThreeLOPrompt: renderThreeLOPrompt, contextIds: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const contextIds = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = function getBaseUrl() {
            const currentUrl = new URL(document.URL);
            return `${currentUrl.origin}/gateway/api`;
        };
        $[2] = t3;
    } else t3 = $[2];
    const getBaseUrl = t3;
    const { captureEvent: captureEvent } = (0, $3nNWm.usePerformanceAnalytics)();
    const authTokenRef = (0, $cozmU.useRef)(undefined);
    let t4;
    if ($[3] !== renderThreeLOPrompt) {
        t4 = {
            renderThreeLOPrompt: renderThreeLOPrompt
        };
        $[3] = renderThreeLOPrompt;
        $[4] = t4;
    } else t4 = $[4];
    const fetchOAuthToken = (0, $kn1J6.useFetchAuthToken)(t4);
    let t5;
    if ($[5] !== accountType || $[6] !== appId || $[7] !== captureEvent || $[8] !== contextIds || $[9] !== extensionId || $[10] !== fetchOAuthToken) {
        t5 = async (restPath, init)=>{
            const requestAuthStartMark = (0, $hjngh.getPerformanceMark)();
            captureEvent?.({
                type: "permission-api-request-initiated",
                elapsed: requestAuthStartMark
            });
            const atlassianAccount = !accountType || accountType === "atlassian";
            if (!(0, $2MUrL.isTokenValid)(authTokenRef.current) && atlassianAccount) authTokenRef.current = await fetchOAuthToken(extensionId, contextIds);
            const headers = new Headers(init.headers);
            headers.set("Authorization", `Bearer ${authTokenRef?.current?.token}`);
            const appAri = (0, $9cGsb.createAppAri)({
                appId: appId
            }).toString();
            headers.set("x-ecosystem-user-agent", `forge ${appAri}`);
            const requestAuthEndMark = (0, $hjngh.getPerformanceMark)();
            const request = fetch(new URL(`${getBaseUrl()}${restPath}`), {
                ...init,
                body: init.body,
                headers: headers
            });
            if ((0, $iDrrr.fg)("forge-ui-app-perf-tracking-enabled")) request.then(()=>{
                const requestEndMark = (0, $hjngh.getPerformanceMark)();
                captureEvent?.({
                    type: "permission-api-requested",
                    duration: requestEndMark - requestAuthStartMark,
                    authDuration: requestAuthEndMark - requestAuthStartMark,
                    elapsed: requestEndMark
                });
            });
            return request;
        };
        $[5] = accountType;
        $[6] = appId;
        $[7] = captureEvent;
        $[8] = contextIds;
        $[9] = extensionId;
        $[10] = fetchOAuthToken;
        $[11] = t5;
    } else t5 = $[11];
    const oauthFetch = t5;
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = async (restPath_0, init_0)=>{
            const request_0 = fetch(`${getBaseUrl()}${restPath_0}`, {
                ...init_0,
                body: init_0.body
            });
            return request_0;
        };
        $[12] = t6;
    } else t6 = $[12];
    const sessionFetch = t6;
    let t7;
    if ($[13] !== oauthFetch) {
        t7 = async (payload)=>{
            const { route: route, method: method } = $21d571b81e33ca19$var$EGRESS_GET();
            const init_1 = {
                method: method
            };
            const sp = new URLSearchParams();
            if (payload.keys && payload.keys.length > 0) payload.keys.forEach((k)=>{
                sp.append("keys", k);
            });
            if (payload.pageSize) sp.append("pageSize", `${payload.pageSize}`);
            if (payload.nextPageToken) sp.append("nextPageToken", payload.nextPageToken);
            let routeToUse = route;
            if (sp.size > 0) routeToUse = `${route}?${sp.toString()}`;
            return oauthFetch(routeToUse, init_1);
        };
        $[13] = oauthFetch;
        $[14] = t7;
    } else t7 = $[14];
    let t10;
    let t8;
    let t9;
    if ($[15] !== installationId) {
        t8 = async (payload_0, isDryRun)=>{
            const { route: route_0, method: method_0 } = $21d571b81e33ca19$var$EGRESS_SET(installationId, isDryRun);
            const body = JSON.stringify(payload_0);
            const init_2 = {
                method: method_0,
                headers: {
                    "Content-Type": "application/json"
                },
                body: body
            };
            return sessionFetch(route_0, init_2);
        };
        t9 = async (payload_1)=>{
            const { route: route_1, method: method_1 } = $21d571b81e33ca19$var$EGRESS_DELETE_DOMAIN(installationId);
            const body_0 = JSON.stringify(payload_1);
            const init_3 = {
                method: method_1,
                headers: {
                    "Content-Type": "application/json"
                },
                body: body_0
            };
            return sessionFetch(route_1, init_3);
        };
        t10 = async (payload_2)=>{
            const { route: route_2, method: method_2 } = $21d571b81e33ca19$var$EGRESS_DELETE_GROUP(installationId);
            const init_4 = {
                method: method_2
            };
            const sp_0 = new URLSearchParams();
            if (payload_2.key) sp_0.append("key", payload_2.key);
            let routeToUse_0 = route_2;
            if (sp_0.size > 0) routeToUse_0 = `${route_2}?${sp_0.toString()}`;
            return sessionFetch(routeToUse_0, init_4);
        };
        $[15] = installationId;
        $[16] = t10;
        $[17] = t8;
        $[18] = t9;
    } else {
        t10 = $[16];
        t8 = $[17];
        t9 = $[18];
    }
    let t11;
    if ($[19] !== oauthFetch) {
        t11 = async (payload_3)=>{
            const { route: route_3, method: method_3 } = $21d571b81e33ca19$var$REMOTE_GET();
            const init_5 = {
                method: method_3
            };
            const sp_1 = new URLSearchParams();
            if (payload_3.keys && payload_3.keys.length > 0) payload_3.keys.forEach((k_0)=>{
                sp_1.append("keys", k_0);
            });
            if (payload_3.pageSize) sp_1.append("pageSize", `${payload_3.pageSize}`);
            if (payload_3.nextPageToken) sp_1.append("nextPageToken", payload_3.nextPageToken);
            let routeToUse_1 = route_3;
            if (sp_1.size > 0) routeToUse_1 = `${route_3}?${sp_1.toString()}`;
            return oauthFetch(routeToUse_1, init_5);
        };
        $[19] = oauthFetch;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== installationId) {
        t12 = async (payload_4, isDryRun_0)=>{
            const { route: route_4, method: method_4 } = $21d571b81e33ca19$var$REMOTE_SET(installationId, isDryRun_0);
            const body_1 = JSON.stringify(payload_4);
            const init_6 = {
                method: method_4,
                headers: {
                    "Content-Type": "application/json"
                },
                body: body_1
            };
            return sessionFetch(route_4, init_6);
        };
        $[21] = installationId;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== t10 || $[24] !== t11 || $[25] !== t12 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
        t13 = {
            egressGet: t7,
            egressSet: t8,
            egressDeleteDomain: t9,
            egressDeleteGroup: t10,
            remoteGet: t11,
            remoteSet: t12
        };
        $[23] = t10;
        $[24] = t11;
        $[25] = t12;
        $[26] = t7;
        $[27] = t8;
        $[28] = t9;
        $[29] = t13;
    } else t13 = $[29];
    return t13;
} : function usePermissionFetchClient({ appId: appId, installationId: installationId, extensionId: extensionId, accountType: accountType, renderThreeLOPrompt: renderThreeLOPrompt, contextIds: contextIds = [] }) {
    function getBaseUrl() {
        const currentUrl = new URL(document.URL);
        return `${currentUrl.origin}/gateway/api`;
    }
    const { captureEvent: captureEvent } = (0, $3nNWm.usePerformanceAnalytics)();
    const authTokenRef = (0, $cozmU.useRef)(undefined);
    const fetchOAuthToken = (0, $kn1J6.useFetchAuthToken)({
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    const oauthFetch = async (restPath, init)=>{
        const requestAuthStartMark = (0, $hjngh.getPerformanceMark)();
        captureEvent?.({
            type: 'permission-api-request-initiated',
            elapsed: requestAuthStartMark
        });
        const atlassianAccount = !accountType || accountType === 'atlassian';
        if (!(0, $2MUrL.isTokenValid)(authTokenRef.current) && atlassianAccount) authTokenRef.current = await fetchOAuthToken(extensionId, contextIds);
        const headers = new Headers(init.headers);
        headers.set('Authorization', `Bearer ${authTokenRef?.current?.token}`);
        // this header is used to identify requests made by Forge, based on:
        // https://hello.atlassian.net/wiki/x/O5jUIwE?atlOrigin=eyJpIjoiM2NhNjU1MDUxOWJkNDcxNThiNzJjNWU1NzE5Y2FmZTMiLCJwIjoiYyJ9
        const appAri = (0, $9cGsb.createAppAri)({
            appId: appId
        }).toString();
        headers.set('x-ecosystem-user-agent', `forge ${appAri}`);
        const requestAuthEndMark = (0, $hjngh.getPerformanceMark)();
        const request = fetch(new URL(`${getBaseUrl()}${restPath}`), {
            ...init,
            body: init.body,
            headers: headers
        });
        if ((0, $iDrrr.fg)('forge-ui-app-perf-tracking-enabled')) request.then(()=>{
            const requestEndMark = (0, $hjngh.getPerformanceMark)();
            captureEvent?.({
                type: 'permission-api-requested',
                duration: requestEndMark - requestAuthStartMark,
                authDuration: requestAuthEndMark - requestAuthStartMark,
                elapsed: requestEndMark
            });
        });
        return request;
    };
    const sessionFetch = async (restPath_0, init_0)=>{
        const request_0 = fetch(`${getBaseUrl()}${restPath_0}`, {
            ...init_0,
            body: init_0.body
        });
        return request_0;
    };
    return {
        egressGet: async (payload)=>{
            const { route: route, method: method } = $21d571b81e33ca19$var$EGRESS_GET();
            const init_1 = {
                method: method
            };
            const sp = new URLSearchParams();
            if (payload.keys && payload.keys.length > 0) payload.keys.forEach((k)=>{
                sp.append('keys', k);
            });
            if (payload.pageSize) sp.append('pageSize', `${payload.pageSize}`);
            if (payload.nextPageToken) sp.append('nextPageToken', payload.nextPageToken);
            let routeToUse = route;
            if (sp.size > 0) routeToUse = `${route}?${sp.toString()}`;
            return oauthFetch(routeToUse, init_1);
        },
        egressSet: async (payload_0, isDryRun)=>{
            const { route: route_0, method: method_0 } = $21d571b81e33ca19$var$EGRESS_SET(installationId, isDryRun);
            const body = JSON.stringify(payload_0);
            const init_2 = {
                method: method_0,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body
            };
            return sessionFetch(route_0, init_2);
        },
        egressDeleteDomain: async (payload_1)=>{
            const { route: route_1, method: method_1 } = $21d571b81e33ca19$var$EGRESS_DELETE_DOMAIN(installationId);
            const body_0 = JSON.stringify(payload_1);
            const init_3 = {
                method: method_1,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body_0
            };
            return sessionFetch(route_1, init_3);
        },
        egressDeleteGroup: async (payload_2)=>{
            const { route: route_2, method: method_2 } = $21d571b81e33ca19$var$EGRESS_DELETE_GROUP(installationId);
            const init_4 = {
                method: method_2
            };
            const sp_0 = new URLSearchParams();
            if (payload_2.key) sp_0.append('key', payload_2.key);
            let routeToUse_0 = route_2;
            if (sp_0.size > 0) routeToUse_0 = `${route_2}?${sp_0.toString()}`;
            return sessionFetch(routeToUse_0, init_4);
        },
        remoteGet: async (payload_3)=>{
            const { route: route_3, method: method_3 } = $21d571b81e33ca19$var$REMOTE_GET();
            const init_5 = {
                method: method_3
            };
            const sp_1 = new URLSearchParams();
            if (payload_3.keys && payload_3.keys.length > 0) payload_3.keys.forEach((k_0)=>{
                sp_1.append('keys', k_0);
            });
            if (payload_3.pageSize) sp_1.append('pageSize', `${payload_3.pageSize}`);
            if (payload_3.nextPageToken) sp_1.append('nextPageToken', payload_3.nextPageToken);
            let routeToUse_1 = route_3;
            if (sp_1.size > 0) routeToUse_1 = `${route_3}?${sp_1.toString()}`;
            return oauthFetch(routeToUse_1, init_5);
        },
        remoteSet: async (payload_4, isDryRun_0)=>{
            const { route: route_4, method: method_4 } = $21d571b81e33ca19$var$REMOTE_SET(installationId, isDryRun_0);
            const body_1 = JSON.stringify(payload_4);
            const init_6 = {
                method: method_4,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body_1
            };
            return sessionFetch(route_4, init_6);
        }
    };
};
module.exports["usePermissionFetchClient"] = $21d571b81e33ca19$export$70250d945629938a;

});

parcelRegister("2lRPc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $czfKl = parcelRequire("czfKl");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $aqd0l = parcelRequire("aqd0l");

// FIT tokens are valid for 1 hour, but to include some buffer, we'll use 30 minutes.
const $f2519ea17e40ec8a$var$FIT_TOKEN_EXPIRY_MS = 1800000;
const $f2519ea17e40ec8a$export$a30e8bad2b49cec5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [signInvocationTokenForUIMutation] = (0, $6SsN4.useMutation)((0, $czfKl.default));
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = new Map();
        $[0] = t0;
    } else t0 = $[0];
    const cachedFitTokenMapRef = (0, $cozmU.useRef)(t0);
    let t1;
    if ($[1] !== signInvocationTokenForUIMutation) {
        t1 = async (remoteKey, init, isMultipartFormData, restPath, contextToken)=>{
            if (!contextToken) throw new Error("Context token is required");
            const { fitToken: fitToken, remoteBaseUrl: remoteBaseUrl } = await $f2519ea17e40ec8a$var$getCachedFitToken(remoteKey, contextToken, cachedFitTokenMapRef, signInvocationTokenForUIMutation);
            const targetUrl = restPath ? new URL(restPath, remoteBaseUrl) : remoteBaseUrl;
            const headers = new Headers(init.headers);
            headers.set("Authorization", `Bearer ${fitToken}`);
            const body = isMultipartFormData ? $f2519ea17e40ec8a$var$parseFormData(JSON.parse(init.body)) : init.body;
            if (isMultipartFormData) headers.delete("content-type");
            const response = await fetch(targetUrl, {
                ...init,
                headers: headers,
                body: body
            });
            const isAttachment = $f2519ea17e40ec8a$var$isBinaryContentType(response.headers.get("content-type"));
            if (response.ok && response.body !== null && response.status !== 204 && isAttachment) {
                const b64Content = await (0, $aqd0l.blobToBase64)(await response.blob());
                return new Response(b64Content, {
                    status: response.status,
                    statusText: response.statusText,
                    headers: response.headers
                });
            }
            return response;
        };
        $[1] = signInvocationTokenForUIMutation;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const [signInvocationTokenForUIMutation] = (0, $6SsN4.useMutation)((0, $czfKl.default));
    // Cache the FIT tokens against remoteKey to avoid excessively minting new FIT tokens.
    const cachedFitTokenMapRef = (0, $cozmU.useRef)(new Map());
    return async (remoteKey, init, isMultipartFormData, restPath, contextToken)=>{
        if (!contextToken) throw new Error('Context token is required');
        const { fitToken: fitToken, remoteBaseUrl: remoteBaseUrl } = await $f2519ea17e40ec8a$var$getCachedFitToken(remoteKey, contextToken, cachedFitTokenMapRef, signInvocationTokenForUIMutation);
        // Call the remote with the FIT token as the authorization header
        const targetUrl = restPath ? new URL(restPath, remoteBaseUrl) : remoteBaseUrl;
        const headers = new Headers(init.headers);
        headers.set('Authorization', `Bearer ${fitToken}`);
        // handle multipart form data
        const body = isMultipartFormData ? $f2519ea17e40ec8a$var$parseFormData(JSON.parse(init.body)) : init.body;
        if (isMultipartFormData) // let the fetch api correctly set the multipart/form-data content-type
        // https://github.com/github/fetch/issues/505#issuecomment-293064470
        headers.delete('content-type');
        const response = await fetch(targetUrl, {
            ...init,
            headers: headers,
            body: body
        });
        // Handle binary response types
        const isAttachment = $f2519ea17e40ec8a$var$isBinaryContentType(response.headers.get('content-type'));
        if (response.ok && response.body !== null && response.status !== 204 && isAttachment) {
            const b64Content = await (0, $aqd0l.blobToBase64)(await response.blob());
            return new Response(b64Content, {
                status: response.status,
                statusText: response.statusText,
                headers: response.headers
            });
        }
        return response;
    };
};
async function $f2519ea17e40ec8a$var$getCachedFitToken(remoteKey, contextToken, cachedFitTokenMapRef, signInvocationTokenForUIMutation) {
    let fitToken;
    let remoteBaseUrl;
    const cachedFitToken = cachedFitTokenMapRef.current.get(remoteKey);
    // Attempt to use the cached FIT token if it is in the map and is valid
    if (cachedFitToken && $f2519ea17e40ec8a$var$isFitValid(cachedFitToken)) {
        fitToken = cachedFitToken.fitToken;
        remoteBaseUrl = cachedFitToken.remoteBaseUrl;
    } else {
        const fitExchangeResponse = await $f2519ea17e40ec8a$var$exchangeFCTForFIT(contextToken, remoteKey, signInvocationTokenForUIMutation);
        const { fitToken: newFitToken, remoteBaseUrl: newRemoteBaseUrl } = fitExchangeResponse;
        cachedFitTokenMapRef.current.set(remoteKey, {
            fitToken: newFitToken,
            remoteBaseUrl: newRemoteBaseUrl,
            fitTokenExpiresAt: Date.now() + $f2519ea17e40ec8a$var$FIT_TOKEN_EXPIRY_MS
        });
        fitToken = newFitToken;
        remoteBaseUrl = newRemoteBaseUrl;
    }
    if (!remoteBaseUrl) throw new Error('Remote base URL is not available for the given remote key');
    if (!fitToken) throw new Error('FIT token is not available for the given remote key');
    return {
        fitToken: fitToken,
        remoteBaseUrl: remoteBaseUrl
    };
}
async function $f2519ea17e40ec8a$var$exchangeFCTForFIT(contextToken, remoteKey, signInvocationTokenForUIMutation) {
    return new Promise((resolve, reject)=>{
        signInvocationTokenForUIMutation({
            variables: {
                input: {
                    forgeContextToken: contextToken,
                    remoteKey: remoteKey
                }
            },
            onCompleted: (data, errors)=>{
                if (errors || !data?.signInvocationTokenForUI || data.signInvocationTokenForUI.errors) reject(new Error(`Failed to generate FIT token`));
                const response = {
                    fitToken: data.signInvocationTokenForUI?.forgeInvocationToken?.jwt ?? '',
                    remoteBaseUrl: data.signInvocationTokenForUI?.metadata?.baseUrl ?? ''
                };
                resolve(response);
            }
        });
    });
}
function $f2519ea17e40ec8a$var$isFitValid(cachedFitToken) {
    return cachedFitToken.fitTokenExpiresAt > Date.now();
}
function $f2519ea17e40ec8a$var$parseFormData(formLike) {
    const form = new FormData();
    for (const [key, value] of Object.entries(formLike))if (key.startsWith('file')) {
        const encodedFileNameKey = `__${key}Name`;
        const encodedMimeTypeKey = `__${key}Type`;
        const fileName = formLike[encodedFileNameKey];
        const mimeType = formLike[encodedMimeTypeKey];
        // convert back from base64 to File (Blob)
        const blob = (0, $aqd0l.base64ToBlob)(value, mimeType);
        const file = new File([
            blob
        ], fileName, {
            type: mimeType
        });
        form.append(key, file);
    } else form.append(key, value);
    // remove request metadata properties
    form.delete('__fileName');
    form.delete('__fileType');
    return form;
}
function $f2519ea17e40ec8a$var$isBinaryContentType(contentType) {
    return Boolean(contentType && !contentType.includes('application/json') && contentType.search(/text\//) === -1);
}
module.exports["useRemoteFetchClient"] = $f2519ea17e40ec8a$export$a30e8bad2b49cec5;

});

parcelRegister("doGLo", function(module, exports) {

var $eEPSE = parcelRequire("eEPSE");


var $l1aSK = parcelRequire("l1aSK");

const $65bc59222c47beed$export$6baf9fc1d877ea76 = 'atlassian-token-service-key';
const $65bc59222c47beed$export$5a2d35665f488c3c = async (startUrl, windowFeatures)=>{
    return (0, $eEPSE.auth)((0, $l1aSK.sanitizeUrl)(startUrl), windowFeatures);
};
const $65bc59222c47beed$export$4211976e157c7ad8 = (startUrl)=>{
    const url = new URL(startUrl || '', window.location.href);
    const serviceKey = url.searchParams.get('serviceKey');
    return serviceKey !== $65bc59222c47beed$export$6baf9fc1d877ea76;
};
module.exports["safeAuth"] = $65bc59222c47beed$export$5a2d35665f488c3c;
module.exports["isExternalAuth"] = $65bc59222c47beed$export$4211976e157c7ad8;

});

parcelRegister("5Wwmi", function(module, exports) {
const $88b38b3f4babac2c$var$DEFAULT_EVENT_SAMPLE_RATE = 0.1;
const $88b38b3f4babac2c$var$DEFAULT_PROFILE_EVENT_VERSION = '2.0';
const $88b38b3f4babac2c$export$b516b893fff0f452 = {
    enabled: true,
    sampleRate: $88b38b3f4babac2c$var$DEFAULT_EVENT_SAMPLE_RATE,
    version: $88b38b3f4babac2c$var$DEFAULT_PROFILE_EVENT_VERSION
};
const $88b38b3f4babac2c$export$b8357089f6c151ea = [
    // Jira modules
    'jira:adminPage',
    'jira:customField',
    'jira:customFieldType',
    'jira:dashboardGadget',
    'jira:globalPage',
    'jira:issueAction',
    'jira:issueActivity',
    'jira:issueContext',
    'jira:issuePanel',
    'jira:projectPage',
    'jira:projectSettingsPage',
    'jira:uiModifications',
    // Confluence modules
    'confluence:contentAction',
    'confluence:contentBylineItem',
    'confluence:globalPage',
    'confluence:globalSettings',
    'confluence:spacePage',
    'xen:macro'
];
module.exports["defaultPerfCaptureConfig"] = $88b38b3f4babac2c$export$b516b893fff0f452;
module.exports["enabledModulesForPerfCapture"] = $88b38b3f4babac2c$export$b8357089f6c151ea;

});

parcelRegister("3db8V", function(module, exports) {
const $e82726be8c3e3c04$export$5458688a52e32026 = [
    // Error in user code
    /^There was an error invoking the function/,
    // User code returned non-JSON value, so XIS threw an InvalidInvocationPayloadError.
    /^Invalid response body, data must be JSON or undefined$/,
    // Networking errors
    /^Failed to fetch$/,
    /^Network error: Failed to fetch$/,
    /^Network error: Network failure: TypeError: Failed to fetch$/,
    /^NetworkError when attempting to fetch resource.$/,
    /^Network error: Received status 504$/,
    // time out
    /^GraphQL error: The underlying service call timed out$/,
    // Unauthenticated requests made from public confluence content
    /^GraphQL error: Auth category: UNAUTHENTICATED is not allowed in service xen_invocation_service$/
];
module.exports["blocklistedErrorMessagePatterns"] = $e82726be8c3e3c04$export$5458688a52e32026;

});

parcelRegister("e1sLx", function(module, exports) {

var $9iaDP = parcelRequire("9iaDP");


var $glUKJ = parcelRequire("glUKJ");


var $6UBMp = parcelRequire("6UBMp");

const $b6b4f23189aabe31$var$getExtensionParams = (extension)=>{
    const { appId: appId, environmentKey: environmentKey, key: key } = extension;
    if (!appId) throw (0, $6UBMp.NavigationError).MissingProperty('appId');
    if (!environmentKey) throw (0, $6UBMp.NavigationError).MissingProperty('environmentKey');
    if (!key) throw (0, $6UBMp.NavigationError).MissingProperty('key');
    return {
        appId: appId,
        environmentKey: environmentKey,
        key: key
    };
};
const $b6b4f23189aabe31$export$7e2ccfc9450d6cc0 = {
    [(0, $9iaDP.BitbucketExtension).REPOSITORY_MAIN_MENU_PAGE]: (extension, { workspaceId: workspaceId, repositoryId: repositoryId })=>{
        const { appId: appId, environmentKey: environmentKey, key: key } = $b6b4f23189aabe31$var$getExtensionParams(extension);
        (0, $6UBMp.ensurePropertyExists)('workspaceId', workspaceId);
        (0, $6UBMp.ensurePropertyExists)('repositoryId', repositoryId);
        return (0, $glUKJ.ensureURLPath)(`/${workspaceId}/${repositoryId}/forge/${appId}/${environmentKey}/${key}`);
    },
    [(0, $9iaDP.BitbucketExtension).REPOSITORY_SETTINGS_MENU_PAGE]: (extension, { workspaceId: workspaceId, repositoryId: repositoryId })=>{
        const { appId: appId, environmentKey: environmentKey, key: key } = $b6b4f23189aabe31$var$getExtensionParams(extension);
        (0, $6UBMp.ensurePropertyExists)('workspaceId', workspaceId);
        (0, $6UBMp.ensurePropertyExists)('repositoryId', repositoryId);
        return (0, $glUKJ.ensureURLPath)(`/${workspaceId}/${repositoryId}/admin/forge/${appId}/${environmentKey}/${key}`);
    },
    [(0, $9iaDP.BitbucketExtension).PROJECT_SETTINGS_MENU_PAGE]: (extension, { workspaceId: workspaceId, projectKey: projectKey })=>{
        const { appId: appId, environmentKey: environmentKey, key: key } = $b6b4f23189aabe31$var$getExtensionParams(extension);
        (0, $6UBMp.ensurePropertyExists)('workspaceId', workspaceId);
        (0, $6UBMp.ensurePropertyExists)('projectKey', projectKey);
        return (0, $glUKJ.ensureURLPath)(`/${workspaceId}/workspace/projects/${projectKey}/settings/forge/${appId}/${environmentKey}/${key}`);
    },
    [(0, $9iaDP.BitbucketExtension).WORKSPACE_GLOBAL_PAGE]: (extension, { workspaceId: workspaceId })=>{
        const { appId: appId, environmentKey: environmentKey, key: key } = $b6b4f23189aabe31$var$getExtensionParams(extension);
        (0, $6UBMp.ensurePropertyExists)('workspaceId', workspaceId);
        return (0, $glUKJ.ensureURLPath)(`/${workspaceId}/workspace/forge/${appId}/${environmentKey}/${key}`);
    },
    [(0, $9iaDP.BitbucketExtension).WORKSPACE_PERSONAL_SETTINGS_PAGE]: (extension, { workspaceId: workspaceId })=>{
        const { appId: appId, environmentKey: environmentKey, key: key } = $b6b4f23189aabe31$var$getExtensionParams(extension);
        (0, $6UBMp.ensurePropertyExists)('workspaceId', workspaceId);
        return (0, $glUKJ.ensureURLPath)(`/${workspaceId}/workspace/personal-settings/forge/${appId}/${environmentKey}/${key}`);
    },
    [(0, $9iaDP.BitbucketExtension).WORKSPACE_SETTINGS_MENU_PAGE]: (extension, { workspaceId: workspaceId })=>{
        const { appId: appId, environmentKey: environmentKey, key: key } = $b6b4f23189aabe31$var$getExtensionParams(extension);
        (0, $6UBMp.ensurePropertyExists)('workspaceId', workspaceId);
        return (0, $glUKJ.ensureURLPath)(`/${workspaceId}/workspace/settings/forge/${appId}/${environmentKey}/${key}`);
    }
};
module.exports["bitbucketExtensionURLHelpers"] = $b6b4f23189aabe31$export$7e2ccfc9450d6cc0;

});

parcelRegister("ivMdx", function(module, exports) {

var $bLswh = parcelRequire("bLswh");


var $glUKJ = parcelRequire("glUKJ");


var $6UBMp = parcelRequire("6UBMp");

const $39184f6969b9d471$var$makeConfluenceURLPath = (0, $glUKJ.createMakeProductURLPath)('/wiki');
const $39184f6969b9d471$var$isCustomContentType = (contentType)=>contentType.startsWith('forge:');
const $39184f6969b9d471$export$68f051c1b56c060f = {
    [(0, $bLswh.ConfluenceExtension).FULL_PAGE]: ({ appId: appId, environmentId: environmentId, properties: properties })=>{
        const { routePrefix: routePrefix } = properties;
        if (!routePrefix) return null;
        return `/forge-apps/a/${appId}/e/${environmentId}/r/${routePrefix}`;
    },
    [(0, $bLswh.ConfluenceExtension).GLOBAL_PAGE]: ({ properties: properties, environmentId: environmentId, appId: appId })=>{
        const { route: route } = properties;
        if (appId && environmentId && route) return $39184f6969b9d471$var$makeConfluenceURLPath(`/apps/${appId}/${environmentId}/${route}`);
        return null;
    },
    [(0, $bLswh.ConfluenceExtension).GLOBAL_SETTINGS]: ({ id: id })=>$39184f6969b9d471$var$makeConfluenceURLPath('/admin/forge', {
            id: id
        }),
    [(0, $bLswh.ConfluenceExtension).SPACE_PAGE]: ({ properties: properties, environmentId: environmentId, appId: appId }, { spaceKey: spaceKey })=>{
        const { route: route } = properties;
        if (route && environmentId && appId) return $39184f6969b9d471$var$makeConfluenceURLPath(`/spaces/${(0, $6UBMp.ensurePropertyExists)('spaceKey', spaceKey)}/apps/${appId}/${environmentId}/${route}`);
        return null;
    },
    [(0, $bLswh.ConfluenceExtension).SPACE_SETTINGS]: ({ properties: properties, appId: appId, environmentId: environmentId }, { spaceKey: spaceKey })=>{
        const { route: route } = properties;
        if (!spaceKey) throw (0, $6UBMp.NavigationError).MissingProperty('spaceKey');
        if (route && environmentId && appId) return $39184f6969b9d471$var$makeConfluenceURLPath(`/spaces/${(0, $6UBMp.ensurePropertyExists)('spaceKey', spaceKey)}/settings/apps/${appId}/${environmentId}/${route}`);
        return null;
    }
};
const $39184f6969b9d471$export$f91bdc214ca5389d = {
    contentView: async ({ contentId: contentId, version: version })=>{
        if (!contentId) throw (0, $6UBMp.NavigationError).MissingProperty('contentId');
        let resp = null;
        try {
            resp = await fetch(`/wiki/rest/api/content/${contentId}`);
        } catch (e) {
            throw (0, $6UBMp.NavigationError).FailedToFetchContentInfo(contentId);
        }
        const { id: id, type: type, _links: { webui: webui } } = await resp.json();
        // if version is provided, we should use it, however, it only works for none-custom content type
        if (version && version >= 0) {
            if ($39184f6969b9d471$var$isCustomContentType(type)) throw new Error('Version is not supported for custom content type');
            return $39184f6969b9d471$var$makeConfluenceURLPath('/pages/viewpage.action', {
                pageId: id,
                pageVersion: `${version}`
            });
        } else if (webui) return $39184f6969b9d471$var$makeConfluenceURLPath(webui);
        throw (0, $6UBMp.NavigationError).LinkForContentNotFound(contentId);
    },
    contentEdit: async ({ contentId: contentId })=>{
        let resp;
        try {
            resp = await fetch(`/wiki/rest/api/content/${contentId}`);
        } catch (e) {
            throw (0, $6UBMp.NavigationError).FailedToFetchContentInfo(contentId);
        }
        const { _links: { edituiv2: edituiv2 } } = await resp.json();
        // content with custom content type doesn't have edit link
        if (edituiv2) return $39184f6969b9d471$var$makeConfluenceURLPath(edituiv2);
        throw (0, $6UBMp.NavigationError).LinkForContentNotFound(contentId);
    },
    spaceView: async ({ spaceKey: spaceKey })=>{
        return $39184f6969b9d471$var$makeConfluenceURLPath(`/spaces/${(0, $6UBMp.ensurePropertyExists)('spaceKey', spaceKey)}`);
    },
    contentList: async (params, { getAppForgeUIExtensions: getAppForgeUIExtensions })=>{
        const { contentType: contentType } = params;
        if (!contentType) throw (0, $6UBMp.NavigationError).MissingProperty('contentType');
        if (contentType === 'customContent' && params.moduleKey) {
            const { moduleKey: moduleKey } = params;
            const module = await (0, $6UBMp.getModuleByKey)(getAppForgeUIExtensions, moduleKey);
            if (!module) throw (0, $6UBMp.NavigationError).ModuleNotFound(moduleKey);
            const { appId: appId, environmentId: environmentId } = module;
            if (appId && environmentId) return $39184f6969b9d471$var$makeConfluenceURLPath('/search', {
                type: `forge:${appId}:${environmentId}:${moduleKey}`
            });
        } else if (contentType === 'page' && params.spaceKey) return $39184f6969b9d471$var$makeConfluenceURLPath(`/spaces/${params.spaceKey}/pages`);
        else if (contentType === 'blogpost' && params.spaceKey) return $39184f6969b9d471$var$makeConfluenceURLPath(`/spaces/${params.spaceKey}/blogs`);
        throw (0, $6UBMp.NavigationError).InvalidValueForProperty('contentType', contentType);
    }
};
module.exports["confluenceExtensionURLHelpers"] = $39184f6969b9d471$export$68f051c1b56c060f;
module.exports["confluenceNavigationTargetURLHelpers"] = $39184f6969b9d471$export$f91bdc214ca5389d;

});

parcelRegister("6UBMp", function(module, exports) {
const $2f1f073e4bf4a085$export$c1f2bec49c0b084d = async (getAppForgeUIExtensions, moduleKey)=>{
    const { extensions: extensions } = await getAppForgeUIExtensions({
        expandAppOwner: false
    });
    const module = extensions?.find(({ key: key })=>key === moduleKey);
    return module?.type ? module : null;
};
const $2f1f073e4bf4a085$export$c53ed1333d39ada3 = {
    ModuleNotFound: (moduleKey)=>{
        return new Error(`Navigation failed: Module with moduleKey ${moduleKey} was not found`);
    },
    MissingProperty: (property)=>{
        return new Error(`Navigation failed: ${property} not provided`);
    },
    FailedToFetchContentInfo: (contentId)=>{
        return new Error(`Navigation failed: Failed to fetch content information with id ${contentId}. Please check if the ID provided is correct`);
    },
    NotSupportedExtensionType: (moduleType)=>{
        return new Error(`Navigation failed: Module type ${moduleType} is not supported`);
    },
    InvalidValueForProperty: (property, value)=>{
        return new Error(`Navigation failed: ${value} is not a valid value for ${property}`);
    },
    LinkForContentNotFound: (contentId)=>{
        return new Error(`Navigation failed: Link for content with id ${contentId} was not found`);
    }
};
const $2f1f073e4bf4a085$export$ae701e18d3b38cae = (propertyName, propertyValue)=>{
    if (propertyValue === undefined || propertyValue === null) throw $2f1f073e4bf4a085$export$c53ed1333d39ada3.MissingProperty(propertyName);
    return propertyValue;
};
module.exports["getModuleByKey"] = $2f1f073e4bf4a085$export$c1f2bec49c0b084d;
module.exports["NavigationError"] = $2f1f073e4bf4a085$export$c53ed1333d39ada3;
module.exports["ensurePropertyExists"] = $2f1f073e4bf4a085$export$ae701e18d3b38cae;

});

parcelRegister("42HAj", function(module, exports) {

var $bLswh = parcelRequire("bLswh");


var $glUKJ = parcelRequire("glUKJ");


var $6UBMp = parcelRequire("6UBMp");

const $818bfc45dc84dd2f$var$makeJiraURLPath = (0, $glUKJ.createMakeProductURLPath)('/jira');
const $818bfc45dc84dd2f$var$PROJECT_TYPE_SEGMENT_MAP = {
    software: 'software',
    business: 'core',
    service_desk: 'servicedesk'
};
const $818bfc45dc84dd2f$var$projectTypeSegmentCache = new Map();
const $818bfc45dc84dd2f$export$8901d41959b1b84d = ()=>$818bfc45dc84dd2f$var$projectTypeSegmentCache.clear();
const $818bfc45dc84dd2f$var$resolveJiraProjectTypeSegment = async (projectKey)=>{
    const cached = $818bfc45dc84dd2f$var$projectTypeSegmentCache.get(projectKey);
    if (cached) return cached;
    try {
        const resp = await fetch(`/rest/api/3/project/${projectKey}`);
        const { projectTypeKey: projectTypeKey } = await resp.json();
        const segment = $818bfc45dc84dd2f$var$PROJECT_TYPE_SEGMENT_MAP[projectTypeKey];
        if (segment) {
            $818bfc45dc84dd2f$var$projectTypeSegmentCache.set(projectKey, segment);
            return segment;
        }
        // eslint-disable-next-line no-console
        console.warn(`Navigation: Unknown project type key "${projectTypeKey}" for "${projectKey}"`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Navigation: Failed to resolve project type for "${projectKey}"`, e);
    }
    // default to software segment if we fail to resolve the project type, this ensure backwards compatibility with the existing apps
    return 'software';
};
const $818bfc45dc84dd2f$export$47842863b73e9046 = {
    [(0, $bLswh.JiraExtension).FULL_PAGE]: ({ appId: appId, environmentId: environmentId, properties: properties })=>{
        const { routePrefix: routePrefix } = properties;
        if (!routePrefix) return null;
        return `/forge-apps/a/${appId}/e/${environmentId}/r/${routePrefix}`;
    },
    [(0, $bLswh.JiraExtension).ADMIN_PAGE]: ({ appId: appId, environmentId: environmentId, properties: properties })=>{
        const { useAsGetStarted: useAsGetStarted, useAsConfig: useAsConfig } = properties;
        if (useAsGetStarted) return $818bfc45dc84dd2f$var$makeJiraURLPath(`/settings/apps/get-started/${appId}/${environmentId}`);
        if (useAsConfig) return $818bfc45dc84dd2f$var$makeJiraURLPath(`/settings/apps/configure/${appId}/${environmentId}`);
        return $818bfc45dc84dd2f$var$makeJiraURLPath(`/settings/apps/${appId}/${environmentId}`);
    },
    [(0, $bLswh.JiraExtension).GLOBAL_PAGE]: ({ appId: appId, environmentId: environmentId })=>{
        return $818bfc45dc84dd2f$var$makeJiraURLPath(`/apps/${appId}/${environmentId}`);
    },
    [(0, $bLswh.JiraExtension).PERSONAL_SETTINGS_PAGE]: ({ appId: appId, environmentId: environmentId })=>{
        return $818bfc45dc84dd2f$var$makeJiraURLPath(`/settings/personal/apps/${appId}/${environmentId}`);
    },
    [(0, $bLswh.JiraExtension).PROJECT_SETTINGS_PAGE]: async ({ appId: appId, environmentId: environmentId }, { projectKey: projectKey })=>{
        const validatedKey = (0, $6UBMp.ensurePropertyExists)('projectKey', projectKey).toUpperCase();
        const segment = await $818bfc45dc84dd2f$var$resolveJiraProjectTypeSegment(validatedKey);
        return $818bfc45dc84dd2f$var$makeJiraURLPath(`/${segment}/projects/${validatedKey}/settings/apps/${appId}/${environmentId}`);
    },
    [(0, $bLswh.JiraExtension).PROJECT_PAGE]: async ({ appId: appId, environmentId: environmentId }, { projectKey: projectKey })=>{
        const validatedKey = (0, $6UBMp.ensurePropertyExists)('projectKey', projectKey).toUpperCase();
        const segment = await $818bfc45dc84dd2f$var$resolveJiraProjectTypeSegment(validatedKey);
        return $818bfc45dc84dd2f$var$makeJiraURLPath(`/${segment}/projects/${validatedKey}/apps/${appId}/${environmentId}`);
    }
};
const $818bfc45dc84dd2f$export$ca7043166c283e6d = {
    dashboard: async ({ dashboardId: dashboardId })=>{
        return $818bfc45dc84dd2f$var$makeJiraURLPath(`/dashboards/${(0, $6UBMp.ensurePropertyExists)('dashboardId', dashboardId)}`);
    },
    issue: async ({ issueKey: issueKey })=>{
        return `/browse/${(0, $6UBMp.ensurePropertyExists)('issueKey', issueKey)}`;
    },
    // equivalent to Connects projectAdminSummary target
    projectSettingsDetails: async ({ projectKey: projectKey })=>{
        const validatedKey = (0, $6UBMp.ensurePropertyExists)('projectKey', projectKey).toUpperCase();
        const segment = await $818bfc45dc84dd2f$var$resolveJiraProjectTypeSegment(validatedKey);
        return $818bfc45dc84dd2f$var$makeJiraURLPath(`/${segment}/projects/${validatedKey}/settings/details`);
    }
};
module.exports["jiraExtensionURLHelpers"] = $818bfc45dc84dd2f$export$47842863b73e9046;
module.exports["jiraNavigationTargetHandlers"] = $818bfc45dc84dd2f$export$ca7043166c283e6d;

});

parcelRegister("jGJD6", function(module, exports) {

var $9iaDP = parcelRequire("9iaDP");

const $fa9918cf1f9ed131$export$95ff2a2eb9aef90c = {
    [(0, $9iaDP.GlobalExtension).FULL_PAGE]: ({ installationId: installationId, properties: properties })=>{
        const { routePrefix: routePrefix } = properties;
        if (!routePrefix || !installationId) return null;
        return `/apps/full-page/${installationId}/${routePrefix}`;
    },
    [(0, $9iaDP.GlobalExtension).GLOBAL_UI]: ({ installationId: installationId })=>{
        if (!installationId) return null;
        return `/apps/${installationId}`;
    }
};
module.exports["globalExtensionURLHelpers"] = $fa9918cf1f9ed131$export$95ff2a2eb9aef90c;

});

parcelRegister("glUKJ", function(module, exports) {
// Ensures that the path structured correctly and adds provided parameters to the path
const $e808f6c710132dcc$export$26e2379e0018d084 = (path, parameters)=>{
    let encodedPath = (path ?? '').split('/').map(encodeURIComponent).join('/');
    if (parameters && Object.keys(parameters).length > 0) encodedPath += '?' + new URLSearchParams(parameters).toString();
    return encodedPath;
};
const $e808f6c710132dcc$export$ab31bc7dd6e328ce = (productPathPrefix)=>(path, parameters)=>{
        return $e808f6c710132dcc$export$26e2379e0018d084(path ? productPathPrefix + path : productPathPrefix, parameters);
    };
module.exports["ensureURLPath"] = $e808f6c710132dcc$export$26e2379e0018d084;
module.exports["createMakeProductURLPath"] = $e808f6c710132dcc$export$ab31bc7dd6e328ce;

});

parcelRegister("bmXU6", function(module, exports) {
/**
 * @generated SignedSource<<708c1bbd91c0ce7794de647ad883ea2d>>
 * @relayHash a8d997cf9f56d7a9bc9c3a4673a4ab05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 392e69b59b157550f874185ece3f2558dca2cfd138ebbca83e163ba479f415b2
const $86bd72e4634545c8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRovoEnabled"
            }
        ],
        "type": "AtlassianStudioUserSiteContextOutput"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getIsRovoEnabledQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getIsRovoEnabledQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "392e69b59b157550f874185ece3f2558dca2cfd138ebbca83e163ba479f415b2",
            "metadata": {},
            "name": "getIsRovoEnabledQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$86bd72e4634545c8$var$node.hash = "4e6658c9c4fce21189d6b3b9b3b4e535";
var $86bd72e4634545c8$export$2e2bcd8739ae039 = $86bd72e4634545c8$var$node;
module.exports["default"] = $86bd72e4634545c8$export$2e2bcd8739ae039;

});

parcelRegister("dlclU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7aRdF = parcelRequire("7aRdF");


var $aRGok = parcelRequire("aRGok");


var $eQiT1 = parcelRequire("eQiT1");


var $fEPJS = parcelRequire("fEPJS");


var $jq995 = parcelRequire("jq995");


var $9Umtx = parcelRequire("9Umtx");


var $ad7Ou = parcelRequire("ad7Ou");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $kSwu1 = parcelRequire("kSwu1");

const $8a22379f2fed28a1$export$9dd6ff9ea0189349 = {
    titleContainer: "_1DCdHiVa5s",
    modalFooterContainer: "_2IVJ4M6wH8 _22sfPnNvrM _3zygPU9r67",
    disclaimerContainer: "_313842Va5s _1DCdHiVa5s",
    rowContainer: "_0Of8r22ADO _1wydGW2ADO _1Znuxb2ADO _2Zuz6Q2ADO _3BoeID6wH8 _3hhsrrNvrM _3XVgLM9r67"
};
const $8a22379f2fed28a1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    declineButtonLabel: {
        id: "forge-ui.adminConsentModal.decline.button.label",
        defaultMessage: "Decline"
    },
    approveButtonLabel: {
        id: "forge-ui.adminConsentModal.approve.button.label",
        defaultMessage: "Approve"
    },
    noticeForMoreDetails: {
        id: "forge-ui.adminConsentModal.notice.for-more-details",
        defaultMessage: "For more details, refer to {appName}'s"
    },
    noticeAnd: {
        id: "forge-ui.adminConsentModal.notice.and",
        defaultMessage: "and"
    },
    termsOfUseLink: {
        id: "forge-ui.adminConsentModal.terms-of-use.link",
        defaultMessage: "terms of use"
    },
    privacyPolicyLink: {
        id: "forge-ui.adminConsentModal.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    modalTransitionTitle: {
        id: "forge-ui.adminConsentModal.modal-transition.title",
        defaultMessage: "Data storage, sharing, receiving and processing"
    },
    modalTransitionText: {
        id: "forge-ui.adminConsentModal.modal-transition.text",
        defaultMessage: "{appName} is requesting to share with and receive data from the following domains:"
    },
    confirmErrorMessage: {
        id: "forge-ui.adminConsentModal.confirm-error.message",
        defaultMessage: "Something went wrong. Please try again or decline."
    },
    egressFetchBackendSide: {
        id: "forge-ui.adminConsentModal.egress.fetch-backend-side",
        defaultMessage: "Fetch backend side"
    },
    egressFetchClientSide: {
        id: "forge-ui.adminConsentModal.egress.fetch-client-side",
        defaultMessage: "Fetch client side"
    },
    egressFonts: {
        id: "forge-ui.adminConsentModal.egress.fonts",
        defaultMessage: "Fonts"
    },
    egressFrames: {
        id: "forge-ui.adminConsentModal.egress.frames",
        defaultMessage: "Frames"
    },
    egressImages: {
        id: "forge-ui.adminConsentModal.egress.images",
        defaultMessage: "Images"
    },
    egressMedia: {
        id: "forge-ui.adminConsentModal.egress.media",
        defaultMessage: "Media"
    },
    egressNavigation: {
        id: "forge-ui.adminConsentModal.egress.navigation",
        defaultMessage: "Navigation"
    },
    egressScripts: {
        id: "forge-ui.adminConsentModal.egress.scripts",
        defaultMessage: "Scripts"
    },
    egressStyles: {
        id: "forge-ui.adminConsentModal.egress.styles",
        defaultMessage: "Styles"
    },
    egressDefault: {
        id: "forge-ui.adminConsentModal.egress.default",
        defaultMessage: "Egress"
    },
    remoteFallbackHeading: {
        id: "forge-ui.adminConsentModal.remote.fallback-heading",
        defaultMessage: "Remote"
    },
    remoteResetToDefault: {
        id: "forge-ui.adminConsentModal.remote.reset-to-default",
        defaultMessage: "This remote is being reset to the default value"
    }
});
const $8a22379f2fed28a1$export$24cbef36aabf5e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { modalState: modalState } = t0;
    const intl = (0, $kSwu1.useIntl)();
    if (modalState.state === "closed") {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null);
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    let t1;
    if ($[1] !== intl || $[2] !== modalState.onCancel || $[3] !== modalState.onConfirm) {
        t1 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $8a22379f2fed28a1$export$9dd6ff9ea0189349.modalFooterContainer
            }, /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                space: "space.075"
            }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                onClick: modalState.onCancel
            }, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.declineButtonLabel)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                onClick: modalState.onConfirm,
                appearance: "primary"
            }, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.approveButtonLabel)))));
        $[1] = intl;
        $[2] = modalState.onCancel;
        $[3] = modalState.onConfirm;
        $[4] = t1;
    } else t1 = $[4];
    const ModalFooter = t1;
    let t2;
    if ($[5] !== modalState.domainInfo) {
        t2 = ()=>{
            const getHumanReadableName = $8a22379f2fed28a1$var$_temp;
            const domainInfo = modalState.domainInfo;
            if (Object.keys(domainInfo).length === 0) return null;
            if (domainInfo.type === "REMOTE") return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
                direction: "column",
                gap: "space.150"
            }, domainInfo.payload.remotes.map((r)=>{
                const manifestRemoteInfo = domainInfo.manifestRemoteMap[r.key];
                return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                    key: r.key,
                    space: "space.150"
                }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
                    size: "small"
                }, manifestRemoteInfo ? manifestRemoteInfo.description : "Remote"), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                    xcss: $8a22379f2fed28a1$export$9dd6ff9ea0189349.rowContainer,
                    spread: "space-between",
                    grow: "fill"
                }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, r.configured.endpoint === null ? "This remote is being reset to the default value" : r.configured.endpoint), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, manifestRemoteInfo ? manifestRemoteInfo.name : null)));
            }));
            if (domainInfo.type === "EGRESS") return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
                direction: "column",
                gap: "space.150"
            }, domainInfo.payload.egresses.map((e)=>/*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                    key: e.key,
                    space: "space.150"
                }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
                    size: "xsmall"
                }, e.description), e.configured.map((c)=>c.type.map((t)=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                            xcss: $8a22379f2fed28a1$export$9dd6ff9ea0189349.rowContainer,
                            spread: "space-between",
                            grow: "fill"
                        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, c.domain), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, getHumanReadableName(t))))))));
        };
        $[5] = modalState.domainInfo;
        $[6] = t2;
    } else t2 = $[6];
    const renderDomains = t2;
    let t3;
    if ($[7] !== intl || $[8] !== modalState) {
        t3 = ()=>{
            const { appName: appName, termsOfUseLink: termsOfUseLink, privacyPolicyLink: privacyPolicyLink } = modalState;
            if (termsOfUseLink && privacyPolicyLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.noticeForMoreDetails, {
                appName: appName ?? "the app"
            }), " ", /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                href: termsOfUseLink
            }, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.termsOfUseLink)), " ", intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.noticeAnd), " ", /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                href: privacyPolicyLink
            }, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.privacyPolicyLink)));
            else {
                if (termsOfUseLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.noticeForMoreDetails, {
                    appName: appName ?? "the app"
                }), " ", /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                    href: termsOfUseLink
                }, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.termsOfUseLink)));
                else {
                    if (privacyPolicyLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.noticeForMoreDetails, {
                        appName: appName ?? "the app"
                    }), " ", /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                        href: privacyPolicyLink
                    }, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.privacyPolicyLink)));
                }
            }
        };
        $[7] = intl;
        $[8] = modalState;
        $[9] = t3;
    } else t3 = $[9];
    const Notice = t3;
    let t4;
    if ($[10] !== modalState) {
        t4 = ()=>{
            modalState.onCancel();
        };
        $[10] = modalState;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== intl) {
        t5 = intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.modalTransitionTitle);
        $[12] = intl;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $8a22379f2fed28a1$export$9dd6ff9ea0189349.titleContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, t5)));
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== intl || $[17] !== modalState.appName) {
        t7 = intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.modalTransitionText, {
            appName: modalState.appName ?? "The app"
        });
        $[16] = intl;
        $[17] = modalState.appName;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, t7);
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== renderDomains) {
        t9 = renderDomains();
        $[21] = renderDomains;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== Notice) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $8a22379f2fed28a1$export$9dd6ff9ea0189349.disclaimerContainer
        }, /*#__PURE__*/ $cozmU.createElement(Notice, null));
        $[23] = Notice;
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    if ($[25] !== t10 || $[26] !== t9) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, t9, t10);
        $[25] = t10;
        $[26] = t9;
        $[27] = t11;
    } else t11 = $[27];
    let t12;
    if ($[28] !== t11 || $[29] !== t8) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.300"
        }, t8, t11));
        $[28] = t11;
        $[29] = t8;
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== ModalFooter) {
        t13 = /*#__PURE__*/ $cozmU.createElement(ModalFooter, null);
        $[31] = ModalFooter;
        $[32] = t13;
    } else t13 = $[32];
    let t14;
    if ($[33] !== t12 || $[34] !== t13 || $[35] !== t4 || $[36] !== t6) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
            onClose: t4,
            width: "large"
        }, t6, t12, t13));
        $[33] = t12;
        $[34] = t13;
        $[35] = t4;
        $[36] = t6;
        $[37] = t14;
    } else t14 = $[37];
    return t14;
} : ({ modalState: modalState })=>{
    const intl = (0, $kSwu1.useIntl)();
    if (modalState.state === 'closed') return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null);
    const ModalFooter = ()=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $8a22379f2fed28a1$export$9dd6ff9ea0189349.modalFooterContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.075"
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            onClick: modalState.onCancel
        }, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.declineButtonLabel)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            onClick: modalState.onConfirm,
            appearance: "primary"
        }, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.approveButtonLabel)))));
    };
    const renderDomains = ()=>{
        const getHumanReadableName = (operation)=>{
            switch(operation){
                case 'FETCH_BACKEND_SIDE':
                    return 'Fetch backend side';
                case 'FETCH_CLIENT_SIDE':
                    return 'Fetch client side';
                case 'FONTS':
                    return 'Fonts';
                case 'FRAMES':
                    return 'Frames';
                case 'IMAGES':
                    return 'Images';
                case 'MEDIA':
                    return 'Media';
                case 'NAVIGATION':
                    return 'Navigation';
                case 'SCRIPTS':
                    return 'Scripts';
                case 'STYLES':
                    return 'Styles';
                default:
                    return 'Egress';
            }
        };
        const domainInfo = modalState.domainInfo;
        if (Object.keys(domainInfo).length === 0) return null;
        if (domainInfo.type === 'REMOTE') return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.remotes.map((r)=>{
            const manifestRemoteInfo = domainInfo.manifestRemoteMap[r.key];
            return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                key: r.key,
                space: "space.150"
            }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
                size: "small"
            }, manifestRemoteInfo ? manifestRemoteInfo.description : 'Remote'), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                xcss: $8a22379f2fed28a1$export$9dd6ff9ea0189349.rowContainer,
                spread: "space-between",
                grow: "fill"
            }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, r.configured.endpoint === null ? 'This remote is being reset to the default value' : r.configured.endpoint), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, manifestRemoteInfo ? manifestRemoteInfo.name : null)));
        }));
        if (domainInfo.type === 'EGRESS') return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.egresses.map((e)=>/*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                key: e.key,
                space: "space.150"
            }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
                size: "xsmall"
            }, e.description), e.configured.map((c)=>{
                return c.type.map((t)=>{
                    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                        xcss: $8a22379f2fed28a1$export$9dd6ff9ea0189349.rowContainer,
                        spread: "space-between",
                        grow: "fill"
                    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, c.domain), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, getHumanReadableName(t)));
                });
            }))));
    };
    const Notice = ()=>{
        const { appName: appName, termsOfUseLink: termsOfUseLink, privacyPolicyLink: privacyPolicyLink } = modalState;
        if (termsOfUseLink && privacyPolicyLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.noticeForMoreDetails, {
            appName: appName ?? 'the app'
        }), ' ', /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: termsOfUseLink
        }, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.termsOfUseLink)), ' ', intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.noticeAnd), ' ', /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: privacyPolicyLink
        }, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.privacyPolicyLink)));
        else if (termsOfUseLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.noticeForMoreDetails, {
            appName: appName ?? 'the app'
        }), ' ', /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: termsOfUseLink
        }, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.termsOfUseLink)));
        else if (privacyPolicyLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.noticeForMoreDetails, {
            appName: appName ?? 'the app'
        }), ' ', /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: privacyPolicyLink
        }, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.privacyPolicyLink)));
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: ()=>{
            modalState.onCancel();
        },
        width: "large"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $8a22379f2fed28a1$export$9dd6ff9ea0189349.titleContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.modalTransitionTitle)))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage($8a22379f2fed28a1$export$defe85febe8b728c.modalTransitionText, {
        appName: modalState.appName ?? 'The app'
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, renderDomains(), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $8a22379f2fed28a1$export$9dd6ff9ea0189349.disclaimerContainer
    }, /*#__PURE__*/ $cozmU.createElement(Notice, null))))), /*#__PURE__*/ $cozmU.createElement(ModalFooter, null)));
};
function $8a22379f2fed28a1$var$_temp(operation) {
    switch(operation){
        case "FETCH_BACKEND_SIDE":
            return "Fetch backend side";
        case "FETCH_CLIENT_SIDE":
            return "Fetch client side";
        case "FONTS":
            return "Fonts";
        case "FRAMES":
            return "Frames";
        case "IMAGES":
            return "Images";
        case "MEDIA":
            return "Media";
        case "NAVIGATION":
            return "Navigation";
        case "SCRIPTS":
            return "Scripts";
        case "STYLES":
            return "Styles";
        default:
            return "Egress";
    }
}
module.exports["styles"] = $8a22379f2fed28a1$export$9dd6ff9ea0189349;
module.exports["messages"] = $8a22379f2fed28a1$export$defe85febe8b728c;
module.exports["AdminModal"] = $8a22379f2fed28a1$export$24cbef36aabf5e56;

});

parcelRegister("aYo0f", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7aRdF = parcelRequire("7aRdF");


var $aRGok = parcelRequire("aRGok");


var $eQiT1 = parcelRequire("eQiT1");


var $fEPJS = parcelRequire("fEPJS");


var $jq995 = parcelRequire("jq995");


var $9Umtx = parcelRequire("9Umtx");


var $ad7Ou = parcelRequire("ad7Ou");


var $1VhsF = parcelRequire("1VhsF");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $dlclU = parcelRequire("dlclU");


var $kSwu1 = parcelRequire("kSwu1");

const $1a69ef1c2fde52fe$var$getHumanReadableMessage = (operation)=>{
    switch(operation){
        case 'FETCH_BACKEND_SIDE':
            return (0, $dlclU.messages).egressFetchBackendSide;
        case 'FETCH_CLIENT_SIDE':
            return (0, $dlclU.messages).egressFetchClientSide;
        case 'FONTS':
            return (0, $dlclU.messages).egressFonts;
        case 'FRAMES':
            return (0, $dlclU.messages).egressFrames;
        case 'IMAGES':
            return (0, $dlclU.messages).egressImages;
        case 'MEDIA':
            return (0, $dlclU.messages).egressMedia;
        case 'NAVIGATION':
            return (0, $dlclU.messages).egressNavigation;
        case 'SCRIPTS':
            return (0, $dlclU.messages).egressScripts;
        case 'STYLES':
            return (0, $dlclU.messages).egressStyles;
        default:
            return (0, $dlclU.messages).egressDefault;
    }
};
const $1a69ef1c2fde52fe$export$a7839a1d0a383d1f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { appName: appName, domainInfo: domainInfo, onCancel: onCancel, onConfirm: onConfirm, termsOfUseLink: termsOfUseLink, privacyPolicyLink: privacyPolicyLink } = t0;
    const [isModalVisible, setIsModalVisible] = (0, $cozmU.useState)(true);
    const [isApproving, setIsApproving] = (0, $cozmU.useState)(false);
    const [hasApproveError, setHasApproveError] = (0, $cozmU.useState)(false);
    const isSubmittingRef = (0, $cozmU.useRef)(false);
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== isApproving || $[1] !== onCancel) {
        t1 = ()=>{
            if (isApproving || isSubmittingRef.current) return;
            isSubmittingRef.current = true;
            setIsModalVisible(false);
            onCancel();
        };
        $[0] = isApproving;
        $[1] = onCancel;
        $[2] = t1;
    } else t1 = $[2];
    const handleCancel = t1;
    let t2;
    if ($[3] !== onConfirm) {
        t2 = async ()=>{
            if (isSubmittingRef.current) return;
            isSubmittingRef.current = true;
            setIsApproving(true);
            setHasApproveError(false);
            try {
                await onConfirm();
                setIsModalVisible(false);
            } catch  {
                isSubmittingRef.current = false;
                setHasApproveError(true);
                setIsApproving(false);
            }
        };
        $[3] = onConfirm;
        $[4] = t2;
    } else t2 = $[4];
    const handleConfirm = t2;
    let t3;
    if ($[5] !== domainInfo.manifestRemoteMap || $[6] !== domainInfo.payload.egresses || $[7] !== domainInfo.payload.remotes || $[8] !== domainInfo.type || $[9] !== intl) {
        t3 = ()=>{
            if (domainInfo.type === "REMOTE") return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
                direction: "column",
                gap: "space.150"
            }, domainInfo.payload.remotes.map((r)=>{
                const manifestRemoteInfo = domainInfo.manifestRemoteMap[r.key];
                return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                    key: r.key,
                    space: "space.150"
                }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
                    size: "small"
                }, manifestRemoteInfo ? manifestRemoteInfo.description : intl.formatMessage((0, $dlclU.messages).remoteFallbackHeading)), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                    xcss: (0, $dlclU.styles).rowContainer,
                    spread: "space-between",
                    grow: "fill"
                }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, r.configured.endpoint === null ? intl.formatMessage((0, $dlclU.messages).remoteResetToDefault) : r.configured.endpoint), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, manifestRemoteInfo ? manifestRemoteInfo.name : null)));
            }));
            return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
                direction: "column",
                gap: "space.150"
            }, domainInfo.payload.egresses.map((e)=>/*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                    key: e.key,
                    space: "space.150"
                }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
                    size: "xsmall"
                }, e.description), e.configured.map((c)=>c.type.map((t)=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                            key: t,
                            xcss: (0, $dlclU.styles).rowContainer,
                            spread: "space-between",
                            grow: "fill"
                        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, c.domain), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage($1a69ef1c2fde52fe$var$getHumanReadableMessage(t)))))))));
        };
        $[5] = domainInfo.manifestRemoteMap;
        $[6] = domainInfo.payload.egresses;
        $[7] = domainInfo.payload.remotes;
        $[8] = domainInfo.type;
        $[9] = intl;
        $[10] = t3;
    } else t3 = $[10];
    const renderDomains = t3;
    let t4;
    if ($[11] !== appName || $[12] !== intl || $[13] !== privacyPolicyLink || $[14] !== termsOfUseLink) {
        t4 = ()=>{
            if (termsOfUseLink && privacyPolicyLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).noticeForMoreDetails, {
                appName: appName
            }), " ", /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                href: termsOfUseLink
            }, intl.formatMessage((0, $dlclU.messages).termsOfUseLink)), " ", intl.formatMessage((0, $dlclU.messages).noticeAnd), " ", /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                href: privacyPolicyLink
            }, intl.formatMessage((0, $dlclU.messages).privacyPolicyLink)));
            if (termsOfUseLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).noticeForMoreDetails, {
                appName: appName
            }), " ", /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                href: termsOfUseLink
            }, intl.formatMessage((0, $dlclU.messages).termsOfUseLink)));
            if (privacyPolicyLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).noticeForMoreDetails, {
                appName: appName
            }), " ", /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                href: privacyPolicyLink
            }, intl.formatMessage((0, $dlclU.messages).privacyPolicyLink)));
            return null;
        };
        $[11] = appName;
        $[12] = intl;
        $[13] = privacyPolicyLink;
        $[14] = termsOfUseLink;
        $[15] = t4;
    } else t4 = $[15];
    const Notice = t4;
    let t5;
    if ($[16] !== handleCancel || $[17] !== handleConfirm || $[18] !== intl || $[19] !== isApproving) {
        t5 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: (0, $dlclU.styles).modalFooterContainer
            }, /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                space: "space.075"
            }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                onClick: handleCancel,
                isDisabled: isApproving
            }, intl.formatMessage((0, $dlclU.messages).declineButtonLabel)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                onClick: handleConfirm,
                appearance: "primary",
                isDisabled: isApproving,
                isLoading: isApproving
            }, intl.formatMessage((0, $dlclU.messages).approveButtonLabel)))));
        $[16] = handleCancel;
        $[17] = handleConfirm;
        $[18] = intl;
        $[19] = isApproving;
        $[20] = t5;
    } else t5 = $[20];
    const ModalFooter = t5;
    let t6;
    if ($[21] !== ModalFooter || $[22] !== Notice || $[23] !== appName || $[24] !== handleCancel || $[25] !== hasApproveError || $[26] !== intl || $[27] !== isModalVisible || $[28] !== renderDomains) {
        t6 = isModalVisible && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
            onClose: handleCancel,
            width: "large"
        }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $dlclU.styles).titleContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, intl.formatMessage((0, $dlclU.messages).modalTransitionTitle)))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.300"
        }, hasApproveError && /*#__PURE__*/ $cozmU.createElement((0, $1VhsF.default), {
            appearance: "error"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).confirmErrorMessage))), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).modalTransitionText, {
            appName: appName
        })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, renderDomains(), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $dlclU.styles).disclaimerContainer
        }, /*#__PURE__*/ $cozmU.createElement(Notice, null))))), /*#__PURE__*/ $cozmU.createElement(ModalFooter, null));
        $[21] = ModalFooter;
        $[22] = Notice;
        $[23] = appName;
        $[24] = handleCancel;
        $[25] = hasApproveError;
        $[26] = intl;
        $[27] = isModalVisible;
        $[28] = renderDomains;
        $[29] = t6;
    } else t6 = $[29];
    let t7;
    if ($[30] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, t6);
        $[30] = t6;
        $[31] = t7;
    } else t7 = $[31];
    return t7;
} : ({ appName: appName, domainInfo: domainInfo, onCancel: onCancel, onConfirm: onConfirm, termsOfUseLink: termsOfUseLink, privacyPolicyLink: privacyPolicyLink })=>{
    const [isModalVisible, setIsModalVisible] = (0, $cozmU.useState)(true);
    const [isApproving, setIsApproving] = (0, $cozmU.useState)(false);
    const [hasApproveError, setHasApproveError] = (0, $cozmU.useState)(false);
    const isSubmittingRef = (0, $cozmU.useRef)(false);
    const intl = (0, $kSwu1.useIntl)();
    const handleCancel = ()=>{
        if (isApproving || isSubmittingRef.current) return;
        isSubmittingRef.current = true;
        setIsModalVisible(false);
        onCancel();
    };
    const handleConfirm = async ()=>{
        if (isSubmittingRef.current) return;
        isSubmittingRef.current = true;
        setIsApproving(true);
        setHasApproveError(false);
        try {
            await onConfirm();
            setIsModalVisible(false);
        } catch  {
            // API failed — re-enable so the user can retry or decline
            isSubmittingRef.current = false;
            setHasApproveError(true);
            setIsApproving(false);
        }
    };
    const renderDomains = ()=>{
        if (domainInfo.type === 'REMOTE') return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.remotes.map((r)=>{
            const manifestRemoteInfo = domainInfo.manifestRemoteMap[r.key];
            return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                key: r.key,
                space: "space.150"
            }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
                size: "small"
            }, manifestRemoteInfo ? manifestRemoteInfo.description : intl.formatMessage((0, $dlclU.messages).remoteFallbackHeading)), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                xcss: (0, $dlclU.styles).rowContainer,
                spread: "space-between",
                grow: "fill"
            }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, r.configured.endpoint === null ? intl.formatMessage((0, $dlclU.messages).remoteResetToDefault) : r.configured.endpoint), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, manifestRemoteInfo ? manifestRemoteInfo.name : null)));
        }));
        return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.egresses.map((e)=>/*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                key: e.key,
                space: "space.150"
            }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
                size: "xsmall"
            }, e.description), e.configured.map((c)=>c.type.map((t)=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                        key: t,
                        xcss: (0, $dlclU.styles).rowContainer,
                        spread: "space-between",
                        grow: "fill"
                    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, c.domain), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage($1a69ef1c2fde52fe$var$getHumanReadableMessage(t)))))))));
    };
    const Notice = ()=>{
        if (termsOfUseLink && privacyPolicyLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).noticeForMoreDetails, {
            appName: appName
        }), ' ', /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: termsOfUseLink
        }, intl.formatMessage((0, $dlclU.messages).termsOfUseLink)), ' ', intl.formatMessage((0, $dlclU.messages).noticeAnd), ' ', /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: privacyPolicyLink
        }, intl.formatMessage((0, $dlclU.messages).privacyPolicyLink)));
        if (termsOfUseLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).noticeForMoreDetails, {
            appName: appName
        }), ' ', /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: termsOfUseLink
        }, intl.formatMessage((0, $dlclU.messages).termsOfUseLink)));
        if (privacyPolicyLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).noticeForMoreDetails, {
            appName: appName
        }), ' ', /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: privacyPolicyLink
        }, intl.formatMessage((0, $dlclU.messages).privacyPolicyLink)));
        return null;
    };
    const ModalFooter = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $dlclU.styles).modalFooterContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.075"
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            onClick: handleCancel,
            isDisabled: isApproving
        }, intl.formatMessage((0, $dlclU.messages).declineButtonLabel)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            onClick: handleConfirm,
            appearance: "primary",
            isDisabled: isApproving,
            isLoading: isApproving
        }, intl.formatMessage((0, $dlclU.messages).approveButtonLabel)))));
    return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, isModalVisible && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: handleCancel,
        width: "large"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $dlclU.styles).titleContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, intl.formatMessage((0, $dlclU.messages).modalTransitionTitle)))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.300"
    }, hasApproveError && /*#__PURE__*/ $cozmU.createElement((0, $1VhsF.default), {
        appearance: "error"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).confirmErrorMessage))), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).modalTransitionText, {
        appName: appName
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, renderDomains(), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $dlclU.styles).disclaimerContainer
    }, /*#__PURE__*/ $cozmU.createElement(Notice, null))))), /*#__PURE__*/ $cozmU.createElement(ModalFooter, null)));
};
module.exports["AdminConsentModal"] = $1a69ef1c2fde52fe$export$a7839a1d0a383d1f;

});

parcelRegister("8OfFZ", function(module, exports) {

var $gg9xj = parcelRequire("gg9xj");


var $llM9z = parcelRequire("llM9z");

const $99141e371219e6ab$export$41b5b6d6fbe1e6b6 = (bridge, args)=>{
    const { userConsentRequired: userConsentRequired } = args;
    return {
        refresh: $99141e371219e6ab$export$98f3bf6f3e07f1f8(bridge?.refresh),
        submit: $99141e371219e6ab$export$98f3bf6f3e07f1f8(bridge?.submit),
        open: $99141e371219e6ab$export$98f3bf6f3e07f1f8(bridge?.open),
        close: $99141e371219e6ab$export$98f3bf6f3e07f1f8(bridge?.close),
        onClose: $99141e371219e6ab$export$98f3bf6f3e07f1f8(bridge?.onClose),
        openModal: $99141e371219e6ab$export$98f3bf6f3e07f1f8(bridge?.openModal, {
            requiresUserConsent: userConsentRequired
        }),
        showFlag: $99141e371219e6ab$export$98f3bf6f3e07f1f8(bridge?.showFlag),
        closeFlag: $99141e371219e6ab$export$98f3bf6f3e07f1f8(bridge?.closeFlag),
        reconcile: $99141e371219e6ab$export$98f3bf6f3e07f1f8(bridge?.reconcile),
        getFrameDispatch: $99141e371219e6ab$export$98f3bf6f3e07f1f8(bridge?.getFrameDispatch),
        emitReadyEvent: $99141e371219e6ab$export$98f3bf6f3e07f1f8(bridge?.emitReadyEvent),
        onError: $99141e371219e6ab$export$98f3bf6f3e07f1f8(bridge?.onError),
        createHistory: ()=>(0, $gg9xj.createHistory)({
                history: bridge?.history,
                extensionBasePath: bridge?.extensionBasePath
            }),
        changeWindowTitle: $99141e371219e6ab$export$98f3bf6f3e07f1f8(bridge?.changeWindowTitle),
        ...(0, $llM9z.getCreateBridgeApiPermissionFunctions)(bridge)
    };
};
const $99141e371219e6ab$export$98f3bf6f3e07f1f8 = (method, ...args)=>{
    return async (payload)=>{
        if (method) return method(payload, ...args) ?? true;
        return false;
    };
};
module.exports["createBridgeApi"] = $99141e371219e6ab$export$41b5b6d6fbe1e6b6;
module.exports["createBridgeMethod"] = $99141e371219e6ab$export$98f3bf6f3e07f1f8;

});

parcelRegister("hYBRd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $2feJ9 = parcelRequire("2feJ9");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $9cGsb = parcelRequire("9cGsb");


var $eL3mC = parcelRequire("eL3mC");


var $iGKcz = parcelRequire("iGKcz");

class $a4d992c0e201ce61$export$67e3479a9f34cffa extends Error {
}
const $a4d992c0e201ce61$export$cea4d5b903e9aab5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useForgeAppQuery() {
    const $ = (0, $bDgLe.c)(3);
    const tracing = (0, $eL3mC.useTracingContext)();
    const relayContext = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext));
    const environment = relayContext?.environment;
    let t0;
    if ($[0] !== environment || $[1] !== tracing) {
        t0 = async (appId, contextIds)=>{
            const appAri = (0, $9cGsb.createAppAri)({
                appId: appId
            }).toString();
            tracing?.recordGqlCall("APP_BY_ID_QUERY - start");
            return new Promise((resolve, reject)=>{
                if (environment) (0, $6SsN4.fetchQuery)(environment, (0, $2feJ9.default), {
                    appAri: appAri,
                    contextIds: contextIds
                }, {
                    networkCacheConfig: {
                        metadata: {
                            headers: {
                                "atl-attribution": (0, $iGKcz.createAtlAttributionHeader)()
                            }
                        }
                    }
                }).subscribe({
                    next: (data)=>{
                        resolve(data.app);
                    },
                    error: (error)=>{
                        const details = JSON.stringify(error);
                        reject(new $a4d992c0e201ce61$export$67e3479a9f34cffa(`Failed to fetch app data by its ID: ${appAri}, GraphQLError: ${details}`));
                    },
                    complete: ()=>{
                        tracing?.recordGqlCall("APP_BY_ID_QUERY - end");
                    }
                });
            });
        };
        $[0] = environment;
        $[1] = tracing;
        $[2] = t0;
    } else t0 = $[2];
    const fetchAppData = t0;
    return fetchAppData;
} : function useForgeAppQuery() {
    const tracing = (0, $eL3mC.useTracingContext)();
    const relayContext = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext));
    const environment = relayContext?.environment;
    const fetchAppData = async (appId, contextIds)=>{
        const appAri = (0, $9cGsb.createAppAri)({
            appId: appId
        }).toString();
        tracing?.recordGqlCall('APP_BY_ID_QUERY - start');
        // TODO move query fragment into AdminConsentModal.tsx
        return new Promise((resolve, reject)=>{
            if (environment) (0, $6SsN4.fetchQuery)(environment, (0, $2feJ9.default), {
                appAri: appAri,
                contextIds: contextIds
            }, {
                networkCacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)()
                        }
                    }
                }
            }).subscribe({
                next: (data)=>{
                    resolve(data.app);
                },
                error: (error)=>{
                    const details = JSON.stringify(error);
                    reject(new $a4d992c0e201ce61$export$67e3479a9f34cffa(`Failed to fetch app data by its ID: ${appAri}, GraphQLError: ${details}`));
                },
                complete: ()=>{
                    tracing?.recordGqlCall('APP_BY_ID_QUERY - end');
                }
            });
        });
    };
    return fetchAppData;
};
module.exports["useForgeAppQuery"] = $a4d992c0e201ce61$export$cea4d5b903e9aab5;

});

parcelRegister("hqafU", function(module, exports) {
/**
 * @generated SignedSource<<54cacd868d486df8b9e16a54c838040b>>
 * @relayHash 1ddb7206934ab3dcd1cf0292ff839f9d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ddbf791d2d018cacdc833e0d1652f1d86228e3ac6814a7974f843771169ae3ee
const $d961f414a22a1eff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ForgeDeprecationMessage_appQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ForgeDeprecationMessage_appQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ddbf791d2d018cacdc833e0d1652f1d86228e3ac6814a7974f843771169ae3ee",
            "metadata": {},
            "name": "ForgeDeprecationMessage_appQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d961f414a22a1eff$var$node.hash = "06c66e4e27413d7a6996129034e23a82";
var $d961f414a22a1eff$export$2e2bcd8739ae039 = $d961f414a22a1eff$var$node;
module.exports["default"] = $d961f414a22a1eff$export$2e2bcd8739ae039;

});

parcelRegister("hq6tn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $bd18b0d531a587e7$export$efd8f108e163181c extends (0, $cozmU.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    render() {
        return this.state.hasError ? this.props.fallback : this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}
module.exports["RelayErrorBoundary"] = $bd18b0d531a587e7$export$efd8f108e163181c;

});

parcelRegister("87CGM", function(module, exports) {
/**
 * Utilities for JWT token decoding and comparison logic used in shadow invocation feature
 */ 
var $6FQr4 = parcelRequire("6FQr4");

function $6b7039b307ace8b9$export$96751ef617237d7e(jwt) {
    if (!jwt) return undefined;
    try {
        const payload = jwt.split('.')[1];
        if (!payload) return undefined;
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
        return JSON.parse(atob(padded));
    } catch (e) {
        return undefined;
    }
}
/**
 * Checks if a value is a plain object (not array, null, or primitive)
 * @param value - The value to check
 * @returns True if the value is a plain object
 */ function $6b7039b307ace8b9$var$isPlainObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
/**
 * Recursively compares two objects and returns the differences
 * @param shadow - The shadow object to compare
 * @param regular - The regular object to compare
 * @param path - The current path in the object hierarchy
 * @param result - The result object to accumulate differences
 */ function $6b7039b307ace8b9$var$visitObjectDifferences(shadow, regular, path, result) {
    const sObj = $6b7039b307ace8b9$var$isPlainObject(shadow) ? shadow : {};
    const rObj = $6b7039b307ace8b9$var$isPlainObject(regular) ? regular : {};
    const sKeys = new Set(Object.keys(sObj));
    const rKeys = new Set(Object.keys(rObj));
    // Find keys only in shadow
    sKeys.forEach((k)=>{
        if (!rKeys.has(k)) result.onlyInShadow.push([
            ...path,
            k
        ].join('.'));
    });
    // Find keys only in regular
    rKeys.forEach((k)=>{
        if (!sKeys.has(k)) result.onlyInRegular.push([
            ...path,
            k
        ].join('.'));
    });
    // Compare common keys
    sKeys.forEach((k)=>{
        if (!rKeys.has(k)) return;
        const sv = sObj[k];
        const rv = rObj[k];
        if ($6b7039b307ace8b9$var$isPlainObject(sv) && $6b7039b307ace8b9$var$isPlainObject(rv)) $6b7039b307ace8b9$var$visitObjectDifferences(sv, rv, [
            ...path,
            k
        ], result);
        else if (JSON.stringify(sv) !== JSON.stringify(rv)) result.mismatchedValues.push({
            key: [
                ...path,
                k
            ].join('.'),
            shadow: sv,
            regular: rv
        });
    });
}
function $6b7039b307ace8b9$export$c88750430cbf4afc(shadowToken, regularToken) {
    const shadow = shadowToken?.context || {};
    const regular = regularToken?.context || {};
    const result = {
        onlyInShadow: [],
        onlyInRegular: [],
        mismatchedValues: []
    };
    $6b7039b307ace8b9$var$visitObjectDifferences(shadow, regular, [], result);
    return result;
}
function $6b7039b307ace8b9$export$ad8401ab212af28d(differences) {
    const allDifferingKeys = new Set();
    // Add keys that are only in shadow token
    differences.onlyInShadow.forEach((key)=>allDifferingKeys.add(key));
    // Add keys that are only in regular token
    differences.onlyInRegular.forEach((key)=>allDifferingKeys.add(key));
    // Add keys that have mismatched values
    differences.mismatchedValues.forEach((mismatch)=>allDifferingKeys.add(mismatch.key));
    // Return sorted array for consistent output
    return Array.from(allDifferingKeys).sort();
}
function $6b7039b307ace8b9$export$6c4ccde2488ac6b8(differences) {
    const keyValues = {};
    // Keys only in shadow token
    differences.onlyInShadow.forEach((key)=>{
        keyValues[key] = {
            shadow: 'present',
            regular: undefined
        };
    });
    // Keys only in regular token
    differences.onlyInRegular.forEach((key)=>{
        keyValues[key] = {
            regular: 'present',
            shadow: undefined
        };
    });
    // Keys with mismatched values
    differences.mismatchedValues.forEach((mismatch)=>{
        keyValues[mismatch.key] = {
            regular: mismatch.regular,
            shadow: mismatch.shadow
        };
    });
    return keyValues;
}
function $6b7039b307ace8b9$export$91cd38f87a379a31(shadowToken, regularToken) {
    const shadow = shadowToken || {};
    const regular = regularToken || {};
    const result = {
        onlyInShadow: [],
        onlyInRegular: [],
        mismatchedValues: []
    };
    $6b7039b307ace8b9$var$visitObjectDifferences(shadow, regular, [], result);
    return result;
}
function $6b7039b307ace8b9$export$ce683f7fc0bd28b1(differences, regularToken) {
    const mismatchesEmpty = differences.mismatchedValues.length === 0;
    const onlyInRegularOk = differences.onlyInRegular.length <= 1;
    if (!mismatchesEmpty || !onlyInRegularOk) return false;
    if (differences.onlyInRegular.length === 1) {
        const onlyKey = differences.onlyInRegular[0];
        // When using context-only paths, this should be 'extension.content.subtype'
        const regularCtx = regularToken?.context || {};
        const regularSubtype = regularCtx?.extension?.content?.subtype;
        return onlyKey === 'extension.content.subtype' && regularSubtype === null;
    }
    // No differences inside context
    return true;
}
function $6b7039b307ace8b9$export$86c16fc1ae19506b(differences, useShadow, regularResponse, shadowResponse) {
    const differingKeys = $6b7039b307ace8b9$export$ad8401ab212af28d(differences);
    const differingKeysWithValues = $6b7039b307ace8b9$export$6c4ccde2488ac6b8(differences);
    const hasDifferences = differingKeys.length > 0;
    return {
        action: 'contextTokenComparison',
        actionSubject: 'forge.ui.invocation',
        source: 'forge.ui.iframe',
        attributes: {
            comparisonResult: hasDifferences ? 'different' : 'same',
            hasDifferences: hasDifferences,
            differenceCount: differingKeys.length,
            differingKeys: differingKeys,
            differingKeysWithValues: // Flat array of actionable key paths
            differingKeysWithValues,
            // Detailed values for each differing key
            onlyInRegularCount: differences.onlyInRegular.length,
            onlyInShadowCount: differences.onlyInShadow.length,
            mismatchedValuesCount: differences.mismatchedValues.length,
            useShadowResponse: useShadow,
            extensionId: regularResponse.extensionId || shadowResponse.extensionId,
            extensionType: regularResponse.extensionType || shadowResponse.extensionType
        }
    };
}
function $6b7039b307ace8b9$export$782f13e8807e97e6(regularResponse, shadowResponse, createAnalyticsEvent) {
    if (!shadowResponse || !regularResponse) return regularResponse;
    const decodedTokens = {
        shadow: $6b7039b307ace8b9$export$96751ef617237d7e(shadowResponse.contextToken?.jwt),
        regular: $6b7039b307ace8b9$export$96751ef617237d7e(regularResponse.contextToken?.jwt)
    };
    // Use context-only comparison for the decision logic (existing behavior)
    const contextDifferences = $6b7039b307ace8b9$export$c88750430cbf4afc(decodedTokens.shadow, decodedTokens.regular);
    const useShadow = $6b7039b307ace8b9$export$ce683f7fc0bd28b1(contextDifferences, decodedTokens.regular);
    if (createAnalyticsEvent) {
        // Use full token comparison for comprehensive analytics
        const fullDifferences = $6b7039b307ace8b9$export$91cd38f87a379a31(decodedTokens.shadow, decodedTokens.regular);
        const analyticsPayload = $6b7039b307ace8b9$export$86c16fc1ae19506b(fullDifferences, useShadow, regularResponse, shadowResponse);
        (0, $6FQr4.fireEvent)(createAnalyticsEvent, analyticsPayload);
    }
    return useShadow ? shadowResponse : regularResponse;
}
module.exports["decodeJwtPayload"] = $6b7039b307ace8b9$export$96751ef617237d7e;

});

parcelRegister("iIo47", function(module, exports) {
!function(e) {
    var t;
    module.exports = e();
}(function() {
    return (function r(o, i, u) {
        function s(n, e) {
            if (!i[n]) {
                if (!o[n]) {
                    var t = undefined;
                    if (!e && t) return t(n, !0);
                    if (a) return a(n, !0);
                    throw new Error("Cannot find module '" + n + "'");
                }
                e = i[n] = {
                    exports: {}
                };
                o[n][0].call(e.exports, function(e) {
                    var t = o[n][1][e];
                    return s(t || e);
                }, e, e.exports, r, o, i, u);
            }
            return i[n].exports;
        }
        for(var a = undefined, e = 0; e < u.length; e++)s(u[e]);
        return s;
    })({
        1: [
            function(w, b, m) {
                (function(e, n, s, c, d, h, p, g, y) {
                    "use strict";
                    var r = w("crypto");
                    function t(e, t) {
                        t = u(e, t);
                        var n;
                        return void 0 === (n = "passthrough" !== t.algorithm ? r.createHash(t.algorithm) : new l).write && (n.write = n.update, n.end = n.update), f(t, n).dispatch(e), n.update || n.end(""), n.digest ? n.digest("buffer" === t.encoding ? void 0 : t.encoding) : (e = n.read(), "buffer" !== t.encoding ? e.toString(t.encoding) : e);
                    }
                    (m = b.exports = t).sha1 = function(e) {
                        return t(e);
                    }, m.keys = function(e) {
                        return t(e, {
                            excludeValues: !0,
                            algorithm: "sha1",
                            encoding: "hex"
                        });
                    }, m.MD5 = function(e) {
                        return t(e, {
                            algorithm: "md5",
                            encoding: "hex"
                        });
                    }, m.keysMD5 = function(e) {
                        return t(e, {
                            algorithm: "md5",
                            encoding: "hex",
                            excludeValues: !0
                        });
                    };
                    var o = r.getHashes ? r.getHashes().slice() : [
                        "sha1",
                        "md5"
                    ], i = (o.push("passthrough"), [
                        "buffer",
                        "hex",
                        "binary",
                        "base64"
                    ]);
                    function u(e, t) {
                        var n = {};
                        if (n.algorithm = (t = t || {}).algorithm || "sha1", n.encoding = t.encoding || "hex", n.excludeValues = !!t.excludeValues, n.algorithm = n.algorithm.toLowerCase(), n.encoding = n.encoding.toLowerCase(), n.ignoreUnknown = !0 === t.ignoreUnknown, n.respectType = !1 !== t.respectType, n.respectFunctionNames = !1 !== t.respectFunctionNames, n.respectFunctionProperties = !1 !== t.respectFunctionProperties, n.unorderedArrays = !0 === t.unorderedArrays, n.unorderedSets = !1 !== t.unorderedSets, n.unorderedObjects = !1 !== t.unorderedObjects, n.replacer = t.replacer || void 0, n.excludeKeys = t.excludeKeys || void 0, void 0 === e) throw new Error("Object argument required.");
                        for(var r = 0; r < o.length; ++r)o[r].toLowerCase() === n.algorithm.toLowerCase() && (n.algorithm = o[r]);
                        if (-1 === o.indexOf(n.algorithm)) throw new Error('Algorithm "' + n.algorithm + '"  not supported. supported values: ' + o.join(", "));
                        if (-1 === i.indexOf(n.encoding) && "passthrough" !== n.algorithm) throw new Error('Encoding "' + n.encoding + '"  not supported. supported values: ' + i.join(", "));
                        return n;
                    }
                    function a(e) {
                        if ("function" == typeof e) return null != /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(e));
                    }
                    function f(o, t, i) {
                        i = i || [];
                        function u(e) {
                            return t.update ? t.update(e, "utf8") : t.write(e, "utf8");
                        }
                        return {
                            dispatch: function(e) {
                                return this["_" + (null === (e = o.replacer ? o.replacer(e) : e) ? "null" : typeof e)](e);
                            },
                            _object: function(t) {
                                var n, e = Object.prototype.toString.call(t), r = /\[object (.*)\]/i.exec(e);
                                r = (r = r ? r[1] : "unknown:[" + e + "]").toLowerCase();
                                if (0 <= (e = i.indexOf(t))) return this.dispatch("[CIRCULAR:" + e + "]");
                                if (i.push(t), void 0 !== s && s.isBuffer && s.isBuffer(t)) return u("buffer:"), u(t);
                                if ("object" === r || "function" === r || "asyncfunction" === r) return e = Object.keys(t), o.unorderedObjects && (e = e.sort()), !1 === o.respectType || a(t) || e.splice(0, 0, "prototype", "__proto__", "constructor"), o.excludeKeys && (e = e.filter(function(e) {
                                    return !o.excludeKeys(e);
                                })), u("object:" + e.length + ":"), n = this, e.forEach(function(e) {
                                    n.dispatch(e), u(":"), o.excludeValues || n.dispatch(t[e]), u(",");
                                });
                                if (!this["_" + r]) {
                                    if (o.ignoreUnknown) return u("[" + r + "]");
                                    throw new Error('Unknown object type "' + r + '"');
                                }
                                this["_" + r](t);
                            },
                            _array: function(e, t) {
                                t = void 0 !== t ? t : !1 !== o.unorderedArrays;
                                var n = this;
                                if (u("array:" + e.length + ":"), !t || e.length <= 1) return e.forEach(function(e) {
                                    return n.dispatch(e);
                                });
                                var r = [], t = e.map(function(e) {
                                    var t = new l, n = i.slice();
                                    return f(o, t, n).dispatch(e), r = r.concat(n.slice(i.length)), t.read().toString();
                                });
                                return i = i.concat(r), t.sort(), this._array(t, !1);
                            },
                            _date: function(e) {
                                return u("date:" + e.toJSON());
                            },
                            _symbol: function(e) {
                                return u("symbol:" + e.toString());
                            },
                            _error: function(e) {
                                return u("error:" + e.toString());
                            },
                            _boolean: function(e) {
                                return u("bool:" + e.toString());
                            },
                            _string: function(e) {
                                u("string:" + e.length + ":"), u(e.toString());
                            },
                            _function: function(e) {
                                u("fn:"), a(e) ? this.dispatch("[native]") : this.dispatch(e.toString()), !1 !== o.respectFunctionNames && this.dispatch("function-name:" + String(e.name)), o.respectFunctionProperties && this._object(e);
                            },
                            _number: function(e) {
                                return u("number:" + e.toString());
                            },
                            _xml: function(e) {
                                return u("xml:" + e.toString());
                            },
                            _null: function() {
                                return u("Null");
                            },
                            _undefined: function() {
                                return u("Undefined");
                            },
                            _regexp: function(e) {
                                return u("regex:" + e.toString());
                            },
                            _uint8array: function(e) {
                                return u("uint8array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint8clampedarray: function(e) {
                                return u("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int8array: function(e) {
                                return u("int8array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint16array: function(e) {
                                return u("uint16array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int16array: function(e) {
                                return u("int16array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint32array: function(e) {
                                return u("uint32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int32array: function(e) {
                                return u("int32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _float32array: function(e) {
                                return u("float32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _float64array: function(e) {
                                return u("float64array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _arraybuffer: function(e) {
                                return u("arraybuffer:"), this.dispatch(new Uint8Array(e));
                            },
                            _url: function(e) {
                                return u("url:" + e.toString());
                            },
                            _map: function(e) {
                                u("map:");
                                e = Array.from(e);
                                return this._array(e, !1 !== o.unorderedSets);
                            },
                            _set: function(e) {
                                u("set:");
                                e = Array.from(e);
                                return this._array(e, !1 !== o.unorderedSets);
                            },
                            _file: function(e) {
                                return u("file:"), this.dispatch([
                                    e.name,
                                    e.size,
                                    e.type,
                                    e.lastModfied
                                ]);
                            },
                            _blob: function() {
                                if (o.ignoreUnknown) return u("[blob]");
                                throw Error('Hashing Blob objects is currently not supported\n(see https://github.com/puleos/object-hash/issues/26)\nUse "options.replacer" or "options.ignoreUnknown"\n');
                            },
                            _domwindow: function() {
                                return u("domwindow");
                            },
                            _bigint: function(e) {
                                return u("bigint:" + e.toString());
                            },
                            _process: function() {
                                return u("process");
                            },
                            _timer: function() {
                                return u("timer");
                            },
                            _pipe: function() {
                                return u("pipe");
                            },
                            _tcp: function() {
                                return u("tcp");
                            },
                            _udp: function() {
                                return u("udp");
                            },
                            _tty: function() {
                                return u("tty");
                            },
                            _statwatcher: function() {
                                return u("statwatcher");
                            },
                            _securecontext: function() {
                                return u("securecontext");
                            },
                            _connection: function() {
                                return u("connection");
                            },
                            _zlib: function() {
                                return u("zlib");
                            },
                            _context: function() {
                                return u("context");
                            },
                            _nodescript: function() {
                                return u("nodescript");
                            },
                            _httpparser: function() {
                                return u("httpparser");
                            },
                            _dataview: function() {
                                return u("dataview");
                            },
                            _signal: function() {
                                return u("signal");
                            },
                            _fsevent: function() {
                                return u("fsevent");
                            },
                            _tlswrap: function() {
                                return u("tlswrap");
                            }
                        };
                    }
                    function l() {
                        return {
                            buf: "",
                            write: function(e) {
                                this.buf += e;
                            },
                            end: function(e) {
                                this.buf += e;
                            },
                            read: function() {
                                return this.buf;
                            }
                        };
                    }
                    m.writeToStream = function(e, t, n) {
                        return void 0 === n && (n = t, t = {}), f(t = u(e, t), n).dispatch(e);
                    };
                }).call(this, w("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
            },
            {
                buffer: 3,
                crypto: 5,
                lYpoI2: 11
            }
        ],
        2: [
            function(e, t, f) {
                (function(e, t, n, r, o, i, u, s, a) {
                    !function(e) {
                        "use strict";
                        var a = "undefined" != typeof Uint8Array ? Uint8Array : Array, t = "+".charCodeAt(0), n = "/".charCodeAt(0), r = "0".charCodeAt(0), o = "a".charCodeAt(0), i = "A".charCodeAt(0), u = "-".charCodeAt(0), s = "_".charCodeAt(0);
                        function f(e) {
                            e = e.charCodeAt(0);
                            return e === t || e === u ? 62 : e === n || e === s ? 63 : e < r ? -1 : e < r + 10 ? e - r + 26 + 26 : e < i + 26 ? e - i : e < o + 26 ? e - o + 26 : void 0;
                        }
                        e.toByteArray = function(e) {
                            var t, n;
                            if (0 < e.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                            var r = e.length, r = "=" === e.charAt(r - 2) ? 2 : "=" === e.charAt(r - 1) ? 1 : 0, o = new a(3 * e.length / 4 - r), i = 0 < r ? e.length - 4 : e.length, u = 0;
                            function s(e) {
                                o[u++] = e;
                            }
                            for(t = 0; t < i; t += 4)s((16711680 & (n = f(e.charAt(t)) << 18 | f(e.charAt(t + 1)) << 12 | f(e.charAt(t + 2)) << 6 | f(e.charAt(t + 3)))) >> 16), s((65280 & n) >> 8), s(255 & n);
                            return 2 == r ? s(255 & (n = f(e.charAt(t)) << 2 | f(e.charAt(t + 1)) >> 4)) : 1 == r && (s((n = f(e.charAt(t)) << 10 | f(e.charAt(t + 1)) << 4 | f(e.charAt(t + 2)) >> 2) >> 8 & 255), s(255 & n)), o;
                        }, e.fromByteArray = function(e) {
                            var t, n, r, o, i = e.length % 3, u = "";
                            function s(e) {
                                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(e);
                            }
                            for(t = 0, r = e.length - i; t < r; t += 3)n = (e[t] << 16) + (e[t + 1] << 8) + e[t + 2], u += s((o = n) >> 18 & 63) + s(o >> 12 & 63) + s(o >> 6 & 63) + s(63 & o);
                            switch(i){
                                case 1:
                                    u = (u += s((n = e[e.length - 1]) >> 2)) + s(n << 4 & 63) + "==";
                                    break;
                                case 2:
                                    u = (u = (u += s((n = (e[e.length - 2] << 8) + e[e.length - 1]) >> 10)) + s(n >> 4 & 63)) + s(n << 2 & 63) + "=";
                            }
                            return u;
                        };
                    }(void 0 === f ? this.base64js = {} : f);
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        3: [
            function(O, e, H) {
                (function(e, n, f, r, h, p, g, y, w) {
                    var a = O("base64-js"), i = O("ieee754");
                    function f(e, t, n) {
                        if (!(this instanceof f)) return new f(e, t, n);
                        var r, o, i, u, s = typeof e;
                        if ("base64" === t && "string" == s) for(e = (u = e).trim ? u.trim() : u.replace(/^\s+|\s+$/g, ""); e.length % 4 != 0;)e += "=";
                        if ("number" == s) r = j(e);
                        else if ("string" == s) r = f.byteLength(e, t);
                        else {
                            if ("object" != s) throw new Error("First argument needs to be a number, array or string.");
                            r = j(e.length);
                        }
                        if (f._useTypedArrays ? o = f._augment(new Uint8Array(r)) : ((o = this).length = r, o._isBuffer = !0), f._useTypedArrays && "number" == typeof e.byteLength) o._set(e);
                        else if (C(u = e) || f.isBuffer(u) || u && "object" == typeof u && "number" == typeof u.length) for(i = 0; i < r; i++)f.isBuffer(e) ? o[i] = e.readUInt8(i) : o[i] = e[i];
                        else if ("string" == s) o.write(e, 0, t);
                        else if ("number" == s && !f._useTypedArrays && !n) for(i = 0; i < r; i++)o[i] = 0;
                        return o;
                    }
                    function b(e, t, n, r) {
                        return f._charsWritten = c(function(e) {
                            for(var t = [], n = 0; n < e.length; n++)t.push(255 & e.charCodeAt(n));
                            return t;
                        }(t), e, n, r);
                    }
                    function m(e, t, n, r) {
                        return f._charsWritten = c(function(e) {
                            for(var t, n, r = [], o = 0; o < e.length; o++)n = e.charCodeAt(o), t = n >> 8, n = n % 256, r.push(n), r.push(t);
                            return r;
                        }(t), e, n, r);
                    }
                    function v(e, t, n) {
                        var r = "";
                        n = Math.min(e.length, n);
                        for(var o = t; o < n; o++)r += String.fromCharCode(e[o]);
                        return r;
                    }
                    function o(e, t, n, r) {
                        r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 1 < e.length, "Trying to read beyond buffer length"));
                        var o, r = e.length;
                        if (!(r <= t)) return n ? (o = e[t], t + 1 < r && (o |= e[t + 1] << 8)) : (o = e[t] << 8, t + 1 < r && (o |= e[t + 1])), o;
                    }
                    function u(e, t, n, r) {
                        r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 3 < e.length, "Trying to read beyond buffer length"));
                        var o, r = e.length;
                        if (!(r <= t)) return n ? (t + 2 < r && (o = e[t + 2] << 16), t + 1 < r && (o |= e[t + 1] << 8), o |= e[t], t + 3 < r && (o += e[t + 3] << 24 >>> 0)) : (t + 1 < r && (o = e[t + 1] << 16), t + 2 < r && (o |= e[t + 2] << 8), t + 3 < r && (o |= e[t + 3]), o += e[t] << 24 >>> 0), o;
                    }
                    function _(e, t, n, r) {
                        if (r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 1 < e.length, "Trying to read beyond buffer length")), !(e.length <= t)) return r = o(e, t, n, !0), 32768 & r ? -1 * (65535 - r + 1) : r;
                    }
                    function E(e, t, n, r) {
                        if (r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 3 < e.length, "Trying to read beyond buffer length")), !(e.length <= t)) return r = u(e, t, n, !0), 2147483648 & r ? -1 * (4294967295 - r + 1) : r;
                    }
                    function I(e, t, n, r) {
                        return r || (d("boolean" == typeof n, "missing or invalid endian"), d(t + 3 < e.length, "Trying to read beyond buffer length")), i.read(e, t, n, 23, 4);
                    }
                    function A(e, t, n, r) {
                        return r || (d("boolean" == typeof n, "missing or invalid endian"), d(t + 7 < e.length, "Trying to read beyond buffer length")), i.read(e, t, n, 52, 8);
                    }
                    function s(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 1 < e.length, "trying to write beyond buffer length"), Y(t, 65535));
                        o = e.length;
                        if (!(o <= n)) for(var i = 0, u = Math.min(o - n, 2); i < u; i++)e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
                    }
                    function l(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "trying to write beyond buffer length"), Y(t, 4294967295));
                        o = e.length;
                        if (!(o <= n)) for(var i = 0, u = Math.min(o - n, 4); i < u; i++)e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
                    }
                    function B(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 1 < e.length, "Trying to write beyond buffer length"), F(t, 32767, -32768)), e.length <= n || s(e, 0 <= t ? t : 65535 + t + 1, n, r, o);
                    }
                    function L(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "Trying to write beyond buffer length"), F(t, 2147483647, -2147483648)), e.length <= n || l(e, 0 <= t ? t : 4294967295 + t + 1, n, r, o);
                    }
                    function U(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "Trying to write beyond buffer length"), D(t, 34028234663852886e22, -3.4028234663852886e+38)), e.length <= n || i.write(e, t, n, r, 23, 4);
                    }
                    function x(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 7 < e.length, "Trying to write beyond buffer length"), D(t, 17976931348623157e292, -1.7976931348623157e+308)), e.length <= n || i.write(e, t, n, r, 52, 8);
                    }
                    H.Buffer = f, H.SlowBuffer = f, H.INSPECT_MAX_BYTES = 50, f.poolSize = 8192, f._useTypedArrays = function() {
                        try {
                            var e = new ArrayBuffer(0), t = new Uint8Array(e);
                            return t.foo = function() {
                                return 42;
                            }, 42 === t.foo() && "function" == typeof t.subarray;
                        } catch (e) {
                            return !1;
                        }
                    }(), f.isEncoding = function(e) {
                        switch(String(e).toLowerCase()){
                            case "hex":
                            case "utf8":
                            case "utf-8":
                            case "ascii":
                            case "binary":
                            case "base64":
                            case "raw":
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return !0;
                            default:
                                return !1;
                        }
                    }, f.isBuffer = function(e) {
                        return !(null == e || !e._isBuffer);
                    }, f.byteLength = function(e, t) {
                        var n;
                        switch(e += "", t || "utf8"){
                            case "hex":
                                n = e.length / 2;
                                break;
                            case "utf8":
                            case "utf-8":
                                n = T(e).length;
                                break;
                            case "ascii":
                            case "binary":
                            case "raw":
                                n = e.length;
                                break;
                            case "base64":
                                n = M(e).length;
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                n = 2 * e.length;
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return n;
                    }, f.concat = function(e, t) {
                        if (d(C(e), "Usage: Buffer.concat(list, [totalLength])\nlist should be an Array."), 0 === e.length) return new f(0);
                        if (1 === e.length) return e[0];
                        if ("number" != typeof t) for(o = t = 0; o < e.length; o++)t += e[o].length;
                        for(var n = new f(t), r = 0, o = 0; o < e.length; o++){
                            var i = e[o];
                            i.copy(n, r), r += i.length;
                        }
                        return n;
                    }, f.prototype.write = function(e, t, n, r) {
                        isFinite(t) ? isFinite(n) || (r = n, n = void 0) : (a = r, r = t, t = n, n = a), t = Number(t) || 0;
                        var o, i, u, s, a = this.length - t;
                        switch((!n || a < (n = Number(n))) && (n = a), r = String(r || "utf8").toLowerCase()){
                            case "hex":
                                o = function(e, t, n, r) {
                                    n = Number(n) || 0;
                                    var o = e.length - n;
                                    (!r || o < (r = Number(r))) && (r = o), d((o = t.length) % 2 == 0, "Invalid hex string"), o / 2 < r && (r = o / 2);
                                    for(var i = 0; i < r; i++){
                                        var u = parseInt(t.substr(2 * i, 2), 16);
                                        d(!isNaN(u), "Invalid hex string"), e[n + i] = u;
                                    }
                                    return f._charsWritten = 2 * i, i;
                                }(this, e, t, n);
                                break;
                            case "utf8":
                            case "utf-8":
                                i = this, u = t, s = n, o = f._charsWritten = c(T(e), i, u, s);
                                break;
                            case "ascii":
                            case "binary":
                                o = b(this, e, t, n);
                                break;
                            case "base64":
                                i = this, u = t, s = n, o = f._charsWritten = c(M(e), i, u, s);
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                o = m(this, e, t, n);
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return o;
                    }, f.prototype.toString = function(e, t, n) {
                        var r, o, i, u, s = this;
                        if (e = String(e || "utf8").toLowerCase(), t = Number(t) || 0, (n = void 0 !== n ? Number(n) : s.length) === t) return "";
                        switch(e){
                            case "hex":
                                r = function(e, t, n) {
                                    var r = e.length;
                                    (!t || t < 0) && (t = 0);
                                    (!n || n < 0 || r < n) && (n = r);
                                    for(var o = "", i = t; i < n; i++)o += k(e[i]);
                                    return o;
                                }(s, t, n);
                                break;
                            case "utf8":
                            case "utf-8":
                                r = function(e, t, n) {
                                    var r = "", o = "";
                                    n = Math.min(e.length, n);
                                    for(var i = t; i < n; i++)e[i] <= 127 ? (r += N(o) + String.fromCharCode(e[i]), o = "") : o += "%" + e[i].toString(16);
                                    return r + N(o);
                                }(s, t, n);
                                break;
                            case "ascii":
                            case "binary":
                                r = v(s, t, n);
                                break;
                            case "base64":
                                o = s, u = n, r = 0 === (i = t) && u === o.length ? a.fromByteArray(o) : a.fromByteArray(o.slice(i, u));
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                r = function(e, t, n) {
                                    for(var r = e.slice(t, n), o = "", i = 0; i < r.length; i += 2)o += String.fromCharCode(r[i] + 256 * r[i + 1]);
                                    return o;
                                }(s, t, n);
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return r;
                    }, f.prototype.toJSON = function() {
                        return {
                            type: "Buffer",
                            data: Array.prototype.slice.call(this._arr || this, 0)
                        };
                    }, f.prototype.copy = function(e, t, n, r) {
                        if (t = t || 0, (r = r || 0 === r ? r : this.length) !== (n = n || 0) && 0 !== e.length && 0 !== this.length) {
                            d(n <= r, "sourceEnd < sourceStart"), d(0 <= t && t < e.length, "targetStart out of bounds"), d(0 <= n && n < this.length, "sourceStart out of bounds"), d(0 <= r && r <= this.length, "sourceEnd out of bounds"), r > this.length && (r = this.length);
                            var o = (r = e.length - t < r - n ? e.length - t + n : r) - n;
                            if (o < 100 || !f._useTypedArrays) for(var i = 0; i < o; i++)e[i + t] = this[i + n];
                            else e._set(this.subarray(n, n + o), t);
                        }
                    }, f.prototype.slice = function(e, t) {
                        var n = this.length;
                        if (e = S(e, n, 0), t = S(t, n, n), f._useTypedArrays) return f._augment(this.subarray(e, t));
                        for(var r = t - e, o = new f(r, void 0, !0), i = 0; i < r; i++)o[i] = this[i + e];
                        return o;
                    }, f.prototype.get = function(e) {
                        return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(e);
                    }, f.prototype.set = function(e, t) {
                        return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(e, t);
                    }, f.prototype.readUInt8 = function(e, t) {
                        if (t || (d(null != e, "missing offset"), d(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return this[e];
                    }, f.prototype.readUInt16LE = function(e, t) {
                        return o(this, e, !0, t);
                    }, f.prototype.readUInt16BE = function(e, t) {
                        return o(this, e, !1, t);
                    }, f.prototype.readUInt32LE = function(e, t) {
                        return u(this, e, !0, t);
                    }, f.prototype.readUInt32BE = function(e, t) {
                        return u(this, e, !1, t);
                    }, f.prototype.readInt8 = function(e, t) {
                        if (t || (d(null != e, "missing offset"), d(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                    }, f.prototype.readInt16LE = function(e, t) {
                        return _(this, e, !0, t);
                    }, f.prototype.readInt16BE = function(e, t) {
                        return _(this, e, !1, t);
                    }, f.prototype.readInt32LE = function(e, t) {
                        return E(this, e, !0, t);
                    }, f.prototype.readInt32BE = function(e, t) {
                        return E(this, e, !1, t);
                    }, f.prototype.readFloatLE = function(e, t) {
                        return I(this, e, !0, t);
                    }, f.prototype.readFloatBE = function(e, t) {
                        return I(this, e, !1, t);
                    }, f.prototype.readDoubleLE = function(e, t) {
                        return A(this, e, !0, t);
                    }, f.prototype.readDoubleBE = function(e, t) {
                        return A(this, e, !1, t);
                    }, f.prototype.writeUInt8 = function(e, t, n) {
                        n || (d(null != e, "missing value"), d(null != t, "missing offset"), d(t < this.length, "trying to write beyond buffer length"), Y(e, 255)), t >= this.length || (this[t] = e);
                    }, f.prototype.writeUInt16LE = function(e, t, n) {
                        s(this, e, t, !0, n);
                    }, f.prototype.writeUInt16BE = function(e, t, n) {
                        s(this, e, t, !1, n);
                    }, f.prototype.writeUInt32LE = function(e, t, n) {
                        l(this, e, t, !0, n);
                    }, f.prototype.writeUInt32BE = function(e, t, n) {
                        l(this, e, t, !1, n);
                    }, f.prototype.writeInt8 = function(e, t, n) {
                        n || (d(null != e, "missing value"), d(null != t, "missing offset"), d(t < this.length, "Trying to write beyond buffer length"), F(e, 127, -128)), t >= this.length || (0 <= e ? this.writeUInt8(e, t, n) : this.writeUInt8(255 + e + 1, t, n));
                    }, f.prototype.writeInt16LE = function(e, t, n) {
                        B(this, e, t, !0, n);
                    }, f.prototype.writeInt16BE = function(e, t, n) {
                        B(this, e, t, !1, n);
                    }, f.prototype.writeInt32LE = function(e, t, n) {
                        L(this, e, t, !0, n);
                    }, f.prototype.writeInt32BE = function(e, t, n) {
                        L(this, e, t, !1, n);
                    }, f.prototype.writeFloatLE = function(e, t, n) {
                        U(this, e, t, !0, n);
                    }, f.prototype.writeFloatBE = function(e, t, n) {
                        U(this, e, t, !1, n);
                    }, f.prototype.writeDoubleLE = function(e, t, n) {
                        x(this, e, t, !0, n);
                    }, f.prototype.writeDoubleBE = function(e, t, n) {
                        x(this, e, t, !1, n);
                    }, f.prototype.fill = function(e, t, n) {
                        if (t = t || 0, n = n || this.length, d("number" == typeof (e = "string" == typeof (e = e || 0) ? e.charCodeAt(0) : e) && !isNaN(e), "value is not a number"), d(t <= n, "end < start"), n !== t && 0 !== this.length) {
                            d(0 <= t && t < this.length, "start out of bounds"), d(0 <= n && n <= this.length, "end out of bounds");
                            for(var r = t; r < n; r++)this[r] = e;
                        }
                    }, f.prototype.inspect = function() {
                        for(var e = [], t = this.length, n = 0; n < t; n++)if (e[n] = k(this[n]), n === H.INSPECT_MAX_BYTES) {
                            e[n + 1] = "...";
                            break;
                        }
                        return "<Buffer " + e.join(" ") + ">";
                    }, f.prototype.toArrayBuffer = function() {
                        if ("undefined" == typeof Uint8Array) throw new Error("Buffer.toArrayBuffer not supported in this browser");
                        if (f._useTypedArrays) return new f(this).buffer;
                        for(var e = new Uint8Array(this.length), t = 0, n = e.length; t < n; t += 1)e[t] = this[t];
                        return e.buffer;
                    };
                    var t = f.prototype;
                    function S(e, t, n) {
                        return "number" != typeof e ? n : t <= (e = ~~e) ? t : 0 <= e || 0 <= (e += t) ? e : 0;
                    }
                    function j(e) {
                        return (e = ~~Math.ceil(+e)) < 0 ? 0 : e;
                    }
                    function C(e) {
                        return (Array.isArray || function(e) {
                            return "[object Array]" === Object.prototype.toString.call(e);
                        })(e);
                    }
                    function k(e) {
                        return e < 16 ? "0" + e.toString(16) : e.toString(16);
                    }
                    function T(e) {
                        for(var t = [], n = 0; n < e.length; n++){
                            var r = e.charCodeAt(n);
                            if (r <= 127) t.push(e.charCodeAt(n));
                            else for(var o = n, i = (55296 <= r && r <= 57343 && n++, encodeURIComponent(e.slice(o, n + 1)).substr(1).split("%")), u = 0; u < i.length; u++)t.push(parseInt(i[u], 16));
                        }
                        return t;
                    }
                    function M(e) {
                        return a.toByteArray(e);
                    }
                    function c(e, t, n, r) {
                        for(var o = 0; o < r && !(o + n >= t.length || o >= e.length); o++)t[o + n] = e[o];
                        return o;
                    }
                    function N(e) {
                        try {
                            return decodeURIComponent(e);
                        } catch (e) {
                            return String.fromCharCode(65533);
                        }
                    }
                    function Y(e, t) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(0 <= e, "specified a negative value for writing an unsigned value"), d(e <= t, "value is larger than maximum value for type"), d(Math.floor(e) === e, "value has a fractional component");
                    }
                    function F(e, t, n) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(e <= t, "value larger than maximum allowed value"), d(n <= e, "value smaller than minimum allowed value"), d(Math.floor(e) === e, "value has a fractional component");
                    }
                    function D(e, t, n) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(e <= t, "value larger than maximum allowed value"), d(n <= e, "value smaller than minimum allowed value");
                    }
                    function d(e, t) {
                        if (!e) throw new Error(t || "Failed assertion");
                    }
                    f._augment = function(e) {
                        return e._isBuffer = !0, e._get = e.get, e._set = e.set, e.get = t.get, e.set = t.set, e.write = t.write, e.toString = t.toString, e.toLocaleString = t.toString, e.toJSON = t.toJSON, e.copy = t.copy, e.slice = t.slice, e.readUInt8 = t.readUInt8, e.readUInt16LE = t.readUInt16LE, e.readUInt16BE = t.readUInt16BE, e.readUInt32LE = t.readUInt32LE, e.readUInt32BE = t.readUInt32BE, e.readInt8 = t.readInt8, e.readInt16LE = t.readInt16LE, e.readInt16BE = t.readInt16BE, e.readInt32LE = t.readInt32LE, e.readInt32BE = t.readInt32BE, e.readFloatLE = t.readFloatLE, e.readFloatBE = t.readFloatBE, e.readDoubleLE = t.readDoubleLE, e.readDoubleBE = t.readDoubleBE, e.writeUInt8 = t.writeUInt8, e.writeUInt16LE = t.writeUInt16LE, e.writeUInt16BE = t.writeUInt16BE, e.writeUInt32LE = t.writeUInt32LE, e.writeUInt32BE = t.writeUInt32BE, e.writeInt8 = t.writeInt8, e.writeInt16LE = t.writeInt16LE, e.writeInt16BE = t.writeInt16BE, e.writeInt32LE = t.writeInt32LE, e.writeInt32BE = t.writeInt32BE, e.writeFloatLE = t.writeFloatLE, e.writeFloatBE = t.writeFloatBE, e.writeDoubleLE = t.writeDoubleLE, e.writeDoubleBE = t.writeDoubleBE, e.fill = t.fill, e.inspect = t.inspect, e.toArrayBuffer = t.toArrayBuffer, e;
                    };
                }).call(this, O("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, O("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
            },
            {
                "base64-js": 2,
                buffer: 3,
                ieee754: 10,
                lYpoI2: 11
            }
        ],
        4: [
            function(c, d, e) {
                (function(e, t, a, n, r, o, i, u, s) {
                    var a = c("buffer").Buffer, f = 4, l = new a(f);
                    l.fill(0);
                    d.exports = {
                        hash: function(e, t, n, r) {
                            for(var o = t(function(e, t) {
                                e.length % f != 0 && (n = e.length + (f - e.length % f), e = a.concat([
                                    e,
                                    l
                                ], n));
                                for(var n, r = [], o = t ? e.readInt32BE : e.readInt32LE, i = 0; i < e.length; i += f)r.push(o.call(e, i));
                                return r;
                            }(e = a.isBuffer(e) ? e : new a(e), r), 8 * e.length), t = r, i = new a(n), u = t ? i.writeInt32BE : i.writeInt32LE, s = 0; s < o.length; s++)u.call(i, o[s], 4 * s, !0);
                            return i;
                        }
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        5: [
            function(v, e, _) {
                (function(l, c, u, d, h, p, g, y, w) {
                    var u = v("buffer").Buffer, e = v("./sha"), t = v("./sha256"), n = v("./rng"), b = {
                        sha1: e,
                        sha256: t,
                        md5: v("./md5")
                    }, s = 64, a = new u(s);
                    function r(e, n) {
                        var r = b[e = e || "sha1"], o = [];
                        return r || i("algorithm:", e, "is not yet supported"), {
                            update: function(e) {
                                return u.isBuffer(e) || (e = new u(e)), o.push(e), e.length, this;
                            },
                            digest: function(e) {
                                var t = u.concat(o), t = n ? function(e, t, n) {
                                    u.isBuffer(t) || (t = new u(t)), u.isBuffer(n) || (n = new u(n)), t.length > s ? t = e(t) : t.length < s && (t = u.concat([
                                        t,
                                        a
                                    ], s));
                                    for(var r = new u(s), o = new u(s), i = 0; i < s; i++)r[i] = 54 ^ t[i], o[i] = 92 ^ t[i];
                                    return n = e(u.concat([
                                        r,
                                        n
                                    ])), e(u.concat([
                                        o,
                                        n
                                    ]));
                                }(r, n, t) : r(t);
                                return o = null, e ? t.toString(e) : t;
                            }
                        };
                    }
                    function i() {
                        var e = [].slice.call(arguments).join(" ");
                        throw new Error([
                            e,
                            "we accept pull requests",
                            "http://github.com/dominictarr/crypto-browserify"
                        ].join("\n"));
                    }
                    a.fill(0), _.createHash = function(e) {
                        return r(e);
                    }, _.createHmac = r, _.randomBytes = function(e, t) {
                        if (!t || !t.call) return new u(n(e));
                        try {
                            t.call(this, void 0, new u(n(e)));
                        } catch (e) {
                            t(e);
                        }
                    };
                    var o, f = [
                        "createCredentials",
                        "createCipher",
                        "createCipheriv",
                        "createDecipher",
                        "createDecipheriv",
                        "createSign",
                        "createVerify",
                        "createDiffieHellman",
                        "pbkdf2"
                    ], m = function(e) {
                        _[e] = function() {
                            i("sorry,", e, "is not implemented yet");
                        };
                    };
                    for(o in f)m(f[o], o);
                }).call(this, v("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, v("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./md5": 6,
                "./rng": 7,
                "./sha": 8,
                "./sha256": 9,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        6: [
            function(w, b, e) {
                (function(e, r, o, i, u, a, f, l, y) {
                    var t = w("./helpers");
                    function n(e, t) {
                        e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;
                        for(var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, u = 0; u < e.length; u += 16){
                            var s = n, a = r, f = o, l = i, n = c(n, r, o, i, e[u + 0], 7, -680876936), i = c(i, n, r, o, e[u + 1], 12, -389564586), o = c(o, i, n, r, e[u + 2], 17, 606105819), r = c(r, o, i, n, e[u + 3], 22, -1044525330);
                            n = c(n, r, o, i, e[u + 4], 7, -176418897), i = c(i, n, r, o, e[u + 5], 12, 1200080426), o = c(o, i, n, r, e[u + 6], 17, -1473231341), r = c(r, o, i, n, e[u + 7], 22, -45705983), n = c(n, r, o, i, e[u + 8], 7, 1770035416), i = c(i, n, r, o, e[u + 9], 12, -1958414417), o = c(o, i, n, r, e[u + 10], 17, -42063), r = c(r, o, i, n, e[u + 11], 22, -1990404162), n = c(n, r, o, i, e[u + 12], 7, 1804603682), i = c(i, n, r, o, e[u + 13], 12, -40341101), o = c(o, i, n, r, e[u + 14], 17, -1502002290), n = d(n, r = c(r, o, i, n, e[u + 15], 22, 1236535329), o, i, e[u + 1], 5, -165796510), i = d(i, n, r, o, e[u + 6], 9, -1069501632), o = d(o, i, n, r, e[u + 11], 14, 643717713), r = d(r, o, i, n, e[u + 0], 20, -373897302), n = d(n, r, o, i, e[u + 5], 5, -701558691), i = d(i, n, r, o, e[u + 10], 9, 38016083), o = d(o, i, n, r, e[u + 15], 14, -660478335), r = d(r, o, i, n, e[u + 4], 20, -405537848), n = d(n, r, o, i, e[u + 9], 5, 568446438), i = d(i, n, r, o, e[u + 14], 9, -1019803690), o = d(o, i, n, r, e[u + 3], 14, -187363961), r = d(r, o, i, n, e[u + 8], 20, 1163531501), n = d(n, r, o, i, e[u + 13], 5, -1444681467), i = d(i, n, r, o, e[u + 2], 9, -51403784), o = d(o, i, n, r, e[u + 7], 14, 1735328473), n = h(n, r = d(r, o, i, n, e[u + 12], 20, -1926607734), o, i, e[u + 5], 4, -378558), i = h(i, n, r, o, e[u + 8], 11, -2022574463), o = h(o, i, n, r, e[u + 11], 16, 1839030562), r = h(r, o, i, n, e[u + 14], 23, -35309556), n = h(n, r, o, i, e[u + 1], 4, -1530992060), i = h(i, n, r, o, e[u + 4], 11, 1272893353), o = h(o, i, n, r, e[u + 7], 16, -155497632), r = h(r, o, i, n, e[u + 10], 23, -1094730640), n = h(n, r, o, i, e[u + 13], 4, 681279174), i = h(i, n, r, o, e[u + 0], 11, -358537222), o = h(o, i, n, r, e[u + 3], 16, -722521979), r = h(r, o, i, n, e[u + 6], 23, 76029189), n = h(n, r, o, i, e[u + 9], 4, -640364487), i = h(i, n, r, o, e[u + 12], 11, -421815835), o = h(o, i, n, r, e[u + 15], 16, 530742520), n = p(n, r = h(r, o, i, n, e[u + 2], 23, -995338651), o, i, e[u + 0], 6, -198630844), i = p(i, n, r, o, e[u + 7], 10, 1126891415), o = p(o, i, n, r, e[u + 14], 15, -1416354905), r = p(r, o, i, n, e[u + 5], 21, -57434055), n = p(n, r, o, i, e[u + 12], 6, 1700485571), i = p(i, n, r, o, e[u + 3], 10, -1894986606), o = p(o, i, n, r, e[u + 10], 15, -1051523), r = p(r, o, i, n, e[u + 1], 21, -2054922799), n = p(n, r, o, i, e[u + 8], 6, 1873313359), i = p(i, n, r, o, e[u + 15], 10, -30611744), o = p(o, i, n, r, e[u + 6], 15, -1560198380), r = p(r, o, i, n, e[u + 13], 21, 1309151649), n = p(n, r, o, i, e[u + 4], 6, -145523070), i = p(i, n, r, o, e[u + 11], 10, -1120210379), o = p(o, i, n, r, e[u + 2], 15, 718787259), r = p(r, o, i, n, e[u + 9], 21, -343485551), n = g(n, s), r = g(r, a), o = g(o, f), i = g(i, l);
                        }
                        return Array(n, r, o, i);
                    }
                    function s(e, t, n, r, o, i) {
                        return g((t = g(g(t, e), g(r, i))) << o | t >>> 32 - o, n);
                    }
                    function c(e, t, n, r, o, i, u) {
                        return s(t & n | ~t & r, e, t, o, i, u);
                    }
                    function d(e, t, n, r, o, i, u) {
                        return s(t & r | n & ~r, e, t, o, i, u);
                    }
                    function h(e, t, n, r, o, i, u) {
                        return s(t ^ n ^ r, e, t, o, i, u);
                    }
                    function p(e, t, n, r, o, i, u) {
                        return s(n ^ (t | ~r), e, t, o, i, u);
                    }
                    function g(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    b.exports = function(e) {
                        return t.hash(e, n, 16);
                    };
                }).call(this, w("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        7: [
            function(e, l, t) {
                (function(e, t, n, r, o, i, u, s, f) {
                    var a;
                    l.exports = a || function(e) {
                        for(var t, n = new Array(e), r = 0; r < e; r++)0 == (3 & r) && (t = 4294967296 * Math.random()), n[r] = t >>> ((3 & r) << 3) & 255;
                        return n;
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        8: [
            function(c, d, e) {
                (function(e, t, n, r, o, s, a, f, l) {
                    var i = c("./helpers");
                    function u(l, c) {
                        l[c >> 5] |= 128 << 24 - c % 32, l[15 + (c + 64 >> 9 << 4)] = c;
                        for(var e, t, n, r = Array(80), o = 1732584193, i = -271733879, u = -1732584194, s = 271733878, d = -1009589776, h = 0; h < l.length; h += 16){
                            for(var p = o, g = i, y = u, w = s, b = d, a = 0; a < 80; a++){
                                r[a] = a < 16 ? l[h + a] : v(r[a - 3] ^ r[a - 8] ^ r[a - 14] ^ r[a - 16], 1);
                                var f = m(m(v(o, 5), (f = i, t = u, n = s, (e = a) < 20 ? f & t | ~f & n : !(e < 40) && e < 60 ? f & t | f & n | t & n : f ^ t ^ n)), m(m(d, r[a]), (e = a) < 20 ? 1518500249 : e < 40 ? 1859775393 : e < 60 ? -1894007588 : -899497514)), d = s, s = u, u = v(i, 30), i = o, o = f;
                            }
                            o = m(o, p), i = m(i, g), u = m(u, y), s = m(s, w), d = m(d, b);
                        }
                        return Array(o, i, u, s, d);
                    }
                    function m(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    function v(e, t) {
                        return e << t | e >>> 32 - t;
                    }
                    d.exports = function(e) {
                        return i.hash(e, u, 20, !0);
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        9: [
            function(c, d, e) {
                (function(e, t, n, r, u, s, a, f, l) {
                    function b(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    function o(e, l) {
                        var c, d = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), t = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), n = new Array(64);
                        e[l >> 5] |= 128 << 24 - l % 32, e[15 + (l + 64 >> 9 << 4)] = l;
                        for(var r, o, h = 0; h < e.length; h += 16){
                            for(var i = t[0], u = t[1], s = t[2], p = t[3], a = t[4], g = t[5], y = t[6], w = t[7], f = 0; f < 64; f++)n[f] = f < 16 ? e[f + h] : b(b(b((o = n[f - 2], m(o, 17) ^ m(o, 19) ^ v(o, 10)), n[f - 7]), (o = n[f - 15], m(o, 7) ^ m(o, 18) ^ v(o, 3))), n[f - 16]), c = b(b(b(b(w, m(o = a, 6) ^ m(o, 11) ^ m(o, 25)), a & g ^ ~a & y), d[f]), n[f]), r = b(m(r = i, 2) ^ m(r, 13) ^ m(r, 22), i & u ^ i & s ^ u & s), w = y, y = g, g = a, a = b(p, c), p = s, s = u, u = i, i = b(c, r);
                            t[0] = b(i, t[0]), t[1] = b(u, t[1]), t[2] = b(s, t[2]), t[3] = b(p, t[3]), t[4] = b(a, t[4]), t[5] = b(g, t[5]), t[6] = b(y, t[6]), t[7] = b(w, t[7]);
                        }
                        return t;
                    }
                    var i = c("./helpers"), m = function(e, t) {
                        return e >>> t | e << 32 - t;
                    }, v = function(e, t) {
                        return e >>> t;
                    };
                    d.exports = function(e) {
                        return i.hash(e, o, 32, !0);
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        10: [
            function(e, t, f) {
                (function(e, t, n, r, o, i, u, s, a) {
                    f.read = function(e, t, n, r, o) {
                        var i, u, l = 8 * o - r - 1, c = (1 << l) - 1, d = c >> 1, s = -7, a = n ? o - 1 : 0, f = n ? -1 : 1, o = e[t + a];
                        for(a += f, i = o & (1 << -s) - 1, o >>= -s, s += l; 0 < s; i = 256 * i + e[t + a], a += f, s -= 8);
                        for(u = i & (1 << -s) - 1, i >>= -s, s += r; 0 < s; u = 256 * u + e[t + a], a += f, s -= 8);
                        if (0 === i) i = 1 - d;
                        else {
                            if (i === c) return u ? NaN : 1 / 0 * (o ? -1 : 1);
                            u += Math.pow(2, r), i -= d;
                        }
                        return (o ? -1 : 1) * u * Math.pow(2, i - r);
                    }, f.write = function(e, t, l, n, r, c) {
                        var o, i, u = 8 * c - r - 1, s = (1 << u) - 1, a = s >> 1, d = 23 === r ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : c - 1, h = n ? 1 : -1, c = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                        for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (i = isNaN(t) ? 1 : 0, o = s) : (o = Math.floor(Math.log(t) / Math.LN2), t * (n = Math.pow(2, -o)) < 1 && (o--, n *= 2), 2 <= (t += 1 <= o + a ? d / n : d * Math.pow(2, 1 - a)) * n && (o++, n /= 2), s <= o + a ? (i = 0, o = s) : 1 <= o + a ? (i = (t * n - 1) * Math.pow(2, r), o += a) : (i = t * Math.pow(2, a - 1) * Math.pow(2, r), o = 0)); 8 <= r; e[l + f] = 255 & i, f += h, i /= 256, r -= 8);
                        for(o = o << r | i, u += r; 0 < u; e[l + f] = 255 & o, f += h, o /= 256, u -= 8);
                        e[l + f - h] |= 128 * c;
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        11: [
            function(e, h, t) {
                (function(e, t, n, r, o, f, l, c, d) {
                    var i, u, s;
                    function a() {}
                    (e = h.exports = {}).nextTick = (u = "undefined" != typeof window && window.setImmediate, s = "undefined" != typeof window && window.postMessage && window.addEventListener, u ? function(e) {
                        return window.setImmediate(e);
                    } : s ? (i = [], window.addEventListener("message", function(e) {
                        var t = e.source;
                        t !== window && null !== t || "process-tick" !== e.data || (e.stopPropagation(), 0 < i.length && i.shift()());
                    }, !0), function(e) {
                        i.push(e), window.postMessage("process-tick", "*");
                    }) : function(e) {
                        setTimeout(e, 0);
                    }), e.title = "browser", e.browser = !0, e.env = {}, e.argv = [], e.on = a, e.addListener = a, e.once = a, e.off = a, e.removeListener = a, e.removeAllListeners = a, e.emit = a, e.binding = function(e) {
                        throw new Error("process.binding is not supported");
                    }, e.cwd = function() {
                        return "/";
                    }, e.chdir = function(e) {
                        throw new Error("process.chdir is not supported");
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ]
    }, {}, [
        1
    ])(1);
});

});

parcelRegister("6YMeN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $56zme = parcelRequire("56zme");


var $ix7El = parcelRequire("ix7El");


var $6SsN4 = parcelRequire("6SsN4");


var $iGKcz = parcelRequire("iGKcz");


var $cozmU = parcelRequire("cozmU");

const $ee8af9ec884f5dfc$var$CORE_EVENT = 'core:event';
const $ee8af9ec884f5dfc$var$CLIENT_EVENTS = 'client-events';
const $ee8af9ec884f5dfc$var$CLIENT_EVENT = 'client-event';
const $ee8af9ec884f5dfc$var$EVENT_PREFIX = 'forge.bridge.';
const $ee8af9ec884f5dfc$var$filterAllowedRecipients = (allExtensions, extension)=>{
    const matchingExtension = allExtensions.find((ext)=>{
        if (ext && ext?.appId && ext?.key) return ext.appId === extension.appId && (ext.key === $ee8af9ec884f5dfc$var$CLIENT_EVENTS || ext.key === $ee8af9ec884f5dfc$var$CLIENT_EVENT);
    });
    const allowedRecipients = matchingExtension?.properties?.allowedRecipients ?? [];
    const filteredAllowedRecipients = allowedRecipients.filter((recipient)=>recipient !== '*').map((recipient)=>recipient.split('/').pop());
    if (!filteredAllowedRecipients.includes(extension.appId)) filteredAllowedRecipients.push(extension.appId);
    return filteredAllowedRecipients;
};
const $ee8af9ec884f5dfc$export$444d4d38f9da2a78 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (contextId, extension)=>{
    const $ = (0, $bDgLe.c)(7);
    const relayEnvironment = (0, $6SsN4.useRelayEnvironment)();
    const allowedRecipientsRef = (0, $cozmU.useRef)(null);
    if (!extension?.appId) return $ee8af9ec884f5dfc$var$_temp;
    let t0;
    if ($[0] !== contextId || $[1] !== extension || $[2] !== relayEnvironment) {
        t0 = async ()=>{
            if (allowedRecipientsRef.current !== null) return allowedRecipientsRef.current;
            if (relayEnvironment) {
                const observable = (0, $6SsN4.fetchQuery)(relayEnvironment, (0, $56zme.default), {
                    contextIds: [
                        contextId
                    ],
                    filter: [
                        {
                            type: (0, $ix7El.GQLExtensionContextsFilterType).ExtensionType,
                            value: [
                                $ee8af9ec884f5dfc$var$CORE_EVENT
                            ]
                        }
                    ]
                }, {
                    networkCacheConfig: {
                        metadata: {
                            headers: {
                                "atl-attribution": (0, $iGKcz.createAtlAttributionHeader)()
                            }
                        }
                    }
                });
                return new Promise((resolve)=>{
                    observable.subscribe({
                        next: (result)=>{
                            const allExtensions = result?.extensionContexts?.[0]?.extensions || [];
                            const filteredAllowedRecipients = $ee8af9ec884f5dfc$var$filterAllowedRecipients(Array.from(allExtensions), extension);
                            resolve(filteredAllowedRecipients);
                        },
                        error: ()=>{
                            resolve([
                                extension.appId ?? ""
                            ]);
                        }
                    });
                });
            }
            return [
                extension.appId
            ];
        };
        $[0] = contextId;
        $[1] = extension;
        $[2] = relayEnvironment;
        $[3] = t0;
    } else t0 = $[3];
    const getAllowedRecipients = t0;
    let t1;
    if ($[4] !== extension || $[5] !== getAllowedRecipients) {
        t1 = async (eventData)=>{
            const { event: event, payload: payload } = eventData;
            if (allowedRecipientsRef.current === null) {
                const allowedRecipients = await getAllowedRecipients();
                allowedRecipientsRef.current = allowedRecipients;
            }
            const newEvent = new CustomEvent(`${$ee8af9ec884f5dfc$var$EVENT_PREFIX}${event}`, {
                detail: {
                    extension: extension,
                    payload: payload,
                    allowedRecipients: allowedRecipientsRef.current ?? [
                        extension.appId
                    ]
                }
            });
            window.document.dispatchEvent(newEvent);
        };
        $[4] = extension;
        $[5] = getAllowedRecipients;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : (contextId, extension)=>{
    const relayEnvironment = (0, $6SsN4.useRelayEnvironment)();
    const allowedRecipientsRef = (0, $cozmU.useRef)(null);
    if (!extension?.appId) return async ()=>{};
    const getAllowedRecipients = async ()=>{
        if (allowedRecipientsRef.current !== null) return allowedRecipientsRef.current;
        if (relayEnvironment) {
            const observable = (0, $6SsN4.fetchQuery)(relayEnvironment, (0, $56zme.default), {
                contextIds: [
                    contextId
                ],
                filter: [
                    {
                        type: (0, $ix7El.GQLExtensionContextsFilterType).ExtensionType,
                        value: [
                            $ee8af9ec884f5dfc$var$CORE_EVENT
                        ]
                    }
                ]
            }, {
                networkCacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)()
                        }
                    }
                }
            });
            return new Promise((resolve)=>{
                observable.subscribe({
                    next: (result)=>{
                        const allExtensions = result?.extensionContexts?.[0]?.extensions || [];
                        const filteredAllowedRecipients = $ee8af9ec884f5dfc$var$filterAllowedRecipients(Array.from(allExtensions), extension);
                        resolve(filteredAllowedRecipients);
                    },
                    error: ()=>{
                        resolve([
                            extension.appId ?? ''
                        ]);
                    }
                });
            });
        }
        return [
            extension.appId
        ];
    };
    return async (eventData)=>{
        const { event: event, payload: payload } = eventData;
        if (allowedRecipientsRef.current === null) {
            const allowedRecipients = await getAllowedRecipients();
            allowedRecipientsRef.current = allowedRecipients;
        }
        const newEvent = new CustomEvent(`${$ee8af9ec884f5dfc$var$EVENT_PREFIX}${event}`, {
            detail: {
                extension: extension,
                payload: payload,
                allowedRecipients: allowedRecipientsRef.current ?? [
                    extension.appId
                ]
            }
        });
        window.document.dispatchEvent(newEvent);
    };
};
async function $ee8af9ec884f5dfc$var$_temp() {}
module.exports["useEmitPublicEvent"] = $ee8af9ec884f5dfc$export$444d4d38f9da2a78;

});

parcelRegister("7Y94N", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $aODBI = parcelRequire("aODBI");


var $iGKcz = parcelRequire("iGKcz");


var $ha1mA = parcelRequire("ha1mA");


var $6SsN4 = parcelRequire("6SsN4");

const $89e062d9fae5bf17$export$df7d62be1d7f5fc9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (installationId, context, appId)=>{
    const $ = (0, $bDgLe.c)(5);
    const relayEnvironment = (0, $6SsN4.useRelayEnvironment)();
    let t0;
    if ($[0] !== appId || $[1] !== context || $[2] !== installationId || $[3] !== relayEnvironment) {
        t0 = async (payload, contextToken)=>{
            const { channelName: channelName, isGlobal: isGlobal, options: options } = payload.data;
            const { token: token, contextOverrides: contextOverrides } = options || {};
            if (token) {
                const validation = (0, $ha1mA.validateRealtimeChannelToken)(token, {
                    requiredPermission: "publish",
                    channelName: channelName
                });
                if (!validation.valid) return {
                    eventId: null,
                    eventTimestamp: null,
                    errors: [
                        {
                            message: `Realtime token validation failed: ${validation.error}`
                        }
                    ]
                };
            }
            const eventPayload = JSON.stringify(payload.data.eventPayload);
            const channelContext = contextOverrides ? JSON.stringify({
                context: context,
                contextOverrides: contextOverrides
            }) : context;
            return new Promise((resolve, reject)=>{
                (0, $6SsN4.commitMutation)(relayEnvironment, {
                    mutation: (0, $aODBI.default),
                    variables: {
                        installationId: installationId,
                        name: channelName,
                        payload: eventPayload,
                        context: channelContext,
                        isGlobal: isGlobal ?? false,
                        token: token
                    },
                    cacheConfig: {
                        metadata: {
                            headers: {
                                "atl-attribution": (0, $iGKcz.createAtlAttributionHeader)(),
                                ...contextToken ? {
                                    "x-forge-context-token": contextToken
                                } : {},
                                ...appId ? {
                                    "x-rate-limit-app-id": appId
                                } : {},
                                ...installationId ? {
                                    "x-rate-limit-installation-id": installationId
                                } : {}
                            }
                        }
                    },
                    onCompleted: (data, errors)=>{
                        if (errors) return resolve({
                            eventId: null,
                            eventTimestamp: null,
                            errors: errors.map($89e062d9fae5bf17$var$_temp)
                        });
                        if (data?.ecosystem?.publishRealtimeChannel) {
                            const { eventId: eventId, eventTimestamp: eventTimestamp } = data.ecosystem.publishRealtimeChannel;
                            if (eventId && eventTimestamp) resolve({
                                eventId: eventId,
                                eventTimestamp: eventTimestamp
                            });
                            else resolve(undefined);
                        } else resolve(undefined);
                    },
                    onError: reject
                });
            });
        };
        $[0] = appId;
        $[1] = context;
        $[2] = installationId;
        $[3] = relayEnvironment;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : (installationId, context, appId)=>{
    const relayEnvironment = (0, $6SsN4.useRelayEnvironment)();
    return async (payload, contextToken)=>{
        const { channelName: channelName, isGlobal: isGlobal, options: options } = payload.data;
        const { token: token, contextOverrides: contextOverrides } = options || {};
        if (token) {
            const validation = (0, $ha1mA.validateRealtimeChannelToken)(token, {
                requiredPermission: 'publish',
                channelName: channelName
            });
            if (!validation.valid) return {
                eventId: null,
                eventTimestamp: null,
                errors: [
                    {
                        message: `Realtime token validation failed: ${validation.error}`
                    }
                ]
            };
        }
        const eventPayload = JSON.stringify(payload.data.eventPayload);
        const channelContext = contextOverrides ? JSON.stringify({
            context: context,
            contextOverrides: contextOverrides
        }) : context;
        return new Promise((resolve, reject)=>{
            (0, $6SsN4.commitMutation)(relayEnvironment, {
                mutation: (0, $aODBI.default),
                variables: {
                    installationId: installationId,
                    name: channelName,
                    payload: eventPayload,
                    context: channelContext,
                    isGlobal: isGlobal ?? false,
                    token: token
                },
                cacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(),
                            ...contextToken ? {
                                'x-forge-context-token': contextToken
                            } : {},
                            ...appId ? {
                                'x-rate-limit-app-id': appId
                            } : {},
                            ...installationId ? {
                                'x-rate-limit-installation-id': installationId
                            } : {}
                        }
                    }
                },
                onCompleted: (data, errors)=>{
                    if (errors) return resolve({
                        eventId: null,
                        eventTimestamp: null,
                        errors: errors.map((error)=>{
                            if (error.extensions?.statusCode === 429) return {
                                message: 'RATE_LIMIT_EXCEEDED'
                            };
                            return error;
                        })
                    });
                    if (data?.ecosystem?.publishRealtimeChannel) {
                        const { eventId: eventId, eventTimestamp: eventTimestamp } = data.ecosystem.publishRealtimeChannel;
                        if (eventId && eventTimestamp) resolve({
                            eventId: eventId,
                            eventTimestamp: eventTimestamp
                        });
                        else resolve(undefined);
                    } else resolve(undefined);
                },
                onError: reject
            });
        });
    };
};
function $89e062d9fae5bf17$var$_temp(error) {
    if (error.extensions?.statusCode === 429) return {
        message: "RATE_LIMIT_EXCEEDED"
    };
    return error;
}
module.exports["usePublishRealtimeChannel"] = $89e062d9fae5bf17$export$df7d62be1d7f5fc9;

});

parcelRegister("fccjA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $i2Kmi = parcelRequire("i2Kmi");


var $ha1mA = parcelRequire("ha1mA");

const $3dc1bc6a02a02109$var$realtimeChannel = `
	subscription realtimeChannel(
		$installationId: ID!
		$name: String!
		$context: String
		$isGlobal: Boolean
		$token: String
	) {
		ecosystem {
			realtimeChannel(
				installationId: $installationId
				name: $name
				context: $context
				isGlobal: $isGlobal
				token: $token
			) {
				payload
			}
		}
	}
`;
const $3dc1bc6a02a02109$var$getChannelKey = (context)=>{
    return Object.entries(context).sort((a, b)=>a[0].localeCompare(b[0])).toString();
};
const $3dc1bc6a02a02109$export$905d34fe81a9cf60 = ({ payload: payload, context: context, installationId: installationId, contextToken: contextToken })=>{
    const query = {
        operationName: 'realtimeChannel',
        query: $3dc1bc6a02a02109$var$realtimeChannel
    };
    return {
        ...query,
        variables: {
            installationId: installationId,
            name: payload.data.channelName,
            context: context,
            isGlobal: payload.data.isGlobal ?? false,
            token: payload.data.options?.token
        },
        extensions: {
            'x-forge-context-token': contextToken,
            ...payload.data.options?.replaySeconds && {
                command: {
                    type: 'replay',
                    data: {
                        // Timestamp in seconds of when to replay messages from. Valid for up to 7 days in the past.
                        sequenceNumber: Date.now() / 1000 - payload.data.options.replaySeconds
                    }
                }
            }
        }
    };
};
const $3dc1bc6a02a02109$var$unsubscribeAllSubscriptions = (activeSubscriptions)=>{
    activeSubscriptions.forEach((subscription)=>{
        if (!subscription.closed) subscription.unsubscribe();
    });
    activeSubscriptions.clear();
};
const $3dc1bc6a02a02109$export$21407f03011cb801 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (installationId, context, getContextToken, getContextTokenOptions)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = new Map();
        $[0] = t0;
    } else t0 = $[0];
    const activeSubscriptions = (0, $cozmU.useRef)(t0);
    let t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const currentSubscriptions = activeSubscriptions.current;
            return ()=>{
                $3dc1bc6a02a02109$var$unsubscribeAllSubscriptions(currentSubscriptions);
            };
        };
        t2 = [];
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== context || $[4] !== getContextToken || $[5] !== getContextTokenOptions || $[6] !== installationId) {
        t3 = async (payload)=>{
            const { onEvent: onEvent, channelName: channelName, options: options, isGlobal: isGlobal } = payload.data;
            const { token: token } = options || {};
            if (token) {
                const validation = (0, $ha1mA.validateRealtimeChannelToken)(token, {
                    requiredPermission: "subscribe",
                    channelName: channelName
                });
                if (!validation.valid) return Promise.reject(new Error(`Realtime token validation failed: ${validation.error}`));
            }
            const channelContext = options?.contextOverrides ? JSON.stringify({
                context: context,
                contextOverrides: options?.contextOverrides
            }) : context;
            const channelKey = $3dc1bc6a02a02109$var$getChannelKey({
                channelName: channelName,
                isGlobal: isGlobal,
                channelContext: channelContext
            });
            const existingSubscription = activeSubscriptions.current.get(channelKey);
            if (existingSubscription) {
                existingSubscription.addCallback(onEvent);
                onEvent("SUBSCRIPTION_STARTED");
            } else {
                const createSubscription = async ()=>{
                    const subscriptionPayload = $3dc1bc6a02a02109$export$905d34fe81a9cf60({
                        payload: payload,
                        context: channelContext,
                        installationId: installationId,
                        contextToken: await getContextToken?.(getContextTokenOptions)
                    });
                    const subscription = (0, $i2Kmi.subscribe)(subscriptionPayload, {
                        next: (result)=>{
                            subscription.onNext(result.data.ecosystem?.realtimeChannel?.payload);
                        },
                        error: async (err)=>{
                            const error = Array.isArray(err) ? err[0] : err;
                            if (error?.extensions?.statusCode === 429) {
                                subscription.onError(new Error("RATE_LIMIT_EXCEEDED"));
                                return;
                            }
                            const shouldRetrySubscribe = error?.message === "FCT has expired on subscribe request";
                            if (shouldRetrySubscribe) try {
                                const newSubscription = await createSubscription();
                                newSubscription.subscriptionCallbacks = [
                                    ...subscription.subscriptionCallbacks
                                ];
                                activeSubscriptions.current.set(channelKey, newSubscription);
                                subscription.unsubscribe();
                                return;
                            } catch (t4) {
                                const err_0 = t4;
                                subscription.onError(err_0);
                                activeSubscriptions.current.delete(channelKey);
                                return;
                            }
                            subscription.onError(err);
                            activeSubscriptions.current.delete(channelKey);
                        },
                        complete: ()=>{
                            activeSubscriptions.current.delete(channelKey);
                        }
                    }, onEvent);
                    activeSubscriptions.current.set(channelKey, subscription);
                    return subscription;
                };
                createSubscription();
            }
            return {
                unsubscribe: ()=>{
                    const subscription_0 = activeSubscriptions.current.get(channelKey);
                    if (subscription_0) {
                        subscription_0.removeCallback(onEvent);
                        if (subscription_0.subscriptionCallbacks.length === 0) {
                            activeSubscriptions.current.delete(channelKey);
                            if (!subscription_0.closed) subscription_0.unsubscribe();
                        }
                    }
                }
            };
        };
        $[3] = context;
        $[4] = getContextToken;
        $[5] = getContextTokenOptions;
        $[6] = installationId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : (installationId, context, getContextToken, getContextTokenOptions)=>{
    const activeSubscriptions = (0, $cozmU.useRef)(new Map());
    (0, $cozmU.useEffect)(()=>{
        const currentSubscriptions = activeSubscriptions.current;
        return ()=>{
            $3dc1bc6a02a02109$var$unsubscribeAllSubscriptions(currentSubscriptions);
        };
    }, []);
    // this is the bridge method that will be called from the extension
    return async (payload)=>{
        const { onEvent: onEvent, channelName: channelName, options: options, isGlobal: isGlobal } = payload.data;
        const { token: token } = options || {};
        if (token) {
            const validation = (0, $ha1mA.validateRealtimeChannelToken)(token, {
                requiredPermission: 'subscribe',
                channelName: channelName
            });
            if (!validation.valid) return Promise.reject(new Error(`Realtime token validation failed: ${validation.error}`));
        }
        const channelContext = options?.contextOverrides ? JSON.stringify({
            context: context,
            contextOverrides: options?.contextOverrides
        }) : context;
        const channelKey = $3dc1bc6a02a02109$var$getChannelKey({
            channelName: channelName,
            isGlobal: isGlobal,
            channelContext: channelContext
        });
        const existingSubscription = activeSubscriptions.current.get(channelKey);
        if (existingSubscription) {
            // if subscription already exists
            existingSubscription.addCallback(onEvent);
            onEvent('SUBSCRIPTION_STARTED');
        } else {
            // helper to create a subscription and handle token refresh
            const createSubscription = async ()=>{
                const subscriptionPayload = $3dc1bc6a02a02109$export$905d34fe81a9cf60({
                    payload: payload,
                    context: channelContext,
                    installationId: installationId,
                    contextToken: await getContextToken?.(getContextTokenOptions)
                });
                const subscription = (0, $i2Kmi.subscribe)(subscriptionPayload, {
                    next: (result)=>{
                        subscription.onNext(result.data.ecosystem?.realtimeChannel?.payload);
                    },
                    error: async (err)=>{
                        const error = Array.isArray(err) ? err[0] : err;
                        if (error?.extensions?.statusCode === 429) {
                            subscription.onError(new Error('RATE_LIMIT_EXCEEDED'));
                            return;
                        }
                        const shouldRetrySubscribe = error?.message === 'FCT has expired on subscribe request';
                        if (shouldRetrySubscribe) try {
                            const newSubscription = await createSubscription();
                            newSubscription.subscriptionCallbacks = [
                                ...subscription.subscriptionCallbacks
                            ];
                            activeSubscriptions.current.set(channelKey, newSubscription);
                            subscription.unsubscribe();
                            return;
                        } catch (err_0) {
                            subscription.onError(err_0);
                            activeSubscriptions.current.delete(channelKey);
                            return;
                        }
                        subscription.onError(err);
                        activeSubscriptions.current.delete(channelKey);
                    },
                    complete: ()=>{
                        activeSubscriptions.current.delete(channelKey);
                    }
                }, onEvent);
                activeSubscriptions.current.set(channelKey, subscription);
                return subscription;
            };
            createSubscription();
        }
        return {
            unsubscribe: ()=>{
                const subscription_0 = activeSubscriptions.current.get(channelKey);
                if (subscription_0) {
                    // remove one subscription
                    subscription_0.removeCallback(onEvent);
                    // if no more subscriptions remove the channelKey and unsubscribe
                    if (subscription_0.subscriptionCallbacks.length === 0) {
                        activeSubscriptions.current.delete(channelKey);
                        if (!subscription_0.closed) subscription_0.unsubscribe();
                    }
                }
            }
        };
    };
};
module.exports["getSubscribePayload"] = $3dc1bc6a02a02109$export$905d34fe81a9cf60;
module.exports["useSubscribeRealtimeChannel"] = $3dc1bc6a02a02109$export$21407f03011cb801;

});

parcelRegister("gJkLc", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $b9heI = parcelRequire("b9heI");


var $c71c0 = parcelRequire("c71c0");


var $524dz = parcelRequire("524dz");

// Bitbucket User Recommendations does not support a generic contextType
const $74844facff4d2970$var$BITBUCKET_FIELD_ID = 'BitbucketMentions';
const $74844facff4d2970$export$b7f5a1a77fbb5609 = async ({ contextIds: contextIds, viewContext: viewContext }, { query: query })=>{
    if (!(0, $iDrrr.fg)('forge-ui-fetch-user-recommendations-bridge-method')) throw new (0, $c71c0.BridgeClientError)('User Recommendations API is not available for this instance.');
    const { accountId: accountId, cloudId: cloudId, locale: locale } = viewContext;
    const productKey = (0, $524dz.parseContextAri)(contextIds[0] ?? '').resourceOwner ?? 'jira';
    const recommendationsRequest = {
        context: {
            // Bitbucket User Recommendations does not support a generic contextType.
            contextType: productKey === 'bitbucket' ? $74844facff4d2970$var$BITBUCKET_FIELD_ID : 'filter',
            // If principalId === 'Context', upstream attempts to use other context
            // (e.g. the request headers) to discover the principal id.
            principalId: accountId ?? 'Context',
            productKey: productKey,
            siteId: cloudId ?? ''
        },
        includeUsers: true,
        includeGroups: false,
        maxNumberOfResults: 100,
        query: query ?? ''
    };
    const intl = (0, $kSwu1.createIntl)({
        locale: locale ?? 'en'
    }, (0, $kSwu1.createIntlCache)());
    const users = await (0, $b9heI.default)(recommendationsRequest, intl);
    return users.map((user)=>({
            appType: user.appType,
            avatarUrl: user.avatarUrl,
            email: user.email,
            id: user.id,
            includeTeamsUpdates: user.includeTeamsUpdates,
            isDisabled: user.isDisabled,
            name: user.name,
            title: user.title,
            tooltip: user.tooltip,
            type: user.type,
            verified: user.verified
        }));
};
module.exports["fetchUserRecommendations"] = $74844facff4d2970$export$b7f5a1a77fbb5609;

});

parcelRegister("84ihY", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $c71c0 = parcelRequire("c71c0");

const $7719c923efcc63e3$export$fb42ce7366122d00 = '/gateway/api/graphql/twg'; // e.g. https://api.atlassian.com/gateway/api/graphql/twg
const $7719c923efcc63e3$var$teamworkGraphFetchClient = async (productFetchClient, contextId, { query: query, variables: variables })=>{
    const body = JSON.stringify({
        query: query,
        variables: variables
    });
    const headers = new Headers({
        'content-type': 'application/json',
        'X-Query-Context': `${contextId}`
    });
    const response = await productFetchClient($7719c923efcc63e3$export$fb42ce7366122d00, 'teamwork-graph', {
        method: 'POST',
        headers: headers,
        body: body
    }, false);
    if (!response.ok) {
        const errorText = await response.text();
        throw new (0, $c71c0.BridgeClientError)(`Unexpected error encountered in requestTeamworkGraph. Status: ${response.status} ${response.statusText}. Response: ${errorText}`);
    }
    const { data: data, errors: errors } = await response.json();
    return {
        data: data,
        errors: errors
    };
};
const $7719c923efcc63e3$export$38751b4fc32b44e0 = async ({ services: { productFetchClient: productFetchClient }, contextIds: contextIds }, payload)=>{
    if (!(0, $iDrrr.fg)('forge-ui-enable-requestteamworkgraph-bridge-method')) throw new (0, $c71c0.BridgeClientError)('TeamWork Graph API is not available for this instance.');
    const contextId = contextIds[0];
    return $7719c923efcc63e3$var$teamworkGraphFetchClient(productFetchClient, contextId, payload);
};
module.exports["TEAMWORK_GRAPH_GATEWAY_PATH"] = $7719c923efcc63e3$export$fb42ce7366122d00;
module.exports["requestTeamworkGraph"] = $7719c923efcc63e3$export$38751b4fc32b44e0;

});

parcelRegister("2gSYB", function(module, exports) {
/**
 * Gets the target window for forwarding messages from FAUS to the product.
 *
 * Current architecture:
 * - Product (Confluence) → Bodied Macro → FAUS → Embedded Macro
 * - FAUS is nested 2 levels deep, so window.parent.parent is the product
 *
 * Future: This can be updated to support multiple nesting levels by checking
 * ancestorOrigins.length or using a more dynamic approach.
 *
 * @returns The product window, or null if not in a nested context
 */ function $fed65b10593e91ec$export$532d4b4b6d3d2c95() {
    // This would need to be changed if we want to support multiple nesting levels
    const targetWindow = window.parent?.parent;
    // Ensure we have a valid target that's not the current window
    if (targetWindow && targetWindow !== window) return targetWindow;
    return null;
}
function $fed65b10593e91ec$export$f0bf9a3931c6275e() {
    return `${window.location.protocol}//${window.location.hostname}`;
}
module.exports["getProductDomain"] = $fed65b10593e91ec$export$f0bf9a3931c6275e;

});

parcelRegister("l2msJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hdBxM = parcelRequire("hdBxM");


var $eet9L = parcelRequire("eet9L");


var $3xKHi = parcelRequire("3xKHi");


var $6SsN4 = parcelRequire("6SsN4");


var $cozmU = parcelRequire("cozmU");

const $6c731e8388540731$var$ROVO_TOPIC = 'ai-mate';
const $6c731e8388540731$var$FORGE_SOURCE = 'forge-bridge-open-rovo';
const $6c731e8388540731$var$ROVO_EVENT_TYPE = 'chat-new';
const $6c731e8388540731$var$makeForgeAgentExternalConfigReference = (appId, installationId, environmentId, agentKey)=>{
    return `${installationId}_ari:cloud:ecosystem::extension/${appId}/${environmentId}/static/${agentKey}`;
};
const $6c731e8388540731$export$1b9e058b7e689de = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRovoAgentsChat(extensionType, appId, cloudId, installationId, environmentId) {
    const $ = (0, $bDgLe.c)(8);
    const publish = (0, $hdBxM.usePublish)($6c731e8388540731$var$ROVO_TOPIC);
    const relayContext = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext));
    const relayEnvironment = relayContext?.environment;
    let t0;
    if ($[0] !== appId || $[1] !== cloudId || $[2] !== environmentId || $[3] !== extensionType || $[4] !== installationId || $[5] !== publish || $[6] !== relayEnvironment) {
        t0 = {
            openRovo: async (t1)=>{
                const { agentKey: agentKey, agentName: agentName, prompt: prompt, sourceAppId: sourceAppId, sourceInstallationId: sourceInstallationId, sourceEnvironmentId: sourceEnvironmentId } = t1;
                const product = (0, $eet9L.getRovoProductFromExtensionType)(extensionType);
                if (!cloudId || !product) return false;
                const effectiveAppId = sourceAppId || appId;
                const effectiveInstallationId = sourceInstallationId || installationId;
                const effectiveEnvironmentId = sourceEnvironmentId || environmentId;
                const isForgeAgent = agentName && agentKey;
                const publishEventDetails = {
                    type: $6c731e8388540731$var$ROVO_EVENT_TYPE,
                    product: product,
                    source: $6c731e8388540731$var$FORGE_SOURCE
                };
                let agentIdConfig;
                if (isForgeAgent) agentIdConfig = {
                    agentExternalConfigReference: $6c731e8388540731$var$makeForgeAgentExternalConfigReference(effectiveAppId, effectiveInstallationId, effectiveEnvironmentId, agentKey)
                };
                else {
                    const agentId = agentName && !agentKey ? await (0, $3xKHi.getRovoAgentId)({
                        agentAppId: effectiveAppId,
                        cloudId: cloudId,
                        input: {
                            name: agentName
                        },
                        product: product,
                        agentKey: agentKey,
                        relayEnvironment: relayEnvironment
                    }) : (0, $3xKHi.DEFAULT_AGENT_REFERENCE);
                    agentIdConfig = {
                        agentId: agentId
                    };
                }
                publish({
                    ...publishEventDetails,
                    data: {
                        dialogues: [],
                        ...agentIdConfig,
                        ...prompt ? {
                            prompt: prompt
                        } : {}
                    }
                });
            }
        };
        $[0] = appId;
        $[1] = cloudId;
        $[2] = environmentId;
        $[3] = extensionType;
        $[4] = installationId;
        $[5] = publish;
        $[6] = relayEnvironment;
        $[7] = t0;
    } else t0 = $[7];
    return t0;
} : function useRovoAgentsChat(extensionType, appId, cloudId, installationId, environmentId) {
    const publish = (0, $hdBxM.usePublish)($6c731e8388540731$var$ROVO_TOPIC);
    const relayContext = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext));
    const relayEnvironment = relayContext?.environment;
    return {
        openRovo: async ({ agentKey: agentKey, agentName: agentName, prompt: prompt, sourceAppId: sourceAppId, sourceInstallationId: sourceInstallationId, sourceEnvironmentId: sourceEnvironmentId })=>{
            const product = (0, $eet9L.getRovoProductFromExtensionType)(extensionType);
            if (!cloudId || !product) return false;
            // Use sourceAppId if provided (from embedded macro forwarding), otherwise use the captured appId
            const effectiveAppId = sourceAppId || appId;
            const effectiveInstallationId = sourceInstallationId || installationId;
            const effectiveEnvironmentId = sourceEnvironmentId || environmentId;
            const isForgeAgent = agentName && agentKey;
            const publishEventDetails = {
                type: $6c731e8388540731$var$ROVO_EVENT_TYPE,
                product: product,
                source: $6c731e8388540731$var$FORGE_SOURCE
            };
            let agentIdConfig;
            if (isForgeAgent) agentIdConfig = {
                agentExternalConfigReference: $6c731e8388540731$var$makeForgeAgentExternalConfigReference(effectiveAppId, effectiveInstallationId, effectiveEnvironmentId, agentKey)
            };
            else {
                // If agent name is not provided use default rovo chat agent
                const agentId = agentName && !agentKey ? await (0, $3xKHi.getRovoAgentId)({
                    agentAppId: effectiveAppId,
                    cloudId: cloudId,
                    input: {
                        name: agentName
                    },
                    product: product,
                    agentKey: agentKey,
                    relayEnvironment: relayEnvironment
                }) : (0, $3xKHi.DEFAULT_AGENT_REFERENCE);
                agentIdConfig = {
                    agentId: agentId
                };
            }
            publish({
                ...publishEventDetails,
                data: {
                    dialogues: [],
                    ...agentIdConfig,
                    ...prompt ? {
                        prompt: prompt
                    } : {}
                }
            });
        }
    };
};
module.exports["useRovoAgentsChat"] = $6c731e8388540731$export$1b9e058b7e689de;

});

parcelRegister("4pyQd", function(module, exports) {
const $bbabfafd56dccb42$export$c58c2ef6cd7b14a1 = (appId, accountId)=>!!window['__consentedApps']?.[`${appId}:${accountId}`];
const $bbabfafd56dccb42$export$8d4e05c53de89926 = (appId, accountId)=>{
    window.__consentedApps = window.__consentedApps || {};
    window.__consentedApps[`${appId}:${accountId}`] = true;
};
module.exports["isAppConsentedLocally"] = $bbabfafd56dccb42$export$c58c2ef6cd7b14a1;
module.exports["setAppConsentLocal"] = $bbabfafd56dccb42$export$8d4e05c53de89926;

});

parcelRegister("fmBaq", function(module, exports) {

var $iGKcz = parcelRequire("iGKcz");

var $5cSJl = parcelRequire("5cSJl");

const $b5737541e06de773$var$globalEdgeUrlMap = {
    dev: 'dev.services.atlassian.com',
    stg: 'stg.services.atlassian.com',
    prod: 'services.atlassian.com'
};
const $b5737541e06de773$var$getBaseUrl = (environment)=>{
    const baseUrl = $b5737541e06de773$var$globalEdgeUrlMap[environment];
    if (!baseUrl) throw new Error(`Invalid environment: ${environment}`);
    const service = 'forge-outbound-proxy';
    const url = `https://${service}.${baseUrl}`;
    return url;
};
const $b5737541e06de773$export$e02fc95a45760598 = async (appId, user, config, environment, contextToken)=>{
    const init = {
        method: 'POST',
        headers: {
            'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(),
            'Content-Type': 'application/json',
            Authentication: `Bearer ${contextToken}`
        },
        body: JSON.stringify({
            user: user,
            config: config,
            appId: appId
        })
    };
    const url = $b5737541e06de773$var$getBaseUrl((0, $5cSJl.getCDNEnvironment)(environment)) + '/client/feature-flags';
    const response = await fetch(url, init);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
};
module.exports["getFeatureFlags"] = $b5737541e06de773$export$e02fc95a45760598;

});

parcelRegister("9ZDPN", function(module, exports) {

var $hOxRx = parcelRequire("hOxRx");


var $6SsN4 = parcelRequire("6SsN4");


var $iGKcz = parcelRequire("iGKcz");

const $b1c08d07a593ce50$export$44a0e63a6f1a626c = async (input)=>{
    const { relayEnvironment: relayEnvironment, ...metricInput } = input;
    return new Promise((resolve)=>{
        // Resolve at most once; the metric is fire-and-forget so the response is ignored.
        let settled = false;
        const finish = ()=>{
            if (settled) return;
            settled = true;
            resolve();
        };
        (0, $6SsN4.commitMutation)(relayEnvironment, {
            mutation: (0, $hOxRx.default),
            variables: {
                input: metricInput
            },
            cacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)()
                    }
                }
            },
            // Fire-and-forget: the response is intentionally ignored.
            onCompleted: finish,
            // Silent fail: emitting a metric must never surface an error to the app.
            onError: finish
        });
    });
};
module.exports["emitFrontendCustomMetric"] = $b1c08d07a593ce50$export$44a0e63a6f1a626c;

});

parcelRegister("7arEA", function(module, exports) {

var $ccsIO = parcelRequire("ccsIO");


var $6SsN4 = parcelRequire("6SsN4");


var $iGKcz = parcelRequire("iGKcz");

const $3fa74d4c96fd2a12$export$66162721dda152ac = (input)=>{
    const { relayEnvironment: relayEnvironment, appId: appId, installationId: installationId, contextAri: contextAri, extensionId: extensionId, logs: logs } = input;
    const mutationInput = {
        installationId: installationId,
        context: {
            appId: appId,
            installationId: installationId,
            contextAri: contextAri,
            extensionId: extensionId,
            userAgent: globalThis.navigator?.userAgent ?? ''
        },
        logs: logs.map((log)=>({
                logId: crypto.randomUUID(),
                msg: log.msg,
                args: log.args,
                lvl: log.lvl,
                errorType: log.errorType,
                timestamp: log.timestamp,
                logSource: log.logSource
            }))
    };
    return new Promise((resolve)=>{
        (0, $6SsN4.commitMutation)(relayEnvironment, {
            mutation: (0, $ccsIO.default),
            variables: {
                input: mutationInput
            },
            cacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)()
                    }
                }
            },
            onCompleted: ()=>resolve(),
            onError: ()=>resolve()
        });
    });
};
module.exports["emitFrontendLogs"] = $3fa74d4c96fd2a12$export$66162721dda152ac;

});

parcelRegister("f96Dm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $h5Ejh = parcelRequire("h5Ejh");


var $iGKcz = parcelRequire("iGKcz");


var $6SsN4 = parcelRequire("6SsN4");

const $ce01df2c0a1a3f30$export$f31e7455041d7e13 = ({ loading: loading, data: data })=>{
    if (!loading) return data?.appActiveTunnels?.customUI;
    return undefined;
};
const $ce01df2c0a1a3f30$export$fe132995f21ca9ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (options)=>{
    const $ = (0, $bDgLe.c)(16);
    const { appId: appId, environmentId: environmentId } = options;
    let t0;
    let t1;
    let t2;
    let t3;
    if ($[0] !== appId || $[1] !== environmentId || $[2] !== options.contextIds) {
        const contextIds = options.contextIds ?? [];
        t1 = (0, $6SsN4.useLazyLoadQuery);
        t2 = (0, $h5Ejh.default);
        if ($[7] !== appId || $[8] !== environmentId) {
            t3 = {
                appId: appId,
                environmentId: environmentId
            };
            $[7] = appId;
            $[8] = environmentId;
            $[9] = t3;
        } else t3 = $[9];
        t0 = (0, $iGKcz.createAtlAttributionHeader)(contextIds.sort().join());
        $[0] = appId;
        $[1] = environmentId;
        $[2] = options.contextIds;
        $[3] = t0;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else {
        t0 = $[3];
        t1 = $[4];
        t2 = $[5];
        t3 = $[6];
    }
    let t4;
    if ($[10] !== t0) {
        t4 = {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        "atl-attribution": t0
                    }
                }
            }
        };
        $[10] = t0;
        $[11] = t4;
    } else t4 = $[11];
    const data = t1(t2, t3, t4);
    let t5;
    if ($[12] !== data?.appActiveTunnels?.customUI) {
        t5 = data?.appActiveTunnels?.customUI ?? [];
        $[12] = data?.appActiveTunnels?.customUI;
        $[13] = t5;
    } else t5 = $[13];
    const tunnels = t5;
    let t6;
    if ($[14] !== tunnels) {
        t6 = {
            tunnels: tunnels,
            loading: false
        };
        $[14] = tunnels;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : (options)=>{
    const { appId: appId, environmentId: environmentId } = options;
    const contextIds = options.contextIds ?? [];
    /* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/no-wrapping-hooks */ const data = (0, $6SsN4.useLazyLoadQuery)((0, $h5Ejh.default), {
        appId: appId,
        environmentId: environmentId
    }, {
        networkCacheConfig: {
            metadata: {
                headers: {
                    'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(contextIds.sort().join())
                }
            }
        }
    });
    /* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/no-wrapping-hooks */ const tunnels = data?.appActiveTunnels?.customUI ?? [];
    return {
        tunnels: tunnels,
        loading: false
    };
};
module.exports["useCustomUITunnelsListRelay"] = $ce01df2c0a1a3f30$export$fe132995f21ca9ac;

});

parcelRegister("10qVl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5xQdV = parcelRequire("5xQdV");


var $cVuzC = parcelRequire("cVuzC");


var $4pyQd = parcelRequire("4pyQd");

const $4109601e59b7cf74$var$defaultComponents = {
    ThreeLOPrompt: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVuzC.default), props)
};
const $4109601e59b7cf74$export$3be8e8bcb6b54c3e = ({ extension: extension, appId: appId, accountId: accountId, components: components, onLoad: onLoad, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, overlayController: overlayController })=>{
    const { ThreeLOPrompt: ThreeLOPrompt } = components ? components($4109601e59b7cf74$var$defaultComponents) : $4109601e59b7cf74$var$defaultComponents;
    const { consentUrl: consentUrl, requiresUserConsent: requiresUserConsent, currentUserConsent: currentUserConsent } = extension;
    const appIsAuthenticated = (0, $4pyQd.isAppConsentedLocally)(appId, accountId);
    const [userConsentRequired, setUserConsentRequired] = (0, $cozmU.useState)(!!(consentUrl && !currentUserConsent && requiresUserConsent && !appIsAuthenticated));
    // Queue of pending retries across concurrent runtime 3LO prompts.
    const invokeRetriesRef = (0, $cozmU.useRef)([]);
    // Always-current values so callbacks created inside effects and renderThreeLOPrompt
    // always reference the latest props without stale closure issues.
    const latestRef = (0, $cozmU.useRef)({
        ThreeLOPrompt: ThreeLOPrompt,
        overlayController: overlayController,
        setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
        setShouldShowRenderer: setShouldShowRenderer,
        extension: extension,
        appId: appId,
        accountId: accountId,
        consentUrl: consentUrl,
        onLoad: onLoad
    });
    latestRef.current = {
        ThreeLOPrompt: ThreeLOPrompt,
        overlayController: overlayController,
        setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
        setShouldShowRenderer: setShouldShowRenderer,
        extension: extension,
        appId: appId,
        accountId: accountId,
        consentUrl: consentUrl,
        onLoad: onLoad
    };
    // Shared presenter — shows <ThreeLOPrompt> via overlayController and handles
    // the common teardown (hide overlay, restore visibility + renderer) before
    // delegating to the caller-specific `onConsented` callback.
    const showThreeLOPrompt = (0, $5xQdV.useCallbackOne)((authUrl, onConsented)=>{
        const { ThreeLOPrompt: ThreeLOPrompt_0, overlayController: overlayController_0, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible_0, setShouldShowRenderer: setShouldShowRenderer_0, extension: extension_0 } = latestRef.current;
        overlayController_0.show(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ThreeLOPrompt_0, {
            authUrl: authUrl,
            onSuccess: async ()=>{
                overlayController_0.hide();
                setIsThreeLOPromptVisible_0(false);
                setShouldShowRenderer_0?.(true);
                await onConsented();
            },
            metadata: {
                moduleType: extension_0.type
            }
        }), true);
        setIsThreeLOPromptVisible_0(true);
        setShouldShowRenderer_0?.(false);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!userConsentRequired) return;
        const { appId: appId_0, accountId: accountId_0, consentUrl: consentUrl_0, onLoad: onLoad_0 } = latestRef.current;
        showThreeLOPrompt(consentUrl_0, async ()=>{
            setUserConsentRequired(false);
            (0, $4pyQd.setAppConsentLocal)(appId_0, accountId_0);
        });
        onLoad_0?.();
    }, [
        userConsentRequired,
        showThreeLOPrompt
    ]);
    // Stable handler — created once, reads all values via latestRef at call time.
    const renderThreeLOPrompt = (0, $5xQdV.useCallbackOne)((authUrl_0, retry)=>new Promise((resolve)=>{
            invokeRetriesRef.current.push(retry);
            showThreeLOPrompt(authUrl_0, async ()=>{
                resolve();
                try {
                    await Promise.all(invokeRetriesRef.current.map((r)=>r()));
                } finally{
                    invokeRetriesRef.current = [];
                }
            });
        }), [
        showThreeLOPrompt
    ]);
    return {
        userConsentRequired: userConsentRequired,
        renderThreeLOPrompt: renderThreeLOPrompt
    };
};
module.exports["useInitialAppState"] = $4109601e59b7cf74$export$3be8e8bcb6b54c3e;

});

parcelRegister("dgxed", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lvKd7 = parcelRequire("lvKd7");


var $8yKod = parcelRequire("8yKod");


var $givIf = parcelRequire("givIf");


var $eYWSl = parcelRequire("eYWSl");


var $bxg0J = parcelRequire("bxg0J");


var $4Yn0i = parcelRequire("4Yn0i");

const $a4009bccb103a8ee$export$aaaa1ba4b40a0c2f = ({ extension: extension, getBridgeContext: getBridgeContext, legacyCustomBridgeMethods: legacyCustomBridgeMethods, customBridge: customBridge })=>{
    const isCustomUIBodiedMacro = (0, $8yKod.isCustomUI)(extension) && extension.properties?.layout === 'bodied';
    // Legacy (v1) methods are tracked live because some modules recreate them after initial render.
    const getLegacyCustomBridgeMethods = (0, $bxg0J.useLiveMethodMap)(legacyCustomBridgeMethods);
    (0, $cozmU.useEffect)(()=>{
        if (!isCustomUIBodiedMacro) return;
        // withEmbeddedMacroContext is injected as the outermost middleware so it:
        //  - unwraps the { embeddedMacroContext, payload } envelope before withMetrics sees it
        //  - provides the correctly merged context (embedded macro identity over host context)
        //    to withMetrics and all inner methods — no mutable refs or manual BridgeFeatures
        //    reconstruction needed.
        const bridgeFeatures = (0, $givIf.createBridgeFeatures)(getBridgeContext, (baseBridgeMethods)=>(0, $eYWSl.consolidateCustomBridge)(baseBridgeMethods, getLegacyCustomBridgeMethods(), // v2 customBridge is a stable-reference contract — passed through directly, not tracked live.
            customBridge), (defaults)=>[
                (0, $4Yn0i.withEmbeddedMacroContext),
                ...defaults
            ]);
        const connection = (0, $lvKd7.createEmbeddedMacroListener)(bridgeFeatures);
        return ()=>{
            connection?.close();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- getBridgeContext and getLegacyCustomBridgeMethods are stable; customBridge is a stable-reference contract captured at listener setup
    }, [
        isCustomUIBodiedMacro
    ]);
};
module.exports["useEmbeddedMacroConnection"] = $a4009bccb103a8ee$export$aaaa1ba4b40a0c2f;

});

parcelRegister("2PcLo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $iDrrr = parcelRequire("iDrrr");


var $8yKod = parcelRequire("8yKod");

const $df1e34c4e4db87cf$var$MACRO_MODULE_NAME = 'xen:macro';
// True in config mode only. Both locations are read because
// `forge-ui-move-macro-data-to-extension-data` moves macro data from extensionPayload to extensionData.
const $df1e34c4e4db87cf$var$getIsConfiguringMacro = ({ extensionData: extensionData, extensionPayload: extensionPayload })=>Boolean(extensionPayload?.macro?.isConfiguring || extensionData?.macro?.isConfiguring);
const $df1e34c4e4db87cf$export$66459c0e0b3813a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, onChange: onChange, reloadIframe: reloadIframe } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== extensionData || $[2] !== extensionPayload) {
        t1 = extension.type === $df1e34c4e4db87cf$var$MACRO_MODULE_NAME && (0, $8yKod.isCustomUI)(extension) && !$df1e34c4e4db87cf$var$getIsConfiguringMacro({
            extensionData: extensionData,
            extensionPayload: extensionPayload
        });
        $[0] = extension;
        $[1] = extensionData;
        $[2] = extensionPayload;
        $[3] = t1;
    } else t1 = $[3];
    const isReloadableCustomUIMacro = t1;
    let t2;
    let t3;
    if ($[4] !== isReloadableCustomUIMacro || $[5] !== onChange || $[6] !== reloadIframe) {
        t2 = ()=>{
            if (!(0, $iDrrr.fg)("forge-ui-bridge-v2-macro-config-reload") || !isReloadableCustomUIMacro) return;
            return onChange((prev, next, changes)=>{
                if (!changes.extensionPayloadChanges.config) return;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(prev.extensionPayload?.config, next.extensionPayload?.config)) return;
                reloadIframe();
            });
        };
        t3 = [
            isReloadableCustomUIMacro,
            onChange,
            reloadIframe
        ];
        $[4] = isReloadableCustomUIMacro;
        $[5] = onChange;
        $[6] = reloadIframe;
        $[7] = t2;
        $[8] = t3;
    } else {
        t2 = $[7];
        t3 = $[8];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, onChange: onChange, reloadIframe: reloadIframe })=>{
    const isReloadableCustomUIMacro = extension.type === $df1e34c4e4db87cf$var$MACRO_MODULE_NAME && (0, $8yKod.isCustomUI)(extension) && !$df1e34c4e4db87cf$var$getIsConfiguringMacro({
        extensionData: extensionData,
        extensionPayload: extensionPayload
    });
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('forge-ui-bridge-v2-macro-config-reload') || !isReloadableCustomUIMacro) return;
        return onChange((prev, next, changes)=>{
            // extensionPayloadChanges is a reference pre-filter only — verify the value changed.
            if (!changes.extensionPayloadChanges.config) return;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(prev.extensionPayload?.config, next.extensionPayload?.config)) return;
            reloadIframe();
        });
    }, [
        isReloadableCustomUIMacro,
        onChange,
        reloadIframe
    ]);
};
module.exports["useReloadOnMacroConfigChange"] = $df1e34c4e4db87cf$export$66459c0e0b3813a4;

});

parcelRegister("c0YtQ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $j3WkY = parcelRequire("j3WkY");

const $c46558a211f74909$export$31553aaa555c1514 = async ({ viewContext: viewContext })=>{
    return viewContext;
};
const $c46558a211f74909$export$468cda29b159ee5d = async ({ services: { invoker: invoker, getContextToken: getContextToken, tracing: tracing, onThreeLO: onThreeLO }, resolverContext: resolverContext, extensionPayload: extensionPayload, contextIds: contextIds }, data)=>{
    // A single resolver call: returns the success body, signals that user consent is
    // required (without prompting), or throws for any other backend error.
    const attemptInvoke = async ()=>{
        const contextToken = await getContextToken({
            contextIdsOverride: contextIds
        });
        tracing.recordGqlCall('invokeExtension - start');
        // Subtract, never reconstruct: `metadata` is a frontend-only flag (it shapes the response,
        // see below), everything else is forwarded as-is. Enumerating fields here silently dropped
        // the endpoint-invocation fields — root cause of PIRA-8624. Passthrough is asserted per
        // shape in `__tests__/invoke-call-shapes.test-utils.ts`; extend that, not this line.
        const { metadata: metadata, ...call } = data;
        const { data: gqlData } = await invoker({
            call: call,
            context: {
                ...resolverContext
            },
            extensionPayload: extensionPayload,
            contextToken: contextToken
        });
        const resp = gqlData?.invokeExtension;
        if (!resp?.success) {
            const error = resp?.errors?.[0];
            if (error?.extensions.errorType === 'USER_CONSENT_REQUIRED') return {
                authUrl: error?.extensions.fields?.authInfoUrl,
                status: 'consent'
            };
            const message = error?.message ?? 'An error occurred while trying to invoke.';
            // Carry the errorType so the withErrorDisplay middleware can classify and
            // (for display-worthy types) surface an error message. Still throws either way.
            if (error?.extensions.errorType) throw new (0, $j3WkY.ForgeAppError)(error.extensions.errorType, message);
            throw new Error(message);
        }
        tracing.recordGqlCall('invokeExtension - end');
        if (!!metadata && (0, $iDrrr.fg)('forge-ui-return-invocation-metadata')) {
            const optsInToRateLimitProperties = metadata.rateLimitProperties === true;
            return {
                result: {
                    body: resp.response?.body ?? {},
                    metadata: {
                        ...optsInToRateLimitProperties ? {
                            rateLimitProperties: resp.rateLimitProperties ?? null
                        } : {}
                    }
                },
                status: 'ok'
            };
        }
        return {
            result: resp.response?.body ?? {},
            status: 'ok'
        };
    };
    const first = await attemptInvoke();
    if (first.status === 'ok') return first.result;
    // USER_CONSENT_REQUIRED: prompt for consent, then retry the resolver exactly once.
    // A second consent-required is terminal (matches v1) — re-prompting here would loop
    // indefinitely if the backend keeps requesting consent.
    return new Promise((resolve, reject)=>{
        onThreeLO(first.authUrl, async ()=>{
            try {
                const retried = await attemptInvoke();
                if (retried.status === 'ok') resolve(retried.result);
                else reject(new Error('User consent was required again after consenting.'));
            } catch (e) {
                reject(e);
            }
        }).catch(reject);
    });
};
const $c46558a211f74909$export$34bfdcdeb272e2c2 = async ({ extension: extension })=>{
    return extension.properties?.frameId ?? null;
};
const $c46558a211f74909$export$32da5b5043dcd88c = async ()=>{
    window.location.reload();
};
module.exports["getContext"] = $c46558a211f74909$export$31553aaa555c1514;
module.exports["invoke"] = $c46558a211f74909$export$468cda29b159ee5d;
module.exports["getFrameId"] = $c46558a211f74909$export$34bfdcdeb272e2c2;
module.exports["reload"] = $c46558a211f74909$export$32da5b5043dcd88c;

});

parcelRegister("4hk2D", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $fmBaq = parcelRequire("fmBaq");


var $9ytZz = parcelRequire("9ytZz");


var $7rglu = parcelRequire("7rglu");

const $d17ee846b768b58d$var$fireFeatureFlagAnalyticsEvent = (tracker, extension, appId, params)=>{
    tracker.trackForgeFeatureFlagEvent({
        appType: (0, $7rglu.getAppType)(extension),
        appId: appId,
        baseUrl: window.location.origin,
        forgeEnvironment: extension.environmentType,
        ...params
    });
};
const $d17ee846b768b58d$export$f9d0db67c92b2ab2 = async (context, payload)=>{
    const { extensionDetails: { appId: appId }, extension: extension, contextIds: contextIds, environment: environment, services: { getContextToken: getContextToken, tracing: tracing, analytics: analytics } } = context;
    if (!(0, $iDrrr.fg)('platform_forge_ff_client_sdk')) return {};
    const contextToken = await getContextToken({
        contextIdsOverride: contextIds
    });
    tracing.recordBridgeCall('getFeatureFlags - start');
    const featureFlagEnv = payload.user?.statsigEnvironment?.tier || (0, $9ytZz.FeatureFlagEnv).development;
    const trackInit = (success)=>{
        if ((0, $iDrrr.fg)('platform_forge_ff_ui_analytics')) $d17ee846b768b58d$var$fireFeatureFlagAnalyticsEvent(analytics.tracker, extension, appId, {
            eventType: (0, $9ytZz.FeatureFlagEventTypes).INITIALIZATION,
            success: success,
            featureFlagEnv: featureFlagEnv
        });
    };
    try {
        const resp = await (0, $fmBaq.getFeatureFlags)(appId, payload.user, payload.config, environment, contextToken);
        tracing.recordBridgeCall('getFeatureFlags - end');
        trackInit(true);
        return resp;
    } catch (err) {
        tracing.recordBridgeCall('getFeatureFlags - end');
        // eslint-disable-next-line no-console
        console.error('There were errors while initialising feature flags client ', err);
        trackInit(false);
        return {};
    }
};
const $d17ee846b768b58d$var$ALLOWED_EVENT_TYPES = [
    (0, $9ytZz.FeatureFlagEventTypes).CHECKFLAG.toUpperCase()
];
const $d17ee846b768b58d$var$isValidFeatureFlagEventPayload = (data)=>{
    if (!data.type || !$d17ee846b768b58d$var$ALLOWED_EVENT_TYPES.includes(data.type.toUpperCase())) return false;
    if (data.type.toUpperCase() === (0, $9ytZz.FeatureFlagEventTypes).CHECKFLAG.toUpperCase() && data.properties.name && (data.properties.name.length < 3 || data.properties.name.length > 50)) return false;
    if (typeof data.properties.success !== 'boolean') return false;
    if (!(data.properties.environment && data.properties.environment.toLowerCase() in (0, $9ytZz.FeatureFlagEnv))) return false;
    return true;
};
const $d17ee846b768b58d$export$40367c2ce2684f9b = async (context, data)=>{
    if (!(0, $iDrrr.fg)('platform_forge_ff_ui_analytics')) return;
    const { extensionDetails: { appId: appId }, extension: extension, services: { analytics: analytics } } = context;
    try {
        if (!$d17ee846b768b58d$var$isValidFeatureFlagEventPayload(data)) return;
        $d17ee846b768b58d$var$fireFeatureFlagAnalyticsEvent(analytics.tracker, extension, appId, {
            flagName: data.properties.name || '',
            eventType: data.type,
            success: data.properties.success,
            featureFlagEnv: data.properties.environment
        });
    } catch  {
    // all errors are ignored
    }
};
module.exports["initFeatureFlags"] = $d17ee846b768b58d$export$f9d0db67c92b2ab2;
module.exports["trackFeatureFlagEvent"] = $d17ee846b768b58d$export$40367c2ce2684f9b;

});

parcelRegister("5GHXA", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $bEbDR = parcelRequire("bEbDR");


var $9ZDPN = parcelRequire("9ZDPN");

const $08251b0dba305e46$export$44a0e63a6f1a626c = async ({ extension: extension, extensionDetails: extensionDetails, contextIds: contextIds, services: { relayEnvironment: relayEnvironment } }, payload)=>{
    if (!(0, $iDrrr.fg)('platform_forge_frontend_custom_metrics')) return;
    // No context ARI → bail. `contextIds[0]` is typed `string` but is `undefined` for an empty array.
    const contextAri = contextIds[0];
    if (!contextAri) return;
    try {
        const { moduleKey: moduleKey } = (0, $bEbDR.parseExtensionId)(extension.id);
        await (0, $9ZDPN.emitFrontendCustomMetric)({
            relayEnvironment: relayEnvironment,
            contextAri: contextAri,
            appId: extensionDetails.appId,
            installationId: extension.installationId,
            moduleKey: moduleKey,
            customMetricName: payload.customMetricName,
            value: payload.value
        });
    } catch  {
    // Silent fail: emitting a metric must never surface an error to the app.
    }
};
module.exports["emitFrontendCustomMetric"] = $08251b0dba305e46$export$44a0e63a6f1a626c;

});

parcelRegister("04D7M", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7arEA = parcelRequire("7arEA");

const $907c20a815f1758e$export$66162721dda152ac = async ({ extension: extension, extensionDetails: extensionDetails, contextIds: contextIds, services: { relayEnvironment: relayEnvironment } }, payload)=>{
    if (!(0, $iDrrr.fg)('platform_forge_frontend_logs')) return;
    const contextAri = contextIds[0];
    if (!contextAri || payload.logs.length === 0) return;
    try {
        await (0, $7arEA.emitFrontendLogs)({
            relayEnvironment: relayEnvironment,
            contextAri: contextAri,
            appId: extensionDetails.appId,
            installationId: extension.installationId,
            extensionId: extension.id,
            logs: payload.logs
        });
    } catch  {
    // Silent fail: emitting logs must never surface an error to the app.
    }
};
module.exports["emitFrontendLogs"] = $907c20a815f1758e$export$66162721dda152ac;

});

parcelRegister("j2j0X", function(module, exports) {

var $7rglu = parcelRequire("7rglu");

const $a22f76b93b48508d$export$2052623e8b7dc210 = async (context, payload)=>{
    context.services.analytics.captureUntrustedEvent(payload);
};
const $a22f76b93b48508d$export$ffaff761e5d8cf6c = async (context, payload)=>{
    context.services.analytics.captureUntrustedEvent(payload);
};
const $a22f76b93b48508d$export$d39f84faa1bc5db6 = async (context, payload)=>{
    const { extension: extension, extensionDetails: { appId: appId }, services: { analytics: analytics } } = context;
    analytics.tracker.trackObjectStoreAction({
        appType: (0, $7rglu.getAppType)(extension),
        appId: appId,
        action: payload.action,
        forgeEnvironment: extension.environmentType
    });
};
module.exports["iframeAnalytics"] = $a22f76b93b48508d$export$2052623e8b7dc210;
module.exports["ufoEvent"] = $a22f76b93b48508d$export$ffaff761e5d8cf6c;
module.exports["trackObjectStoreAction"] = $a22f76b93b48508d$export$d39f84faa1bc5db6;

});

parcelRegister("21ZKL", function(module, exports) {
/**
 * Creates a bridge method that delegates to a single `BridgeConfig` callback,
 * passing the payload through directly.
 *
 * Contract:
 *   - Callback present  → `(await callback(payload)) ?? true`
 *   - Callback absent   → `false`
 *
 * The callback is read from `bridgeConfig` at invocation time (not creation time),
 * so updates to the product's bridge prop are always reflected.
 */ const $cb3fdecab3798f28$var$createBridgeConfigDelegate = (callbackName)=>async ({ bridgeConfig: bridgeConfig }, payload)=>{
        const callback = bridgeConfig[callbackName];
        if (!callback) return false;
        return await callback(payload) ?? true;
    };
/**
 * Creates a bridge method that delegates to a single `BridgeConfig` callback,
 * re-wrapping the payload as `{ data: payload }` before forwarding.
 *
 * BAD LEGACY PAYLOAD SHAPE — do not use this for new bridge methods.
 *
 * In the legacy bridge path (postRobot), feature handlers received the raw port-rpc
 * event object `{ data: actualPayload }` and product-side `BridgeConfig` callbacks
 * were written to access `opts.data` to get the actual value. The v2 bridge
 * (`bridge-core-reset`) correctly unwraps `{ data }` before invoking the bridge
 * method — so these delegates must re-wrap to maintain backward compatibility with
 * all existing product implementations (Confluence, Jira, xen-editor-provider, etc.)
 * that were written against the legacy contract.
 *
 * New bridge methods should use `createBridgeConfigDelegate` and accept the payload
 * directly (no `.data` wrapping).
 */ const $cb3fdecab3798f28$var$createBridgeConfigDelegateForLegacyWrappedPayload = (callbackName)=>async ({ bridgeConfig: bridgeConfig }, payload)=>{
        const callback = bridgeConfig[callbackName];
        if (!callback) return false;
        return await callback({
            data: payload
        }) ?? true;
    };
/**
 * Canonical list of every `BridgeConfig` key exposed as a bridge feature.
 *
 * Keys excluded from this list (e.g. `spaPush`, `history`, `extensionBasePath`)
 * are used internally by other bridge methods and are not directly dispatched
 * from the app iframe.
 */ const $cb3fdecab3798f28$var$BRIDGE_CONFIG_DELEGATE_KEYS = [
    'changeWindowTitle',
    'close',
    'closeFlag',
    'emitReadyEvent',
    'getFrameDispatch',
    'onClose',
    'onError',
    'open',
    'openModal',
    'reconcile',
    'refresh',
    'showFlag',
    'submit'
];
const $cb3fdecab3798f28$export$4497e820804c31db = [
    'close',
    'onClose',
    'openModal',
    'submit'
];
const $cb3fdecab3798f28$export$966b3425a26d5e9f = Object.fromEntries($cb3fdecab3798f28$var$BRIDGE_CONFIG_DELEGATE_KEYS.map((key)=>[
        key,
        $cb3fdecab3798f28$export$4497e820804c31db.includes(key) ? $cb3fdecab3798f28$var$createBridgeConfigDelegateForLegacyWrappedPayload(key) : $cb3fdecab3798f28$var$createBridgeConfigDelegate(key)
    ]));
module.exports["bridgeConfigDelegates"] = $cb3fdecab3798f28$export$966b3425a26d5e9f;

});

parcelRegister("2sLfT", function(module, exports) {

var $2MUrL = parcelRequire("2MUrL");

const $39c483f8ad6aa980$export$28eb87eac4188ed6 = async ({ services: { productFetchClient: productFetchClient } }, { restPath: restPath, product: product, fetchRequestInit: fetchRequestInit, isMultipartFormData: isMultipartFormData })=>{
    const response = await productFetchClient(restPath, product, fetchRequestInit, isMultipartFormData);
    const { status: status, statusText: statusText } = response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const headers = Object.fromEntries(response.headers.entries());
    const isAttachment = (0, $2MUrL.isBinaryContentType)(response.headers.get('content-type'));
    const body = response.body ? await response.text() : undefined;
    return {
        headers: headers,
        status: status,
        statusText: statusText,
        body: body,
        isAttachment: isAttachment
    };
};
module.exports["fetchProduct"] = $39c483f8ad6aa980$export$28eb87eac4188ed6;

});

parcelRegister("6gtkV", function(module, exports) {

var $2MUrL = parcelRequire("2MUrL");

const $fb70c1569409af94$export$db36d2f1649120da = async ({ services: { getContextToken: getContextToken, remoteFetchClient: remoteFetchClient } }, { remoteKey: remoteKey, fetchRequestInit: fetchRequestInit, isMultipartFormData: isMultipartFormData })=>{
    const { path: path, ...init } = fetchRequestInit;
    const contextToken = await getContextToken();
    const response = await remoteFetchClient(remoteKey, init, isMultipartFormData, path, contextToken);
    const { status: status, statusText: statusText } = response;
    const headers = Object.fromEntries(response.headers.entries());
    const isAttachment = (0, $2MUrL.isBinaryContentType)(response.headers.get('content-type'));
    const body = response.body ? await response.text() : undefined;
    return {
        headers: headers,
        status: status,
        statusText: statusText,
        body: body,
        isAttachment: isAttachment
    };
};
module.exports["fetchRemote"] = $fb70c1569409af94$export$db36d2f1649120da;

});

parcelRegister("6cgNn", function(module, exports) {

var $gqUuL = parcelRequire("gqUuL");

const $ddb5015c148d68b5$export$cee03385e28d6243 = async ({ environment: environment, bridgeControls: bridgeControls })=>{
    bridgeControls.enableTheming();
    const currentTheme = (0, $gqUuL.getGlobalTheme)();
    bridgeControls.setTheme(currentTheme, null, environment);
};
module.exports["enableTheming"] = $ddb5015c148d68b5$export$cee03385e28d6243;

});

parcelRegister("fG2vF", function(module, exports) {

var $1uMa2 = parcelRequire("1uMa2");


var $hNQPV = parcelRequire("hNQPV");


var $852mP = parcelRequire("852mP");


var $4K6lC = parcelRequire("4K6lC");

const $55dfd5b335764d33$export$dfbfa9404d7ff498 = (0, $hNQPV.createBridgeResource)('events', ()=>({
        subscriptions: new Set()
    }), ({ subscriptions: subscriptions })=>{
    for (const sub of subscriptions)sub.unsubscribe();
    subscriptions.clear();
});
const $55dfd5b335764d33$export$af631764ddc44097 = async ({ extensionDetails: extensionDetails, claimBridgeResource: claimBridgeResource, page: page, services: { analytics: analytics } }, { event: event, callback: callback })=>{
    const state = claimBridgeResource($55dfd5b335764d33$export$dfbfa9404d7ff498);
    const subscription = (0, $1uMa2.on)(event, callback, extensionDetails);
    state.subscriptions.add(subscription);
    analytics.createAnalyticsEvent({
        eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
        data: {
            action: 'subscribed',
            actionSubject: 'bridgeEvent',
            attributes: {
                // TODO: remove the condition (and related test) once Developer UGC spec is ready
                event: event === 'JIRA_ISSUE_CHANGED' ? 'JIRA_ISSUE_CHANGED' : 'other'
            },
            source: page,
            tags: [
                'forge'
            ]
        }
    }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    return {
        unsubscribe: ()=>{
            if (state.subscriptions.delete(subscription)) subscription.unsubscribe();
        }
    };
};
const $55dfd5b335764d33$export$8f35fbd5db0f3634 = async ({ extensionDetails: extensionDetails }, { event: event, payload: payload })=>{
    (0, $1uMa2.emit)(event, payload, extensionDetails);
};
module.exports["on"] = $55dfd5b335764d33$export$af631764ddc44097;
module.exports["emit"] = $55dfd5b335764d33$export$8f35fbd5db0f3634;

});

parcelRegister("4HYkN", function(module, exports) {

var $lKlSv = parcelRequire("lKlSv");


var $eqEJl = parcelRequire("eqEJl");


var $ix7El = parcelRequire("ix7El");


var $iGKcz = parcelRequire("iGKcz");


var $hNQPV = parcelRequire("hNQPV");


var $1uMa2 = parcelRequire("1uMa2");

const $7486a51bb61001dd$export$fc4b2a656c4af0a2 = (0, $hNQPV.createBridgeResource)('public-events', ()=>({
        subscriptions: new Set()
    }), ({ subscriptions: subscriptions })=>{
    for (const sub of subscriptions)sub.unsubscribe();
    subscriptions.clear();
});
// ─── Cache ────────────────────────────────────────────────────────────────────
/**
 * Module-level cache of allowed-recipients lists keyed on the sorted, joined
 * contextIds string. Sorting makes the key order-independent; joining with
 * a null byte avoids false collisions between adjacent entries.
 * The number of distinct keys in a session is bounded by the number of distinct
 * page contexts visited, so there is no meaningful memory growth.
 *
 * Exposed via `clearAllowedRecipientsCache` for test teardown.
 */ const $7486a51bb61001dd$var$allowedRecipientsCache = new Map();
const $7486a51bb61001dd$export$28205a69263b59e6 = ()=>$7486a51bb61001dd$var$allowedRecipientsCache.clear();
// ─── GQL constants ────────────────────────────────────────────────────────────
const $7486a51bb61001dd$var$CORE_EVENT = 'core:event';
const $7486a51bb61001dd$var$CLIENT_EVENTS = 'client-events';
const $7486a51bb61001dd$var$CLIENT_EVENT = 'client-event';
const $7486a51bb61001dd$var$EVENT_PREFIX = 'forge.bridge.';
// ─── Shared helpers ───────────────────────────────────────────────────────────
/**
 * Mirrors `filterAllowedRecipients` in `useEmitPublicEvent.ts`.
 * Finds the `core:event` extension for this app with key `client-events` or
 * `client-event`, extracts the `allowedRecipients` property. The `*` wildcard
 * is not supported — it is discarded rather than treated as "broadcast to all".
 * Converts full ARIs to bare app IDs (last `/`-segment), and unconditionally
 * appends the sender's own `appId` so the emitting extension always receives
 * its own public events.
 */ const $7486a51bb61001dd$var$filterAllowedRecipients = (allExtensions, extension)=>{
    const matchingExtension = allExtensions.find((ext)=>ext.appId && ext.key && ext.appId === extension.appId && (ext.key === $7486a51bb61001dd$var$CLIENT_EVENTS || ext.key === $7486a51bb61001dd$var$CLIENT_EVENT));
    const allowedRecipients = matchingExtension?.properties?.allowedRecipients ?? [];
    const filtered = allowedRecipients.filter((r)=>r !== '*').map((r)=>r.split('/').at(-1) ?? r);
    if (!filtered.includes(extension.appId)) filtered.push(extension.appId);
    return filtered;
};
/**
 * Fetches the allowed-recipients list for `emitPublic` by querying the
 * `core:event` extension manifest via Relay. Falls back to `[extensionDetails.appId]`
 * on network error so public events always reach the sending extension at minimum.
 */ const $7486a51bb61001dd$var$fetchAllowedRecipients = (relayEnvironment, contextIds, extensionDetails)=>{
    const observable = (0, $eqEJl.fetchQuery)(relayEnvironment, (0, $lKlSv.default), {
        contextIds: contextIds,
        filter: [
            {
                type: (0, $ix7El.GQLExtensionContextsFilterType).ExtensionType,
                value: [
                    $7486a51bb61001dd$var$CORE_EVENT
                ]
            }
        ]
    }, {
        networkCacheConfig: {
            metadata: {
                headers: {
                    'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)()
                }
            }
        }
    });
    return new Promise((resolve)=>{
        observable.subscribe({
            next: (result)=>{
                const allExtensions = result?.extensionContexts?.[0]?.extensions ?? [];
                resolve($7486a51bb61001dd$var$filterAllowedRecipients(Array.from(allExtensions), extensionDetails));
            },
            error: ()=>{
                resolve([
                    extensionDetails.appId
                ]);
            }
        });
    });
};
const $7486a51bb61001dd$var$getOrFetchAllowedRecipients = async (relayEnvironment, contextIds, extensionDetails)=>{
    const cacheKey = [
        ...contextIds
    ].sort().join('\0');
    if (!$7486a51bb61001dd$var$allowedRecipientsCache.has(cacheKey)) {
        const recipients = await $7486a51bb61001dd$var$fetchAllowedRecipients(relayEnvironment, contextIds, extensionDetails);
        $7486a51bb61001dd$var$allowedRecipientsCache.set(cacheKey, recipients);
        return recipients;
    }
    return $7486a51bb61001dd$var$allowedRecipientsCache.get(cacheKey);
};
const $7486a51bb61001dd$export$2b8594f1cc80daad = async ({ extensionDetails: extensionDetails, claimBridgeResource: claimBridgeResource }, { event: event, callback: callback })=>{
    const state = claimBridgeResource($7486a51bb61001dd$export$fc4b2a656c4af0a2);
    const subscription = (0, $1uMa2.onPublic)(event, callback, extensionDetails);
    state.subscriptions.add(subscription);
    return {
        unsubscribe: ()=>{
            if (state.subscriptions.delete(subscription)) subscription.unsubscribe();
        }
    };
};
const $7486a51bb61001dd$export$343310a09924dfa5 = async ({ contextIds: contextIds, extensionDetails: extensionDetails, services: { relayEnvironment: relayEnvironment } }, { event: event, payload: payload })=>{
    const allowedRecipients = await $7486a51bb61001dd$var$getOrFetchAllowedRecipients(relayEnvironment, contextIds, extensionDetails);
    const newEvent = new CustomEvent(`${$7486a51bb61001dd$var$EVENT_PREFIX}${event}`, {
        detail: {
            extension: extensionDetails,
            payload: payload,
            allowedRecipients: allowedRecipients
        }
    });
    window.document.dispatchEvent(newEvent);
};
module.exports["onPublic"] = $7486a51bb61001dd$export$2b8594f1cc80daad;
module.exports["emitPublic"] = $7486a51bb61001dd$export$343310a09924dfa5;

});

parcelRegister("dQO8T", function(module, exports) {

var $iXYFx = parcelRequire("iXYFx");


var $iIo47 = parcelRequire("iIo47");


var $6SsN4 = parcelRequire("6SsN4");


var $iGKcz = parcelRequire("iGKcz");


var $fccjA = parcelRequire("fccjA");


var $i2Kmi = parcelRequire("i2Kmi");


var $ha1mA = parcelRequire("ha1mA");


var $hNQPV = parcelRequire("hNQPV");

const $6c7339072212c6d0$export$77e681b21805710f = (0, $hNQPV.createBridgeResource)('realtime', ()=>({
        activeSubscriptions: new Map()
    }), (state)=>{
    for (const { subscription: subscription } of state.activeSubscriptions.values())if (!subscription.closed) subscription.unsubscribe();
    state.activeSubscriptions.clear();
});
const $6c7339072212c6d0$var$getChannelKey = (context)=>{
    return Object.entries(context).sort((a, b)=>a[0].localeCompare(b[0])).toString();
};
/**
 * Computes the extension context hash used to scope realtime channels.
 * Matches the hash computed by the backend Realtime service and the legacy InnerIframe.tsx.
 */ const $6c7339072212c6d0$var$computeExtensionContext = (resolverContext)=>{
    try {
        const { modal: _modal, ...productExtensionData } = resolverContext.extension ?? {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($iIo47)))(productExtensionData);
    } catch  {
        // eslint-disable-next-line no-console
        console.error('Product context is not a serializable object.');
        return '';
    }
};
const $6c7339072212c6d0$export$361c332a01480dda = async (context, payload)=>{
    const { extension: extension, claimBridgeResource: claimBridgeResource, resolverContext: resolverContext, services: { getContextToken: getContextToken } } = context;
    const realtimeState = claimBridgeResource($6c7339072212c6d0$export$77e681b21805710f);
    const { onEvent: onEvent, channelName: channelName, options: options, isGlobal: isGlobal } = payload;
    const { token: token } = options || {};
    if (token) {
        const validation = (0, $ha1mA.validateRealtimeChannelToken)(token, {
            requiredPermission: 'subscribe',
            channelName: channelName
        });
        if (!validation.valid) return Promise.reject(new Error(`Realtime token validation failed: ${validation.error}`));
    }
    const extensionContext = $6c7339072212c6d0$var$computeExtensionContext(resolverContext);
    const channelContext = options?.contextOverrides ? JSON.stringify({
        context: extensionContext,
        contextOverrides: options?.contextOverrides
    }) : extensionContext;
    const channelKey = $6c7339072212c6d0$var$getChannelKey({
        channelName: channelName,
        isGlobal: isGlobal,
        channelContext: channelContext
    });
    const existingEntry = realtimeState.activeSubscriptions.get(channelKey);
    if (existingEntry) {
        existingEntry.subscription.addCallback(onEvent);
        onEvent('SUBSCRIPTION_STARTED');
    } else {
        const createSubscription = async ()=>{
            const subscriptionPayload = (0, $fccjA.getSubscribePayload)({
                // getSubscribePayload expects the v1-shaped { data: {...} } envelope.
                payload: {
                    data: payload
                },
                context: channelContext,
                installationId: extension.installationId,
                contextToken: await getContextToken()
            });
            // Declare before subscribe() so the sink closures can reference it.
            // Assignment happens synchronously before any sink callbacks fire.
            let subscription;
            subscription = (0, $i2Kmi.subscribe)(subscriptionPayload, {
                next: (result)=>{
                    subscription.onNext(result.data.ecosystem?.realtimeChannel?.payload);
                },
                error: async (err)=>{
                    const error = Array.isArray(err) ? err[0] : err;
                    if (error?.extensions?.statusCode === 429) {
                        subscription.onError(new Error('RATE_LIMIT_EXCEEDED'));
                        return;
                    }
                    const shouldRetrySubscribe = error?.message === 'FCT has expired on subscribe request';
                    if (shouldRetrySubscribe) try {
                        const callbacksToCopy = [
                            ...subscription.subscriptionCallbacks
                        ];
                        await createSubscription();
                        const newEntry = realtimeState.activeSubscriptions.get(channelKey);
                        if (newEntry) newEntry.subscription.subscriptionCallbacks = callbacksToCopy;
                        subscription.unsubscribe();
                        // The new subscription is already at channelKey — don't delete the map entry.
                        return;
                    } catch (retryError) {
                        subscription.onError(retryError);
                        if (realtimeState.activeSubscriptions.get(channelKey)?.subscription === subscription) realtimeState.activeSubscriptions.delete(channelKey);
                        if (!subscription.closed) subscription.unsubscribe();
                        return;
                    }
                    subscription.onError(error);
                    if (realtimeState.activeSubscriptions.get(channelKey)?.subscription === subscription) realtimeState.activeSubscriptions.delete(channelKey);
                    if (!subscription.closed) subscription.unsubscribe();
                },
                complete: ()=>{
                    if (realtimeState.activeSubscriptions.get(channelKey)?.subscription === subscription) realtimeState.activeSubscriptions.delete(channelKey);
                    if (!subscription.closed) subscription.unsubscribe();
                }
            }, onEvent);
            realtimeState.activeSubscriptions.set(channelKey, {
                subscription: subscription
            });
            return subscription;
        };
        createSubscription();
    }
    return {
        unsubscribe: ()=>{
            const entry = realtimeState.activeSubscriptions.get(channelKey);
            if (entry) {
                entry.subscription.removeCallback(onEvent);
                if (entry.subscription.subscriptionCallbacks.length === 0) {
                    realtimeState.activeSubscriptions.delete(channelKey);
                    if (!entry.subscription.closed) entry.subscription.unsubscribe();
                }
            }
        }
    };
};
const $6c7339072212c6d0$export$50666a6a6eccdc2e = async (context, payload)=>{
    const { extension: extension, resolverContext: resolverContext, services: { getContextToken: getContextToken, relayEnvironment: relayEnvironment } } = context;
    const extensionContext = $6c7339072212c6d0$var$computeExtensionContext(resolverContext);
    const contextToken = await getContextToken();
    const { channelName: channelName, isGlobal: isGlobal, options: options } = payload;
    const { token: token, contextOverrides: contextOverrides } = options || {};
    if (token) {
        const validation = (0, $ha1mA.validateRealtimeChannelToken)(token, {
            requiredPermission: 'publish',
            channelName: channelName
        });
        if (!validation.valid) return {
            eventId: null,
            eventTimestamp: null,
            errors: [
                {
                    message: `Realtime token validation failed: ${validation.error}`
                }
            ]
        };
    }
    const eventPayload = JSON.stringify(payload.eventPayload);
    const channelContext = contextOverrides ? JSON.stringify({
        context: extensionContext,
        contextOverrides: contextOverrides
    }) : extensionContext;
    return new Promise((resolve, reject)=>{
        (0, $6SsN4.commitMutation)(relayEnvironment, {
            mutation: (0, $iXYFx.default),
            variables: {
                installationId: extension.installationId,
                name: channelName,
                payload: eventPayload,
                context: channelContext,
                isGlobal: isGlobal ?? false,
                token: token
            },
            cacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(),
                        ...contextToken ? {
                            'x-forge-context-token': contextToken
                        } : {},
                        'x-rate-limit-app-id': extension.appId,
                        'x-rate-limit-installation-id': extension.installationId
                    }
                }
            },
            onCompleted: (data, errors)=>{
                if (errors) return resolve({
                    eventId: null,
                    eventTimestamp: null,
                    errors: errors.map((error)=>{
                        if (error.extensions?.statusCode === 429) return {
                            message: 'RATE_LIMIT_EXCEEDED'
                        };
                        return error;
                    })
                });
                if (data?.ecosystem?.publishRealtimeChannel) {
                    const { eventId: eventId, eventTimestamp: eventTimestamp } = data.ecosystem.publishRealtimeChannel;
                    if (eventId && eventTimestamp) {
                        resolve({
                            eventId: eventId,
                            eventTimestamp: eventTimestamp
                        });
                        return;
                    }
                }
                resolve(undefined);
            },
            onError: reject
        });
    });
};
module.exports["subscribeRealtimeChannel"] = $6c7339072212c6d0$export$361c332a01480dda;
module.exports["publishRealtimeChannel"] = $6c7339072212c6d0$export$50666a6a6eccdc2e;

});

parcelRegister("b3CvB", function(module, exports) {

var $fPzvm = parcelRequire("fPzvm");


var $cozmU = parcelRequire("cozmU");


var $eqEJl = parcelRequire("eqEJl");


var $gFIer = parcelRequire("gFIer");


var $67Hav = parcelRequire("67Hav");


var $4El6d = parcelRequire("4El6d");


var $4POBX = parcelRequire("4POBX");


var $8j9ei = parcelRequire("8j9ei");


var $ixV18 = parcelRequire("ixV18");


var $9PdUw = parcelRequire("9PdUw");


var $ix7El = parcelRequire("ix7El");


var $c71c0 = parcelRequire("c71c0");


var $jAjCC = parcelRequire("jAjCC");

// ─── Module-level base URL cache ──────────────────────────────────────────────
const $e22e54a1050bd62b$var$storedBaseUrlRelayByCloudId = new Map();
const $e22e54a1050bd62b$export$448f9742733bb2de = ()=>{
    $e22e54a1050bd62b$var$storedBaseUrlRelayByCloudId.clear();
};
/**
 * Retrieves the base URL for the given cloud tenant using a Relay query,
 * caching the result for the lifetime of the module. Needed to support
 * cross-custom-domain routing when `isCustomDomain()` returns true.
 */ const $e22e54a1050bd62b$var$getBaseUrl = (relayEnvironment, cloudId)=>{
    if (!cloudId) return Promise.resolve(window.location.origin);
    const cachedBaseUrl = $e22e54a1050bd62b$var$storedBaseUrlRelayByCloudId.get(cloudId);
    if (cachedBaseUrl) return Promise.resolve(cachedBaseUrl);
    const observable = (0, $eqEJl.fetchQuery)(relayEnvironment, (0, $fPzvm.default), {
        cloudIds: [
            cloudId
        ]
    });
    return new Promise((resolve, reject)=>{
        let settled = false;
        observable.subscribe({
            next: (data)=>{
                if (settled) return;
                settled = true;
                const baseUrl = data?.tenantContexts?.[0]?.cloudUrl ?? '';
                $e22e54a1050bd62b$var$storedBaseUrlRelayByCloudId.set(cloudId, baseUrl);
                resolve(baseUrl);
            },
            error: (err)=>{
                if (!settled) {
                    settled = true;
                    reject(err);
                }
            },
            complete: ()=>{
                if (!settled) {
                    settled = true;
                    resolve($e22e54a1050bd62b$var$storedBaseUrlRelayByCloudId.get(cloudId) ?? '');
                }
            }
        });
    });
};
// ─── Extension query helper ───────────────────────────────────────────────────
/**
 * Returns a `getAppForgeUIExtensions` function compatible with `TargetURLUtils`,
 * pre-bound to the current extension's appId + environmentId. Uses Relay directly
 * (no Apollo fallback) since the bridge layer is Relay-only.
 */ const $e22e54a1050bd62b$var$makeGetAppForgeUIExtensions = (relayEnvironment, contextIds, appId, environmentId, cloudId)=>{
    return (params)=>(0, $9PdUw.getForgeUIExtensionsRelayAsync)({
            contextIds: contextIds,
            extensionsFilter: [
                {
                    type: (0, $ix7El.GQLExtensionContextsFilterType).AppIdEnvironmentId,
                    value: [
                        `${appId}:${environmentId}`
                    ]
                }
            ],
            cloudId: cloudId,
            relayEnvironment: relayEnvironment,
            ...params,
            // Must use the product-agnostic extensionContexts query (bypassNewForgeExtensionListCall: true).
            // Without this flag, getForgeUIExtensionsRelayAsync defaults to the confluence_forgeExtensionsByType
            // query which returns no results outside of Confluence, causing module key lookups to silently
            // fail in Jira and other products.
            bypassNewForgeExtensionListCall: true
        });
};
// ─── Shared onNavigate helper ─────────────────────────────────────────────────
/**
 * Validates the URL, navigates immediately for trusted links, and for external
 * links shows the ExternalLinkModal via overlayController before navigating.
 *
 * `spaPush` (the product's client-side router push, from `bridgeConfig.spaPush`)
 * is forwarded to `navigateToUrl` so `same-tab` trusted navigations perform an
 * SPA push instead of a full page reload. Mirrors the v1 wiring in
 * `useNavigation({ push: bridge?.spaPush })`.
 */ const $e22e54a1050bd62b$var$onNavigate = async ({ type: type, url: urlString }, { extension: extension, overlayController: overlayController, analytics: { fireUIEvent: fireUIEvent }, spaPush: spaPush, appId: appId, hostOnNavigate: hostOnNavigate, openNewTabAsPopupWindow: openNewTabAsPopupWindow })=>{
    const url = (0, $4El6d.makeUrl)(urlString);
    const egressService = (0, $gFIer.egressPermissionService)('FETCH_CLIENT_SIDE', extension.egress);
    const linkType = (0, $67Hav.getLinkType)(url, egressService);
    if (linkType === 'invalid' || !url) throw new (0, $c71c0.BridgeClientError)(`link is invalid: ${urlString}`);
    if (linkType === 'trusted') {
        hostOnNavigate?.({
            type: type,
            url: url.href
        });
        (0, $4POBX.navigate)(url.href, type, spaPush, appId, openNewTabAsPopupWindow);
        return;
    }
    const analyticsAttributes = (0, $67Hav.getAnalyticsAttributes)(url);
    fireUIEvent({
        action: 'viewed',
        actionSubject: 'externalLinkModal',
        attributes: analyticsAttributes
    });
    return new Promise((resolve, reject)=>{
        overlayController.show(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jAjCC.ExternalLinkModal), {
            url: url,
            extensionTitle: extension.properties?.title,
            onConfirm: ()=>{
                hostOnNavigate?.({
                    type: type,
                    url: url.href
                });
                (0, $4POBX.navigate)(url.href, type, spaPush, appId, openNewTabAsPopupWindow);
                fireUIEvent({
                    action: 'approved',
                    actionSubject: 'externalLinkModal',
                    attributes: analyticsAttributes
                });
                overlayController.hide();
                resolve();
            },
            onCancel: ()=>{
                fireUIEvent({
                    action: 'cancelled',
                    actionSubject: 'externalLinkModal',
                    attributes: analyticsAttributes
                });
                overlayController.hide();
                reject(new (0, $c71c0.BridgeClientError)('cancelled'));
            }
        }));
    });
};
const $e22e54a1050bd62b$export$94df0e59ebebf4a7 = async ({ extension: extension, extensionDetails: extensionDetails, contextIds: contextIds, viewContext: viewContext, services: { relayEnvironment: relayEnvironment } }, data)=>{
    if (!data.target) return null;
    const { appId: appId } = extensionDetails;
    const { environmentId: environmentId } = extension;
    const path = await (0, $ixV18.createNavigateTargetPath)(data, {
        getContext: async ()=>viewContext,
        getAppForgeUIExtensions: $e22e54a1050bd62b$var$makeGetAppForgeUIExtensions(relayEnvironment, contextIds, appId, environmentId, viewContext.cloudId)
    });
    if (!path) return null;
    const baseUrl = (0, $8j9ei.isCustomDomain)(window.location.hostname) ? await $e22e54a1050bd62b$var$getBaseUrl(relayEnvironment, viewContext.cloudId) : window.location.origin;
    return `${baseUrl}${path}`;
};
const $e22e54a1050bd62b$export$ff7962acd6052c28 = async ({ extension: extension, extensionDetails: extensionDetails, contextIds: contextIds, viewContext: viewContext, bridgeConfig: bridgeConfig, services: { relayEnvironment: relayEnvironment, overlayController: overlayController, analytics: analytics } }, data)=>{
    const { onNavigate: hostOnNavigate, spaPush: spaPush, openNewTabAsPopupWindow: openNewTabAsPopupWindow } = bridgeConfig;
    const { appId: appId } = extensionDetails;
    if ('target' in data && data.target) {
        const targetData = data;
        const { environmentId: environmentId } = extension;
        const path = await (0, $ixV18.createNavigateTargetPath)(targetData, {
            getContext: async ()=>viewContext,
            getAppForgeUIExtensions: $e22e54a1050bd62b$var$makeGetAppForgeUIExtensions(relayEnvironment, contextIds, appId, environmentId, viewContext.cloudId)
        });
        if (!path) {
            // eslint-disable-next-line no-console
            console.warn('Path was not found for the parameters provided');
            return;
        }
        const url = (0, $8j9ei.isCustomDomain)(window.location.hostname) ? `${await $e22e54a1050bd62b$var$getBaseUrl(relayEnvironment, viewContext.cloudId)}${path}` : path;
        return $e22e54a1050bd62b$var$onNavigate({
            type: targetData.type,
            url: url
        }, {
            extension: extension,
            overlayController: overlayController,
            analytics: analytics,
            spaPush: spaPush,
            appId: appId,
            hostOnNavigate: hostOnNavigate,
            openNewTabAsPopupWindow: openNewTabAsPopupWindow
        });
    }
    return $e22e54a1050bd62b$var$onNavigate(data, {
        extension: extension,
        overlayController: overlayController,
        analytics: analytics,
        spaPush: spaPush,
        appId: appId,
        hostOnNavigate: hostOnNavigate,
        openNewTabAsPopupWindow: openNewTabAsPopupWindow
    });
};
module.exports["getUrl"] = $e22e54a1050bd62b$export$94df0e59ebebf4a7;
module.exports["navigate"] = $e22e54a1050bd62b$export$ff7962acd6052c28;

});

parcelRegister("bAnXF", function(module, exports) {

var $gg9xj = parcelRequire("gg9xj");

const $3b94a0a1b450445c$export$4178d7ac16e6cf7c = async ({ bridgeConfig: bridgeConfig })=>{
    return (0, $gg9xj.createHistory)({
        history: bridgeConfig.history,
        extensionBasePath: bridgeConfig.extensionBasePath
    });
};
module.exports["createHistory"] = $3b94a0a1b450445c$export$4178d7ac16e6cf7c;

});

parcelRegister("aV0pR", function(module, exports) {

var $dNEbC = parcelRequire("dNEbC");


var $eet9L = parcelRequire("eet9L");


var $3xKHi = parcelRequire("3xKHi");

// ─── constants ───────────────────────────────────────────────────────────────
const $1a6259cb7b3e09c5$var$FORGE_SOURCE = 'forge-bridge-open-rovo';
const $1a6259cb7b3e09c5$var$ROVO_EVENT_TYPE = 'chat-new';
const $1a6259cb7b3e09c5$var$makeForgeAgentExternalConfigReference = (appId, installationId, environmentId, agentKey)=>`${installationId}_ari:cloud:ecosystem::extension/${appId}/${environmentId}/static/${agentKey}`;
const $1a6259cb7b3e09c5$export$9be383b35c20e3cc = async ({ resolverContext: resolverContext, extension: extension, extensionDetails: extensionDetails, services: { relayEnvironment: relayEnvironment, rovoPublisher: rovoPublisher } }, { agentKey: agentKey, agentName: agentName, prompt: prompt })=>{
    const { cloudId: cloudId } = resolverContext;
    const product = (0, $eet9L.getRovoProductFromExtensionType)(extension.type);
    if (!cloudId || !product) return false;
    const appId = extensionDetails.appId;
    const installationId = extension.installationId;
    const environmentId = extension.environmentId;
    const publishEventDetails = {
        type: $1a6259cb7b3e09c5$var$ROVO_EVENT_TYPE,
        product: product,
        source: $1a6259cb7b3e09c5$var$FORGE_SOURCE
    };
    let agentIdConfig;
    if (agentName && agentKey) // Forge-managed agent: reference by external config reference ARI
    agentIdConfig = {
        agentExternalConfigReference: $1a6259cb7b3e09c5$var$makeForgeAgentExternalConfigReference(appId, installationId, environmentId, agentKey)
    };
    else {
        // Named agent (by name only, no key) or default Rovo chat agent
        const agentId = agentName && !agentKey ? await (0, $3xKHi.getRovoAgentId)({
            agentAppId: appId,
            cloudId: cloudId,
            input: {
                name: agentName
            },
            product: product,
            relayEnvironment: // agentKey is guaranteed falsy in this branch (condition: agentName && !agentKey)
            relayEnvironment
        }) : (0, $3xKHi.DEFAULT_AGENT_REFERENCE);
        agentIdConfig = {
            agentId: agentId
        };
    }
    rovoPublisher({
        ...publishEventDetails,
        data: {
            dialogues: [],
            ...agentIdConfig,
            ...prompt ? {
                prompt: prompt
            } : {}
        }
    });
    return true;
};
const $1a6259cb7b3e09c5$export$243c13f4da40a98e = async ({ resolverContext: resolverContext, services: { relayEnvironment: relayEnvironment } })=>{
    const { cloudId: cloudId } = resolverContext;
    if (!cloudId) return false;
    return (0, $dNEbC.getIsRovoEnabled)({
        cloudId: cloudId,
        relayEnvironment: relayEnvironment
    });
};
module.exports["openRovo"] = $1a6259cb7b3e09c5$export$9be383b35c20e3cc;
module.exports["isRovoEnabled"] = $1a6259cb7b3e09c5$export$243c13f4da40a98e;

});

parcelRegister("24ctJ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hNQPV = parcelRequire("hNQPV");


var $c71c0 = parcelRequire("c71c0");


var $lD72o = parcelRequire("lD72o");


var $krAZe = parcelRequire("krAZe");


var $8KRzS = parcelRequire("8KRzS");

const $1f1949ec6606ea29$var$RATE_LIMIT_MS = 5000;
const $1f1949ec6606ea29$var$permissionModalResource = (0, $hNQPV.createBridgeResource)('permissionModal', ()=>({
        isRateLimited: false,
        isModalOpen: false
    }), ()=>{}); // ─── Context type ─────────────────────────────────────────────────────────────
const $1f1949ec6606ea29$var$fetchAppData = async (relayEnvironment, appId, contextIds)=>{
    try {
        return await (0, $krAZe.getForgeApp)(relayEnvironment, appId, contextIds);
    } catch (e) {
        if (e instanceof Error) {
            const error = new (0, $c71c0.BridgeClientError)(e.message);
            error.stack = e.stack;
            throw error;
        }
        throw new (0, $c71c0.BridgeClientError)(typeof e === 'string' ? e : String(e));
    }
};
const $1f1949ec6606ea29$var$trackPermission = (analytics, appId, installationId, action)=>{
    analytics.tracker.trackPermissionAction({
        appId: appId,
        installationId: installationId,
        action: action
    });
};
const $1f1949ec6606ea29$var$canOpenModal = (state)=>!state.isModalOpen && !state.isRateLimited;
const $1f1949ec6606ea29$var$noteModalOpened = (state)=>{
    state.isModalOpen = true;
    state.isRateLimited = true;
    setTimeout(()=>{
        state.isRateLimited = false;
    }, $1f1949ec6606ea29$var$RATE_LIMIT_MS);
};
const $1f1949ec6606ea29$var$noteModalClosed = (state)=>{
    state.isModalOpen = false;
}; // ─── egressGet ────────────────────────────────────────────────────────────────
const $1f1949ec6606ea29$export$7d243a3c2dda5c06 = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics }, extensionDetails: { appId: appId }, extension: { installationId: installationId } }, payload)=>{
    if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return {};
    $1f1949ec6606ea29$var$trackPermission(analytics, appId, installationId, 'egressGet');
    try {
        const resp = await permissionFetchClient.egressGet(payload);
        const json = await resp.json();
        if (!resp.ok) throw new (0, $c71c0.BridgeClientError)(JSON.stringify(json, null, 2));
        return json;
    } catch (err) {
        throw new (0, $c71c0.BridgeClientError)(`Could not get egress due to: ${err}`);
    }
};
const $1f1949ec6606ea29$export$ecdd54002a55cf8b = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics, overlayController: overlayController, relayEnvironment: relayEnvironment }, extensionDetails: { appId: appId }, extension: { installationId: installationId }, contextIds: contextIds, claimBridgeResource: claimBridgeResource }, payload)=>{
    if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return {};
    $1f1949ec6606ea29$var$trackPermission(analytics, appId, installationId, 'egressSet');
    const app = await $1f1949ec6606ea29$var$fetchAppData(relayEnvironment, appId, contextIds);
    const dryRunResp = await permissionFetchClient.egressSet(payload, true);
    if (!dryRunResp.ok) throw new (0, $c71c0.BridgeClientError)('Dry run failed');
    const modalState = claimBridgeResource($1f1949ec6606ea29$var$permissionModalResource);
    if (!$1f1949ec6606ea29$var$canOpenModal(modalState)) throw new (0, $c71c0.BridgeClientError)('Permission request rate limited. Please wait before making another request.');
    return new Promise((resolve, reject)=>{
        $1f1949ec6606ea29$var$noteModalOpened(modalState);
        overlayController.show(/*#__PURE__*/ $cozmU.createElement((0, $lD72o.AdminConsentModal), {
            appName: app.name,
            domainInfo: {
                type: 'EGRESS',
                payload: payload
            },
            termsOfUseLink: app.termsOfService ?? null,
            privacyPolicyLink: app.privacyPolicy ?? null,
            onCancel: ()=>{
                $1f1949ec6606ea29$var$noteModalClosed(modalState);
                reject(new (0, $c71c0.BridgeClientError)('Setting egress was rejected by admin'));
            },
            onConfirm: async ()=>{
                const setResp = await permissionFetchClient.egressSet(payload, false);
                const json = await setResp.json();
                if (!setResp.ok) throw new (0, $c71c0.BridgeClientError)(JSON.stringify(json, null, 2));
                $1f1949ec6606ea29$var$noteModalClosed(modalState);
                resolve(json);
            }
        }), false);
    });
};
const $1f1949ec6606ea29$export$370bd1f6454115f4 = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics }, extensionDetails: { appId: appId }, extension: { installationId: installationId } }, payload)=>{
    if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return {};
    $1f1949ec6606ea29$var$trackPermission(analytics, appId, installationId, 'egressDeleteDomain');
    try {
        const resp = await permissionFetchClient.egressDeleteDomain(payload);
        if (resp.ok && resp.status === 204) return undefined;
        const json = await resp.json();
        if (!resp.ok) throw new (0, $c71c0.BridgeClientError)(JSON.stringify(json, null, 2));
        return json;
    } catch (err) {
        throw new (0, $c71c0.BridgeClientError)(`Could not delete egress domain due to ${err}`);
    }
}; // ─── egressDeleteGroup ────────────────────────────────────────────────────────
const $1f1949ec6606ea29$export$f9aaf7f6a0038759 = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics }, extensionDetails: { appId: appId }, extension: { installationId: installationId } }, payload)=>{
    if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return {};
    $1f1949ec6606ea29$var$trackPermission(analytics, appId, installationId, 'egressDeleteGroup');
    try {
        const resp = await permissionFetchClient.egressDeleteGroup(payload);
        if (resp.ok && resp.status === 204) return undefined;
        const json = await resp.json();
        if (!resp.ok) throw new (0, $c71c0.BridgeClientError)(JSON.stringify(json, null, 2));
        return json;
    } catch (err) {
        throw new (0, $c71c0.BridgeClientError)(`Could not delete egress group due to ${err}`);
    }
}; // ─── remoteGet ────────────────────────────────────────────────────────────────
const $1f1949ec6606ea29$export$3eb5f19ac16138d9 = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics }, extensionDetails: { appId: appId }, extension: { installationId: installationId } }, payload)=>{
    if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return {};
    $1f1949ec6606ea29$var$trackPermission(analytics, appId, installationId, 'remoteGet');
    try {
        const resp = await permissionFetchClient.remoteGet(payload);
        const json = await resp.json();
        if (!resp.ok) throw new (0, $c71c0.BridgeClientError)(JSON.stringify(json, null, 2));
        return json;
    } catch (err) {
        throw new (0, $c71c0.BridgeClientError)(`Could not get remote due to: ${err}`);
    }
}; // ─── remoteSet ────────────────────────────────────────────────────────────────
const $1f1949ec6606ea29$export$9cf051d35cd846be = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics, overlayController: overlayController, relayEnvironment: relayEnvironment }, extensionDetails: { appId: appId }, extension: { installationId: installationId }, contextIds: contextIds, claimBridgeResource: claimBridgeResource }, payload)=>{
    if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return {};
    $1f1949ec6606ea29$var$trackPermission(analytics, appId, installationId, 'remoteSet');
    const app = await $1f1949ec6606ea29$var$fetchAppData(relayEnvironment, appId, contextIds);
    const dryRunResp = await permissionFetchClient.remoteSet(payload, true);
    if (!dryRunResp.ok) throw new (0, $c71c0.BridgeClientError)('Dry run failed');
    const modalState = claimBridgeResource($1f1949ec6606ea29$var$permissionModalResource);
    if (!$1f1949ec6606ea29$var$canOpenModal(modalState)) throw new (0, $c71c0.BridgeClientError)('Permission request rate limited. Please wait before making another request.');
     // Build the manifest remote map from the app's extension nodes so the modal
    // can show descriptive names and supported patterns for each remote key.
    const node = (app.installationsByContexts?.edges ?? [])[0]?.node;
    const payloadKeys = new Set(payload.remotes.map((r)=>r.key));
    const manifestRemoteMap = (node?.appEnvironmentVersion?.extensions?.nodes ?? []).filter((e)=>e && e.extensionData.type === 'core:remote' && payloadKeys.has(e.extensionData.key)).reduce((acc, e)=>{
        if (e?.extensionData) acc[e.extensionData.key] = e.extensionData.configurable;
        return acc;
    }, {});
    return new Promise((resolve, reject)=>{
        $1f1949ec6606ea29$var$noteModalOpened(modalState);
        overlayController.show(/*#__PURE__*/ $cozmU.createElement((0, $lD72o.AdminConsentModal), {
            appName: app.name,
            domainInfo: {
                type: 'REMOTE',
                payload: payload,
                manifestRemoteMap: manifestRemoteMap
            },
            termsOfUseLink: app.termsOfService ?? null,
            privacyPolicyLink: app.privacyPolicy ?? null,
            onCancel: ()=>{
                $1f1949ec6606ea29$var$noteModalClosed(modalState);
                reject(new (0, $c71c0.BridgeClientError)('Setting remote was rejected by admin'));
            },
            onConfirm: async ()=>{
                const setResp = await permissionFetchClient.remoteSet(payload, false);
                if (!setResp.ok) throw new (0, $c71c0.BridgeClientError)(setResp.statusText);
                $1f1949ec6606ea29$var$noteModalClosed(modalState);
                resolve(undefined);
            }
        }), false);
    });
};
const $1f1949ec6606ea29$export$2e94858f69910d94 = {
    __permission__egressGet: $1f1949ec6606ea29$export$7d243a3c2dda5c06,
    __permission__egressSet: (ctx, payload)=>{
        if ((0, $iDrrr.fg)('forge-ui-permission-consent-modal-improvements')) return (0, $8KRzS.egressSet)(ctx, payload);
        return $1f1949ec6606ea29$export$ecdd54002a55cf8b(ctx, payload);
    },
    __permission__egressDeleteDomain: $1f1949ec6606ea29$export$370bd1f6454115f4,
    __permission__egressDeleteGroup: $1f1949ec6606ea29$export$f9aaf7f6a0038759,
    __permission__remoteGet: $1f1949ec6606ea29$export$3eb5f19ac16138d9,
    __permission__remoteSet: (ctx, payload)=>{
        if ((0, $iDrrr.fg)('forge-ui-permission-consent-modal-improvements')) return (0, $8KRzS.remoteSet)(ctx, payload);
        return $1f1949ec6606ea29$export$9cf051d35cd846be(ctx, payload);
    }
};
module.exports["permissionBridgeMethods"] = $1f1949ec6606ea29$export$2e94858f69910d94;

});

parcelRegister("j3WkY", function(module, exports) {
/**
 * Error thrown by bridge methods (e.g. `invoke`) that carries the backend
 * `errorType` alongside the message. The `withErrorDisplay` middleware inspects
 * `errorType` to decide whether to surface a Forge UI runtime error message; the error is
 * always rethrown so the app-side call still rejects.
 *
 * Pure (no React) so it can be thrown from the bridge method layer.
 */ class $a07088b53ac152e1$export$634a078025d77a0b extends Error {
    constructor(errorType, message){
        super(message ?? errorType);
        this.errorType = void 0;
        this.name = 'ForgeAppError';
        this.errorType = errorType;
        // Required for correct `instanceof` checks when transpiled to ES5.
        Object.setPrototypeOf(this, $a07088b53ac152e1$export$634a078025d77a0b.prototype);
    }
}
module.exports["ForgeAppError"] = $a07088b53ac152e1$export$634a078025d77a0b;

});

parcelRegister("aQTdX", function(module, exports) {
/**
 * Debug helpers for diagnosing why BridgeContext re-fires its change listeners.
 *
 * Flip `DEBUG_ENABLED` to `true` locally when you want to see the exact leaf-level
 * properties that triggered a context change. Leave it `false` on every commit.
 */ 
var $lVeki = parcelRequire("lVeki");

const $76c5233a7089a4ec$var$DEBUG_ENABLED = false;
/**
 * Returns true if `value` is a "plain" object — one we recurse into when diffing.
 * Library instances (Apollo client, Relay environment, etc.) have non-default
 * prototypes and are treated as opaque leaves to avoid traversing their internals.
 */ const $76c5233a7089a4ec$var$isPlainObject = (value)=>{
    if (value === null || typeof value !== 'object' || Array.isArray(value)) return false;
    const proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
};
const $76c5233a7089a4ec$var$diffValue = (prev, next, path, out)=>{
    if (Object.is(prev, next)) return;
    if (Array.isArray(prev) && Array.isArray(next)) {
        const max = Math.max(prev.length, next.length);
        for(let i = 0; i < max; i++)$76c5233a7089a4ec$var$diffValue(prev[i], next[i], `${path}[${i}]`, out);
        return;
    }
    if ($76c5233a7089a4ec$var$isPlainObject(prev) && $76c5233a7089a4ec$var$isPlainObject(next)) {
        const keys = new Set([
            ...Object.keys(prev),
            ...Object.keys(next)
        ]);
        for (const key of keys)$76c5233a7089a4ec$var$diffValue(prev[key], next[key], path ? `${path}.${key}` : key, out);
        return;
    }
    // Mixed types, primitives, functions, or opaque (non-plain) objects: emit a leaf entry.
    out.push({
        path: path,
        prev: prev,
        next: next
    });
};
const $76c5233a7089a4ec$export$8b12422c455acfb9 = (prev, next, keys)=>{
    const out = [];
    for (const key of keys)$76c5233a7089a4ec$var$diffValue(prev[key], next[key], key, out);
    return out;
};
const $76c5233a7089a4ec$export$dad3a5c40b33fdca = (prev, next, changes)=>{
    if (!changes.__all__) return;
    const changedFields = (0, $lVeki.getBaseChangedFields)(changes);
    // eslint-disable-next-line no-console
    console.log('BridgeContext changed:', changedFields);
    if (!$76c5233a7089a4ec$var$DEBUG_ENABLED) return;
    const diffs = $76c5233a7089a4ec$export$8b12422c455acfb9(prev, next, changedFields);
    // eslint-disable-next-line no-console
    console.log('BridgeContext deep diff:', diffs);
};
module.exports["logBridgeContextChange"] = $76c5233a7089a4ec$export$dad3a5c40b33fdca;

});

parcelRegister("lVeki", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");

// These are standard fields in the BridgeContextChanges, they are not used to indicate any specific context field changes.
const $e3db27ba1b4dda5b$var$DEFAULT_CONTEXT_CHANGES_PROPS = [
    '__all__',
    'extensionPayloadChanges'
];
/**
 * Keys excluded entirely from the change calculation. Products typically pass a
 * freshly-allocated `bridge` object on every render, so reference-comparing it would mark
 * every render as a context change and spuriously fire listeners.
 *
 * `customBridgeContext` is excluded for the same reason: it is an opaque, product-owned bag
 * (often re-allocated each render) read live at call time by custom bridge methods, so it must
 * not drive context-change notifications.
 */ const $e3db27ba1b4dda5b$var$IGNORED_KEYS = [
    'bridge',
    'getContextToken',
    'customBridgeContext'
];
/**
 * Keys that are deep-compared (via `lodash.isEqual`) instead of reference-compared. Products
 * commonly re-allocate these objects on every render with structurally identical content
 * (e.g. `coreData = { cloudId, workspaceId, ... }`); a simple `!==` would spuriously flag
 * them as changed.
 *
 * NOTE: values referenced by these keys must be plain JSON-shaped objects (no class instances,
 * no Apollo client, no Relay environment, no React refs). `lodash.isEqual` will recurse into
 * anything you put here, including library internals — keep these shapes simple.
 */ const $e3db27ba1b4dda5b$var$STRUCTURAL_KEYS = [
    'coreData',
    'extension',
    'contextIds'
];
/**
 * Equality test for reference-compared keys. Two values are treated as equal (i.e. unchanged)
 * when they are reference-equal OR when both are functions.
 *
 * Functions are deliberately never compared by identity. Products commonly re-allocate callback
 * props (`onError`, `onLoad`, `setIsLoading`, …) on every render, and these can leak into the
 * change input via prop spreads at the call sites. Bridge methods read the latest props lazily and
 * no listener reacts to a function-identity change, so treating function↔function as equal
 * suppresses that spurious churn without dropping any real data change. Non-function values
 * (objects, arrays, primitives) fall back to reference equality — a reference change there may be a
 * genuine content change, so we must not blanket-ignore it.
 */ const $e3db27ba1b4dda5b$var$isContextValueEqual = (prevValue, nextValue)=>prevValue === nextValue || typeof prevValue === 'function' && typeof nextValue === 'function';
const $e3db27ba1b4dda5b$export$7b88e6c4776bbc6a = (prev, next)=>{
    const allKeys = new Set([
        ...Object.keys(prev),
        ...Object.keys(next)
    ]);
    const changes = {
        __all__: false,
        extensionPayloadChanges: {}
    };
    for (const key of allKeys){
        if ($e3db27ba1b4dda5b$var$IGNORED_KEYS.includes(key)) {
            changes[key] = false;
            continue;
        }
        const prevValue = prev[key];
        const nextValue = next[key];
        const changed = $e3db27ba1b4dda5b$var$STRUCTURAL_KEYS.includes(key) ? !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(prevValue, nextValue) : !$e3db27ba1b4dda5b$var$isContextValueEqual(prevValue, nextValue);
        changes[key] = changed;
        if (changed) changes.__all__ = true;
    }
    // When extensionPayload reference changed, record per-top-level-key reference equality
    // as a cheap pre-filter signal for listeners.
    //
    // IMPORTANT: reference equality only — NOT value equality. A sub-key flagged `true` means
    // its reference changed, not necessarily that its serialised value changed. Listeners that
    // care about actual value equality must perform their own secondary comparison (e.g.
    // `isEqual`) before acting.
    //
    // The benefit is still real: when only `isEditing` changes and `config` keeps its reference,
    // `extensionPayloadChanges.config` is `false` and the listener short-circuits with zero
    // deep comparisons.
    if (changes.extensionPayload) {
        const prevPayload = prev.extensionPayload ?? {};
        const nextPayload = next.extensionPayload ?? {};
        const subKeys = new Set([
            ...Object.keys(prevPayload),
            ...Object.keys(nextPayload)
        ]);
        const subChanges = {};
        for (const k of subKeys)subChanges[k] = prevPayload[k] !== nextPayload[k];
        changes.extensionPayloadChanges = subChanges;
    }
    return changes;
};
const $e3db27ba1b4dda5b$export$cf5490ed2de0a62 = (changes)=>{
    return Object.keys(changes).filter((k)=>{
        const key = k;
        return !$e3db27ba1b4dda5b$var$DEFAULT_CONTEXT_CHANGES_PROPS.includes(key) && changes[key] === true;
    });
};
module.exports["computeBridgeContextChanges"] = $e3db27ba1b4dda5b$export$7b88e6c4776bbc6a;
module.exports["getBaseChangedFields"] = $e3db27ba1b4dda5b$export$cf5490ed2de0a62;

});

parcelRegister("aqd0l", function(module, exports) {
const $a9383b9f08139cd0$export$b3fb17ae4345ac8f = (b64string, mimeType)=>{
    const base64Data = b64string.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for(let i = 0; i < byteCharacters.length; i++)byteNumbers[i] = byteCharacters.charCodeAt(i);
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([
        byteArray
    ], {
        type: mimeType
    });
};
const $a9383b9f08139cd0$export$47a328b4cabd57cc = (blob)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};
module.exports["base64ToBlob"] = $a9383b9f08139cd0$export$b3fb17ae4345ac8f;
module.exports["blobToBase64"] = $a9383b9f08139cd0$export$47a328b4cabd57cc;

});

parcelRegister("kn1J6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cOQZ8 = parcelRequire("cOQZ8");


var $6SsN4 = parcelRequire("6SsN4");


var $eL3mC = parcelRequire("eL3mC");


var $iGKcz = parcelRequire("iGKcz");

const $fe07dd246eb4e288$export$5d72c9fa1086d504 = 1000;
const $fe07dd246eb4e288$export$b3d02211996f2c0a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { renderThreeLOPrompt: renderThreeLOPrompt } = t0;
    const tracing = (0, $eL3mC.useTracingContext)();
    const [commitUserAuthTokenForExtensionMutation] = (0, $6SsN4.useMutation)((0, $cOQZ8.default));
    let fetchAuthToken;
    if ($[0] !== commitUserAuthTokenForExtensionMutation || $[1] !== renderThreeLOPrompt || $[2] !== tracing) {
        fetchAuthToken = async (extensionId, contextIds)=>{
            tracing?.recordGqlCall("userAuthTokenForExtension - start");
            return new Promise((resolve, reject)=>{
                commitUserAuthTokenForExtensionMutation({
                    variables: {
                        input: {
                            extensionId: extensionId,
                            contextIds: contextIds
                        }
                    },
                    cacheConfig: {
                        metadata: {
                            headers: {
                                "atl-attribution": (0, $iGKcz.createAtlAttributionHeader)(contextIds.sort().join())
                            }
                        }
                    },
                    onError: (error)=>{
                        reject(new Error(`Network error: ${error.message}`));
                    },
                    onCompleted: (data)=>{
                        if (data?.userAuthTokenForExtension) {
                            const { success: success, authToken: authToken, errors: errors } = data.userAuthTokenForExtension;
                            tracing?.recordGqlCall("userAuthTokenForExtension - end");
                            if (!success && errors && errors[0].message?.includes("No Atlassian OAuth token found for this user and extension")) {
                                renderThreeLOPrompt(async ()=>{
                                    const token = await fetchAuthToken(extensionId, contextIds);
                                    resolve(token);
                                });
                                return;
                            }
                            if (success && authToken) {
                                const { token: token_0, ttl: ttl } = authToken;
                                resolve({
                                    token: token_0,
                                    expiry: Date.now() + ttl * $fe07dd246eb4e288$export$5d72c9fa1086d504
                                });
                                return;
                            }
                            reject(new Error("An unexpected error occurred when fetching an auth token"));
                            return;
                        }
                    }
                });
            });
        };
        $[0] = commitUserAuthTokenForExtensionMutation;
        $[1] = renderThreeLOPrompt;
        $[2] = tracing;
        $[3] = fetchAuthToken;
    } else fetchAuthToken = $[3];
    return fetchAuthToken;
} : ({ renderThreeLOPrompt: renderThreeLOPrompt })=>{
    const tracing = (0, $eL3mC.useTracingContext)();
    const [commitUserAuthTokenForExtensionMutation] = (0, $6SsN4.useMutation)((0, $cOQZ8.default));
    const fetchAuthToken = async (extensionId, contextIds)=>{
        tracing?.recordGqlCall('userAuthTokenForExtension - start');
        return new Promise((resolve, reject)=>{
            commitUserAuthTokenForExtensionMutation({
                variables: {
                    input: {
                        extensionId: extensionId,
                        contextIds: contextIds
                    }
                },
                // @ts-ignore
                cacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(contextIds.sort().join())
                        }
                    }
                },
                onError: (error)=>{
                    reject(new Error(`Network error: ${error.message}`));
                },
                onCompleted: (data)=>{
                    if (data?.userAuthTokenForExtension) {
                        const { success: success, authToken: authToken, errors: errors } = data.userAuthTokenForExtension;
                        tracing?.recordGqlCall('userAuthTokenForExtension - end');
                        if (!success && errors && errors[0].message?.includes('No Atlassian OAuth token found for this user and extension')) {
                            renderThreeLOPrompt(async ()=>{
                                const token = await fetchAuthToken(extensionId, contextIds);
                                resolve(token);
                            });
                            return;
                        }
                        if (success && authToken) {
                            const { token: token_0, ttl: ttl } = authToken;
                            resolve({
                                token: token_0,
                                expiry: Date.now() + ttl * $fe07dd246eb4e288$export$5d72c9fa1086d504
                            });
                            return;
                        }
                        reject(new Error('An unexpected error occurred when fetching an auth token'));
                        return;
                    }
                }
            });
        });
    };
    return fetchAuthToken;
};
module.exports["useFetchAuthToken"] = $fe07dd246eb4e288$export$b3d02211996f2c0a;

});

parcelRegister("kyUPS", function(module, exports) {

var $d5UvQ = parcelRequire("d5UvQ");


var $1G3WB = parcelRequire("1G3WB");


var $6SsN4 = parcelRequire("6SsN4");


var $iGKcz = parcelRequire("iGKcz");

let $27fd1fce00dabd00$var$tenantRegionResult;
const $27fd1fce00dabd00$export$e1b0b3d6e5c0e66c = ()=>{
    $27fd1fce00dabd00$var$tenantRegionResult = undefined;
};
const $27fd1fce00dabd00$var$getTenantRegionRelay = ({ product: product, cloudId: cloudId, relayEnvironment: relayEnvironment })=>{
    if (!!$27fd1fce00dabd00$var$tenantRegionResult) return $27fd1fce00dabd00$var$tenantRegionResult;
    if (!relayEnvironment || !cloudId) return Promise.resolve(null);
    try {
        const observable = (0, $6SsN4.fetchQuery)(relayEnvironment, (0, $d5UvQ.default), {
            cloudIds: [
                cloudId
            ],
            product: product
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)()
                    }
                }
            }
        });
        $27fd1fce00dabd00$var$tenantRegionResult = new Promise((resolve)=>{
            observable.subscribe({
                next: (data)=>{
                    resolve(data?.tenantContexts?.[0]?.activationIdByProduct?.targetRegion ?? null);
                },
                error: ()=>{
                    resolve(null);
                }
            });
        });
        return $27fd1fce00dabd00$var$tenantRegionResult;
    } catch  {
        return Promise.resolve(null);
    }
};
const $27fd1fce00dabd00$export$f15a25d73b1f3084 = (0, $1G3WB.functionWithFG)('forge-ui-enable-region-steering', $27fd1fce00dabd00$var$getTenantRegionRelay, ()=>Promise.resolve(null));
module.exports["getTenantRegion"] = $27fd1fce00dabd00$export$f15a25d73b1f3084;

});

parcelRegister("czfKl", function(module, exports) {
/**
 * @generated SignedSource<<a86167cf33d9148d7192b88e655b4033>>
 * @relayHash 054ff1d044a88d72c8190c4e95486551
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d76d2d503320e36d09076652b2b41d61cb81839e0eedd2aa0b959bf242a17b03
const $bab2d6614d02f5c8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "concreteType": "ForgeInvocationToken",
        "kind": "LinkedField",
        "name": "forgeInvocationToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jwt"
            }
        ]
    }, v7 = {
        "concreteType": "InvocationTokenForUIMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "baseUrl"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "SignInvocationTokenForUIResponse",
                    "kind": "LinkedField",
                    "name": "signInvocationTokenForUI",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "SignInvocationTokenForUIResponse",
                    "kind": "LinkedField",
                    "name": "signInvocationTokenForUI",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "d76d2d503320e36d09076652b2b41d61cb81839e0eedd2aa0b959bf242a17b03",
            "metadata": {},
            "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$bab2d6614d02f5c8$var$node.hash = "fe7d32870ddf9b8f5524abb29f382040";
var $bab2d6614d02f5c8$export$2e2bcd8739ae039 = $bab2d6614d02f5c8$var$node;
module.exports["default"] = $bab2d6614d02f5c8$export$2e2bcd8739ae039;

});

parcelRegister("gg9xj", function(module, exports) {

var $c71c0 = parcelRequire("c71c0");

const $b8ad427038665da1$export$21f63b78155c2049 = (extensionBasePath)=>{
    return {
        extensionRouteToFullPath: (extensionRoute)=>`${extensionBasePath}${extensionRoute ?? ''}`,
        fullPathToExtensionRoute: (fullLocation)=>{
            const extensionRoute = fullLocation.split(extensionBasePath).pop();
            return extensionRoute ? extensionRoute : '/';
        }
    };
};
const $b8ad427038665da1$export$4178d7ac16e6cf7c = ({ history: history, extensionBasePath: extensionBasePath })=>{
    if (!history || !extensionBasePath) throw new (0, $c71c0.BridgeClientError)('History API is not available within this module.');
    const { extensionRouteToFullPath: extensionRouteToFullPath, fullPathToExtensionRoute: fullPathToExtensionRoute } = $b8ad427038665da1$export$21f63b78155c2049(extensionBasePath);
    const parseLocation = (location, parser)=>({
            ...location,
            pathname: parser(location.pathname)
        });
    const setNewHistoryLocation = (type, pathOrLocation, state)=>{
        const setHistory = type === 'push' ? history.push : history.replace;
        if (typeof pathOrLocation === 'string') return setHistory(extensionRouteToFullPath(pathOrLocation), state);
        return setHistory(parseLocation({
            state: state,
            ...pathOrLocation
        }, extensionRouteToFullPath));
    };
    return {
        ...history,
        location: parseLocation(history.location, fullPathToExtensionRoute),
        push (pathOrLocation, state) {
            setNewHistoryLocation('push', pathOrLocation, state);
        },
        replace (pathOrLocation, state) {
            setNewHistoryLocation('replace', pathOrLocation, state);
        },
        listen (listener) {
            const unlisten = history.listen((location, action)=>{
                listener(parseLocation(location, fullPathToExtensionRoute), action);
            });
            return unlisten;
        }
    };
};
module.exports["createHistory"] = $b8ad427038665da1$export$4178d7ac16e6cf7c;

});

parcelRegister("2feJ9", function(module, exports) {
/**
 * @generated SignedSource<<cafdf6a863735600bf8dd9feb570d348>>
 * @relayHash f7bba14ed0ba3e90a97cbe6770906a31
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f678bd76c790e4ebfae99dd7eda54817e5a91318514b0cfd2d4a03ccfb0c7ad
const $21cf31192942851c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "appAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contextIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "appAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "privacyPolicy"
    }, v4 = {
        "kind": "ScalarField",
        "name": "termsOfService"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "extensionData"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useForgeAppQuery_appByIdQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "App",
                        "kind": "LinkedField",
                        "name": "app",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v4 /*: any*/ ,
                            {
                                "args": v5 /*: any*/ ,
                                "concreteType": "AppInstallationByIndexConnection",
                                "kind": "LinkedField",
                                "name": "installationsByContexts",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "AppInstallationByIndexEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "AppInstallation",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "AppEnvironmentVersion",
                                                        "kind": "LinkedField",
                                                        "name": "appEnvironmentVersion",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AppVersionExtensions",
                                                                "kind": "LinkedField",
                                                                "name": "extensions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "AppVersionExtension",
                                                                        "kind": "LinkedField",
                                                                        "name": "nodes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v6 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useForgeAppQuery_appByIdQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "AppInstallationByIndexConnection",
                            "kind": "LinkedField",
                            "name": "installationsByContexts",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "AppInstallationByIndexEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "AppInstallation",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AppEnvironmentVersion",
                                                    "kind": "LinkedField",
                                                    "name": "appEnvironmentVersion",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AppVersionExtensions",
                                                            "kind": "LinkedField",
                                                            "name": "extensions",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AppVersionExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "3f678bd76c790e4ebfae99dd7eda54817e5a91318514b0cfd2d4a03ccfb0c7ad",
            "metadata": {},
            "name": "useForgeAppQuery_appByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$21cf31192942851c$var$node.hash = "8343441a33776d30a7ee1f511ffa878d";
var $21cf31192942851c$export$2e2bcd8739ae039 = $21cf31192942851c$var$node;
module.exports["default"] = $21cf31192942851c$export$2e2bcd8739ae039;

});

parcelRegister("56zme", function(module, exports) {
/**
 * @generated SignedSource<<698d49f34e710bffcab59faf5fb5a56d>>
 * @relayHash 27a2ffb4f10a1c89ef127341679ca34d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 30715749324f4ce2692f3d99003222db57884cb021e35c4efc344badee2c59dd
const $70f757c68aba6ded$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contextIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEmitPublicEvent_getExtensionListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEmitPublicEvent_getExtensionListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "30715749324f4ce2692f3d99003222db57884cb021e35c4efc344badee2c59dd",
            "metadata": {},
            "name": "useEmitPublicEvent_getExtensionListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$70f757c68aba6ded$var$node.hash = "d64f8ab7fa1f6f87512e638d0dec22de";
var $70f757c68aba6ded$export$2e2bcd8739ae039 = $70f757c68aba6ded$var$node;
module.exports["default"] = $70f757c68aba6ded$export$2e2bcd8739ae039;

});

parcelRegister("aODBI", function(module, exports) {
/**
 * @generated SignedSource<<77c01d71360291bea3dc6bb34e30b0e9>>
 * @relayHash 146848d898d4f1b4f17c6ffe7e519e02
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81e1bc983c19feae9a62b87e16c21b378ccf00340edc9840ae4d1e14b946f849
const $2d8a5a8a42689b30$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "installationId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isGlobal"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "name"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "payload"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "token"
    }, v6 = [
        {
            "concreteType": "EcosystemMutation",
            "kind": "LinkedField",
            "name": "ecosystem",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "context",
                            "variableName": "context"
                        },
                        {
                            "kind": "Variable",
                            "name": "installationId",
                            "variableName": "installationId"
                        },
                        {
                            "kind": "Variable",
                            "name": "isGlobal",
                            "variableName": "isGlobal"
                        },
                        {
                            "kind": "Variable",
                            "name": "name",
                            "variableName": "name"
                        },
                        {
                            "kind": "Variable",
                            "name": "payload",
                            "variableName": "payload"
                        },
                        {
                            "kind": "Variable",
                            "name": "token",
                            "variableName": "token"
                        }
                    ],
                    "concreteType": "EcosystemRealtimePublishBody",
                    "kind": "LinkedField",
                    "name": "publishRealtimeChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "eventId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventTimestamp"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePublishRealtimeChannelMutation",
            "selections": v6 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePublishRealtimeChannelMutation",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "id": "81e1bc983c19feae9a62b87e16c21b378ccf00340edc9840ae4d1e14b946f849",
            "metadata": {},
            "name": "usePublishRealtimeChannelMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$2d8a5a8a42689b30$var$node.hash = "e82f2888e170470f31e8c75c07be4439";
var $2d8a5a8a42689b30$export$2e2bcd8739ae039 = $2d8a5a8a42689b30$var$node;
module.exports["default"] = $2d8a5a8a42689b30$export$2e2bcd8739ae039;

});

parcelRegister("ha1mA", function(module, exports) {

var $87CGM = parcelRequire("87CGM");

function $3ba297d6a80777c7$export$3e18358e83fbc375(token, options) {
    const decoded = (0, $87CGM.decodeJwtPayload)(token);
    if (!decoded) return {
        valid: false,
        error: 'INVALID_TOKEN'
    };
    const { channelName: channelName, requiredPermission: requiredPermission } = options;
    const { exp: exp, channel: channel, permissions: permissions } = decoded;
    if (exp !== undefined && Date.now() / 1000 >= exp) return {
        valid: false,
        error: 'TOKEN_EXPIRED'
    };
    if (channel.name && channel.name !== channelName) return {
        valid: false,
        error: 'CHANNEL_NAME_MISMATCH'
    };
    if (permissions && !permissions.includes(requiredPermission)) return {
        valid: false,
        error: 'MISSING_PERMISSION'
    };
    return {
        valid: true
    };
}
module.exports["validateRealtimeChannelToken"] = $3ba297d6a80777c7$export$3e18358e83fbc375;

});

parcelRegister("i2Kmi", function(module, exports) {

var $7qSpV = parcelRequire("7qSpV");

const $53a5cb81cf35414e$var$getAGGWebsocketURI = ()=>{
    return `wss://${window.location.host}/gateway/api/graphql/subscriptions`;
};
const $53a5cb81cf35414e$var$createAGGSubscriptionClient = ()=>{
    return (0, $7qSpV.createClient)({
        url: $53a5cb81cf35414e$var$getAGGWebsocketURI(),
        retryAttempts: 2,
        lazy: true
    });
};
const $53a5cb81cf35414e$var$getAGGSubscriptionClient = ()=>{
    let client = window.__FORGE_AGG_SUBSCRIPTION_CLIENT__;
    if (!client) {
        client = $53a5cb81cf35414e$var$createAGGSubscriptionClient();
        window.__FORGE_AGG_SUBSCRIPTION_CLIENT__ = client;
    }
    return client;
};
class $53a5cb81cf35414e$var$BasicSubscription {
    get subscriptionCallbacks() {
        return this._subscriptionCallbacks;
    }
    set subscriptionCallbacks(callbacks) {
        this._subscriptionCallbacks = callbacks;
    }
    unsubscribe() {
        if (!this.closed) {
            this.baseUnsubscribe();
            this.closed = true;
            this._subscriptionCallbacks = [];
        }
    }
    addCallback(callback) {
        this._subscriptionCallbacks.push(callback);
    }
    removeCallback(callback) {
        const index = this._subscriptionCallbacks.indexOf(callback);
        if (index !== -1) this._subscriptionCallbacks.splice(index, 1);
    }
    onNext(event) {
        const payload = this.parsePayload(event);
        this._subscriptionCallbacks.forEach((callback)=>{
            try {
                callback(payload);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('[forge-realtime] Error in subscription callback: ', error);
            }
        });
    }
    onError(error) {
        this._subscriptionCallbacks.forEach((callback)=>{
            try {
                callback(null, error);
            } catch (callbackError) {
                // eslint-disable-next-line no-console
                console.error('[forge-realtime] Error in subscription callback:', callbackError);
            }
        });
    }
    parsePayload(payload) {
        try {
            return JSON.parse(payload);
        // eslint-disable-next-line no-unused-vars
        } catch (err) {
            return payload;
        }
    }
    constructor(baseUnsubscribe, callback){
        this.closed = void 0;
        this.baseUnsubscribe = void 0;
        this._subscriptionCallbacks = void 0;
        this.closed = false;
        this.baseUnsubscribe = baseUnsubscribe;
        this._subscriptionCallbacks = [
            callback
        ];
    }
}
const $53a5cb81cf35414e$export$ec068583843480e7 = (payload, sink, subscriptionCallback, client)=>{
    if (!client) client = $53a5cb81cf35414e$var$getAGGSubscriptionClient();
    const unsubscribe = client.subscribe(payload, sink);
    return new $53a5cb81cf35414e$var$BasicSubscription(unsubscribe, subscriptionCallback);
};
module.exports["subscribe"] = $53a5cb81cf35414e$export$ec068583843480e7;

});

parcelRegister("eet9L", function(module, exports) {
const $91130746828240ec$export$eb5f18ff99769aac = (extensionType)=>{
    const [product, moduleName] = extensionType.split(':');
    const SUPPORTED_PRODUCTS = [
        'jira',
        'confluence',
        'global'
    ];
    // For xen:macro
    if (product === 'xen') return 'confluence';
    // Resolve non-portal JSM modules to Jira
    if (product === 'jiraServiceManagement') {
        if (moduleName && !moduleName.includes('portal')) return 'jira';
    }
    if (!SUPPORTED_PRODUCTS.includes(product)) return null;
    return product;
};
module.exports["getRovoProductFromExtensionType"] = $91130746828240ec$export$eb5f18ff99769aac;

});

parcelRegister("3xKHi", function(module, exports) {

var $1Mj9K = parcelRequire("1Mj9K");


var $6SsN4 = parcelRequire("6SsN4");

const $65585082a0e49620$export$6e6c2af98f57fa9d = 'ai_mate_agent';
// From https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/06c1faa9feb39485f12c6528f9baf9bb1c653451/platform/packages/ai-mate/conversation-assistant-agent/src/services/paginated-agents/utils.tsx
const $65585082a0e49620$var$getAgentIdFromAri = (ari)=>{
    // Pattern: ari:cloud:rovo::agent/activation/{uuid}/{uuid}
    const ariPattern = /^ari:cloud:rovo::agent\/activation\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/([^/]+)$/;
    const match = ari.match(ariPattern);
    if (!match) return null;
    // Return the second UUID (agent ID)
    return match[1];
};
const $65585082a0e49620$var$getIdFromAgent = (agent)=>{
    const id = agent?.node?.id;
    if (!id) return null;
    return $65585082a0e49620$var$getAgentIdFromAri(agent?.node?.id);
};
const $65585082a0e49620$export$73f5d5418567eaae = (agentsList, agentKey, agentAppId)=>{
    // No agents found from given name so fallback to default agent
    if (agentsList.length === 0) return null;
    // OOTB agents can't have the same name,
    // but it can have the same name as a custom agent or a forge agent
    if (!agentKey || !agentAppId) {
        // Custom agents don't have externalConfigReference
        const agent = agentsList.find((agent)=>agent?.node?.externalConfigReference != null && !agent?.node?.externalConfigReference.includes('ari:cloud:ecosystem::extension'));
        return $65585082a0e49620$var$getIdFromAgent(agent);
    }
    // Forge agents can have the same name so we have to filter further by key and appId
    // Their external config reference follows the pattern:
    // `${installationId}_ari:cloud:ecosystem::extension/${appId}/${environmentId}/static/${moduleKey}`;
    const forgeAgentRegex = new RegExp(`${agentAppId}/[^/]+/static/${agentKey}`);
    const agent = agentsList.find((agent)=>agent?.node?.externalConfigReference && forgeAgentRegex.test(agent?.node?.externalConfigReference));
    return $65585082a0e49620$var$getIdFromAgent(agent);
};
const $65585082a0e49620$export$de10b7621d6ba909 = async ({ cloudId: cloudId, product: product, input: input, agentKey: agentKey, agentAppId: agentAppId, relayEnvironment: relayEnvironment })=>{
    if (!relayEnvironment) return $65585082a0e49620$export$6e6c2af98f57fa9d;
    try {
        const observable = (0, $6SsN4.fetchQuery)(relayEnvironment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $1Mj9K.default), /* eslint-enable @atlassian/relay/unused-fields */ {
            cloudId: cloudId,
            input: input,
            product: product
        });
        return new Promise((resolve)=>{
            observable.subscribe({
                next: (data)=>{
                    const agentsList = data?.agentStudio_getAgents?.edges ?? [];
                    const agentId = $65585082a0e49620$export$73f5d5418567eaae(agentsList, agentKey, agentAppId) ?? $65585082a0e49620$export$6e6c2af98f57fa9d;
                    resolve(agentId);
                },
                error: ()=>{
                    resolve($65585082a0e49620$export$6e6c2af98f57fa9d);
                }
            });
        });
    } catch  {
        return $65585082a0e49620$export$6e6c2af98f57fa9d;
    }
};
module.exports["DEFAULT_AGENT_REFERENCE"] = $65585082a0e49620$export$6e6c2af98f57fa9d;
module.exports["getRovoAgentId"] = $65585082a0e49620$export$de10b7621d6ba909;

});

parcelRegister("hOxRx", function(module, exports) {
/**
 * @generated SignedSource<<833852bc3ddd9a91a710ff19c2d356a2>>
 * @relayHash bfe07c4627cdf47f030bff23909d7190
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9f6f405334e912ac423e5472ae733bed876222fcd844be006c0a9c718a6d4c9a
const $c0b39ec2d0b4ba41$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "EcosystemMutation",
            "kind": "LinkedField",
            "name": "ecosystem",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ForgeObservabilityMutation",
                    "kind": "LinkedField",
                    "name": "forgeObservability",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "input"
                                }
                            ],
                            "concreteType": "ForgeObservabilityPublishFrontendCustomMetricResponse",
                            "kind": "LinkedField",
                            "name": "publishFrontendCustomMetric",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "emitFrontendCustomMetricMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "emitFrontendCustomMetricMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9f6f405334e912ac423e5472ae733bed876222fcd844be006c0a9c718a6d4c9a",
            "metadata": {},
            "name": "emitFrontendCustomMetricMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c0b39ec2d0b4ba41$var$node.hash = "0525b01263b0e23397f5287e835f1eb4";
var $c0b39ec2d0b4ba41$export$2e2bcd8739ae039 = $c0b39ec2d0b4ba41$var$node;
module.exports["default"] = $c0b39ec2d0b4ba41$export$2e2bcd8739ae039;

});

parcelRegister("ccsIO", function(module, exports) {
/**
 * @generated SignedSource<<2453e2a3b295aae9be8512d63fd1c17f>>
 * @relayHash 35a31007da7a8584dd5dff16743fe11f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6f7eeee326e17c5b9e476252d3e39fbd99b274b81f611099789d5280d6b02f2f
const $e15c5b876cde129a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "EcosystemMutation",
            "kind": "LinkedField",
            "name": "ecosystem",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ForgeObservabilityMutation",
                    "kind": "LinkedField",
                    "name": "forgeObservability",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "input"
                                }
                            ],
                            "concreteType": "ForgeObservabilityPublishFrontendLogsResponse",
                            "kind": "LinkedField",
                            "name": "publishFrontendLogs",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "emitFrontendLogsMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "emitFrontendLogsMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "6f7eeee326e17c5b9e476252d3e39fbd99b274b81f611099789d5280d6b02f2f",
            "metadata": {},
            "name": "emitFrontendLogsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e15c5b876cde129a$var$node.hash = "3f0953e113f91299f136bc829278a3b0";
var $e15c5b876cde129a$export$2e2bcd8739ae039 = $e15c5b876cde129a$var$node;
module.exports["default"] = $e15c5b876cde129a$export$2e2bcd8739ae039;

});

parcelRegister("h5Ejh", function(module, exports) {
/**
 * @generated SignedSource<<28d43f74f9a6863d0a8de40dec2b7423>>
 * @relayHash f504b87a4e0ed24c5467ba12a605952a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9123000e799c8af26e2146bcbeaf5a5445b2e622a89605e7d2dedac44d1c74aa
const $fa04d7b2f9c7b8d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "appId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "environmentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "appId",
                    "variableName": "appId"
                },
                {
                    "kind": "Variable",
                    "name": "environmentId",
                    "variableName": "environmentId"
                }
            ],
            "concreteType": "AppTunnelDefinitions",
            "kind": "LinkedField",
            "name": "appActiveTunnels",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CustomUITunnelDefinition",
                    "kind": "LinkedField",
                    "name": "customUI",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resourceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tunnelUrl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCustomUITunnelsListRelay_forge_ui_Query",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCustomUITunnelsListRelay_forge_ui_Query",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9123000e799c8af26e2146bcbeaf5a5445b2e622a89605e7d2dedac44d1c74aa",
            "metadata": {},
            "name": "useCustomUITunnelsListRelay_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fa04d7b2f9c7b8d2$var$node.hash = "f05d61452951b17f46031ee0cc173398";
var $fa04d7b2f9c7b8d2$export$2e2bcd8739ae039 = $fa04d7b2f9c7b8d2$var$node;
module.exports["default"] = $fa04d7b2f9c7b8d2$export$2e2bcd8739ae039;

});

parcelRegister("4Yn0i", function(module, exports) {
function $ef348286efea7bf0$var$isEmbeddedMacroPayload(value) {
    return typeof value === 'object' && value !== null && 'embeddedMacroContext' in value;
}
function $ef348286efea7bf0$var$createOpenModalPayload(payload, embeddedMacroContext) {
    const { extension: extension, extensionPayload: extensionPayload, resolverContext: resolverContext } = embeddedMacroContext;
    return {
        ...payload,
        embeddedMacroLocalId: resolverContext?.localId,
        extension: extension,
        extensionData: resolverContext?.extension,
        extensionPayload: extensionPayload,
        isEmbeddedMacroModal: true
    };
}
const $ef348286efea7bf0$export$10fc17d781b6867c = (method, methodName)=>async (context, embeddedMacroPayload)=>{
        if (!$ef348286efea7bf0$var$isEmbeddedMacroPayload(embeddedMacroPayload)) return method(context, embeddedMacroPayload);
        const { embeddedMacroContext: embeddedMacroContext, payload: payload } = embeddedMacroPayload;
        const { contextIds: contextIds, extension: extension, extensionDetails: extensionDetails, extensionPayload: extensionPayload, page: page, resolverContext: resolverContext, viewContext: viewContext } = embeddedMacroContext;
        const mergedContext = {
            ...context,
            contextIds: contextIds,
            extension: extension,
            extensionDetails: extensionDetails,
            extensionPayload: extensionPayload,
            page: page,
            resolverContext: resolverContext,
            viewContext: viewContext
        };
        if (methodName === 'openModal') return method(mergedContext, $ef348286efea7bf0$var$createOpenModalPayload(payload, embeddedMacroContext));
        // `payload` is `unknown` from the embedded macro payload — cast to Payload since this middleware
        // intentionally unwraps it and forwards the inner args as-is to the method.
        return method(mergedContext, payload);
    };
module.exports["withEmbeddedMacroContext"] = $ef348286efea7bf0$export$10fc17d781b6867c;

});

parcelRegister("7rglu", function(module, exports) {

var $8yKod = parcelRequire("8yKod");

const $b1202efb42879188$export$7a88fe5d3687ebff = (extension)=>(0, $8yKod.isCustomUI)(extension) ? 'CustomUI' : 'UIKit';
module.exports["getAppType"] = $b1202efb42879188$export$7a88fe5d3687ebff;

});

parcelRegister("hNQPV", function(module, exports) {
/**
 * Opaque handle describing a per-instance bridge resource: how to create its
 * state and how to tear it down when the BridgeContextObject is destroyed.
 *
 * Declare one resource per feature module (keep it private to the module unless
 * sharing across methods is intentional).
 *
 * Future lifecycle hooks (e.g. `onUpdate`, `onContextTokenRefresh`) can be
 * added here without changing existing callsites.
 */ const $ccd2992f0ac29606$export$c0f9ef43567dcb8a = (debugName, create, destroy)=>({
        id: Symbol(debugName),
        create: create,
        destroy: destroy
    });
module.exports["createBridgeResource"] = $ccd2992f0ac29606$export$c0f9ef43567dcb8a;

});

parcelRegister("lKlSv", function(module, exports) {
/**
 * @generated SignedSource<<d3085f3315879872c8437a2bae079d15>>
 * @relayHash b17b87df0361e2b091063266ad414333
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID add4418fa3b9922378db99ca8f4638f62a27cdbfc1ca37cb555b2c7463d0cdf4
const $9d8ac209cf64adb0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contextIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "publicEventsBridgeMethod_getExtensionListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "publicEventsBridgeMethod_getExtensionListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "add4418fa3b9922378db99ca8f4638f62a27cdbfc1ca37cb555b2c7463d0cdf4",
            "metadata": {},
            "name": "publicEventsBridgeMethod_getExtensionListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9d8ac209cf64adb0$var$node.hash = "7bbb57a8de2a877674c61a37fce31344";
var $9d8ac209cf64adb0$export$2e2bcd8739ae039 = $9d8ac209cf64adb0$var$node;
module.exports["default"] = $9d8ac209cf64adb0$export$2e2bcd8739ae039;

});

parcelRegister("iXYFx", function(module, exports) {
/**
 * @generated SignedSource<<21db12c527eddb222f1bf05d8283d44d>>
 * @relayHash 93b3893a8e9a1daa7b144c57b1a4a9d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2856644f2efd708a0c94f2c0495a994e7de8bc5389ada3a88bbe8d568f1b0876
const $9c6b4be5cdd6ca7c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "installationId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isGlobal"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "name"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "payload"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "token"
    }, v6 = [
        {
            "concreteType": "EcosystemMutation",
            "kind": "LinkedField",
            "name": "ecosystem",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "context",
                            "variableName": "context"
                        },
                        {
                            "kind": "Variable",
                            "name": "installationId",
                            "variableName": "installationId"
                        },
                        {
                            "kind": "Variable",
                            "name": "isGlobal",
                            "variableName": "isGlobal"
                        },
                        {
                            "kind": "Variable",
                            "name": "name",
                            "variableName": "name"
                        },
                        {
                            "kind": "Variable",
                            "name": "payload",
                            "variableName": "payload"
                        },
                        {
                            "kind": "Variable",
                            "name": "token",
                            "variableName": "token"
                        }
                    ],
                    "concreteType": "EcosystemRealtimePublishBody",
                    "kind": "LinkedField",
                    "name": "publishRealtimeChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "eventId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventTimestamp"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "realtimePublishChannelMutation",
            "selections": v6 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "realtimePublishChannelMutation",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "id": "2856644f2efd708a0c94f2c0495a994e7de8bc5389ada3a88bbe8d568f1b0876",
            "metadata": {},
            "name": "realtimePublishChannelMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9c6b4be5cdd6ca7c$var$node.hash = "5ea0f10b611a7938d84804613e71e265";
var $9c6b4be5cdd6ca7c$export$2e2bcd8739ae039 = $9c6b4be5cdd6ca7c$var$node;
module.exports["default"] = $9c6b4be5cdd6ca7c$export$2e2bcd8739ae039;

});

parcelRegister("fPzvm", function(module, exports) {
/**
 * @generated SignedSource<<949a41936564b270f94089d6d2803225>>
 * @relayHash ada3e04d4a67a0cf753a63d3ffc29f1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 18f7f0ebdb47541d86e76505147e1f52e7b4dc441ac13869211d7a904ef73b70
const $13df2f14901951c8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIds"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudIds",
                    "variableName": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "cloudUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "navigationBridgeMethod_tenantUrlQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "navigationBridgeMethod_tenantUrlQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "18f7f0ebdb47541d86e76505147e1f52e7b4dc441ac13869211d7a904ef73b70",
            "metadata": {},
            "name": "navigationBridgeMethod_tenantUrlQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$13df2f14901951c8$var$node.hash = "537ee6daeedfde6695ff904bf976af02";
var $13df2f14901951c8$export$2e2bcd8739ae039 = $13df2f14901951c8$var$node;
module.exports["default"] = $13df2f14901951c8$export$2e2bcd8739ae039;

});

parcelRegister("lD72o", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7aRdF = parcelRequire("7aRdF");


var $aRGok = parcelRequire("aRGok");


var $eQiT1 = parcelRequire("eQiT1");


var $fEPJS = parcelRequire("fEPJS");


var $jq995 = parcelRequire("jq995");


var $9Umtx = parcelRequire("9Umtx");


var $ad7Ou = parcelRequire("ad7Ou");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $dlclU = parcelRequire("dlclU");


var $kSwu1 = parcelRequire("kSwu1");

const $a097f14be5631130$var$getHumanReadableName = (operation)=>{
    switch(operation){
        case 'FETCH_BACKEND_SIDE':
            return 'Fetch backend side';
        case 'FETCH_CLIENT_SIDE':
            return 'Fetch client side';
        case 'FONTS':
            return 'Fonts';
        case 'FRAMES':
            return 'Frames';
        case 'IMAGES':
            return 'Images';
        case 'MEDIA':
            return 'Media';
        case 'NAVIGATION':
            return 'Navigation';
        case 'SCRIPTS':
            return 'Scripts';
        case 'STYLES':
            return 'Styles';
        default:
            return 'Egress';
    }
};
const $a097f14be5631130$export$a7839a1d0a383d1f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { appName: appName, domainInfo: domainInfo, onCancel: onCancel, onConfirm: onConfirm, termsOfUseLink: termsOfUseLink, privacyPolicyLink: privacyPolicyLink } = t0;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(true);
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== onCancel) {
        t1 = ()=>{
            setIsOpen(false);
            onCancel();
        };
        $[0] = onCancel;
        $[1] = t1;
    } else t1 = $[1];
    const handleCancel = t1;
    let t2;
    if ($[2] !== onConfirm) {
        t2 = async ()=>{
            try {
                await onConfirm();
                setIsOpen(false);
            } catch  {}
        };
        $[2] = onConfirm;
        $[3] = t2;
    } else t2 = $[3];
    const handleConfirm = t2;
    let t3;
    if ($[4] !== domainInfo.manifestRemoteMap || $[5] !== domainInfo.payload.egresses || $[6] !== domainInfo.payload.remotes || $[7] !== domainInfo.type) {
        t3 = ()=>{
            if (domainInfo.type === "REMOTE") return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
                direction: "column",
                gap: "space.150"
            }, domainInfo.payload.remotes.map((r)=>{
                const manifestRemoteInfo = domainInfo.manifestRemoteMap[r.key];
                return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                    key: r.key,
                    space: "space.150"
                }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
                    size: "small"
                }, manifestRemoteInfo ? manifestRemoteInfo.description : "Remote"), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                    xcss: (0, $dlclU.styles).rowContainer,
                    spread: "space-between",
                    grow: "fill"
                }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, r.configured.endpoint === null ? "This remote is being reset to the default value" : r.configured.endpoint), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, manifestRemoteInfo ? manifestRemoteInfo.name : null)));
            }));
            return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
                direction: "column",
                gap: "space.150"
            }, domainInfo.payload.egresses.map($a097f14be5631130$var$_temp2));
        };
        $[4] = domainInfo.manifestRemoteMap;
        $[5] = domainInfo.payload.egresses;
        $[6] = domainInfo.payload.remotes;
        $[7] = domainInfo.type;
        $[8] = t3;
    } else t3 = $[8];
    const renderDomains = t3;
    let t4;
    if ($[9] !== appName || $[10] !== intl || $[11] !== privacyPolicyLink || $[12] !== termsOfUseLink) {
        t4 = ()=>{
            if (termsOfUseLink && privacyPolicyLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).noticeForMoreDetails, {
                appName: appName
            }), " ", /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                href: termsOfUseLink
            }, intl.formatMessage((0, $dlclU.messages).termsOfUseLink)), " ", intl.formatMessage((0, $dlclU.messages).noticeAnd), " ", /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                href: privacyPolicyLink
            }, intl.formatMessage((0, $dlclU.messages).privacyPolicyLink)));
            if (termsOfUseLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).noticeForMoreDetails, {
                appName: appName
            }), " ", /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                href: termsOfUseLink
            }, intl.formatMessage((0, $dlclU.messages).termsOfUseLink)));
            if (privacyPolicyLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).noticeForMoreDetails, {
                appName: appName
            }), " ", /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                href: privacyPolicyLink
            }, intl.formatMessage((0, $dlclU.messages).privacyPolicyLink)));
            return null;
        };
        $[9] = appName;
        $[10] = intl;
        $[11] = privacyPolicyLink;
        $[12] = termsOfUseLink;
        $[13] = t4;
    } else t4 = $[13];
    const Notice = t4;
    let t5;
    if ($[14] !== handleCancel || $[15] !== handleConfirm || $[16] !== intl) {
        t5 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: (0, $dlclU.styles).modalFooterContainer
            }, /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                space: "space.075"
            }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                onClick: handleCancel
            }, intl.formatMessage((0, $dlclU.messages).declineButtonLabel)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                onClick: handleConfirm,
                appearance: "primary"
            }, intl.formatMessage((0, $dlclU.messages).approveButtonLabel)))));
        $[14] = handleCancel;
        $[15] = handleConfirm;
        $[16] = intl;
        $[17] = t5;
    } else t5 = $[17];
    const ModalFooter = t5;
    let t6;
    if ($[18] !== ModalFooter || $[19] !== Notice || $[20] !== appName || $[21] !== handleCancel || $[22] !== intl || $[23] !== isOpen || $[24] !== renderDomains) {
        t6 = isOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
            onClose: handleCancel,
            width: "large"
        }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $dlclU.styles).titleContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, intl.formatMessage((0, $dlclU.messages).modalTransitionTitle)))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.300"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).modalTransitionText, {
            appName: appName
        })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, renderDomains(), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $dlclU.styles).disclaimerContainer
        }, /*#__PURE__*/ $cozmU.createElement(Notice, null))))), /*#__PURE__*/ $cozmU.createElement(ModalFooter, null));
        $[18] = ModalFooter;
        $[19] = Notice;
        $[20] = appName;
        $[21] = handleCancel;
        $[22] = intl;
        $[23] = isOpen;
        $[24] = renderDomains;
        $[25] = t6;
    } else t6 = $[25];
    let t7;
    if ($[26] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, t6);
        $[26] = t6;
        $[27] = t7;
    } else t7 = $[27];
    return t7;
} : ({ appName: appName, domainInfo: domainInfo, onCancel: onCancel, onConfirm: onConfirm, termsOfUseLink: termsOfUseLink, privacyPolicyLink: privacyPolicyLink })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(true);
    const intl = (0, $kSwu1.useIntl)();
    const handleCancel = ()=>{
        setIsOpen(false);
        onCancel();
    };
    const handleConfirm = async ()=>{
        try {
            await onConfirm();
            setIsOpen(false);
        } catch  {}
    };
    const renderDomains = ()=>{
        if (domainInfo.type === 'REMOTE') return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.remotes.map((r)=>{
            const manifestRemoteInfo = domainInfo.manifestRemoteMap[r.key];
            return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                key: r.key,
                space: "space.150"
            }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
                size: "small"
            }, manifestRemoteInfo ? manifestRemoteInfo.description : 'Remote'), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                xcss: (0, $dlclU.styles).rowContainer,
                spread: "space-between",
                grow: "fill"
            }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, r.configured.endpoint === null ? 'This remote is being reset to the default value' : r.configured.endpoint), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, manifestRemoteInfo ? manifestRemoteInfo.name : null)));
        }));
        return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.egresses.map((e)=>/*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                key: e.key,
                space: "space.150"
            }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
                size: "xsmall"
            }, e.description), e.configured.map((c)=>c.type.map((t)=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                        key: t,
                        xcss: (0, $dlclU.styles).rowContainer,
                        spread: "space-between",
                        grow: "fill"
                    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, c.domain), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, $a097f14be5631130$var$getHumanReadableName(t))))))));
    };
    const Notice = ()=>{
        if (termsOfUseLink && privacyPolicyLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).noticeForMoreDetails, {
            appName: appName
        }), ' ', /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: termsOfUseLink
        }, intl.formatMessage((0, $dlclU.messages).termsOfUseLink)), ' ', intl.formatMessage((0, $dlclU.messages).noticeAnd), ' ', /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: privacyPolicyLink
        }, intl.formatMessage((0, $dlclU.messages).privacyPolicyLink)));
        if (termsOfUseLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).noticeForMoreDetails, {
            appName: appName
        }), ' ', /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: termsOfUseLink
        }, intl.formatMessage((0, $dlclU.messages).termsOfUseLink)));
        if (privacyPolicyLink) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).noticeForMoreDetails, {
            appName: appName
        }), ' ', /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: privacyPolicyLink
        }, intl.formatMessage((0, $dlclU.messages).privacyPolicyLink)));
        return null;
    };
    const ModalFooter = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $dlclU.styles).modalFooterContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.075"
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            onClick: handleCancel
        }, intl.formatMessage((0, $dlclU.messages).declineButtonLabel)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            onClick: handleConfirm,
            appearance: "primary"
        }, intl.formatMessage((0, $dlclU.messages).approveButtonLabel)))));
    return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: handleCancel,
        width: "large"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $dlclU.styles).titleContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, intl.formatMessage((0, $dlclU.messages).modalTransitionTitle)))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, intl.formatMessage((0, $dlclU.messages).modalTransitionText, {
        appName: appName
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, renderDomains(), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $dlclU.styles).disclaimerContainer
    }, /*#__PURE__*/ $cozmU.createElement(Notice, null))))), /*#__PURE__*/ $cozmU.createElement(ModalFooter, null)));
};
function $a097f14be5631130$var$_temp(c) {
    return c.type.map((t)=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            key: t,
            xcss: (0, $dlclU.styles).rowContainer,
            spread: "space-between",
            grow: "fill"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, c.domain), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, $a097f14be5631130$var$getHumanReadableName(t))));
}
function $a097f14be5631130$var$_temp2(e) {
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        key: e.key,
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, e.description), e.configured.map($a097f14be5631130$var$_temp));
}
module.exports["AdminConsentModal"] = $a097f14be5631130$export$a7839a1d0a383d1f;

});

parcelRegister("krAZe", function(module, exports) {

var $lM6pO = parcelRequire("lM6pO");


var $6SsN4 = parcelRequire("6SsN4");


var $9cGsb = parcelRequire("9cGsb");


var $iGKcz = parcelRequire("iGKcz");

class $ed1b1ece545083fd$export$8814b2f3dd4388d5 extends Error {
}
const $ed1b1ece545083fd$export$3d35432ad69f8123 = (relayEnvironment, appId, contextIds)=>{
    const appAri = (0, $9cGsb.createAppAri)({
        appId: appId
    }).toString();
    return new Promise((resolve, reject)=>{
        (0, $6SsN4.fetchQuery)(relayEnvironment, (0, $lM6pO.default), {
            appAri: appAri,
            contextIds: contextIds
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)()
                    }
                }
            }
        }).subscribe({
            next: (data)=>{
                resolve(data.app);
            },
            error: (error)=>{
                reject(new $ed1b1ece545083fd$export$8814b2f3dd4388d5(`Failed to fetch app data by its ID: ${appAri}, GraphQLError: ${JSON.stringify(error)}`));
            }
        });
    });
};
module.exports["getForgeApp"] = $ed1b1ece545083fd$export$3d35432ad69f8123;

});

parcelRegister("8KRzS", function(module, exports) {
/* indexWithQueue.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hNQPV = parcelRequire("hNQPV");


var $c71c0 = parcelRequire("c71c0");


var $aYo0f = parcelRequire("aYo0f");


var $krAZe = parcelRequire("krAZe");

let $1539f4177c2ac77e$var$modalInstanceCounter = 0;
const $1539f4177c2ac77e$var$permissionModalResource = (0, $hNQPV.createBridgeResource)('permissionModal', ()=>({
        isModalOpen: false,
        queue: []
    }), ()=>{}); // ─── Context type ─────────────────────────────────────────────────────────────
const $1539f4177c2ac77e$var$fetchAppData = async (relayEnvironment, appId, contextIds)=>{
    try {
        return await (0, $krAZe.getForgeApp)(relayEnvironment, appId, contextIds);
    } catch (e) {
        if (e instanceof Error) {
            const error = new (0, $c71c0.BridgeClientError)(e.message);
            error.stack = e.stack;
            throw error;
        }
        throw new (0, $c71c0.BridgeClientError)(typeof e === 'string' ? e : String(e));
    }
};
const $1539f4177c2ac77e$var$trackPermission = (analytics, appId, installationId, action)=>{
    analytics.tracker.trackPermissionAction({
        appId: appId,
        installationId: installationId,
        action: action
    });
}; /**
    * Waits until the modal slot is free. If a modal is already open the caller is
    * enqueued and will proceed once all preceding modals are closed.
    */ 
const $1539f4177c2ac77e$var$waitForModalSlot = (state)=>{
    if (!state.isModalOpen) {
        state.isModalOpen = true;
        return Promise.resolve();
    }
    return new Promise((resolve)=>{
        state.queue.push(()=>{
            state.isModalOpen = true;
            resolve();
        });
    });
}; /**
    * Releases the modal slot and lets the next queued caller (if any) proceed.
    */ 
const $1539f4177c2ac77e$var$releaseModalSlot = (state)=>{
    state.isModalOpen = false;
    const next = state.queue.shift();
    if (next) next();
}; // ─── egressSet ────────────────────────────────────────────────────────────────
const $1539f4177c2ac77e$export$ecdd54002a55cf8b = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics, overlayController: overlayController, relayEnvironment: relayEnvironment }, extensionDetails: { appId: appId }, extension: { installationId: installationId }, contextIds: contextIds, claimBridgeResource: claimBridgeResource }, payload)=>{
    if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return {};
    $1539f4177c2ac77e$var$trackPermission(analytics, appId, installationId, 'egressSet');
    const modalState = claimBridgeResource($1539f4177c2ac77e$var$permissionModalResource);
    await $1539f4177c2ac77e$var$waitForModalSlot(modalState);
    let app;
    try {
        app = await $1539f4177c2ac77e$var$fetchAppData(relayEnvironment, appId, contextIds);
    } catch (err) {
        $1539f4177c2ac77e$var$releaseModalSlot(modalState);
        throw err;
    }
    const dryRunResp = await permissionFetchClient.egressSet(payload, true);
    if (!dryRunResp.ok) {
        $1539f4177c2ac77e$var$releaseModalSlot(modalState);
        throw new (0, $c71c0.BridgeClientError)('Dry run failed');
    }
    return new Promise((resolve, reject)=>{
        const instanceKey = ++$1539f4177c2ac77e$var$modalInstanceCounter;
        overlayController.show(/*#__PURE__*/ $cozmU.createElement((0, $aYo0f.AdminConsentModal), {
            key: instanceKey,
            appName: app.name,
            domainInfo: {
                type: 'EGRESS',
                payload: payload
            },
            termsOfUseLink: app.termsOfService ?? null,
            privacyPolicyLink: app.privacyPolicy ?? null,
            onCancel: ()=>{
                $1539f4177c2ac77e$var$releaseModalSlot(modalState);
                reject(new (0, $c71c0.BridgeClientError)('Setting egress was rejected by admin'));
            },
            onConfirm: async ()=>{
                const setResp = await permissionFetchClient.egressSet(payload, false);
                const json = await setResp.json();
                if (!setResp.ok) throw new (0, $c71c0.BridgeClientError)(JSON.stringify(json, null, 2));
                $1539f4177c2ac77e$var$releaseModalSlot(modalState);
                resolve(json);
            }
        }), false);
    });
};
const $1539f4177c2ac77e$export$9cf051d35cd846be = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics, overlayController: overlayController, relayEnvironment: relayEnvironment }, extensionDetails: { appId: appId }, extension: { installationId: installationId }, contextIds: contextIds, claimBridgeResource: claimBridgeResource }, payload)=>{
    if (!(0, $iDrrr.fg)('configurable-egress-mvp-frontend')) return {};
    $1539f4177c2ac77e$var$trackPermission(analytics, appId, installationId, 'remoteSet');
    const modalState = claimBridgeResource($1539f4177c2ac77e$var$permissionModalResource);
    await $1539f4177c2ac77e$var$waitForModalSlot(modalState);
    let app;
    try {
        app = await $1539f4177c2ac77e$var$fetchAppData(relayEnvironment, appId, contextIds);
    } catch (err) {
        $1539f4177c2ac77e$var$releaseModalSlot(modalState);
        throw err;
    }
    const dryRunResp = await permissionFetchClient.remoteSet(payload, true);
    if (!dryRunResp.ok) {
        $1539f4177c2ac77e$var$releaseModalSlot(modalState);
        throw new (0, $c71c0.BridgeClientError)('Dry run failed');
    } // Build the manifest remote map from the app's extension nodes so the modal
    // can show descriptive names and supported patterns for each remote key.
    const node = (app.installationsByContexts?.edges ?? [])[0]?.node;
    const payloadKeys = new Set(payload.remotes.map((r)=>r.key));
    const manifestRemoteMap = (node?.appEnvironmentVersion?.extensions?.nodes ?? []).filter((e)=>e && e.extensionData.type === 'core:remote' && payloadKeys.has(e.extensionData.key)).reduce((acc, e)=>{
        if (e?.extensionData) acc[e.extensionData.key] = e.extensionData.configurable;
        return acc;
    }, {});
    return new Promise((resolve, reject)=>{
        const instanceKey = ++$1539f4177c2ac77e$var$modalInstanceCounter;
        overlayController.show(/*#__PURE__*/ $cozmU.createElement((0, $aYo0f.AdminConsentModal), {
            key: instanceKey,
            appName: app.name,
            domainInfo: {
                type: 'REMOTE',
                payload: payload,
                manifestRemoteMap: manifestRemoteMap
            },
            termsOfUseLink: app.termsOfService ?? null,
            privacyPolicyLink: app.privacyPolicy ?? null,
            onCancel: ()=>{
                $1539f4177c2ac77e$var$releaseModalSlot(modalState);
                reject(new (0, $c71c0.BridgeClientError)('Setting remote was rejected by admin'));
            },
            onConfirm: async ()=>{
                const setResp = await permissionFetchClient.remoteSet(payload, false);
                if (!setResp.ok) throw new (0, $c71c0.BridgeClientError)(setResp.statusText);
                $1539f4177c2ac77e$var$releaseModalSlot(modalState);
                resolve(undefined);
            }
        }), false);
    });
};
module.exports["egressSet"] = $1539f4177c2ac77e$export$ecdd54002a55cf8b;
module.exports["remoteSet"] = $1539f4177c2ac77e$export$9cf051d35cd846be;

});

parcelRegister("cOQZ8", function(module, exports) {
/**
 * @generated SignedSource<<243826f017886b1beee3409e510959ff>>
 * @relayHash 8044e66d6d14d3c8d608ad17b4c7a655
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4bd98d71393d58feccd2a11d41423b399b61ad4c7d6d4a93b8d392ec2588d343
const $41067dc9ccec007d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "UserAuthTokenForExtensionResponse",
            "kind": "LinkedField",
            "name": "userAuthTokenForExtension",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "AuthToken",
                    "kind": "LinkedField",
                    "name": "authToken",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "token"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ttl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchAuthToken_forge_ui_userAuthTokenMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchAuthToken_forge_ui_userAuthTokenMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "4bd98d71393d58feccd2a11d41423b399b61ad4c7d6d4a93b8d392ec2588d343",
            "metadata": {},
            "name": "useFetchAuthToken_forge_ui_userAuthTokenMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$41067dc9ccec007d$var$node.hash = "d3c16ce08d98682bc3fa0189ab747c05";
var $41067dc9ccec007d$export$2e2bcd8739ae039 = $41067dc9ccec007d$var$node;
module.exports["default"] = $41067dc9ccec007d$export$2e2bcd8739ae039;

});

parcelRegister("d5UvQ", function(module, exports) {
/**
 * @generated SignedSource<<03e7f531f3d1ad6f240db21bb1800046>>
 * @relayHash e47a8d762ffff04a617bbcb521f2ffa5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dfe29aeb7d5310c6db8859a9de6a2e7e88aba2fbf6339df8df5a30ef3f21bad3
const $9e4e27626ac44b8f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudIds",
                    "variableName": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "product",
                            "variableName": "product"
                        }
                    ],
                    "concreteType": "TenantContextActivationId",
                    "kind": "LinkedField",
                    "name": "activationIdByProduct",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "targetRegion"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getTenantRegionQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getTenantRegionQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "dfe29aeb7d5310c6db8859a9de6a2e7e88aba2fbf6339df8df5a30ef3f21bad3",
            "metadata": {},
            "name": "getTenantRegionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9e4e27626ac44b8f$var$node.hash = "6dc84af73dba89409a0c35ebb8003355";
var $9e4e27626ac44b8f$export$2e2bcd8739ae039 = $9e4e27626ac44b8f$var$node;
module.exports["default"] = $9e4e27626ac44b8f$export$2e2bcd8739ae039;

});

parcelRegister("1Mj9K", function(module, exports) {
/**
 * @generated SignedSource<<fed83af1929c32c5fdaa5e0b824c5337>>
 * @relayHash 6baab84fb33d5b03a95e7fc260932ffd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e09a83e61fd43789aeb35b90e2f5c323733ae91a0c8a217868f45694be7598a
const $ad61edee7637bfe9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                },
                {
                    "kind": "Variable",
                    "name": "product",
                    "variableName": "product"
                }
            ],
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AgentStudioAgentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAssistant",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "externalConfigReference"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getRovoAgentIdRelayQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getRovoAgentIdRelayQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9e09a83e61fd43789aeb35b90e2f5c323733ae91a0c8a217868f45694be7598a",
            "metadata": {},
            "name": "getRovoAgentIdRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ad61edee7637bfe9$var$node.hash = "2d164c49d934dbe7dee2500c2971c832";
var $ad61edee7637bfe9$export$2e2bcd8739ae039 = $ad61edee7637bfe9$var$node;
module.exports["default"] = $ad61edee7637bfe9$export$2e2bcd8739ae039;

});

parcelRegister("lM6pO", function(module, exports) {
/**
 * @generated SignedSource<<c22a8773a4c94a6d083b02ef971eb34f>>
 * @relayHash 6c8bbff92427f8f13a9f68ade35e1315
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a614603202abfb55d7d7de64c2578f6deaab7e80d00892134b1cea54b0b6ade8
const $95b8a6ea7a4a75d4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "appAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contextIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "appAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "privacyPolicy"
    }, v4 = {
        "kind": "ScalarField",
        "name": "termsOfService"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "extensionData"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getForgeApp_appByIdQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "App",
                        "kind": "LinkedField",
                        "name": "app",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v4 /*: any*/ ,
                            {
                                "args": v5 /*: any*/ ,
                                "concreteType": "AppInstallationByIndexConnection",
                                "kind": "LinkedField",
                                "name": "installationsByContexts",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "AppInstallationByIndexEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "AppInstallation",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "AppEnvironmentVersion",
                                                        "kind": "LinkedField",
                                                        "name": "appEnvironmentVersion",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AppVersionExtensions",
                                                                "kind": "LinkedField",
                                                                "name": "extensions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "AppVersionExtension",
                                                                        "kind": "LinkedField",
                                                                        "name": "nodes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v6 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getForgeApp_appByIdQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "AppInstallationByIndexConnection",
                            "kind": "LinkedField",
                            "name": "installationsByContexts",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "AppInstallationByIndexEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "AppInstallation",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AppEnvironmentVersion",
                                                    "kind": "LinkedField",
                                                    "name": "appEnvironmentVersion",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AppVersionExtensions",
                                                            "kind": "LinkedField",
                                                            "name": "extensions",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AppVersionExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "a614603202abfb55d7d7de64c2578f6deaab7e80d00892134b1cea54b0b6ade8",
            "metadata": {},
            "name": "getForgeApp_appByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$95b8a6ea7a4a75d4$var$node.hash = "e93ae1f09519a9c62b2154493dddce01";
var $95b8a6ea7a4a75d4$export$2e2bcd8739ae039 = $95b8a6ea7a4a75d4$var$node;
module.exports["default"] = $95b8a6ea7a4a75d4$export$2e2bcd8739ae039;

});


$parcel$global.rlb("4m45y")
//# sourceMappingURL=FullPageEditorComponent.46960206.js.map
